let basicJson = [
  {
    ID: "311",
    Name: "Level: 8mm Head",
    Category: "Levels",
    "Branch Circuit Current Phase C": "Yes",
    "Cold Water Radius": "0",
    Comments: "0",
    Description: "-1",
    "Electrical Data": "0",
    "Elevation at Top Survey": "Project Base Point",
    "Facucent Drilling": "8mm Head",
    Family: "8mm Head",
    "Limit Offset": "Dash - Tight",
    "Line Style": "1",
    "Schedule Level": "None",
    "Start Symbol Type": "Default",
    "Story Above": "No",
    "Switch ID": "M_Level Head - Circle",
    Symbol: "No",
    "Symbol at End 1 Default": "Yes",
    "Tumble Dryer": "8mm Head",
    "Type Comments": "8mm Head",
  },
  {
    ID: "312",
    Name: "Level 1",
    Category: "Views",
    "Angled Joins": "No",
    "Associated Datum": "Level 1",
    "Calculation Rules": "Callout Head w 3mm Corner Radius",
    "Color Scheme": "Background",
    "Created By": "No",
    "Crop Region Visible": "Yes",
    "Decimal Degress": "None",
    Department: "Independent",
    Depth: "0",
    Description: "-1",
    "Desired Stair Height": "Medium",
    "Detail Line": "1",
    "Dimming Lamp Color Temperature Shift": "Architectural",
    Dishwasher: "Normal",
    "Facucent Drilling": "Floor Plan",
    Family: "Floor Plan",
    "Neutral Rating": "Yes",
    "Nominal Width": "Level 1",
    "Ordinate Dimension Settings": "Project North",
    "Parent View": "Show Original",
    Perimeter: "Working Drawings",
    "Phase Demolished": "Show All",
    "Railing Height": "None",
    "Range: Base Level": "Unbounded",
    "Rebar Cover - Top Face": "Sim",
    "Reference Level": "1",
    "Referencing Detail": "A103",
    Rotation: "None",
    Scale: "100",
    "Schedule Level": "None",
    "Sheet Issue Date": "Plans",
    "Sheet Name": "A102",
    "Show Drop Panel": "By Discipline",
    Summary: "No",
    "Tumble Dryer": "Floor Plan",
    "Type Comments": "Floor Plan",
    "Unconnected Height": "Look down",
    "Vertical Scale": "Level 1",
    "View Range": " 1 : 100",
    "View Scale": "None",
    "View Template": "-1",
    "Wall Finish": "Clean all wall joins",
  },
  {
    ID: "694",
    Name: "Level: 8mm Head",
    Category: "Levels",
    "Branch Circuit Current Phase C": "Yes",
    "Cold Water Radius": "0",
    Comments: "0",
    Description: "-1",
    "Electrical Data": "2700",
    "Elevation at Top Survey": "Project Base Point",
    "Facucent Drilling": "8mm Head",
    Family: "8mm Head",
    "Limit Offset": "Dash - Tight",
    "Line Style": "1",
    "Schedule Level": "None",
    "Start Symbol Type": "Default",
    "Story Above": "No",
    "Switch ID": "M_Level Head - Circle",
    Symbol: "No",
    "Symbol at End 1 Default": "Yes",
    "Tumble Dryer": "8mm Head",
    "Type Comments": "8mm Head",
  },
  {
    ID: "8142",
    Name: "Elevation: Building Elevation",
    Category: "Elevations",
    "Calculation Rules": "Callout Head w 3mm Corner Radius",
    Description: "-1",
    "Detail Line": "-",
    "Elevation from Level": "12mm Circle",
    "Facucent Drilling": "Building Elevation",
    Family: "Building Elevation",
    "Neutral Rating": "Yes",
    "Reference Level": "1",
    "Referencing Detail": "A102",
    "Sheet Name": "-",
    "Tumble Dryer": "Building Elevation",
    "Type Comments": "Building Elevation",
    "Vertical Scale": "North",
    "View Template": "-1",
  },
  {
    ID: "8157",
    Name: "North",
    Category: "Views",
    "Angled Joins": "Yes",
    "Assembly Description": "None",
    "Calculation Rules": "Callout Head w 3mm Corner Radius",
    "Color Scheme": "Background",
    "Created By": "No",
    "Crop Region Visible": "Yes",
    "Decimal Degress": "None",
    Department: "Independent",
    Description: "-1",
    "Desired Stair Height": "Fine",
    "Detail Line": "-",
    "Dimming Lamp Color Temperature Shift": "Architectural",
    Dishwasher: "Normal",
    "Elevation from Level": "12mm Circle",
    "Facucent Drilling": "Elevation",
    Family: "Elevations (Building Elevation)",
    "Far Clip Active": "22132",
    "Far Clip Settings": "0",
    "Height Offset From Level": " 1 : 5000",
    "Neutral Rating": "Yes",
    "Nominal Width": "North",
    "Parent View": "Show Original",
    Perimeter: "Working Drawings",
    "Phase Demolished": "Show All",
    "Reference Level": "1",
    "Referencing Detail": "A102",
    Scale: "100",
    "Schedule Level": "None",
    "Sheet Name": "---",
    "Show Drop Panel": "By Discipline",
    Summary: "No",
    "Tumble Dryer": "Building Elevation",
    "Type Comments": "Building Elevation",
    "Vertical Scale": "North",
    "View Range": " 1 : 100",
    "View Scale": "None",
    "View Template": "-1",
  },
  {
    ID: "8174",
    Name: "Elevation: Building Elevation",
    Category: "Elevations",
    "Calculation Rules": "Callout Head w 3mm Corner Radius",
    Description: "-1",
    "Detail Line": "3",
    "Elevation from Level": "12mm Circle",
    "Facucent Drilling": "Building Elevation",
    Family: "Building Elevation",
    "Neutral Rating": "Yes",
    "Reference Level": "1",
    "Referencing Detail": "A102",
    "Sheet Name": "A105",
    "Tumble Dryer": "Building Elevation",
    "Type Comments": "Building Elevation",
    "Vertical Scale": "East",
    "View Template": "-1",
  },
  {
    ID: "8176",
    Name: "East",
    Category: "Views",
    "Angled Joins": "No",
    "Assembly Description": "None",
    "Calculation Rules": "Callout Head w 3mm Corner Radius",
    "Color Scheme": "Background",
    "Created By": "No",
    "Crop Region Visible": "Yes",
    "Decimal Degress": "None",
    Department: "Independent",
    Description: "-1",
    "Desired Stair Height": "Fine",
    "Detail Line": "3",
    "Dimming Lamp Color Temperature Shift": "Architectural",
    Dishwasher: "Normal",
    "Elevation from Level": "12mm Circle",
    "Facucent Drilling": "Elevation",
    Family: "Building Elevation",
    "Far Clip Active": "26874",
    "Far Clip Settings": "0",
    "Height Offset From Level": " 1 : 5000",
    "Neutral Rating": "Yes",
    "Nominal Width": "East",
    "Parent View": "Show Original",
    Perimeter: "Working Drawings",
    "Phase Demolished": "Show All",
    "Reference Level": "1",
    "Referencing Detail": "A102",
    Rotation: "None",
    Scale: "100",
    "Schedule Level": "None",
    "Sheet Issue Date": "Elev./ Stair Sections",
    "Sheet Name": "A105",
    "Show Drop Panel": "By Discipline",
    Summary: "No",
    "Tumble Dryer": "Building Elevation",
    "Type Comments": "Building Elevation",
    "Vertical Scale": "East",
    "View Range": " 1 : 100",
    "View Scale": "None",
    "View Template": "-1",
  },
  {
    ID: "8208",
    Name: "Elevation: Building Elevation",
    Category: "Elevations",
    "Calculation Rules": "Callout Head w 3mm Corner Radius",
    Description: "-1",
    "Detail Line": "2",
    "Elevation from Level": "12mm Circle",
    "Facucent Drilling": "Building Elevation",
    Family: "Building Elevation",
    "Neutral Rating": "Yes",
    "Reference Level": "1",
    "Referencing Detail": "A102",
    "Sheet Name": "A104",
    "Tumble Dryer": "Building Elevation",
    "Type Comments": "Building Elevation",
    "Vertical Scale": "West",
    "View Template": "-1",
  },
  {
    ID: "8237",
    Name: "West",
    Category: "Views",
    "Angled Joins": "No",
    "Assembly Description": "None",
    "Calculation Rules": "Callout Head w 3mm Corner Radius",
    "Color Scheme": "Background",
    "Created By": "No",
    "Crop Region Visible": "Yes",
    "Decimal Degress": "None",
    Department: "Independent",
    Description: "-1",
    "Desired Stair Height": "Fine",
    "Detail Line": "2",
    "Dimming Lamp Color Temperature Shift": "Architectural",
    Dishwasher: "Normal",
    "Elevation from Level": "12mm Circle",
    "Facucent Drilling": "Building Elevation",
    Family: "Building Elevation",
    "Far Clip Active": "27108",
    "Far Clip Settings": "0",
    "Height Offset From Level": " 1 : 5000",
    "Neutral Rating": "Yes",
    "Nominal Width": "West",
    "Parent View": "Show Original",
    Perimeter: "Working Drawings",
    "Phase Demolished": "Show All",
    "Reference Level": "1",
    "Referencing Detail": "A102",
    Rotation: "None",
    Scale: "100",
    "Schedule Level": "None",
    "Sheet Issue Date": "Elev./Sec./Det.",
    "Sheet Name": "A104",
    "Show Drop Panel": "By Discipline",
    Summary: "No",
    "Tumble Dryer": "Building Elevation",
    "Type Comments": "Building Elevation",
    "Vertical Scale": "West",
    "View Range": " 1 : 100",
    "View Scale": "-1",
    "View Template": "-1",
  },
  {
    ID: "8251",
    Name: "Site",
    Category: "Views",
    "Angled Joins": "No",
    "Associated Datum": "Level 1",
    "Calculation Rules": "Callout Head w 3mm Corner Radius",
    "Color Scheme": "Background",
    "Created By": "No",
    "Crop Region Visible": "Yes",
    "Decimal Degress": "None",
    Department: "Independent",
    Depth: "0",
    Description: "-1",
    "Desired Stair Height": "Coarse",
    "Detail Line": "1",
    "Dimming Lamp Color Temperature Shift": "Architectural",
    Dishwasher: "Normal",
    "Facucent Drilling": "Floor Plan",
    Family: "Floor Plan",
    "Neutral Rating": "Yes",
    "Nominal Width": "Site",
    "Ordinate Dimension Settings": "True North",
    "Parent View": "Show Original",
    Perimeter: "Working Drawings",
    "Phase Demolished": "Show All",
    "Railing Height": "None",
    "Range: Base Level": "Unbounded",
    "Rebar Cover - Top Face": "Sim",
    "Reference Level": "1",
    "Referencing Detail": "A103",
    Rotation: "None",
    Scale: "200",
    "Schedule Level": "None",
    "Sheet Issue Date": "Site Plan",
    "Sheet Name": "A101",
    "Show Drop Panel": "By Discipline",
    Summary: "No",
    "Tumble Dryer": "Floor Plan",
    "Type Comments": "Floor Plan",
    "Unconnected Height": "Look down",
    "Vertical Scale": "Site",
    "View Range": " 1 : 200",
    "View Scale": "-1",
    "View Template": "-1",
    "Wall Finish": "Clean all wall joins",
  },
  {
    ID: "9599",
    Name: "Architectural Reflected Ceiling Plan",
    Category: "Views",
    Depth: "0",
    Description: "-1",
    "Desired Stair Height": "Coarse",
    "Dimming Lamp Color Temperature Shift": "Architectural",
    Dishwasher: "Normal",
    "Ordinate Dimension Settings": "Project North",
    "Parent View": "Show Original",
    "Phase Demolished": "Show All",
    Scale: "100",
    "Show Drop Panel": "By Discipline",
    Summary: "No",
    "Unconnected Height": "Look up",
    "View Range": " 1 : 100",
    "View Scale": "None",
  },
  {
    ID: "9605",
    Name: "Architectural Elevation",
    Category: "Views",
    "Color Scheme": "Background",
    Description: "-1",
    "Desired Stair Height": "Fine",
    "Dimming Lamp Color Temperature Shift": "Architectural",
    Dishwasher: "Normal",
    "Far Clip Settings": "0",
    "Parent View": "Show Original",
    "Phase Demolished": "Show All",
    Scale: "100",
    "Show Drop Panel": "By Discipline",
    Summary: "No",
    "View Range": " 1 : 100",
    "View Scale": "None",
  },
  {
    ID: "9610",
    Name: "Architectural Section",
    Category: "Views",
    "Color Scheme": "Background",
    Description: "-1",
    "Desired Stair Height": "Fine",
    "Dimming Lamp Color Temperature Shift": "Architectural",
    Dishwasher: "Normal",
    "Far Clip Settings": "0",
    "Parent View": "Show Original",
    "Phase Demolished": "Show All",
    Scale: "100",
    "Show Drop Panel": "By Discipline",
    Summary: "No",
    "View Range": " 1 : 100",
    "View Scale": "None",
  },
  {
    ID: "98746",
    Name: "Elevation: Building Elevation",
    Category: "Elevations",
    "Calculation Rules": "Callout Head w 3mm Corner Radius",
    Description: "-1",
    "Detail Line": "1",
    "Elevation from Level": "12mm Circle",
    "Facucent Drilling": "Building Elevation",
    Family: "Building Elevation",
    "Neutral Rating": "Yes",
    "Reference Level": "1",
    "Referencing Detail": "A102",
    "Sheet Name": "A103",
    "Tumble Dryer": "Building Elevation",
    "Type Comments": "Building Elevation",
    "Vertical Scale": "South",
    "View Template": "-1",
  },
  {
    ID: "98984",
    Name: "South",
    Category: "Views",
    "Angled Joins": "Yes",
    "Assembly Description": "None",
    "Calculation Rules": "Callout Head w 3mm Corner Radius",
    "Color Scheme": "Background",
    "Created By": "No",
    "Crop Region Visible": "Yes",
    "Decimal Degress": "None",
    Department: "Independent",
    Description: "-1",
    "Desired Stair Height": "Fine",
    "Detail Line": "1",
    "Dimming Lamp Color Temperature Shift": "Architectural",
    Dishwasher: "Normal",
    "Elevation from Level": "12mm Circle",
    "Facucent Drilling": "Building Elevation",
    Family: "Elevations (Building Elevation)",
    "Far Clip Active": "22660",
    "Far Clip Settings": "0",
    "Height Offset From Level": " 1 : 5000",
    "Neutral Rating": "Yes",
    "Nominal Width": "South",
    "Parent View": "Show Original",
    Perimeter: "Working Drawings",
    "Phase Demolished": "Show All",
    "Reference Level": "1",
    "Referencing Detail": "A102",
    Rotation: "None",
    Scale: "100",
    "Schedule Level": "None",
    "Sheet Issue Date": "Elevations/Sections",
    "Sheet Name": "A103",
    "Show Drop Panel": "By Discipline",
    Summary: "No",
    "Tumble Dryer": "Building Elevation",
    "Type Comments": "Building Elevation",
    "Vertical Scale": "South",
    "View Range": " 1 : 100",
    "View Scale": "-1",
    "View Template": "-1",
  },
  {
    ID: "102462",
    Category: "HVAC Zones",
    Level: "-1",
    "Calculate Coefficient of Utilization": "0.00 /",
    "Calculated Area per Cooling Load": "0.0000 /",
    "Calculated Area per Heating Load": "0",
    "Calculated Cooling Load": "0.00 /",
    "Calculated Cooling Load per area": "0",
    "Calculated Heating Load": "0.00 /",
    "Calculated Heating Load per area": "0.0 /",
    "Calculated Supply Airflow": "0.00 /(·)",
    "Coefficient of Utilization": "0.00%",
    "Control Panel": "12 °",
    "Cooling Information": "23 °",
    "Degress Minutes Seconds": "0",
    Description: "-1",
    "Grease Filter": "0",
    "Gross Surface Area": "0",
    "Heat Transfer Coefficient (U)": "32 °",
    "Heating Information": "21 °",
    "Hot Water Radius": "0",
    Illuminance: "<None>",
    Occupant: "0",
    "Occupied Area": "0",
    "Outdoor Air Information": "0.00 /(·)",
    "Outdoor Air per Area": "0.0 /",
    "Outdoor Air per Person": "0",
    "Parts Visibility": "0",
    Perimeter: "Existing",
    "Phase Filter": "Existing",
    "Service Panel": "<Building>",
    "Solar Panel Angle": "From Space Type",
    URL: "No",
    "Use Air Changes Per Hour": "No",
    "Use Dehumidification Set Point": "No",
    "Use Landing Height Adjustment": "No",
    "Use Outside Air Per Area": "No",
  },
  {
    ID: "176804",
    Name: "Floor: Generic 150mm",
    Category: "Floors",
    Level: "Level 1",
    "Aalto Vase Material": "0.1",
    "Architrave Offset": "106",
    "Coarse Poche Material": "0",
    "Coarse Scale Fill Color": "-1",
    CosAng: "0",
    "Default Elevation": "150",
    Description: "-1",
    Elevation: "-150",
    "Elevation at Bottom Survey": "0",
    "Emit from Line Length": "No",
    "Facucent Drilling": "Generic 150mm",
    Family: "Generic 150mm",
    "Full Step Arrow": "Interior",
    "Heat Load Values": "0.0000 /(·)",
    "Height 1": "0",
    Illuminance: "<None>",
    "Parts Visibility": "48000",
    Phase: "Working Drawings",
    "Phase Created": "None",
    "Referencing Sheet": "No",
    Rim: "Yes",
    "Rough Width": "1",
    "Slab Thickness": "0.00°",
    "Story Above": "No",
    Structural: "SH_resin Floor",
    "Text Type": "0.00 /",
    "Thermal Mass": "0.0000 (·)/",
    "Thermal Resistance (R)": "150",
    "Tumble Dryer": "Generic 150mm",
    "Type Comments": "Generic 150mm",
    "Type Id": "<None>",
    Voltage: "15.89",
  },
  {
    ID: "195169",
    Name: "Grid: 6.5mm Bubble",
    Category: "Grids",
    "Center Mark Visible": "Continuous",
    Description: "-1",
    Enclosure: "0",
    "End Segment Color": "Grid Line",
    "End Segment Pattern": "1",
    "Facucent Drilling": "6.5mm Bubble",
    Family: "6.5mm Bubble",
    None: "Top",
    Pipe: "No",
    "Plan View Symbols End 1 (Default)": "Yes",
    "Schedule Level": "None",
    "Switch ID": "M_Grid Head - Circle",
    "Tumble Dryer": "6.5mm Bubble",
    "Type Comments": "6.5mm Bubble",
  },
  {
    ID: "195239",
    Name: "Grid: 6.5mm Bubble",
    Category: "Grids",
    "Center Mark Visible": "Continuous",
    Description: "-1",
    Enclosure: "0",
    "End Segment Color": "Grid Line",
    "End Segment Pattern": "1",
    "Facucent Drilling": "6.5mm Bubble",
    Family: "6.5mm Bubble",
    None: "Top",
    Pipe: "No",
    "Plan View Symbols End 1 (Default)": "Yes",
    "Schedule Level": "None",
    "Switch ID": "M_Grid Head - Circle",
    "Tumble Dryer": "6.5mm Bubble",
    "Type Comments": "6.5mm Bubble",
  },
  {
    ID: "195253",
    Name: "Grid: 6.5mm Bubble",
    Category: "Grids",
    "Center Mark Visible": "Continuous",
    Description: "-1",
    Enclosure: "0",
    "End Segment Color": "Grid Line",
    "End Segment Pattern": "1",
    "Facucent Drilling": "6.5mm Bubble",
    Family: "6.5mm Bubble",
    None: "Top",
    Pipe: "No",
    "Plan View Symbols End 1 (Default)": "Yes",
    "Schedule Level": "None",
    "Switch ID": "M_Grid Head - Circle",
    "Tumble Dryer": "6.5mm Bubble",
    "Type Comments": "6.5mm Bubble",
  },
  {
    ID: "195255",
    Name: "Grid: 6.5mm Bubble",
    Category: "Grids",
    "Center Mark Visible": "Continuous",
    Description: "-1",
    Enclosure: "0",
    "End Segment Color": "Grid Line",
    "End Segment Pattern": "1",
    "Facucent Drilling": "6.5mm Bubble",
    Family: "6.5mm Bubble",
    None: "Top",
    Pipe: "No",
    "Plan View Symbols End 1 (Default)": "Yes",
    "Schedule Level": "None",
    "Switch ID": "M_Grid Head - Circle",
    "Tumble Dryer": "6.5mm Bubble",
    "Type Comments": "6.5mm Bubble",
  },
  {
    ID: "195257",
    Name: "Grid: 6.5mm Bubble",
    Category: "Grids",
    "Center Mark Visible": "Continuous",
    Description: "-1",
    Enclosure: "0",
    "End Segment Color": "Grid Line",
    "End Segment Pattern": "1",
    "Facucent Drilling": "6.5mm Bubble",
    Family: "6.5mm Bubble",
    None: "Top",
    Pipe: "No",
    "Plan View Symbols End 1 (Default)": "Yes",
    "Schedule Level": "None",
    "Switch ID": "M_Grid Head - Circle",
    "Tumble Dryer": "6.5mm Bubble",
    "Type Comments": "6.5mm Bubble",
  },
  {
    ID: "195259",
    Name: "Grid: 6.5mm Bubble",
    Category: "Grids",
    "Center Mark Visible": "Continuous",
    Description: "-1",
    Enclosure: "0",
    "End Segment Color": "Grid Line",
    "End Segment Pattern": "1",
    "Facucent Drilling": "6.5mm Bubble",
    Family: "6.5mm Bubble",
    None: "Top",
    Pipe: "No",
    "Plan View Symbols End 1 (Default)": "Yes",
    "Schedule Level": "None",
    "Switch ID": "M_Grid Head - Circle",
    "Tumble Dryer": "6.5mm Bubble",
    "Type Comments": "6.5mm Bubble",
  },
  {
    ID: "195261",
    Name: "Grid: 6.5mm Bubble",
    Category: "Grids",
    "Center Mark Visible": "Continuous",
    Description: "-1",
    Enclosure: "0",
    "End Segment Color": "Grid Line",
    "End Segment Pattern": "1",
    "Facucent Drilling": "6.5mm Bubble",
    Family: "6.5mm Bubble",
    None: "Top",
    Pipe: "No",
    "Plan View Symbols End 1 (Default)": "Yes",
    "Schedule Level": "None",
    "Switch ID": "M_Grid Head - Circle",
    "Tumble Dryer": "6.5mm Bubble",
    "Type Comments": "6.5mm Bubble",
  },
  {
    ID: "195338",
    Name: "Grid: 6.5mm Bubble",
    Category: "Grids",
    "Center Mark Visible": "Continuous",
    Description: "-1",
    Enclosure: "0",
    "End Segment Color": "Grid Line",
    "End Segment Pattern": "1",
    "Facucent Drilling": "6.5mm Bubble",
    Family: "6.5mm Bubble",
    None: "Top",
    Pipe: "No",
    "Plan View Symbols End 1 (Default)": "Yes",
    "Schedule Level": "None",
    "Switch ID": "M_Grid Head - Circle",
    "Tumble Dryer": "6.5mm Bubble",
    "Type Comments": "6.5mm Bubble",
  },
  {
    ID: "195411",
    Name: "Grid: 6.5mm Bubble",
    Category: "Grids",
    "Center Mark Visible": "Continuous",
    Description: "-1",
    Enclosure: "0",
    "End Segment Color": "Grid Line",
    "End Segment Pattern": "1",
    "Facucent Drilling": "6.5mm Bubble",
    Family: "6.5mm Bubble",
    None: "Top",
    Pipe: "No",
    "Plan View Symbols End 1 (Default)": "Yes",
    "Schedule Level": "None",
    "Switch ID": "M_Grid Head - Circle",
    "Tumble Dryer": "6.5mm Bubble",
    "Type Comments": "6.5mm Bubble",
  },
  {
    ID: "195418",
    Name: "Grid: 6.5mm Bubble",
    Category: "Grids",
    "Center Mark Visible": "Continuous",
    Description: "-1",
    Enclosure: "0",
    "End Segment Color": "Grid Line",
    "End Segment Pattern": "1",
    "Facucent Drilling": "6.5mm Bubble",
    Family: "6.5mm Bubble",
    None: "Top",
    Pipe: "No",
    "Plan View Symbols End 1 (Default)": "Yes",
    "Schedule Level": "None",
    "Switch ID": "M_Grid Head - Circle",
    "Tumble Dryer": "6.5mm Bubble",
    "Type Comments": "6.5mm Bubble",
  },
  {
    ID: "196629",
    Name: "Level: 8mm Head",
    Category: "Levels",
    "Branch Circuit Current Phase C": "Yes",
    "Cold Water Radius": "0",
    Comments: "0",
    Description: "-1",
    "Electrical Data": "6000",
    "Elevation at Top Survey": "Project Base Point",
    "Facucent Drilling": "8mm Head",
    Family: "8mm Head",
    "Limit Offset": "Dash - Tight",
    "Line Style": "1",
    "Schedule Level": "None",
    "Start Symbol Type": "Default",
    "Story Above": "No",
    "Switch ID": "M_Level Head - Circle",
    Symbol: "No",
    "Symbol at End 1 Default": "Yes",
    "Tumble Dryer": "8mm Head",
    "Type Comments": "8mm Head",
  },
  {
    ID: "198694",
    Name: "Basic Wall: SIP 202mm Wall - conc clad",
    Category: "Walls",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABAB9jsEKwjAQRP9lzzE0SSOxnooKgh6KCB5KDy2GNhATqVEopf/uQltBBG87+2Z3Ju8hq8y5u2tI4OArk3nb1d4BgcwbFx6Q5P04oiHmVMmYrVdUMi5hIL9owSKqhBTfUODBUv2H89Nijk7btuwwHxdbU9500C0kEY0IHLWrQzOJkw9lMFh5lBdz/aC9NnWDGZxRwRkjsLP6NZkV9lWCwMZbj3/d09qheAP27/FeDwEAAA==",
    Pbi3DGeometry:
      "xA8AAB+LCAAAAAAABAClV11rwjAU/S95riGxbZrq09gHg+1BtsEexh4UiwacHa4MRPzvi1p1S3pzbyai2JObcz+S3Jy+bdhoYl7WnxUbsId6Yp7rhZmyhI1qs2y+2OBtc/hrh8XQftg2OSM9KcRw/2O/bPt+nHa1Wo3Xdm7W5zrPZFJynaVlIjUvhNDJGZZayg74YF1ypXSBwRlXeao8kp7gfVUUSSq4LMoMMwd9dkYIkfdyXhYq8+2l5FIptecvsxSfEBc9RIOY75Lu55h1C2v7pP3IHQ67GXgubCVdHDJvC+OyY/hlboGUQKcteXBZdUdW3nKDE1AP3gAlpuBWS3kulfazPuFOSV17D0fsXX5naVzzU/zegJeAWwqcCpoRWSNnH4Uzc3vJCf7bGx342JCwCN2GgdYAmgA4cJtDGIaiB5wC5iB5ZyGBsgMkkXmGybFGgh416EhB3Q7BnXiA8iIwsk+xqz10WdOOEbWKSPbIGsF9hnpiIDEA4WCHpjqgrR9NPkFRItoMOZKY2Oo8wEgvobkkWgMuw8nH9UDSXg/uUUi+QWKHejNHSjjihU31GqsfLhOaSPDQdQrpcgSHgkR5ML90Hfh/jQMqymgXcLToQCuMcdFHlolksR4dU0jd2wH7Onxjxh9VU63YQHCRsMdqOWvm7cNT3YwbUy/bx1czPQ3dV2Y2b9qH20X1/dvwul7UlpDdlbuPfev+ASjIP67EDwAA",
    Absorptance: "0.1",
    Area: "22",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "-300",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    Cost: "0",
    "Cross-Section": "Vertical",
    Description: "Structural Insulation Panel Wall with Kiln Dried Timber Panel Rainscreen",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "SIP 202mm Wall - conc clad",
    "Family and Type": "SIP 202mm Wall - conc clad",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "47.5455 /(·)",
    Image: "<None>",
    Keynote: "F10",
    Length: "6202",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Structure - Timber Insulated Panel - Insulation",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "3.09 /",
    "Thermal Resistance (R)": "0.0210 (·)/",
    "Top Constraint": "Roof Line",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "0",
    Type: "SIP 202mm Wall - conc clad",
    "Type Id": "SIP 202mm Wall - conc clad",
    "Type Image": "<None>",
    "Type Mark": "WT1",
    "Unconnected Height": "3300",
    Volume: "4.52",
    Width: "202",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Both",
  },
  {
    ID: "198749",
    Name: "Basic Wall: Wall - Timber Clad",
    Category: "Walls",
    Pbi2DGeometry: "CQEAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzIz6lMz89T0lEKyM/MKylWsoquhjCBCoyM9EwNzIytTfSApFKtDqaMrqGBnqWZsRGqpLGeoZmlIX5JqJmxMIsdi4oSK4G2AwVcMhNzU0tSi5SsDPQMdJR8UvPSSzKgnKD8ksSSTKCDIdzwzBS4lEdqZnoG0AoLPQtTC2MdJdec1DJktc75OflAM/NKc3JqYwE2EvWpCQEAAA==",
    Pbi3DGeometry:
      "GhMAAB+LCAAAAAAABACtWN9r2zAQ/l/0rArJsiU7fRpbx6B9KNtgDyUPKTWtIY1HZgql5H+v09lzdL6TzmGEhPjLp0/3w7o75+5N3N43P19/12Ilrtv75ke7bR6EFLdts+v+iNXd29+v/c/6sn+Jg5yQC6P15cdH/xaH9bjs036/ee3XZpkqtLPSKmdtJr3S2lg5ormyVZ5LrbQExFPoIlOVdzJTpTblKarzzEHJEeYLBMxceeOKABuMLFVZlBbaSewO4Kj3QBiJCe3q0S2nMmeKmQs9ubBlOgaYBL4fbi9lnNH9F1vN6EiERww3DqJeeef9zL8BDnRHG7DNFoUNkgkbEj5z6Ql1zBuuNEiWVcZVZrbjCAc7Am6AgQQCOKCGSY2j+HpvMotio7PQfIgnvKVksChADcISgg2SN4mgSQpvRVbkcDJECTNI63AzUMepbGM5NF67AANlM0RDorcmXHtaRhNys7W0M0RePiyfsyMRmYdvmTTGHjwBZNxrUMujChQ3ossOOzvEU6tmnRJefUHuOXQr4iTEOxET5h0+onnx2P9Fm+iXsTZAtHceGxPmVGBsDliI8fKMTKro3T+VF2QhXYQSLHpHbIDEhi78TJHNlbF2OkyxXGJ74DzeHtgYj45K2ODCnnCSivGhlXcEEnBshI+jnOIYnxVSDwx83Xg9YcILTMbbVxRNHCcaOqefRhWICQAIpySCQST+NJcagnniEXrgzjmG856xOSMkMWUknukXjCrx/yRIjGcX/qcC2jYWQKyo4mWTeuY8F6fq71qKL83mue7qvVgdSeKm3j12T8PF97bbdE27Gy5/NQ//fvpWN49P3XBxta1fTomf223bC4qv1fElDut3AbDSRBoTAAA=",
    Absorptance: "0.1",
    Area: "6",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    Cost: "0",
    "Cross-Section": "Vertical",
    Description: "Structural Insulation Panel Wall with Kiln Dried Timber Panel Rainscreen",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Wall - Timber Clad",
    "Family and Type": "Wall - Timber Clad",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Keynote: "F10",
    Length: "4580",
    "Location Line": "Finish Face: Interior",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Structure - Timber Insulated Panel - Insulation",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "Yes",
    "Top Offset": "0",
    Type: "Wall - Timber Clad",
    "Type Id": "Wall - Timber Clad",
    "Type Image": "<None>",
    "Unconnected Height": "3000",
    Volume: "1.21",
    Width: "202",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Both",
  },
  {
    ID: "211850",
    Name: "Sink-Offset-Kohler-Vault-3823_4: Steel-Stainless-NA",
    Category: "Plumbing Fixtures",
    Level: "Level 1",
    Pbi2DGeometry:
      "1AAAAB+LCAAAAAAABAA1jUELgjAcxb/L/zzHptvUdYoSgjqIBB3Eg9bQwdrCViDid29S3R6P3/u9eoay0+fpoUDC0XW6Ulff2t4oQFA6bf0TZD1/Y0AowTkn+SYiOBOUw9L8se04tlNgQ7HX7V15NYIkmCA4Kdv7AWSMU0E4gsr51mtnQQqcECo4TRgTWcxzzoqIBuKib+uA4owlGYKD0v3gV1uaCgSFUe+fIMYJJQzBzhkX7uzLmKX5AJHi2zLUAAAA",
    Pbi3DGeometry:
      "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",
    "ADA Compliant": "No",
    Area: "1",
    "Assembly Code": "D2010410",
    "Assembly Description": "Sinks - Kitchen",
    Cost: "0",
    "Created By": "http://www.medialab3dstudio.com/",
    CWFU: "0",
    "Default Elevation": "0",
    Description: "Vault(TM) offset kitchen sink with four-hole faucet drilling",
    "Design Option": "-1",
    "Elevation from Level": "941",
    "Facucent Drilling": "4 Hole",
    Family: "Steel-Stainless-NA",
    "Family and Type": "Steel-Stainless-NA",
    Finish: "Steel-Kohler-NA-Stainless",
    Height: "237",
    Host: "4500_Kitchen Island_DW : 4500_Kitchen Island_DW",
    "Host Id": "-1",
    HWFU: "0",
    Image: "<None>",
    Length: "838",
    Manufacturer: "Kohler",
    Mark: "1",
    Model: "K-3823-4",
    "OmniClass Number": "23.45.05.14.14",
    "OmniClass Title": "Sinks/Lavatories",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Product Documentation Link": "http://www.us.kohler.com/onlinecatalog/pdf/1130288_4.pdf",
    "Product Page URL": "http://www.us.kohler.com/onlinecatalog/detail.jsp?prod_num=3823-4",
    "Sanitary Connector Left": "Sanitary Connection Left",
    "Sanitary Connector Right": "Sanitary Connection Right",
    "Sanitary Diameter": "95",
    "Sanitary Radius": "48",
    "Schedule Level": "Level 1",
    "System Classification": "Sanitary",
    "System Type": "Undefined",
    Type: "Steel-Stainless-NA",
    "Type Id": "Steel-Stainless-NA",
    "Type Image": "<None>",
    URL: "http://www.us.kohler.com/index.jsp",
    Volume: "0",
    WFU: "0",
    Width: "559",
  },
  {
    ID: "213811",
    Name: "Faucet-8inch_Reach-Kohler-Purist-7507: Chrome-Polished_Chrome-CP",
    Category: "Plumbing Fixtures",
    Level: "Level 1",
    Pbi2DGeometry:
      "1QAAAB+LCAAAAAAABAA1jVELgjAUhf/LfZ6yu01Te4oSgnoQCXoQH7SGDtYWtgIR/3sT6+2cc797TjVB0arL+JSQwcm2qpQ315hOSyBQWGXcC7JqWqVHEENMRbwNMKSxYDDXf2w3DM3oWR8cVPOQTg6Q0ZASOEvTuX4xPKUbAqV1jVPWQObLkCMyjCgmlFEm8gAFgau6rw+Cs4jAUaqud4tPE+HPuZafXwMPaRJ7ZG+19XvmrfVcfwHj4LUr1QAAAA==",
    Pbi3DGeometry:
      "6wcAAB+LCAAAAAAABADtk18LgjAUxb/LfV7jjtSlPUUFPfQgEfQQPRiNGpgLW0FE371R9ofBmj4nonh/nnv0zp3lFdK1nF8OApLilOcEUiULfYRkeX3eQgLYNwfcyId0GGL/cTEn3FavtkFZZhfTy5CGnAekwyiPAk66FHtRSBijQcxCJ0Ya9zB+Y4+JQ21hzysrHFDkpsn2tvHvL3GYeMax8MvEGsfGDhOHutlS/cYe73pqzzjNflo9E4fag5vtE49JnTUxWRrJbC+0KCFBigSmotjqXVXMlM60VEVVLuTm/Wgi5Hanq2Kci/O3cKhyVT4z/ghyG/o29G3o/yj0qzuPSPcD6wcAAA==",
    "Actual Valve Water Flow": "0.1 /",
    "ADA Compliant": "Yes",
    Area: "0",
    "Assembly Code": "D2010",
    "Assembly Description": "Plumbing Fixtures",
    "Cold Water Connector": "Cold Water Connection",
    "Cold Water Diameter": "10",
    "Cold Water Radius": "5",
    Cost: "0",
    "Created By": "http://medialab3dstudio.com/",
    CWFU: "0",
    "Default Elevation": "0",
    Description: "Purist(R) kitchen sink faucet with 8 inch spout reach",
    "Design Option": "-1",
    "Elevation from Level": "941",
    Family: "Chrome-Polished_Chrome-CP",
    "Family and Type": "Chrome-Polished_Chrome-CP",
    Finish: "Chrome-Kohler-CP-Polished_Chrome",
    Height: "300",
    Host: "Sink-Offset-Kohler-Vault-3823_4 : Steel-Stainless-NA",
    "Host Id": "-1",
    "Hot Water Connector": "Hot Water Connection",
    "Hot Water Diameter": "10",
    "Hot Water Radius": "5",
    HWFU: "0",
    Image: "<None>",
    "Installation Type": "Single-hole",
    Length: "203",
    Manufacturer: "Kohler",
    Mark: "3",
    Model: "K-7507",
    "OmniClass Number": "23.45.55.17",
    "OmniClass Title": "Mixing Faucets",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Product Documentation Link": "http://www.us.kohler.com/onlinecatalog/detail.jsp?prod_num=7507",
    "Product Page URL": "http://www.us.kohler.com/onlinecatalog/detail.jsp?prod_num=7507",
    "Schedule Level": "Level 1",
    "Spout Reach": "168",
    "Spout Reach Offset": "188",
    "System Classification": "Domestic Cold Water,Domestic Hot Water",
    "System Type": "Undefined",
    Type: "Chrome-Polished_Chrome-CP",
    "Type Id": "Chrome-Polished_Chrome-CP",
    "Type Image": "<None>",
    URL: "http://www.us.kohler.com",
    Volume: "0",
    WFU: "0",
    Width: "116",
  },
  {
    ID: "234869",
    Name: "Basic Wall: Wall - Timber Clad",
    Category: "Walls",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABAB9jsEKwjAQRP9lzzE0TVqTehIVBD0EETyUHloMbSAmUqNQSv/dQKsigredfcPM5D3ISh+7q4IMdq7S0pmudhYQSKetv0GW9+MZDJRiwlKymJEIc5pQGNAvZJgl6fwbxZhxyv6hT2Txql62bdmF/vBY6/KivGohi3CEYK9s7ZtJHJwvvQ6TR3nS5zfaKl03oYUITIXgCDZGPSazwJzFCYKVMy7k2rsxQ/EER04HOQ8BAAA=",
    Pbi3DGeometry:
      "bAcAAB+LCAAAAAAABACdVd9rwyAQ/l98dqJGE22fxn4w2B7KNthD2UNKpRWyODIZlNL/fW6z6ZbEaoIk6Hfnd+d5dy73YLHSz7t3BWbg3qz0k6n0GkCwMLq2H2C23P9OnRjP3QAHeEIuCMbzn5/7wOH1uO2yacqd25tliLCcQKeCOM4kJAIVGAvYE0gkGOUtzlDOs7yLnmgkYoRmA4IOv+ehDBFcyDhRSB8jKriAVCLKEtQj7hyPRRETGQuilEsZ0G0terhv8T+L0+ekoDGaIDzkStBmP7rnnQkTdcOeytOxG4tO6GDRA0eyOCFCIaawIJT6o28nWlzjwzopzZMy8XzBDbeLSBNJqrdE7Unco7wOlEIQT7/NaIYlVuHEXjmyxhPZkxqaJ3fP1rUu35RVDZhhhCF4UPXGbv3i0djSalP75Ytet6I7pTdb6xc3lfr8q3hlKuMIwa38Hu51/AIMsW8ibAcAAA==",
    Absorptance: "0.1",
    Area: "21",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    Cost: "0",
    "Cross-Section": "Vertical",
    Description: "Structural Insulation Panel Wall with Kiln Dried Timber Panel Rainscreen",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Wall - Timber Clad",
    "Family and Type": "Wall - Timber Clad",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Keynote: "F10",
    Length: "4661",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Structure - Timber Insulated Panel - Insulation",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Ceiling",
    "Top Extension Distance": "0",
    "Top is Attached": "Yes",
    "Top Offset": "3746",
    Type: "Wall - Timber Clad",
    "Type Id": "Wall - Timber Clad",
    "Type Image": "<None>",
    "Unconnected Height": "3446",
    Volume: "4.34",
    Width: "202",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Both",
  },
  {
    ID: "243254",
    Name: "Building Section",
    Category: "Views",
    "Angled Joins": "No",
    "Calculation Rules": "Callout Head w 3mm Corner Radius",
    "Color Scheme": "Background",
    "Created By": "No",
    "Crop Region Visible": "Yes",
    "Decimal Degress": "None",
    Department: "Independent",
    Description: "-1",
    "Desired Stair Height": "Fine",
    "Detail Line": "1",
    "Dimming Lamp Color Temperature Shift": "Architectural",
    Dishwasher: "Normal",
    "Facucent Drilling": "Section",
    Family: "Sections (Building Section)",
    "Far Clip Active": "21301",
    "Far Clip Settings": "0",
    "Height Offset From Level": " 1 : 100",
    "Neutral Rating": "Yes",
    "Nominal Width": "Building Section",
    "Parent View": "Show Original",
    Perimeter: "Working Drawings",
    "Phase Demolished": "Show All",
    "Reference Level": "1",
    "Referencing Detail": "A102",
    Rotation: "None",
    Scale: "100",
    "Schedule Level": "None",
    "Section Shape": "Section Head - Filled, Section Tail - Filled",
    "Sheet Issue Date": "Elev./Sec./Det.",
    "Sheet Name": "A104",
    "Show Drop Panel": "By Discipline",
    Summary: "No",
    "Tumble Dryer": "Building Section",
    "Type Comments": "Building Section",
    "Vertical Scale": "Building Section",
    "View Range": " 1 : 100",
    "View Scale": "None",
    "View Template": "-1",
  },
  {
    ID: "243274",
    Name: "Basic Roof: SG Metal Panels roof",
    Category: "Roofs",
    "Aalto Vase Material": "0.1",
    "Architrave Offset": "173",
    "Arrowhead Type": "B1020",
    "Assembly Code": "Roof Construction",
    "Coarse Poche Material": "0",
    "Coarse Scale Fill Color": "-1",
    CosAng: "0",
    "Default Elevation": "202",
    Description: "-1",
    "Equality Witness Display": "-6202",
    "Extrusion End": "13298",
    "Facucent Drilling": "SG Metal Panels roof",
    Family: "SG Metal Panels roof",
    Fascia: "0",
    "Heat Load Values": "1.1740 /(·)",
    Illuminance: "<None>",
    Length3: "0",
    Phase: "Working Drawings",
    "Phase Created": "None",
    Radius: "Plumb Cut",
    "Reference Label": "Roof Line",
    "Referencing Sheet": "No",
    Rim: "Yes",
    "Rough Width": "1",
    "Slab Thickness": "0.00°",
    "Text Type": "1.91 /",
    "Thermal Mass": "0.8518 (·)/",
    "Thermal Resistance (R)": "202",
    "Tumble Dryer": "SG Metal Panels roof",
    "Type Comments": "SG Metal Panels roof",
    "Type Id": "<None>",
    Voltage: "34.97",
    "Witness Line Tick Mark": "<not associated>",
  },
  {
    ID: "243275",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "245423",
    Name: "Level: 8mm Head",
    Category: "Levels",
    "Branch Circuit Current Phase C": "Yes",
    "Cold Water Radius": "0",
    Comments: "0",
    Description: "-1",
    "Electrical Data": "3000",
    "Elevation at Top Survey": "Project Base Point",
    "Facucent Drilling": "8mm Head",
    Family: "8mm Head",
    "Limit Offset": "Dash - Tight",
    "Line Style": "1",
    "Schedule Level": "None",
    "Start Symbol Type": "Default",
    "Story Above": "No",
    "Switch ID": "M_Level Head - Circle",
    Symbol: "No",
    "Symbol at End 1 Default": "Yes",
    "Tumble Dryer": "8mm Head",
    "Type Comments": "8mm Head",
  },
  {
    ID: "245424",
    Name: "Level 2",
    Category: "Views",
    "Angled Joins": "No",
    "Associated Datum": "Level 2",
    "Calculation Rules": "Callout Head w 3mm Corner Radius",
    "Color Scheme": "Background",
    "Created By": "No",
    "Crop Region Visible": "Yes",
    "Decimal Degress": "None",
    Department: "Independent",
    Depth: "0",
    Description: "-1",
    "Desired Stair Height": "Medium",
    "Detail Line": "2",
    "Dimming Lamp Color Temperature Shift": "Architectural",
    Dishwasher: "Normal",
    "Facucent Drilling": "Floor Plans",
    Family: "Floor Plans",
    "Neutral Rating": "Yes",
    "Nominal Width": "Level 2",
    "Ordinate Dimension Settings": "Project North",
    "Parent View": "Show Original",
    Perimeter: "Working Drawings",
    "Phase Demolished": "Show All",
    "Railing Height": "None",
    "Range: Base Level": "Unbounded",
    "Rebar Cover - Top Face": "Sim",
    "Reference Level": "1",
    "Referencing Detail": "A103",
    Rotation: "None",
    Scale: "100",
    "Schedule Level": "None",
    "Sheet Issue Date": "Plans",
    "Sheet Name": "A102",
    "Show Drop Panel": "By Discipline",
    Summary: "No",
    "Tumble Dryer": "Floor Plan",
    "Type Comments": "Floor Plan",
    "Unconnected Height": "Look down",
    "Vertical Scale": "Level 2",
    "View Range": " 1 : 100",
    "View Scale": "None",
    "View Template": "-1",
    "Wall Finish": "Clean all wall joins",
  },
  {
    ID: "247014",
    Name: "Longitudinal Section",
    Category: "Views",
    "Angled Joins": "No",
    "Calculation Rules": "Callout Head w 3mm Corner Radius",
    "Color Scheme": "Background",
    "Created By": "No",
    "Crop Region Visible": "Yes",
    "Decimal Degress": "None",
    Department: "Independent",
    Description: "-1",
    "Desired Stair Height": "Fine",
    "Detail Line": "3",
    "Dimming Lamp Color Temperature Shift": "Architectural",
    Dishwasher: "Normal",
    "Facucent Drilling": "Building Section",
    Family: "Section: Building Section",
    "Far Clip Active": "7091",
    "Far Clip Settings": "0",
    "Height Offset From Level": " 1 : 100",
    "Neutral Rating": "Yes",
    "Nominal Width": "Longitudinal Section",
    "Parent View": "Show Original",
    Perimeter: "Working Drawings",
    "Phase Demolished": "Show All",
    "Reference Level": "1",
    "Referencing Detail": "A102",
    Rotation: "None",
    Scale: "100",
    "Schedule Level": "None",
    "Section Shape": "Section Head - Filled, Section Tail - Filled",
    "Sheet Issue Date": "Elevations/Sections",
    "Sheet Name": "A103",
    "Show Drop Panel": "By Discipline",
    Summary: "No",
    "Tumble Dryer": "Building Section",
    "Type Comments": "Building Section",
    "Vertical Scale": "Longitudinal Section",
    "View Range": " 1 : 100",
    "View Scale": "None",
    "View Template": "-1",
  },
  {
    ID: "382617",
    Name: "Plans - A102",
    Category: "Sheets",
    "Apparent Load Phase C": "Yes",
    "Appears In Sheet List": "Approver",
    "Centerline Tick Mark": "JLH",
    "Current Revision Description": "No",
    Department: "Independent",
    Description: "-1",
    "Design Option": "Designer",
    "Draw Layer": "SM",
    "Facucent Drilling": "Sheet",
    Family: "Sheet: Sheet",
    "Feed Through Lugs Current Phase C": "C:\\Program Files\\Autodesk\\Revit 2021\\Samples\\rac_basic_sample_project.rvt",
    "Ground Bus": "<None>",
    "Nominal Width": "Plans",
    "Sash Material": " 1 : 100",
    "Sheet Height": "7/24/12",
    "Sheet Issue Date": "Plans",
    "Tumble Dryer": "Sheet",
    "Type Comments": "Sheet",
    "View Scale": "None",
  },
  {
    ID: "382621",
    Name: "A1 metric: A1 metric",
    Category: "Title Blocks",
    Level: "-1",
    Pbi2DGeometry: "qgAAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygxKTS5JzEvPSVXSUQrIz8wrKVayiq6GMIFKDKwNlGpjYVKORUWJlUB5oIBLZmJuaklqkZKVgZ6BjpJPal56SQaUE5RfkliSmZ8H5YZnpsClPFIz0zNKoBzXnNQyZIXO+Tn5QAPzSnNyamMB1gT9gKoAAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Approved By": "Approver",
    Area: "0",
    "Checked By": "JLH",
    "Date/Time Stamp": "7/24/12",
    "Design Option": "-1",
    "Designed By": "Designer",
    "Drawn By": "SM",
    Family: "A1 metric",
    "Family and Type": "A1 metric",
    "File Path": "C:\\Program Files\\Autodesk\\Revit 2021\\Samples\\rac_basic_sample_project.rvt",
    "Host Id": "-1",
    Scale: " 1 : 100",
    "Sheet Height": "594",
    "Sheet Issue Date": "7/24/12",
    "Sheet Name": "Plans",
    "Sheet Number": "A102",
    "Sheet Width": "840",
    Type: "A1 metric",
    "Type Id": "A1 metric",
    Volume: "0",
  },
  {
    ID: "411452",
    Category: "Topography",
    "Cushion/Chair Back Material": "0",
    Description: "-1",
    "File Path": "0",
    Illuminance: "<None>",
    "Mass Floors": "Grass",
    "Moves With Nearby Elements": "0",
    Phase: "Working Drawings",
    "Phase Created": "None",
    Profile: "3527",
    "Suppress Spaces": "3611",
  },
  {
    ID: "411864",
    Name: "Grid: 6.5mm Bubble",
    Category: "Grids",
    "Center Mark Visible": "Continuous",
    Description: "-1",
    Enclosure: "0",
    "End Segment Color": "Grid Line",
    "End Segment Pattern": "1",
    "Facucent Drilling": "6.5mm Bubble",
    Family: "6.5mm Bubble",
    None: "Top",
    Pipe: "No",
    "Plan View Symbols End 1 (Default)": "Yes",
    "Schedule Level": "None",
    "Switch ID": "M_Grid Head - Circle",
    "Tumble Dryer": "6.5mm Bubble",
    "Type Comments": "6.5mm Bubble",
  },
  {
    ID: "412015",
    Name: "Grid: 6.5mm Bubble",
    Category: "Grids",
    "Center Mark Visible": "Continuous",
    Description: "-1",
    Enclosure: "0",
    "End Segment Color": "Grid Line",
    "End Segment Pattern": "1",
    "Facucent Drilling": "6.5mm Bubble",
    Family: "6.5mm Bubble",
    None: "Top",
    Pipe: "No",
    "Plan View Symbols End 1 (Default)": "Yes",
    "Schedule Level": "None",
    "Switch ID": "M_Grid Head - Circle",
    "Tumble Dryer": "6.5mm Bubble",
    "Type Comments": "6.5mm Bubble",
  },
  {
    ID: "412093",
    Name: "Grid: 6.5mm Bubble",
    Category: "Grids",
    "Center Mark Visible": "Continuous",
    Description: "-1",
    Enclosure: "0",
    "End Segment Color": "Grid Line",
    "End Segment Pattern": "1",
    "Facucent Drilling": "6.5mm Bubble",
    Family: "6.5mm Bubble",
    None: "Top",
    Pipe: "No",
    "Plan View Symbols End 1 (Default)": "Yes",
    "Schedule Level": "None",
    "Switch ID": "M_Grid Head - Circle",
    "Tumble Dryer": "6.5mm Bubble",
    "Type Comments": "6.5mm Bubble",
  },
  {
    ID: "414482",
    Name: "M_Concrete-Round-Column with Drop Caps: M_1000",
    Category: "Structural Columns",
    Level: "Level 1",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABABNjUEKwjAURO/y12lI2qTauBIVBF2UIrgoXUT9tIGYSI1CKb27ASu4G+Y9ZuoRyos5DQ8EBQd/MRVeg3atRSBQeuPCE1Q9fmNUEk5FtkhXCaN5zgVMzU9b970eohuLrdF3DNiDYpQROKJrQwdK0CLlGYHKBx2MdzM+m9s/3aNpu3jFJc2XqSCws/ie/UTSgklJYOOtj/PuZe3UfAD8VdnJxAAAAA==",
    Pbi3DGeometry:
      "B1UAAB+LCAAAAAAABACtnE+P1EYQxb/LnGdHdvs/nCISKVJyQEmkHCIOIFYwEmEjsoqEEN89bY9n126/n6trQQiWqe15Xd39qrqrqu2/vhxevjn/8fmf28Ozwy93b86/3304vz0cDy/vzh/v/z08++vL5b/x18Xz+Ofw9fgouSmL4vn0T/x7+Prq+rUfPn16/Tl+96Y4tUNojjfhVIbq2J/Kqo2filPdVceb8jT0fbOQlmVRjuI2NO2DuDyVfdGOEKEv20XroSqqSRzKJYjuUEljR0M1bJCxQ6kejSV0F3EfyoceI0RfTaqX/aMsFFWYVGzLetEyhGHSpe0X3y9CXY/SumjL/bYw5upUdF2XdhcbDUNXZ2LomdDKaQhQGZRzrZ5uHKJSZb1ZpvixrsOGRNA6Qvbh25CRcnXVTa2r4pEaxEQACadmGEHWnOPBdO1luVZ0RrHkRzj1Qz9s1hy7BBDoUoLQ+gK0FAPPorjpmsQ+oTEZ6J4xx59NvaFIMc5ht3ERdVH3i0FPFldEeoTeBFCdSQTddjbk+KOvqpSicW66wdBrdn5xDEOfOspxZpouXc04hKII+33NxhCFTd9bamlUBaDbzrvLemr1EEADNQUwLrGKMLOziSewswFt2k62uV5GTa+rmSScebSHnNZ6HA4toDvcsSb3kCyG7A5V0wh6ihWuRqDexs1jTTM9D/R9mPVpL9hYhYJQ9MOlkD5PebfEgm6a01A0qbE8SFc6LKRL01xALK1wIZYdIgi01oooKQ1lOclXceJTjdYAvbb+R+ilY7Y69CH7MJbO7WnQyf75AJLQfCFfGuBCvLRAa7JBDCAri11Il/7BxpBqr63W5CRovfT6tn6gCGB7VoHYQyjuTleHuAd5sl845OPxbile+rrFoBaO0aAtknzlMDfQSz3IINbnXVOPVQxmgNCMsyqruM9UkXRZBsyWir4+06xAujdcQyaTW8RFt5arNIA1B14tcVlXkVPqGjbaJAFYxuQQvheH2q+iygwDlvZO3Sbhc8awfNOQhP7JfpIuFrcmdNKeRqs5RThJKiKjvcRnRym9qvSTnF6gBcnhDZxxLZZZnmKbYtAokOvQmrOFeKjkzXKRlyDzsLNihuI8TFJFZrowuUbTohnN2aEMvtiZJ01FH+VyzMJMrwEIMRGSizlZROKQmbnMYqKLc2bmV5JZW1sO255KQswIQ6deZy7RqZYBZx44x8m6DG1DdGDDTnVBgkBUFYY1l4c1aydLDvGiwAN1EXlkhFNzVj3IPr/TaZROr7rOAzluNR16X2daQr0DbCELxULPI+z34bHRZ479mVaZQXnTEKDSCdBZrPLx3qiy6LZkDMIkNazH0E0j2KumYL4gI8EnE7e+RIS25P0zuq5IaI0hFciZYkjzZtdgMCOp05e64mO3tccHauhikExXU5VKTZHBwpQZ20R/Fon2KgVZRPZXG7NoZZUbdVtYOJNUHqp5OGVVHHXbjAKIBSxtDknpKMjaCPu4VJfT2fiM/L+ulUHjJGzYdrgt4zGCLiVCpQDy9joRmZn8tuqXUEKAWousQOa1tscJqqjStnl/YzMnMnInTuqKqrQAG8DEtZn6Hfj7tEq4AMgpilmwwH99iUEDZ3DIRXKjyk6NJfN91yaeYOAZ3H9ELy5uvh2Kcf6Gpu2msKOuuyhtuvpRWp6aZris7TCY0i6qHaVdO/QLXNWbRpA6xKkspxPCUNT1PgA1rcqm2vbVFmGUhrqpF9KuaiagegpnrtK4mO20Hn3Y70xPI3Wm284OpA51byIIxcZP1egM4sDbujQgysid2E+yanrO4seLp0jWUrdtw7AZnEbQbSWunHW9FMU4kVU6kaTXNGXJuo/nuhCSGXNpUNRFD8uz6Uu03e+rLntTATEAPTH5qFFYDeXC2+xxcfSHVZPiXldhTBCMnm7bOjGqC3Q8R45zZGBj68m0t1ZBIFoMIJNpjV6ptQc/W/joMOtu44HTOZnd6uhIh9Da2MWcRSrKKmM4sksvCAweRilBYJSzDxiPGFXoLPrMxE67nK1gq6Dyh1c7XLOHzAvUkP253DI01trhPgDqAXQ/VyNWi25aamLXEgSWcd570kUHEGQOYAOhpnPDtrUEYX+kDWEoL6uwcoyeKF7XAh2hdk5kb0UU8u6ySGVoZSk9IRIneHl02xk2zc7zQFIJYFWiyPMsgJ5ySs5lZ8Yg+KEQTsU+3yHc89xwzldX0zEngLMQHFGdL5QynpzKihi10oicD6GNfv/Rlaz0bkbdYLf44XlKBuqk+kk6XQLKf5bOBXx1EtklMVVtc10UcdYN4VE/6bLzn1fUEOBH8U6Br7wK1zJ8t0/klCK274k3320axy0geszRdxHEN3/5DzTinSvPPRqgOjAELtLAfMjWGhsYvGcw6QlFxsqy+qviZ30sR9+joxQoje/kJpJIgiv0OmaASAduFujoDKIUcGsQYEAkAdgU6kj/SmOkWFM4TQxSwOOp0WguwbYpGOZ8UtxBD94gJaOlSUjb0Zo5NitcJdeLAoByvqtDQFC43aNpm//kPdPWx8/v8Aw6htyQ14KUFGSTfE/aQ5eQ7pL7FbQFrSF/IBMFdBikvCXlROWhA3J0gI0HGj0aeA+AVhAWEhSEEwbwEpjmOxd52CCFxGBNVchTed4V4X3NAyyB730OsLxENM0oOsNTql5qIrFdoZXbUPPfFYGkBAobichVxpHLykptLG7qOras5mBiY6cQk2JAQkfqpquecIdA1k11WVsnq3SpWpe1de1Wl9ZlFg2GJgehs2i6Cq+TumoQ7qyWZpXv0oSDEnA/SRBl54qTTtRr5Twvf1ALlf+aBySb50KQJqYehKarVEwvhqarh5iyiKHHq28RqnsG+v4CVfn1jQB5TVNXTHRncKlB1kGyL0BQRV6GdvCGIMdFA/F+H7o+oGF1zUUNAd5GpC9L6CXTijlesKO55CmpeRYdpJqj6n1Cmneao3oQjvcvyesh+a+FopUEMnmub2+JRyroV1uZt9X3iattz75wb9FOMlQ50WqMKYbj5PrDcTh1kRAP0vgzjuUqjZwJMX7JF2rQtXT9/UQrLZ0BdqVrDdbCNarUVX7d0//uYHPmZR/WM13rpfEsuMbdm8U94bdyK2Nl94Q7Hb06Hn48v/779v720+FZtMnj4dfbj+/u388ffru7f31/vvs4f/zz/PbhVz/fnt+9v58//PTh9r9lwxd3H+4i4OFFMf45fH31P1LBT8YHVQAA",
    "Assembly Code": "B10",
    "Assembly Description": "Superstructure",
    b: "1000",
    "b 1": "500",
    "Base Level": "Level 1",
    "Base Offset": "-1800",
    "Capital Height": "250",
    "Capital Top Offset": "250",
    "Capital Top Radius": "450",
    "Column Location Mark": "B-2(1500)",
    "Column Style": "Vertical",
    Cost: "0",
    "Design Option": "-1",
    "Drop Panel Length": "1500",
    "Drop Panel Thickness": "250",
    "Drop Panel Width": "1500",
    "Enable Analytical Model": "Yes",
    Family: "M_1000",
    "Family and Type": "M_1000",
    "Height 1": "250",
    "Host Id": "-1",
    Image: "<None>",
    Length: "4900",
    "Moves With Grids": "Yes",
    "OmniClass Number": "23.25.30.11.14.11",
    "OmniClass Title": "Columns",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rebar Cover - Bottom Face": "Rebar Cover 1",
    "Rebar Cover - Other Faces": "Rebar Cover 1",
    "Rebar Cover - Top Face": "Rebar Cover 1",
    "Room Bounding": "Yes",
    "Section Shape": "Not Defined",
    "Show Capital": "Yes",
    "Show Drop Panel": "Yes",
    "Slab Thickness": "120",
    "Structural Material": "Concrete - Cast-in-Place Concrete",
    "Top Level": "Level 2",
    "Top Offset": "100",
    Type: "M_1000",
    "Type Id": "M_1000",
    "Type Image": "<None>",
    Volume: "4.1",
  },
  {
    ID: "415791",
    Name: "Grid: 6.5mm Bubble",
    Category: "Grids",
    "Center Mark Visible": "Continuous",
    Description: "-1",
    Enclosure: "0",
    "End Segment Color": "Grid Line",
    "End Segment Pattern": "1",
    "Facucent Drilling": "6.5mm Bubble",
    Family: "6.5mm Bubble",
    None: "Top",
    Pipe: "No",
    "Plan View Symbols End 1 (Default)": "Yes",
    "Schedule Level": "None",
    "Switch ID": "M_Grid Head - Circle",
    "Tumble Dryer": "6.5mm Bubble",
    "Type Comments": "6.5mm Bubble",
  },
  {
    ID: "417494",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "418079",
    Name: "Basic Wall: Wall - Timber Clad",
    Category: "Walls",
    Pbi2DGeometry: "BwEAAB+LCAAAAAAABAB9jsEKwjAQRP9lzyE0jZW0nkQFQQ9FBA+lhxZDuhCzUqNQSv/dQNXqxdvOvmFmih7yGo/dVUMGO6oxJ9sZcsAgJ3T+BlnRj2cwSMkjIeaLlKuZTGFgE4pjnog4/Y+EEuIHTYEjKt+1y7atutAdHmusLtrrFrKIRwz22hnfvMSBfOUxzB3lCc8ftNVomtChuEqUZLCx+vHtXZGlkOnu1g7lE9ljgkAHAQAA",
    Pbi3DGeometry:
      "pwMAAB+LCAAAAAAABACdU98LgjAQ/l/ueY1NK6Y9RT8I6iEq6EF6UBo6MBc2ghD/92aZVtiUODZ23919t33bvAzWgdjdzhxcWMpAbGUsjoBgLUWiLuB62XOpw2SkDXJUIz1KyOgx6QH54VU2TlP/pmstCw+o5SAHs77tIIIJ+oIYZgNmI9vGhNLhP2gDaQHVWZRR+qqtEw3oJ2MFfTH+btKwwYbabk2NJzOdv52+oyTv0ne+z2bSNrkMIhq31fZODN1aL/aX7E86/eKnwj9xxVNwiyxY8SRUUelspPKVkEnp7sWxCi24CCNVOrOYX98TJzKWmhDmTmH6Y90BCCjSGKcDAAA=",
    Absorptance: "0.1",
    Area: "9",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    Cost: "0",
    "Cross-Section": "Vertical",
    Description: "Structural Insulation Panel Wall with Kiln Dried Timber Panel Rainscreen",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Wall - Timber Clad",
    "Family and Type": "Wall - Timber Clad",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Keynote: "F10",
    Length: "3200",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Structure - Timber Insulated Panel - Insulation",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Wall - Timber Clad",
    "Type Id": "Wall - Timber Clad",
    "Type Image": "<None>",
    "Unconnected Height": "2700",
    Volume: "1.75",
    Width: "202",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Both",
  },
  {
    ID: "418183",
    Name: "Floor: Generic 300",
    Category: "Floors",
    Level: "Level 2",
    "Aalto Vase Material": "0.1",
    "Architrave Offset": "100",
    "Coarse Poche Material": "0",
    "Coarse Scale Fill Color": "-1",
    CosAng: "0",
    "Default Elevation": "300",
    Description: "-1",
    Elevation: "2700",
    "Elevation at Bottom Survey": "3000",
    "Emit from Line Length": "No",
    "Facucent Drilling": "Generic 300",
    Family: "Generic 300",
    "Full Step Arrow": "Interior",
    "Heat Load Values": "0.0000 /(·)",
    "Height 1": "0",
    Illuminance: "<None>",
    "Parts Visibility": "45611",
    Phase: "Working Drawings",
    "Phase Created": "None",
    "Referencing Sheet": "No",
    Rim: "Yes",
    "Rough Width": "1",
    "Slab Thickness": "0.00°",
    "Story Above": "No",
    Structural: "SH_resin Floor",
    "Text Type": "0.00 /",
    "Thermal Mass": "0.0000 (·)/",
    "Thermal Resistance (R)": "300",
    "Tumble Dryer": "Generic 300",
    "Type Comments": "Generic 300",
    "Type Id": "<None>",
    Voltage: "30.15",
  },
  {
    ID: "418977",
    Name: "M_Wind Power Generator: 9 Meters High",
    Category: "Site",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jlELwiAUhf/LfRbRTU3tKSoI6mGMoIexh61kE0xjWTDG/nuO6u1wv+9yTjVB0drz+DCg4RhaW5prbHznDCAogvXxCbqavjEpnGJBlVgrzGTOYa7/1mYYmjGp6bCzzd1EM4AmmCA4Gd/FHrTAK0I5gjLEJtrgFyyY4FRKRYiUlDOe8MXeFpvhTFGB4GBs16fmPMcqk4nvnXn//tMWRhiCbXAhtfmXc3P9AQDBzLTSAAAA",
    Pbi3DGeometry:
      "xwcAAB+LCAAAAAAABADtk08LgjAYxr/Le15jy2k2T1FBhw4RQYfoYDRqYC5sBRF+98S0P6ZLryEy8f357HHv3LO6wWwjF9ejAB6egwDBTMlQn4Cvbo9H4EC85IIYvUiHEuKlt2RAvM6nDaLIvyZzmYupayEHM7dLEcUOIwzZDqaUVVFq4T4jvRwbHcq1BWr+XEYtG9uO2/9yLnLzOqpcTL18wtyh0EoBlzpUaBvt0Q9stq6pNvbS6GfVcSjXmmnDs2E2qbcbSXJG0j8ILSLgBBMEUxHu9D4r5kr7WqowK5dy+3w1EXK311kxDsTlXThUgYoeiU5j20a8jXgb8b+N+PoOxMbjsccHAAA=",
    Area: "3",
    Cost: "0",
    "Design Option": "-1",
    Family: "9 Meters High",
    "Family and Type": "9 Meters High",
    Host: "Level : Level 1",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "500",
    "OmniClass Number": "23.75.10.31",
    "OmniClass Title": "Wind Energy Equipment",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Pole Height": "9000",
    "Total Height": "9300",
    Type: "9 Meters High",
    "Type Id": "9 Meters High",
    "Type Image": "<None>",
    Volume: "0.24",
  },
  {
    ID: "418985",
    Name: "M_Wind Power Generator: 9 Meters High",
    Category: "Site",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jUELwiAcxb/L/yyimzq1U1QQ1GGMoMPYYZVsgmksC8bYd89R3R7v93u8eoLyYk/jw4CGQ7jYylxj6ztnAEEZrI9P0PX0jUnhCrOCy1WOOWc5zM3fWg9DOyY1FVvb3k00A2iCCYKj8V3sQQtcEMoRVCG20Qa/YMEEp1IqQqSknPGEz/a22AxnigoEe2O7Pj3nOVaZTHznzPu3p2lPGIJNcCG9+Zdzc/MB8GcOUtIAAAA=",
    Pbi3DGeometry:
      "xwcAAB+LCAAAAAAABADtk82OgjAUhd/lrmtzK5QRXBk1ceHCTCaZhXGBsdEmSA1WE0J8dxuF+WmgwtYQUuj9OD1wC2ddwGorv/KTgCi9JAmBlZKpPkO0Lp5TiADH5oAb+SUDhjh+nMyA26ZaNsmyODdreUDRCxlByvkwJIwGPvok8Gj4Ya71dESRMb+ibod67X/qflpJPU55MAptYxs736LBw9mIRSsLqxMb13s0iLvskZO6jduJ3Z10+lStLBrEL3C3n+OFSasNMcmZyfgotMggQooEliLd60NZfCoda6nSsvyWu59bCyH3B10W80Rc/wqnKlHZM9GP2PYR7yPeR/xtI765A8G0WR/HBwAA",
    Area: "3",
    Cost: "0",
    "Design Option": "-1",
    Family: "9 Meters High",
    "Family and Type": "9 Meters High",
    Host: "Level : Level 1",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "500",
    "OmniClass Number": "23.75.10.31",
    "OmniClass Title": "Wind Energy Equipment",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Pole Height": "9000",
    "Total Height": "9300",
    Type: "9 Meters High",
    "Type Id": "9 Meters High",
    "Type Image": "<None>",
    Volume: "0.24",
  },
  {
    ID: "420270",
    Name: "Bathtub-TOTO-Nexus-FBF794S: 01 Cotton",
    Category: "Plumbing Fixtures",
    Level: "Level 2",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABAA1zUELgjAYxvHv8p7XmNNtbp2igqAOIkEH8aA1dLC2sBWI+N2bVLeXP7+Ht5qgaM15fGhQcPStKfU1NK6zGhAU3rjwBFVN3zOSFcE8EetVjmVGKcz1X22GoRkjjWFnmrsOegBFMEFw0q4LPSiKM0lyBKUPTTDegUowE0RInlIuZJZLhuBibotlmBOWIjho0/VhkSIGBHur37+xxHlGY9p66+Mr97J2rj/e7zT+zwAAAA==",
    Pbi3DGeometry:
      "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",
    Area: "3",
    "Assembly Code": "D2010510",
    "Assembly Description": "Bathtubs",
    "CADworks URL": "http://www.CADworks.net",
    Cost: "0",
    CWFU: "0",
    "Default Elevation": "0",
    Description: "Cast Iron Bathtub",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "01 Cotton",
    "Family and Type": "01 Cotton",
    Finish: "Metal - TOTO - Enameled - 01 Cotton",
    Host: "Level : Level 2",
    "Host Id": "-1",
    HWFU: "0",
    Image: "<None>",
    Manufacturer: "TOTO",
    Mark: "12",
    Model: "FBF794S#01D",
    "Nominal Height": "537",
    "Nominal Length": "1700",
    "Nominal Width": "750",
    "OmniClass Number": "23.45.05.14.21",
    "OmniClass Title": "Bathtubs",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Product URL": "http://www.totousa.com/Default.aspx?TabId=75&ProductId=0f62a304-6f03-4786-b3a1-ed82694f167b&SearchId=2b23fb16-8c35-4b42-bd24-70517483f004&PTab=2&STab=0",
    "Schedule Level": "Level 2",
    Series: "Nexus",
    "Shipping Weight": "1.73",
    "Skirt Material": "Plastic - TOTO - 01 Cotton",
    "System Classification": "Sanitary",
    "System Type": "Undefined",
    Type: "01 Cotton",
    "Type Id": "01 Cotton",
    "Type Image": "<None>",
    URL: "http://www.totousa.com",
    Volume: "0.26",
    "Waste Connection NPT": "76",
    "Waste Connection Radius": "38",
    WFU: "0",
  },
  {
    ID: "422243",
    Name: "Basic Wall: Wall - Timber Clad",
    Category: "Walls",
    Pbi2DGeometry: "BwEAAB+LCAAAAAAABAB9js0KwjAQhN9lzyG0TbSxnooKgh6KCB5KDy2GNhCzUqNQSt/dhVp/Lt529htmJu8hq8yxu2pIYIeVydB2NTpgkKFx/gZJ3o8nGUTEVSjjpeRiISUM7IMiQiL+iwSPRTj/QVPghIqpNm3bsqNueqxNedFet5AEPGCw1672zUsc0Jfe0NxRnsz5jbba1A11KK5mSjDYWP349q7QImW6u7VD8QRO/pDJBwEAAA==",
    Pbi3DGeometry:
      "gAkAAB+LCAAAAAAABACdVl1rgzAU/S95dkFNqtE+jX0w2B7KNthD2YOl0gacGU4GpfS/LzrXabw3xiIt5njuudfkfrg+ktVGvh4+c5KSR7WRL6qQW+KRlZJl/UXS9fH3Vj/2l/oiJ+8fuQp8f9n+6R85vf+ZXVdVdtC2LKRcMO5xyhLOPZ/6noZCkQgLFFHRrAxbQcVCMIQbJjSKFsFYYY6uGakh2kKMBlESWFjWgAxz2HWHwlwn3TasiCZhzD1GYxZEZ/Mh2o+/gwzFPhGwHbJgJ8b7XBpQTLmzK1gBcDUU7efi0NZAO2J7apORo4p9cyMVRui0gjUAQBTZ0KGC83nglY3Vv30rLSw8yd0qFDl4iAVsBp6vE/KT1YNEP6s7wGcKo7ACWFBIDKAukm0XdArrG09soJN3Vz+WkTW3c0xNJufRCIgihWpFXQamfcJZvWFVhNfanFltTTy8sQAdaexEf8rcyuwjr/OKpA2LPOXlrt53i2dVZ7VUZbd8k9vzo4dc7vZ1t7gr8u8+8UYVSguS+6S59BfTDz5TXD+ACQAA",
    Absorptance: "0.1",
    Area: "6",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    Cost: "0",
    "Cross-Section": "Vertical",
    Description: "Structural Insulation Panel Wall with Kiln Dried Timber Panel Rainscreen",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Wall - Timber Clad",
    "Family and Type": "Wall - Timber Clad",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Keynote: "F10",
    Length: "3041",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Structure - Timber Insulated Panel - Insulation",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Ceiling",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "0",
    Type: "Wall - Timber Clad",
    "Type Id": "Wall - Timber Clad",
    "Type Image": "<None>",
    "Unconnected Height": "2700",
    Volume: "1.21",
    Width: "202",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Both",
  },
  {
    ID: "422466",
    Name: "Single-Flush: 800 x 2100",
    Category: "Doors",
    Level: "Level 1",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABAA1jV0LgjAYhf/Le73Gpm46u4oSgroQCboQL2YNHawtbAUi/vdmH3eHh+ecU09Qtvo03hXkcHCtrtTFS9sZBQhKp61/QF5P3xiUmGCRpmydYMJjmJu/tBkGOQYzgJ2WN+XVADnBBMFR2c73kMeYJoIjqJyXXju7kJiRjCckopyTTAhWrChDcNbXpUAw5QmCvdJdH65TTFkUISiMev0GPvtbZ1z4sk9j5uYNAJu7Gc8AAAA=",
    Pbi3DGeometry:
      "PxEAAB+LCAAAAAAABACtV01rwkAQ/S97TkPcfJjoyWqh0B6kLfQgHhSDBqwpNhRE/O+NdqtmfbOzq0UU83z73mR2ZtyMtmI4Ld42n7noiKdyWryWy2ImPDEsi1X1JTqj7e/X+uegW7/Ezjshd60g6B4+6rfYjf+W9dbryaZeG0pfplnqhX6axW0v8ANPZn6SxC0DlPjpfg1GNUWMNkXbYSu5FD2ge+JprQOE5YwoVrC6H2NGrG+UI7pYUWkmsmeMxlQaYGOtN8dItHPAe6KZxLEMvciPMpk2lisIE9t+K5byeMs2XFKXdwNhqYRHgWwboCvCxFwXXQ1lIw2zKGoUkIIurA/oRTZ5LqnLu4Gw1Gao1FHQFWFirouuhhKRku7YB5cyrhxcI3hLQJqNRBcrhyqjWUxvNbUAxNc1TbRzwF1nqAiu9Plu5saWdVUaiS5WYEIyfUpHY5q2eCZbjwGaaOeA+w+1SugnYSi1v+QDpI0fhWojxYZL6vJuIKzzG6WhK8LEXBddDWUj5c8058SLbPJcq7MSVqAPdyp1FHRFmORh1VoXnzn1SEl37INLGVcOrhG8JSDNRqKLlUOV0Symt5paALrlrG7ngLvu9ucyQzdzY+t/nstcrMCEZPqUjsY0bfFMth4DNNHOAfffmcnYE4Ni8pFX+Vp09mvFc76aVwt18VJWk6ooV+ryvZgdf3rMi/miUhcPy/z7nNgvl2UtKAb9/n2vJ3bjH9AoWwM/EQAA",
    "Analytic Construction": "<None>",
    Area: "3",
    "Assembly Code": "C1020",
    "Assembly Description": "Interior Doors",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    "Door Material": "Door - Panel",
    Family: "800 x 2100",
    "Family and Type": "800 x 2100",
    Function: "Interior",
    "Head Height": "2100",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2100",
    "Host Id": "Wall - Timber Clad",
    Image: "<None>",
    Mark: "103",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rough Height": "0",
    "Rough Width": "0",
    "Sill Height": "0",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "50",
    "Trim Projection Ext": "30",
    "Trim Projection Int": "30",
    "Trim Width": "80",
    Type: "800 x 2100",
    "Type Id": "800 x 2100",
    "Type Image": "<None>",
    "Type Mark": "3",
    "Visual Light Transmittance": "0",
    Volume: "0.11",
    "Wall Closure": "By host",
    Width: "800",
  },
  {
    ID: "423099",
    Name: "Curtain Wall: SH_Curtain wall",
    Category: "Walls",
    Pbi2DGeometry: "CgEAAB+LCAAAAAAABAB9js0KwjAQhN9lzyEk2p9YT6KCoIcigofSQ4uhXYiJ1CiU0nd3obbqxdvOfsPMZB2kJZ7am4YE9q7E1Jm2chYYpA6tv0OSdcNJhvmcCymjZcxjEcTQsw8KZlyFgfyHpOALFUY/bEycWD4Wr5qmaKmdHhssrtrrBhLBBYODtpWv3+LofOGRBg/yjJcJ7TRWNZVIRZuEYrA1+vltXjvjKNQ+jOnzF1wjWCMKAQAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "17",
    "Assembly Code": "B2020200",
    "Assembly Description": "Curtain Walls",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 1",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Border 1 Type": "64 x 128 rectangular",
    "Border 2 Type": "64 x 128 rectangular",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Curtain Panel": "Glazed",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "SH_Curtain wall",
    "Family and Type": "SH_Curtain wall",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "64 x 128 rectangular",
    "Join Condition": "Vertical Grid Continuous",
    Justification: "Beginning",
    Layout: "Fixed Distance",
    Length: "3000",
    Number: "1",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "3000",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Roof Line",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "SH_Curtain wall",
    "Type Id": "SH_Curtain wall",
    "Type Image": "<None>",
    "Unconnected Height": "5700",
  },
  {
    ID: "423100",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1",
    Pbi2DGeometry:
      "0wAAAB+LCAAAAAAABAA1jUELwiAcxb/L/2yiUzHtFDUI6jBG0GHsYCWbYBrLgjH23TOq23uP33uvmaA6u+N4t6BhH8+utpdkQuctIKiiC+kBupm+MiNMYEHESmHGRQFz+4fWw2DGTOZg68zNJjuAJpggONjQpR40x7LgHEEdk0kuBtAMF0pSRYVUQnHOpSwXVCA4ueunkNtLxhDsrOv6/K2wpDT70tvXb4FgymiBYBN9zH/h6f3cvgH08Kz/0wAAAA==",
    Pbi3DGeometry:
      "ywMAAB+LCAAAAAAABACdU80KwjAMfpeca0m36X48iQqCHkQFD+Jhw6KFucosgojvbtXppm52SmlpviRf0qRZnGAcidlxxyGAoYzEVMZiBQTGUiRqD8HidL9qNbb1gjPJkQZDbN8OveG8fLh10jQ8al/bpV7LtYhPHXRdgpTZzCJvqE89x2oS26bMsbx/0HLeB5rb+uxJkJtWgZ+kBfCF82ug8kxL/euHNz3UXBRzrJqVKnbll26X0hoqWFnW72mZvlBVrJrNrm7BnVVPRU+EW654CgFSJDDiyVptMmEiVaiETDJxLlZP1YCL9UZlQj/mh6JhV8YyvU4leti9Dt8FzUzDocsDAAA=",
    "Analytic Construction": "<None>",
    Area: "4",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2960",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.11",
    Width: "1440",
  },
  {
    ID: "423107",
    Name: "Entrance door: Entrance door",
    Category: "Doors",
    Level: "Level 1",
    Pbi2DGeometry:
      "0gAAAB+LCAAAAAAABAA1jUELwiAcxb/L/2wyneK0U9QgqMMYQYexgyvZBNNYFoyx755R3R6P3++9Zoaqs6fpbkDBIXS2Npeofe8MIKiC9fEBqpm/MSE5xzzja4lzxiks7R/ajKOeEpmKndU3E80IKsMZgqPxfRxAMSwoYwjqEHW0wYPKMZWCSMKF5JIxJkS5IhzB2V4/QoZzWhAEe2P7IX0XaUAgKJ15/QYkLhhNwja4kO7807mlfQPK/bN90gAAAA==",
    Pbi3DGeometry:
      "qBIAAB+LCAAAAAAABAClmMtKw0AUht9l1jFMM8kkqSupgqALUcFFcdFi0EBtpAahiO/u2KZpMjm3VMRLvk7//9zmFJx/q7tl+bj9KNRU3VTL8qFalS8qUHdVua4/1XT+vf/TvazP3Zf6CY7kbKL1+e6H+1Y/z4e3XWw2i617r0nDzKZRkIeRnWTuVxZHSWBMOImjDKUmTiKGtrow7en26SQLE5tb9vAYux1FhFvcTxrBYzJh8uP8+kEzxR/TPpEfVzvBDEgo58dVgxoZMRZaplpbh21q9tjYtIOTeEdjnST+YZd6mhjZ2aFwG0YfE8o6dA/WlxCeHRMxEtoBe6cpjX+F7AlbE+c0PSrAdIwbfJZ081NGMF0gotPjHI9FhinZEFn3SDtv4GBKDiccmki3SzuDjGD6osLS/mXwsOcIDy1RTunMwcJU3tIiESEjhwfBEZUTNlCUNNI+Oj0kEWb1ySZGqC2bJGQ3n7ayaUvRwhV9cvRwFubGpEB02iaARvtpzh9GlBs8WB0H5dMNG+otRtLPo9hZSJesEJIdLAEH7M8ijb3LCSdCUrZPhN0ga5ieUHmRbpcOFxJSegqz7aMdva7ClBwt2bjwdoN9Qdwb7jaR/YdjgPsk10Vmnu6HMDaoPoyf7EaSpUdGCDUUtY/RGLFGkCUw3L/IWkbCZjAT9zhLeKTJzgijFhs+B+qyXLwXdbFRU9fxQN0W69f6rXm4r+pFXVbr5vGpfGlfui7K17e6ebhaFV/dg7NqVW3+/uWkMz37+8/SL+eSkeeoEgAA",
    "Analytic Construction": "<None>",
    Area: "4",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Entrance door",
    "Family and Type": "Entrance door",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2660",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Mark: "201A",
    "OmniClass Number": "23.30.10.00",
    "OmniClass Title": "Doors",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rough Height": "0",
    "Rough Width": "0",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Entrance door",
    "Type Id": "Entrance door",
    "Type Image": "<None>",
    "Type Mark": "60",
    "Visual Light Transmittance": "0",
    Volume: "0.1",
    Width: "1440",
  },
  {
    ID: "423134",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABFjUELgjAcxb/L/zyGm7q5dYoKgjqIBB3Ew6yhg7WFrUDE795CpNt7j9+PV09QtuYyPjVIOPnWVPoWlOusBgSlNy68QNbTEiOSUcwpFRuB0yynMDcrtR0GNUY0DnujHjroAWSCEwRn7brQ/wpJCUVQ+aCC8Q4kwTlPuGApZVxkhWAMwdXcFzilBUFw1Kbrw18+WP1Z7QLnTERl562PZ+5t7dx8AdR3FvHRAAAA",
    Pbi3DGeometry:
      "AQQAAB+LCAAAAAAABACVk98LwiAQx/+XezbR1dpcT1FBUA9RQQ/RwyIpYc1YEozR/56t9YNiO1MU73P6Ve68dQGzrVrmJwkRTPRWLXSidkBgplVqzhCti8fSulnPdriSN2lxxnrlZAdcN89j/SyLc3u249HA8wQRlIecEx5Svyu65I19JrwGHDAW4vipXYNL7XZAhQj9b5Ff/LW7RgTBNdpN70ZFXF6Cxvu/UCERbMJoil0+hPOVbvFGcNMfRK90ySWahk9tW0tDFR+lkRlEjDICU5nuzaEy5trERum0Mldq93KNpdofTGWMEnn53DjQic7utVw2W7I3THmvRQEEAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1440",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "423136",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zQAAAB+LCAAAAAAABABFjbEKwjAYhN/ln0NokjZt4iQqCDqUIjiUDlFDG4iJ1CiU0nc3WsXt7vjurh6hPJnDcNMgYedPptLnoFxrNSAovXHhDrIeZxkRxjBJabEQmKUZhan5Ucu+V0NEY7A26qqD7kEmOEGw164N3dsQRiiCygcVjHcgCc7yJBecUZ6LtBCcIziaywwzWhAEW23aLvzLG6uf3/ZnfOWtj0fuYe3UvAD7nXrUzQAAAA==",
    Pbi3DGeometry:
      "pwMAAB+LCAAAAAAABACNk10LgjAUhv/LuV5j08qPrqKCoC6kgi6iC8VRA3NhIwjxv7dS+xCdUxTPs/OeI+/ZDjkEEd89rgx8WImIb0XCY0AQCJ7KG/iHvPxUy2SibijQlwwoIZP3Sz1QHGvZNMvCh9LaNqZDy0Uepi6liGBqUwt96Yh4ViclelRVbEFlOQe7Y8f60zZRI7FdrqUtRdv/USc06Nvjo7EXWod0tGdkBuM169ZjaDfq3EO6Dtr56Nyta6kdP+fhhUmWgf9KgTVLT/JcBRshQ8lFWoV7Hn+WloyfzrIKFgm7/ybORCKy14l7X+pgPQGRdzxYpwMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1440",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "423138",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jU8LgjAYh7/Le17DzQ3dOkUJQR1Egg7iYdbQwdrCViDid29l3d4/z+/31BOUrTmNdw0SDr41lb4E5TqrAUHpjQsPkPW0jBFhFOeckbXAKeMU5uZPbYZBjRGNh51RNx30ADLBCYKjdl3oPwtJCUVQ+aCC8Q5kiqnIiCA8E1wwxrKsWBGO4GyuSyClOUGw16bro1zgnNH4Lqx+/Rq+gq23Psrc09q5eQPnsyiE0QAAAA==",
    Pbi3DGeometry:
      "IwMAAB+LCAAAAAAABACdkt0KgjAUgN/lXC/ZhpI/V1FBUBdSQRfShdLQgbmwEYj47k3TFJPMNjZ2vvO3nR0vBzfgx+zGwIatCPhBxPwCCFzBE3kH28tfR6XGjppQoJbMCMZOtakFxblxW6SpnylfnWpzSi1kacQkBGENoxYZ2KINMg2d/IwGYnXRgFUXWZqpU6PvO4VOus3XcNXjptDRPANWvXDduk6hf3/eR7heLcbpcB7VbSvuX5lkKdilCexYEsqoFvZC+pKLpBZP/PJWbRgPI1kL65g9uoZLEYu07PZqqKZ+Ag72m0UjAwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "3000",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "423139",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "1AAAAB+LCAAAAAAABAA1jcsKwjAQRf9l1jE0L5LUlWhB0EUpgovSRdXQBmIiNQql9N+NVHdzh3PvqScoL/Y0PgzkcAgXW5lrbH3nDCAog/XxCXk9LWdCOMVKcLLWmHFBYW7+1GYY2jGh6bGz7d1EM0Ce4QzB0fgu9t9AGKEIqhDbaIOHnGGqJdFESC0051zKYkUEgrO9LQVGFUGwN7brk1wltWIICmfevwWNFaepsQ0uJJ9/OTc3H6alUEXUAAAA",
    Pbi3DGeometry:
      "awMAAB+LCAAAAAAABACdk10LgjAUhv/LuV5jG4rTrqKCoC6kgi6kC6OhA3NhI5Dov7fMUkJN29jYefbuPWMfwQ38g9zmZwEeLNVBblQij4DAVzLVF/CC22topsnYVLijiowoIeOiMw3u+/eySZaFuVlrMcxtiyIX28RliHLsEMKRwQ5jbjumnNIeuPRuwd/edbWLucXsDo9hG6njZuuKNmu7jYedXoF7JmzWthzdH/hXwmZtjxschrsSmlc7k+FJaJGBRzBBsBJppOMyWCsdaqnSMtzJ42dqIWQU6zKYJ+JaF05VorLnrymK+RwPvgTRNWsDAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "423148",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zgAAAB+LCAAAAAAABAA1jUELwiAcxb/L/ywydS61U1QQ1GGMoMPYwZVsgmksC8bYd89Y3d57/B6/eoKytefxYUDBMbS2MteofecMICiD9fEJqp6WmBDGcEZIsZaY5ZzC3PypzTDoMaFp2Fl9N9EMoDKcITgZ38X+WwgjFEEVoo42eFAMk5xwSQvOuJArieBibwvKqCAIDsZ2fdIKLLhgCPbOvH9fiUVOOYJtcCGZ/Mu5ufkAKr+JU84AAAA=",
    Pbi3DGeometry:
      "awMAAB+LCAAAAAAABACtk1ELwiAQx7/LPZucayu3nqKCoB5GBT1EDxtJCWvGkiBi3z1bq43FqkWK4v08/6enri7gh3JxPgjwYKJCOVeR3AABX8lYH8FbXe5DM409UyElBWkxxF7WmQbp+rGsnyTB2axttymzLU5cyjhjhHHaReSkwA66VhkjY53GuEa7imu8y9il3LacqkYT+vPu3kpnB29Cv45X412RLue/Cf3Lhb9IV3L0mb6PZ17tUAZ7oUUCHlIkMBXxVu9yY6Z0oKWKc3MpN8+psZDbnc6NUSROZceBilRy+zVZMZ/jCoWSMEFrAwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "423149",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "ywAAAB+LCAAAAAAABAA1jbEKwjAYhN/ln0NokqY2cRIVBB1KERxKh6o/bSAmUqNQSt/daHW7O767q0YozuY43BE07P3ZlHgJjWstAoHCGxceoKtxlhERgiaMZUtFRSo5TPWfWvV9M0Q0BhvT3DBgDzqhCYEDujZ0H8ME4wRKH5pgvAMtKEuZVDyTQuZqoQiczHVGBc8ZgR2atou3iuYplwS2Fl+/7nd67a2PN+5p7VS/ASAdkYLLAAAA",
    Pbi3DGeometry:
      "IwMAAB+LCAAAAAAABACVkt8LgjAQx/+Xe16y+SP88RQVBPUgFfQgPSgOHZgLG4GI/3vTLH1Yahsbu8997w5uF1TgR+xc3im4sOcRO/GMxYDA5ywXD3CD6v2UbuzJDTXqyYJg7LWXPFBfP2GroghLGWsYGiZkiRzNwo6OsIaRRMTUbTUiNiEjqMulQMNcQ5Wj2aZu/YidV3SI1Ol6qtb+TjqvKy2aWUStVbTnDzRVRK2d+Jl5aKyInLYNC29U0ALcJhYONE9E2hlHLkLBeN6ZFxZ/XTvKklR0xjajz6FwzTNeNNPeLjnUL/oApH4jAwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "3000",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "424758",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1",
    Pbi2DGeometry:
      "1AAAAB+LCAAAAAAABAA1jUEKwjAURO/y1zEkzU9j4kq0IOiiiOCidFE11EBMpEZBinc3ou6G4b2ZZoT64HbPqwUD63hwW3tMXei9BQJ1dCHdwDTjN2YEGRUlUzNNBcoCXu2fmg9D98xoLpauu9hkBzCMMgIbG/p0BoNUFYgEtjF1ycUARtBCK665VFpqRFSqmnBJYO9OHyHbUyEIrKzrz/lc0xKlIlB5+/gtMMoFLwgsoo/5L9y9f7VvYBxg1dQAAAA=",
    Pbi3DGeometry:
      "ywMAAB+LCAAAAAAABACdU8EKwjAM/Zeca8nmtHY7yRQEPYgKHsTDxooW5iqzCCL+u1WnTt3clNLSvCQvadIsjjAO5eywFeDCUIVyqmIZAYGxkonegbs43q5GjZ5ZcCJPpGEhetfDbDgt727dNA0OxtexKbNtTjh1kDGC1GpaNnlDOWWszUmTUc47rX/QYt4Mzdly606QMy0DP0mf4Cvnt0DFmRb61w9f+dDKotSIVbNSua780u1C2qoKlpb1a1qVX6gsVs1ml7fgxmqmoieDjdAiBRcpEhiJZKXXmTBROtBSJZk4l9FDNRBytdaZ0I/FPm/oq1ill6nEDvqX4TsDMS6vKMsDAAA=",
    "Analytic Construction": "<None>",
    Area: "4",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2940",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.11",
    Width: "1440",
  },
  {
    ID: "424759",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1",
    Pbi2DGeometry:
      "1AAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7zG5qZz6xQlBHUQCTqIB62hg7WFrUDE796iuj0ev9979QxlZ07TXYOCg+9MpS+hdb3VgKD0xoUHqHr+xohwgllGxFpixtMEluZPbcaxnSIai51pbzroERTBBMFRuz4MoDgWCecIKh/aYLwDxXAiBZU0FTKVnHMhihVNEZzN9SNEO2cMwV6bfojnOc4yGgcKq1+/BYklySmCrbc+/rmntUvzBva6RwLUAAAA",
    Pbi3DGeometry:
      "3QMAAB+LCAAAAAAABACdU80KwjAMfpeca8nmz9Z5EhUEPYgKHsTDhkULc5VZBBHf3U6rTt3slNKffEm+tEmzOME4ErPjjkMAQxmJqYzFCgiMpUjUHoLF6XbUamzrAWfyRGoOYvu66Ann5d2tk6bhUfs2XOq5LiOMNtDz9MbQd8gb6vi02WItUvcoY37zP7iY2qA5W+Y8GHK2pegn7RN8Zf0aqviyhQTV41vfas1LhViVk5WvzU9lL2a25rE8u5bL2f9TacCKhS+vhqHVfdIT4ZYrnkKAFAmMeLJWGyNMpAqVkIkR52L1UA24WG+UEfoxP+QNuzKWadan6GM3a8cLutttmd0DAAA=",
    "Analytic Construction": "<None>",
    Area: "4",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2640",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.1",
    Width: "1440",
  },
  {
    ID: "424777",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABFjV0LgjAYhf/Lez2G23QfdhUVBHUhEnQhXmgNHawtbAUi/vcWIt2dc3geTjVB0ZrL+NSQw8m3ptS30LjOakBQeOPCC/JqWmJEmMCSC7pRmKUZhbleqe0wNGNE47A3zUMHPUCe4ATBWbsu9L9CGKEISh+aYLyDnOBMJEJxRrlQqVQiRXA19wVmVBIER226Pvzlg9Wf1ZY444oj2Hnr45l7WzvXX1yn7S/RAAAA",
    Pbi3DGeometry:
      "AQQAAB+LCAAAAAAABACVk1ELwiAQx7/LPZvoaptbT1FBUA9RQQ/Rw0ZSwpqxJIjou2e1VRTbmaJ4v9O/cuetLjBN1eJ8kBDDWKdqrjO1AQJTrXJzhHh1eS6tm3Vthyt5kxZnrPuY7IDrujrWK4rkbM+2QyqC0CMR5YJzwgX1gyggb+yzyGvAIWMCx5V2DX5qtynveOJH5Ad/7a4RQXCNduO7MRGnl2Dx/i9USAQbMZZipw/heqVbvBHc+AexK51yiaXhU9vW0kAle2lkATGjjMBE5luzK42ZNolROi/Npdq8XCOptjtTGsNMnj439nWmi3stP5ot2RsQFrY6AQQAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1440",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "424778",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zQAAAB+LCAAAAAAABABFjbEKwjAYhN/ln0NpkjZp4iQqCDqUIjiUDlFDG4iJ1CiU0nc3WsXt7vjurh6hPJnDcNMgYedPptLnoFxrNSAovXHhDrIeZxkRyhMhinwhEprlBKbmRy37Xg0RjcHaqKsOugeZJimCvXZt6N4GU0wQVD6oYLwDiZOcp1wwShgXWSEYQ3A0lxmmpMAIttq0XfiXN1Y/v+3P+MpbH4/cw9qpeQFnR1kYzQAAAA==",
    Pbi3DGeometry:
      "pwMAAB+LCAAAAAAABACNk1ELgjAQx7/LPS/ZZpHTp6ggqIeooAfpwXDUwFzYCCL67k3TlNJNRfF+u/+d/G8Ln7A+it3jysGHpTyKrUxEDAjWUqTqBn74/HzqZRzoG16oJgOCcVC89AOvQyWbZFn00Fp37DDmjRBziEcIwg5xCUU1HWFGOyk2o7JiCyrKDakzppQ1tX/oJ7FdbqQtRVv/0Si097X52NsLo0MGahuZfbw9u1kM7UZde8jYwTQfo7tVLb3jZyK6cMUz8PMUWPH0pM5lsJEqUkKmZbgX8XdpwcXprMpgnvB7M3EqE5nlJ6649MF6Az7uur6nAwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1440",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "424779",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABFjUELgjAcxb/L/zyGm7q5dYoKgjqIBB3Ew6yhg7WFrUDE797Cott7j9+PV09QtuY03jVIOPjWVPoSlOusBgSlNy48QNbTEiOSUcwpFSuB0yynMDc/aj0MaoxoHLZG3XTQA8gEJwiO2nWh/xSSEoqg8kEF4x1IgnOecMFSyrjICsEYgrO5LnBKC4Jgr03Xh7+8s/r1tQXmnAkEG299/HJPa+fmDfeYUYnQAAAA",
    Pbi3DGeometry:
      "3QMAAB+LCAAAAAAABACVk10LwiAUhv/Lubah62NzXUUFQV1EBV1EFxuTEtaMJUFE/z1b9sFanpps8zzqq7zHszrDNJGL015ABGOVyLnKZAoEpkrm+gDR6nzvmmHaNQ0u5EUajNJu+TEvXNaPZb2iiE9mbcv3At/nhHssZMz8gqDDyYu2Kfe/Uk5DhlKrW09L3WbgcR62KwoftDK3XsFJ63Ud58UU8DNg/v7jjtMzB8WyiWf+x91+8tdJHfcM2w3PG+b6m66pk4GMd0KLAiLqUQITkW/01gYzpWMtVW7DpUyfQyMhN1ttg2Emju8T+ypTxa1Oy8eU4xW5uZXm3QMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1440",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "424786",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jVsLgjAYhv/Ld72GO8jcuooSgroQCboQL7SGDtYWtgIR/3sr6+47PO/7VBMUrTmNdw0KDr41pb6ExnVWA4LCGxceoKppGSPCBJaMZmuJGU8pzPWf2gxDM0Y0HnamuemgB1AJThActetC/1kIIxRB6UMTjHegGKZSEElSIVPJORciX5EUwdlcl0A0EQR7bbo+yiXOOI3v3OrXr+Er2Hrro8w9rZ3rN3pXxQDRAAAA",
    Pbi3DGeometry:
      "IwMAAB+LCAAAAAAABACdkk8LgjAUwL/LOy+Zlun0FBUEdZAKOkgHpaEDc2EjEPG7N01TTDLb2Nj7vX/b23MzcHx2TG8ULNhynx14xC6AwOEsFnew3Ox1lGpsywk5ashExdguN7kgP9duiyTxUuk7NRRzbmiIKKqpqggrGDVIx0SrESGm/jPqidVGPVZtRBRzpuld3zF01G2+hisfN4YO5umx6oRr13UM/fvzPsJ1ajFM+/PIblsx70oFTcAqTGBH40CElbDnwhOMx5V4Ype3akNZEIpKWEf00TZc8ognRbeXQzb1E2pjgOojAwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "3000",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "424787",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "1AAAAB+LCAAAAAAABAA1jcsKwjAQRf9l1jE0L5LUlWhB0EUpgovSRdXQBmIiNQql9N+NVHdzh3PvqScoL/Y0PgzkcAgXW5lrbH3nDCAog/XxCXk9LWdCmMSaUbXWmHFBYW7+1GYY2jGh6bGz7d1EM0Ce4QzB0fgu9t9AGKEIqhDbaIOHnGGqJdFESC0051zKYkUEgrO9LYVkIgj2xnZ9kiushGIICmfevwWNFaepsQ0uJJ9/OTc3H6wmMlTUAAAA",
    Pbi3DGeometry:
      "awMAAB+LCAAAAAAABACdk10LgjAUhv/LuV5js8xNr6KCoC6kgi6iC6OhA3NhI4jwv7fMSkJN29jYefbuPWMf2xv4e7m+ngS4MFd7uVKxPAACX8lEn8Hd3p5DM008UyFDH9KjhHh5Zxpku9eyUZoGV7O272DOmY04tgm3EGXYIYQhg9nQseoxZZS2wIV3Df72Lqs5ZgPLbvDotpEyrrb+0Gpts3G308txy4TV2pqj+wP/SlitbXGD3XBTQvNqJzI4Ci1ScAkmCBYiCXVUBEulAy1VUoQbeXhPzYQMI10E01hcysKxilX6+DV5MZ/jDnuB4ChrAwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "424922",
    Name: "Basic Wall: Interior - 165 Partition (1-hr)",
    Category: "Walls",
    Pbi2DGeometry: "CwEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzG0iZpQT6KCoIcigofSQ4uhXYhZqVEope9uoP7Uk7ed/YaZyTpISzy2VwMJ7KjElGxbkQMGKaHzN0iybjiDQQqu46laTASPVTSHnn2ZCEyqv0zFQv6wUebA8nf1smmKNvSHxxqLi/GmgSTiEYO9cZWvX+JAvvAYJg/yhOcP2hqs6lCiuZ5pyWBjzWPsXZGlkOnu1vb5E3bzHdELAQAA",
    Pbi3DGeometry:
      "8AsAAB+LCAAAAAAABACtVt9rwjAQ/l/yXEOb1jTVp7EfDLYH2QZ7kD0oFg04O1wZiPi/L+1atfEuucoQxXz9cvddyH296Z5N5vpt95WzEXsq5vq1WOsFC9ik0Jvym42m+7+/5nE4Nh92CE7IIArDcf1jvuzw0W672W5nO7M3FlyoTAUDwaM0lIHkqloaOFFxcoRDHgY2tcE6PMXVUMUX1CaqyLiUwwhIRtFwig1Jg6hIPpHyRGaRj10Ftqk1hkSVPBNpV5eIeXSx3cLa7NB2C/uXshC5LZumziWapg6qr8YSrkKRVVgaiRjQVcMQ1bUdog55nCSyixHSIIqQTC0MJbMwF/V0qDXWHioc4ayhztk2bHWOLxketRPhsk1p0nrIgAJjh2kF6XGYVM+zeM6j9fB6+Q5UCtoWkBERHAfVQrijKA+KB/UdpJnQ8mgdBC0eu0PbDXz7wLGx+9vPj2k25+mNa6vsBEFO0GuaSJUuNuGmUBzaq8E38kAtTDFc77zjSoZQOw6GGJsXJkxj2GudlhL1B7en9RsHXbfVYcjEadKMznd69pmX+ZaNKhp7zjfLctUsXopyVupi0yzf9eL46DHXy1XZLO7X+c858bZYFyYgSx+qj5nQfwEQdoB38AsAAA==",
    Absorptance: "0.1",
    Area: "6",
    "Assembly Code": "C1010145",
    "Assembly Description": "Partitions - Drywall w/ Metal Stud",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "-1",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Interior - 165 Partition (1-hr)",
    "Family and Type": "Interior - 165 Partition (1-hr)",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Length: "3041",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Wood - Stud Layer",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Ceiling",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "0",
    Type: "Interior - 165 Partition (1-hr)",
    "Type Id": "Interior - 165 Partition (1-hr)",
    "Type Image": "<None>",
    "Unconnected Height": "2700",
    Volume: "0.99",
    Width: "165",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "425292",
    Name: "Single-Flush: 800 x 2100",
    Category: "Doors",
    Level: "Level 1",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABAA1jV0LgjAYhf/Lez3HNqc2u4oSgroQCboQL2YNHawtbAUi/vdmH3eHh+ecU09Qtvo03hXkcHCtrtTFS9sZBQhKp61/QF5P3xiUmGCRZck6YphzymFu/tpmGOQY3AB2Wt6UVwPkBBMER2U730MeY8pFiqByXnrt7EIYZUxwwVYkJowWEU0QnPV10QmmKUewV7rrw3WGacIYgsKo16/+Wd8648KTfRozN29Kyk8tzwAAAA==",
    Pbi3DGeometry:
      "CxIAAB+LCAAAAAAABACtV01rwkAQ/S97jmETjYl6slootAdpCz0UD4pBA9YUGwoi/vfGNLZ2s292xor4kefbeS+zM8Pmda8m8+x5956qvrrP59lTvs4WylOTPNsUH6r/uv/+Wf6tB+VLHbxfpBVoPag+yrc6TE/LhtvtbFeubYd+mPQSrxX6UScJPe1rL+z53W4UkFjXT47LAGxGBbAROA7CtiVwBR+pZ8tFGAhJwyAI887o9Aju2U2V6cG8o2Q6TJFFY9tvwYY5qFwZsE+GUhSVlyWs47ARocIANfaDqPw6u30GG8fmSNrc1VvQ0WFMYhfZBWxZbBNmOA5i3TWLq8KaBiq4mV0GG8fmSNrc1ftzyiTELrIL2LLYJowcYw9ADBQ7KCpQPWCXbHl3UGV6ohIkeM4mNOLZMEbpU1SuDGhQqlac/cFpfufAE1StgyrTsw1YV1NTpsiBDQa7YHBQVK4M6FXQUkmgY7OKKqw5tiq4OYgYbBybI2lzZ9wzxC6yC9iy2CbMcMw4QP2hNrPLYDMPZyAIcaw8ZRJiF9nFB2ZBbHDobTjGHoAYKHZQVKB6wC7Z8u6gyvREJUjwnE1oxLNh/3x24MqABr3K8yPV/M6Bd73nR5mebcC6mpoyRQ5sMNgFg4OicmVAr54pTT01zmZvaZFuVf+4Wj2km2Wxqi8e82JWZPmmvnzJFj9/3aXZclXUF7fr9POcOMrXeRlQjUejm+FQHaZfwylGZAsSAAA=",
    "Analytic Construction": "<None>",
    Area: "3",
    "Assembly Code": "C1020",
    "Assembly Description": "Interior Doors",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    "Door Material": "Door - Panel",
    Family: "800 x 2100",
    "Family and Type": "800 x 2100",
    Function: "Interior",
    "Head Height": "2100",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2100",
    "Host Id": "Interior - 165 Partition (1-hr)",
    Image: "<None>",
    Mark: "104",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rough Height": "0",
    "Rough Width": "0",
    "Sill Height": "0",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "50",
    "Trim Projection Ext": "30",
    "Trim Projection Int": "30",
    "Trim Width": "80",
    Type: "800 x 2100",
    "Type Id": "800 x 2100",
    "Type Image": "<None>",
    "Type Mark": "3",
    "Visual Light Transmittance": "0",
    Volume: "0.11",
    "Wall Closure": "By host",
    Width: "800",
  },
  {
    ID: "425745",
    Name: "Basic Wall: Interior - 165 Partition (1-hr)",
    Category: "Walls",
    Pbi2DGeometry: "DQEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzGkTSqxnkQFQQ9FBA+lh4qhXYhZqVEopf9uoFYUBG87+4aZyTvITnhorwZS2NIJM7JtRQ4YZITO3yDNu+EMhlhxLeLZfBJzpSIFPfvBIsG1TOQ3TLhUavoHjqnFWL5omrINC8JjheXFeNNAKrhgsDOu8vVL7MmXHsPoQR7x/EYbg1UdSjTXiZYM1tY8Pr1LshQy3d3avngC+PEqlQ0BAAA=",
    Pbi3DGeometry:
      "3QMAAB+LCAAAAAAABACVU1sLgjAU/i/neY3lNM2eogtBPUQFPUgPRkMH5sJGINJ/b5ZlF53G2Nj5zv07HC+D5Z5v0hMDF+Ziz9ci4gdAsBQ8lmdwvezxVWoyUAeuqEQ6XUIG90dduO6ebsMk8VPla5jYIUYfKRNsEdpHBBP0AzrYsRxa4ga2uwb9E66MfActTE2z9+P/hL+r+MY/YugC65JVFatzb06uZVbHSdv+a+j6bzgtR9wuZy1rurYbpl5JcNsumvC66ak9GXP/yCRLwM2NYMHiQIaFsBLSl1zEhbjlh5dqxngQykKYROzybjgSkVABwZ7mR63jDcE9d0/dAwAA",
    Absorptance: "0.1",
    Area: "6",
    "Assembly Code": "C1010145",
    "Assembly Description": "Partitions - Drywall w/ Metal Stud",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "-1",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Interior - 165 Partition (1-hr)",
    "Family and Type": "Interior - 165 Partition (1-hr)",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Length: "2558",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Wood - Stud Layer",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Ceiling",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "0",
    Type: "Interior - 165 Partition (1-hr)",
    "Type Id": "Interior - 165 Partition (1-hr)",
    "Type Image": "<None>",
    "Unconnected Height": "2700",
    Volume: "1.06",
    Width: "165",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "427092",
    Name: "Basic Wall: Wall - Timber Clad",
    Category: "Walls",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABAB9jk8LgkAUxL/LO6+Luu76p1NUENRBIuggHpQWfbDthm2BiN+9BTWIoNub9xtmphggr/Hc3yVkcDA15kb1jdFAIDeo7QOyYphOZ4hCmvAoWEVUcCZgJL/IEz5lcRp+Q0Z5IJL/cAktl+p111W963ePLVY3aWUHmU99AkepG9vO4mRsZdFNnuQFrx+0l9i0riMIaZxyRmCn5Gs2e4ymLCawMcq4XP1Uaizf4XDEoA8BAAA=",
    Pbi3DGeometry:
      "YQsAAB+LCAAAAAAABAClVt1rwjAQ/1/ynIbEfDTVp7EPBtuDbIM9yB4UiwacGa4MRPzfl22tbtfekipFae7j97u75i6Z7Mh45p62byUZkjs/c49+5eaEkrF36+qdDCe7n9eg5qPwkD09SjLB+ej7L/zI/qVxu9hsptvgqwbMaiWoYkZLQzPJCpnTRpoNOJPKKJoJZrnSR4UQTBhjqA1rK+MOCL4J5nkxgHLEGiGtrWEofUM8KHLGtbTpQNBeccal0L3lrYBUwWyuWrxI0XAcNGPNWahc3mJAkXpTowzdqWHmGG8jxxJolbqbFn5hybQwtk3byFvpQgcIFHWADK1PlsrQZAyBoByz750BFino4b9SgN5tGy8C5gCS6ibFUkWssUImTrz/M8USiu37tLmZih7bA1i3xeQwnliXp/KCbo6Zx7r8zBmFwHefTv/2wZmBJ2GndGnS7kJixg5HtKdPV2AUqSMPP39PVsSoY+dUbNicOuVT44x/hOTbVLx4CHm4q1656WtZlRsyDCpK7sv1olrWiwdfTSvn1/Xy2c0PqtvSLZZVvbhelR+/DS/9ygdAclN8PeFK/AnfuoJ2YQsAAA==",
    Absorptance: "0.1",
    Area: "61",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "-1200",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    Cost: "0",
    "Cross-Section": "Vertical",
    Description: "Structural Insulation Panel Wall with Kiln Dried Timber Panel Rainscreen",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Wall - Timber Clad",
    "Family and Type": "Wall - Timber Clad",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Keynote: "F10",
    Length: "19822",
    "Location Line": "Finish Face: Interior",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Structure - Timber Insulated Panel - Insulation",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Ceiling",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "0",
    Type: "Wall - Timber Clad",
    "Type Id": "Wall - Timber Clad",
    "Type Image": "<None>",
    "Unconnected Height": "3900",
    Volume: "12.34",
    Width: "202",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Both",
  },
  {
    ID: "428588",
    Name: "Basic Wall: SIP 202mm Wall - conc clad",
    Category: "Walls",
    Pbi2DGeometry: "DQEAAB+LCAAAAAAABACFjkELgkAUhP/LO2+L67rytJNUENRBIuggHpQWXdh2w7ZAxP/egpZ06vbmfcPMFAPktTr3dwkpHGytcqv7xhogkFtl3APSYphOb4g4ZSjEOqEY8QRGsqBVyGgkePyHMWTshy2REyo/xVnXVb1v94+tqm7SyQ7SgAYEjtI0rp3FybrKKT94khd1/aK9VE3rO1hAMYyRwE7L12xGigI5gY3V1ueap9Zj+QZLngvyDQEAAA==",
    Pbi3DGeometry:
      "ERUAAB+LCAAAAAAABAClV9tu2zAM/Rc9O4IusS2nT8MuGLA9FNuAPRR5SFGjNZDFQ2YMKIr8++wmtiOZFKkOQS85YQ4PRZqk7l7E7X3z4/l3LTbiS3vffG/3zYPIxG3bHLo/YnP3cv63/1jd9C9xymZkpZW6ef3V/4jTdvzau+Nx99x/11qptC6ySrq1rTLtZKmUy4yVuqj0CA9/TB6icWOEOYCddLmzCKqttKbI4yri2gKKEV6b3sN6tq5k4XI+WrgSiy+0hsOO6Bi4YSG8XBGRr4yW2hjLCn1VSJu7BQecl8A4iiIMgbZLGay0lqasHNMaCHA400TyBNlw8WL+4CMNZRDp4gY5mmPsTBw58ckrEhMsBilMVlHxi1s7rQePa9VnJsSXuX+FR58IjJBMCj1jH50EgsZWGlcapug59Ig/RPJEHUQ4dSlYCGLNZY9HiZHDBwiTwGdi+3JTVWiLyADPD+ZlobNgUMTUMq5TO3fyt4pAagZ2F6DLeeIdJkfxctp58DxkvMNASFg6MOq4xzR9cAp5quNlgNUMsSN57QfpSiRMr1/07ClLXS43iBSUGmrLJSTe8Fhtdwn7U4SzyFDUWFuj8ZiWhMEddUtMOmT8J24LCDkncfGVEvaH7ATkpYXz+CIPKm+VYZOkdH1G5DAF3FZZlyqmCEa7pgYS3ZzI62WsoxKXNeYw+U+X54bYw65kKEHuh0RXxS+TyKwjQ09TjVgj3EkxetSMxT9qT9zZSGuMPI6n3+UCnKIBYL52zynVNZAmmtaJ4dZz7RBJP7xdISWOhU6RpOaYceuAXeICIQ7yYUOK5C0wwn2Gt5n40Ox+1V19FBslVSa+1ofH7uny5lvb7bqmPVze/mwepo8+183jU3d583Ff/702fN/u255QfKqGlzht/wH1ZzgrERUAAA==",
    Absorptance: "0.1",
    Area: "43",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "-300",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    Cost: "0",
    "Cross-Section": "Vertical",
    Description: "Structural Insulation Panel Wall with Kiln Dried Timber Panel Rainscreen",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "SIP 202mm Wall - conc clad",
    "Family and Type": "SIP 202mm Wall - conc clad",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "47.5455 /(·)",
    Image: "<None>",
    Keynote: "F10",
    Length: "19702",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Structure - Timber Insulated Panel - Insulation",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "3.09 /",
    "Thermal Resistance (R)": "0.0210 (·)/",
    "Top Constraint": "Roof Line",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "0",
    Type: "SIP 202mm Wall - conc clad",
    "Type Id": "SIP 202mm Wall - conc clad",
    "Type Image": "<None>",
    "Type Mark": "WT1",
    "Unconnected Height": "3300",
    Volume: "8.09",
    Width: "202",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Both",
  },
  {
    ID: "428745",
    Name: "Basic Wall: SIP 202mm Wall - conc clad",
    Category: "Walls",
    Pbi2DGeometry:
      "FQEAAB+LCAAAAAAABACFjsELgjAYxf+X7zzHNt00O0UFQR0kgg7iQWnoYG1hKxDxf2+gJp26fe/7Pd57eQ9ZpS7dQ0IKR1upzOqutgYQZFYZ94Q078fTG6IQ04TzdUAJ5iRcwYAWGDCKIx6Kv5RiKoT4oUvwDIt5wKZty86v8I+dKu/SyRZSggmCkzS1ayZxtq50yg8f5VXdvuggVd34FspwJGKGYK/lezLHmNE4QbC12vpc89J6KD4wPz1iFQEAAA==",
    Pbi3DGeometry:
      "jy0AAB+LCAAAAAAABACtmktv00AQx7+Lz+7KXr/LCfEQEhwQIHFAPRQRQaTSoBIhIdTvjgHbSXb255lNUdQqmfXMf177mFl/+JW9/rh99/PbJrvMXu4+bt/ubrafsjx7vdve7r9nlx9+/fs6DhePxk92nx8oF2VRPPr7b/zL7q9mtsd3d9c/R97au76py3x8xDVFNeSd82XX5yO9HYoj+uD62je5eL4cXF36ys4wAVSVK+tWPu9HejtEnveu7qtaPE9yiE76JOOG9LJ3XVGkGybo/ahgX+W+c03rI3JC+gyMDCHAHDJERgZC8K7rmjoBwY8/28pMLytX+bYRwGXthm7wBuDZ2WABRVlkNUaZByaVcMA+pXRwkZQG8DhG8kS3J4EhO0ASpQemAc0VdhRNa552ZF46RkL4lMXGvjotZoBve1cXTSUAcEaG9Fl+KGemj7Fr+qaRNhMDKFS5ti8GKQYVQmDMpgtfutJ76aOLsnS+G3qh1EXrqhFE0klSOY5XbWxuRYOD8itXdF1nxxUMs5dQEiBTGCiN4vbC0zj/41Ls1q5rI+UsGYGBJ+jK+b6L5FYIvfi/HtO3jiwJyfOGIkMa4YQCTdECTC0yzYoMUVvkhym6DIioHanUlX1kLWcjaAYiOEKQO9YcCKLYwIRUZnfp8+LhflzSamX9ji/TtDUdqTt+adtWrqITfWY4GB4MEAMiLGZbGRBaDIj5FzCkQpMcev5w/jmlL+vQqRwQT1LQ1WRWSFfcA1qG5Mj8mUeGcbVai4uwIDKvzCiYL8iB6OioZfpYtUJnWWNxht3TAElKVon9BAlIyMY8U03GMBwKM4VBmVkIcKh0bIIEfaq1SSGYciT+ULEozx86V6f+EY0cmxzCFfInPQ918enzZjmi5WDGjdLNuKLjJxPOppCoPQNHW/NK9GoChQSANjXIFSgo2QRS1ZzU6OyzbSOEBO8p0KjrmnVxI8w6Ue6p/sMQmddTLaaIwDsqHW70zchc66j1CZ4vAwZLfWA/4RjOt8ZWikHhhx7rAZo2OIw31zLmAQUaGidqL814fNJOy7Yeoaak6bigO586osl7gNqlpQHzhhi0ufQbHuvipm9YtnsQXVXbRqlHwbzq6CvefyjEEB7b2fpMtu4O6iS03lAYEtZ6RjAkGnecSlcMdfNnpK9rb6z2/rGcXf5a0M1t/gRTUljE7Vf8bpQ6JKmNGR3AppDF6FOOlYPkQsd4pw8QRJw+qapUkVisqHSSf0rXetzBZmdsQmg9+sTOOvZvsLuiDzz4NsGMbe4gKndq6hUZABhjqdxJASiXfWqdSIIUuqXoSywTE16uEBg4gFppovS+jI1+NrIeCqX0N2sqLA6W5WnvMnQKgj1VX2aRgQv/44XfvrUIG5SFP6H9pjiJNLU779zuiLLpkG36K2vKJqidRKwvoM3y6cUgvAvE6OD1+RqH8V2zo9eV4uoihuEdMS2Nz8fAt49YFHHwO1Fwtc/n5LMCFedgEHoHYo0DDMFb/HRwvETnogLRDbLsKCkj6yd8O13Dvsqzp9vrr5v95i67LFyRZ682t5/3X6Yfb3b76/12dzv9fL/9tAy92Gw/f9lPP57dbH4cP/hkd7MbBWbPhz+f7P7qNxXjLfePLQAA",
    Absorptance: "0.1",
    Area: "43",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "-500",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    Cost: "0",
    "Cross-Section": "Vertical",
    Description: "Structural Insulation Panel Wall with Kiln Dried Timber Panel Rainscreen",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "SIP 202mm Wall - conc clad",
    "Family and Type": "SIP 202mm Wall - conc clad",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "47.5455 /(·)",
    Image: "<None>",
    Keynote: "F10",
    Length: "19702",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Structure - Timber Insulated Panel - Insulation",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "3.09 /",
    "Thermal Resistance (R)": "0.0210 (·)/",
    "Top Constraint": "Roof Line",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "0",
    Type: "SIP 202mm Wall - conc clad",
    "Type Id": "SIP 202mm Wall - conc clad",
    "Type Image": "<None>",
    "Type Mark": "WT1",
    "Unconnected Height": "3500",
    Volume: "8.15",
    Width: "202",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Both",
  },
  {
    ID: "428797",
    Name: "Curtain Wall: SH_Curtain wall",
    Category: "Walls",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABAB9js0KwjAQhN9lzzHkx5SknkQFQQ9FBA+lhxZDG4iJ1CiU0nc30FYQxNvOfsPM5D1klTl3dw0pHHxlMm+72jtAkHnjwgPSvB/PaFiwBDNK1EphQZmAAf1gC0qw5IJ/U4Flwul/OKcWc/m6bcsuLoiPrSlvOugWUoIJgqN2dWgmcfKhDCaOHuXFXD9or03dxA6qMFdKIthZ/ZrMCsslEwg23vqY657WDsUbnC6zshEBAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "26",
    "Assembly Code": "B2020200",
    "Assembly Description": "Curtain Walls",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 2",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Border 1 Type": "64 x 128 rectangular",
    "Border 2 Type": "64 x 128 rectangular",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Curtain Panel": "Glazed",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "SH_Curtain wall",
    "Family and Type": "SH_Curtain wall",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "64 x 128 rectangular",
    "Join Condition": "Vertical Grid Continuous",
    Justification: "Beginning",
    Layout: "Fixed Distance",
    Length: "6202",
    Number: "3",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "1500",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Roof Line",
    "Top is Attached": "Yes",
    "Top Offset": "0",
    Type: "SH_Curtain wall",
    "Type Id": "SH_Curtain wall",
    "Type Image": "<None>",
    "Unconnected Height": "3000",
  },
  {
    ID: "429964",
    Name: "Basic Wall: Interior - Partition",
    Category: "Walls",
    Pbi2DGeometry: "CwEAAB+LCAAAAAAABAB9jsEKwjAQRP9lzzGkidGknkQFQQ9FBA+lhxZDGoiJ1CiU0n830Kqg4G1n3zAzeQdZZY7tVUEKO1+ZzNtWewcIMm9cuEGad8MZDQzPBJGLSUKwYJxBj36YxDyh/ItQMad/yCeveNUum6ZsY3d8rE15UUE1kBJMEOyV06EexcGHMpg4d5Anc36jrTK6jiWJxExKgWBj1WM0SyymlCNYeetjrrtb2xdPUTTlKAsBAAA=",
    Pbi3DGeometry:
      "Ig8AAB+LCAAAAAAABAClV01P4zAQ/S8+B8t2vuxyQuwiJDigZaU9IA5FRBCp26xKhIQQ/33dEkjivJk4oKpV8zJ+8zwej8c3r+Lqrv798q8SK3HR3NXXzaa+F4m4aupt+yRWN6/vf/1rdew/4i3pkSOt1PHhx3/F2+3HsJPdbv3ix6aysMol3kLmKnWJkzYzedLBmTS5C8FPW+1kpk36gRfSGJslupBl2qMdhclkrkszx0FYK2lsbhPjpMl646VCijwt9tRale5b8sbxwO6stHmKwfFwJ7XVehL4g9gYR1ATN/7L6jul+5goXfAE2JajjZGFWScra6xfytDXAQx9DSzH2MT/EB2bhrEeOuqV0pqwK05+wAonhVlxqDDtZGswDGy4sIYwiOMsPoB+36tS2aiZKZkaE0cwLXZjuN/0LI51YJedOmNlodxMhEkdHbOvgkpbG2EeFM2vsGPhxNQJajxNuGBUxoASB8sG2sqxGCSEIJVA4dLD+syYziUmv2Xows8dW/xwesOGy7dgrrCUQk3QPScUuI+KCJ2RUblHl2G2YgfnGIvO9mBxNWwus7hukCJHXQ2NzXQa9OFH7+OY5gU3FEvOrbjDe95ZRMpzYEBKlfmF1Z9oeEkc07OVvj9Dlrf63yfGfQt1KUAo1SVhXqwhvqOansdc4HEkIosPrwLevMikG2r2l80f9fpv1VY7sfKvEnFZbR/ax+7hV9Ou27rZdo9/6vvPV+dV/fDYdg8/N9Xz0PC02TSeUJRn+4+/0/4Hlpc0JyIPAAA=",
    Absorptance: "0.1",
    Area: "25",
    "Assembly Code": "C1010145",
    "Assembly Description": "Partitions - Drywall w/ Metal Stud",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Coarse Scale Fill Color": "8421504",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Interior - Partition",
    "Family and Type": "Interior - Partition",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Length: "6202",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Wood - Stud Layer",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Line",
    "Top Extension Distance": "0",
    "Top is Attached": "Yes",
    "Top Offset": "0",
    Type: "Interior - Partition",
    "Type Id": "Interior - Partition",
    "Type Image": "<None>",
    "Unconnected Height": "3000",
    Volume: "2.98",
    Width: "120",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "430064",
    Name: "Basic Wall: Interior - Partition",
    Category: "Walls",
    Pbi2DGeometry: "CwEAAB+LCAAAAAAABAB9js0KwjAQhN9lzzG0adI/T6KCoIcigofSQ0tDG4hZqVEope9uoNXixdvOfsPM5ANklbr0dwkpHLFSGeq+QQMEMlTGPiDNh+l0hhWngvlszSkTSQIjWVDAaOzz6D8KRRD+oCVwQsWndtN1Ze+63WOnypu0soPUox6BkzSNbWdxRlta5eZO8qrqLzpI1bSuw3fZEY8I7LV8zeaExpwJAlvU6HLNU+uxeAO3sqwxCwEAAA==",
    Pbi3DGeometry:
      "QigAAB+LCAAAAAAABACtWclqHDEQ/Zc+j0Uv6s05hSwEkoNJAjkYHxw82A2OJzhDwBj/e2R71NOSXi2aCSbB81zzalFJqiqdPxZnP6fvD7/XxWnxefNz+ra5na6KVXG2me62f4rT88fXX92fyzfup3ha7ZGTqizfvPzn/hVPF/5rb+/vLx/cd0+saWprV9bU7TiuRjPYul2d1Kaqx5ZHq34HhxS1NW3V15R0Y+rB/VUnTFFDoytTtVUMhuqgpFeG0Sx7sbCGeGeZNWVfNbNoZ/qmbpxoN5QjK+o9a0xfl4m/TtYOiWyIOmV2rIdniqbu4rVXEXuKznRjFzsRgHtWoCt010cRhwaq0kTR08LYYlGoK3JhXnMiuL2p7NCDmC+jO5OQ8H9QOZhyaKzWElWu5ATqgAyKPPEMhCPY7bpyJlbxeju0GpoBCC/hvfBYtnEq16Npm1JAvSekFYgY29a4E6ht0yQPYZ/PtbGLGPGRo4OxtNmvNQ0TJEsX5/QiLUHcRI4SsaYDtQyJQKJzB0d7ERLk+1FmCxpJZ6Ah2MdobbJ2XXwJd23TJZcwDSZX5Qvq7K3KfiRk9zdzAOcQQ3MjXo/OlQgjK5gWcWArPEoI66j32bJLrVfhJLUY4eRQ8hSv+2FOOEY4ydnQbWxcxJzuEs6VBTfwkPBln+EBTFATJJQ09kYVPiLWguuUN77Q4YT93pz3doBi4rkEC4wL0bjYCmjnumCJ+rKAkUxPohDG0jgOgTrsQ1JcygSECcg3zKqxAAWMtzUvjqrEIThwPgn7jmhJcfuKT2XNWc02wOTly5Zc8mkqyaqKRLasbexohUoV87qP7peYAaNC+aqwQdDWdlbrsMIEghZcVcS5LKDYM6hMtgB9H04A+H5WPHfhCQ0VwX6+NKN9OaGWkSY6PyjLsy6cJ2YawpgiMAvRKm4YnVWYYCmKTRW65MABjGZEmw0BWuwwf8TRWnb9z0syDUhyp2A0u55htYnjSa50V95VCn3CYCvqKrQnQcZgDGYCXEpNw5WgCl3UtYovZsXgRG4wWIWEcNiGE925BGsaILHB4FQqJ1rMXYgHsaorRlFr4/EurwuLBrSwVmZBxdCZHYXTmphjlzueAy1Zk5CcJxHqsUaaenAkymo8a8qCXWGCwd43MsirIg9v9pQ7YiRE6CPnF2gmSAwW8d1CjGsP1aji5i+5eGyMHiuymDNfZLA0YbQw2dXNzniYW1vYaczDprAzS58K8mBuwCzAYdN0rCHYR8y8RIkhhThKJDwkSBTWwb4yp2knFjYjFriN5Q0jQa0qLuy69poEj11M3KXk9BgafbqMV85FFO+NlD4pf7AZ2aigL2qFZzjselM42NPEQznx9E1olGCNRmweppD05Q3FFQoJCskVbl3YiYoMHrba/PgmDzxu5TLmR5qHj8OWDU9GcmYrxEMwYRy3xw6Zekn74IDNqxydMSiv72JVvJ8uf6236/vitDTlqviyvrve3uw+fN1sL7fT5m738cd0Nf/p03q6vtnuPny4Xf9dCr7b3G4cYdF/fP4pni7+AaoM8vZCKAAA",
    Absorptance: "0.1",
    Area: "40",
    "Assembly Code": "C1010145",
    "Assembly Description": "Partitions - Drywall w/ Metal Stud",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Coarse Scale Fill Color": "8421504",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Interior - Partition",
    "Family and Type": "Interior - Partition",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Length: "11380",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Wood - Stud Layer",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Line",
    "Top Extension Distance": "0",
    "Top is Attached": "Yes",
    "Top Offset": "0",
    Type: "Interior - Partition",
    "Type Id": "Interior - Partition",
    "Type Image": "<None>",
    "Unconnected Height": "3000",
    Volume: "4.47",
    Width: "120",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "430318",
    Name: "Basic Wall: Interior - Partition",
    Category: "Walls",
    Pbi2DGeometry: "DQEAAB+LCAAAAAAABAB9jsELgjAYxf+X77zGnFM3O0UFQR0kgg7iQXHoYG1hKxDxf2+gdijo9r3v93jv5QNklbr0dwkpHG2lMqv7xhpAkFll3APSfJhObwhCHNI4WjPMojiBEf2iFcOccPbNEkroX7ZEFkvxpuvK3rf7x06VN+lkBynBBMFJmsa1szhbVzrlB0/yquoPOkjVtL4jEDgUgiPYa/mazQJzRiMEW6utzzVPrcfiDY8fPCoNAQAA",
    Pbi3DGeometry:
      "3A4AAB+LCAAAAAAABACdV8FO4zAQ/RefjWWP46Qup9UuaCU4IEDaA9pDKyIaqdugEq1UIf4dU1IIGc90gqJWycvLmxdn7BnfPaurZXO7e6zVXF20y+amXTf3Squrttl0T2p+9/x+mm7b03SoF/2JnDhrT/d/6ade/h4e+7HdLnbpWeeNhzLowkCIUUczKyDoA+pMVZYFgbrSVB68HklAYYKr4Bj7xJpZmAHCp4nnbR+0x3Aw1gYME06IkAeVhFcWYCgDSUdDNFAIZIiopDwdltX5fNkKLORkvuBjOlbn8cKUzgUk400MoRCrE2YI8SNeIKnNbDw+BN6E0lUaSmPjkN+bTzqVG/DBeG/39AAZlygsZZOQZ/h7m8Qo4JHn2JSZER1PyiGMyNGjgP1gjVA0ffloYl3e7xjOu8Dzlh05ik59XSLZ3l8yodGnu4Og47WFYxPaRMJSeUw4nzgu/JgTxUKSUXkqygemjglrHptnkpTMB2NSD09aSf0SihBsUiS7cKOVWFJzhOxp2sT6hnwTtZhLaeEnY3JpYpYz6PFpxXVP0j6OizihFfhOgze505DmMdsRypswvnWgaj5eiXl9qlrQ+mM+r0/0qFR9+Yb/PF/cG3MVid8DZBrsKTVTyma1sXHuNQlt6SIq6ufF24gv8mmb+KtZ/Ku7eqvm1litLuvNQ7fqL67bbtE17aa//NPcf9z6XTcPq66/OFvX/4fEn+26TYKqOn870m70FXD4kubcDgAA",
    Absorptance: "0.1",
    Area: "13",
    "Assembly Code": "C1010145",
    "Assembly Description": "Partitions - Drywall w/ Metal Stud",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Coarse Scale Fill Color": "8421504",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Interior - Partition",
    "Family and Type": "Interior - Partition",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Length: "2824",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Wood - Stud Layer",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Line",
    "Top Extension Distance": "0",
    "Top is Attached": "Yes",
    "Top Offset": "0",
    Type: "Interior - Partition",
    "Type Id": "Interior - Partition",
    "Type Image": "<None>",
    "Unconnected Height": "3000",
    Volume: "1.56",
    Width: "120",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "430361",
    Name: "Basic Wall: Interior - Partition",
    Category: "Walls",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABAB9js0KwjAQhN9lzzE020TbehIVBD0UETyUHloMbSAmUqNQSt/dQH/Ei7ed/YaZyTpIS3VpHxISONpSpVa3lTVAILXKuCckWTec3sBCKjDk64WgQSAQevJliDReIf5nnC4ZEz9szpxYPlVvmqZofb9/7FRxl042kAQ0IHCSpnL1KM7WFU75yYO8qtuMDlJVtS9hgmIYcQJ7Ld+jOaYRR0Fga7X1uealdZ9/AAn5aVYPAQAA",
    Pbi3DGeometry:
      "RwYAAB+LCAAAAAAABACVVF1LwzAU/S/3OQtpTEzbPYkfCPowVPBh+NCxsAVqIzUIY+y/G7Xbarf23hJakpOTk/uZ+RZmC/ey+bCQw4NfuGdfuiUwmHlXhU/I59u/adwW0zhgx47IJBFi+vuLH+ze9seu6rrYxLPJBTdSSDbRXAgtWcZTJTVLFNep1idwhy0VN0LKE/oBJ/KRWxXPTIba2BI/R5eSG6MVBu9V+vCuOnIrESYHUvHLJIlWx/1UZEcrEbzr7H+4q94D78WJxYGI9wTmPHuk4bSCGWZjIRxXXcPukNOJFCnWpn0JpeWfmGdiw6A+IUa2qnFYn6oz9m3ra2Fi1zT8+CLfuOLdBltDLrhg8GirVVg3iycfiuB81Sxf3fKwdW/dah2axW1pv9rEa1/6KAjm7mfEh/8b/1qmyUcGAAA=",
    Absorptance: "0.1",
    Area: "13",
    "Assembly Code": "C1010145",
    "Assembly Description": "Partitions - Drywall w/ Metal Stud",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Coarse Scale Fill Color": "8421504",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Interior - Partition",
    "Family and Type": "Interior - Partition",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Length: "2880",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Wood - Stud Layer",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Line",
    "Top Extension Distance": "0",
    "Top is Attached": "Yes",
    "Top Offset": "0",
    Type: "Interior - Partition",
    "Type Id": "Interior - Partition",
    "Type Image": "<None>",
    "Unconnected Height": "3000",
    Volume: "1.52",
    Width: "120",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "430412",
    Name: "Basic Wall: Interior - Partition",
    Category: "Walls",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzE0f21aT6KCoIcigofSQ8XQBmIiNQql9N0NtBUEwdvOfsPMFD3kF33q7goy2LuLzp3pamcBQe609Q/Iin48g4FSnCSCLxcMJ0IKGNAPRiIsmWDfkGESp+QPnFPLuXzVtlUXFoTHRlc35VULWYQjBAdla99M4uh85XUYPcqzvn7QTum6CSUkxpRLjmBr1Gsyp1hyKhCsnXEh1z6NGco3E/UYlxEBAAA=",
    Pbi3DGeometry:
      "+gsAAB+LCAAAAAAABAClVl1rwjAU/S95riFJm8bo09gHg+1BtsEeZA+KRQPODFcGIv73ZS52Gnt7E0fxIyc359ybj9OMt2Q0NS+bj4oMyIOdmme7NDOSkZE1q/qTDMbb37+umw3dQ3bZH9LjjA33X+5Ddm+HYVfr9WTjxgpBlZJF1lNUSi4yXlKVizxr8JzKkqtM034h5DGspfsN4YKWnLu2pKzPNMqCiIqSMh1B45NxqooLgdP7LEMalzSTIqGmdtWLZix2ZjijXMn+WbzDJct1G76PPyPyxYqCKhYzZwcBrmnBY4igacMqi1dOThWViF0FYKf48AOcU15qfs5+hJ+sZYg3siFRUxg6IizgXxKtRQA1B4cAywfCQyNA04QGIAKpxyl1KbEtgekG5oFkH3gKEg0YExAdbP249Y7MpNuAEW7gECJ5d/hpJ47bV8xRizv+qDZkU6mnLdpGIoUj/bEbRs06wma7La3tPdHdAWyu5h2YbFOgMppr6usXShW+cp3ecvD4djzMJ1UX4seMHzAm0Au7YE/uLtE3ZvJe1dWaDBhlGXmsVvN64RtPtp7Uxq5889XMmq77yswXtW/cLquv48Bru7SOkKi7n8fd1b8BPBPeNvoLAAA=",
    Absorptance: "0.1",
    Area: "7",
    "Assembly Code": "C1010145",
    "Assembly Description": "Partitions - Drywall w/ Metal Stud",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Coarse Scale Fill Color": "8421504",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Interior - Partition",
    "Family and Type": "Interior - Partition",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Length: "2157",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Wood - Stud Layer",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Line",
    "Top Extension Distance": "0",
    "Top is Attached": "Yes",
    "Top Offset": "0",
    Type: "Interior - Partition",
    "Type Id": "Interior - Partition",
    "Type Image": "<None>",
    "Unconnected Height": "3000",
    Volume: "0.8",
    Width: "120",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "430859",
    Name: "Basic Wall: Interior - Partition",
    Category: "Walls",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABAB9jsELgjAYxf+X7zyHczM3O0UFQR0kgg7iQXHoYG1hKxDxf2+gdijo9r3v93jv5QNklbr0dwkpHG2lMqv7xhpAkFll3APSfJhObwgYTggna4ZZvEpgRL8oICHmNKbfkEaM/YdLaLFUb7qu7H2/f+xUeZNOdpCGOERwkqZx7SzO1pVO+cmTvKr6gw5SNa3vIAJTITiCvZav2SwwZ1GMYGu19bnmqfVYvAHXKAgCDwEAAA==",
    Pbi3DGeometry:
      "RxEAAB+LCAAAAAAABACtV8tq3DAU/RetZSHJsi1NVqUPCu0itIUuwiwmxCSG6bhMTSGE+feqGU8rWz7XUlPMPHx0de5LV7q6eWLXt92Xx+8t27AP/W33ud93d4yz6747DD/Y5ubp/NcPyyv/sBP/ixRKyqvnL/9hp+1l2qvjcffo5xZGNMoqbkRdlTV3whpd8QtaVELJ2nFVC+O05TNpbfxw41LFAfkclkLbynLthDa6/FedEFdSVLL0A04YFfAjvYUVWjZlZOaFZ46P4pFehCMeaOcaUTQhjkSpjVnSfMYjhycwpAn00hOQPdkKkANwghSykc8plsraEJ+nnrRU+h/tuLailq5O0Is8jipgYuYMNkJXLhambUziiOozRIOCW6eYC0PPUSZQCEHIR2O82ko1elVtppWAHdiyHPG1CGRuK3m1igpjXWntC4IXWkhZV+vr0yg/GUhHYQHUWScF4DjDqdLUKbRsCCqUpYpYXg5gkUQRBSZTgY49OUsDODW31E4VeU5GaTG1a3t48t4Oj7/VgWXz432PgpOcJdGAeLKMg41jsigCfJLQ5MYD8afjk/WVoBfZiXiQ3tw2AvEjHPEgv1Be8oo4BX7BYiDp87YOFMn0zAJ6siui4RekFRyZZPdPw8lraeXykniy0fD/KvzE05eGk6ub6OGXr2m5eP5Bgm4JGJ/3uORFFtCgywbooGNxkh0YQ/f+iQ1xLL3AveXsTbf71g7tkW28T5x9bA/3w8P48qkfdkPXH8bXr93dn6H3bXf/MIwvb/ftz1Dwdb/vPSFr3v1+2Gn7CzLbDqNHEQAA",
    Absorptance: "0.1",
    Area: "20",
    "Assembly Code": "C1010145",
    "Assembly Description": "Partitions - Drywall w/ Metal Stud",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Coarse Scale Fill Color": "8421504",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Interior - Partition",
    "Family and Type": "Interior - Partition",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Length: "4661",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Wood - Stud Layer",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Line",
    "Top Extension Distance": "0",
    "Top is Attached": "Yes",
    "Top Offset": "0",
    Type: "Interior - Partition",
    "Type Id": "Interior - Partition",
    "Type Image": "<None>",
    "Unconnected Height": "3000",
    Volume: "2.22",
    Width: "120",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "430997",
    Name: "Single-Flush: 800 x 2100",
    Category: "Doors",
    Level: "Level 2",
    Pbi2DGeometry:
      "0gAAAB+LCAAAAAAABAA1jk0LgjAcxr/L/7zGNveidooSgjqIBB3Eg9XQwdrCViDid29S3R4efs9LPUF5MafxoSGHg7+YSl9D6zqrAUHpjQtPyOvpKyOSEJzyZM0xF1LB3PyhzTC0YySjsTPtXQc9QE4wQXDUrgs95AmmPJMIKh/aYLxbHMYJZUxIxjOVpYoXKyoQnM1tCRBMJUew16br47TCVDCGoLD6/SvI4hcWA1tvfZxzL2vn5gPQHjcH0gAAAA==",
    Pbi3DGeometry:
      "lRIAAB+LCAAAAAAABACtV01rwkAU/C97TkO+TfRktVBoD9IWeigeFIMuWFNsKIj435umsabZ97EviFSacZyZ7L733Lwd1WypXw4fuRqqh2Kpn4utXilHzQq9Kz/V8O34+2/1sTeqXurkXJAb3/NG9Vv1p07z89fG+/3iUH03DFw/jkMncqMgzJzMTaMgdoLMjUMvoVE/cQdhEGJwRxmBDekgziDpGm7IFwkxiggzMCJid4fMMonunCXLHIkdIBeVC8eXElwFoi3kyBI7ZP+6fpE/SCt4EAemxA8IUys0y6K0tRI8F9Vl3cBgl70IktSnwD5hYa5E9z9qlzaJw8Qssho1I5zhzuLasHFtC0s432WPmtUk0H6hEbZMuwOTqfEciCFc9HB1wXWEbBa8/DRZ4ictRo7LdaShCoJ23UCS7c3g1qVqh+8adiqwQ1BUwjRZ4gcOXas2J5Nxsxyb+qKJQpLtzeAmRnrNT/zILKkaNYfaGe6MKRs2rm1hCeczbpxA+4VG2DLtDmyZ2u7I1SabK23DtjvOISLcsbRZUwLtFxo/eAu00WMzkBrPgRgiLYAUGVJNyH7BO0CTZY7ikuS4fIMaujB6hScRiR3SyFd5SqWGBD8er/iUKnOEB7JV45Ph+EGP/iiIxgxJltghvd32mztqqhfveZnv1dBzPUc95rt1uWkunopyUepi11y+6tXfR/e5Xm/K5uJum3+1iZNiW1SCajqZ3I7H6jT/BjnEGu+VEgAA",
    "Analytic Construction": "<None>",
    Area: "3",
    "Assembly Code": "C1020",
    "Assembly Description": "Interior Doors",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    "Door Material": "Door - Panel",
    Family: "800 x 2100",
    "Family and Type": "800 x 2100",
    Function: "Interior",
    "Head Height": "2100",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2100",
    "Host Id": "Interior - Partition",
    Image: "<None>",
    Mark: "202",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rough Height": "0",
    "Rough Width": "0",
    "Sill Height": "0",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "50",
    "Trim Projection Ext": "30",
    "Trim Projection Int": "30",
    "Trim Width": "80",
    Type: "800 x 2100",
    "Type Id": "800 x 2100",
    "Type Image": "<None>",
    "Type Mark": "3",
    "Visual Light Transmittance": "0",
    Volume: "0.11",
    "Wall Closure": "By host",
    Width: "800",
  },
  {
    ID: "431064",
    Name: "Single-Flush: 800 x 2100",
    Category: "Doors",
    Level: "Level 2",
    Pbi2DGeometry: "zAAAAB+LCAAAAAAABAA1jUELwiAYhv/LdxaZTt20U1QQ1GGMoMPYwUo2wTSWBWPsv2esbi8Pz8vTTFBd7Gl8GFBwCBdbm2vUvnMGEFTB+vgE1UzLTArHeZmLFcOMiwLm9i+th0GPyUxga/XdRDOAynCG4Gh8F3tQOSZMCgR1iDra4BdCuKSC57yUhURwtrevmmEiGIK9sV2fogUmnFIEO2fev6vEJaMcwSa4kEL+5dzcfgDCcgClzAAAAA==",
    Pbi3DGeometry:
      "jREAAB+LCAAAAAAABACtV01rwkAQ/S97TkO+TfRktVBoD6Ut9CAeFIMuWFNsKEjxv3erScxuZmYnKFJpnm/fm52ZHTazX/GylO+Hr1wMxVOxlG/FVq6EI14KuSu/xXD2e/5X/eyN1EccnQty53ve6PSl/sRxXi8b7/eLg1qbuEmWOJEbBWHm+Ik7CIPQ0cDMTaMgVk/ewA/7g6BmDTbUIM6a9TUTxUxJDdQlSSM4UFiAHwC9UXtO7E6MPLXrwS4xJEgnDs8mEQ/dNLgPs8JE3ivZ0E29NFXgIA7+mVkWpRdmBZ6Wa0wzKJRYS9abbxO11VA8lAskqLziNOo4t8CmFCCxq4jsBVK8LAagToRJHCYd5xoEqIYmwewU0eC2BMxsWJ1gzSZJmr+OmuVlhQptC5TVBUCQrCgcFlYsEgVl0e7pY0VXi93kBBGtPwPDjO3ng9HfBIjNBPIQslvbgtoGEkjkOLH62jYiSSJ+Klkg5k3wegwEC4qeMbMB/cSPOlO2BvUhc0KNpiGYndFlcFsCYFCUE6zZbFTz11EzqaxQoW2BsroACHaCre8legTabUXnktcdWJZx9zUTY7dCrp5Vsgz/NmqW2x4qtitQlf0+AB8BKCjY34LCukQT9XGjytWj42nqlVd73J51XK6+2xMjgzyat3qnY4wsZI7e4J2OMa1xIn5MWSDqTRN7zAgSJQ7eWXbuiKlcfOZlvhdDz/Uc8Zzv1uWmengtykUpi131+CFXzU+PuVxvyurhYZv/tImTYlsoQTGdTO7HY3Gc/wEzVZQzjREAAA==",
    "Analytic Construction": "<None>",
    Area: "3",
    "Assembly Code": "C1020",
    "Assembly Description": "Interior Doors",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    "Door Material": "Door - Panel",
    Family: "800 x 2100",
    "Family and Type": "800 x 2100",
    Function: "Interior",
    "Head Height": "2100",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2100",
    "Host Id": "Interior - Partition",
    Image: "<None>",
    Mark: "204",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rough Height": "0",
    "Rough Width": "0",
    "Sill Height": "0",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "50",
    "Trim Projection Ext": "30",
    "Trim Projection Int": "30",
    "Trim Width": "80",
    Type: "800 x 2100",
    "Type Id": "800 x 2100",
    "Type Image": "<None>",
    "Type Mark": "3",
    "Visual Light Transmittance": "0",
    Volume: "0.11",
    "Wall Closure": "By host",
    Width: "800",
  },
  {
    ID: "431144",
    Name: "Single-Flush: 800 x 2100",
    Category: "Doors",
    Level: "Level 2",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1zT0LwjAYBOD/8s4xNGnz6SQqCDqUIjiUDlVDG4iJ1CiU0v9uRN2O4zmunqA82+N4N6BhH862MpfY+s4ZQFAG6+MDdD19YyKUYiUoXS4kljxnMDd/thqGdkw2FRvb3kw0A+gMZwgOxnexB51jUiiOoAqxjTZ40AQzkQnFc8qFKqSSBMHJXj84w4QXCHbGdn06FpgwShFsnXn9xgrLgjIE6+BCuvJP5+bmDdHIFHnQAAAA",
    Pbi3DGeometry:
      "8RMAAB+LCAAAAAAABAC1l0trwkAQgP/LntMlD5NN9GS1UGgP0hZ6EA+KQQPWFBsKIv73Bh+J2WRmdhKLKOabncdmZ2Z3pwcxWSQf++9Y9MVLukje002yFJaYpMk2+xH96eH8Nxfbg/wjjlZJHhzbHpx+8q84zq5qw91uvs91XVdGXtSz8iHSUX5oRTLsub5VcCV933Eh7ARSea5H86t5UFA6UMpvNFTh+nDIDMUh+8acnJi5gOsaeBXcpSE4YN70ReP5Y4jvtrpQlrfldDp40g2UfxL0vNArLN1wXCEXRFEvLAX6epEKmIt2wepcSTcMFYS7zwBS4DrQ0gsM3wkiB8G68crwm2DOvOEt4wqwA9QxEKeO62tb5d3jBxX4LuoJh08CCQmsDaYAXjWU05FSKY1yXu6So03Kuo4B2xiGkpw0boKNKwhJcbSRGHMywTmZz2/muABywegcjbtCC452Jk7HgravVpxuJ64MVBDVSqPE+hGrMrxmpuF4gSvADlDHQJw61t+PzrvHDyrwXdSPbNAkihMbxMEjnh4SeUVoVjA/RZoGWz99a+tcwd1nAF9NeA7Au0Zj+Eg4UHnwOLZiuMAgVDqxcQE3genxZlXewP/rUkZWMsrNy4lxqTfsOgYd+E6X+raNn3OpB9tH4zbBxVhrMu9YwEbWAhPtZGaJcTL/irN4J/q2tC3xGm9X2fry8JZm8yxJt5fHz2RZiJ7jZLXOLg9Pm/j3duAo3aS5QTEejR6HQ3Gc/QEfLqVH8RMAAA==",
    "Analytic Construction": "<None>",
    Area: "3",
    "Assembly Code": "C1020",
    "Assembly Description": "Interior Doors",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    "Door Material": "Door - Panel",
    Family: "800 x 2100",
    "Family and Type": "800 x 2100",
    Function: "Interior",
    "Head Height": "2100",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2100",
    "Host Id": "Interior - Partition",
    Image: "<None>",
    Mark: "203",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rough Height": "0",
    "Rough Width": "0",
    "Sill Height": "0",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "50",
    "Trim Projection Ext": "30",
    "Trim Projection Int": "30",
    "Trim Width": "80",
    Type: "800 x 2100",
    "Type Id": "800 x 2100",
    "Type Image": "<None>",
    "Type Mark": "3",
    "Visual Light Transmittance": "0",
    Volume: "0.11",
    "Wall Closure": "By host",
    Width: "800",
  },
  {
    ID: "431198",
    Name: "Single-Flush: 800 x 2100",
    Category: "Doors",
    Level: "Level 2",
    Pbi2DGeometry: "zgAAAB+LCAAAAAAABAA1jUELwiAYhv/LdxZRp3PaKSoI6jBG0GHssJVsgmksC8bYf8+obi8vz8NTz1B29jTdDWg4hM5W5hJb3zsDCMpgfXyArufvTAjNsGAZXxHMBaewNH9qPY7tlNB0bG17M9GMoAkmCI7G93EAnWHKVY6gCrGNNnjQFAtJpMozlkvFCyUQnO31wxJMc45gb2w/pKzEVDCGYOfM6+cqXHCWhE1wIZX807mleQMxU0LbzgAAAA==",
    Pbi3DGeometry:
      "JRMAAB+LCAAAAAAABAC1l0trwkAUhf/LrGOYTMxLV1YLhXYhbaGL4kIxaMCaYkNBxP/eEF8xM/cx0VJams/ryTH3zHXmcyfGs+x9+52KnnjOZ9lbvsrmwhHjPFsXP6L3uTv8W74s++WP2DsX0vGk7Fd/yl+xn5zeNthsptvyvZ7vBkGoHM+NwrDrJG7cVYFzoh3pxkGsIOyFbuQrn+RHcQBfxCMljSJXvFFuFkEppMzl+MdhYtubAh/fthUUB+RZj5dICw/foZ/mLLegdOOVij1HuVLFSU2jonhxiZOkG5+xoS9YOSDexmCDdjzXUzKC8I2+oXJbeT08gHlfhQGIdfGr8pqZiutPFy0H5YnbAi4bWOtpnd7oHCi3E9fihdiGjAApssNgfwhOe8SjS3C7jJLVnMXbxIA2jqE4k+IczF0rUKCJccHleKR5Sbcb0Tg2S7OWlnnK21B00vDmj/kLqAWlB0TsxZEh8Aest/uqvCmjNwUtB+WJ2wIuG1h7LnV6o3Og3E5cS4/ZdrWTMlNg26XbQHfKQDl7T0cbbO57tT5e4Rt9gwcCS3loh282D5mBom/JAXkckxax0OLYJp5ULb1aG/Q/jjzIikQpc3nwj8aMicGYl3c6Grcb01ZHY2gYmIe6JcYHDXf+AF87rTAxICaOGGXTr7RIN6InXemIl3S9KJbHi9e8mBZZvj5efmTz80tPabZYFseLx1X6Wy8c5qu8FBSj4fBhMBD7yR9xFLLrJRMAAA==",
    "Analytic Construction": "<None>",
    Area: "3",
    "Assembly Code": "C1020",
    "Assembly Description": "Interior Doors",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    "Door Material": "Door - Panel",
    Family: "800 x 2100",
    "Family and Type": "800 x 2100",
    Function: "Interior",
    "Head Height": "2100",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2100",
    "Host Id": "Interior - Partition",
    Image: "<None>",
    Mark: "205",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rough Height": "0",
    "Rough Width": "0",
    "Sill Height": "0",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "50",
    "Trim Projection Ext": "30",
    "Trim Projection Int": "30",
    "Trim Width": "80",
    Type: "800 x 2100",
    "Type Id": "800 x 2100",
    "Type Image": "<None>",
    "Type Mark": "3",
    "Visual Light Transmittance": "0",
    Volume: "0.11",
    "Wall Closure": "By host",
    Width: "800",
  },
  {
    ID: "457479",
    Name: "Single Window: Standard",
    Category: "Windows",
    Level: "Level 2",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1jUELgjAcxb/L/zzH5pxu6xQVBHUQCTqIB62hg7WFrUDE796iur33+D1+9QxlZ07TXYOCg+9MpS+hdb3VgKD0xoUHqHr+xogkAgsq6SqhBAvGGSzNn1uPYztFOA5b09500CMoggmCo3Z9GEBlWKaUIah8aIPxDhTDNKNcpjlnXMhCIjib6wclmOUk1r02/RDFUSspRbCz+vX7SiyILBBsvPXR5J7WLs0b3223udAAAAA=",
    Pbi3DGeometry:
      "dycAAB+LCAAAAAAABACtWk1P3DAQ/S85h8jZxI4DJ0QrVWoPqK3UA+IAYgWRKKm2q0oI8d+b/YI49ss8exECNvMyfuN54xkf9uolu7ztfj7/WWan2df+tvvRP3Z3WZ5d9t3T+m92evWy+zjA6mz4yV7zd8tJqdTZ9s/wm71eH9zOV6ub58H3xBSVtjofXika1VR5W7TKlnnAbrVtHXuttE6wo/V39rIsFk1r/YXGgBNRAPCXkjgEcrQLaiUuKEKI6ARKgJBZogaomqGYodixZUaVawyzIDUhEAq1VfUi9H5bNWXYbuqtvTSc/bA+slO8w8Y3H4b4N7DMi94f7EZv1rf1Qgftqm2492E8IH60/n4dZN+u/y78JCAHkDy2FFEeE47J7kJL+RyR5JBjUjKux6gGgh4eIHr4HCiq8FJkhXDJhZILxeza5eKcJ+BkFc4Rfb4oAq4EhSNGh0oRcAcMdSfBzncJfLpQ5Uc1drIhH3lKpdmRMoPimGd7EDPOmPF3bANCkxrYEcP21lLa4b/aFZGyi9ZB6spWIUQVpdKCC6Axhda6YlxGbShM7y0Fw3oHIEVsuNPbH/Z4i5Z1SEgi4ID7C8yKiT16E269hUI9AIcETgBf1akDoBjrPe8S2J7D7a+EgvLzMSGIjtVrCjM+gXpOTUkCC9pk8AI5ARI2gvsV8JmpRRnAJLDg6ZPA1Yp8NmVm5EDrJANUH6E67jw3IThXJMJQCU0774TC8pUBfnLKLmRvEu3c2MTDILqDy8B0yorU0EESLw4R4hq5lLbcIUbZdoPoyjQhRBVKGeMih13GI5hnhBxTdFZpmwLI2dwk3tba8amqtg0hqlioqnaRQzrjEczzhkDZTFFr084DrmgQ4HT2qib5uDqKITslsVstUC1TGF3ZecDVCgKcvFMWWSr3rHhSxQNEnaQ3N/do8YBYI7JO7vnwdIoHiCIBKnHdFvfHeGnpKvm4gQYo5oYTrMQPm/xsh6NmD1YKTiXaJSGPkOW4Ph67l7k7BjHH8fCN7x10G5KbBN1WAAee1LjXAfKkcUXOUOJqg7XCl54In4RMYprkq0LCVmBNzOSSutjFz6dpJuEgZy8xxAwEHP5GxOkI2ZOSIo9ANuCZOy3WMcInIZeYRrwDzNxBEnYzFkDbMqzMFgjeh5MRSBOqmUYbHSxyAQiQuIBPItPjveDV4iOj8kKmkmePSbGrcHwdQQ4u9ZIoYsRctUoBxFWSJOWO5zrPPnU3v5fr5So7HQ5qnn1bPt2vH/YP3/v1zbrrn/aPv7q7N+jLsrt/WO8fPj8u/41fvOgf+9XmG3TKqovNF+X+Awe6W6d3JwAA",
    "Analytic Construction": "<None>",
    Area: "6",
    "Bottom Hung Casement": "No",
    Casement: "SH_Aluminum, Anodized Black",
    "Casement Depth": "60",
    "Casement Pivot": "No",
    "Casement Swing in Plan": "No",
    "Casement Width": "60",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    Description: "Single Window Unit - Triple Glazed",
    "Design Option": "-1",
    Family: "Standard",
    "Family and Type": "Standard",
    Frame: "SH_Aluminum, Anodized Black",
    "Frame Depth": "60",
    "Frame Depth over": "80",
    "Frame Depth under": "80",
    "Frame Width": "60",
    Glass: "<By Category>",
    "Head Height": "2700",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2700",
    "Host Id": "SIP 202mm Wall - conc clad",
    Image: "<None>",
    "Install Depth (from outside)": "80",
    Mark: "18",
    Operation: "SinglePanel",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rough Height": "2700",
    "Rough Width": "1500",
    "Sill Height": "0",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Hung Casement": "Yes",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Type Mark": "46",
    "Visual Light Transmittance": "0",
    Volume: "0.15",
    "Wall Closure": "By host",
    Width: "1500",
    "Window Cill Exterior": "SH_Aluminum, Anodized Black",
    "Window Cill Interior": "Wood_Walnut black",
  },
  {
    ID: "457534",
    Name: "Single Window: Standard",
    Category: "Windows",
    Level: "Level 2",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7zG5pxu6xQVBHUQCTqIB62hg7WFrUDE796kur33+D1+1QRFa87jQ4OCo29Nqa+hcZ3VgKDwxoUnqGr6xohQgkXG5Xq1BMYZzPWf2wxDM0Y4DjvT3HXQAyiCCYKTdl3oQaVYJpQhKH1ogvEOFMM0pVwmGWdcyFwiuJjbghLMMhLrQZuuj2KBhaQUwd7q9+8rsSAyR7D11keTe1k71x9q5FpW0AAAAA==",
    Pbi3DGeometry:
      "6yUAAB+LCAAAAAAABACtWt9L3EAQ/l/ynIZN9pJL9KnYQqF9kLbQB/FB8dCANeV6FET835vES8zuzrczE0WqvW9mZ2bnmx+LePGUnF+3Px//7JKT5Gt33f7o7tubJE3Ou/bh8Dc5uXh6+W8vNqf9V/KcviIfcmNOx2/9v+T5cjr2cb+/euzP5jazRVWmvUq2NVubNllj6jwl8LqsGwffmLJcgSP7I14PWjYws4CX0YSwbyRuO+YSRc5bEYQiSbsyXXE4lkUJ15La4L0CSrWFJClIsdcYqRI6UJCN2RSUfmO3OY1XmxHPKxk+2Ue4yG+eFWU9xj+Ieb9Iv8ercrBfb4qSxE2zlenDeED8yP7RDsIHczPtbjhLOK49GJdrO7bdGxFGfNsKl8C2WxyO9ivXlLYHM9q+bToSyoiMfUEKAZlMibo4X3IR8wLimL4Q9wtvXlBcTLOIg+TNC9oFTRgGl3Y66hi6qlVjWTZO13ceN/NX7A6FVzxLRAtIsLDeME7QVgU4bX18WeR1/9PUPV6ZInfwja1tiJssN2VEnTbfh5MXfcmyB+aRQroNzYBwJhgYVwYZvMfwiTlO6QF14oAHcDdi0nu4+gJuXVGBToIpeZ4g5NI/QLtYsBw/QFxu6TmwgwIKc+GZ18XpNzzUD6p3XRqU9tG1iMecAyuDR/OH1o/VGy9ALmBJi2tdVhF89/Ge0QERNxwsmRH8FI355AgWFER0MYR7yus5UJ4cLNt2nLpwvrC4YNlFRrl6/vICfz+yruGBOF1ynIloPlAa+4JXZvgtRg/YahviJjOmqpb4dDMdjuzP+NrSqk1Za2Ema2PrVY6+tU0T4iYrjN0s8SlpOhzZn3GalJ7doqjzuMChBQoEPHr1sLr5lswgnCfSrQaal966sbmNCxxmoEBApe+Bp8bpgJAavUBQF+sHlNM6CgFbGTxHTjeEHOkFggKhWRLMTTTv9KSK6+P91hHtIrJeYAW+086WzjF2jyB+wEQRqqszB+yvn8+q+CPvAXb/otWpnwviEcMPAPHIoH2gjRuZYrTrNStIuBHZRwliCD1WhPrq3CEHK1e9LnzIveAxhx5h+u3iZw6uYenzQ7DBaB/owRLbL7TvNQnhV5goWPz6RNwJ9dXZQw64rY3fC7obOMkuh19sUyyMAuLFugqHDsK62JZVSRYxIyBcOILABeMa3QHZ0UckyYYsfQrfmsQ6nOqrBvoQpDxOBReroC7jjuU1Eyfuxf5lmnxqr37vDrt9ctI3YZp82z3cHu6OH753h6tD2z0cP/5qb2bRl117e3c4fvh8v/u3VDzr7rv98FdbpjZnwx9n/QdzhB7r6yUAAA==",
    "Analytic Construction": "<None>",
    Area: "6",
    "Bottom Hung Casement": "No",
    Casement: "SH_Aluminum, Anodized Black",
    "Casement Depth": "60",
    "Casement Pivot": "No",
    "Casement Swing in Plan": "No",
    "Casement Width": "60",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    Description: "Single Window Unit - Triple Glazed",
    "Design Option": "-1",
    Family: "Standard",
    "Family and Type": "Standard",
    Frame: "SH_Aluminum, Anodized Black",
    "Frame Depth": "60",
    "Frame Depth over": "80",
    "Frame Depth under": "80",
    "Frame Width": "60",
    Glass: "<By Category>",
    "Head Height": "2700",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2700",
    "Host Id": "SIP 202mm Wall - conc clad",
    Image: "<None>",
    "Install Depth (from outside)": "80",
    Mark: "19",
    Operation: "SinglePanel",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rough Height": "2700",
    "Rough Width": "1500",
    "Sill Height": "0",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Hung Casement": "Yes",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Type Mark": "46",
    "Visual Light Transmittance": "0",
    Volume: "0.15",
    "Wall Closure": "By host",
    Width: "1500",
    "Window Cill Exterior": "SH_Aluminum, Anodized Black",
    "Window Cill Interior": "Wood_Walnut black",
  },
  {
    ID: "457542",
    Name: "Single Window: Standard",
    Category: "Windows",
    Level: "Level 2",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1zc0KwjAQBOB32XMM+WnaJJ5EBUEPpQgeSg9VQxuIidQolNJ3N6LeZodvmXqC8myP492Ahn0428pcYus7ZwBBGayPD9D19I2JcIIJY8VyQQmWXHCYm79bDUM7JpyKjW1vJpoBdOIIDsZ3sQedYcUoR1CF2EYbPGiOaUaFYrngQqpCITjZ64cSzHOSzp2xXZ+GJZaKUgRbZ16/X4UlUQWCdXAhLfmnc3PzBsoxkpzQAAAA",
    Pbi3DGeometry:
      "gSYAAB+LCAAAAAAABACtWk1P3DAQ/S85p5Hz4cSBU0UrVWoPqK3UA+IAYgWRKFttV5UQ4r/XWXbZOJ7xvAkI8bFv7HnjeeMZH7h4ys6vh5+Pf1bZSfZ1fT38WN8PN1mena+Hh+3f7OTi6eVPbzan/it7zo/Ih9KY090P/509Xx62fdxsrh793roqGlc3uV9SdKar877ojStzAnfW9QHeGGsX4Jz/HV51hW2rMvIzxafxEHjkR/Cf5OXiR/wg8SD51+ZNwJP5RHRH6gTh5fTV1hVSnwrepL6ILlycvWkqan1fdyWNt80OL1sMP/jncIi3LCrrdvGPZpmXW+/x1o7+XVNZEjd9h61n42Hi5/zv/XD46O6oexhPgAvrR/+a9aH/8FyUn8i/ipfzH9ZJuP6oO7l+jkvrI/9MPKQfrB6gfHL6CnUb4nIdpvxDOgr3Bb5HgH+o3oR7BMcJ+IfuEdd/BBzuA+w9Yupc1bexfvum+yjNhQXzRcWb6DPQnALm2tv6DDd/GZzxv3uHlM7/Nm40dLYP8KZ2dYybojQ2tZz27wOqXGuBHcdOQxHHfpiAXmHOuzLO6AXH73iNFN2gTx5DwZ2OmAIzXH2EsLyoSA+GQ/pmhljP+QaaYqJ0egNxuClz5IcLKM7FzL0uzujqsxviEl6WCC0BdzLq7Rfi2vjZXkTvSJWdbGA52NKGax6rDPkWyszcBlAgEUfaBdJUk7yi0FBpJKdFPL7ml5CpVQEGh6CwHGw4Ig5MwERvVzdk2TAfmSI1uyEtF44LER03tK15MbTG9aPB1m1HGExhTNsGhsPhtAaW42hYWGDOWKeFhdx53NmuCTbUdd8TBlNUxveNqeGQO62B5TgaaH281LVr+rQh0Ic1QIrOi2PpXZxKxOGyorOyoPXx7kvnyrQh0Ic1QIrOOWR9gtsQ66M3AMWxvGUF10hhEItDVim4E7FKegNQIrRKUCdl259eV7hE3m9G0RSJmcMW4TsNcrSfyWOFVYhpLOB6de44gre0atURUi8FaSZz41TfH+BWIzcCuHXQHOwATrQzmnvROALHI/BU4URinzDgBn0COYqls193ArYEoHce+zjTz5t5+tjBjD5JgJlGc7CPmNS8ockXpUSeaVi4qWcpqyC6Q59ElkOa5qmnhPIcQdqt/4PUY2egXrQLDSwHUSWd9ZedKmrBQHAEhphDImfPwbrSRwWlBEuiglyT3UBaffmwHFDaBT2kcKESFcg15SMo+MJxmWefhqvfq+1qk534a5ln31YPt9u7/Yfv6+3Vdlg/7D/+Gm5eTV9Ww+3ddv/h8/3q33Th2fp+vRn/l8w4czb+y9h/2qCGXoEmAAA=",
    "Analytic Construction": "<None>",
    Area: "6",
    "Bottom Hung Casement": "No",
    Casement: "SH_Aluminum, Anodized Black",
    "Casement Depth": "60",
    "Casement Pivot": "No",
    "Casement Swing in Plan": "No",
    "Casement Width": "60",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    Description: "Single Window Unit - Triple Glazed",
    "Design Option": "-1",
    Family: "Standard",
    "Family and Type": "Standard",
    Frame: "SH_Aluminum, Anodized Black",
    "Frame Depth": "60",
    "Frame Depth over": "80",
    "Frame Depth under": "80",
    "Frame Width": "60",
    Glass: "<By Category>",
    "Head Height": "2700",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2700",
    "Host Id": "SIP 202mm Wall - conc clad",
    Image: "<None>",
    "Install Depth (from outside)": "80",
    Mark: "20",
    Operation: "SinglePanel",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rough Height": "2700",
    "Rough Width": "1500",
    "Sill Height": "0",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Hung Casement": "Yes",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Type Mark": "46",
    "Visual Light Transmittance": "0",
    Volume: "0.15",
    "Wall Closure": "By host",
    Width: "1500",
    "Window Cill Exterior": "SH_Aluminum, Anodized Black",
    "Window Cill Interior": "Wood_Walnut black",
  },
  {
    ID: "485432",
    Name: "Single Window: Standard",
    Category: "Windows",
    Level: "Level 2",
    Pbi2DGeometry: "zgAAAB+LCAAAAAAABAA1jUEKwjAURO/y1zEkTdP2x5WoIOiiFMFF6aJqaAMxkRqFUnp3I+puZnjDqycoz+Y43jUo2PuzqfQltK6zGgiU3rjwAFVP3xiRRUELjnyJVPJEwtz8qdUwtGNE47Ax7U0HPYBilBE4aNeFHlRKMeGCQOVDG4x3oATlKZeYZFLIAnMkcDLXD8qoyFisO226PmqjFDknsLX69fsiLRjmBNbe+mhyT2vn5g1oYLG2zgAAAA==",
    Pbi3DGeometry:
      "LyQAAB+LCAAAAAAABACtmt9L3EAQx/+XPJ9hc5vNbfSp2EKhfZC20AfxQfHQgPXK9SiI+L83FxOT7M53ZjaW0lo/jt+dnZ8rePmcXdw0P55+b7PT7Mvupvm+e2hus1V2sWseD3+y08vn1/+2XzZn7Z/sZTWSk8KYs+6f9m/2cjV824f9/vqp/d6TKrfOu1WdG7/etB+88/VqpNaXDtLa+EKkvS5NX3WLIl9vah9KRDi0BiI8BtpKzN5GRdPOAzdPSQBLgbAypGx1qOh/SSFduguoLttVYauOFtWMlja2db4ok2mgS59G0dq67nJ2U4ie1eX6SL2pNwQt126pLmmbojtQ2rOOjilCeKocW3dujHh2E9EaafNHAgcDPMvriGcFI/oNrXntOQbXASJpEaQrJ4Wi1PAY1E5QlAtoWlFy1sr+DCgQ5jGoX0ZaSXWNASqJnwkaCks0pfxTxi5NgbCEQStjaS1Vzgh5oixabkA4xO3GrVf9Y6EweWFcjH1eWm+jd0jLN8b445nOOas2R/KBDHBmxMGbKBhB0ZnAnBKnPZm/rJbeHpgDceB39Mjr6XK3SeNIuCu1KEqvNLrJgMOsq8yBeKhCuxJepu+QIHbhgbQxJQy8CNp36dWROZKnPY9mSVjxi1ynzYXQMuKaZo0vCrAuobxx2ol0U2ryIHin6HZxAnJuoNyoxROnrraqUOGjfaTifNemtrhmYwp7JGmassYpx4Ftyw9YwVwST01Y5Ezhi+mNjKmqKV/7qsDc585WGw0f/KH5RL/3s2zdS6wJfRA6cYAHcZPXrx04RGBtbDnlvTWJfW5tXSvwEC6aD+pVXrqqjqL1hvkk6TmQD3FfetNwpT4teUwqz2HlrCfi1GMuN2oMtNnUDAUepAZgIZFS2sMjp4FKmx+6+YbTMsrOgjTU9TwvNOVzKCU86CNx7LBp0WJ+pkV50S0NpA1+ouNLQbW2kYNpxcfPCmX/o6ylXJ4Z/yA/pOvyilrkPDAHC1BaaWmvA7pnwZGa7hw7mRSml58wObj9Kc2IhDnFLRXVmgCJSrkzeh2ghBA+S4+XBT4Da/AuEl46mskfUf5RJJhLezp4+0gvrnAjk+LJLr7jcTBaJ0ULPv7SAgCfxUAeOA9/Xnin98g+1rfWUQOFxVFa5zgURzyeYtZuqOboMDGHFnEgL2Ckor2rELK0EEjWaUeyyZCiK3moKi9UGKkple1Tz0VJnZ57tco+Nte/toftPjttG3KVfd0+3h3u+0++7Q7Xh2b32H/6s7l9+9LnbXN3f+g/+fSw/Ts1PN897PbH3/wx3pwff8HnH1NRtLMvJAAA",
    "Analytic Construction": "<None>",
    Area: "6",
    "Bottom Hung Casement": "No",
    Casement: "SH_Aluminum, Anodized Black",
    "Casement Depth": "60",
    "Casement Pivot": "No",
    "Casement Swing in Plan": "No",
    "Casement Width": "60",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    Description: "Single Window Unit - Triple Glazed",
    "Design Option": "-1",
    Family: "Standard",
    "Family and Type": "Standard",
    Frame: "SH_Aluminum, Anodized Black",
    "Frame Depth": "60",
    "Frame Depth over": "80",
    "Frame Depth under": "80",
    "Frame Width": "60",
    Glass: "<By Category>",
    "Head Height": "2700",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2700",
    "Host Id": "SIP 202mm Wall - conc clad",
    Image: "<None>",
    "Install Depth (from outside)": "80",
    Mark: "21",
    Operation: "SinglePanel",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rough Height": "2700",
    "Rough Width": "1500",
    "Sill Height": "0",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Hung Casement": "Yes",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Type Mark": "46",
    "Visual Light Transmittance": "0",
    Volume: "0.15",
    "Wall Closure": "By host",
    Width: "1500",
    "Window Cill Exterior": "SH_Aluminum, Anodized Black",
    "Window Cill Interior": "Wood_Walnut black",
  },
  {
    ID: "485452",
    Name: "Curtain Wall Dbl Glass: Curtain Wall Dbl Glass",
    Category: "Doors",
    Level: "Level 2",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABAA1jbEKwjAYhN/ln2NImzZp4iQqCDqUIjiUDlV/2kBMpEahlL67ERVuuDu+4+oJyrM5jncEDXt/NhVeQus6i0Cg9MaFB+h6+tqILBJBGZdLQUUhJczNn1oNQztGNBYb094w4ACaUUbggK4LPeiU8lwSqHxog/EOdEJzyaQSPBVSZUUUgZO5flhGucpj3KHp+vgraMFZSmBr8fVbq1iJjMDaWx+v3NPauXkD09RHIc8AAAA=",
    Pbi3DGeometry:
      "uR0AAB+LCAAAAAAABACtmV1r2zAUhv+Lrl0jf8iO06vRDQbbRdkGuyi9aKlpDVk8MjMopf99TuJstqT3fKSjtNRP37znWDqSj9ybF3N93317/tmatfnU33df+033YBJz3Xfb4ZdZ37wcfx3/bC/HL/Oa/CMXmbWXhx/jt3m9PX3s3W539zx+9iKr0qJsXFKlq9rlSVaMl7lL9jy3RbXnriyj3NcXtS0ovc9R3AOvU2ttxD/GkQ/Ih9Rj/yKaZ5W6aJ4x/ZG7PJPJgf00nJD79nSWUnnU3aVN44rYWGZlloVjP+rr0sXm5KQX+0TjTv7BHE56xJEPyl/jc+QO6AsQF3Ew/KE9sqH1fjFMo48wuKmgdoDNYp3naVW7Jlyfcz5fnz4/zZVED/wX+1qEB/5Ungo94+/8/OdLMYLB8CC5h1HQxSYYuocc+cSzYeSevbfefB7MubdufR6MPeGPfCh9ZG4X+1qEy+4X+XhLMdQvh3+5/iNqqUs0qLcbhXrEkQ9IXmhz5j4S6yMozvUvfu2jfDgu7V84LtnXKL02Lur7FPsymSfnL+hntc8DTq+NS/bRgrrl8hT36ZL6FzxZwM5PdsU+Bk2u8pHIyHUxyf5c8TgnuSAubPS1T3Rar42LzjXaToLmkrj0sQzlA+qVTv/Np0HwJA6f86h/oc4vxPmL5Gyfwuu1cdF5UNsfkZyNy57v5H0opdfG5c650r6V45K46Fys7bspvTYuV/+SHpJsOYPjOInpw76kL6aTlL9MQC8ftP04rdfGpd8nsMcSNk/1+wqSc8chXq4NS7yckR/lCMyFFJW9712mRe5cMl5WVVUHvElXXsxqlWsxMp/zqWvybQ44zGWOAxfGXRqVxsE9ncmFUcEQnDUdPqaHVznqvLkAv3lKmaoWc6ZkYvomb4LbalJbNhAHLohP7oKohyQjNnMeqaWYC42RuZgz9yTm2rhgELRTwnBgLxxjumyE+P9MKyjsszBTA7eJed/d/WiHdmfWNrWJ+dxuH4en6eJLP9wNXb+dLr93D3//9LHtHp+G6eLDpv09F171m363/x+sXdmr/b9a/wADzUEIuR0AAA==",
    "Analytic Construction": "1/8 in Pilkington single glazing",
    Area: "3",
    "Construction Type Id": "GSP4R",
    Cost: "0",
    "Define Thermal Properties by": "Schematic Type",
    "Design Option": "-1",
    Family: "Curtain Wall Dbl Glass",
    "Family and Type": "Curtain Wall Dbl Glass",
    Function: "Exterior",
    "Glazing Material": "Glass",
    "Handle Material": "Metal - Aluminum",
    "Heat Transfer Coefficient (U)": "3.6886 /(·)",
    Height: "2080",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Mark: "206B",
    Offset: "51",
    "OmniClass Number": "23.30.10.00",
    "OmniClass Title": "Doors",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rough Height": "0",
    "Rough Width": "0",
    "Solar Heat Gain Coefficient": "0.78",
    "Thermal Resistance (R)": "0.2711 (·)/",
    Thickness: "0",
    Type: "Curtain Wall Dbl Glass",
    "Type Id": "Curtain Wall Dbl Glass",
    "Type Image": "<None>",
    "Type Mark": "68",
    "Visual Light Transmittance": "0.9",
    Volume: "0.06",
    Width: "1440",
  },
  {
    ID: "485456",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jcsKwjAQRf9l1jHk0UdSV6KCoItSBBeli1RDG4iJ1CiU0n83UoVZzNx7hlNPULbmPD40FHD0ran0NSjXWQ0ISm9ceEJRT8sakRXNMOH5ekUJTgmXMDd/bjMMaoxwDHZG3XXQAxQEEwQn7brQfw/KKUNQ+aCC8Q4KitOc5DLjLMtlIuIguJjbAnMmKIKDNl0f1RkWQsZ6b/X79y2xSFiKYOutjy73snZuPtDB1/DSAAAA",
    Pbi3DGeometry:
      "sAMAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzOz8lMUdJRCsjPzCspVrKKroYwgdIG1kCoVKuDENE1NDCwBhNArFQbC9PmWFSUWAnUq2topmdkYKgDVKJnbG5krmOpZ2FiZArkm+pZmBtZ4pcwNTC2JEICYQUucVQbCKsHiwP55sZGxpgGkS5BBaeiWYAefOTIELSdmDjCbQdaIBIvQ8U0gi1GyJQgYDkw6btkJuamlqQWKVkZ6BnoKPmk5qWXZEA5QfkliSWZ+XlQbnhmClzKIzUzPaMEynHNSS1DVuicn5NfBMp6YADMYQCASZLAsAMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2100",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "485458",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jUELwiAcxb/L/2wydem0U1QQ1GGMoMPYwUo2wTSWBWPsu2eM3d57/H68eoTyZi/Dy4CCU7jZytyj9q0zgKAM1sc3qHqcY0JWhOOMiY3EpCAEpmahtn2vh4SmYW/100TTg8pwhuBsfBu7fyGMUARViDra4EERvBaZkJxRLmReyIIhuNrHDDNaEARHY9suHVPMucwRHJz5LjbHgtGk7IIL6cx/nJuaH9RD68nRAAAA",
    Pbi3DGeometry:
      "hgMAAB+LCAAAAAAABAClU18LgjAQ/y73PMemps6eooKgHqSCHqIHo1EDc2EjCPG7t8osjGXZxsbud3e/G/dnmUO0FvPzgUMIY7kWM5mIDSCIpEjVEcJlfn9qNenqDQV6IhYlpHu79IFi9XDrZVl81r4W9bBNKGKYBpQiyrBLqIfqsId9x3ZeYOIy9ivMsOMGwRv3W0iDdY27gwPfZq1xA30Fm8wb6WsJ+xKvktAY12RvKFQb2ETeVKk//27ovY9RdUMPRLznimcQEkwQTHi6VbtSmEoVKyHTUlyITaUacbHdqVIYJvz0atiXicyuA3Vbem4uhPYQYoYDAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "814",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "485460",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 2",
    Pbi2DGeometry: "zgAAAB+LCAAAAAAABAA1jUEKwjAURO/y1zGkTU2auBIVBF2UIrgoXbQa2kBMpEahlN7dLyrMYhjeY6oJitaexrsBDYfQ2tJcYuM7Z4BAEayPD9DV9K2ILBJBGZerhEqlUpjrP7UehmZEFIetbW4mmgE0o4zA0fgu9qAzVAiUITbRBg86oUvJpBI8FVJlOYbA2V4/KHo55wT2xnY93goqVIryzpnXz1ZUSY7GJriAT/7p3Fy/AYc5up3OAAAA",
    Pbi3DGeometry:
      "JQQAAB+LCAAAAAAABACVU8sKwjAQ/Jc9p2GrbW3qSaog6EFU8CAeWgwaqI3UIIj470atT2zaEBIys8nsso/lGSapmJ/2HCIYyVTMZCbWQGAiRa4OEC3Pj6s2Y1cvuJA347iI3fuhN1xWz2+9okhO+q/jBtQNWyFxkPrMDwmjrNPW8JfXOAiCztvgUZd5LWu+Sv+DR8b8fzJ3/l88X4ZfoRoHDfxWhG9SsQjGmH3LpNXxjbJpLrtNn5h9V1XYtrFsOrSJ4/oSm0rzLa7nrS+SHVe8gAgpEhjzfKO2JZhKlSgh8xIuxPplGnKx2aoSDDJ+/HwYy0wWt3nHEOPbWF8BYaJ7KyUEAAA=",
    "Analytic Construction": "<None>",
    Area: "3",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2040",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.08",
    Width: "1460",
  },
  {
    ID: "485462",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 2",
    Pbi2DGeometry: "zgAAAB+LCAAAAAAABAA1jUEKwjAURO/y1zGkTU2auBIVBF2UIrgoXbQa2kBMpEahlN7dLyrMYhjeY6oJitaexrsBDYfQ2tJcYuM7Z4BAEayPD9DV9K2ILBJBGZerBadJmsJc/6n1MDQjojhsbXMz0QygGWUEjsZ3sQedUakIlCE20QYPOqFLyaQSPBVSZTmGwNlePyh6OecE9sZ2Pd4KKlSK8s6Z189WVEmOxia4gE/+6dxcvwHVdA8xzgAAAA==",
    Pbi3DGeometry:
      "EwQAAB+LCAAAAAAABACVU8sKwjAQ/Jc9p2Gr9OlJqiDoQVTwIB4qBg3URmoQivTfTbVqfTSmhITMJDu77GN1gemGL/IjgxDGYsPnIuFbIDAVPJUnCFeX+1U9Y08tKMiLsWzE3u1QG4r1w6yfZXGubC3bpbbf8YnlUMf2SEADr6vQB62g67pejUfqddrzDfI1GoPA+aVy57+jqfNfMlp1A6cNoWtVTEPRZr1dtrS0SRL1pTbuDL3bppq27STzjjTx+7+s2oq8iavpGvD4wCTLIESKBCYs3cl9BWZCxpKLtIJLvn0+jRjf7WUFhgk71z9GIhFZOd3oY1QO8RX1KnCFEwQAAA==",
    "Analytic Construction": "<None>",
    Area: "3",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2040",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.08",
    Width: "1460",
  },
  {
    ID: "485464",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jUELgjAcxb/L/zzHdHNz6xQVBHUQCTqIB62hg7WFrUDE796ignd4PH4/Xj1D2ZnTdNeg4OA7U+lLaF1vNSAovXHhAaqevzUiScoxoWKVFJikJIel+WPrcWynyMZha9qbDnoERTBBcNSuDwMohkXGGILKhzYY70ClOBdESE4zLiQrYhCczfUDR7OgFMFem36IzxxzmUkEO6tfP1tiKWg0Nt76+OWe1i7NG8PEalfRAAAA",
    Pbi3DGeometry:
      "SQQAAB+LCAAAAAAABACdlN8LgjAQx/+Xe15jas0fPUUFQT1EBT1ID0ajBubCRhDR/95MK61sLobD2+d233N3M7zAdM0X5wODAMZizeci5htAMBU8kUcIwkv+qjDpqgFX9FppWYR075N64Lp6bOulaXRWe1sWxZZne0j5YMe1XeRj33Uy+x2oBUqpWyIdTNue8weo1SgB4vudr5Fy8C2rKvmIpRNpIl73Gb8DmaSkqYbxCWpBs7PV9YJR++gSqK26eccZdW8z9QZl/12rqoC6kwMe7ZlkKQQEEwQTlmzlrjBmQkaSi6Qwl3zzRCPGtztZGMOYncqOfRGLNPsnEI/0s6t/AwKsNKxJBAAA",
    "Analytic Construction": "<None>",
    Area: "3",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2040",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.07",
    Width: "1440",
  },
  {
    ID: "485466",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 2",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1jUELwiAcxb/L/2zi0um0U1QQ1GGMoMPYwUo2wTSWBWPsu+eIwTs8Hr8frx6hvNnL8DKg4BRutjL3qH3rDCAog/XxDaoe/zUhq4xjQsWGYyYZg6lZqG3f6yGhadhb/TTR9KAIJgjOxrexA8UwpaJAUIWoow0eVIZzQYTkdM2FZEUKgqt9zHAyC0oRHI1tuzjLOZEIDs58F1likROBYBdcSF/+49zU/ABohm+h0AAAAA==",
    Pbi3DGeometry:
      "BQMAAB+LCAAAAAAABACVUssKwjAQ/Jc9x7BtTe3jJCoIehAVPBQPlYY2UBupQRDx3021an3VlpCQnczOJpMNTjDbiOVxx8GDidyIhUxFBARmUmRqD15wum31Mfp6wJk8kY6B6F8XPeG8vqf18zw86tyOYVPDMR3SpZbJGDFc2mPYI++42aUmcyu4Q23bsl746LrsG7+Kf/C/6NTq/6nbBK9976/7tNBv4sOHn3/wJv9SW7eFn018KPV1Pw1FuOWK5+AhRQJTnsUqKYO5VKESMivDlYgeR2Mu4kSVwSjlhypxIFOZF/2MDg6Ktr0AbsK3aQUDAAA=",
    "Analytic Construction": "<None>",
    Area: "1",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "0",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.02",
    Width: "0",
  },
  {
    ID: "485467",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 2",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABAA1jUELwiAcxb/L/2yiuem0U1QQ1GGMoMPYwZVsgmksC8bYd8+IwTs8Hr8fr56gbO1lfBpQcAqtrcwtat85AwjKYH18gaqnf03IinJMmNhQLKRcw9ws1HYY9JjQNOytfphoBlAEEwRn47vYg8qSgqAKUUcbPCiKc0GE5GzNhcyKFARXe/+hySsYQ3A0tuvTrcSMcIrg4MxnsSUWOREIdsGFdOXfzs3NF8rn3kbPAAAA",
    Pbi3DGeometry:
      "VwUAAB+LCAAAAAAABACVVF1rwjAU/S95TsNN1o+kPokKg+1BtsEeZA8Vgwa6ZnRhIOJ/X9zq1DVJU0pL78e557b35K4OaLlWL/sPiUr0oNfqWddqgzBaatWYT1SuDr+vNgwTe6EjvngSCjD5edgbHd/OsGnbVnuLTWhOKGccp4SKlGGWkjuRU/zfTwUpMigu/gRIJjLeD/gKnQGMkyJnN37GRYqZIJDlfBgwRHDdEQiRuQrd+HsAB0OwUCC/92lRBL6OfD87Jj9M4B3n0JyjAHHcvvk4FBP0e1uKIAjPLaTVcSIeRRHUzMDBdR0Td6sjCIIaG6FVB6/dUHNVvUsjW1QCAYweZbM1u8540qYySjed+ao2f6F7qbY70xmLWn5dJ850rdvThgQOs9Mi/AZKG9eVVwUAAA==",
    "Analytic Construction": "<None>",
    Area: "3",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "0",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.08",
    Width: "0",
  },
  {
    ID: "485468",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 2",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABAA1jV0LgjAYhf/Lez3H5tR9dBUVBHUhEnQhXmgNHawtbAUi/vcWIZyLw+F5OPUMZWcu01ODgpPvTKVvoXW91YCg9MaFF6h6/teIJLTAhPFNwjBNU1ialdqOYztFNA570z500CMoggmCs3Z9GEBlmEsElQ9tMN6BojjnhMuCpQWXmYhBcDX3Hxo9wRiCozb9EG8FFiKnCA5Wf1ZbYp4TjmDnrY9X7m3t0nwBeHxADM8AAAA=",
    Pbi3DGeometry:
      "JQQAAB+LCAAAAAAABACVk02LwjAQhv/LnNMwqcak9SS6sLB7EBU8iIeKQQO1WbphQcT/vlGrVmtDJDR0niTvDPOxOMB4pWf7HwUpfJmVnppcr4HA2OjC/kK6OFx+3TH23YIjuZOIIfbPm/vguLw+G5RltndvI9ajTMaSRJxyJghLqOAoyDOPuxRjUedIRey4pL0Ol8G8Tb/OMUn4K50Lb8ZT500dv36I37b4/Trh8fjz/27e/Lwtb836+nlIn/j9ttX33b4K788QvyH19dflQd/N20hnO2VVCSlSJPCtio3dVsbE2MxqU1TmXK9vR59Kb7a2Mj5y9Ve/ODS5KU/zjhKHp7H+B6lDnzolBAAA",
    "Analytic Construction": "<None>",
    Area: "3",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "0",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.07",
    Width: "0",
  },
  {
    ID: "485469",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jVELgjAUhf/LfZ5ja27T9RQVBPUgEvQgPmgNHawtbAUi/vcmIdyHwznfx60mKFpzHV8aFJx9a0p9D43rrAYEhTcuvEFV0z9GJKECEya3icQZ4QLmesV2w9CMkY3FwTRPHfQAimCC4KJdF3pQKWY0FQhKH5pgvANFMZdE5oJthMzTLB6Cm3kscDQzxhCctOn6sMiUkzgfrf6udo4lJxLB3lsfn7mPtXP9A0DjXqrSAAAA",
    Pbi3DGeometry:
      "HQMAAB+LCAAAAAAABAClkl0LgjAUhv/LuZ7jTNOcXUUFQV1EBV1EF0rDBubCRiDSf2+VfaGhEWNjZ+8eXs7HuoBZJJf5QUAAExXJhUrkFgjMlEz1EYJ1cb8aGXtmwZm8XiyG2LsdZsN588D6WRbmhrWYR5lv+8TilHs2J4zTrotd8hJc6nV8h9gO5cg6VeGdQM7dWuIu1Hh8EF/NWxENHl8TbMq8FdEuwWpJmqpbFX5pVDvz//pRZ27mbCjDvdAigwApEpiKNNa7MpgrHWqp0jJcye1TGgsZ73QZjBJxev84UInKrnOOPg6u43wBMHd5Ox0DAAA=",
    "Analytic Construction": "<None>",
    Area: "1",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "0",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.02",
    Width: "0",
  },
  {
    ID: "485492",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 2",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABFjUELwiAcxb/L/2yizulcp6ggqMMYQYexg5VsgmksC8bYd2+xott7j9+PVw1QnO2xvxvIYR/OtjSXqH3jDCAogvXxAXk1zHFCFlRgksglx1RxBmP9o1Zdp/sJnYaN1TcTTQc5wQTBwfgmtp9CE8oQlCHqaIOHnOJUEqlEwoRUPFNCIDjZ6wwnLKMIdsY2bfzLW2deX1vhjLMUwTq4MH35p3Nj/Qa23Uc90AAAAA==",
    Pbi3DGeometry:
      "AQQAAB+LCAAAAAAABACdU18LwiAQ/y737ETXVnM9RQVBPUQFPUQPG0kJa8aSYIy+e1brf6KlKN7v7n6e592ignEqZuWOQwxDmYqpzMQKEIylyNUe4kV1PWo1aesJR/RAPEpI+7LpBcflza1TFEmpfT3axD6hKMCUBT5imLUaEfJoiKOWz6xwFPihGX6j/o6+MnsEhyyMPqgfeG1/ZfkXNpE7BG4w/i2S99f/kikDsSlRFtwSiVM52O+05NuxrJyK0Po/LrBLgete6olkyxUvICaYIBjxfK02tTCRKlFC5rU4F6u7asDFeqNqoZ/xw7NhV2ayOPfyZeiWPQE4DFR6AQQAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "485493",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 2",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABFjUELgjAcxb/L/zzHNnVzdooKgjqIBB3Ew6yhg7WFrUDE755h0e29x+/Hq0YoGnMa7hpyOPjGlPoSlGutBgSFNy48IK/GJc5IRDkmsVhFBAsmYKp/1Lrv1TCj87A16qaD7iEnmCA4ateG7lNoTBmC0gcVjHeQU5wKIiSPGRcyySTnCM7musAxyyiCvTZtF/7yzurX15Y4S1iKYOOtn7/c09qpfgPubJON0AAAAA==",
    Pbi3DGeometry:
      "7wMAAB+LCAAAAAAABACdU0sLwjAM/i85d6Wdzj08iQqCHoYKHoaHDYsW5iqzCCL+d+usD8YenS0tzZfka5om0Q3ChK+vJwYBzEXCVyLlO0AQCp7JMwTR7XVUajJUE+7oi1iUkGGxqQX37dttlOfxVfladIBtQpFFsGu7yMe+2/OQRR3subbfCnt926mHS9TVaInZwQ6tYH7D2lpz/IPWEJuEXG3bJYjSo7skqJq3Jj8tcHMYZiXQcmNzmg3ryKzqmr/FBDUoZ9U5Ex4fmWQ5BAQTBAuW7eVBC0shY8lFpsUN331UM8b3B6mFacouv4ZjkYr82bnFUA36ABqC13XvAwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "485494",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABFjV0LgjAYhf/Lez3HPnRTu4oKgroQCboQL7SGDtYWtgIR/3sLi+7OOTwPp5qgaPVpvCvI4eBaXaqLb2xnFCAonLb+AXk1LTEgERWYcLmKEizilMNc/7D1MDRjYMOw1c1NeTVATjBBcFS28/2nUE4ZgtL5xmtnIac4kURmgjMhszjNhEBw1tcF5iylCPZKd73/yzujXl87w2nMEgQbZ1z4sk9j5voNcxtE79EAAAA=",
    Pbi3DGeometry:
      "JQQAAB+LCAAAAAAABACdU18LwiAQ/y737ES31v49RQVBPUQFPUQPG0kJa8aSIKLvnpW1WNhciuL97u53et6tLjDN+OJ8YBDDWGR8LnK+AQRTwQt5hHh1eR6VmiRqwhVViEMJSR6bWnBdv9x6ZZmela9Du9glFDk+7nZCD0U4CrwQOdTHYeBGFnjYcf0feJ3eANfYKcFe4Abf9JVCe2ii/3FjAKsHmMzb3qeeiHZpM5Ebs9aoaLqPZZVYBG7Kv3XBWRZo84/Z4VYNoPptwNM9k6yEmGCCYMKKrdxpYSZkKrkotLjkm7dqxPh2J7UwzNnp07AvclHe+/0xVFvfANVcwAAlBAAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1440",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "485500",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABFjUELgjAcxb/L/zzH5nRzdooKgjqIBB3Eg9bQwdrCViDid28h0u29x+/HqyYoWn0ZnwpyOLlWl+rmG9sZBQgKp61/QV5NSwxIRDkmTGwiglOZZjDXK7YdhmYMbBj2unkorwbICSYIzsp2vv8VymiMoHS+8dpZyClOBRGSs5gLmWSScwRXfV9gFmcUwVHprvd/+WDUZ7Ul5lQmCHbOuHBm38bM9Rf7Dm380gAAAA==",
    Pbi3DGeometry:
      "JQQAAB+LCAAAAAAABACdU18LgjAQ/y73PMcmqalPUUFQD1FBD9KD4rCBubARSPTdW2VZyHK2sbH73Z/fcbuLLrBM+KY6MghgLhK+FjlPAcFS8EKeIIguz6dSk1BtuKIGsSgh4eNSB667l9uoLONK+VrUxTahyCLY8Z0hoj52qT9AFnXw0LN9I4XnEO+XokWhw78ZBliJdpugwWv7Z5x/YV1wo+Q15v1yaVegb8U04XUF68AN8jFskm7mjur3aDbD9uz8MRPYtPnVvE14fGCSlRAQTBAsWJHJfS2shIwlF0Utbnn6Vs0Yz/ayFqY5O38ajkUuyvu8P5Ya6xvQhQqaJQQAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "485501",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABFjUELgjAcxb/L/zzH5nRzdooKgjqIBB3Eg9bQwdrCViDid28h0u29x+/HqyYoWn0ZnwpyOLlWl+rmG9sZBQgKp61/QV5NSwxIRDkmTGyiFKdUwFyv1HYYmjGgYdjr5qG8GiAnmCA4K9v5/lcoozGC0vnGa2chpzgVREjOYi5kkknOEVz1fYFZnFEER6W73v/lg1Gf1ZaYU5kg2Dnjwpl9GzPXX7xjR1vRAAAA",
    Pbi3DGeometry:
      "EwQAAB+LCAAAAAAABACdU18LwiAQ/y737ERHm209RQVBPUQFPUQPi0kJa8aSYETfPSv7w8i0FMX73d3P87xbnmCyFvN6zyGFkVyLmSxEDggmUpTqAOnydD9qNenoCWf0QgJKSOe26QXn1cOtW1VZrX0DGuOQUBREOKIM0QTHNGmhgEa4zcLEA2cRYV/wJr0FbrATzMJP7E/c2BuaP2EbuVfoFuvfQmm+/7dsWbhtyXLhrmA8K8N5rSPt3hXmWZGuj/KCvcpdd1dfZDuueAUpwQTBmJcbtTXCVKpMCVkacSHyp2rIxWarjDAo+PHdsCcLWV27+zZ0E18AupPRdBMEAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "485505",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 2",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1jUEKwjAQRe8y6xiapE2TuhIVBF2UIrgoXaQa2kBMpEahlN7dSBVmMfP/G149Qdma8/jQUMDRt6bS16BcZzUgKL1x4QlFPS1rRFaE44Tl6xTTTEqYmz+1GQY1RjQGO6PuOugBigQnCE7adaH/HoQRiqDyQQXjHRQEZ3mSS84oz2Uq4iC4mNsCMyoIgoM2XR/FHAshY723+v37llikNEOw9dZHl3tZOzcfLHPWAdAAAAA=",
    Pbi3DGeometry:
      "dAMAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzOz8lMUdJRCsjPzCspVrKKroYwgdIG1kCoVKuDENE1NDCwBhNArFQbC9PmWFSUWAnUq2topmdkYKhjomdsZGqqY6lnYWJkqqNraKpnYW5kiVvY0NLEiKAwzGjsoqgm41cLFgXyzI2NjNGNIE2YIsehGYwaSKSKE7CTUAzgMhstqIgTp0q8Y4Y4GcJ4rQQmX5fMxNzUktQiJSsDPQMdJZ/UvPSSDCgnKL8ksSQzPw/KDc9MgUt5pGamZ5RAOa45qWXICp3zc/KLQNkHDIC5BAAVzNhUdAMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2100",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "485506",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jcsKwjAQRf9l1jHk0aZpXYkKgi5KEVyULlINbSAmUqNQSv/dSBVmMXPvGU49Qdma8/jQUMDRt6bS16BcZzUgKL1x4QlFPS1rRFZUYMKz9YpgIWgCc/PHNsOgxsjGYGfUXQc9QEEwQXDSrgv996CcMgSVDyoY76CgOM1IlgvORJYnMg6Ci7ktMGeSIjho0/XRLLCUeaz3Vr9/3zmWCUsRbL310eVe1s7NB6lS1fzRAAAA",
    Pbi3DGeometry:
      "gwMAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzOz8lMUdJRCsjPzCspVrKKroYwgdIG1kCoVKuDENE1NDCwBhNArFQbC9PmWFSUWAnUq2topmdkYKija6BnamlqoWOpZ2FiZKqja2iqZ2FuZIlP3NzInKAw3HDsoqhGE1AMEgXyzI2NjDHMIFWcQgeimY0WVqRLELKYcGTgNB811IgTp04iwBL2pAvjtRKYml0yE3NTS1KLlKwM9Ax0lHxS89JLMqCcoPySxJLM/DwoNzwzBS7lkZqZnlEC5bjmpJYhK3TOz8kvAuUmMABmGgCmDaqIgwMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2100",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "485507",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jUEKwjAQRe8y6xiStGmSuhIVBF2UIrgoXbQa2kBMpEahlN7dSBVmMfP/G141QdGa8/jQkMPRt6bU19C4zmpAUHjjwhPyalrWiKxohkki1iuOuWQC5vqPbYahGSMbg51p7jroAXKCCYKTdl3ovwdNKENQ+tAE4x3kFHNBhMoSlgmVyjgILua2wAmTFMFBm66P5gxLqWK9t/r9+1ZYpowj2Hrro8u9rJ3rD4o4rAzRAAAA",
    Pbi3DGeometry:
      "gwMAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzOz8lMUdJRCsjPzCspVrKKroYwgdIG1kCoVKuDENE1NDCwBhNArFQbC9PmWFSUWAnUq2topmdkYKija6pnamiuY6lnYWJkqqNraKpnYW5kiUfYzMTCmLA43HAcwiiGE1IMFgZyzY2NjNENIU2YQvehmowaVKSKE7CTYDzgMhstsIiVoFICwBLuZInjtxeYml0yE3NTS1KLlKwM9Ax0lHxS89JLMqCcoPySxJLM/DwoNzwzBS7lkZqZnlEC5bjmpJYhK3TOz8kvAuUmMABmGgBRIE1UgwMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2100",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "485508",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 2",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7yGm7q5dYoKgjqIBB3Ew6yhg7WFrUDE795ChHd47/F7vHqCsjXX8aVBwtm3ptL3oFxnNSAovXHhDbKeFhuRDWE4Sfk2wzQXAuZmpXbDoMaIxuJg1FMHPYBMcILgol0X+n8gKaEIKh9UMN6BJDjnCRcspYyLrIhCcDOPBU5pQRCctOn6eJxhTkjMR6u/61pgVuQI9t76+OU+1s7ND9hrLJHQAAAA",
    Pbi3DGeometry:
      "egMAAB+LCAAAAAAABACdk18LgjAQwL/LPa+xTWfNnqKCoB6igh6iB6WhA3NhI5DouzfN/mBJ4sbG7nf/4Ha3u8IyVJv8JMGHuQ7VWifqAAiWWqXmDP7u+nhaNRnaDTf0Jj1KyLC87IHb/uk2yrIgt7496mFGKHIxFS5DVGBvwFGNMhc7wqMf2GGcF5hx0W+Jf4f+or9ta4E5HvSZ6Mr/5Gww/hu7Vqp2vHXWBuuG/+mAu6Zsqku3VmlTRNvEExUcpZEZ+AQTBAuZRiauhJU2gVE6rcStOrxUM6mi2FTCNJGXT8OxTnRWDFG57KzcAT+rIPZ6AwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1473",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "485509",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 2",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1jUELgjAcxb/L/zzH5nRzdooKgjqIBB3Ew6qhg7WFrUDE795ChHd47/F7vGaC6mYu40tDCSd/M7W+B+U6qwFB5Y0LbyibabERSSjHhIlNQjDnNIO5XbHtMKgxsrHYG/XUQQ9QEkwQnLXrQv8PlNEUQe2DCsY7KCnOBRGSs5QLmRVRCK7mscAsLSiCozZdH58lJkIgOFj9XccS8yJHsPPWxyv3sXZufx2PfQ3QAAAA",
    Pbi3DGeometry:
      "gAMAAB+LCAAAAAAABACdk8kKwjAQQP9lzmlII+l6EhUEPYgKHsRDS0MN1EZqEET678Zad4NtExIybzaYzKzPMIvF8rTnEMBExmIhM5EAgpkUuTpAsD7fnlpNQr2hRE9i2YSE1aUPlJu7W78oopP2tWwHU2Iji2CXusj2seMx9EGph50e814x87WsuevQpvh37G9qMH4PzbDnUr8z/5fVZP4//Hu9mvEWaQ3mhl9qj7umNBWmY8M0qKJu5aGIdlzxAgKCCYIpz1O1rYW5VJESMq/FlUgeqjEX6VbVwijjx1fDgcxkcR2laumJuQCLBZZTgAMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2803",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "485679",
    Name: "Single-Flush: 800 x 2100",
    Category: "Doors",
    Level: "Level 2",
    Pbi2DGeometry: "zAAAAB+LCAAAAAAABAA1jUELwiAYhv/LdxZxzum0U1QQ1GGMoMPYwZVsgmksC8bYf8+obi8vz8PTzFB19jTdDSg4hM7W5hK1750BBFWwPj5ANfN3JiTHrGQrgQtGBCztn1mPo54SmI6t1TcTzQiKYILgaHwfB1A5zpjkCOoQdbTBg8pwIYiQPKdcSFbKAsHZXj8swRlnCPbG9kOKCpwVlCLYOfP6uRKXjCZhE1xIJf90bmnffy1n/swAAAA=",
    Pbi3DGeometry:
      "txEAAB+LCAAAAAAABACtl01Lw0AQhv/LnmNI0qbd1FOtgqAHUcFD6aFiaAO1kRoEkf530/RrM/vuZBaltDRvZp+ZzMeymf6oh9fi+fsjVyN1V74WT+WqeFOBeiiLdfWpRtOf/d/6dnRZf9Q2OCsXcRRdNj/1V21nx2XjzWb+Xa/thf00ToJBmCS6H8SDcNhLekFbzULdT9KjqEOd9sQaJp7VRA+t5Y1GfZsiWc5BeU8wUPdqoXsmox5JYVU+V+7iyers9oQqJW0ISTd1OOkokjvFBDkcZrurOE7TnWWW9fVRpctN0/Z6zpJArbQbABiUwBNmpmE2SDPq/6C2qdgUY/FjQSwtM6YOdJTZETQqa3vCdpsSLE2iCWhTPVxBqJUsU21TsSmk4qeCVNJYkInLygSF/bP9RlS2iXy88eXy7XgR1N0tXL8LYhIxmQ7E88qqktH0aHfYWR5blgja0ddovxTsoQJg5+yK92/e0HePwMPEqidsrLW2h6FRrRKZtm0Aa0qwNPsmAIYlcQWhVgZMtU3FppCKnwpSSbEhszm9WO7dBx3qqNOSQOXHbrknzLQSZaptKjbFWPxYECt7ccBVZeLCEbDdRlS2h3y88RXz7XcRVHr4d06AZFT+dvh3D694Iv/y0ue7T/37S597S2VjFQwPN73yzZu39N0m8DCx6h47C9R1MX/Pq3yjRlEYBeo+Xy+q5eHisazmVVGuD5cvxdvp1m1eLJbV4eJmlX+ZhpNyVdZAdT2ZXI3Hajv7BZeWLl63EQAA",
    "Analytic Construction": "<None>",
    Area: "3",
    "Assembly Code": "C1020",
    "Assembly Description": "Interior Doors",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    "Door Material": "Door - Panel",
    Family: "800 x 2100",
    "Family and Type": "800 x 2100",
    Function: "Interior",
    "Head Height": "2100",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2100",
    "Host Id": "Interior - Partition",
    Image: "<None>",
    Mark: "206A",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rough Height": "0",
    "Rough Width": "0",
    "Sill Height": "0",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "50",
    "Trim Projection Ext": "30",
    "Trim Projection Int": "30",
    "Trim Width": "80",
    Type: "800 x 2100",
    "Type Id": "800 x 2100",
    "Type Image": "<None>",
    "Type Mark": "3",
    "Visual Light Transmittance": "0",
    Volume: "0.11",
    "Wall Closure": "By host",
    Width: "800",
  },
  {
    ID: "488881",
    Name: "M_Skylight: 1180 x 1170mm",
    Category: "Windows",
    Level: "-1",
    Pbi2DGeometry:
      "1QAAAB+LCAAAAAAABAA1jc0KwjAQhN9lzzFk2/zYeBItCHooRfAgPbQaaiAmUqMgpe9uRIU57A7fzBxHqDq7f90MaNiGztbmFFvfOwMEqmB9vIM+jt8zISgpVwwXM0WRMQ5T88eWw9C+EpuMtW2vJpoBNKOMwM74Pl5A53TOZUGgDrGNNnjQSCXnSSLPleAZCixnKAgc7PkT4JShSu/G2P4SPwVKFEigdOb5a8gkTVkCq+BC2vMP56bmDXrjrWDVAAAA",
    Pbi3DGeometry:
      "GCYAAB+LCAAAAAAABACtmk1P3DAQhv9Lzmnk2I4/4FTRSpXaA2or9YA4gFhBJEqq7aoSQvz32kmgJPaMZ9IV4iPveue1k5lnxwkXT9X5df/98deuOqk+D9f9t+G+v6nq6nzoHw6/q5OLp+nP8LI4DV/Vc/1PedcKcTr+CN/V8+XL297v91eP4b2tbZTQvlaNdFbVMhzKTtetapxQBpJFY3Vraukbb8NvSJ5jAzIcW5ppdGfl25lYOY1u27cxyCoQeC3jkwZGM2e3WDfvLOVD509SSQUCMxIhH5p4pvFkYqcecBV5MjGtnZNBlkZ1UTYyTPRFlo2X2tbSNM60r2pcTRcXI4U1BVWEgMpNfsqX/IDRaej56srppEpjbUkOod288DZYII7AaNSyNeHUjxP0viRHy3Zcu+tMW7IERqexpZY6yjIsI8qdLsohttHj4t2CLWvH/GAssmycDNkWEscbU1BFo4weF95JKQt+wOAkMpK+eTXNSMAvF0OFGhSQusrevIoWEakMIbcXAC0SF5DhNKeXYclxmbeAXCosUhnCliacxnXmAjKY55wyxC1XyZtX0RKiVSFkh+QusYLybkjcdbW9yksa43K+ADhFmAaePySXKMblNNP5hQg7LlCMy2D+cyoxEzsmzYrGqJpJc34dQoZLHONyPv9ZVZhGxvM3KycpidQh2BlxGiZeHRGLcVPHRC4lTj1u6ph4tUQsyC0tE7WU6NW4pWPiVRKtGvGeiZjZYFIClrzNByNVj9EMlRz/5x5DcRtE25lr6ccJdl2tRCNMawuqapTVo5/qFOKXH4zadT5GCrKYLhcmh8jthPHWWlMwBAaDjtrO2e6cLsnh88THLLNhNbI8vdzgTGQbrmVIdi+n6rfhfBVkFZ3c+HnihEQcgcFAaCPMKHd2wtDUX2JyiN3FVIixtcIsgdFAbOFj/Wunpwka50pytIy0CGu3ssMsgdGopRFej5XknC/JoTy8H3nRemlKlsDoNDanCYDABTjyGglO33yUOzIlyyPc1CVSG7Q01pk16vIqhEUGsgt2S84BcomKFGiXHJegA+QSh0nUhi2VcAnpABnmIoPbsKW2LiEdIMNcZIAbtvReJ6QDZJiLDHCXLJekA+QSikngBi05tyRAeAGWrPsanFt4R9lgFS2P8XyNA+409ljbq2YPVRMy8qkN2i06PVwGwcjgNui46PRQFYQlB9tp6Ii5dZ+Hyxko8qmdiR0xt+7zcDkDRT61M7EjXNZ9Hi5noMinNmi5bPRwGWQlh9ppbPpzEZBbGLOpz1YYTxGPca9304ad/QybQuwte3Yiaxm43rJj58GWBuwtO3YOa2m43rJdp6OWjutNu3U6aRm43rRbp5OWgetNu3UeaYm4xrfrJPBBzMr4XdbVh/7q5+6w21cnoSeoqy+7h9vD3XzwdThcHfrhYT780d+8vvRp19/eHeaDj/e7P28Hng33wz7+i5dw4iz+J9dflXjYJhgmAAA=",
    "Analytic Construction": "1/8 in Pilkington single glazing",
    Area: "3",
    "Construction Type Id": "GSP4R",
    Cost: "0",
    "Define Thermal Properties by": "Schematic Type",
    "Design Option": "-1",
    Family: "1180 x 1170mm",
    "Family and Type": "1180 x 1170mm",
    "Frame Material": "SH_Aluminum, Anodized Black",
    "Glass Pane Material": "Glass",
    "Heat Transfer Coefficient (U)": "3.6886 /(·)",
    Height: "1170",
    "Host Id": "SG Metal Panels roof",
    Image: "<None>",
    Mark: "22",
    "Moves With Nearby Elements": "No",
    "OmniClass Number": "23.30.20.21.14",
    "OmniClass Title": "Roof Windows",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rough Height": "0",
    "Rough Width": "0",
    "Sash Material": "SH_Aluminum, Anodized Black",
    "Solar Heat Gain Coefficient": "0.78",
    "Thermal Resistance (R)": "0.2711 (·)/",
    Type: "1180 x 1170mm",
    "Type Id": "1180 x 1170mm",
    "Type Image": "<None>",
    "Type Mark": "33",
    "Visual Light Transmittance": "0.9",
    Volume: "0.04",
    Width: "1118",
  },
  {
    ID: "489062",
    Name: "M_Skylight: 1180 x 1170mm",
    Category: "Windows",
    Level: "-1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1zT0LwjAYBOD/8s4h5KNJkzqJCoIOpQgOpUPV0AZiIjUKpfS/m6Jux/EcV09QXuxpfBgo4BAutjLX2PrOGUBQBuvjE4p6+sZEGMGEcb0iWOZUw9z81XoY2jHRVGxtezfRDFAkjOBofBd7KDhWmdQIqhDbaINfGppRoZkUXCida6oQnO1twRkmNBcI9sZ2fVyoVJwj2Dnz/q0ZxVSrZDbBhXTmX87NzQeb/qB90QAAAA==",
    Pbi3DGeometry:
      "jycAAB+LCAAAAAAABACtml1rE0EUhv/LXsdlvj/qlagg6IWo4IV4UTFooDZSgyDif3d2N627O3u+xlCszdvJeYfd8z45mfTD7+71p8O7X9/33VX38vjp8PZ4c/jc7brXx8Pt6Ud39eH39GP5tXpcvro/u3/KI63U4/Fb+df9+Xj/tCd3d9e/ynN17nXKZvco9zaFsDOmNzrY4f+QlYf10Een3M64PgYDyQ/VARkpbnwel7u42Es0elyutF2UEelA+aVM7R1Y3bDH+SUQXjGoPHTJODpUX9QeUH3WpaeaTN6TwH2Vybx+Vz4NsolTEZuz+6fnXjlTnq77aJOe6zalNJRVOTlaD30wxo+2PkfaF1q/Uf/+dptJ137Vfpt6qZ9MGOsrnVFfaD3ha6KetsmQB1eXhurBzatDrtD6qrzxOo6yGbtP2+xJuRQPebwlPiePmULr0fKpz3bYpO6TzYbWQz80XqlucrK0K7C8rk7197Ze9ytgu1mmXIxYfsD0RXtDOiOGrNgivg/gmrc3pGNxkMSW4TtvcECmQ8jJLOJp0rq7t1U4CoK44oarvgZkMmS8rMKmVFdzQwbZ4vVXoZzpC5iTOpwOWVrr+vevvQuck3qdgra0Ir5zopM6GBBRWDeqm1QBnZDrNIizChrOSY6rQD5EUa0qUz29rdc9ikYVnrtk85g0YsyoNs9j/IiJoto8kUkjxoxq81DGT5kgq61DmSRqrLRS4xiz65Fu3TYVv/eR9PClhiuG738chXDeifHODVRw0ya9soOcXAq0nnsXp/La5IDZQuspX5/PNzFx9FK/bGC8KSGj+8TXw74uxjGYYUoaKperoKwdXgaymxqf2uX2+rq8Dm4MRPZm1L1xtF5imod7Xl6VQtSoLbQeqm/tWc+Tbg0pl+ojWkr1qCzqCq0HyqcRoS5FNyE0W0outVMhz3AFfMb3CCxHPYOKUy9Fpym59IayU29MVMEctxfXlUXTBEK4bVPpTCIayy91dsTwvcBJNQ/ysGfS3lc0hHSEnhLIM2wXMIR0BjxZkGf4znEIyDSyOYRHPENB5hqFkI6hU0B4zNYFs2YhICPkFOAd9ozZhQqGkI6wk093humCiJBOEpvDd8xUcj6CAA6yFR6ziA4bL/WejuN7mU8YRZivq0+5Xw2OpF4ztIn0iO18ciR1GKEy1MO+i9GR1EG6iki/UX3E4mp0JPUNjLbAfqP8SMbV9EjqNWBbYF9Xn3C0GiFJvWZpE+9h2/kUSckwY2XAr8tLPgDCGIsiX/BBkuRzVYSlIuY3nyI0fNzPYX7zMQKf1iLqNx8jSHHNxH7zQYIU10zsN58kCIAtAX/zWYKA2BLyN54n8IktIn/TmYIM1zzoEwcKTGhisK5NP+66Z4frb/vT/q67Ur3ada/2t19OX88P3hxP16fD8fb88P3h88OvXuwPX76ezg+e3+x/zhc+Pd4c74a/rFNJPR3+gO4vvONHX48nAAA=",
    "Analytic Construction": "1/8 in Pilkington single glazing",
    Area: "3",
    "Construction Type Id": "GSP4R",
    Cost: "0",
    "Define Thermal Properties by": "Schematic Type",
    "Design Option": "-1",
    Family: "1180 x 1170mm",
    "Family and Type": "1180 x 1170mm",
    "Frame Material": "SH_Aluminum, Anodized Black",
    "Glass Pane Material": "Glass",
    "Heat Transfer Coefficient (U)": "3.6886 /(·)",
    Height: "1170",
    "Host Id": "SG Metal Panels roof",
    Image: "<None>",
    Mark: "23",
    "Moves With Nearby Elements": "No",
    "OmniClass Number": "23.30.20.21.14",
    "OmniClass Title": "Roof Windows",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rough Height": "0",
    "Rough Width": "0",
    "Sash Material": "SH_Aluminum, Anodized Black",
    "Solar Heat Gain Coefficient": "0.78",
    "Thermal Resistance (R)": "0.2711 (·)/",
    Type: "1180 x 1170mm",
    "Type Id": "1180 x 1170mm",
    "Type Image": "<None>",
    "Type Mark": "33",
    "Visual Light Transmittance": "0.9",
    Volume: "0.04",
    Width: "1118",
  },
  {
    ID: "490318",
    Category: "Topography",
    "Cushion/Chair Back Material": "0",
    Description: "-1",
    "File Path": "0",
    Illuminance: "<None>",
    "Mass Floors": "Grass",
    "Moves With Nearby Elements": "0",
    Phase: "Working Drawings",
    "Phase Created": "None",
    Profile: "149",
    "Suppress Spaces": "149",
  },
  {
    ID: "493612",
    Name: "Basic Wall: CL_W1",
    Category: "Walls",
    Pbi2DGeometry:
      "FgEAAB+LCAAAAAAABAB9jk8LgkAUxL/LO6/L/jF17RQVBHWQCDqIB8VFF7bdsC0Q8bu3oBVEdHvzfsPM5ANklTr1Vwkp7G2lMqv7xhpAkFll3A3SfJhObwh4jBmnbBlQgkXEGYzoB2UERywUXzDBNBTJf/jJLV4DVl1X9n6Ff2xUeZFOdpASTBAcpGlcO4ujdaVTfvgkz6p+o51UTetrKMWLOGEItlo+ZnMQYsEoR7C22vpgc9d6LJ6zIU+xFgEAAA==",
    Pbi3DGeometry:
      "DwYAAB+LCAAAAAAABACdVN9rwyAQ/l98NuIZY370qWsLg+2hbIM9lD2kVFohiyOTQSn93+e2ZCsYGx0hIXff3X3e+enmhNZb9XR8k6hCd3qrHnWjdgijtVateUfV5vTza2E6sw864z9PApTOvj/2ReeXIW3edfXR5iZpTlgKDCcAhDMmcMJJySDFFwglGU3LMWTIoYQWeR6G+KqVBAoA128TaFkWLsAoAZGNrHgABOFC8GkGX7y/i1gGt4eCAP9yuBQ9wsA6OLMUIhtxO5W8wMjO+sm9ow2l9yx3cE/Mz7ul/jmFIAEjCTgG8ZL+zwocCU12E7PzEzr1t+JVsMser6Gpkx58cK+LMUpEkXeAvVmXqn6VRnaosqEY3ct2bw698aBNbZRue/NZ7X6hW6n2B9Mbq0Z+XAYudKNtQXSzXMB8ZS/wT2iepvAPBgAA",
    Absorptance: "0.1",
    Area: "25",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "-1500",
    "Coarse Scale Fill Color": "12632256",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "Yes",
    Family: "CL_W1",
    "Family and Type": "CL_W1",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0.7500 /(·)",
    Image: "<None>",
    Keynote: "F10",
    Length: "9628",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rebar Cover - Exterior Face": "Rebar Cover 1",
    "Rebar Cover - Interior Face": "Rebar Cover 1",
    "Rebar Cover - Other Faces": "Rebar Cover 1",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "Yes",
    "Structural Material": "CL Concrete_ panels",
    "Structural Usage": "Bearing",
    "Thermal Mass": "12.67 /",
    "Thermal Resistance (R)": "1.3333 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-1000",
    Type: "CL_W1",
    "Type Id": "CL_W1",
    "Type Image": "<None>",
    "Unconnected Height": "3500",
    Volume: "6.8",
    Width: "280",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Both",
  },
  {
    ID: "493697",
    Name: "Basic Wall: CL_W1",
    Category: "Walls",
    Pbi2DGeometry:
      "EgEAAB+LCAAAAAAABACFjk8LgkAUxL/LO6/L/lFz7RQVBHWQCDqIB6VFF7bdsC0Q8bu3oCadur15v2Fm8h6ySl26h4QUjrZSmdVdbQ0gyKwy7glp3o+nNwR8hWNBojUjmMZRDANaIKeYCfaHUUySkP2wJXSGxVy+aduy8wv8Y6fKu3SyhZRgguAkTe2aSZytK53yo0d5VbcvOkhVN76FUhwmTCDYa/mezEGIBaMcwdZq64PNS+uh+ABITOP1EgEAAA==",
    Pbi3DGeometry:
      "PwUAAB+LCAAAAAAABACVVE1rwzAM/S86O8ZfcdP01C8YbIeyDXYoO6TUtIYsHpkZlNL/PrOla2iqxMXERM/PerIke32E1ca+Hj4N5PDoNvbFlXYLBFbOVv4L8vXx7zcss0kYcCIXJOGMTX6n8MHp/bxtWtfFIexN5IgKyQURjHKdaqJpqvmIdPBE0bHgkkhOucx0B8ccYfxrHKGfYUG1lmnXyxU+RI8TvZwpo1yNMyI4ZZkSLb5SWg3BLdWbeMf9kG5fUTBlLPlIRIgAGuq9Cj2VuZXS6EwMViamq/qdxHb4AB0/Umw3RFQLiTQy+QNFweC77mJ4iRa2+DDe1JAzygg8mWrn943x7Hzhrasa881u/5cejN3tfWMsS/PdJs5d6YJDmC3mfLoMD94PxkMlOT8FAAA=",
    Absorptance: "0.1",
    Area: "75",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "-1500",
    "Coarse Scale Fill Color": "12632256",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "Yes",
    Family: "CL_W1",
    "Family and Type": "CL_W1",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0.7500 /(·)",
    Image: "<None>",
    Keynote: "F10",
    Length: "21026",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rebar Cover - Exterior Face": "Rebar Cover 1",
    "Rebar Cover - Interior Face": "Rebar Cover 1",
    "Rebar Cover - Other Faces": "Rebar Cover 1",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "Yes",
    "Structural Material": "CL Concrete_ panels",
    "Structural Usage": "Bearing",
    "Thermal Mass": "12.67 /",
    "Thermal Resistance (R)": "1.3333 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-1000",
    Type: "CL_W1",
    "Type Id": "CL_W1",
    "Type Image": "<None>",
    "Unconnected Height": "3500",
    Volume: "20.83",
    Width: "280",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Both",
  },
  {
    ID: "493790",
    Name: "Basic Wall: CL_W1",
    Category: "Walls",
    Pbi2DGeometry:
      "DgEAAB+LCAAAAAAABABVjksLwjAQhP/LnuOSZ5O2J1FB0EMRwUPxUDHUQGykRqFI/7sBX3jb2W92Z+oHVAe3HS4WCliFg6uCH9rQAYEquC5eoagfrzEZWIZUcFZSlFRxGMkPKY1ca1FOBEXNRfYHjUadmzJHzZT5IzJDpbgpJUUjZbraf4Knfd8MKT0t5q4522h7KChSAmvbtfH0FpsQm+hS4ZfcueMXLa1rTymEMZSG5wQW3t7f5onEnDNBYBZ8SI+7m/fj/gnn9qWBDgEAAA==",
    Pbi3DGeometry:
      "OQUAAB+LCAAAAAAABACdVFtrwjAU/i/nOYacxKa2PjkVBtuDbIM9yB4qBg3URrowEPG/L7jaSbuQdISGnu9cvuRcsj7DaqPfTkcFOTyZjX41pd4CgZXRlf2EfH3++XVqNnULLuQXGSFj0+vmPrh83NxmdV2cnK9AimIiCWcUZSKJpInElHTh0ZhmHAVJHc4FEheRMsRJq/DE8dr3FD6HG87pmKfiimfZ3YE6eMg8lra9F6dSiqR3L0GzhPMebQduaT14N3qINfaU/+WNLm/QwZuJoYX5O9EDyxLZVAFzD2nkCAWCRHZCqCC+OfSlPbJhA/kdNITuDVro4qCsqiF3GSbwrKqd3TfCi7GF1aZqxHe9bVWPSu/2thGWpfq6N5yb0riA8LCY42zpnrpvCxv0KjkFAAA=",
    Absorptance: "0.1",
    Area: "55",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "-1500",
    "Coarse Scale Fill Color": "12632256",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "Yes",
    Family: "CL_W1",
    "Family and Type": "CL_W1",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0.7500 /(·)",
    Image: "<None>",
    Keynote: "F10",
    Length: "15750",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rebar Cover - Exterior Face": "Rebar Cover 1",
    "Rebar Cover - Interior Face": "Rebar Cover 1",
    "Rebar Cover - Other Faces": "Rebar Cover 1",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "Yes",
    "Structural Material": "CL Concrete_ panels",
    "Structural Usage": "Bearing",
    "Thermal Mass": "12.67 /",
    "Thermal Resistance (R)": "1.3333 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-1000",
    Type: "CL_W1",
    "Type Id": "CL_W1",
    "Type Image": "<None>",
    "Unconnected Height": "3500",
    Volume: "15.45",
    Width: "280",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Both",
  },
  {
    ID: "493879",
    Name: "Basic Wall: Foundation - 300mm Concrete",
    Category: "Walls",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACFjksLwjAQhP/LntPQ9GGaehIVBD0UETyUHloM7UJMpEahlP53g62vk7ed/YaZyXvIKjx0FwkpbE2FmVFdbTQQyAxqe4U078fTGXhA45Dzucd86jOWwEA+MAopS+L4PxRi9sO+U5+seJUv2rbs3AL3WGF5lla2kLp0Ajupa9tMYm9sadGNHuURT2+0kVg3roQxGiWBILBW8j6ZvYiKgIUElkYZF6xvSg3FA+WXvVUSAQAA",
    Pbi3DGeometry:
      "WwYAAB+LCAAAAAAABAClVV1rgzAU/S/3OQ35UKP2aXSFwfZQtsEeyh4sDW3AmeLCoJT+92WbrjK9NjKCYs49NzlJzo3rE6w25vl40JDDvd2YJ1uaLRBYWVO5d8jXp59PH2Zz3+BMLsiMMzb/fvkHzq9t2k1dF0efqzjlQnLiKZRxnpKExglXpIfPIpoJLkkkacyTtBOQNJMKxfGBBE3jaCCASQqeueX3JhhXigrqJmRZMsQfg8dHUYJGQske/S/engtCD9U4TczAzne1YEeLisTUBODjFkHdeWUFYZuMrRcz5hX+xKNFcXT7pxYQViiBBu+XFQKHVVuoSYJF/qvIh40T4rOpd9dlVn9L35riTTtdQ+4TCDzoauf2TefRusIZWzXdF7P9Dd1ps9u7prMs9UeXuLCl9QPCgn01/zP4BO8PDeRbBgAA",
    Absorptance: "0.1",
    Area: "31",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "-1500",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "Concrete",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "Yes",
    Family: "Foundation - 300mm Concrete",
    "Family and Type": "Foundation - 300mm Concrete",
    Function: "Foundation",
    "Heat Transfer Coefficient (U)": "3.4867 /(·)",
    Image: "<None>",
    Length: "8947",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rebar Cover - Exterior Face": "Rebar Cover 1",
    "Rebar Cover - Interior Face": "Rebar Cover 1",
    "Rebar Cover - Other Faces": "Rebar Cover 1",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "Yes",
    "Structural Material": "Concrete, Cast In Situ",
    "Structural Usage": "Bearing",
    "Thermal Mass": "42.12 /",
    "Thermal Resistance (R)": "0.2868 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-1000",
    Type: "Foundation - 300mm Concrete",
    "Type Id": "Foundation - 300mm Concrete",
    "Type Image": "<None>",
    "Unconnected Height": "3500",
    Volume: "9.06",
    Width: "300",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "495352",
    Name: "Floor: Concrete-Domestic 425mm",
    Category: "Floors",
    Level: "Level 1",
    "Aalto Vase Material": "0.1",
    "Architrave Offset": "38",
    "Coarse Poche Material": "0",
    "Coarse Scale Fill Color": "-1",
    "Cooling Set Point": "225",
    CosAng: "0",
    "Default Elevation": "425",
    Description: "-1",
    Elevation: "-425",
    "Elevation at Bottom": "-225",
    "Elevation at Bottom Core": "-425",
    "Elevation at Bottom Survey": "0",
    "Elevation at Top": "0",
    "Elevation at Top Core": "0",
    "Emit from Line Length": "Yes",
    "Facucent Drilling": "Concrete-Domestic 425mm",
    Family: "Concrete-Domestic 425mm",
    "Full Step Arrow": "Interior",
    "Heat Load Values": "0.6084 /(·)",
    "Height 1": "0",
    Illuminance: "<None>",
    "Parts Visibility": "24820",
    Phase: "Working Drawings",
    "Phase Created": "None",
    "Rebar Cover": "Rebar Cover 1",
    "Rebar Cover - Interior Face": "Rebar Cover 1",
    "Rebar Cover - Other Faces": "Rebar Cover 1",
    "Referencing Sheet": "No",
    Rim: "Yes",
    "Rough Width": "1",
    "Slab Thickness": "0.00°",
    "Story Above": "Yes",
    Structural: "Concrete, Cast In Situ",
    "Text Type": "31.74 /",
    "Thermal Mass": "1.6437 (·)/",
    "Thermal Resistance (R)": "425",
    "Tumble Dryer": "Concrete-Domestic 425mm",
    "Type Comments": "Concrete-Domestic 425mm",
    "Type Id": "<None>",
    Voltage: "16.35",
  },
  {
    ID: "497540",
    Name: "Basic Wall: Interior - Partition",
    Category: "Walls",
    Pbi2DGeometry: "CQEAAB+LCAAAAAAABAB9jk8LgkAUxL/LO6/Luq75p1NUENRBIuggHhQXXdh2w7ZAxO/eA7Xo0u3N+w0zkw+QVerS3yWkcLSVyqzuG2uAQGaVcQ9I82E60eAJGnKfrz1GWcRiGMmXBVTE4g9hNOA8+QFL3IKKpXTTdWWPzfjYqfImnewgxWQCJ2ka187ibF3pFI6d5FXVH3SQqmmxw0+oH60CAnstX7M5obHgIYGt1RZzzVPrsXgDnnpJhwkBAAA=",
    Pbi3DGeometry:
      "HwYAAB+LCAAAAAAABACVVE1rwzAM/S86O8ZxvMZJT2MfDLZD2QY7lB1SalpDFo/MDErpf5+7JV2aJraCyYeen58lS/JyD4uVft19Ksjh0az0iyn1GggsjK7sF+TL/d+vm2ZzN+BA/pEoZmz++3IPHN7bZdd1Xezc2kjQhAtBIkZZyiTJqBT86mjKOMku4B6bZ5TFUl7QTziSH9iVUcEZD7E74kP0hHKZhtBWYwTuSwe2RMLYU2TuwzPCJZ2xbNb66EXPozwHe7LDaCuLLAi/9MhxDJKnuIyrDz/bd25TKskXBSpzgVIMdeJI+jC5xuUU2xP+cPz+darOp40UmXppjbUnrjMaurtpb3XxoayqIXdTBJ5UtbHbxng2trDaVI35ptenqQelN1vbGHel+u4Sb0xpnCCk98fhLvQfitHZUh8GAAA=",
    Absorptance: "0.1",
    Area: "14",
    "Assembly Code": "C1010145",
    "Assembly Description": "Partitions - Drywall w/ Metal Stud",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Coarse Scale Fill Color": "8421504",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Interior - Partition",
    "Family and Type": "Interior - Partition",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Length: "2440",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Wood - Stud Layer",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Line",
    "Top Extension Distance": "0",
    "Top is Attached": "Yes",
    "Top Offset": "0",
    Type: "Interior - Partition",
    "Type Id": "Interior - Partition",
    "Type Image": "<None>",
    "Unconnected Height": "3000",
    Volume: "1.61",
    Width: "120",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "498006",
    Name: "Single Window: Standard",
    Category: "Windows",
    Level: "Level 2",
    Pbi2DGeometry: "zgAAAB+LCAAAAAAABAA1jcsKwjAURP/lrkNI0qZ5uBIVBF2UIrgoXbQa2kBMpEahlP67EXU3M5zh1DOUnT1NdwMaDqGzlbnE1vfOAIIyWB8foOv5GxNCORZSsJXCnDIOS/On1uPYTglNw9a2NxPNCJpgguBofB8H0DlWjGYIqhDbaIMHnWGaU65YwTMulVAIzvb6QQnOCpLq3th+SFqJpaIUwc6Z1++rsCRKINgEF5LJP51bmjecn8OqzgAAAA==",
    Pbi3DGeometry:
      "IyMAAB+LCAAAAAAABAClmk1r20AQhv+Lzq5YafWxSk4lLRTaQ2gLPYQcEmISgRsV1xRCyH+vJEuytXpndkYhJI4fj9+d2fnYNfjmNbq+r3++/NlGF9HX5r7+0ezqh2gTXTf18+FvdHHzevy3fdlctj/R2+ZEPiTGXPZ/2t/o7XZ828f9/u6lfW/i4jQr3aaKjUvL9sHlrtqcqHVZTtLKuCRIB11Mj7o2tmmR+wo+9WyxAkuxroiyUYioZjUcsWbXWYp1RTvJ1oOIvj9vuFJXUFGOi8QWPU2KGc3s0jZ3Saamni5eDdHK5n1stkyCnlVZ2lFnqhLQLM3X6kJbje5IsWc9nTJE0HPdhW3vw0RnUQRsCV12NezZnM6yOdFZlQT8pWxZ3RnFUWAFzZ7hKtFQIhcsxVXiVd8Kqqk+xlbYhR7FuizFlcroCqmkA3Dt8D0voVRNymtdM1MxxboBijuW1pVS0SQITo1VZxbW9Wie2u6t/emfmDgx+YK6OLPO+teKFpfGuO7R5InUmJCea2A3JupdbuZDxl8OGyNh6MP8erQuZmxMKGOPF7e0ga71GNr6sn1V+btzhIsgRuxlWWSNpT0N6IYfxtAH3p75q2FjoItdmHfoypgJa0Ib++yPCq+4VzgNjQP7SSoLGnIZIIFlKeSNdSvi9hPsf8A5QVsHJhzjA5EUobBqoMrqiChy4niRYLY1VV0sOPn4k0ExJRlT+Ur4yGSnJm/MC+uy47vRFdEpDmOK4kRTVyQUdXFuizJERycQPekOrmWdR5q0S2POjtuF6CRcpIk7Czk1rc0JD7aIutjaqgrScX8gHpVdnGRVttihCXMJkVFC2MfHyjrfIdXNj6VI9ZyVcZXPIjjuzYSZXAgpIczmYqxhLxcEDmQulGd/ybNN0swEybAiszFKetszVvA8HZjyqQvl2e8YbqKwyZBiblj5uRANfkKX+GTF5l5y1hK+6UqNHQiiNsd50gRNznOcEehy4KzR+wxt8RkWOJc0xzlsSbyapPfGbiJk0QnGDwXmCOS7Xzx/2CNCNPVxasSxUgc7kkXO8hcOta/YFt9j+LuJZIQvKHuPCViHTlr/ysLfkebWhLbOwXcd7qO1bquo65omdvL2iqQJr6l7/HqnsfFC2docDQsWL9I4x542gZfzydoS9UGPl0NmBSa0A5gQkUUZ2Cpd8CFr3ZJsGgIbG3JQVFVEQehyGbLWLUnk8nzJ2030qb77vT1s99FF23ub6Nv2+fHwNDz53hzuDnXzPDz9VT9ML33Z1o9Ph+HJ593237nhVbNr9t23XYwzV92XWv4DgIwnwCMjAAA=",
    "Analytic Construction": "<None>",
    Area: "6",
    "Bottom Hung Casement": "No",
    Casement: "SH_Aluminum, Anodized Black",
    "Casement Depth": "60",
    "Casement Pivot": "No",
    "Casement Swing in Plan": "No",
    "Casement Width": "60",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    Description: "Single Window Unit - Triple Glazed",
    "Design Option": "-1",
    Family: "Standard",
    "Family and Type": "Standard",
    Frame: "SH_Aluminum, Anodized Black",
    "Frame Depth": "60",
    "Frame Depth over": "80",
    "Frame Depth under": "80",
    "Frame Width": "60",
    Glass: "<By Category>",
    "Head Height": "2700",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2700",
    "Host Id": "SIP 202mm Wall - conc clad",
    Image: "<None>",
    "Install Depth (from outside)": "80",
    Mark: "24",
    Operation: "SinglePanel",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rough Height": "2700",
    "Rough Width": "1500",
    "Sill Height": "0",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Hung Casement": "Yes",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Type Mark": "46",
    "Visual Light Transmittance": "0",
    Volume: "0.15",
    "Wall Closure": "By host",
    Width: "1500",
    "Window Cill Exterior": "SH_Aluminum, Anodized Black",
    "Window Cill Interior": "Wood_Walnut black",
  },
  {
    ID: "499496",
    Name: "Walvit_Hung Bowl_604118 W: Walvit",
    Category: "Generic Models",
    Level: "Level 2",
    Pbi2DGeometry: "vAAAAB+LCAAAAAAABAA9jcsKwjAURP/lrtPQ1PQVV6KCoIuigovSRYuXJhCTEqNQSv/dgNXdPA4z9QRVp67jgCDgaDt1GSQ6BAKVVcY/QdTTV4Y+SmhWrLJ1xGjKOIe5+WEb59oxsCHYqfaBHh0IRlnBEwInNL2XIGIaEzhb33plzWJv6v6vDqh6GX4SmvO0ILDX+F7YkpY5ywlsrbZh2by0npsP7GFX/LwAAAA=",
    Pbi3DGeometry:
      "DwgAAB+LCAAAAAAABADtlEELgjAUx7/LO8+xLbJmp6igQweJoEN0MBo5MBe2Aom+e6PMQlnTcyJT38///vrm3tvcINzJVX4SEKSXJEEQKpnqMwSb2+sWAiAjc8AdfYhHCRk9T2bAffueNs6yKDdzPYZ9znxkrpT4fcQxH9AB8gge0h63YoI5Y70SO0ws6gp2vLLAlGGD+zXzGv/9LTYbR0YVXLpUUqpxi41N3m7BfmOXeUO5K6WWf6+Zi03u5G03jcun2eKY6prK6Ci0yCAgmCBYiPSg4yJYKh1pqdIiXMt9+Wgu5CHWRTBLxPVbOFGJyl5V/yztrg10baBrA3/dBrYP0f4D/Q8IAAA=",
    Area: "1",
    "Bowl Height": "406",
    "Button Height": "813",
    Cost: "0",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "Walvit",
    "Family and Type": "Walvit",
    Host: "Floor : Generic 300",
    "Host Id": "-1",
    Image: "<None>",
    Manufacturer: "Caroma",
    Model: "Walvit Round Front Plus",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Porcelain: "Porcelain",
    "Silver Button": "Steel buttons",
    Type: "Walvit",
    "Type Id": "Walvit",
    "Type Image": "<None>",
    URL: "http://www.caromausa.com/Walvit-RFP",
    Volume: "0.02",
  },
  {
    ID: "503701",
    Name: "Elev./Sec./Det. - A104",
    Category: "Sheets",
    "Apparent Load Phase C": "Yes",
    "Appears In Sheet List": "Approver",
    "Centerline Tick Mark": "JLH",
    "Current Revision Description": "No",
    Department: "Independent",
    Description: "-1",
    "Design Option": "Designer",
    "Draw Layer": "SM",
    "Facucent Drilling": "Sheet",
    Family: "Sheet: Sheet",
    "Feed Through Lugs Current Phase C": "C:\\Program Files\\Autodesk\\Revit 2021\\Samples\\rac_basic_sample_project.rvt",
    "Ground Bus": "<None>",
    "Nominal Width": "Elev./Sec./Det.",
    "Sash Material": "As indicated",
    "Sheet Height": "7/30/12",
    "Sheet Issue Date": "Elev./Sec./Det.",
    "Sheet Name": "A104",
    "Tumble Dryer": "Sheet",
    "Type Comments": "Sheet",
    "View Scale": "None",
  },
  {
    ID: "503705",
    Name: "A1 metric: A1 metric",
    Category: "Title Blocks",
    Level: "-1",
    Pbi2DGeometry: "qgAAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygxKTS5JzEvPSVXSUQrIz8wrKVayiq6GMIFKDKwNlGpjYVKORUWJlUB5oIBLZmJuaklqkZKVgZ6BjpJPal56SQaUE5RfkliSmZ8H5YZnpsClPFIz0zNKoBzXnNQyZIXO+Tn5QAPzSnNyamMB1gT9gKoAAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Approved By": "Approver",
    Area: "0",
    "Checked By": "JLH",
    "Date/Time Stamp": "7/30/12",
    "Design Option": "-1",
    "Designed By": "Designer",
    "Drawn By": "SM",
    Family: "A1 metric",
    "Family and Type": "A1 metric",
    "File Path": "C:\\Program Files\\Autodesk\\Revit 2021\\Samples\\rac_basic_sample_project.rvt",
    "Host Id": "-1",
    Scale: "As indicated",
    "Sheet Height": "594",
    "Sheet Issue Date": "7/30/12",
    "Sheet Name": "Elev./Sec./Det.",
    "Sheet Number": "A104",
    "Sheet Width": "840",
    Type: "A1 metric",
    "Type Id": "A1 metric",
    Volume: "0",
  },
  {
    ID: "505974",
    Name: "Pocket_Slider_Door_5851: 2.027 x 0.945",
    Category: "Doors",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7zG3HRz6xQVBHUQCTqIB62hg7WFrUDE796kuj3e+z1+1QRFa87jQ4OCo29Nqa+hcZ3VgKDwxoUnqGr6xoisUpzRhK5XHPNMJDDXf2wzDM0Y2VjsTHPXQQ+gCCYITtp1oQfFcEJIiqD0oQnGO1AJzgQRkjPKhUxzmTMEF3NbYIKZZALBQZuuj+bFR+K8t/r9e0ucpzRDsPXWR5d7WTvXH0eD+8DRAAAA",
    Pbi3DGeometry:
      "mRYAAB+LCAAAAAAABACtV01r20AQ/S97lsXqW3JOrhMotIfQFnoIPjhEJALXCq4ohOD/XlWWKu3Hm51NQkiInp/fvJ2dnVndvYrb++bHy3Mt1uJLe998bw/NgwjEbdscu99iffd6+bf/WF71P+IczMgqkvJq+NP/ivNu+trmdNq/9N9dpWESp2mwKsNYFklQhWUaZ0EPp2kxwLLqn2d4Yssij/hsTbuIyogKqWr7hcyqzIKCiBOsSQO2XRr4ANKThh0lch3lYZJHVFZBni5wFsZJGZsqI27SI5lXbJXRS4+nVVy+1ztbHrocYAvdzz3Oma6vVK5Fn8T5lU7AC3EW7qxfBf6nUpArdalQdF19zi+CWSs1ZJanzLIiAn5j17EHpFuAtpS3CNu5NmEzpTpsWgbmeGRDWWmTFmkCdjVVR3PXpS+4eeYnXGs1Cp2rzp00Lo96/3mPd7Y8PcYtdD/3OGdotqC4JO7MvWNC6eJpUsW4Nxn1jiaI/XTQ88azT5p0YB0MVxbdPaMVGbd6LhMrjorJL5FUU8LHDBwnnY6sg9bLpVs8zl6QiIIDuglbm5svzAvJuXeyi4jHdtyA9e6oiCPc6cUzqLITHtOKt0Vgn1FQV3GR5tlRmRXt2g7E92tH1KYyzKAXAPqFwUMH+UGTgOR/nL61h9lviu4pxoDJu/CMokIFt03ycooXqbF9jzDNZ7vxPcSsyx/jFsZ6ZUdDdTmay7wc/MtiedUf0DKMqjhH8DI3JH4RB/Di0GdZbhNRcJ1uF6FQpMzGyeVwYd+gYPm+W+HAgTwvvXS1MOEP2E97Lfuj9MbvAnHd7H/VXX0SaxnKQHytj4/d0/jwre32XdMex8efzcP/jz7XzeNTNz7cHOo/S+K2PbS9oLjebj9tNuK8+wuYUCb3mRYAAA==",
    "Analytic Construction": "<None>",
    "Architrave Offset": "5",
    Area: "4",
    "Assembly Code": "C1020",
    "Assembly Description": "Interior Doors",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    Description: "Internal Single Pocket Slider",
    "Design Option": "-1",
    "Door Ironmongery": "Door - Handle",
    "Door Material": "Door - Panel",
    "Door Panel Width": "910",
    Family: "2.027 x 0.945",
    "Family and Type": "2.027 x 0.945",
    "Frame Thickness": "40",
    Function: "Interior",
    "Handle position - X": "125",
    "Handle position - Z": "700",
    "Head Height": "2027",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2027",
    "Host Id": "Interior - Partition",
    Image: "<None>",
    "Jamb Pocket": "50",
    "Jamb Rebate": "45",
    Mark: "207",
    "Open dist Elevation 3D": "2",
    "Open dist Plan 2D": "600",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rough Height": "35",
    "Rough Width": "0",
    "Sill Height": "0",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "40",
    Type: "2.027 x 0.945",
    "Type Id": "2.027 x 0.945",
    "Type Image": "<None>",
    "Type Mark": "51",
    "Vis - Architrave": "No",
    "Visual Light Transmittance": "0",
    Volume: "0.09",
    "Wall Closure": "By host",
    Width: "945",
  },
  {
    ID: "506168",
    Name: "wardrobe1: wardrobe",
    Category: "Furniture Systems",
    Level: "-1",
    Pbi2DGeometry: "ugAAAB+LCAAAAAAABAA1jcEKwjAQRP9lzyHUxto0nkQFQQ+lCB5KD6ku6UJMpEahlP67Eettmfdmth6hbOk8PBAUHH1LFV6DdsYiMCg9ufAEVY+/Myo5T6XI1glMzZ9v+l4PUYrBjvQdA/agEp4wOKEzoQO14MVKZgwqH3Qg72Z8oduXCl6InMEByXTxheQyk4LB3uJ7tgsul2nsb731cdu9rJ2aD3xCG0e6AAAA",
    Pbi3DGeometry:
      "ywMAAB+LCAAAAAAABAClk98LgjAQx/+Xe15jzsJpT1FBUA9SQQ/Sg9HQgbmwEUT4v7dq/ZjIMJpMvM9235t3u+QK8U6sL0cOEczlTqxkIfaAIJaiVCeIkuvzUy+ToX6gRh/S8wgZPl56Qr19uY2qKr1oXw/7HgtQH9NBGCKP4YAQhgwl2Kf0Q31MWUB/ou26DWorhJj16aBxBBsafxe049vQ1mw/aat/9/DOH+2UFJds90w1qvJLtVtlXRl0wf8vVoe6uqAzlO6KiUgPXPEKIoIJggUvM5UbYylVqoQsjbkR+/fSjIssV8aYFvz8vXEsC1ndu/IxdPPdALfggtjLAwAA",
    Area: "1",
    Cost: "0",
    "Design Option": "-1",
    Family: "wardrobe",
    "Family and Type": "wardrobe",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "wardrobe",
    "Type Id": "wardrobe",
    "Type Image": "<None>",
    Volume: "1.94",
  },
  {
    ID: "506386",
    Name: "Basic Wall: Interior - Partition",
    Category: "Walls",
    Pbi2DGeometry: "DAEAAB+LCAAAAAAABACFjkELgkAUhP/LO6+L67qr2SkqCOogEXQQD0aLLmz7wrZAxP/egpZ06vbmfcPMFD3kF33q7goy2ONF52i6Gi0QyFFb94Cs6MfTGxjlgollwGkYcQkDmVEQUZGKvyxmCf9hc+SIyk/xqm2rzrf7x0ZXN+VUC1lIQwIHZWvXTOKIrnLaDx7lWV+/aKd03fgOJmkiJYGtUa/Ju6BpHAkCazToY+3TmKF8A0tRE14MAQAA",
    Pbi3DGeometry:
      "NQYAAB+LCAAAAAAABACdVMlqwzAQ/Zc5O0KSl8jOKXSh0B5CW+gh9OAQkQhcq7iiEEL+vUrruEa2lhhho3l6epoZjWZ9hNVGvB4+ORTwKDfiRVZiCxGspKjVFxTr499UL+OFHnCK/pEZwXjx+9MfnN4v25ZNUx70XoLilKTRLEaYxlmUI5ZQbWKUUExN2CDTDGWYDdkXPJDuPlPDjMS5j90TH6VTlLJ0GKcBdyo23FD3nRoGh+cxIfP4DFOas76TTnwYax82xMfREemQOC2O+IprstdhZeupN6vT0+rKFcwVN+ksT/fztNxl0MU7Mzi5HVj8sMXocrtLla0f+FNo6lz1Nq38cX3df29F+cEVb6DACEfwxOud2rfGs1SlErJuzTex7ZYeuNjtVWvcVfy7T7yRldSCML8/D93mfwBfgD/BNQYAAA==",
    Absorptance: "0.1",
    Area: "6",
    "Assembly Code": "C1010145",
    "Assembly Description": "Partitions - Drywall w/ Metal Stud",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Coarse Scale Fill Color": "8421504",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Interior - Partition",
    "Family and Type": "Interior - Partition",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Length: "1200",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Wood - Stud Layer",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Line",
    "Top Extension Distance": "0",
    "Top is Attached": "Yes",
    "Top Offset": "0",
    Type: "Interior - Partition",
    "Type Id": "Interior - Partition",
    "Type Image": "<None>",
    "Unconnected Height": "3000",
    Volume: "0.73",
    Width: "120",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "506797",
    Name: "Basic Wall: Interior - Partition",
    Category: "Walls",
    Pbi2DGeometry: "CwEAAB+LCAAAAAAABAB9jkELgkAQhf/LnLdlXTVcO0UFQR0kgg7iQWnRgW0nbAtE/O8taB4Kus2b7/Hey3vIKjx3dw0pHKjCjExXkwUGGaF1D0jzfjy9YSF4JIVcLUIupYhhYL9M8EAuv0kShOoPmfOKT+26bcvOd/vHFsubdrqFVHDB4Kht7ZpJnMiVDv3cUV7wOqO9xrrxJYHioVIJg53Rr8mseBLJmMGGDPlc+zRmKN6ej+xnCwEAAA==",
    Pbi3DGeometry:
      "MwUAAB+LCAAAAAAABACVVN9rwjAQ/l/uOQ3XtNa0Psk2GbgH2QZ7kD1UDBroGumCIOL/vsx1s6vNDwktve++fHe9u2R5hMVKvh52AgqYq5V8UZVcA4GFkrX+hGJ5/Pk0bpyYBSdyQaIYcXJ+mQdO77/bpk1THszeCGnKkJEoociSjLCMZshHpI/nlKesAyPFMfIr2KbS0llOMea8izM+OuMsZYmf79G/pMPjJB+S+Yf36dfqbhk7v/9XQfqWdCw19rKd2pb+udvqZYeEtDVjYDacuH/03EUPLaOzAvZ5HJ6AWyfDcyoD4tpq6etJaP63xDW3z70sP4QWDRTGReBJ1Bu9bY1npUstVd2ab3L953oUcrPVrfFQiX2XeKcqZQRhPPte5pL7AlMue9YzBQAA",
    Absorptance: "0.1",
    Area: "5",
    "Assembly Code": "C1010145",
    "Assembly Description": "Partitions - Drywall w/ Metal Stud",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Coarse Scale Fill Color": "8421504",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Interior - Partition",
    "Family and Type": "Interior - Partition",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Length: "1020",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Wood - Stud Layer",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Line",
    "Top Extension Distance": "0",
    "Top is Attached": "Yes",
    "Top Offset": "0",
    Type: "Interior - Partition",
    "Type Id": "Interior - Partition",
    "Type Image": "<None>",
    "Unconnected Height": "3000",
    Volume: "0.6",
    Width: "120",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "511122",
    Name: "Level: 8mm Head",
    Category: "Levels",
    "Branch Circuit Current Phase C": "Yes",
    "Cold Water Radius": "0",
    Comments: "0",
    Description: "-1",
    "Electrical Data": "-800",
    "Elevation at Top Survey": "Project Base Point",
    "Facucent Drilling": "8mm Head",
    Family: "8mm Head",
    "Limit Offset": "Dash - Tight",
    "Line Style": "1",
    "Schedule Level": "None",
    "Start Symbol Type": "Default",
    "Story Above": "No",
    "Switch ID": "M_Level Head - Circle",
    Symbol: "No",
    "Symbol at End 1 Default": "Yes",
    "Tumble Dryer": "8mm Head",
    "Type Comments": "8mm Head",
  },
  {
    ID: "512277",
    Name: "M_Pile Cap-600 Pile: 600 x 600 x 900mm",
    Category: "Structural Foundations",
    Level: "Foundation",
    Pbi2DGeometry: "xQAAAB+LCAAAAAAABABNjcsKwjAURP/lrmNIGvpIXIkKgi5KEVyULlK9tIGYSI1CKf13A1ZwN8w5zNQTlK05jw8EBUffmgqvQbvOIhAovXHhCaqevjEqQlDGebZeCUZ5IWFuftpmGPQY3VjsjL5jwAEUo4zACV0XelCcyqxICVQ+6GC8W/DF3P7pAU3Xx6uE0SxPJYG9xffirxJBE8lyAltvfdx3L2vn5gMNnifMxQAAAA==",
    Pbi3DGeometry:
      "SQQAAB+LCAAAAAAABACtk98LwiAQx/+XezbxR7VcT1FBUA9RQQ/Rw0ZSwpqxJIjof89qrciGLUIUz4/e9zzPxQnGsZoddxJCGOpYTXWiVoBgrFVq9hAuTvepxaRtG5zRc6VGCWnfBtvhvHwc62RZdLRnOcOEBRzVmMCM1AM7wU1ab6ECcIppwNkTcCxEo/ULKNVwgOOK44YQ9ENU76Bw5QVOVO/A0Si9R6mr6lF5U/J9Er0a1bPrPG318inV8KbdD/5Yu19XiR94xO2f7KloK43MICSYIBjJdG02uTHRJjJKp7k5V6sCDaRab0xu9BN5eN3Y1Ym2DqFLrs1+/Qt/4qKjSQQAAA==",
    Area: "0",
    "Assembly Code": "A1010130",
    "Assembly Description": "Pile Caps",
    Cost: "0",
    "Cut-off": "150",
    "Design Option": "-1",
    "Elevation at Bottom": "-7099",
    "Elevation at Bottom Survey": "-7099",
    "Elevation at Top": "-797",
    "Elevation at Top Survey": "-797",
    "Enable Analytical Model": "Yes",
    Family: "600 x 600 x 900mm",
    "Family and Type": "600 x 600 x 900mm",
    "Height Offset From Level": "-797",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    Length: "600",
    "Moves With Grids": "Yes",
    "OmniClass Number": "23.25.05.11",
    "OmniClass Title": "Foundation Piles",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Pile Type": "600mm Diameter",
    "Rebar Cover - Bottom Face": "Rebar Cover 1",
    "Rebar Cover - Other Faces": "Rebar Cover 1",
    "Rebar Cover - Top Face": "Rebar Cover 1",
    "Structural Material": "Concrete - Cast-in-Place Concrete",
    Thickness: "300",
    Type: "600 x 600 x 900mm",
    "Type Id": "600 x 600 x 900mm",
    "Type Image": "<None>",
    Volume: "0.11",
    Width: "600",
  },
  {
    ID: "512279",
    Name: "M_Pile-Steel Pipe: 600mm Diameter",
    Category: "Structural Foundations",
    Level: "Foundation",
    Pbi2DGeometry: "xQAAAB+LCAAAAAAABAA1jUELgkAQhf/LnG1Z3SjXTlFBUAeRoIN4WGvQgW03bAtE/O+NZLd57/uYVw6Q13TpnwgZnHxNBd6CcY1FiCD35MILsnL4nawoJWQcrzYLJUWcahirv7btOtOzy8WezAMDdpBJISM4o2tCOwWtl+sICh9MIO9mfKX7TNOJHpGalqeSaUBxcbD4mf1FokSiJZc7bz3/d29rx+oLsYBTucUAAAA=",
    Pbi3DGeometry:
      "jBkAAB+LCAAAAAAABACdl1tr20AQhf/LPstC0uq2zlNIC4X2IbSFPgQ/OEQkAtcqriiE4P/ejS+xtda3OzImwfJ45sycM+udeXhT94/tz9c/jZqrr91j+6NbtU8qUvddu+7/qvnD2/6tNSc39qW20emTWZokN7t/9k9tF0e3281m+Wp9dRbXSZVGs8zEVZ5q+0bHmUmqSOs4qdNyb0nSemDJjoahSxYX2uTRTCdxUiTDYFprs/Op02pgyLNiH8xkmZGgYKxwLTaxsipTYcqUGeNwtCwua6MnJZ3FJicBSBoPDGdWmGpinR4JmE6PBKkpdpa0NsJg9rkacfG1U17remqwo4vOdhS5MNaSF4XMsGfMGooyGenzd150KQQhKn3lh3xGYCCxM10cXo7td1nlscsuUDzqe2Ih/r5jx8jk9tsfszFm2IdwOGtfNE+l4+QEDwB25tgxH4LY2MaksnN5wT+rPHQ5A5H20smF6WJZMDFpx57gHRA0CFrMSyUyRnIh91AIIiDzFOkaRZBGRGcWHYtAq2sOPaBcuKBB8qMvvSdOIML74+TAPxF433FW0gvvDH6IggbJrx3WTmShVFwhFkIYxDszMl0QJhHAkcKhQSATNzWQ6zk5zlAmSJfHOPHoh/A44LoajuwxuK1wWtKdyOm4DxD6XLTDedgidCmNpKJEXcJGrkgopIQ4pEBMoWMJy8Rrm3jVc89U2CBaNaXbqXuzju7Aw33SnR5GJ9DpazMHG7qMjDvDLvWuxjQBc/VIGOqFJVIhCIHMIyVXKMI0ou64R9AkSxDc2sCu5/wIOZnePwLJUcHJvcu9EMzWvddhPBFP/YLFgpMKdYJ4RcGJH0Ph8oAe0q1Cwq1fjctOwJ4CbqU3ZPDE4OUchMaJN3jPCyB4KMExBiZkGuexCOnaJ2gDHpBphwsuUWI+hGtJeKoLz4eyJp869Cwi9ald/m76ZqPmFj1S35r1c/9yePje9cu+7daHx1/t04fpS9M+v/SHh8+r5t/5F++6VWcDqrvk/aW2i/+HU0QBjBkAAA==",
    Area: "0",
    "Assembly Code": "A1020130",
    "Assembly Description": "Piles - Steel Pipe",
    Cost: "0",
    Depth: "6000",
    "Design Option": "-1",
    Diameter: "300",
    "Elevation at Bottom": "-7099",
    "Elevation at Bottom Survey": "-7099",
    "Elevation at Top": "-947",
    "Elevation at Top Survey": "-947",
    Family: "600mm Diameter",
    "Family and Type": "600mm Diameter",
    "Height Offset From Level": "-902",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    Length: "0",
    "Minimum Embedment": "152",
    "Moves With Grids": "Yes",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Radius: "150",
    "Structural Material": "Metal - Steel - 345 MPa",
    Type: "600mm Diameter",
    "Type Id": "600mm Diameter",
    "Type Image": "<None>",
    Volume: "0.42",
    Width: "0",
  },
  {
    ID: "512297",
    Name: "M_Pile Cap-600 Pile: 600 x 600 x 900mm",
    Category: "Structural Foundations",
    Level: "Foundation",
    Pbi2DGeometry: "xgAAAB+LCAAAAAAABABNzVELgjAUBeD/cp/nmE5XrqeoIKgHkaAH8WHaRQdrC1uBiP+9QQa9Xe75OKeaoGj0ZXwgSDi5RpfYemU7g0CgcNr6J8hq+p6BcE5ZHItNlDDKU5HCXP/cdhjUGHB47LW6o8cBJKOMwBlt53uQMc3FOiNQOq+8dnaJr/r2nx5Rd33YCgtileUEDgbfi48STjljQe2ccaHfvoyZ6w/1+h76xgAAAA==",
    Pbi3DGeometry:
      "SQQAAB+LCAAAAAAABACtk8GKwjAQht9lzmmYJtraelp0Qdg9iAoexEOLQQPdZumGhVJ8d6PWKsYSKxISMvmS+SeTyaqCaSoX5a+AGL5UKucqkxsgMFUy138Qr6rz1GAcmgZ7cl3xfMThaTAd9uvLsY+iSEpzljOKLOTE8yPKA8aIx2jAeiFpAPMp5xheAadR1B+8Alo1LGC54jTAQfQgqnvQuHICK6p7YGm03qPVVfeonCl5PolOje7ZtZ62e/m0ajjT7gZvrN2nq8QNHOLmT45l8iO0KCBGigS+Rb7Vu9qYKZ1oqfLaXMpNgyZCbne6Nj4z8X+7caQyZRzCCI/NfP0D5fgSA0kEAAA=",
    Area: "0",
    "Assembly Code": "A1010130",
    "Assembly Description": "Pile Caps",
    Cost: "0",
    "Cut-off": "150",
    "Design Option": "-1",
    "Elevation at Bottom": "-7102",
    "Elevation at Bottom Survey": "-7102",
    "Elevation at Top": "-800",
    "Elevation at Top Survey": "-800",
    "Enable Analytical Model": "Yes",
    Family: "600 x 600 x 900mm",
    "Family and Type": "600 x 600 x 900mm",
    "Height Offset From Level": "-800",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    Length: "600",
    "Moves With Grids": "Yes",
    "OmniClass Number": "23.25.05.11",
    "OmniClass Title": "Foundation Piles",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Pile Type": "600mm Diameter",
    "Rebar Cover - Bottom Face": "Rebar Cover 1",
    "Rebar Cover - Other Faces": "Rebar Cover 1",
    "Rebar Cover - Top Face": "Rebar Cover 1",
    "Structural Material": "Concrete - Cast-in-Place Concrete",
    Thickness: "300",
    Type: "600 x 600 x 900mm",
    "Type Id": "600 x 600 x 900mm",
    "Type Image": "<None>",
    Volume: "0.11",
    Width: "600",
  },
  {
    ID: "512299",
    Name: "M_Pile-Steel Pipe: 600mm Diameter",
    Category: "Structural Foundations",
    Level: "Foundation",
    Pbi2DGeometry: "xgAAAB+LCAAAAAAABAA1jUELgkAQhf/LnNdldc3UTlFBUAeRoIN4WGvQgW03bAtE/O+tZLd57/uYV41QNHQZngg5nGxDJd6cMq1GYFBYMu4FeTX+Tq9IyUUYJpsgElzGSQxT/fe2fa8GL/tiT+qBDnvIBRcMzmha180hy+I1g9I65ciaBV/pvtB0pkektvNbfiFMpS8OGj+LH0SSSyFWDHZWW//fvLWe6i9J5GqPxgAAAA==",
    Pbi3DGeometry:
      "zRkAAB+LCAAAAAAABACdl1tr20AQhf/LPstipdVl5TyFNFBoH0Jb6EPwg0NEInCt4IpCCP7vlW+xtdK3GhmTEHkyc2bOmdXOPH6oh6fq1/tbqebqW/1U/axX1bMK1ENdrZu/av74cfizNeub9qO2wfmbWaT1zf5X+6O2i5Pb7WazfG99TRxanUfBLCpCW1gbzGITGq3TwJhQ2yg7WNLCdCzxydB1icPUFEn7hQ5jnXeDGWOKvU+RJ2nHksRptvfRVicSGA42Xk0LY43JhElTaozD0eIwszsap2Qdh0VCGpA6PhzOLS3yiZX6VGBGPSpERbq3mCRLhNFSbfIhH19TJdbYydFOPolNo2GcLIqhrXuWA2+tJY/sQMPvDK3swmBEqI8CgU8PB1K7UMfh5tSH/Tovus2B8XWBJxpmcOjdIUK5Dw8nbogc9iEcztoXzVMpsCM6CdyhvTPv4Jgw07YQHtKeCB6xuz4XMNKeOrswaSwOZyZu3XMCDgwaBK3mZRM5Q82Yf6oFQZB+DHWNLkglwjOTjkWg1zUvAEDpuaBBcglI740ziPQ+OXt43hZ4B3Je4jvwIoEuDBpE7z6snwhDubhGrIQwkHvm5ApRmEeCZxodi0As7m5g2HOEnIFNkjDPeOK5EPF5AHaVHFp2cKXhxMSbk9N6nyj0vWjV8xBG6FImUUmRxITOdKFcSAvxiJGYR8cyrhXvd+Kd0D1c4wbRTireY93LdnBd7i6eAxNFfzq9YsPmaI7PwBDU7VbvFo3jMROAnKFmXCXWgiBIP9NyhS5MJarPiwbOuQTCPQ4Uew6SlJbpbSQQHlWc3sPcEKPpunc9jC3ynUCwd3BWo90gXmFwIcBQuFugh3TpkLDr12OgGbCvgF3xjTl6bvC6HsX2TcMjN78AgycVnG1oeqZpH8uQboaCVuDRGde80S1LzIh0axFMe+ODo7DXp05Ci0B9qZZ/yqbcqHlbYqC+l+uX5vX48KNulk1Vr4+Pv6vnT9PXsnp5bY4P96vy3+U/3tWrug2o7vTuo7aL/8KClRTNGQAA",
    Area: "0",
    "Assembly Code": "A1020130",
    "Assembly Description": "Piles - Steel Pipe",
    Cost: "0",
    Depth: "6000",
    "Design Option": "-1",
    Diameter: "300",
    "Elevation at Bottom": "-7102",
    "Elevation at Bottom Survey": "-7102",
    "Elevation at Top": "-950",
    "Elevation at Top Survey": "-950",
    Family: "600mm Diameter",
    "Family and Type": "600mm Diameter",
    "Height Offset From Level": "-902",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    Length: "0",
    "Minimum Embedment": "152",
    "Moves With Grids": "Yes",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Radius: "150",
    "Structural Material": "Metal - Steel - 345 MPa",
    Type: "600mm Diameter",
    "Type Id": "600mm Diameter",
    "Type Image": "<None>",
    Volume: "0.42",
    Width: "0",
  },
  {
    ID: "512319",
    Name: "M_Pile Cap-600 Pile: 600 x 600 x 900mm",
    Category: "Structural Foundations",
    Level: "Foundation",
    Pbi2DGeometry: "xgAAAB+LCAAAAAAABABNzc0KwjAQBOB32XMa0l+beBIVBD2UIngoPaS6pIGYSI1CKX13A1bwNux87DQTVJ0+jw8EAUfX6RqvXlplEAhUTlv/BNFM3xhIFtOy4HwdZYyyNM5hbn9uMwxyDDgcdlre0eMAIigCJ7TK9yBiyosyJ1A7L712dqkv+vbfHlCrPmwljBarnBPYG3wvPkpSmjIW1NYZF/7blzFz+wEv5GDUxgAAAA==",
    Pbi3DGeometry:
      "SQQAAB+LCAAAAAAABACtk98LwiAQx/+Xe3ZyW+5H6ykqCOohKughelgkJawZS4KI/ves1ops2CJE8fzofc/znJ9gtBTT445DDAO5FBOZihUQGEmRqT3E89N9qjG2dIMzea44LmLrNugO58XjWDvPk6M+y5BGkR8Qp9GkyEKPOB4NPBaSEjCXouuHT+DRyGfuL6BSwwCGqwYNMGp+iOodlK6swIjqHRgalfeodFU/KmtKvk+iVaN+do2nrV8+lRrWtNvBH2v36yqxA4u4/pNdkWy54jnESJHAkGdrtSmMsVSJEjIrzJlYlajPxXqjCqOX8sPrxo5MpXYIHbw2/fUvvpCnikkEAAA=",
    Area: "0",
    "Assembly Code": "A1010130",
    "Assembly Description": "Pile Caps",
    Cost: "0",
    "Cut-off": "150",
    "Design Option": "-1",
    "Elevation at Bottom": "-7102",
    "Elevation at Bottom Survey": "-7102",
    "Elevation at Top": "-800",
    "Elevation at Top Survey": "-800",
    "Enable Analytical Model": "Yes",
    Family: "600 x 600 x 900mm",
    "Family and Type": "600 x 600 x 900mm",
    "Height Offset From Level": "-800",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    Length: "600",
    "Moves With Grids": "Yes",
    "OmniClass Number": "23.25.05.11",
    "OmniClass Title": "Foundation Piles",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Pile Type": "600mm Diameter",
    "Rebar Cover - Bottom Face": "Rebar Cover 1",
    "Rebar Cover - Other Faces": "Rebar Cover 1",
    "Rebar Cover - Top Face": "Rebar Cover 1",
    "Structural Material": "Concrete - Cast-in-Place Concrete",
    Thickness: "300",
    Type: "600 x 600 x 900mm",
    "Type Id": "600 x 600 x 900mm",
    "Type Image": "<None>",
    Volume: "0.11",
    Width: "600",
  },
  {
    ID: "512321",
    Name: "M_Pile-Steel Pipe: 600mm Diameter",
    Category: "Structural Foundations",
    Level: "Foundation",
    Pbi2DGeometry: "xgAAAB+LCAAAAAAABAA1jVELgjAUhf/LfZ5jOi1nT1FBUA8iQQ/iw6zLHKwtbAUi/vcm2du55/u4px6hbPVleCIUcHKtrvDmpVUGgUDptPUvKOrxF4OSxjRfCbGJUkYZjzOYmr+37Xs5BDkUey0f6LGHIlgEzmiV7+ZDiHRNoHJeeu3sgq/6vtB8pkfUqgtbCaNxzkNxMPhZ/CjhlDOWEdg548J/+zZmar6T+hShxgAAAA==",
    Pbi3DGeometry:
      "wRkAAB+LCAAAAAAABACtl1tr20AQhf/LPstC0uq2zlNJC4X2IbSFPgQ/OEQkAtcqriiE4P9e+Rbb6/12R04xNpEnM2fmnFnvzP2runtof7z8btRUfeke2u/don1Ukbrr2mX/R03vX3d/DubkZnipdXT8ZpImyc32Y3ir9ezg9mG1mr8Mvnkal2WRRxNt4qLWdTTJdKyTpIgGi9HG7Cx5np9Ysjipcu320aaqtpbaZPWZT2qydGspC1OeWbJa73CqbSoCHI4WridP4iKtS2HWlJsPh6KlA5FVOTbrypjapQLr48Ph3PKiGFmpTwXG8ahQbXwGS6LTQqiPLjOXi6+pdJ6NjLX1GAxplaQOkMGSmcoF77LsOBsseaJd3b6xVEaGw2z6Ojfk48qacjtoc8nOoQsvKz30mqse7gGOxhnsOteVNXfh7ry5LOzDOJw1R/NUCuwEzwG3qKtBLBgdl0ltJCfUpYFH63OfExhpSx1dmDPWhjMTd+4xAQsGDaJOYwKYM9KMq8RaEATpx1DX6IJUIjwzaVkEel1z/hHFckGD6BYQ3xwHmBFXytGFfzDwGuTExNfgEf8chb6X/PRx8cAX6uUrEQtBUZB6DHWFJkQjgvP0c2YICeU7Jnga4PzYs5okWRrupPMgYfPUa+vnWnF4keG8xAuT3XJvMGgQLXmcGeLLqCQZBfIiMpOFarEmSCPE8q1iliWolS+WeBW0T1bYIFpFxeurfc26gln7pj1LOOfSKxZrjmb52OPPRbv68HkwZgKQM9SMq8RaEATpx1DX6IJUIrxnxcCthEC4x5FiPEhSWsanJRDr2laV3/8YyuMRoMThgXNyYBV0FejvBkco6cT/H9cdAQaOPgGhcPAacwmAgvJLMwjOd7/0KhdkGxioHR6UFDq8e2YP7gWe5WP8JsFTvm+7GnP4x668geHQlRIMh9IhLNA4s0h9bOe/mr5ZqemAEqmvzfKpf94/fOv6ed92y/3jz/bxzfS5aZ+e+/3Dp0Xz9/Qfb7tFNwRUt8nmpdazf0o07fnBGQAA",
    Area: "0",
    "Assembly Code": "A1020130",
    "Assembly Description": "Piles - Steel Pipe",
    Cost: "0",
    Depth: "6000",
    "Design Option": "-1",
    Diameter: "300",
    "Elevation at Bottom": "-7102",
    "Elevation at Bottom Survey": "-7102",
    "Elevation at Top": "-950",
    "Elevation at Top Survey": "-950",
    Family: "600mm Diameter",
    "Family and Type": "600mm Diameter",
    "Height Offset From Level": "-902",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    Length: "0",
    "Minimum Embedment": "152",
    "Moves With Grids": "Yes",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Radius: "150",
    "Structural Material": "Metal - Steel - 345 MPa",
    Type: "600mm Diameter",
    "Type Id": "600mm Diameter",
    "Type Image": "<None>",
    Volume: "0.42",
    Width: "0",
  },
  {
    ID: "512394",
    Name: "M_Pile Cap-600 Pile: 600 x 600 x 900mm",
    Category: "Structural Foundations",
    Level: "Foundation",
    Pbi2DGeometry: "1QAAAB+LCAAAAAAABABNzc8LgjAcBfD/5XueYz+cunWKCoI6iAQdxIPW0MHawlYg4v/eoIJuj8fn8eoZys6cprsGBQffmUpfQut6qwFB6Y0LD1D1/ImRsBRTwfkqSQkmnApYmp9bj2M7RRyLrWlvOugRVFQIjtr1YQBFscwKgaDyoQ3GO1Ac05QKyTLBRSFzySmCs7n+4702/RCvGcFZLiSCndWv7zxhHHNCotp46+Ode1q7NG8dtVug1QAAAA==",
    Pbi3DGeometry:
      "SQQAAB+LCAAAAAAABACVU02LwjAQ/S9zTsMkra2tJ1FB0IO4wh7EQ8WggdpIDYKI/924trsLWjMyJGTyMvPmK8sLzNZ6cT4oyGBi1vrLFHoDDGZGl/YI2fLyODoYe07gyv5uAoHY+9ncguuqMetXVX52tjLkIk4FCyLBUXQSFkgeyyhhssNFmMRvgDDlGCWSADQcrYCfI+QxdtMXUTXAkysy0MpBB1pdeTOnF/HzktDzIJP7p8Rbdm+49ElsHZ/Pe04fHzK5v+cPDvcnhzrfK6sqyJAjg6kqt3ZXK3Njc6tNWavfevMLjZXe7mytjAp1+v9wYArjHMIA7+K+/g0PkZLDSQQAAA==",
    Area: "0",
    "Assembly Code": "A1010130",
    "Assembly Description": "Pile Caps",
    Cost: "0",
    "Cut-off": "150",
    "Design Option": "-1",
    "Elevation at Bottom": "-7102",
    "Elevation at Bottom Survey": "-7102",
    "Elevation at Top": "-800",
    "Elevation at Top Survey": "-800",
    "Enable Analytical Model": "Yes",
    Family: "600 x 600 x 900mm",
    "Family and Type": "600 x 600 x 900mm",
    "Height Offset From Level": "-800",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    Length: "600",
    "Moves With Grids": "Yes",
    "OmniClass Number": "23.25.05.11",
    "OmniClass Title": "Foundation Piles",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Pile Type": "600mm Diameter",
    "Rebar Cover - Bottom Face": "Rebar Cover 1",
    "Rebar Cover - Other Faces": "Rebar Cover 1",
    "Rebar Cover - Top Face": "Rebar Cover 1",
    "Structural Material": "Concrete - Cast-in-Place Concrete",
    Thickness: "300",
    Type: "600 x 600 x 900mm",
    "Type Id": "600 x 600 x 900mm",
    "Type Image": "<None>",
    Volume: "0.11",
    Width: "600",
  },
  {
    ID: "512396",
    Name: "M_Pile-Steel Pipe: 600mm Diameter",
    Category: "Structural Foundations",
    Level: "Foundation",
    Pbi2DGeometry: "1QAAAB+LCAAAAAAABAA1zVELgjAUBeD/cp/X2LwunT1FBUE9iAQ9iA9aQwdrC1uBiP+9SfZ27+E7nHKEvNGX4akgg5NrdKFuvratUUAgd9r6F2Tl+DsDiWLKBeJmFTPKkAuYqr/b9n09BByCva4fyqsesqAInJVtfTc/UsYJgcL52mtnIUPKYy5ktBYoUplI5ASu+r7gdMZHpdsuTEeM8hRDcDDqs9RXEVJkTBDYOePCnH0bM1Vfzy2Mk9UAAAA=",
    Pbi3DGeometry:
      "yRkAAB+LCAAAAAAABACtV01r20AQ/S97lsVKu6sP5xTSQKE9hLbQQ/DBISIRuFZwRSEE//euvU4UrfeNZoUxCZGeZ+btm9nMzP2buHtof72+NGIpvnUP7c9u0z6KRNx17bb/K5b3b+5PC8sr+xH7ZHizyKS8Ov6yP2K/eje73u3Wr9Y2V2mtqzpZqDo1laqShX2jpDRJrlNZKeUQrfUIUaasQjYqLVXtbMrC6BFSqewIFKYuRs6K3JgjUtV5xQwDnOHTYGYUAYdomWalzEaILk1xqeNQSue50nE50KkpyuiTxp+HyCimRkitD1yt1FJlhpUElRZVloWpTSU75M3ZWCSvSxOIE2RQZHmI9UkcC2ipNCsMVW2zSMdSo8K4a3WwKessUGyh47iSiomDbSgG2Ju7PBYxWTWuUHfhQoir3VAcfB5sg+Ngb8gGa4BvAnl7QIGQhYhv6Rix7qUlG1PVgwmuqTnZ8RAYZgCwL8wM1xrm7CGfNGOKeUmVOfKzhYFaMgCoygwhvaxAACdyMMF3GTmj/mthbx7yToC6/h4ymMAuhFsa7igegqIM77ErzAt2LaIJjxGYMajkBSVmSM9VBerIAIAkM1Q8SwkEZtyh6ctFDXlTtfJh4x8/6AyZ4I0G7xpwPRkDMIhXRSFPeMJFywRF2EOgYAzGWC8iX7DEUHgkJFevaU9QkmgVz1ICAZxFv3MxTM76Y2ghw948xG/DIWce4vf6uG0Zb7EeAsP4E03IF8FsYiHFw/ZZufLFvKTKHPnZwkAtGQBUZYaQeDKG6eLeJM4Vg7ziaxICML+QL2QFY0AZgQUcNYjJH8bAFnC7iaTLX24Ya0f8ogJjwLkIWBCyQ1dQElg+3O7E6I28tsyYIqIbPzAgDoGHxPA0QkgLFw000UduE0SEGbsBPWzx9yhYhHOCw0KfEJ2fWOBqlYgv7fpP0zc7sbS8EvG92T71z6eHH12/7ttue3r83T5+QF+b9um5Pz3cbpp/n794020661DcyMNH7Ff/AasGjE3JGQAA",
    Area: "0",
    "Assembly Code": "A1020130",
    "Assembly Description": "Piles - Steel Pipe",
    Cost: "0",
    Depth: "6000",
    "Design Option": "-1",
    Diameter: "300",
    "Elevation at Bottom": "-7102",
    "Elevation at Bottom Survey": "-7102",
    "Elevation at Top": "-950",
    "Elevation at Top Survey": "-950",
    Family: "600mm Diameter",
    "Family and Type": "600mm Diameter",
    "Height Offset From Level": "-902",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    Length: "0",
    "Minimum Embedment": "152",
    "Moves With Grids": "Yes",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Radius: "150",
    "Structural Material": "Metal - Steel - 345 MPa",
    Type: "600mm Diameter",
    "Type Id": "600mm Diameter",
    "Type Image": "<None>",
    Volume: "0.42",
    Width: "0",
  },
  {
    ID: "512445",
    Name: "M_Pile Cap-600 Pile: 600 x 600 x 900mm",
    Category: "Structural Foundations",
    Level: "Foundation",
    Pbi2DGeometry: "xQAAAB+LCAAAAAAABABNzUELgkAQBeD/MudtWTXN3U5RQVAHkaCDeFhr0IFtN2wLRPzvLWTQ7THvY141QtHQeXggKDi6hkq8em1bg8CgcGT9E1Q1fmMgy4jnmZTrRSJ4lEuY6h/b9L0egg2HHek7euxBCS4YnNC2vgMVcZnlKYPSee3J2bm+0O2/PSC1XZiKBc9WqWSwN/ie/SJOeCJEUFtnXPhvX8ZM9QevWxr0xQAAAA==",
    Pbi3DGeometry:
      "SQQAAB+LCAAAAAAABACtk1ELgjAQx7/LPds4p5nZU1QQ1ENU0EP0YDRqYC5sBBF9964yi5YsI4Zzt593//N2m59gtJTT405ABAO1lBOVyBU4MFIy1XuI5qf7kjC2aMDZee7UXMTWbaIHzouHWzvL4iP5+sjCsB44Nd5kHP0GLVjA6V0Az2Vuw+NPwFlY991fQKmGAYxQHgswbH7I6h0UoazAyOodGBql/1EaqnpW1pJ8X0SrRvXqGkdbvX1KNaxlt4M/9u7XXWIHFnG6k10Zb4UWGUTI0IGhSNd6kxtjpWMtVZqbM7kqUF/I9UbnRi8Rh9cPOypRFBA6eB109S8pnOhHSQQAAA==",
    Area: "0",
    "Assembly Code": "A1010130",
    "Assembly Description": "Pile Caps",
    Cost: "0",
    "Cut-off": "150",
    "Design Option": "-1",
    "Elevation at Bottom": "-7102",
    "Elevation at Bottom Survey": "-7102",
    "Elevation at Top": "-800",
    "Elevation at Top Survey": "-800",
    "Enable Analytical Model": "Yes",
    Family: "600 x 600 x 900mm",
    "Family and Type": "600 x 600 x 900mm",
    "Height Offset From Level": "-800",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    Length: "600",
    "Moves With Grids": "Yes",
    "OmniClass Number": "23.25.05.11",
    "OmniClass Title": "Foundation Piles",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Pile Type": "600mm Diameter",
    "Rebar Cover - Bottom Face": "Rebar Cover 1",
    "Rebar Cover - Other Faces": "Rebar Cover 1",
    "Rebar Cover - Top Face": "Rebar Cover 1",
    "Structural Material": "Concrete - Cast-in-Place Concrete",
    Thickness: "300",
    Type: "600 x 600 x 900mm",
    "Type Id": "600 x 600 x 900mm",
    "Type Image": "<None>",
    Volume: "0.11",
    Width: "600",
  },
  {
    ID: "512447",
    Name: "M_Pile-Steel Pipe: 600mm Diameter",
    Category: "Structural Foundations",
    Level: "Foundation",
    Pbi2DGeometry: "xQAAAB+LCAAAAAAABAA1jcEKwjAQRP9lzzGkTdWmnkQFQQ+lCB5KD6ku7UJMpEahlP67KdbbzrzHTjlAXtOlfyJkcHI1FXjz2jYGgUHuyPoXZOXwO4OSRDxdKbVZSMGjVMFY/bVt1+k+uKHYk36gxw4ywQWDM9rGt1NQKlkzKJzXnpyd8ZXuM00nekRq2jAVTwMyFAeDn9lfxJJLIZYMds648N++jRmrLxNFboHFAAAA",
    Pbi3DGeometry:
      "gRkAAB+LCAAAAAAABACdl09r20AQxb/LnmWx0uqP5ZxCWii0h9AWegg+OEQkAtcqriiE4O/ejWXH1np/2pExSWxPZt7Me7PamYc3df/Y/Hz9U6uF+to+Nj/adfOkInXfNpvur1o8vPVvrVnf2JfaRadvZonWN/tf9kftlke32+129Wp9syQuijyLZmkVl1li7BsTG63zyFoqU1W9RSfzM0sa6zIzfh9TlWU0MzrWuTYDn6RKk73PPCkHhnRuepgqTSsRDAYLV2MzK8oiEeZMqY3hULQkzrOymJh0WVVznwQszggMZ5bl+cQ6RyRgmBEJyoNPMq+E2pgi9XiMtZPJ0mmhjg4m3TPqYliLJU5m6NmyhrzQviZ/J8UUIhTmcaxhQz6enCmzM1UcZo7Nd1nnscc81aD2HIvx+3715czN1x8yn4V9GIez5mgjlfrJCbU/tqavNYYYJi60/Ss6lBf0s8hDlzMQaSudXJgtVgUTkzbsCd4BQYOow7h8ZgzkwhKpEERA5inSNYogjYjOLDoWgVbXnHlEcVzQIHrqi2+KI4z8Cjl54FMCrzxOS3rnndCHIPS94GHHhQNXqNVYgVgHCkK0Y6TpehCHBI0zzvn3IYnGTgceAjg27jwmSJXmN+nIR9A41brKebYX3lE4K+kq5HbaBwoaRNsbJ4b4Mh5BwrCyiItMkU4sB1LoDzW2YTmWoExjscQbnnugwgbRhildSt071RfLWSPducE7e07fljnY0MUz6AzbdAwdZ1+uHglDvbBEKgQhkHmKdI0iSCOi8wZBKwdBcGsju3h+hJxM7x+B5Kjg5N7FSOFs3ZkBxhLxvC9YKTipUCeIlxOc9TEUDvToId0nBNwG1LjsBOwp4FZ8SQaPDF7QQWwcdYN3vQCChg9EoNkY53gUT7rxCUJh5+AkH9iexHQIt5HwVBcYDqUNPm3gWUbqU7P6XXf1Vi0seKS+1Zvn7uXw4Xvbrbqm3Rw+/mqePkxf6ub5pTt8+Lyu/53/4127bm1AdaffX2q3/A8pfmbDgRkAAA==",
    Area: "0",
    "Assembly Code": "A1020130",
    "Assembly Description": "Piles - Steel Pipe",
    Cost: "0",
    Depth: "6000",
    "Design Option": "-1",
    Diameter: "300",
    "Elevation at Bottom": "-7102",
    "Elevation at Bottom Survey": "-7102",
    "Elevation at Top": "-950",
    "Elevation at Top Survey": "-950",
    Family: "600mm Diameter",
    "Family and Type": "600mm Diameter",
    "Height Offset From Level": "-902",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    Length: "0",
    "Minimum Embedment": "152",
    "Moves With Grids": "Yes",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Radius: "150",
    "Structural Material": "Metal - Steel - 345 MPa",
    Type: "600mm Diameter",
    "Type Id": "600mm Diameter",
    "Type Image": "<None>",
    Volume: "0.42",
    Width: "0",
  },
  {
    ID: "512449",
    Name: "M_Pile Cap-600 Pile: 600 x 600 x 900mm",
    Category: "Structural Foundations",
    Level: "Foundation",
    Pbi2DGeometry: "1AAAAB+LCAAAAAAABABNzc8LgjAcBfD/5XueYz+cunWKCoI6iAQdxIPW0MHawlYg4v/eoIJuj8fn8eoZys6cprsGBQffmUpfQut6qwFB6Y0LD1D1/ImRsBRTwfkq4QTTQsLS/Nh6HNsp2lhsTXvTQY+gCCYIjtr1YQBFscwKgaDyoQ3GO1Ac05QKyTLBRSFzySmCs7n+4702/RCfGcFZLiSCndWv7zxhHHNCotp46+Ode1q7NG+6QY4/1AAAAA==",
    Pbi3DGeometry:
      "SQQAAB+LCAAAAAAABACVU80KwjAMfpecu9If3dx2EhUEPYgKHoaHiWUW5iqzCCK+u9VtKuhsJbQ0/Zp8aX6SC8w2cnk+CIhgojZyoXK5BQQzJQt9hCi5VEcDk9gIXNHrxqOExI/NLLiuG7N+WaZnY8s4pn5IkccppgFnyGPYZ50AsS6mPPB/ACzEjJgLO9BwtAJ2Do590gu/RNUAH66cgVYOd6DVlfXn7kn8PyXu/3Amt3eJNe3WcN07sbV9/q+5e/s4k9trXnGYmRzKdC+0KCEimCCYiiLTu1qZK51qqYpaXcntExoLme10rYxycXp/OFC5Mg5hQO5iRv8GsDsh50kEAAA=",
    Area: "0",
    "Assembly Code": "A1010130",
    "Assembly Description": "Pile Caps",
    Cost: "0",
    "Cut-off": "150",
    "Design Option": "-1",
    "Elevation at Bottom": "-7102",
    "Elevation at Bottom Survey": "-7102",
    "Elevation at Top": "-800",
    "Elevation at Top Survey": "-800",
    "Enable Analytical Model": "Yes",
    Family: "600 x 600 x 900mm",
    "Family and Type": "600 x 600 x 900mm",
    "Height Offset From Level": "-800",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    Length: "600",
    "Moves With Grids": "Yes",
    "OmniClass Number": "23.25.05.11",
    "OmniClass Title": "Foundation Piles",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Pile Type": "600mm Diameter",
    "Rebar Cover - Bottom Face": "Rebar Cover 1",
    "Rebar Cover - Other Faces": "Rebar Cover 1",
    "Rebar Cover - Top Face": "Rebar Cover 1",
    "Structural Material": "Concrete - Cast-in-Place Concrete",
    Thickness: "300",
    Type: "600 x 600 x 900mm",
    "Type Id": "600 x 600 x 900mm",
    "Type Image": "<None>",
    Volume: "0.11",
    Width: "600",
  },
  {
    ID: "512451",
    Name: "M_Pile-Steel Pipe: 600mm Diameter",
    Category: "Structural Foundations",
    Level: "Foundation",
    Pbi2DGeometry: "1AAAAB+LCAAAAAAABAA1jdEKgjAYhd/lv15j83fp7CoqCOpCJOhCvNAaOlhb2ApEfPcm2d05h+/wlSPkjb4MTwUZnFyjC3XztW2NAgK509a/ICvHXwxIFFMuEDcrZJSnEqbqj237vh4CG4a9rh/Kqx4yRhmBs7Kt7+YiZZwQKJyvvXYWMqQ85kJGa4EilYlETuCq7wuczvBR6bYL5mj2YRgORn2W+ypCiowJAjtnXNDZtzFT9QVo2VkM1AAAAA==",
    Pbi3DGeometry:
      "gRkAAB+LCAAAAAAABACtl01r20AQhv/LnmWx0uozOZW0UGgPoS30EHxwiEgErlVcUQjB/71ry4mj9T6rXdWYxNa+no99Z8Yzc/cibu/bH8+/G3ElvnT37fdu3T6ISNx27ab/I67uXoaPGpbX+iV20elkkUh5ffin/8Ru+Sr2YbtdPWvZVMV1VtXRIq3jMkuU/qBiJWUepVksK6UGRCbVCFF5WdlkVFyqepCp07QeIZVKDkCVlCNdRZrn0ULJWOZSeVqx6+K7sF8u+2+ISstihGRlXlzoMi6a01RlYQHI4rwogy8afB2OJjvm4DnLswOSVOCxEQAVF1WS2B3zCPSZtkFGI9n+GzYz5w4USWrx+UiMPs8LWfsYcaXZHI8D/XIZGapJI4UqCkuSWe4yZFKIGZZxOcDahprZy5RFYqkzGzIkrc0O34dl2A5rIxnmgGvAWTf29HAmIVbnCNC6pX4PyeeTCObTnMgYCFk5nbMq9IuzjD02kHeE+RF5QYY9mPclBWn0AJCRGSQaEUGAg3gS4QomZa7fKtZmIK8OuIreQE4i2He4h2ETGQNk43SOitgpalOOjjtGMFrI4gXp9aDdkxMicfoc+JhBoRkOOp9ROtM15ZrlprNkELHc/VwXifDGwtsE7R+jczRhZI9FDw+xtCy4vDUQZMvDYSaLY0W5RcaBRE+uJvUgG8EEnkUDAQ6g2ac8RM66oW3bYm0GYjZdmzIDMTt70B7M+6mBkBVzdrGpYr8mV00epsd56k/kBRn2YN6XFKTRA0BKZrCIwy9FyreAfCprcvI2vWVKQBORjgEPrgKyjDyRALqES0XwpoXTAe9GnjuQhyr0FocZVIX3cAfDJkDXwPBhmDD/QZWjFULrpFb+X2PPlHqH/+QPGoaZw7FD0LQeuCg4LDhJtVjGIT54UUALEAd7ck/FzfvKgT9ly0h8bFe/mr7Ziisd0Uh8bTaP/dPx4VvXr/q22xwff7YPb9Dnpn186o8Pn9bN3/dfvOnWnVYobuT+JXbLfzC7FHmBGQAA",
    Area: "0",
    "Assembly Code": "A1020130",
    "Assembly Description": "Piles - Steel Pipe",
    Cost: "0",
    Depth: "6000",
    "Design Option": "-1",
    Diameter: "300",
    "Elevation at Bottom": "-7102",
    "Elevation at Bottom Survey": "-7102",
    "Elevation at Top": "-950",
    "Elevation at Top Survey": "-950",
    Family: "600mm Diameter",
    "Family and Type": "600mm Diameter",
    "Height Offset From Level": "-902",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    Length: "0",
    "Minimum Embedment": "152",
    "Moves With Grids": "Yes",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Radius: "150",
    "Structural Material": "Metal - Steel - 345 MPa",
    Type: "600mm Diameter",
    "Type Id": "600mm Diameter",
    "Type Image": "<None>",
    Volume: "0.42",
    Width: "0",
  },
  {
    ID: "512469",
    Name: "M_Pile Cap-600 Pile: 600 x 600 x 900mm",
    Category: "Structural Foundations",
    Level: "Foundation",
    Pbi2DGeometry: "xgAAAB+LCAAAAAAABABNzc0KwjAQBOB32XMa0r/YxJOoIOihFMFD6SHVpQ3ERGoUSum7G7CCt2XnY6aeoGz1eXwgSDi6Vld49cp2BoFA6bT1T5D19D0DyWJacCHWUcJomvEM5ubnNsOgxoDDY6fVHT0OIBllBE5oO9+DjKngRU6gcl557ewSX/TtPz2g7vqwFRb4KhcE9gbfi4+SlKaMBbV1xoV++zJmbj6oM+atxgAAAA==",
    Pbi3DGeometry:
      "SQQAAB+LCAAAAAAABACtk1ELwiAQx7/LPTu5ubXWeooKgnqICnqIHjaSEtaMJUFE3z2rtSIbtghRPH96//M8FycYJ2J23HGIYCgTMZWpWAGBsRSZ2kO0ON2nGmNbNziT54rjIrZvg+5wXj6OdfI8PuqzPtIwbATEcVvUCxgjDqMB85ukBMylnofNJ2A0bPjuL6BSwwCGK48GGLY+RPUOSldWYET1DgyNyntUuqoflTUl3yfRqlE/u8bT1i+fSg1r2u3gj7X7dZXYgUVc/8meiLdc8RwipEhgxLO12hTGRKpYCZkV5lysSjTgYr1RhdFP+eF1Y1emUjuELl6b/voXbpWfs0kEAAA=",
    Area: "0",
    "Assembly Code": "A1010130",
    "Assembly Description": "Pile Caps",
    Cost: "0",
    "Cut-off": "150",
    "Design Option": "-1",
    "Elevation at Bottom": "-7102",
    "Elevation at Bottom Survey": "-7102",
    "Elevation at Top": "-800",
    "Elevation at Top Survey": "-800",
    "Enable Analytical Model": "Yes",
    Family: "600 x 600 x 900mm",
    "Family and Type": "600 x 600 x 900mm",
    "Height Offset From Level": "-800",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    Length: "600",
    "Moves With Grids": "Yes",
    "OmniClass Number": "23.25.05.11",
    "OmniClass Title": "Foundation Piles",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Pile Type": "600mm Diameter",
    "Rebar Cover - Bottom Face": "Rebar Cover 1",
    "Rebar Cover - Other Faces": "Rebar Cover 1",
    "Rebar Cover - Top Face": "Rebar Cover 1",
    "Structural Material": "Concrete - Cast-in-Place Concrete",
    Thickness: "300",
    Type: "600 x 600 x 900mm",
    "Type Id": "600 x 600 x 900mm",
    "Type Image": "<None>",
    Volume: "0.11",
    Width: "600",
  },
  {
    ID: "512471",
    Name: "M_Pile-Steel Pipe: 600mm Diameter",
    Category: "Structural Foundations",
    Level: "Foundation",
    Pbi2DGeometry: "xgAAAB+LCAAAAAAABAA1jVELgjAUhf/LfZ5jumXOnqKCoB5Egh7Eh1kXHawtbAUi/vcm2ds95/u4pxqhaPRleCLkcHKNLvHmlW0NAoHCaetfkFfj7wyKiGmWSrmJEka5SAVM9d/b9r0aghyKvVYP9NhDzigjcEbb+m4OUoo1gdJ55bWzC77q+0KzmR5Rt13YCgtxxkNxMPhZ/CjhlDO2IrBzxoX/9m3MVH8BFC2S2MYAAAA=",
    Pbi3DGeometry:
      "whkAAB+LCAAAAAAABACdl1tr20AQhf/LPstipdVtnaeQFgrtQ2gLfQh+cIhIBK5VXFEIwf+9ii+xvdpvNTImIdJk5sycM+udeXhT94/Nz9c/tZqrr+1j86NdNU8qUvdts+7+qvnD2/7P3qxv+o/aRqc3s0Trm92v/kdtF0e3281m+dr7ZklcFHkWzRIbV7aqollqYqN1HvUWa6zdW3JrzixprMvM+H2MLcv+hY5TXVYXPolNk52PLbP8wpJWxu58dKUzEQ5HG6+nx6mMKYRZU24hHIqWxHlWFlOzLq2tfCqwPiEczi3L84mVhlRgnIAK5cHHZEUm1McUqc8l1FQmSyfGOnpkVZ74QYokhZ4eWPac9ZYyqXzd/m6xmQyH2Qx1rsBnkDXldqaNw86xC4eVnvXaoB7uAY7GGew715c1d+H+vPks7MM4nDVHC1QK7EjOAbfooEEcGBMXurLCEzrQIKD1pc8ZjLSlTi7MGWvDmYk795SAA4MGUacxAcwZacZVYi0IgvRjqGt0QSoRnpl0LAK9rjn/iOK4oEF0C4hvjiPMhCvl5MJfGHgNcmLia/CEf4lC7yVffVw88IV6hUrEQlAUpB5DXaEJ0YjgPP1cGMaECh0TPA1wftxZTZIsDXfSeZCweep19fOtOLzIcF7ihcltuQ8YNIiWPM4M8WVUkowCeRGZyUK1WBOkEWKFVjHHMqpVKJZ4FXRP1rhBtIqK11f3mvUFc/ZNzywxnEuvWKw5muPjGX8u2zWEz4MxE4CcoWZcJdaCIEg/hrpGF6QS4QMrBm4lBMI9jhTjQZLSMr2NBMKjitN7GEONp+uOEjCuyLcBwcbBWY12g3h5wVUAQ+G8jx7SdUPA7ogenmbAvgJ25Zfm6MHBK3sUPDQGj9z+AgyaSBAC52Yc81FA6VIoCIXdw2P+yHolJkS6rAimvZGpUdzn06agRaQ+NcvfdVdv1LyvL1Lf6vVz93J4+N52y65p14fHX83Th+lL3Ty/dIeHz6v63/k/3rWrtg+o7vT7R20X/wFpBxDxwhkAAA==",
    Area: "0",
    "Assembly Code": "A1020130",
    "Assembly Description": "Piles - Steel Pipe",
    Cost: "0",
    Depth: "6000",
    "Design Option": "-1",
    Diameter: "300",
    "Elevation at Bottom": "-7102",
    "Elevation at Bottom Survey": "-7102",
    "Elevation at Top": "-950",
    "Elevation at Top Survey": "-950",
    Family: "600mm Diameter",
    "Family and Type": "600mm Diameter",
    "Height Offset From Level": "-902",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    Length: "0",
    "Minimum Embedment": "152",
    "Moves With Grids": "Yes",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Radius: "150",
    "Structural Material": "Metal - Steel - 345 MPa",
    Type: "600mm Diameter",
    "Type Id": "600mm Diameter",
    "Type Image": "<None>",
    Volume: "0.42",
    Width: "0",
  },
  {
    ID: "512473",
    Name: "M_Pile Cap-600 Pile: 600 x 600 x 900mm",
    Category: "Structural Foundations",
    Level: "Foundation",
    Pbi2DGeometry: "1QAAAB+LCAAAAAAABABNzUELgjAYxvHv8p7n2Nymbp2igqAOIkEH8aA1dLC2sBWI+N0bVNDt5eX38K9nKDtzmu4aFBx8Zyp9Ca3rrQYEpTcuPEDV8+eMJOWYCsZWSUow4xmHpfm59Ti2U8TxsTXtTQc9giKYIDhq14cBFMUyKwSCyoc2GO9AMUw5FTLNBBOFzCWjCM7m+o/32vRDTMdglguJYGf16ztPUoYZIVFtvPUx557WLs0brIUEDdUAAAA=",
    Pbi3DGeometry:
      "SQQAAB+LCAAAAAAABACVU0uLwjAQ/i9zjiEPTW09SRUEPcgqeJA9VAwaqI3UIBTxv5vV1l3QbkZCwky+zHyTeawvMN+YZXXUkMDUbszC5mYLBObWFO4EyfryED3MBn7BlfzedDhjg/vhN1y/G7NhWWaVtxWSchVz0hGcSskiL1AluhERPcplpP4BeEylEgIBNBytQJhDUsX68ZuoGuDFFRpo5cADra6CP8cn8fOU4P+BJg93STDtwXDxndjaPp/XHN8+aPJwzR8cfiZHJjtop0tIGGUEZrrYuX2tfFmXOWOLWl2Z7ROaaLPbu1oZ5/r892Fqc+sdQsp+lh/9G17Erh1JBAAA",
    Area: "0",
    "Assembly Code": "A1010130",
    "Assembly Description": "Pile Caps",
    Cost: "0",
    "Cut-off": "150",
    "Design Option": "-1",
    "Elevation at Bottom": "-7102",
    "Elevation at Bottom Survey": "-7102",
    "Elevation at Top": "-800",
    "Elevation at Top Survey": "-800",
    "Enable Analytical Model": "Yes",
    Family: "600 x 600 x 900mm",
    "Family and Type": "600 x 600 x 900mm",
    "Height Offset From Level": "-800",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    Length: "600",
    "Moves With Grids": "Yes",
    "OmniClass Number": "23.25.05.11",
    "OmniClass Title": "Foundation Piles",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Pile Type": "600mm Diameter",
    "Rebar Cover - Bottom Face": "Rebar Cover 1",
    "Rebar Cover - Other Faces": "Rebar Cover 1",
    "Rebar Cover - Top Face": "Rebar Cover 1",
    "Structural Material": "Concrete - Cast-in-Place Concrete",
    Thickness: "300",
    Type: "600 x 600 x 900mm",
    "Type Id": "600 x 600 x 900mm",
    "Type Image": "<None>",
    Volume: "0.11",
    Width: "600",
  },
  {
    ID: "512475",
    Name: "M_Pile-Steel Pipe: 600mm Diameter",
    Category: "Structural Foundations",
    Level: "Foundation",
    Pbi2DGeometry: "1QAAAB+LCAAAAAAABAA1jUEKwjAURO/y12lI8pPa1JWoIOiiiOBCXKQaaiAmUqNQinc3ou5mhje8wwhN63bDzUIN69i6rT0lEzpvgUATXUh3qA/jN2ZESMoV4rQQjKIsJbyOf27W92bIcB4Wzlxtsj3UjDICGxu6dPkUreWEwDYmk1wMUCPlkistSoWq0hONnMDenX9w9YFX1nWXrM5CXmEelt4+f/dCIEXGFIF59DHrwsP71/ENfh3TPtUAAAA=",
    Pbi3DGeometry:
      "xxkAAB+LCAAAAAAABACtl9tq20AQht9lr2Whw+qUXJW0UGgvQlvoRfCFQ0QicK3iikIIfvduLMeKVvutdlVjEmz/mtM/M56Zuxdxe9/8eP5diyvxpb1vvrfb5kEE4rZtdt0fcXX30r9VcHStXuIQDN+s4ii6Pv5Tf+KwfhP7sN9vnpVskoaVLKtgFVdhWZVlsFLfpFGUBYkMozJNeySr0hGSZkVpkknDIj0+GinhSI6QMo2PIlUhs5GyPMmyo0gSFaWjGVDG0bBnNgfOiCyzeITIIssvFY6N6SRJpV8OZJjlhXek/vFYMsquWaiWmTwiqczBaS0JaZiXcWx2zSHZE21nmTxOMrOdqQfqWZPXJ3IUUMSldDJjq7ZFTvu6ZjPTt9WrTCXHrp2LbRJOX1I+dljG5gFr65tHIaq9ckPDmZC+dk12OB6WYTusjWSYA+4Ea/dAgVgLkbt0jCj1kXLWp6oHEa6pJdnREDQzAKyLPeNaY5815B1njmRekmUX+p2JQS4dAGRlAZFaVhDgRA4i3MukzParxdo05M0BW/tryCCCU4hHGk8UDSErw/esiv3CqWUZwmMEM4ZMXpBiB+pdWUEeHQCgZAGLk5QgsKCH5pvLtuQ51EovYwh/qoxE+KLhWwPPkzGARrQqMmniDZeOCZvDGoKEOXjMfFnyhSVG5olIV77mNSEl3ixOUoIAZ1GfXA4ik/loOshYm4boY9ikTEP0We93LfMVqyFoxrDRTHRZPJs/SHnZHperO5mXZNmFfmdikEsHAFlZQCRvxpgu105yabH5xVx3mFkhVcg8Jt6/IdA4koUS6BUeHv4HGa4NfEE5HkoOqtBd3HJQFcYxkw+TBMWBGcREYR+AKstspGGKA/4/F6JZC5Yg0Ce0DduI5dCgjd7zmrBYsDNrMI17vv8xgSYoF1Dms9lzj9v3p20diI/N5lfd1XtxpTIeiK/17rF7On341nabrml3p48/m4cz9LluHp+604dP2/rv+wdv2m2rFIqb6PUlDut/2MTnz8cZAAA=",
    Area: "0",
    "Assembly Code": "A1020130",
    "Assembly Description": "Piles - Steel Pipe",
    Cost: "0",
    Depth: "6000",
    "Design Option": "-1",
    Diameter: "300",
    "Elevation at Bottom": "-7102",
    "Elevation at Bottom Survey": "-7102",
    "Elevation at Top": "-950",
    "Elevation at Top Survey": "-950",
    Family: "600mm Diameter",
    "Family and Type": "600mm Diameter",
    "Height Offset From Level": "-902",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    Length: "0",
    "Minimum Embedment": "152",
    "Moves With Grids": "Yes",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Radius: "150",
    "Structural Material": "Metal - Steel - 345 MPa",
    Type: "600mm Diameter",
    "Type Id": "600mm Diameter",
    "Type Image": "<None>",
    Volume: "0.42",
    Width: "0",
  },
  {
    ID: "512522",
    Name: "M_Pile Cap-600 Pile: 600 x 600 x 900mm",
    Category: "Structural Foundations",
    Level: "Foundation",
    Pbi2DGeometry: "xQAAAB+LCAAAAAAABABNzc0KwjAQBOB32XMa0v8mnkQFQQ+lCB5KD2ld2kBMpEahlL67ASt4G3Y+duoZylZdpgeCgJNtVYWdk6bXCARKq4x7gqjnb/QkCWmRcb4JEk6LPIGl+bHtOMrJW3/YK3lHhyMIRhmBM5reDSBCyrMiJVBZJ52yZq2v6vbfHlH1g5+KGM3ylBM4aHyvPohiGjPm1c5q6/+bl9ZL8wG+bjzwxQAAAA==",
    Pbi3DGeometry:
      "SQQAAB+LCAAAAAAABACtk00LwjAMhv9Lzt3o5j7qdhIVBD2ICh7Ew4ZFC3OVWQQR/7tR5xTrqBMpK0mfNW+aposTjFMxO+44RDCUqZjKTKyAwFiKXO0hWpzuJmIa44Azea5YDqXxbcIPzsvHtk5RJEfc61GbMT8glsfQaIfEcu3A9UJSAR8Nn7lP4KLvOb+AWg0NaKFadkBZ+0NW76AKZQRaVu9A06g9R22o5lkZS/J9EY0azaurXW3z9qnVMJbdDP7Yu193iRkYxPFN9kSy5YoXEFGbEhjxfK02pTORKlFC5qU7F6sKDbhYb1Tp9DN+eP2xKzOJAaFLrwOf/gVxhMSuSQQAAA==",
    Area: "0",
    "Assembly Code": "A1010130",
    "Assembly Description": "Pile Caps",
    Cost: "0",
    "Cut-off": "150",
    "Design Option": "-1",
    "Elevation at Bottom": "-7102",
    "Elevation at Bottom Survey": "-7102",
    "Elevation at Top": "-800",
    "Elevation at Top Survey": "-800",
    "Enable Analytical Model": "Yes",
    Family: "600 x 600 x 900mm",
    "Family and Type": "600 x 600 x 900mm",
    "Height Offset From Level": "-800",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    Length: "600",
    "Moves With Grids": "Yes",
    "OmniClass Number": "23.25.05.11",
    "OmniClass Title": "Foundation Piles",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Pile Type": "600mm Diameter",
    "Rebar Cover - Bottom Face": "Rebar Cover 1",
    "Rebar Cover - Other Faces": "Rebar Cover 1",
    "Rebar Cover - Top Face": "Rebar Cover 1",
    "Structural Material": "Concrete - Cast-in-Place Concrete",
    Thickness: "300",
    Type: "600 x 600 x 900mm",
    "Type Id": "600 x 600 x 900mm",
    "Type Image": "<None>",
    Volume: "0.11",
    Width: "600",
  },
  {
    ID: "512524",
    Name: "M_Pile-Steel Pipe: 600mm Diameter",
    Category: "Structural Foundations",
    Level: "Foundation",
    Pbi2DGeometry: "xQAAAB+LCAAAAAAABAA1jVELgjAUhf/LfZ5j6srNnqKCoB5Egh7Eh1kXHawtbAUi/vcm2du55/u4pxqhaPRleCLkcHKNLvHmlW0NAoHCaetfkFfjLwaFx1SspdxEXFKRcZjqv7btezUENxR7rR7osYecUUbgjLb13XxIyTMCpfPKa2cXfNX3hYqZHlG3XZhKGI1FGoqDwc/iR0lKU8ZWBHbOuPDfvo2Z6i8CcEiFxQAAAA==",
    Pbi3DGeometry:
      "rRkAAB+LCAAAAAAABACtl1tr20AQhf/LPstipdXFcp5KWii0D6Et9CH4wSEiEbhWcUUhBP/3yrfYXu+3O1KKSbA9njkz58xqZ+5f1d1D8+Pld61m6kv70Hxvl82jitRd26y6P2p2/7p/25v1Tf9Sm+j0zSTR+mb3r/9Tm/nR7cN6vXjpfbMkLoo8iyZZFWdpYaJJamKjdR71lspU1c5ipkV1ZkljXWbG7WOqstxZSpObC5+kSpOdJdfbN2eWdGr2OIUuZTgcLVxPrmNTJIkwa8rNh0PRkjjPymJo1mVVTV0qsD4+HM4ty/OBlfpUYByPCuXBZ1pmQnlMkTo8fC1lsnRYqJ1Dn65O0sKB0VuSTLsa2mXZE9Zb0ix3tfqWljSR4TCVvrYN+biyptyOylyzc2zB60qPjeaqBxuAg3EC+651Jc0duD9rLgv7MA5nzdE8lbrJCZ0B7k9Xd1yCmP4H00pwNF38e2S+9DlDkXbTyYX5Yl04M3HTnhKwYNAg6jImgDkDxbhILAUxkH0MNUYWZBLhmUjLIpBrzNFHFMsFDaLnv/jOOMIMuExOLvy0wAuQExNfgCf8SxT6XvDY49qBLpTLVyHWgZog8xhqhCTEIoLj1HP+fUgl3xnBowCHx57QBKnSRCcdAgmaB11bPNdWw7sL5yXekex+e4NBg2iv48wQX0YlqBgWF3GZKtSKFUESIZZv97IsQaV8scS7n32swgbR7ineV+0L1hXMWjDtKcI5jo7YpDma5WMPPlfN6sPHgZjrR8pQMi4SS0EQZB9DjZEFmUR43ixoFSEIbnAkGE+RlJThaQmkGtun8nsfQ3k8ApQ4PHA8DiyArgK9zeCIJJ3z/+OSI8DAmSegE05cQy4AEFB+YQbB+daXXuOCbANztMODkkKHd4/qwXXAs3MMXyB4uPftVEPO/tBFNzAWulJyj4XS+SvQN/NIfWwWv+quXqtZDx6pr/XqqXs+fPjWdouuaVeHjz+bxzfT57p5eu4OHz4t67/nP7xtl20fUN3q7Utt5v8AMHdxSq0ZAAA=",
    Area: "0",
    "Assembly Code": "A1020130",
    "Assembly Description": "Piles - Steel Pipe",
    Cost: "0",
    Depth: "6000",
    "Design Option": "-1",
    Diameter: "300",
    "Elevation at Bottom": "-7102",
    "Elevation at Bottom Survey": "-7102",
    "Elevation at Top": "-950",
    "Elevation at Top Survey": "-950",
    Family: "600mm Diameter",
    "Family and Type": "600mm Diameter",
    "Height Offset From Level": "-902",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    Length: "0",
    "Minimum Embedment": "152",
    "Moves With Grids": "Yes",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Radius: "150",
    "Structural Material": "Metal - Steel - 345 MPa",
    Type: "600mm Diameter",
    "Type Id": "600mm Diameter",
    "Type Image": "<None>",
    Volume: "0.42",
    Width: "0",
  },
  {
    ID: "512526",
    Name: "M_Pile Cap-600 Pile: 600 x 600 x 900mm",
    Category: "Structural Foundations",
    Level: "Foundation",
    Pbi2DGeometry: "1AAAAB+LCAAAAAAABABNzUELgjAcBfDv8j/PsblN3TpFBUEdRIIO4kFr6GBtYSsQ8bs3qKDb4/F7vHqGsjOn6a5BwcF3ptKX0LreakBQeuPCA1Q9f2IkKcdUMLZKuMRFzmFpfmw9ju0UbSy2pr3poEdQBBMER+36MICiWGaFQFD50AbjHSiGKadCpplgopC5ZBTB2Vz/8V6bfojPKcFZLiSCndWv7zxJGWaERLXx1sc797R2ad6TgP/91AAAAA==",
    Pbi3DGeometry:
      "SQQAAB+LCAAAAAAABACVU80KwjAMfpecu9J1buvmSVQQ9CAqeBAPE4sW5iqzCCK+u1U3FXQ2Elqafk2+/HVxhvFKzU57CSkM9UpNda7WQGCsVWEOkC7Oj6OFWdsKXMjrxvMZa983u+CyrM06ZZmdrC0PqB8lPvFCRkUoOPE4jXgrJjykfhBHP4CWoEIkMQKoORoBN0dAIyaSL1HVwIcrNNDIgQcaXTkzxxfx/5Lg80CTu6fEWXZnuPhJbByf/3uOHx80ubvnDw77J3sq20kjS0gZZQRGstiYbaVMtMmM0kWlztX6CQ2k2mxNpfRzeXx/2NW5tg6hy25iv/4VkRpb6UkEAAA=",
    Area: "0",
    "Assembly Code": "A1010130",
    "Assembly Description": "Pile Caps",
    Cost: "0",
    "Cut-off": "150",
    "Design Option": "-1",
    "Elevation at Bottom": "-7102",
    "Elevation at Bottom Survey": "-7102",
    "Elevation at Top": "-800",
    "Elevation at Top Survey": "-800",
    "Enable Analytical Model": "Yes",
    Family: "600 x 600 x 900mm",
    "Family and Type": "600 x 600 x 900mm",
    "Height Offset From Level": "-800",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    Length: "600",
    "Moves With Grids": "Yes",
    "OmniClass Number": "23.25.05.11",
    "OmniClass Title": "Foundation Piles",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Pile Type": "600mm Diameter",
    "Rebar Cover - Bottom Face": "Rebar Cover 1",
    "Rebar Cover - Other Faces": "Rebar Cover 1",
    "Rebar Cover - Top Face": "Rebar Cover 1",
    "Structural Material": "Concrete - Cast-in-Place Concrete",
    Thickness: "300",
    Type: "600 x 600 x 900mm",
    "Type Id": "600 x 600 x 900mm",
    "Type Image": "<None>",
    Volume: "0.11",
    Width: "600",
  },
  {
    ID: "512528",
    Name: "M_Pile-Steel Pipe: 600mm Diameter",
    Category: "Structural Foundations",
    Level: "Foundation",
    Pbi2DGeometry: "1AAAAB+LCAAAAAAABAA1zVELgjAUBeD/cp/X2NyWmz1FBUE9iAQ9iA9aQwdrC1uBiP+9SfZ27+E7nHKEvDGX4akhg5NvTKFvoXat1YAg98aFF2Tl+DsjSTimgrHNiissUw5T9Wfbvq+HaGOwN/VDB91DRjBBcNauDd38KMVTBIUPdTDeQcYw5VSoZC2YkCpVjCK4mvuC5YyP2rRdXE4IppLF4GD1Z6mvEoYZIQLBzlsf59zb2qn6AkEYKM7UAAAA",
    Pbi3DGeometry:
      "sxkAAB+LCAAAAAAABACtV01r20AQ/S97lsVqvyQ5p5AWCu0htIUegg8OEYnAtYorCiH4v3djOVG03jeeFcYkRHqerzczmZm7F3F73/58/tOIpfja3bc/uk37IDJx27Xb/q9Y3r0Mf3pYXvmP2Gfjm0Uh5dXhl/8R+9Wb2PVut372skrntanqbGHq3Cins4V/o6W0mTK5rLQ+ILpy9QTRtqxiMjovdT3IOFnWE6TSxQGwUhUTZU5Ze0BKbTXTDFCGo8GeUQ4MiJW5LJSbIKa07lLhUEwrpU1aDkxuXZkcaXo8REaxawTVxg6BVqVh5UDnriqKuGfnch3TNsh4pDCyiNiJeuAKFXH6SI2XUMbWLCtUrc3yOdEzysrQUx7RqnCRSotFM9RTih0sQ3mAtQ2d8yrjiqlvQ7fFkKFwY3ZwPFgG28HakAzmAPcB2Tvx+iDLEHboBPC6pfc0paJHEVxQc1ITINDMCGBd2DNcaNjnAPnAGY/LS5LMYZ/NC6SSAUBSZvAYJAUCOI+jCO5jpIz6j4W1BcibA1TrB8goAgcQHmZ4mAQIsjK+x6qwX2hgEdN3isCEQSIvyDCDeS4pkEYGACiZwWKYEfR+RgOd7yxqtztTKO8iYexRXUgEnzH4wIA3yRSARoISimnCey26ICiHAwQSxvAY84XThcoLGUc0ctk6rwkSkszhSUIggHMYziyGyMlkjN1gWFuAhAM4pixAwimfdiDjwzVAoJlwl4npIjyjb1C8YZ9UK5/LS5LMYZ/NC6SSAUBWZhAJN2KULG4bcfoLepVekBCA2YX+Qq+gDUQiEIAbBrHvIxNYAJ40ac7yDxrGqZF+nEAbcB0CEgTpUBWkBNYOdy4xpiJvIDO2h+SRDwSIIPByGF1DCGbhcYG2+MQLgrAw4x4glyz+6QRLcIZtWOVnKOdnFahaZeJTu/7d9M1OLH3omfjWbB/7p+PD965f9223PT7+ah/eoS9N+/jUHx8+b5p/H7940206r1DcyNeP2K/+AzNZ+DqzGQAA",
    Area: "0",
    "Assembly Code": "A1020130",
    "Assembly Description": "Piles - Steel Pipe",
    Cost: "0",
    Depth: "6000",
    "Design Option": "-1",
    Diameter: "300",
    "Elevation at Bottom": "-7102",
    "Elevation at Bottom Survey": "-7102",
    "Elevation at Top": "-950",
    "Elevation at Top Survey": "-950",
    Family: "600mm Diameter",
    "Family and Type": "600mm Diameter",
    "Height Offset From Level": "-902",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    Length: "0",
    "Minimum Embedment": "152",
    "Moves With Grids": "Yes",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Radius: "150",
    "Structural Material": "Metal - Steel - 345 MPa",
    Type: "600mm Diameter",
    "Type Id": "600mm Diameter",
    "Type Image": "<None>",
    Volume: "0.42",
    Width: "0",
  },
  {
    ID: "512683",
    Name: "Floor: Timber Suspended Floor",
    Category: "Floors",
    Level: "Level 1 Living Rm.",
    "Aalto Vase Material": "0.1",
    "Architrave Offset": "74",
    "Coarse Poche Material": "0",
    "Coarse Scale Fill Color": "<Solid fill>",
    CosAng: "0",
    "Default Elevation": "247",
    Description: "-1",
    Elevation: "-797",
    "Elevation at Bottom Survey": "-550",
    "Emit from Line Length": "No",
    "Facucent Drilling": "Timber Suspended Floor",
    Family: "Timber Suspended Floor",
    "Full Step Arrow": "Interior",
    "Heat Load Values": "0.0000 /(·)",
    "Height 1": "0",
    Illuminance: "<None>",
    "Parts Visibility": "37396",
    Phase: "Working Drawings",
    "Phase Created": "None",
    "Referencing Sheet": "No",
    Rim: "Yes",
    "Rough Width": "1",
    "Slab Thickness": "0.00°",
    "Story Above": "No",
    Structural: "Structure - Timber Joist/Rafter Layer",
    "Text Type": "0.00 /",
    "Thermal Mass": "0.0000 (·)/",
    "Thermal Resistance (R)": "247",
    "Tumble Dryer": "Timber Suspended Floor",
    "Type Comments": "Timber Suspended Floor",
    "Type Id": "<None>",
    Voltage: "18.33",
  },
  {
    ID: "513254",
    Name: "Precast Stair: Precast Stair",
    Category: "Stairs",
    "Actual Lighting Load per area": "3",
    "Actual Power Load per area": "181",
    "Actual Riser Height": "300",
    "Base is Attached": "Level 1 Living Rm.",
    "Base Material": "0",
    "Connection cable length": "Notch",
    CosAng: "0",
    Cut: "Single Zigzag",
    Description: "-1",
    "Designed By": "3",
    "Desired Number of Risers": "550",
    "Facucent Drilling": "Precast Stair",
    Family: "Precast Stair",
    "Full Step Arrow": "Interior",
    "Horizontal Align": "10",
    Illuminance: "<None>",
    "Landing Height Adjustment": "220mm Thickness",
    "Left Attachment": "0",
    "Left Lateral Offset": "None",
    "Left Support": "<None>",
    "Maximum Ridge Height": "181",
    "MCB Rating": "No",
    "Middle Support": "0",
    "Middle Support Number": "<None>",
    "Minimum Embedment": "1000",
    "Minimum Run Width": "280",
    "Non-Plan View Symbols (Default)": "100",
    "Notch Extension": "100",
    Phase: "Working Drawings",
    "Phase Created": "None",
    "Read Convention": "Rebar Cover 1",
    "Right Attachment": "0",
    "Right Lateral Offset": "None",
    "Right Support": "<None>",
    Roughness: "190mm Depth",
    "Top is Attached": "Level 1",
    "Top Material": "0",
    "Track/Bswy Length": "1",
    "Tumble Dryer": "Precast Stair",
    "Type Comments": "Precast Stair",
    "Type Id": "<None>",
    "Vertical Align": "10",
  },
  {
    ID: "513460",
    Name: "Automatic Up/Down Direction: Standard",
    Category: "Stair Paths",
    "Area per Person": "Arrow Open 90 Degree 1.25mm",
    Description: "-1",
    "Distance from Wall": "3",
    "Door thickness": "DN",
    "Facucent Drilling": "Standard",
    Family: "Standard",
    "Front Tempered Glass Material": "No",
    "Line Pattern": "Straight",
    "Ordinate Dimension Settings": "Horizontal",
    "Show Area": "No",
    "Show Capital": "Yes",
    "Show Title": "Yes",
    Stand: "0",
    "Start Extension": "None",
    "Text Size": "2.5mm Arial",
    "Tumble Dryer": "Standard",
    "Type Comments": "Standard",
    "Units Format": "UP",
  },
  {
    ID: "513461",
    Name: "Automatic Up/Down Direction: Standard",
    Category: "Stair Paths",
    "Area per Person": "Arrow Open 90 Degree 1.25mm",
    Description: "-1",
    "Distance from Wall": "3",
    "Door thickness": "DN",
    "Facucent Drilling": "Standard",
    Family: "Standard",
    "Front Tempered Glass Material": "No",
    "Line Pattern": "Straight",
    "Ordinate Dimension Settings": "Horizontal",
    "Show Area": "No",
    "Show Capital": "Yes",
    "Show Title": "Yes",
    Stand: "0",
    "Start Extension": "None",
    "Text Size": "2.5mm Arial",
    "Tumble Dryer": "Standard",
    "Type Comments": "Standard",
    "Units Format": "UP",
  },
  {
    ID: "513463",
    Name: "Automatic Up/Down Direction: Standard",
    Category: "Stair Paths",
    "Area per Person": "Arrow Open 90 Degree 1.25mm",
    Description: "-1",
    "Distance from Wall": "3",
    "Door thickness": "DN",
    "Facucent Drilling": "Standard",
    Family: "Standard",
    "Front Tempered Glass Material": "No",
    "Line Pattern": "Straight",
    "Ordinate Dimension Settings": "Horizontal",
    "Show Area": "No",
    "Show Capital": "Yes",
    "Show Title": "Yes",
    Stand: "0",
    "Start Extension": "None",
    "Text Size": "2.5mm Arial",
    "Tumble Dryer": "Standard",
    "Type Comments": "Standard",
    "Units Format": "UP",
  },
  {
    ID: "515270",
    Name: "Level: 8mm Head",
    Category: "Levels",
    "Branch Circuit Current Phase C": "Yes",
    "Cold Water Radius": "0",
    Comments: "0",
    Description: "-1",
    "Electrical Data": "-550",
    "Elevation at Top Survey": "Project Base Point",
    "Facucent Drilling": "8mm Head",
    Family: "8mm Head",
    "Limit Offset": "Dash - Tight",
    "Line Style": "1",
    "Schedule Level": "None",
    "Start Symbol Type": "Default",
    "Story Above": "No",
    "Switch ID": "M_Level Head - Circle",
    Symbol: "No",
    "Symbol at End 1 Default": "Yes",
    "Tumble Dryer": "8mm Head",
    "Type Comments": "8mm Head",
  },
  {
    ID: "523063",
    Category: "Topography",
    "Cushion/Chair Back Material": "0",
    Description: "-1",
    "File Path": "0",
    Illuminance: "<None>",
    "Mass Floors": "Grass",
    "Moves With Nearby Elements": "0",
    Phase: "Working Drawings",
    "Phase Created": "None",
    Profile: "287",
    "Suppress Spaces": "287",
  },
  {
    ID: "523531",
    Name: "wardrobe2: wardrobe",
    Category: "Furniture Systems",
    Level: "-1",
    Pbi2DGeometry: "ugAAAB+LCAAAAAAABAA1jcsKwjAQRf9l1iGk9mEaV6KCoItSBBeli9QO7UBMpEahlP67EetuuOfcO9UERUOX8YGg4OQaKvHmte0MAoPCkfVPUNX0O4MS8SwRyUbAXP/5dhj0GKQQ7Enf0eMASnDB4Iy28z2oiOeZTBmUzmtPzi74Su2XxjyP1wyOSF0fXkguUxkzOBh8L3bOZbIK/Z0zLmzblzFz/QGOI7f0ugAAAA==",
    Pbi3DGeometry:
      "7wMAAB+LCAAAAAAABACtk10LwiAUhv/LuTYxc7Stq6ggqIuooIvoYmNSwpphEkT037NaH5NNElLUnUd9PTt61heYpWJ5PnCIYSJTsZC5yADBTIpCHyFeX56fZpr0TIUr+pBWm5DeozMNrpvXtr5SydnsbTHcoYwhhmkQRagd4i4hIXphYgb6hSnuBEHkiRu0bVwViXDIaGA7YtFSwk2rXljU0m3wuF7Cxwn3P/8YIae0T9zsi/J7BPXSzoA66V8e3U+37aTu80zmDEWy55oriAkmCKa82OpdacylTrSQRWmuRPaeGnOx3enSGOX89L1wIHOp7pn7KCZBb/Iq2ZPvAwAA",
    Area: "1",
    Cost: "0",
    "Design Option": "-1",
    Family: "wardrobe",
    "Family and Type": "wardrobe",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "wardrobe",
    "Type Id": "wardrobe",
    "Type Image": "<None>",
    Volume: "1.94",
  },
  {
    ID: "525603",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jUELgjAcxb/L/zzH5tS5dYoKgjqIBB3Ew6yhg7WFrUDE754l3t7v8Xu8aoSiMZfhqUHCyTem1LegXGs1ICi8ceEFshqXOCsRzTBhfBNRglPCBEz16m37Xg2zPBd7ox466B4kwQTBWbs2dD+gjMYISh9UMN6BpDjlhIuMxRkXSS7SBMHV3BeZxTlFcNSm7cKfM84QHKz+rGuBGeUcwc5bP5+5t7VT/QVTE88S0wAAAA==",
    Pbi3DGeometry:
      "UgQAAB+LCAAAAAAABACllFFrwjAQx7/LPcdwSZvW1KehwmA+yDbYg+yhYtBAbUYXBBG/+9Ku27RwEF1KQu9++fOnd01WJ1iu7evxw0ABT25tX1xlN8Bg6WztP6FYnb5fA8ZJeODM/jIjgTjpljDh/P4je2ia8hi0I5FxiYKFLVxhopnQPBUyYZdASkxbkI3VVV5I3eWVxkiQ5DJvQaKylEV5k4qBh+LjXOq7CWkzALQkyua6kjFgUJgof1pDdfLWPO0Q28h/fghpc4c/Wfvb/28SxDQ+HM6ZLffGmwYK5MhgYeqt3/XBs/Olt67uwze7+UWPxm53vg/mlTlcbpy6yjXt5dCNcAd8AWNwTwJSBAAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "120",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "529515",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "529516",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "529517",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "529518",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "530178",
    Name: "Basic Wall: SIP 202mm Wall - conc clad",
    Category: "Walls",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjjELwjAUhP/Lm9PQJARjnUQFQYcigkPp0GJIAzFPahRK6X830Nalg9u79x13V/SQ1/baPTVkcMLa5ug6gx4I5Gh9eEFW9OMZDQlndKXkZk0l4xIGskQJS6kSUiwg41z8oXNsOZdv27bq4oL42NvqoYNuIUtpSuCsvQnNJC4YqmDj6FHe7P2HjtqaJpbECsEZI3Bw+jOZFVVSCQI7dBhz/du5ofwCr1eJthEBAAA=",
    Pbi3DGeometry:
      "nA0AAB+LCAAAAAAABAClV0trwzAM/i8+O8Z2XnZ7Gnsw2A5lG+wwdmhpaA1dM7owKKX/fU6b9GXLj47QEkuyJH+WPysfGzSaqLf1d4UG6KmeqNd6oaYIo1Gtls0PGnxs9q9aTYf6QVt8lCSM0uHuT//Q9rOfdrNajdd6bsIZKUWOJRFZKrEgIhcp7qWCFJyynZLn+MKWSVIUogwzvnCcSCIzLuM8a7EUmTg6oYQXZYlTSlgpM595VNqtb50x5pLwjKfXxgTWmTBGWFEUBiy9vE1SZhZFFI6AcZtkzgOCAmuFJwABABAAayiqZUcYb18s2HQKSnJ6jsNeYSbklkOOzNrxZAQGOEFUQIoeas8UE1a33OfImex5TlAIy5a68JOECcYM9MyqdlmDexO3l2BQg0wOS7VXKYRBNGhgCAsHOeWuNVgjQxM8gQPJL257TbHTh5UPoWMKhIT5BFZ4eD6E/32HzlUnEJHG0XpMBGehAFcwII5PFL4JfPwaMuOfIcBsLxUR6AVQlPeExDVezgPvZD+onbLJHR1fsP/Y29DTk1jTj71rwxuPKxqnyK4GuPDspA1QuT3BYM+x15ajNM6c68+cOzX+qppqhQaUUIyeq+WsmXeDl7oZN6pedsN3NT2oHis1mzfd4H5R/Z4a3taLWjtED7J99NfUHx0ke86cDQAA",
    Absorptance: "0.1",
    Area: "6",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "-300",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    Cost: "0",
    "Cross-Section": "Vertical",
    Description: "Structural Insulation Panel Wall with Kiln Dried Timber Panel Rainscreen",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "SIP 202mm Wall - conc clad",
    "Family and Type": "SIP 202mm Wall - conc clad",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "47.5455 /(·)",
    Image: "<None>",
    Keynote: "F10",
    Length: "6202",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Structure - Timber Insulated Panel - Insulation",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "3.09 /",
    "Thermal Resistance (R)": "0.0210 (·)/",
    "Top Constraint": "Roof Line",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "0",
    Type: "SIP 202mm Wall - conc clad",
    "Type Id": "SIP 202mm Wall - conc clad",
    "Type Image": "<None>",
    "Type Mark": "WT1",
    "Unconnected Height": "3300",
    Volume: "1.19",
    Width: "202",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Both",
  },
  {
    ID: "534688",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "534689",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "534690",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "534691",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "549031",
    Name: "Floor: Generic 300",
    Category: "Floors",
    Level: "Level 2",
    "Aalto Vase Material": "0.1",
    "Architrave Offset": "9",
    "Coarse Poche Material": "0",
    "Coarse Scale Fill Color": "-1",
    CosAng: "0",
    "Default Elevation": "300",
    Description: "-1",
    Elevation: "2700",
    "Elevation at Bottom Survey": "3000",
    "Emit from Line Length": "No",
    "Facucent Drilling": "Generic 300",
    Family: "Generic 300",
    "Full Step Arrow": "Interior",
    "Heat Load Values": "0.0000 /(·)",
    "Height 1": "0",
    Illuminance: "<None>",
    "Parts Visibility": "15000",
    Phase: "Working Drawings",
    "Phase Created": "None",
    "Referencing Sheet": "No",
    Rim: "Yes",
    "Rough Width": "1",
    "Slab Thickness": "0.00°",
    "Story Above": "No",
    Structural: "SH_resin Floor",
    "Text Type": "0.00 /",
    "Thermal Mass": "0.0000 (·)/",
    "Thermal Resistance (R)": "300",
    "Tumble Dryer": "Generic 300",
    "Type Comments": "Generic 300",
    "Type Id": "<None>",
    Voltage: "2.7",
  },
  {
    ID: "550255",
    Name: "Floor: Generic 150mm",
    Category: "Floors",
    Level: "Level 1 Living Rm.",
    "Aalto Vase Material": "0.1",
    "Architrave Offset": "18",
    "Coarse Poche Material": "0",
    "Coarse Scale Fill Color": "-1",
    CosAng: "0",
    "Default Elevation": "150",
    Description: "-1",
    Elevation: "-700",
    "Elevation at Bottom Survey": "-550",
    "Emit from Line Length": "No",
    "Facucent Drilling": "Generic 150mm",
    Family: "Generic 150mm",
    "Full Step Arrow": "Interior",
    "Heat Load Values": "0.0000 /(·)",
    "Height 1": "0",
    Illuminance: "<None>",
    "Parts Visibility": "18002",
    Phase: "Working Drawings",
    "Phase Created": "None",
    "Referencing Sheet": "No",
    Rim: "Yes",
    "Rough Width": "1",
    "Slab Thickness": "0.00°",
    "Story Above": "No",
    Structural: "SH_resin Floor",
    "Text Type": "0.00 /",
    "Thermal Mass": "0.0000 (·)/",
    "Thermal Resistance (R)": "150",
    "Tumble Dryer": "Generic 150mm",
    "Type Comments": "Generic 150mm",
    "Type Id": "<None>",
    Voltage: "2.7",
  },
  {
    ID: "554383",
    Name: "Single Window: Standard",
    Category: "Windows",
    Level: "Level 2",
    Pbi2DGeometry: "zgAAAB+LCAAAAAAABAA1jUELwiAcxb/L/yyibm5qp6ggqMMYQYexgyvZBNNYFoyx755R3d57/B6/Zoaqs6fpbkDBIXS2Npeofe8MIKiC9fEBqpm/MSGM4JKIfCUxp4zD0v6p9TjqKaFp2Fp9M9GMoAgmCI7G93EAlWPJaIagDlFHGzyoDNOccskKnnEhS4ngbK8flOCsIKnuje2HpBVYSEoR7Jx5/b4SCyJLBJvgQjL5p3NL+wauWkvOzgAAAA==",
    Pbi3DGeometry:
      "aSMAAB+LCAAAAAAABAClmk1r20AQhv+Lzq5ZafWxSk4lLRTaQ2gLPYQcEmISgRsV1xRCyH+vrMiWtPvO7IxMyIcej9+d2ZmdWUNuXpPr++bny59NcpF8be+bH+22eUhWyXXbPO//Jhc3r+9/di+by+4reVuN5ENqzGX/o/tO3m6Pb/u42929dO/N7Dot63RVr43Lqu6XK1y9Gql1eUHS2rg0SgddTHvd1K2zvHKeQkA9W6zAUqwromwUIqpZDUes2XWWYl3RTrL1IKLn5w1X6gIqynGZ2rKnaTmjuQ1tC5fmaurp4tUQrW3Rx2arNOpZnWcH6kxdAZpnxVJdaKvRPVLs2YGOGSLoRDe0Pfgw0mkUMVtCl10Nezan02yOdFolMX8pW1Z3RnEUWEGzZ7hKNJTIBUtxlXjVt4Bqqo+2lZ5Cj2JdluJKpXWlVHICcO3wZ15CqZqU17qmp2KKdSMUn1hSV0xFnSDWNZbNLKzr0TzPD2nsp39q1qkpAto9Wmf9a0X3WBnjVlm2rqssE1oT2r4IduREvevNvM3462FjIIyd8G5Iy8ImrAlt7HR4VevpOU5D40C4r65gj95pEMgRe9mWWBPavgh2xA9lOBLezs3Xw8ZQGDvhndZlYRPWhDZ2OmgbXpkvcBoa8xtKKwuOZhgggSU5jBnrVsSnML7/MefipzvW6xgfiKQIhVWtVVZHRJETo0aCuaOpPMaCMcgOCVWzjBhrliOmKNtAeeuoti5Tvic2L6fRGFOWE5y5MiWxWxe2rOL46AnEo/bgYH7wS1MH0sjz4QnQk3CR23QSdmZsPsGDLaJdVLauo/S4QxAPyl3nMZUp/R0aMZsUKSa05/hUY5NdUl4NWQpl59BV1gU7dMJMRoSUEGYzMpSynxEC8/mLZnu+5HyXdC1C1sHonIyys00aqtlLCqZsAqPZ9k8P31/YpEgx27uCpEhmAikNP4fFykAwj8kPGZq6izUI0akn8qUInG7yMDHY6+gIWuA2NsbDjR9YunmPjyheUHQWx3OLdcF4i7UJZkDG+oGiJ3HTQzQQcIrE8ZKjH2cidDdyJ1F7i23xVYe9vog6e0DZqw5vHR3D/p2Gv0bN5y3WVjp41uQfm7hiq+gLnSJ4+oaLtAm/iQl7nt+EdaBtbYHaBouDXM6wr03gsFNZW6HD0OOw1yzAhDaPCRFhlPxW6YKPWuuWZNPAb2zUQUlVEQWhy2XUWrckkcvpkrer5FNz93uz3+ySi+7wrZJvm+fH/dPw8L3d3+2b9nl4/NU8nF76smken/bDw+ft5t/U8KrdtrvD/8wYZ64O/xrzH5yor4lpIwAA",
    "Analytic Construction": "<None>",
    Area: "6",
    "Bottom Hung Casement": "No",
    Casement: "SH_Aluminum, Anodized Black",
    "Casement Depth": "60",
    "Casement Pivot": "No",
    "Casement Swing in Plan": "No",
    "Casement Width": "60",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    Description: "Single Window Unit - Triple Glazed",
    "Design Option": "-1",
    Family: "Standard",
    "Family and Type": "Standard",
    Frame: "SH_Aluminum, Anodized Black",
    "Frame Depth": "60",
    "Frame Depth over": "80",
    "Frame Depth under": "80",
    "Frame Width": "60",
    Glass: "<By Category>",
    "Head Height": "2700",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2700",
    "Host Id": "SIP 202mm Wall - conc clad",
    Image: "<None>",
    "Install Depth (from outside)": "80",
    Mark: "28",
    Operation: "SinglePanel",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rough Height": "2700",
    "Rough Width": "1500",
    "Sill Height": "0",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Hung Casement": "Yes",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Type Mark": "46",
    "Visual Light Transmittance": "0",
    Volume: "0.15",
    "Wall Closure": "By host",
    Width: "1500",
    "Window Cill Exterior": "SH_Aluminum, Anodized Black",
    "Window Cill Interior": "Wood_Walnut black",
  },
  {
    ID: "554644",
    Name: "M_Wind Power Generator: 9 Meters High",
    Category: "Site",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jV0LgjAYhf/Le73G5j6cdhUVBHUhEnQhXmgNHawtbAUi/vcm1d3hPM/hVBMUrTmPDw05HH1rSn0NjeusBgSFNy48Ia+mb4yKTDFjNFuvEsxSAXP9tzbD0IxRjcXONHcd9AA5wQTBSbsu9JBLnBIqEJQ+NMF4t2DJpaBKZYQoRQUXEV/MbbE5TjIqERy06fr4zBjOEhX53ur3b0/jnnAEW299fHMva+f6A6pByHzSAAAA",
    Pbi3DGeometry:
      "6wcAAB+LCAAAAAAABADtk80LgjAYxv+X97zG/Fqmp6igQweJoEN0MBo1MBe2gpD+96S0j9GcnhOZ+P589rh37lnlEG344npkEKTnJEEQCZ7KEwSr/PkIAZCwuOCG3qRnERI+bsWA27qaNsyy+FrMpQ72B56Deh52+tRFFqYucVHfwr5NqQ7bmPi2XVGDx2/xNzV8r8KOhz3qD1RrFdcvRGNS34yKKxOlHRVrXDTqNjtVS+uNm4kNrbT8Yw1ddHITb3lQTDaNdqbI0pjHByZZBgHBBMGMpTu5L4u5kLHkIi3LJd++Xk0Z3+1lWUwSdvkUjkQismfGH0HuQt+Fvgv9H4V+fQeGtFdl6wcAAA==",
    Area: "3",
    Cost: "0",
    "Design Option": "-1",
    Family: "9 Meters High",
    "Family and Type": "9 Meters High",
    Host: "Level : Level 1",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "500",
    "OmniClass Number": "23.75.10.31",
    "OmniClass Title": "Wind Energy Equipment",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Pole Height": "9000",
    "Total Height": "9300",
    Type: "9 Meters High",
    "Type Id": "9 Meters High",
    "Type Image": "<None>",
    Volume: "0.24",
  },
  {
    ID: "566588",
    Name: "Railing: SH_1100mm",
    Category: "Railings",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjjELwjAUhP/Lm9PQpGls6yQqCDoUERxKh4qhDcQ8qVEopf/dQGsdHNzeve+4u6KH/KJP3V1BBnu86BxNV6MFAjlq6x6QFf14egOPKJMpWwYypJzJGAbyhYLTJF6IPzBOf+EcO8PyU79q26rzG/xjo6ubcqqFLKQhgYOytWsmcURXOe1nj/KsrzPaKV03vkVQwdKIwNao1+QNOJVMJATWaNDn2qcxQ/kGfh8PlhMBAAA=",
    Pbi3DGeometry:
      "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",
    "Angled Joins": "Add Vertical/Horizontal Segments",
    "Baluster Offset": "0",
    "Base Level": "Level 1 Living Rm.",
    "Base Offset": "0",
    Cost: "0",
    "Design Option": "-1",
    Family: "SH_1100mm",
    "Family and Type": "SH_1100mm",
    Height: "1100",
    Image: "<None>",
    "Landing Height Adjustment": "0",
    "Lateral Offset": "0",
    Length: "6001",
    "Offset from Path": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "None",
    "Rail Connections": "Trim",
    "Railing Height": "1100",
    "Tangent Joins": "Extend Rails to Meet",
    Type: "SH_1100mm",
    "Type Id": "SH_1100mm",
    "Type Image": "<None>",
    "Use Landing Height Adjustment": "No",
    "Use Top Rail": "Yes",
  },
  {
    ID: "566603",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "566606",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "566610",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
  },
  {
    ID: "567887",
    Name: "Railing: SH_1100mm",
    Category: "Railings",
    Pbi2DGeometry: "DAEAAB+LCAAAAAAABACFjkELgkAQhf/LnLdFd81cO0UFQR0kgg7iwWjRgW0nbAtE/O8taB7q0G3efI/3Xt5BdsFTe9eQwp4umJFpK7LAICO07gFp3g2nN8iEJ2GilrOYi7mS0LNfprgQ8Rda/EVTYvEpXjVN2fp2/9hgedNON5AGPGBw0LZy9SiO5EqHfvAgz3id0E5jVfuSiEehkgy2Rr9Gr+KBFILBmgz5WPs0pi/e0kcLWwwBAAA=",
    Pbi3DGeometry:
      "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",
    "Angled Joins": "Add Vertical/Horizontal Segments",
    "Baluster Offset": "0",
    "Base Level": "Level 2",
    "Base Offset": "0",
    Cost: "0",
    "Design Option": "-1",
    Family: "SH_1100mm",
    "Family and Type": "SH_1100mm",
    Height: "0",
    Image: "<None>",
    "Landing Height Adjustment": "0",
    "Lateral Offset": "0",
    Length: "4720",
    "Offset from Path": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "None",
    "Rail Connections": "Trim",
    "Railing Height": "1100",
    "Tangent Joins": "Extend Rails to Meet",
    Type: "SH_1100mm",
    "Type Id": "SH_1100mm",
    "Type Image": "<None>",
    "Use Landing Height Adjustment": "No",
    "Use Top Rail": "Yes",
  },
  {
    ID: "568017",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "568020",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "568024",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
  },
  {
    ID: "599841",
    Name: "Basic Wall: Retaining - 300mm Concrete",
    Category: "Walls",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABAB9jrEKwjAQht/l5hiSNqWmTqKCoEMRwaF0aDGkgZhIjUIpfXcPWjsouN1/3899V/SQ1+bc3RVkcPC1yb3ttHdAIPfGhQdkRT+OWFgwKkXCV2JJozSKYSC/LOU0jdkX41RGUvxl883yo163bdWhHxdbU91UUC1kjDICR+V0aKZw8qEKBl8e48VcZ7RXRjco4ZzyREgCO6teU1mglscENt56vOue1g7lG4LZhSgPAQAA",
    Pbi3DGeometry:
      "LQUAAB+LCAAAAAAABACdlFFrwjAQx7/LPcdwidXa+iRuMNAHUcEH2UPFoIHajBoEEb+72UzdaBYSJbTp/fLPXXp3ZH2B2UYuz18CcpiojVyoUm6BwEzJSh8hX1/un2YZh2bAlfySDkMc/rzMA9fPZtuorouz2dtBmiU9RpKUpgPkhPUppn1G2jyhGWfdB04Z5d2Bg31ePPIG++QO55Rz3nPcWBwrD0Rt5MzMWeL+k+VO1BZvufHgdn59QePO+FrMuJoG1J6QT5YikNvoWkQ2UlAfKIe3TE/1QKiTok//f5J9SQvxuK4JYOvc3DtvsjgILWrIkSKBqah2em+NudKFlqqy5kpuH0sfQu722hrvpTj9FY5VqYxDGOP3MNfbDbgnuwstBQAA",
    Absorptance: "0.1",
    Area: "25",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "-1500",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "Concrete",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "Yes",
    Family: "Retaining - 300mm Concrete",
    "Family and Type": "Retaining - 300mm Concrete",
    Function: "Retaining",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Length: "7150",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rebar Cover - Exterior Face": "Rebar Cover 1",
    "Rebar Cover - Interior Face": "Rebar Cover 1",
    "Rebar Cover - Other Faces": "Rebar Cover 1",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "Yes",
    "Structural Material": "Concrete - Cast In Situ",
    "Structural Usage": "Bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Unconnected",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "0",
    Type: "Retaining - 300mm Concrete",
    "Type Id": "Retaining - 300mm Concrete",
    "Type Image": "<None>",
    "Unconnected Height": "3400",
    Volume: "7.6",
    Width: "300",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "599906",
    Name: "Basic Wall: Retaining - 300mm Concrete",
    Category: "Walls",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABAB9jksLwjAQhP/LnmNoNql9eBIVBD0UETyUHiqGNhATqVEopf/dQB/ixdvOfsPM5B1kV3VuHxJSONiryqxuK2uAQGaVcU9I8244vWHBqOARriJGkccIPfkywWnIlvF/hhQRwx82Z06smKrXTVO2vt8/tqq8SycbSAMaEDhKU7l6FCfrSqf85EFe1G1Ge6mq2pcwRlkoEgI7Ld+jWdAEGSewsdr6XPPSui8+jdw7sA8BAAA=",
    Pbi3DGeometry:
      "LwYAAB+LCAAAAAAABACtVFFLwzAQ/i/3nIVLmq5r9yRTEPRhqODD8GFjYQvURmoQxth/N9a2usw0KUhoyX253N13ubvVEZYb9XR4k1DAnd6oR12qLRBYalWZdyhWx++tPca5XXAiP8iEIc6bn/3g9NJdu6rr9cHenSDNRcpIxihPZpzkNElREBcWNOcsISKhyEXmwq42m1LMpuwCz+lM8PTCil+9iSXSqcd4F7mgiHmITxeJo93DcerDyYpn3/DpYU45t7Lrcxh22J+jrmkP7GM/bGWUy8gnDiR2kPq4h3eoj32E/ykrn9dgu3lyHuqf884PpGC4CyPHiqfGY8dKIC/dRPi7AmIaJbLZYsaBnbzXav0qjayhQIoE7mW1M/tWeNBmbZSuWvFZbfujW6l2e9MKN6X8+K240KW2BmGBX8sO+E9+rD+eLwYAAA==",
    Absorptance: "0.1",
    Area: "47",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "-1500",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "Concrete",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "Yes",
    Family: "Retaining - 300mm Concrete",
    "Family and Type": "Retaining - 300mm Concrete",
    Function: "Retaining",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Length: "13702",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rebar Cover - Exterior Face": "Rebar Cover 1",
    "Rebar Cover - Interior Face": "Rebar Cover 1",
    "Rebar Cover - Other Faces": "Rebar Cover 1",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "Yes",
    "Structural Material": "Concrete - Cast In Situ",
    "Structural Usage": "Bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Unconnected",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "0",
    Type: "Retaining - 300mm Concrete",
    "Type Id": "Retaining - 300mm Concrete",
    "Type Image": "<None>",
    "Unconnected Height": "3400",
    Volume: "13.98",
    Width: "300",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "599951",
    Name: "Basic Wall: Retaining - 300mm Concrete",
    Category: "Walls",
    Pbi2DGeometry: "DQEAAB+LCAAAAAAABAB9js0KwjAQhN9lzyEkTUp/PIkKgh6KCB5KDy2GdCEmUqNQSt/dQGtBBG87+w0zUw5QNHju7wpyOLgGC2d67SwQKBxa/4C8HKYzGKSgLJLJKuE0EUzASH5ZnFLOZfrNJGUs+4eWxOpTvO66ug/t4bHF+qa86iBnlBE4Kqt9O4uT87XHMHiSF7wuaK9Qt6GDc8pjmRHYGfWazZJmERcENs64kGufxozVG7t6dMcNAQAA",
    Pbi3DGeometry:
      "LwcAAB+LCAAAAAAABACdVdFqwyAU/RefnRhjkiZ9Gt1gsD2UbbCHsoeUhlbI4shkUEr/fW5JutZ4jRZJiMfj8Vy9N64OaLkWr/vPChXoUa7Fi6zFBmG0lKJRX6hYHbpPPUznuqEj/kduIkrnfy/9oOP7MO22bcu9nstjQhnPcBYRFs8YzkmcUI5NmJOcRfEJTjKSMpaZ8MCOUkKzNBrhOZlxloxUYPqFl4EOWATEAeegCLBkoHEr3U/cFOGE0nykcYkOQXaoeWimwrmunTs6yHBht2G7CWO5qW0OidqN+qU1wJ5y7bWlUIwmPqHu59zM9qBDd+f6xH/EnXxQ7H5bBVadsxjteTlR6O6Uh9nW+oeqye4vwLVP6V0XYVAkHapvnjtRflSqalFBCcXoqWq2atd3nqUqlZBN330Tm9PQQyW2O9V37uvq+5y4kLXUgmhBf5u+4H4Ar7cpJC8HAAA=",
    Absorptance: "0.1",
    Area: "14",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "-1500",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "Concrete",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "Yes",
    Family: "Retaining - 300mm Concrete",
    "Family and Type": "Retaining - 300mm Concrete",
    Function: "Retaining",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Length: "4150",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rebar Cover - Exterior Face": "Rebar Cover 1",
    "Rebar Cover - Interior Face": "Rebar Cover 1",
    "Rebar Cover - Other Faces": "Rebar Cover 1",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "Yes",
    "Structural Material": "Concrete - Cast In Situ",
    "Structural Usage": "Bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Unconnected",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "0",
    Type: "Retaining - 300mm Concrete",
    "Type Id": "Retaining - 300mm Concrete",
    "Type Image": "<None>",
    "Unconnected Height": "3400",
    Volume: "4.23",
    Width: "300",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "626581",
    Name: "Contour Labels: 1.5mm Arial",
    Category: "Contour Labels",
    Pbi2DGeometry: "GwEAAB+LCAAAAAAABACFjsELgjAYxf+X7zzHZlOnnaKCoA4SQQfxoDTmYG1hKxDxf2+gKZ26fe/9Hu97RQ95rS7dQ0AGR1ur3OpOWgMIcquMe0JW9OPpAwnFLE3YOqCMY85IBANaaMAjnPIw/Y+jFaY8pj946Z5p+R2xaduq80u8sVPVXTjRQkYwQXASRrpmEmfrKqf8+FFe1W1GB6Fk49/QGDPCQgR7Ld5TOJjNrdXWN5uX1kP5Ad8fBSUbAQAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Bold: "No",
    Color: "0",
    "Design Option": "-1",
    "Elevation Base": "Project Base Point",
    Family: "1.5mm Arial",
    "Family and Type": "1.5mm Arial",
    Italic: "No",
    "Label primary contours only": "No",
    "Relative Base": "Current Level",
    "Text Font": "Arial",
    "Text Size": "1.5",
    Type: "1.5mm Arial",
    "Type Id": "1.5mm Arial",
    Underline: "No",
  },
  {
    ID: "626630",
    Name: "Contour Labels: 1.5mm Arial",
    Category: "Contour Labels",
    Pbi2DGeometry:
      "GQEAAB+LCAAAAAAABACFjs0KwjAQhN9lz2lo0vTXk6gg6KGI4KH00GJoAzGRGoVS+u4utIriwdvOfrM7UwyQ1+rYXyVksLO1yq3uG2uAQG6VcTfIimEa0cACKlgaLDzGIhomgsNIfmnMKec8/GIei/GCi+QP/fhcviosu67qsQcu1qq6SCc7yHzqE9hL07h2FgfrKqew+iRP6vxGW6maFoN4iilxRGCj5WM2exgofMEJrKy2+NnctR7LJxCXB+kZAQAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Bold: "No",
    Color: "0",
    "Design Option": "-1",
    "Elevation Base": "Project Base Point",
    Family: "1.5mm Arial",
    "Family and Type": "1.5mm Arial",
    Italic: "No",
    "Label primary contours only": "No",
    "Relative Base": "Current Level",
    "Text Font": "Arial",
    "Text Size": "1.5",
    Type: "1.5mm Arial",
    "Type Id": "1.5mm Arial",
    Underline: "No",
  },
  {
    ID: "627064",
    Name: "Basic Wall: CL_W1",
    Category: "Walls",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABAB9js0KwjAQhN9lz2loTNWmnkQFQQ9FBA+lh4qhXYiJ1CiU0nd3oT/ixdvOfMPMZi2kVzw3Dw0JHNwVU2ea0llgkDq0/glJ1vYnBQK55AsVzleKi1gI6NiXRZJLIaN/SIQ8VCr+YVPlBPNxel3XRUP7ZGyxuGuva0goxeCobemrQZycLzzSy7284G1Ce41lRSsRVzMhGeyMfg/ZYPQ2zjjqtS9juvwDBc8Q5w8BAAA=",
    Pbi3DGeometry:
      "3QMAAB+LCAAAAAAABACVU80KwjAMfpecu9JsE7d58g8EPYgKHsTDhkULc5VZBBHf3aqbynSto7Q0X5IvP21WF5gmYnE+cIhgLBMxl6nYAIGpFJk6QrS6PK9azTp6wZW8EQcZ6zwOveG6Lt26eR6fta/v0qDlIwkpBojE8WnookcqMKOMOF6buh66TbEayhJ+maN2DsPgwVHamrAqbxX/IjZGrMu6lqVpOrby7Q/wqynmWkwFfjL++6LGIP/33dKCH5k1bbrtD1kj6TkZiHjPFc8hupvBhGdbtSuEmVSxEjIrxKXYvFQjLrY7VQjDlJ8+DfsylZoQeoM+dod6HG8+yAj43QMAAA==",
    Absorptance: "0.1",
    Area: "37",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "-1500",
    "Coarse Scale Fill Color": "12632256",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "Yes",
    Family: "CL_W1",
    "Family and Type": "CL_W1",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0.7500 /(·)",
    Image: "<None>",
    Keynote: "F10",
    Length: "24690",
    "Location Line": "Finish Face: Interior",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rebar Cover - Exterior Face": "Rebar Cover 1",
    "Rebar Cover - Interior Face": "Rebar Cover 1",
    "Rebar Cover - Other Faces": "Rebar Cover 1",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "Yes",
    "Structural Material": "CL Concrete_ panels",
    "Structural Usage": "Bearing",
    "Thermal Mass": "12.67 /",
    "Thermal Resistance (R)": "1.3333 (·)/",
    "Top Constraint": "Level 1",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "0",
    Type: "CL_W1",
    "Type Id": "CL_W1",
    "Type Image": "<None>",
    "Unconnected Height": "1500",
    Volume: "10.25",
    Width: "280",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Both",
  },
  {
    ID: "627729",
    Name: "Basic Wall: CL_W1",
    Category: "Walls",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABAB9jlELgjAUhf/LfZ5jmxumPUUFQT1IBD2ID0pjDtYWtgIR/3sDtYigt3vudzjnFD3ktT51NwkZ7F2tc2c65SwgyJ22/g5Z0Y9nMPAYJwlLlhElWJA4hQH9QkqxEIx/M4YXgtO/7BNazuWrtq26sCA8Nrq6Si9byAgmCA7SKt9M4uh85XUYPcqzvrzRTmrVhBaOU0ZjBFsjn5M3mn9rZ1zItQ9jhvIFtcprVBEBAAA=",
    Pbi3DGeometry:
      "4wQAAB+LCAAAAAAABACdVN9rwjAQ/l/uOQ25prNdffIXDLYHcYIPsoeKQQNdM7owEPF/X6ZdtbVnq5SW3pe773L5PrLcw3Sl57svBTG8mpV+N6leA4Op0Zn9hni5P/26ZdF3DxzYGfFQiP7x4144fPyXDfI82bnaQPIw9EOGgvekkMwL+LOPktVxwUWJOTouEKM7QIq2xH0ePQXIELn0Ze9EUsPquV7kuMNKagNEVl9t7cwRoKjxksmVqR+ivtgyeWptxNSQV3iL2qRejepWvNFNlBuVFekb295s0XSwtI6tzm0z6D3GJSfvqgY9Qmd/PqS0uy3GOvlUVuUQ//WDN5Vt7LYIZsYmVpusCBd6XS69KL3Z2iKYpOrnMnFkUuMIYTge4WDiLqVfaTd+POMEAAA=",
    Absorptance: "0.1",
    Area: "10",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "-1500",
    "Coarse Scale Fill Color": "12632256",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "CL_W1",
    "Family and Type": "CL_W1",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0.7500 /(·)",
    Image: "<None>",
    Keynote: "F10",
    Length: "6723",
    "Location Line": "Finish Face: Interior",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "CL Concrete_ panels",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "12.67 /",
    "Thermal Resistance (R)": "1.3333 (·)/",
    "Top Constraint": "Level 1",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "0",
    Type: "CL_W1",
    "Type Id": "CL_W1",
    "Type Image": "<None>",
    "Unconnected Height": "1500",
    Volume: "2.69",
    Width: "280",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Both",
  },
  {
    ID: "628359",
    Name: "water: water",
    Category: "Mass",
    Level: "-1",
    Pbi2DGeometry: "uQAAAB+LCAAAAAAABAA1jcEKwjAQRP9lz7GkaEuMJ6mCoIdSBA+lh1SXdCEmUqNQSv/dFettZt4wU49QtnQeHggajqGlCq/ReOsQBJSBfHyCrsef5IrcSJiaP9r2vRmYc7Ajc8eIPWiZSAEn9DZ2oBU7lS0FVCGaSMHP/EK3L07Z5JkScECyHR+kiZKrTMDe4XvuL9JknSvOiuAC7/uXc1PzARC/rAG5AAAA",
    Pbi3DGeometry:
      "PwUAAB+LCAAAAAAABAClVN9LwzAQ/l/uOQ350WZt9yROEbaHoYIPw4eOhS1QG6lhMMb+90Vbp0ay65TS0vsu930fd0cWe5gvzePuVUMJU7s0D7Y2KyAwt6Zxb1Au9t2vT7Oxf+BAvpCEMzb++PgXDs+fZVdtW+18bSponqWccEZZUeQk4bRQeUZ+4YxylZJEjqiQXPwdj/GHOKdSSBXHO/6IzaEwIio55TJXRLyXZ2fwgD7iEYER0VMr8UQnEHE5FB4sG3YT3YVAeTiOKWNj/zmAy/qDugxEMZr/bWy0BbExxojQ85duZ9RpUOFvoompXrTTLZS+hsBMN2u36YN76ypnbNOHT2Z1St1ps964Prip9fb7wWtbW08IqrgVk5G/8I6oosEIPwUAAA==",
    Area: "70",
    "Base Level": "-1",
    Cost: "0",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "water",
    "Family and Type": "water",
    "Gross Floor Area": "0",
    "Gross Surface Area": "169",
    "Gross Volume": "38.54",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "water",
    "Type Id": "water",
    "Type Image": "<None>",
    Volume: "38.54",
  },
  {
    ID: "628523",
    Name: "Basic Wall: CL_W1",
    Category: "Walls",
    Pbi2DGeometry: "FQEAAB+LCAAAAAAABACFjksLwjAQhP/LntOQJn3YehIVBD0UETyUHloMbSBmpUahlP53A219nLztzDfMTt5DVqlTd5OQwh4rlaHuajRAIENl7B3SvB9PF/BETKOEhUvP92nAeQQD+VDO6ULE8T/IaMhE8gO/emdazANWbVt2boUzNqq8SitbSBllBA7S1LaZxBFtaZUbPsqzurzRTqq6cW8CmnBfENhq+Zyy3uytUaPrNQ+th+IFm9ds6xUBAAA=",
    Pbi3DGeometry:
      "rgQAAB+LCAAAAAAABAC1VEuLwjAQ/i9zTkMeam09+QLBPcgq7EH2UDG0gdpIDYKI/32zu/VB01hzkJKSmW/mm5nMJOszLDZyddoLiGGuNnKpcrkFBAslC32AeH3+3xqYDMwHF3TXBJSQwd/PLLh8X92GZZmcjG/AQ8w4ZSigFHcY66GAYNIPQ8Q4pr2IPgAdHDHKbcA4uK3dARqQVp/G2LZ5TUtwl/ColuczpV1qDbDJ3Uhziu1M/ln5NOG1ZjaX4KN9NiM+tO+ZJ584PuXa89rWQ+cB+V03V0Bz8Scy2QktSoh/GeBDFKnOKuFT6URLVVTil9zeoJmQaaYrYZqL46PhWOXKEMJoMqbDqXlffgDm2v84rgQAAA==",
    Absorptance: "0.1",
    Area: "28",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "-1500",
    "Coarse Scale Fill Color": "12632256",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "Yes",
    Family: "CL_W1",
    "Family and Type": "CL_W1",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0.7500 /(·)",
    Image: "<None>",
    Keynote: "F10",
    Length: "18449",
    "Location Line": "Finish Face: Interior",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rebar Cover - Exterior Face": "Rebar Cover 1",
    "Rebar Cover - Interior Face": "Rebar Cover 1",
    "Rebar Cover - Other Faces": "Rebar Cover 1",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "Yes",
    "Structural Material": "CL Concrete_ panels",
    "Structural Usage": "Bearing",
    "Thermal Mass": "12.67 /",
    "Thermal Resistance (R)": "1.3333 (·)/",
    "Top Constraint": "Level 1",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "0",
    Type: "CL_W1",
    "Type Id": "CL_W1",
    "Type Image": "<None>",
    "Unconnected Height": "1500",
    Volume: "7.73",
    Width: "280",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Both",
  },
  {
    ID: "647908",
    Name: "Floor: Insitu Concrete 225mm",
    Category: "Floors",
    Level: "Level 1",
    "Aalto Vase Material": "0.1",
    "Architrave Offset": "70",
    "Coarse Poche Material": "0",
    "Coarse Scale Fill Color": "-1",
    CosAng: "0",
    "Default Elevation": "225",
    Description: "-1",
    Elevation: "-825",
    "Elevation at Bottom Survey": "-600",
    "Emit from Line Length": "No",
    "Facucent Drilling": "Insitu Concrete 225mm",
    Family: "Insitu Concrete 225mm",
    "Full Step Arrow": "Interior",
    "Heat Load Values": "4.6489 /(·)",
    "Height 1": "-600",
    Illuminance: "<None>",
    "Parts Visibility": "53164",
    Phase: "Working Drawings",
    "Phase Created": "None",
    "Referencing Sheet": "No",
    Rim: "No",
    "Rough Width": "1",
    "Slab Thickness": "0.00°",
    "Story Above": "No",
    Structural: "Concrete, Cast In Situ",
    "Text Type": "31.59 /",
    "Thermal Mass": "0.2151 (·)/",
    "Thermal Resistance (R)": "225",
    "Tumble Dryer": "Insitu Concrete 225mm",
    "Type Comments": "Insitu Concrete 225mm",
    "Type Id": "<None>",
    Voltage: "15.77",
  },
  {
    ID: "650527",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "650528",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "650529",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "650530",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "655533",
    Name: "Basic Wall: Wall - Timber Clad",
    Category: "Walls",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzGkTWJiPYkKgh6KCB5KDy2GNhATqVEope9uoD/iydvOfsPMZB2kpb60DwUJHF2pU2fayllAkDpt/ROSrBvOYIhjLKkQ6wUnmNOlgB59IaM4kpz/gWyFpWA/bE6dWD6Vb5qmaMOC8Njp4q68aiAhmCA4KVv5ehRn5wuvw+hBXvVtRgelqzqURFgSxhHsjXqPXoEJpxLB1hkXYu3LmD7/ACRfjdAQAQAA",
    Pbi3DGeometry:
      "EwQAAB+LCAAAAAAABAClU1sLgjAU/i/neY2ZmtOeogtBPUgFPUQPhsMG5sJGEOF/b5VZGfNCjI2db+d857azuYK/46vLkYEHM7HjSxHzEBD4gifyBN7m+ryqZ9JXCzL0RjoGIf3HoTZk25fZIE2Di7K1upjaloE6NsG22XOQg4ltUvSDUyVTE3VNbPTcP3Adf44X+paLqWO9aAr1arhM/g2Xuatd6iLXsLQLpTb9hu3Q1KUupZpMy+Rte13ttWE36iqjC7JdPxr+r2ZO1XSNeHBgkqXgEUwQzFkSyX0uLIQMJBdJLq55WDxNGY/2MhfGMTt/Kg5FLBQhTNz7UkN8AxfdIIETBAAA",
    Absorptance: "0.1",
    Area: "3",
    "Base Constraint": "Ceiling",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "-550",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    Cost: "0",
    "Cross-Section": "Vertical",
    Description: "Structural Insulation Panel Wall with Kiln Dried Timber Panel Rainscreen",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Wall - Timber Clad",
    "Family and Type": "Wall - Timber Clad",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Keynote: "F10",
    Length: "6202",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Structure - Timber Insulated Panel - Insulation",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Wall - Timber Clad",
    "Type Id": "Wall - Timber Clad",
    "Type Image": "<None>",
    "Unconnected Height": "550",
    Volume: "0.67",
    Width: "202",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Both",
  },
  {
    ID: "665557",
    Name: "Assembled Stair: 190mm max riser 250mm going",
    Category: "Stairs",
    "Actual Lighting Load per area": "16",
    "Actual Power Load per area": "188",
    "Actual Riser Height": "250",
    "Base is Attached": "Level 1",
    "Base Material": "0",
    CosAng: "0",
    Cut: "Single Zigzag",
    Description: "-1",
    "Designed By": "16",
    "Desired Number of Risers": "3000",
    "Facucent Drilling": "190mm max riser 250mm going",
    Family: "190mm max riser 250mm going",
    "Full Step Arrow": "Interior",
    Illuminance: "<None>",
    "Landing Height Adjustment": "Non-Monolithic Landing",
    "Left Attachment": "0",
    "Left Lateral Offset": "None",
    "Left Support": "<None>",
    "Maximum Ridge Height": "190",
    "MCB Rating": "No",
    "Middle Support": "0",
    "Middle Support Number": "Carriage - 50mm Width",
    "Minimum Embedment": "1000",
    "Minimum Run Width": "250",
    Phase: "Working Drawings",
    "Phase Created": "None",
    "Right Attachment": "0",
    "Right Lateral Offset": "None",
    "Right Support": "<None>",
    Roughness: "50mm Tread 13mm Riser",
    "Top is Attached": "Level 2",
    "Top Material": "0",
    "Track/Bswy Length": "1",
    "Tumble Dryer": "190mm max riser 250mm going",
    "Type Comments": "190mm max riser 250mm going",
    "Type Id": "<None>",
  },
  {
    ID: "665704",
    Name: "Automatic Up/Down Direction: Standard",
    Category: "Stair Paths",
    "Area per Person": "Arrow Open 90 Degree 1.25mm",
    Description: "-1",
    "Distance from Wall": "3",
    "Door thickness": "DN",
    "Facucent Drilling": "Standard",
    Family: "Standard",
    "Front Tempered Glass Material": "No",
    "Line Pattern": "Straight",
    "Ordinate Dimension Settings": "Horizontal",
    "Show Area": "No",
    "Show Capital": "Yes",
    "Show Title": "Yes",
    Stand: "0",
    "Start Extension": "None",
    "Text Size": "2.5mm Arial",
    "Tumble Dryer": "Standard",
    "Type Comments": "Standard",
    "Units Format": "UP",
  },
  {
    ID: "665708",
    Name: "Automatic Up/Down Direction: Standard",
    Category: "Stair Paths",
    "Area per Person": "Arrow Open 90 Degree 1.25mm",
    Description: "-1",
    "Distance from Wall": "3",
    "Door thickness": "DN",
    "Facucent Drilling": "Standard",
    Family: "Standard",
    "Front Tempered Glass Material": "No",
    "Line Pattern": "Straight",
    "Ordinate Dimension Settings": "Horizontal",
    "Show Area": "No",
    "Show Capital": "No",
    "Show Title": "No",
    Stand: "0",
    "Start Extension": "None",
    "Text Size": "2.5mm Arial",
    "Tumble Dryer": "Standard",
    "Type Comments": "Standard",
    "Units Format": "UP",
  },
  {
    ID: "665711",
    Name: "Railing: SH_1100mm",
    Category: "Railings",
    Pbi2DGeometry:
      "6gEAAB+LCAAAAAAABACFkcEKwjAMht8l5650rq3rPIkKgh6GCB6Gh4llK9RVZhXG2Ltb3BTEqrckX/iT/MlaSA9q25wlJLAyB5Ua3RSmAgSpUZW9QJK1fegaohgTwdmEYkoFhw69IRGF3xDtkfiGAo4jEvoVA4ZjDyOc/mHcy8Qw75OJH7uIXyc8JJn38IddT7R/mjqt67xxzrrCXOUnaWUNCcEEwVpWhS2HZGNsbpV7Rp/u1PGFllIVpZsRRphTPkaw0PI2NAcEh4KNEMyMNk64umrd7e+Ause96gEAAA==",
    Pbi3DGeometry:
      "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",
    "Angled Joins": "Add Vertical/Horizontal Segments",
    "Baluster Offset": "0",
    "Base Level": "-1",
    "Base Offset": "0",
    Cost: "0",
    "Design Option": "-1",
    Family: "SH_1100mm",
    "Family and Type": "SH_1100mm",
    Height: "0",
    Image: "<None>",
    "Landing Height Adjustment": "0",
    "Lateral Offset": "0",
    Length: "4536",
    "Offset from Path": "25",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "None",
    "Rail Connections": "Trim",
    "Railing Height": "1100",
    "Tangent Joins": "Extend Rails to Meet",
    Type: "SH_1100mm",
    "Type Id": "SH_1100mm",
    "Type Image": "<None>",
    "Use Landing Height Adjustment": "No",
    "Use Top Rail": "Yes",
  },
  {
    ID: "665845",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "665848",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "665860",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
  },
  {
    ID: "669213",
    Name: "Linear Dimension Style: Feet & Inches",
    Category: "Dimensions",
    "Alignment Method": "None",
    "Base Power Load on": "0",
    "Body width": "No",
    "Center Segment": "Solid",
    "Centerline Pattern": "None",
    "Centerline Symbol": "Default",
    "Cold Water Radius": "0",
    Cost: "11",
    Description: "-1",
    "Digital Plate": "2.3813",
    "Dimension Line Extension": "6.35",
    "Dimension Line Snap Distance": "Continuous",
    "End Segment Weight": "Equality Text",
    "Equality Formula": "EQ",
    "Equality Text": "Tick and Line",
    "Facucent Drilling": "Feet & Inches",
    Family: "Feet & Inches",
    "Fixed Door": "2.3813",
    "Installation Type": 'Diagonal 3/64"',
    "Interior Tick Mark": "Dynamic",
    "Interior Type": "No",
    L: "<None>",
    Layout: "Yes",
    "Leader Line": "None",
    "Leader Tick Mark": "Arc",
    "Line Style": "1",
    Rangehood: "Up, then Left",
    "Show in": "Beyond Witness Lines",
    "Show Leader When Text Moves": "No",
    "Supply Voltage": "No",
    "Target Elevation": "Opaque",
    "Text Background": "Arial",
    "Text Font": "1.5875",
    "Text Offset": "2.3813",
    Thickness: 'Diagonal 3/64"',
    "Tick Mark": "5",
    "Total Input Wattage": "3429",
    "Tumble Dryer": "Feet & Inches",
    "Type Comments": "Feet & Inches",
    "Underlay Orientation": "No",
    "Width (pixels)": "1",
    "Window Cill Interior": "Gap to Element",
    "Witness Line Control": "2.3813",
    "Witness Line Extension": "1.5875",
    "Witness Line Gap to Element": "2.3813",
    "Witness Line Length": "None",
  },
  {
    ID: "670283",
    Name: "Linear Dimension Style: Feet & Inches",
    Category: "Dimensions",
    "Alignment Method": "None",
    "Base Power Load on": "0",
    "Body width": "No",
    "Center Segment": "Solid",
    "Centerline Pattern": "None",
    "Centerline Symbol": "Default",
    "Cold Water Radius": "0",
    Cost: "7",
    Description: "-1",
    "Digital Plate": "2.3813",
    "Dimension Line Extension": "6.35",
    "Dimension Line Snap Distance": "Continuous",
    "End Segment Weight": "Value",
    "Equality Formula": "EQ",
    "Equality Text": "Tick and Line",
    "Facucent Drilling": "Feet & Inches",
    Family: "Feet & Inches",
    "Fixed Door": "2.3813",
    "Installation Type": 'Diagonal 3/64"',
    "Interior Tick Mark": "Dynamic",
    "Interior Type": "No",
    L: "<None>",
    Layout: "Yes",
    "Leader Line": "None",
    "Leader Tick Mark": "Arc",
    "Line Style": "1",
    Rangehood: "Up, then Left",
    "Show in": "Beyond Witness Lines",
    "Show Leader When Text Moves": "No",
    "Supply Voltage": "No",
    "Target Elevation": "Opaque",
    "Text Background": "Arial",
    "Text Font": "1.5875",
    "Text Offset": "2.3813",
    Thickness: 'Diagonal 3/64"',
    "Tick Mark": "5",
    "Total Input Wattage": "18000",
    "Tumble Dryer": "Feet & Inches",
    "Type Comments": "Feet & Inches",
    "Underlay Orientation": "No",
    "Width (pixels)": "1",
    "Window Cill Interior": "Gap to Element",
    "Witness Line Control": "2.3813",
    "Witness Line Extension": "1.5875",
    "Witness Line Gap to Element": "2.3813",
    "Witness Line Length": "None",
  },
  {
    ID: "674370",
    Name: "Miele Washing Machine W 5820 WPS: Miele Washing Machine W 5820 WPS",
    Category: "Generic Models",
    Level: "Level 1",
    Pbi2DGeometry: "uQAAAB+LCAAAAAAABABNjcsKwjAQRf9l1jG0ibU1rkQFQRdFBReli5YO7UBMSoxCKf13Az5wdx+He4sR8pouQ4+g4GBrOvcdOgQGuSXj76CK8S1DLxZcyiRezeZcZomAqfxia+eqIbAh2FJ1Q48OVMyXiYgZHNG0vgMV8YjByfrKkzUfe6XmV+2R2i78CJ5mWcpgp/H5z26stmHWPLSeyher4sV/uQAAAA==",
    Pbi3DGeometry:
      "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",
    Area: "2",
    "Black Screen": "Black panel",
    Buttons: "Buttons",
    Cost: "0",
    "Default Elevation": "0",
    Depth: "615",
    Description: "Miele Washing Machine W 5820 WPS",
    "Design Option": "-1",
    Door: "Door",
    "Elevation from Level": "0",
    Family: "Miele Washing Machine W 5820 WPS",
    "Family and Type": "Miele Washing Machine W 5820 WPS",
    Fascia: "Main body",
    Glass: "Glass",
    Hieght: "850",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    Logo: "Logo",
    Manufacturer: "Miele Australia Pty.Ltd.",
    Model: "W 5820 WPS",
    "Offset from Host": "0",
    "OmniClass Number": "23.40.20.00",
    "OmniClass Title": "General Furniture and Specialties",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Miele Washing Machine W 5820 WPS",
    "Type Id": "Miele Washing Machine W 5820 WPS",
    "Type Image": "<None>",
    URL: "www.miele.com.au",
    Volume: "0.25",
    "Washing machine": "Main body",
    Width: "595",
  },
  {
    ID: "677695",
    Name: "Miele Tumble Dryer T 7944 C: Miele Tumble Dryer T 7944 C",
    Category: "Specialty Equipment",
    Level: "Level 1",
    Pbi2DGeometry: "zQAAAB+LCAAAAAAABAA1zcsKwjAQBdB/mXUMaWsejStRQdBFKYKL0kWqoQ3ERGoUSum/m/rYzVzOnalGKBpzGu4aJBx8Y0p9Ccq1VgOCwhsXHiCr8TtGkjKcZTRZLRhmIuEw1X+27ns1RBuDrVE3HXQPkmCC4KhdGzqQCc5pmiAofVDBeDcnlBOesyxlPF+KnCI4m+tsU0wEiXavTduFeedCcAQ7q1+/8uf2xlsf/7intVP9BhGz0ybNAAAA",
    Pbi3DGeometry:
      "fwcAAB+LCAAAAAAABADtk8ELgjAUxv+Xd15jjebMTlFBhw4SQQfpYDR0YC5sBRH975laiemyYyCi+H6+79tz+nlXcLdydTkIcOJTFCFwlYz1ERzvmt+CA2SUHnBDb9LrEzLKLukJt81TNk4S/5JqKcN0yPqox7HFuI0IJohyPCAWrWcMc8J4zkzaur4yM61RMIq5bfMPyyo2rN7g0Dh8hT3llfmruM6hobXtrhiYybJdq2n+Hz5LC3lD6xf822/wxaTNVqSpmEp/L7RIwHm8ByxEHOiwKJZK+1qquCjXcvd6NBcyCHVRzCJxLjdOVKSSPK1ZJLv4dvHt4vuX8d3cAcbv9h1/BwAA",
    Area: "3",
    Consideration: "Please refer to installation instructions and diagrams prior to specification",
    "Control Panel": "Silver Aluminium",
    Cost: "0",
    "Default Elevation": "0",
    Depth: "634",
    Description: "Tumble Dryer T 7944 C",
    "Design Option": "-1",
    "Digital Plate": "Black Glass",
    Door: "Silver Aluminium",
    "Door swing line on/off": "No",
    "Elevation from Level": "0",
    Family: "Miele Tumble Dryer T 7944 C",
    "Family and Type": "Miele Tumble Dryer T 7944 C",
    Height: "850",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    "Joinery cut line on/off": "No",
    Manufacturer: "Miele Australia Pty. Ltd.",
    Model: "T 7944 C",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Power connection point indicator on/off": "No",
    "Service Panel": "Silver Aluminium",
    Switch: "Stainless Steel",
    "Tumble Dryer": "Silver Aluminium",
    Type: "Miele Tumble Dryer T 7944 C",
    "Type Id": "Miele Tumble Dryer T 7944 C",
    "Type Image": "<None>",
    URL: "www.miele.com.au",
    Vents: "Silver Aluminium",
    Voltage: "230",
    Volume: "0.05",
    "Water Container": "Silver Aluminium",
    Wheels: "Stainless Steel",
    Width: "595",
  },
  {
    ID: "679009",
    Name: "Miele Built-in Rangehood DA 2210: Rangehood DA-2210",
    Category: "Specialty Equipment",
    Level: "Level 1",
    Pbi2DGeometry: "wgAAAB+LCAAAAAAABAA1jNEKgjAYhd/lv15jcylrXUUFQV2IBF2IFzN/dLC2sBWI+O5NsrtzzvdxyhHy2lyHJ4KCs69NgfegXWsRCOTeuPACVY6/GBXOqGAy2a4kTSUXMFV/bdf3eohuHA5GPzBgD4pRRuCCrg0dKEEznqYECh90MN4t+GaamXIquNwQOKFpuzB3loiEwNHiZ9EzKrK1JLD31sdz97Z2qr7y51xJwgAAAA==",
    Pbi3DGeometry:
      "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",
    Area: "2",
    Considerations: "Please refer to installation instructions and diagrams prior to specification",
    "Control Panel": "Stainless Steel",
    Cost: "0",
    "Default Elevation": "0",
    Description: "Rangehood DA 2210",
    "Design Option": "-1",
    "Elevation from Level": "1450",
    "Face depth": "402",
    "Face height": "50",
    "Face width": "1102",
    Family: "Rangehood DA-2210",
    "Family and Type": "Rangehood DA-2210",
    Frame: "Stainless Steel",
    "Grease Filter": "Black Glass",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    "Joinery cut line on/off": "No",
    Lighting: "Lighting",
    Logo: "Black Plastic",
    Manufacturer: "Miele Australia Pty.Ltd.",
    Model: "DA 2210",
    "Offset from Host": "1450",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Power connection point indicator on/off": "No",
    Rangehood: "Stainless Steel",
    Type: "Rangehood DA-2210",
    "Type Id": "Rangehood DA-2210",
    "Type Image": "<None>",
    URL: "www.miele.com.au",
    Voltage: "230",
    Volume: "0.07",
  },
  {
    ID: "680539",
    Name: "Miele Induction Cooktop KM 6350 LPT: Miele Induction Cooktop 6350 LPT",
    Category: "Generic Models",
    Level: "Level 1",
    Pbi2DGeometry: "uwAAAB+LCAAAAAAABAA9jMEKwjAQRP9lzzE01TY2nkQFQQ9FBQ+lhxaXdiEmJUahlP67Eau3mXmPKQbIa7r0HYKCg63p3LXoEBjklox/gCqGbwxcRDxbyGw1W3KZJgLG8qetnav64IZhS9UdPTpQgstEpAyOaBrfgop4xOBkfeXJmqle6fZHe6Sm9Z8yFwmDncbXpMZcZiJmsLHahmPz1Hos33Xf0MO7AAAA",
    Pbi3DGeometry:
      "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",
    Area: "1",
    Cable: "Rubber",
    "Connection Box": "Plastic",
    Considerations: "Please refer to installation instructions and diagrams prior to specification",
    Cost: "0",
    "Default Elevation": "0",
    Description: "Induction Cooktop 6350 LPT",
    "Design Option": "-1",
    "Door swing line on/off": "No",
    "Elevation from Level": "-114",
    "Face depth": "514",
    "Face height": "3",
    "Face width": "794",
    Family: "Miele Induction Cooktop 6350 LPT",
    "Family and Type": "Miele Induction Cooktop 6350 LPT",
    Frame: "Clean Steel",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    "Induction Cooking": "Black Glass",
    "Induction Cooking Pan": "Black Glass Pan",
    "Joinery cut line on/off": "No",
    "Joinery cut out dimension - depth": "500",
    "Joinery cut out dimension - height": "equal to or above 30",
    "Joinery cut out dimension -width": "780",
    Manufacturer: "Miele Australia Pty.Ltd.",
    Model: "6350 LPT",
    "Offset from Host": "-114",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Power connection point indicator on/off": "No",
    Rim: "Stainless Steel",
    Type: "Miele Induction Cooktop 6350 LPT",
    "Type Id": "Miele Induction Cooktop 6350 LPT",
    "Type Image": "<None>",
    URL: "www.miele.com.au",
    Voltage: "230",
    Volume: "0.01",
  },
  {
    ID: "684791",
    Name: "Miele MasterCool KF 1911 Vi: Miele Fridge/Freezer KF 1911 Vi",
    Category: "Specialty Equipment",
    Level: "Level 1",
    Pbi2DGeometry: "zgAAAB+LCAAAAAAABAA1jcsKwjAURP/lrmNo0iZp4kpUEHRRiuCidNFqaAMxkRqFUvrvxtduGM6ZqSYoWnMcbxoU7H1rSn0OjeusBgSFNy7cQVXTN0aEpjjjhCwXHFPGKMz1H1sNQzNGNhYb01x10AOoBCcIDtp1oQdFsWQyRVD60ATjHSiCmUiE5CnlQmYyIRmCk7m8YYJFnnEEO226Pj5zLEUe5a3Vz5/9GV976+ORe1g71y+yqv1BzgAAAA==",
    Pbi3DGeometry:
      "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",
    Area: "10",
    "Body depth": "610",
    "Body height": "2127",
    "Body width": "902",
    Considerations: "Please refer to installation instructions and diagrams prior to specification",
    Cost: "0",
    "Default Elevation": "0",
    Description: "Fridge/Freezer KF 1911 Vi",
    "Design Option": "-1",
    Door: "Metal",
    "Door swing line on/off": "No",
    "Elevation from Level": "0",
    Family: "Miele Fridge/Freezer KF 1911 Vi",
    "Family and Type": "Miele Fridge/Freezer KF 1911 Vi",
    Fitting: "Metal",
    "Fixed Door": "Metal 2",
    Fridge: "Metal",
    "Fridge Base": "Metal 1",
    "Fridge Legs": "Rubber",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    "Joinery cut line on/off": "No",
    Logo: "Metal",
    Manufacturer: "Miele Australia Pty.Ltd.",
    Model: "KF 1911 Vi",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Power connection point indicator on/off": "No",
    Type: "Miele Fridge/Freezer KF 1911 Vi",
    "Type Id": "Miele Fridge/Freezer KF 1911 Vi",
    "Type Image": "<None>",
    URL: "www.miele.com.au",
    Voltage: "230",
    Volume: "0.36",
  },
  {
    ID: "686184",
    Name: "Miele Oven H 5681 BP: Miele Oven H 5681 BP",
    Category: "Specialty Equipment",
    Level: "Level 1",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7zGNp1zdooKgjqIBB3Ew6yhg7WFrUDE797Cuj1+7/d49QRla87jQ0MBR9+aSl+Dcp3VgKD0xoUnFPW0xKiwBFOe8vUqwULA3PylzTCoMZoR7Iy666AHKAgmCE7adaGHgmLJGUVQ+aCC8e5LuCBCZgnLhEwloSmCi7ktciQZgoM2XR+WMY/13ur3b82wyHOBYOutj1/uZe3cfADz3zQtzwAAAA==",
    Pbi3DGeometry:
      "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",
    Area: "2",
    "Body depth": "547",
    "Body height": "575",
    "Body width": "554",
    Casing: "Stainless Steel",
    Considerations: "Please refer to installation instructions and diagrams prior to specification",
    Cost: "0",
    "Default Elevation": "0",
    Description: "Ovens H 5681 BP",
    "Design Option": "-1",
    "Display Panel": "Black Glass",
    Door: "Black Glass",
    "Door swing line on/off": "Yes",
    "Elevation from Level": "350",
    "Face depth": "22",
    "Face height": "596",
    "Face width": "595",
    "Facing Panel": "Cleansteel",
    Family: "Miele Oven H 5681 BP",
    "Family and Type": "Miele Oven H 5681 BP",
    Frame: "Black Plastic",
    Handle: "Cleansteel",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    "Joinery cut line on/off": "Yes",
    "Joinery cut out dimension - depth": "equal to or above 550",
    "Joinery cut out dimension - height": "593-595",
    "Joinery cut out dimension -width": "560-568",
    Manufacturer: "Miele Australia Pty.Ltd.",
    Model: "H 5681 BP",
    "Offset from Host": "350",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Plate: "Black Plastic",
    "Power connection point indicator on/off": "No",
    Type: "Miele Oven H 5681 BP",
    "Type Id": "Miele Oven H 5681 BP",
    "Type Image": "<None>",
    URL: "www.miele.com.au",
    Voltage: "230",
    Volume: "0.09",
  },
  {
    ID: "687033",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jT0LwjAYhP/LO8eQjzZJ6yQqCDqUIjiUDq2GNhATqVEopf/dSHW7O567qyYoWnMeHxpyOPrWlPoaGtdZDQgKb1x4Ql5Ni4zIigpMuFyvCGYqVTDXf2wzDM0Y2RjsTHPXQQ+QE0wQnLTrQv81lFOGoPShCcY7yClOJZGZ4EzILFGZzBBczG2BOVMUwUGbro/PCVZURL+3+v1rswQnTMTBrbc+nrmXtXP9AQgWYc3SAAAA",
    Pbi3DGeometry:
      "JQQAAB+LCAAAAAAABACdk1FrwjAQx7/LPachOZPa1KexDQb6INtgD7KHikEDXTO6IIj43U27urlJGmtKSu+Xu/unudxiD/Oled19ashhapfmxZZmBQTm1lTuC/LF/vvTL7OJf+BAfknCGZu0Lz/h8H4Ku6vrYudjE55SZJwkjGImM4KKosAROXFBUSpFUFDJx3iGeSpHDRaYRnGbXIkmOZNpRmKiIf+L9JJmY1SDee9+/vBgQFT537FF+OVJxJSDEcGKDcH9+7mqZDf/QK/EEOlwEYZc3iC+psK+3x5M8aGdriFnlBGY6WrtNp3xbF3hjK06882sfpaetFlvXGc8lnp77nhvS1s3/d4O39ZH96JkTiUEAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1998",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "687035",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7zG5tRtdooKgjqIBB3Ew6qhg7WFrUDE795KvL3f4/d49Qjl1ZyHp4YCjv5qKn0LyrVWA4LSGxdeUNTjHKOyojkmjK8FlkRkMDWLtel7NUQ1FjujHjroHgqCCYKTdm3ofkAZTRBUPqhgvIOC4owTLnOW5FymQnKJ4GLus8wSQREctGm78Geepgj2Vn+WtcSMEo5g662PZ+5t7dR8AanjKOzRAAAA",
    Pbi3DGeometry:
      "CgQAAB+LCAAAAAAABACdk19rwjAQwL/LPcdwp22X1CfZBoPtQZywB9lDxaCBrhldGIj43U1rnVK51ZqQP/fLJXfc5RY7mC7tfPttIIVXt7TvLrcrEDB1tvA/kC52x204xnHosBdnMiDEcT2FAfvP07VJWWbbcHdAiRwiCSU1qliQlklYTlRLUkQVjZCSC4yR1hUeRUp1YSUVjWoc64jE/xYZ5aunY6kehro3Z31pYU6902wrXh28HYMOs4w6m6U+mHXlpizd5zj3eB+TfMj7/FEW35LPUFRPNvsy3pSQokQBb6ZY+00jzJzPvHVFI37Y1d/Ri7HrjW+E59z8Xio+utyVVVHXLdTuAR0UZe4KBAAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "120",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "687037",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jUELgjAcxb/L/zzHNt3m7BQVBHUQCTqIB6uhg7WFrUDE795CvL33+P149QTlzVzGl4YCTv5mKn0PreusBgSlNy68oainJUYkoQKTVG4SSjBjJIO5WbntMLRjhOOwN+1TBz1AQTBBcNauC/2/0JQyBJUPbTDeQUExl0QqkTIhVZYrniG4mscCpyynCI7adH28zjDnIsoHq7+rrTBXhCPYeevjmftYOzc/c/2JXNMAAAA=",
    Pbi3DGeometry:
      "QAQAAB+LCAAAAAAABAClVE2LwjAU/C/vHMNLaNqmnkQFQQ+yK+xB9lAxaKA2UoMg4n83262uKOnHmpCQN5PJJHlNl2eYr/TitFeQwNSs9KfJ9BoIzI3O7QGS5fl36GjsuwoX8of0GGK/7FyDy/dNNiiK9OS0PRZSjoy4KZRzDAiTNIwFueOCiphHhAeUBWH0iAeSlTgKzppxtz7jslxfSBSk0dgreHEQNI64/A9Rt6knwi9pYf90hY3Ey500u3sl/gR2w+v21DKBb5yixqSjeU02un3RfrxVut1THOl0p6wqIEGKBGYq39htFXwYm1pt8ir80us7NVF6s7VVMM7U8XHi0GSm+PkVlMW9+Ct+fr/xQAQAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1962",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "690080",
    Name: "4500_Kitchen Island_DW: 4500_Kitchen Island_DW",
    Category: "Casework",
    Level: "Level 1",
    Pbi2DGeometry: "wAAAAB+LCAAAAAAABABNjUEKwjAURO/y1zEkTbVtXIkKgi5KEVyULlL9pIGYSI1CKb27ERXcDfMeM/UIZWuOww1Bwt63psJzUE5bBAKlNy7cQdbjJ0aFM5ozLpYzRrNUpDA1P23V92qIbiw2Rl0xYA+SUUbggE6HDiRPaZFkOYHKBxWMd19+Mpc3TigXyZzADo3u4pegC5YXBLYWn//62lsfp93D2ql5ATbnNF3AAAAA",
    Pbi3DGeometry:
      "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",
    Area: "21",
    Cost: "0",
    "Default Elevation": "0",
    Depth: "600",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "4500_Kitchen Island_DW",
    "Family and Type": "4500_Kitchen Island_DW",
    Height: "900",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "OmniClass Number": "23.40.35.00",
    "OmniClass Title": "Casework",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "4500_Kitchen Island_DW",
    "Type Id": "4500_Kitchen Island_DW",
    "Type Image": "<None>",
    Volume: "2.33",
    Width: "4500",
  },
  {
    ID: "690286",
    Name: "4500_Kitchen Island: 4500_Kitchen Island",
    Category: "Casework",
    Level: "Level 1",
    Pbi2DGeometry:
      "0wAAAB+LCAAAAAAABAA1jcsKwjAQRf9l1mlImj6SuBItCLooRXBRumg1tIGYSI1CKf1342s3dzj3nnqGstPH6aZAwt51ulJn39reKEBQOm39HWQ9f8+AUII5oWwVCZxnaQ5L88fW49hOgQ2PrW6vyqsRJMEEwUHZ3g8gaYJFnHMElfOt186CzHDCaSZynrA04YRzUUQ0RXDSl3cjxpTFIe6U7oegZzgjXCAojHr+Fj6GjTMu2OzDmKV5ATHDSCvTAAAA",
    Pbi3DGeometry:
      "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",
    Area: "23",
    Cost: "0",
    "Default Elevation": "0",
    Depth: "600",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "4500_Kitchen Island",
    "Family and Type": "4500_Kitchen Island",
    Height: "900",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "OmniClass Number": "23.40.35.00",
    "OmniClass Title": "Casework",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "4500_Kitchen Island",
    "Type Id": "4500_Kitchen Island",
    "Type Image": "<None>",
    Volume: "2.77",
    Width: "4500",
  },
  {
    ID: "694796",
    Name: "Miele Built-under Dishwasher G 4101 U CS: Miele Built-under Dishwasher G 4101 U CS",
    Category: "Generic Models",
    Level: "Level 1",
    Pbi2DGeometry: "uAAAAB+LCAAAAAAABABNjcsKwjAQRf9l1jGkVWkaV6KCoIuigovSRUqHdiAmJUahlP67AR+4u4/DveUIRU2XoUdQcHA1nfsOPQKDwpENd1Dl+Jaxl3whs/lqlnC5lDlM1Zdae6+HiMZgS/qGAT2oSOVpwuCItg0dKMEFg5MLOpCzH3ul5lftkdou3qRcZiJjsDP4/Gc3zrg4ax/GTNULXmuzl7gAAAA=",
    Pbi3DGeometry:
      "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",
    Area: "2",
    "Black Screen": "Black panel",
    Buttons: "Buttons",
    Cost: "0",
    "Default Elevation": "0",
    Depth: "570",
    Description: "Miele Built-under Dishwasher G 4101 U CS",
    "Design Option": "-1",
    Dishwasher: "Main body",
    "Door thickness": "50",
    "Elevation from Level": "0",
    Family: "Miele Built-under Dishwasher G 4101 U CS",
    "Family and Type": "Miele Built-under Dishwasher G 4101 U CS",
    Fascia: "Fascia",
    Front: "720",
    Hieght: "870",
    Host: "Level : Level 1",
    "Host Id": "-1",
    Image: "<None>",
    Logo: "Logo",
    Manufacturer: "Miele Australia Pty.Ltd.",
    Model: "G 4101 U CS",
    "Offset from Host": "0",
    "OmniClass Number": "23.40.20.00",
    "OmniClass Title": "General Furniture and Specialties",
    Panel: "116",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Plinth: "Plinth",
    "Plinth height": "5",
    Type: "Miele Built-under Dishwasher G 4101 U CS",
    "Type Id": "Miele Built-under Dishwasher G 4101 U CS",
    "Type Image": "<None>",
    URL: "www.miele.com.au",
    Volume: "0.29",
    Width: "598",
  },
  {
    ID: "696998",
    Name: "Miele Built-in Microwave M 8260-2: Miele Microwave M 8260-2",
    Category: "Specialty Equipment",
    Level: "Level 1",
    Pbi2DGeometry: "zgAAAB+LCAAAAAAABAA1zVELwiAUBeD/cp9NdLqZ6ykqCOphjKCHsQdXsgmmsSwYY/89a/V27uG7nGqEojGn4a4hh4NvTKkvQbnWakBQeOPCA/JqnGMkCcOMiNWCYSFgqv9m3fdqiDAWW6NuOugecoIJgqN2beggp1imCUVQ+qCC8e7TpIIImbEkE5JLQjmCs7nOOOMknntt2i58KSVLBDurX79vjkVKBIKNtz5uuae1U/0GLXw6es4AAAA=",
    Pbi3DGeometry:
      "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",
    Area: "2",
    Casing: "Stainless Steel",
    Considerations: "Please refer to installation instructions and diagrams prior to specification",
    Cost: "0",
    "Default Elevation": "0",
    Description: "Microwave M 8260-2",
    "Design Option": "-1",
    "Display Panel": "Black Glass",
    Door: "Black Glass",
    "Door swing line on/off": "No",
    "Elevation from Level": "920",
    "Face depth": "20",
    "Face height": "460.5",
    "Face width": "595",
    "Facing Panel": "Cleansteel",
    Family: "Miele Microwave M 8260-2",
    "Family and Type": "Miele Microwave M 8260-2",
    Frame: "Black Plastic",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    "Joinery cut line on/off": "No",
    "Joinery cut out dimension - depth": "equal to or above 500",
    "Joinery cut out dimension - height": "450",
    "Joinery cut out dimension -width": "562-568",
    Knob: "Stainless Steel 1",
    Manufacturer: "Miele Australia Pty.Ltd.",
    Model: "M 8260-2",
    "Offset from Host": "920",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Power connection point indicator on/off": "No",
    Type: "Miele Microwave M 8260-2",
    "Type Id": "Miele Microwave M 8260-2",
    "Type Image": "<None>",
    URL: "www.miele.com.au",
    Voltage: "230",
    Volume: "0.03",
  },
  {
    ID: "697577",
    Name: "hood enclosure: hood enclosure",
    Category: "Furniture Systems",
    Level: "-1",
    Pbi2DGeometry: "tgAAAB+LCAAAAAAABAA1jMEKwjAQBf9lzyEk1kYbT6KCoIdSBA+lh9Qu7UJMpEahlP67EevtMTO8coS8psvwQNBw8jUVeAvGtRaBQe7JhSfocvzNmIiNgKn6q23fmyH6CPZk7hiwBy24YHBG14YOdMKVTFMGhQ8mkHezvlLztZIncp0xOCK1Xbxf8KUSisHB4nvOFU+yVUQ7b308dy9rp+oDHfYocrYAAAA=",
    Pbi3DGeometry:
      "NQkAAB+LCAAAAAAABAClllFLwzAQx79LnrOQdrZJuydRQdCHoYIPw4eNlS1QG6lFGGPf3Vhj7cLlmrCVjeXX9J+7f3rXro5kuVEvh4+KlORBb9SzrtWWULLUquk+Sbk6/v41p/nCHORE/8ks4XzR/5gvOb39XXbdtuuDuTZJmeB5RmeCFVJkNGfzQuR0wAVLRJb6sGQyk/NJbLU9eKQt0qTHaVKMZ/e4YOkVlz7siniw1Z5eEkjeSJrPBLUSMA20z5PLIJ1keT5Bh+AgGugdnIqT9vkeOtRRgClqHJyHk/P57jnUUYAp6hqchVsROMYrIsi2oOBgM8OMh3Q9d6zPeWi5yJyxLQ2KDWkYnh3BZkeZ5JFG7098clzU0dIBPTGofsIqEOsYYd0F0vVUoK+0oeUiGz7WM4JiQ6zHngNRecdJX/jYCI7avH/cqvV71VUtKTnjlDxWza7b28GT7tad0o0dvqrtcOq+Urt9Zwd3dfU1nnija20EiZA/h3nN+QajVuV6NQkAAA==",
    Area: "0",
    Cost: "0",
    "Design Option": "-1",
    Family: "hood enclosure",
    "Family and Type": "hood enclosure",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "hood enclosure",
    "Type Id": "hood enclosure",
    "Type Image": "<None>",
    Volume: "0.04",
  },
  {
    ID: "697612",
    Name: "Compound Ceiling: 3000 x 3000mm Grid",
    Category: "Ceilings",
    Level: "Level 1",
    "Aalto Vase Material": "0.1",
    "Architrave Offset": "84",
    "Coarse Poche Material": "0",
    "Coarse Scale Fill Color": "-1",
    CosAng: "0",
    Description: "-1",
    "Facucent Drilling": "3000 x 3000mm Grid",
    Family: "3000 x 3000mm Grid",
    "Heat Load Values": "0.0000 /(·)",
    "Height 1": "2700",
    Illuminance: "<None>",
    "Parts Visibility": "39156",
    Phase: "Working Drawings",
    "Phase Created": "None",
    Rim: "Yes",
    "Rough Width": "1",
    "Slab Thickness": "0.00°",
    "Text Type": "0.00 /",
    "Thermal Mass": "0.0000 (·)/",
    "Thermal Resistance (R)": "50",
    "Tumble Dryer": "3000 x 3000mm Grid",
    "Type Comments": "3000 x 3000mm Grid",
    "Type Id": "<None>",
    Voltage: "4.18",
  },
  {
    ID: "698859",
    Name: "Lavatory-TOTO-Luminist_Rectangle_Vessel_LLT151: Standard",
    Category: "Plumbing Fixtures",
    Level: "Level 2",
    Pbi2DGeometry: "wQAAAB+LCAAAAAAABAA1jNEKgjAYhd/lv55jc6a5rqKCoC5Egi7Ei1k/Olhb2ApEfPcW2t055/s41QhFoy/DE0HCyTW6xJtXtjUIBAqnrX+BrMY5BiViNOXZJhI0T+IYpvpvbfteDUENw16rB3rsQTLKCJzRtr4DyWm6YjmB0nnltbMLvur7TFnKBIEj6rbzvy7WWULgYPCz6JzTmHMCO2dcOLdvY6b6C1AdvjDBAAAA",
    Pbi3DGeometry:
      "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",
    "ADA Compliant": "Yes",
    Area: "0",
    "Assembly Code": "D2010310",
    "Assembly Description": "Lavatories - Single",
    "CADworks URL": "http://www.CADworks.net",
    "Chrome Drain Fitting Visibility": "Yes",
    "Cold Water Connection NPT": "10",
    "Cold Water Connection Radius": "5",
    Cost: "0",
    CWFU: "0",
    "Default Elevation": "0",
    Description: "Rectangle Vessel Lavatory",
    "Design Option": "-1",
    "Distance from Wall": "102",
    "Elevation from Level": "750",
    Family: "Standard",
    "Family and Type": "Standard",
    Finish: "Epoxy Resin - TOTO - 61 Angelic White",
    "Flow Pressure": "0",
    Host: "Level : Level 2",
    "Host Id": "-1",
    "Hot Water Connection NPT": "10",
    "Hot Water Connection Radius": "5",
    HWFU: "0",
    Image: "<None>",
    Manufacturer: "TOTO",
    Mark: "32",
    Model: "LLT151",
    "Nominal Height": "115",
    "Nominal Length": "320",
    "Nominal Width": "500",
    "Offset from Host": "750",
    "OmniClass Number": "23.45.05.14.14",
    "OmniClass Title": "Sinks/Lavatories",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Product URL": "http://www.totousa.com/ProductDetail/tabid/75/Default.aspx?ProductId=bed3c6ef-3249-4991-8e7d-95b38e7deef4&SearchId=38911d30-d0e8-4fd9-a60f-54114ef37070",
    Series: "Luminist",
    "Shipping Weight": "0.06",
    "System Classification": "Sanitary,Domestic Cold Water,Domestic Hot Water",
    "System Type": "Undefined",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    URL: "http://www.totousa.com",
    Volume: "0",
    "Waste Connection NPT": "32",
    "Waste Connection Radius": "16",
    WFU: "0",
  },
  {
    ID: "699850",
    Category: "Section Boxes",
    Description: "-1",
  },
  {
    ID: "699851",
    Name: "Kitchen",
    Category: "Views",
    "Callout Tag": "Explicit",
    "Circuit Prefix Separator": "Poche",
    "Created By": "Yes",
    "Crop Region Visible": "Yes",
    "Decimal Degress": "None",
    Department: "Independent",
    Description: "-1",
    "Desired Stair Height": "Medium",
    "Detail Line": "-",
    "Dimming Lamp Color Temperature Shift": "Architectural",
    "Extrusion Start": "1500",
    "Facucent Drilling": "3D View",
    Family: "3D View: 3D View",
    "Family Type": "No",
    "Far Clip Active": "14823",
    "Lock Proportions": "Yes",
    "Neutral Rating": "Yes",
    "Nominal Width": "-1",
    "Parent View": "Show Original",
    Perimeter: "Working Drawings",
    "Phase Demolished": "Show All",
    "Projected Area": "Perspective",
    "Schedule Level": "None",
    "Scope Box": "No",
    "Sheet Name": "---",
    Summary: "No",
    Tank: "1500",
    "Tumble Dryer": "3D View",
    "Type Comments": "3D View",
    "Vertical Scale": "Kitchen",
    "View Scale": "-1",
    "View Template": "-1",
  },
  {
    ID: "700280",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "700281",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "700282",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "700283",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "701300",
    Name: "fire place hang: fire place hang",
    Category: "Generic Models",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry: "vQAAAB+LCAAAAAAABAA9jc0KwjAQhN9lzzEkxrYYT6KCoIeigofSQ4tLG4hJiVEope/uitXb/HzMFAPktbn0HYKGg6/NuWsxIDDIvXHxAboYvpJ6pbiQMl3NFglfqgzG8oetQ6h6YinYmuqOEQPo5ENLBkd0TWxBCy4YnHysovFusldz+1d7NE1LP3PJRaoY7Cy+JnZGkcxoa+Otp2n3tHYs33K95MK9AAAA",
    Pbi3DGeometry:
      "ewgAAB+LCAAAAAAABADtlE+LgzAQxb/LnGMYNaFWT8vuQg97KGWhh9KDZUMbcM1is4UifvcNrf2Dkh29iyhOfnlvTNS3qWG505/nHwVp+VsUDJZGl/YI6aa+3kIKmLkDGvYYCULE7HJxJzTbm+ylqvKz08bIhYgEC0TCJcqEBSHHcBayWHKZYPIfiLmYi9kD0FZeRRfQzVsQIUch5/0efUA9ldeKXmAX3K26C+wDr5VXMX4TKUD3GKygFzj+1Q628ipoMP67oq0G7pX7J990/q2sqiB1Qww+VLm3h7ZYGZtbbcq2XOuvO1oovT/Ytngv1Ol54qspTHXNiksgTOExhccUHlN4jA6P7R9o05mmewgAAA==",
    Area: "8",
    Cost: "0",
    "Default Elevation": "1219",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "fire place hang",
    "Family and Type": "fire place hang",
    "Host Id": "-1",
    Image: "<None>",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Schedule Level": "Level 1 Living Rm.",
    Type: "fire place hang",
    "Type Id": "fire place hang",
    "Type Image": "<None>",
    Volume: "0.55",
    "Work Plane": "Level : Level 1 Living Rm.",
  },
  {
    ID: "704053",
    Name: "Compound Ceiling: 3000 x 3000mm Grid",
    Category: "Ceilings",
    Level: "Level 1 Living Rm.",
    "Aalto Vase Material": "0.1",
    "Architrave Offset": "71",
    "Coarse Poche Material": "0",
    "Coarse Scale Fill Color": "-1",
    CosAng: "0",
    Description: "-1",
    "Facucent Drilling": "3000 x 3000mm Grid",
    Family: "3000 x 3000mm Grid",
    "Heat Load Values": "0.0000 /(·)",
    "Height 1": "2700",
    Illuminance: "<None>",
    "Parts Visibility": "35596",
    Phase: "Working Drawings",
    "Phase Created": "None",
    Rim: "No",
    "Rough Width": "1",
    "Slab Thickness": "0.00°",
    "Text Type": "0.00 /",
    "Thermal Mass": "0.0000 (·)/",
    "Thermal Resistance (R)": "50",
    "Tumble Dryer": "3000 x 3000mm Grid",
    "Type Comments": "3000 x 3000mm Grid",
    "Type Id": "<None>",
    Voltage: "3.54",
  },
  {
    ID: "704275",
    Name: "Curtain Wall: SH_Curtain wall",
    Category: "Walls",
    Pbi2DGeometry:
      "EwEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzE0TWJDPYkKgh6KCB5KDy2GdiEmUqNQSv/dQGvFk7edfcPM5D1kFZ67u4YUDq7CzJmudhYIZA6tf0Ca9+MZDHFMFU+S1UIyKpkQMJAvFJwyJeUfKBSNOV/+wDl2hsWnft22ZRc2hMcWy5v2uoU0ohGBo7a1byZxcr70GGaP8oLXGe011k1oUVRJxQnsjH5N3gWjKhKSwMYZF3Lt05iheAN3dV45EwEAAA==",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "16",
    "Assembly Code": "B2020200",
    "Assembly Description": "Curtain Walls",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 1 Living Rm.",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Border 1 Type": "64 x 128 rectangular",
    "Border 2 Type": "64 x 128 rectangular",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Curtain Panel": "Glazed",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "SH_Curtain wall",
    "Family and Type": "SH_Curtain wall",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "64 x 128 rectangular",
    "Join Condition": "Vertical Grid Continuous",
    Justification: "Beginning",
    Layout: "Fixed Distance",
    Length: "6202",
    Number: "1",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "1500",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Ceiling",
    "Top is Attached": "No",
    "Top Offset": "-550",
    Type: "SH_Curtain wall",
    "Type Id": "SH_Curtain wall",
    "Type Image": "<None>",
    "Unconnected Height": "2700",
  },
  {
    ID: "704276",
    Name: "Curtain Wall Dbl Glass: Curtain Wall Dbl Glass",
    Category: "Doors",
    Level: "Level 1",
    Pbi2DGeometry:
      "1QAAAB+LCAAAAAAABAA1jV0LgjAYhf/Lez3HPpzOdRUlBHUhEnQhXlgNHawtbAUi/vcW1d3h8JzzNDNUZ3Oc7hoU7P3Z1PoSOtdbDQgqb1x4gGrmb4wIEzjLmFglaYFlnsLS/rH1OHZTZGOxNd1NBz2CIpggOGjXhwEUw1zkCGofumC8A8UxS2VGKJe5LASVLC8TKhCczPXDE8wLIRHstOmHKM+w5IQhKK1+/R4SiiUlcbLx1kefe1q7tG/3QTtB1QAAAA==",
    Pbi3DGeometry:
      "OR0AAB+LCAAAAAAABAClWdtq20AQ/Rc9y2J1s1bOU0gLhfYhtIU+hDw4RCQC1yquKISQf698kWOPZubMOoRcfPbonPHu7O6Mc/ca3T60P1/+NNEi+to9tD+6VfsYxdFt1677v9Hi7nX/5zDsroav6C1+R2apc1e7H8N39HY/Pna92SxfhmezMimqMp6VLkn9vIzTZF6XZbyF69LvcFe46hQ/0Ck80jNX5QEyxDXXUCoNArfRee2aJ3sWHclEw2d1pmlTuuZIZu8oTXFeQwgEsLkVK+rE59l0gQe8rnzG4T5NS0ZGolOcd81LTjvnIwSBCyJ82ETEs2jNk4/wufR+whk8SIQPT5IecTLbnl0boE3Y51vYZb5mdt8In+++I5lsYcDmpclBNdGmuKAihILoRN2zbLrVCJuiZBsbVYhnzQdODiVj3Ca2IE121Okay+g+jc9nm8F1aRNZ1CYHFZURYEmd0D3LplttgpMYPRuKqMJ6knNmApMI9bglETZsZtXsRwSsQwjOX/+8J3+yqdwQN7UUsp2jKqrbSdVU2OGqs8Ms9cLTep7rsLWqBbg5K0HwZl+Q3fBqQFeJsZQV69DLLjaAG6tfFQUXm8YNcVP7BnAVq6EFNSQ6DO5nwA6z1FsglJYgQmN/ZcxteNGjwoB2DggHnRAqMFCYgY2WDqOyRmeHWeptnF4vgvhsHSLfToYUqDo3xE3rUVFm6rGZul9jbqMCT6pXUZtKcKEHDitZETvMUv0AwFhpqzBwFHp0LQxb6xHupn6mYGxGVBT4SZ9thDZRiB/qC5J7r++H30X1rlMmLq2rKT5LE++KndB8Xn1oQLIY8ZE/FjtHofEBOEAdKE4doLN5gCpJ7w3h2FmcDBirfeXEJPjwStgt4MCli41CDU1XlMYneDkUftM3lie5c5aBUUnCqYPZmYZK8dOM2SldPiBZIFzSsb5nNHfBU4EeCDWGi4PnGsZqTz0xZYIXGj4Q7i2t9bn1fRx9ape/m77ZRIthJI6+Neun/vnw4nvXL/u2Wx9e/mofj0NfmvbpuT+8+Lxq/p0Sb7pVt9n+D9R5d7P9V+d/V2Xw9zkdAAA=",
    "Analytic Construction": "1/8 in Pilkington single glazing",
    Area: "3",
    "Construction Type Id": "GSP4R",
    Cost: "0",
    "Define Thermal Properties by": "Schematic Type",
    "Design Option": "-1",
    Family: "Curtain Wall Dbl Glass",
    "Family and Type": "Curtain Wall Dbl Glass",
    Function: "Exterior",
    "Glazing Material": "Glass",
    "Handle Material": "Metal - Aluminum",
    "Heat Transfer Coefficient (U)": "3.6886 /(·)",
    Height: "2080",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Mark: "106A",
    Offset: "51",
    "OmniClass Number": "23.30.10.00",
    "OmniClass Title": "Doors",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rough Height": "0",
    "Rough Width": "0",
    "Solar Heat Gain Coefficient": "0.78",
    "Thermal Resistance (R)": "0.2711 (·)/",
    Thickness: "0",
    Type: "Curtain Wall Dbl Glass",
    "Type Id": "Curtain Wall Dbl Glass",
    "Type Image": "<None>",
    "Type Mark": "68",
    "Visual Light Transmittance": "0.9",
    Volume: "0.06",
    Width: "1440",
  },
  {
    ID: "704282",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1",
    Pbi2DGeometry:
      "0wAAAB+LCAAAAAAABAA1jV0LgjAYhf/Lez2Hc7qvrqKEoC5Egi7EC6uhg7WFrUDE/96iujscnvOcZobqbI7TXYOCvT+bWl9C53qrAUHljQsPUM38jRGhKS4KskpyiQXPYWn/1Hocuymisdia7qaDHkGlOEVw0K4PA6gcc4mg9qELxjtQFGe5YCmhggtZEJHxMiEFgpO5fvC4FZQi2GnTD/GaYSazKCitfv0MCcGM0wzBxlsf79zT2qV9A43Bv+nTAAAA",
    Pbi3DGeometry:
      "JQQAAB+LCAAAAAAABACdU1ELgjAQ/i/3PMfUZs6eooKgHqKCHqQHo1EDc2EjEOm/N0stDJvF2PS+2323fbsLc1jsxDo7cwhgJndiJWOxBwQLKRJ1gSDMn7/aTQZ6wA29EMsmZPBY9ITbtgobpmmU6VjXwaznIYsSTGzmI8vGXt91UBOnxaePHB/blLL/8Tb+Cq8Degwz16MVUbXfADfpm/gHvSlv6wVamX49klGJrtJ1TdxN0cZD/lgnLeRGlU3qfz+ksQpNabuXifG1nil0v41FdOKKpxBoD4I5Tw7qWBpLqSIlZFKaG7GvXVMuDkdVGpOYX983jmQs06LfiU9GRVvfAQl45XglBAAA",
    "Analytic Construction": "<None>",
    Area: "3",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2040",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.08",
    Width: "1460",
  },
  {
    ID: "704284",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1",
    Pbi2DGeometry:
      "1AAAAB+LCAAAAAAABAA1jUELgjAcxb/L/zyHbnOb6xQlBHUQCTqIB6uhg7WFrUDE796iuj0ev/d7zQzV2RynuwYFe382tb6EzvVWA4LKGxceoJr5GyNCc8wEIauEFVgKBkv7x9bj2E2RjcXWdDcd9AgqxSmCg3Z9GEAxLAoEtQ9dMN6BopgwydOMSiGLPJNElEmWIziZ6wePW0kpgp02/RC/OeYFiYLS6tfPkGSYC0oQbLz18c49rV3aN7U2p0jUAAAA",
    Pbi3DGeometry:
      "NwQAAB+LCAAAAAAABAClVM0KwjAMfpecu9JZt27zJCoIehAVPIiHiUULc5VZBBHf3U63KY6RiZT+JF+Tr03Srm8w26rl9SQhgoneqoVO1A4IzLRKzRmi9e21tDDr2QZ38tY4LmO952A73DelWT/L4qu15YIGvugQx2OUuWFAHJf6gndIDfDySRDOKRP/6BsJKqC06IY05L5XeSoNMH2NoQZ8M6DUjZdo9PT7odB4tI9ga/K2of1O6s9V00SABRxLBHZQrCox3vYlg6btRWFf4FDFR2lkBpFFCExlujeHQphrExul00JcqV0FjaXaH0whjBJ5+dw40InO8h+ABWyQP/QH76ErFTcEAAA=",
    "Analytic Construction": "<None>",
    Area: "3",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2040",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.08",
    Width: "1460",
  },
  {
    ID: "704286",
    Name: "Curtain Wall Dbl Glass: Curtain Wall Dbl Glass",
    Category: "Doors",
    Level: "Level 1",
    Pbi2DGeometry:
      "1QAAAB+LCAAAAAAABAA1jUELgjAcxb/L/zzH5qab6xQlBHUQCTqIB6uhg7WFrUDE796iuj0ev/d+zQzV2RynuwYFe382tb6EzvVWA4LKGxceoJr5GyPCCWY5EauEF1gKDkv7x9bj2E2RjcXWdDcd9AiKYILgoF0fBlApZplAUPvQBeMdKIZTLnNCmRSyyKhMRZnQDMHJXD98VBWZRLDTph+iPMeSkRRBafXr95BQLCmJk423Pvrc09qlfQM3YVDP1QAAAA==",
    Pbi3DGeometry:
      "AR4AAB+LCAAAAAAABAClWV1r20AQ/C96lsVJlizJeQppoNA+hLbQh5AHh4hE4FrBFYUQ8t8rf0i29jQ3ew4hwZobzazv9k67yv17cPdY/3p7rYJl8K15rH826/opCIO7pt60f4Pl/fvhYzdsrrqf4CM8IbPYmKv9n+43+Hjob7vebldv3b2pieJ8noSzrPtQLLIwjhZlloU7vEz3sElNfg73dIkf6YnJ5x4qwtSkhRuX8iR4JR3JLwA/A2EOfKGTJd2lS1/ygf6Ai+kc9CWOdEA8lD+5jGkZFfPEWvUOLvNOz4aLOM6mVABdwsD0sIi2/AkXQZLgoQyIXshkwHYB+Cd8rH+Y+wmc6uv4UL/HxfQPOghH+oIvt7pJinJqj/a43KMDf7zVKR3Iy3NNyksYyUxHw+hCXe7DARf70OJLXOxztY7wleeghUt9Fr+Sj/Tlnhsvugs/5Pho+idgKq/jI/nxuWapIByoC7rch+O5n+CL/W/pIL7SV55HNi7iZPFDHRD/5CKqzxFS1wgYFRLIFB2ClO/rS+os9eFLcOYL6zXfU5nxfX1Jlat9GhBcW0S7YWXGukNXWrrTnj5P2PNHWSfD+vbS5yHB1XU1wenzkPF9fUmfwp7nNE7fPojg7DlP+b6+pP9ieUvj1PZ3yvxnFYO7vpCNiht2N1+0SHFH6NnZEZxWRozv60s6R1Z+0jiVnSnqZH3LXs739XW3yiRfeZjKTlyV97RuRPUw65MFjvpw33qY83193e8j9PW8G2e+8H0Bqv9RP8L4vr7kfYe6DyI49UXvX3z7OMb39SX5f9BPojxJypNOFpm4zG18FkeFSfdC80X2qQFk0eM9vy+fBqH+BjogHSQuHaizekAqoe/GcO4MJ4PGql85mASfXgm9BR24dLFZqL7pytL4DM+6HWl9sXkelWWhGTgqIdxyUDuLUC38PGP2SpcPIAuCIx31dyZz5z0V9AZfY7o4dK55rOrUgynjvdD8Bn9vtNZj64cw+FKv/lRttQ2W3UgYfK82z+3L8eJH067autkcL3/XT8PQ16p+fmmPF7fr6t858aZZN9vd/3JNYW52/7L9D/BbGu0BHgAA",
    "Analytic Construction": "1/8 in Pilkington single glazing",
    Area: "3",
    "Construction Type Id": "GSP4R",
    Cost: "0",
    "Define Thermal Properties by": "Schematic Type",
    "Design Option": "-1",
    Family: "Curtain Wall Dbl Glass",
    "Family and Type": "Curtain Wall Dbl Glass",
    Function: "Exterior",
    "Glazing Material": "Glass",
    "Handle Material": "Metal - Aluminum",
    "Heat Transfer Coefficient (U)": "3.6886 /(·)",
    Height: "2080",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Mark: "106B",
    Offset: "51",
    "OmniClass Number": "23.30.10.00",
    "OmniClass Title": "Doors",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rough Height": "0",
    "Rough Width": "0",
    "Solar Heat Gain Coefficient": "0.78",
    "Thermal Resistance (R)": "0.2711 (·)/",
    Thickness: "0",
    Type: "Curtain Wall Dbl Glass",
    "Type Id": "Curtain Wall Dbl Glass",
    "Type Image": "<None>",
    "Type Mark": "68",
    "Visual Light Transmittance": "0.9",
    Volume: "0.06",
    Width: "1440",
  },
  {
    ID: "704288",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABFjUELwiAcxb/L/2wynelcp6ggqMMYQYexgyvZBNNYFoyx756xott7j9+PV41QNOY03DXkcPCNKfUlKNdaDQgKb1x4QF6Nc4wIo1hQKlcLJnEmGEz1D1v3vRoiG4etUTcddA95ghMER+3a0H0KSQlFUPqggvEOcoKXIhGSp5QLyTLJOYKzuc5wSjOCYK9N24W/vLP69bU5lpRGY+Otj1/uae1UvwHYa2Aa0QAAAA==",
    Pbi3DGeometry:
      "7wMAAB+LCAAAAAAABACVk9EKwiAUht/lXJuYtZbrKioI6iIq6CK6WCRLWDOWBGP07lnZitHUNiY7n+f8yq9nW8JiL9bFmUMEM7kXK5mKAyBYSJGpC0Tb8vWrp8lAv3BDH9JqEzJ4DvqD2+5dNszzuNC1XYpDShlqBQSTTh/1MKO0hyrcZThsN9AQk0CXOKgRbsBGuRNixvpBTaNG67kNEnb8W9q+aZeG10ZcTv/nk9U+K3Ucrc898FrOz2gbtd46x2peB+jy/ltad85YxCeueA6RTkcw51mijiZYShUrITMTbsShmppykRyVCSYpv34njmQq80fnPh/doHd90A7a7wMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1440",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "704289",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABFjcsKwjAURP/lrmNI05hHXYkKgi5KEVyULloNbSAmUqNQSv/dSBV3M8M5TDlC3pjTcNeQwcE3ptCXULvWakCQe+PCA7JynGNEqMSEMrFaMIWlYDBVP2zd9/UQ2ThsTX3TQfeQEUwQHLVrQ/cpSZpQBIUPdTDeQZbgpSBC8ZRyoZhUnCM4m+sMp1QmCPbatF34yzurX1+bY0VpNDbe+vjlntZO1Ru4cwiU0QAAAA==",
    Pbi3DGeometry:
      "7wMAAB+LCAAAAAAABACVk1ELgjAQx7/LPa9xusq0p6ggqIeooIfoQXHUwFzYCCL67q2ysshtKQ7vt7v/xn+71RmmiVic9hwiGMtEzGUmUiAwlSJXB4hW58evnsaufuFC3qThIXbvg/7gsn6W9YoiPulav0PRbwak0UKKrEPaNPT9NnnhZkgDr4YGFFu6xEJL4Rr8VGaUIbJvjU/6nVsjYca/pS2btmi4bcTi9H8+Ge0zU/PROt0Dl+XcjDZR860zr+Z2gBbvq9K6cwYi3nHFC4h0OoEJzzdqWwYzqWIlZF6GS5G+pkZcbLaqDIYZP1YT+zKTxa1z749u0CtvSbSb7wMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1440",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "704290",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABFjUELwiAcxb/L/2yyqblpp6ggqMMYQYexgyvZBNNYFoyx756xott7j9+PV41QNOY03DVIOPjGlPoSlGutBgSFNy48QFbjHCNCCRaMrxZM4DxjMNU/at33aohoHLZG3XTQPcgEJwiO2rWh+5SUpgRB6YMKxjuQKV5mSSY4JTwTLBecIzib6wxTkqcI9tq0XfjLO6tfX5tjQUg0Nt76+OWe1k71G7FhJE3QAAAA",
    Pbi3DGeometry:
      "3QMAAB+LCAAAAAAABACVk98LgjAQx/+Xe15jmpraU1QQ1ENU0EP0YDhyYC5sBBH97y1bPxA7l6J4n919N77nba4w34nV5cghhqnciaXMRQoE5lIU6gTx5vr81Musr2+4kQ/pOIz1q5d+4LZ9lQ3KMrno2q5LIy8gHZ9R1g1JQCPXDciLehHtOc2wR5mvC1BoRJupUXVD6vh+VFOo0XruDwkcN0ujR26TsDoHbvFfHqHWoRTtqEXzrfaychiB2I/WspVV33DPv4X1nIxEcuCKlxDrbAIzXuxVZoKFVIkSsjDhWqTvpQkX+0yZYJzz83fiUOayfMxpdelxvAPWyq5J3QMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "704291",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABFjcsKwjAURP/lrmNokppHXYkKgi5KEVyULloNbSAmUqNQSv/dSBV3M8M5TDlC3pjTcNeQwcE3ptCXULvWakCQe+PCA7JynGNEmMCSC7papApLkcJU/bB139dDZOOwNfVNB91DluAEwVG7NnSfQhihCAof6mC8g4zgpUiE4oxyoVKpOEdwNtcZZlQSBHtt2i785Z3Vr6/NsaI0GhtvffxyT2un6g2D7VRg0QAAAA==",
    Pbi3DGeometry:
      "7wMAAB+LCAAAAAAABACVk10LgjAUhv/LuV5jaTqzq6ggqAupoIvoQmnUwFzYCCT87y2z79yW4vA8O+fdeLezOkOU8EVxYBDCRCR8LlK+AQSR4Jk8Qrg6337VNOmpF0r0JK02Ib1qUB+U63tZP8/jQtW6FAc+dVDLI5i4AfJx13F89MCdLqbtBkox8VSJgdbCDfiu7GJCvzXe6Wdug4Qe/5Y2bNqgYbcRg9P/+aS1T0/1R2t1D2yWszNaR/W3Tr+a3QEavH+VVp0z5PGeSZZDqNIRTFm2lbs6mAkZSy6yOlzyzWNqzPh2J+tglLLTa+JApCK/dm71qAa9AMTAFrHvAwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "704293",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABFjUELgjAcxb/L/zyHm5vb7BQVBHUQCTqIB62hg7WFrUDE755h0e29x+/HK0fIG3Ma7hoyOPjGFPoSatdaDQhyb1x4QFaOS5wRKjHhXK0iprAUDKbqh637vh5mdh62pr7poHvIYhwjOGrXhu5TSEIogsKHOhjvICOYi1ioNKGpUEyqNEVwNtcFTqgkCPbatF34yzurX187IljGjCPYeOvnM/e0dqreppvlwdIAAAA=",
    Pbi3DGeometry:
      "AQQAAB+LCAAAAAAABACVk1sLwiAUx7/LeXbibrXLU1QQ1ENU0MPoYWNSwpqxJIjou2drta5qiuL56fkr53iSE0wztjjuKEQw5hmb84LlgGDKWSn2ECWn21Juk1h2OKOWWDYhcT3JAefV3a1XVelR+joBtn0/RJZPMHEDZNm403Ud9OBeiLu2AgfE87W4Ff/Fa3XXwaHXeVf5oC9nf0ho8Xdp5bM1ImYv0Qb8z1jpQqiguhybfQnDG03ircOqL6i+0CyT2hy8iMtaGrB0SwWtIJIOCCa0XItNY8y4SAXjZWMuWf7YGlG23ojGGBb08HywzwteXWu5brJkL1NgaKEBBAAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "704294",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABFjUELgjAcxb/L/zzH5qZzdooKgjqIBB3Ew6yhg7WFrUDE755h0e29x+/Hq0YoGnMa7hpyOPjGlPoSlGutBgSFNy48IK/GJc4IY5gIEa8iLnEmOEz1D1v3vRpmdh62Rt100D3kBBMER+3a0H0KZTRGUPqggvEOcooTQYRMWZwKyTOZpgjO5rrALM4ogr02bRf+8s7q19eOKM4ITxBsvPXzmXtaO9VvHIpDANIAAAA=",
    Pbi3DGeometry:
      "EwQAAB+LCAAAAAAABACVk1ELwiAQx7/LPTtxreVaT1FBUA9RQQ/Rw0ZSwpqxJIix757VakVtZ4ri/fT+yp23zmEWy+XlKCCEiYrlQiVyCwRmSqb6BOE6fyzNNuuZDgWpiOMy1rtPZkCxebr1syy6GF/Po4zzFnF8RpkXEMelHe61yIu3u5S7DThgbR/FlXgdf6hzGnR+yHzhz9N1KjivkW9+PCZj+xws8v8GDQ1mI0bybfk9bO+0CjyGG38kcqVtUrFkfMib6hrK6CC0yCA0DgSmIt3pfWnMlY60VGlpruT2tTUWcrfXpTFKxPn94EAlKrtV972ZIr4CSdm9yBMEAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "704296",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry:
      "1gAAAB+LCAAAAAAABAA1jUELgjAcxb/L/zyHm1P/2ilKCOogEnQQD1pDB2sLW4GI372FdXvv8Xvv1TOUnTpPDwk5HG2nKnl1rem1BAKlVcY9Ia/nVXpEcIqxYJtAZBRTAUvzx7bj2E6e9cFetXfp5Ah5SEMCJ2l6N3wNixgnUFnXOmUN5BHlApOQRZhiFjPkaRGwmMBF3dZCxJEROEjVD/49oYgZEii0fP8WAkYxFL6ys9r6Q/PSemk+qzRmxNYAAAA=",
    Pbi3DGeometry:
      "egMAAB+LCAAAAAAABACtk98LgjAQx/+Xe55j6kZmT1FBUA9SQQ/Rg9LIgbmwEYT4v7fUyhJFqY2N3efuvjf2Y5eCF4jN7czBhYUMxFpG4gAIPClidQF3lxZL7SYj3SFDb2KYhIzySQ/I9s+0cZL4N51LLTywrCEyGMHEdpBhYodQhl6cDvHArGKHUbMvbhKv86b4D84wcZhdk+mHf9hkq3xxBH1o54oN4d/a1avoQ/9y99/StVPqgttL6kc8Ff6JK56AqxMQLHl8VGFprKTylZBxaW7F4eWac3EMVWnMIn6tBk5kJJPHJ8qb/it3HNlou3oDAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2100",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "704297",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7yG25xudooKgjqIBB3Ew6yhg7WFrUDE797Cur33+L336gnK1pzHh4YCjr41lb4G5TqrAUHpjQtPKOppkRGhDJNMkvUqlVjkKczNH9sMgxojG4OdUXcd9ABFghMEJ+260H8NYYQiqHxQwXgHRRxLCZc044wLmUsEF3NbUEYFQXDQpuvjL8EyExzB3ur3r8txIjhDsPXWxyf3snZuPsRq7HXPAAAA",
    Pbi3DGeometry:
      "aAMAAB+LCAAAAAAABAClk10LgjAUhv/LuV7j2DLTrqKCoC6kgi6kC6NRA3NhIwjxv7fMzLJEa2Mf59k57769GNyNWF6OHByYyo1YyEBsgYArRahO4HjxvauHsa8zJORJWgZiP610gWT9CBtEkX/RsW1GGSIjLRMpsh6xKJq6yXHHppZRoEbXNprRL8Il/MX7BZsUeyYriTTDvy6wUvu+9ya05nyfnd+FixfQhP5/3e+6pfOpg6sm1E92JPwDVzwCR7sTmPFwp/aZMZfKV0KGmbkS23xowsVurzJjHPBz0XEoAxndvkya9M+4Agkbk9JoAwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "600",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "704298",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry:
      "1gAAAB+LCAAAAAAABAA1jcsKwjAURP/lrtOQV+1NXYkWBF1IEVyIi6ihBmIiNQpS+u9G1N3McGZmP8Dm6Lavm4UaVvHoWntKJnTeAoFNdCHdod4PX5kRgZRpJqeF0hQrBePhj8363rwym4OFM1ebbA81o4zA2oYuXT6GSy4ItDGZ5GKAWlKhcMK4xAp1yVFUTcFLAjt3/hakQE5gaV13ye8TiqiRQOPt87dQcIpM5co8+pgPw8P78fAGiXFVxNYAAAA=",
    Pbi3DGeometry:
      "egMAAB+LCAAAAAAABACtk8kKwjAQht9lzmlIl9DFk6gg6KGo4KF4qDRooDYSgyDSdzfaqrWlxaIJCZlvZv4JWaIrhFu+uhwZBDATW74UKU8AQSh4pk4QRNdiqd1koDvk6E0Mk5DBY9ID8s0zbShlfNG5loeJ5bjIoAQT20OGiT3iUPTijo9ds4pNSv2+uE28ydviPzjFxKN2Q6Yf/mGTnfLFEfShX1dsCa9rV6+iD/3L3delG6f0De4uqR/xmMcHppiEQCcgmLNsp/alsRAqVlxkpbnmycs1ZXy3V6UxSdm5GjgSqZD3T/Ro+q/cANCOfEh6AwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2100",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "704299",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry:
      "1gAAAB+LCAAAAAAABAA1jcEKwjAQRP9lz2nIJmm7rSfRgqCHIoIH8VA1tIGYSI2CiP9uRL3NDG9mdk9oD3bzuBioYRkOdm2OsfO9M8CgDdbHK9S751cmRCkuEItJpitOpYbX/o9Nx7F7JDYFc9udTTQj1IILBivj+zh8DCqUDNYhdtEGD7XiUlMhUFFJVY4kyybDnMHWnr4FJQkZLIzth/RecKKKGDTO3H8LGXISOlVmwYV06G/OvfZvcf2iPtYAAAA=",
    Pbi3DGeometry:
      "awMAAB+LCAAAAAAABACtk1sLgjAUx7/LeZ5j3vLSU1QQ1ENU0IP0oDhyYC5sBBF991Zq1kjRaGNj57dz/rue4ArLiG0uRwo+zHnE1jxlMSBYcpaJE/jBtRjKaTKUFW6oJppOyPDZyQa3XRU2yvPwImNNA3vWAGk2wcR0kaZjl1g2qrDlYUevqYmJ4xh9cYO2ipvcFW5j4tqmqtKH/rrBVu3i7N1hx8W+O3/qfl5/H/qP51aVlevphtuXlL92wsIDFTQHXwYgWNBsL5LSWHERCsaz0tyy+DU1o2yfiNKYpvT87jjmKc8fWfMsMjnu8VxmwGsDAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2100",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "704300",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry:
      "1gAAAB+LCAAAAAAABAA1jVELgjAUhf/LfZ7DualXe4oSgnoQCXoQH7SGDtYWtgIR/3sL6+2ey3fOV89Qduo8PSTkcLSdquTVtabXEgiUVhn3hLye19MjPKUZj3ATiIxiKmBp/th2HNvJs/6xV+1dOjlCHtKQwEma3g3fwDiLCFTWtU5ZAzmnkcAkZBxTzGKGUVoELCZwUbe14FWMwEGqfvD2hCJmSKDQ8v1bCBjFUPjKzmrrheal9dJ8ANkfOErWAAAA",
    Pbi3DGeometry:
      "egMAAB+LCAAAAAAABACtk98LgjAQx/+Xe55jZsupT1FBUA9SQQ/Rg9LQgbmwEYT4v7fKyhJDqY2N3efuvjf2Y5ODH4rV+cDBhZkMxVImYgcIfClSdQR3k9+X2k083aFAL2KYhHi3SQ8oto+0YZYFZ51r2ZgN7B4yKMHEYsgwMSN9ip6872DbrGLHYbQrbhKv86b4N04xYdSqyXTDP2zyq/z9CLrQ1hUbwj+1q1fRhf7l7j+la6fUBn8vqR/xWAR7rngGrk5AMOdppOLSWEgVKCHT0lyL3dM15SKKVWlMEn6qBo5kIrPrJ7o1/VcuScM/WXoDAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2100",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "704902",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "704903",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "704904",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "704905",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "706063",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "706118",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "706288",
    Name: "Single Window: Standard",
    Category: "Windows",
    Level: "Level 2",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABAA1jUELgjAcxb/L/zzH5pxu6xQVBHUQCTqIB62hg7WFrUDE796iur33+D1+9QxlZ07TXYOCg+9MpS+hdb3VgKD0xoUHqHr+xogkBOe0WCWUYME4g6X5Y+txbKfIxmFr2psOegRFMEFw1K4PA6gMy5QyBJUPbTDegWKYZpTLNOeMC1lIBGdz/aAEs5zEutemH6JXYCEpRbCz+vX7SiyILBBsvPXR5J7WLs0bb3Upr88AAAA=",
    Pbi3DGeometry:
      "6yUAAB+LCAAAAAAABACtWl1P3DAQ/C95DpFz+XLgqaKVKrUPqK3UB8QDiBNEoqS6niohxH9vctz14tjjnQ0IFXqz9ux6Z71rIS6fk4ub7sfT73Vymnzpb7rv/UN3m6TJRd89bv8kp5fPr/8dzOZs+Epe0iNykhtztvs2/Eterg7bPmw210/D3jyzZVGnw4qsMU2RtllrbJ76sK1sO4VLU1VqGHDv4JMiM03TeCxTfBpLAPd4BP6oXxA9Q8OEIydemTMBj+ZSlpsoDsYpElZXTURJKpxGZZX1ADG2plwFVrdFkwfhutzBec3AB24AEy7zbFXZXdyjVXIJVg9wXY3ctlxVIdi0DbMaRRKOG3DvSQA8ch01dkNxcGH9SK9Z7/K7hwrxePwqv4jfrQ13/VHu4Po5Lq33+EE8QR6qFqh0Innj9erAYgXGyCkN47eEvDwEOVVo8ftDxkiQU7cHdJs4zF59eHVAaSt6M9VW33T/hNavnh8qp5GmQswheWq9raOAyRqGAfvuaZHb4aex6ckqs3b8OTGUhS0CBpPlpopsQC7yrC5rZsOhrwDPHg8KaI8jem2c81cZXH8Ik1yuzluYHx3L7/UurAzeLatAjAd8n7MZ7kk4Wx6mn2ob3eCfaurWpwHheElwyZVBelcd7/BLdlke1B7A2ULPuimuPgDsP2gHrjgRhw5QSZOlTlWFdO1Ep2A5JQuBE72B6ZxRt6K4VDnEZ0JgTLmXD5UogXPzjthANRsJZoYdbOfKNizis8koeUXLBak0hnhExw1t0652htqMv8awWVXUTcBgMmPq2jEcDqc1QB9Hw/LasqayelxK4GBo7Kp0dhRF2wYMJluZonQMhwxqDdDH0RBWKc+asorjjkYIp0Sd18fCmzgVCMCMnrO6CIuTZ1U5qhrBHWkQTmk58yAq49wFTxktLlbE0l7lXBwaF6pBlMWpf08WLS6WQ1gUqm3CXqfVkayHd5pFYfrIZEH19j6DmuxXxOSAwqDWwW5Qpw55eEMz1p0h8hyQBy8cmNqGQDYW8eqTrSLMD2cr7FxhvwtGDTf5iAcIlAa+TNgd6uRBF0vnuvIISH7q/QYfXdrhMksemrzkW0McXmF++DbBoyXseEEmxNnFRRp7ZULV2B3q9EEXwsiOvRaUp5hmvBp/rR1QYoeH3qcLDchFoDqaqq5CdRzHfQcO7juQPMMzQCptTEwyqOzRjvmkOnJqCwbxU7kWRBBCpUpS8K0pGUG4Vx9XafKxu/613q43yelwCdPk6/rxbnu///Ct315vu/5x//Fnd/vf9Hnd3d1v9x8+Paz/Thee9w/9ZvyrLWPN+fjHWf8ASoDtOuslAAA=",
    "Analytic Construction": "<None>",
    Area: "6",
    "Bottom Hung Casement": "No",
    Casement: "SH_Aluminum, Anodized Black",
    "Casement Depth": "60",
    "Casement Pivot": "No",
    "Casement Swing in Plan": "No",
    "Casement Width": "60",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    Description: "Single Window Unit - Triple Glazed",
    "Design Option": "-1",
    Family: "Standard",
    "Family and Type": "Standard",
    Frame: "SH_Aluminum, Anodized Black",
    "Frame Depth": "60",
    "Frame Depth over": "80",
    "Frame Depth under": "80",
    "Frame Width": "60",
    Glass: "<By Category>",
    "Head Height": "2700",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2700",
    "Host Id": "SIP 202mm Wall - conc clad",
    Image: "<None>",
    "Install Depth (from outside)": "80",
    Mark: "93",
    Operation: "SinglePanel",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rough Height": "2700",
    "Rough Width": "1500",
    "Sill Height": "0",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Hung Casement": "Yes",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Type Mark": "46",
    "Visual Light Transmittance": "0",
    Volume: "0.15",
    "Wall Closure": "By host",
    Width: "1500",
    "Window Cill Exterior": "SH_Aluminum, Anodized Black",
    "Window Cill Interior": "Wood_Walnut black",
  },
  {
    ID: "707722",
    Name: "Curtain Wall: SH_Curtain wall",
    Category: "Walls",
    Pbi2DGeometry: "CAEAAB+LCAAAAAAABAB9jsEKwjAQRP9lzyGkmrSxnkQFQQ9FBA+lh4qhXYhZqVEopf9uoFYUwdvOvmFm8g6yEx7aq4EUtnTCjGxbkQMGGaHzN0jzbjiDQQqutE7mM66iiYKe/SLJYzWNv5HiUibxPzQGFmPtomnKNnSHxwrLi/GmgVRwwWBnXOXrl9iTLz2GuYM84vmNNgarOnREmidCaAZrax6f5iVZCqHubm1fPAHKxRDLCAEAAA==",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "8",
    "Assembly Code": "B2020200",
    "Assembly Description": "Curtain Walls",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 1",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Border 1 Type": "64 x 128 rectangular",
    "Border 2 Type": "64 x 128 rectangular",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Curtain Panel": "Glazed",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "SH_Curtain wall",
    "Family and Type": "SH_Curtain wall",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "64 x 128 rectangular",
    "Join Condition": "Vertical Grid Continuous",
    Justification: "Beginning",
    Layout: "Fixed Distance",
    Length: "1481",
    Number: "1",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "3000",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Roof Line",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "SH_Curtain wall",
    "Type Id": "SH_Curtain wall",
    "Type Image": "<None>",
    "Unconnected Height": "5700",
  },
  {
    ID: "707723",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1jUELwiAcxb/L/yyi0+m0U1QQ1GGMoMPYYSvZBNNYFoyx755R3R7v/X68eoays6fpbkDDIXS2MpfY+t4ZQFAG6+MDdD1/Y0I4w4QWdCWwopLB0vyp9Ti2U0JTsbXtzUQzgiaYIDga38cBNMeZyCmCKsQ22uBBU5xLIpVgmZCKF6pI69leP3AyC8YQ7I3th3SssOC5RLBz5vWzCaaMZgg2wYX05Z/OLc0b2hdxv9AAAAA=",
    Pbi3DGeometry:
      "ywMAAB+LCAAAAAAABACVU8sKwjAQ/Jc9x7DV0Db1JFUQ9CAqeBAPFYMGaiM1CEX8d1Ot75q2hITsJLOz7GN5hslazrODgABGai1nKpYbIDBRMtFHCJbn+9U8Y9csuJAX0nIQu7fDbLisHrRemkaZ4bIORR9dwqjnM58gdTpOm3yhnHqey58op8g4b4SW+32hjst+HeTgTwRv4Cfd5rNCqDzSv/x68pa0NkiKDazIlKWCNav9V6u0VE3aomZjVWlVFMuS7A+vZir6MtoLLVIIkCKBsUi2elcYU6UjLVVSmAu5eT4NhdzudGEMYnF6/xiqWKX5VBrFMB++K9oX0mjLAwAA",
    "Analytic Construction": "<None>",
    Area: "4",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2940",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.1",
    Width: "1300",
  },
  {
    ID: "707726",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABFjcsKwjAURP/lrkNo+kjTuBIVBF2UIrgoXaR6aQMxkRqFUvrvRkpxNzOcw9QTlK2+jE8ECSfX6gpvXtnOIBAonbb+BbKelhiQNKERE2yT0lykAuZmpbbDoMaAhmGv1QM9DiAjGhE4o+18/yssYTGBynnltbMgGc3yKC94EvO8SEXBOYGrvi9wEgtG4Ii66/1fPhj8rLagGS+CsnPGhTP7NmZuvngatYjRAAAA",
    Pbi3DGeometry:
      "AQQAAB+LCAAAAAAABACdU18LwiAQ/y73bOKWW257igqCeogKeogeNiYlrBlLgoi+e1ar9QebS1G83939PM+75QkmiZgfdxxCGMlEzGQmUkAwkSJXewiXp/tRq0mkJ5xRhbQcQqLbphecVw+3blHER+1LXcw86iCKO4wy5DDs+YGPaBs7zHXr4Q4hzAh/cRvgN+4AExoEX9wVfLcuSf6FDdw2cRusm0Xy+fhmqTJwG1L1G66NxKYgaq/8mW/bqrKpwdrfsYGt6lv3Ul/EW654ASHBBMGY52u1KYWpVLESMi/FhUifqiEX640qhUHGD6+GPZnJ4trLt6Fb9gKlxLevAQQAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1300",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "707727",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zQAAAB+LCAAAAAAABABFjbEKwjAYhN/ln0NImpo2cRIVBB1KERxKh1RDG4iJ1CiU0nc3WsXt7vjurhqhaMxxuGmQsPeNKfU5KNdaDQgKb1y4g6zGWUYkZZjQnC4FJqkQMNU/atX3aohoDDZGXXXQPUiCCYKDdm3o3oYymiAofVDBeAeS4kVGMsFZwjOR5oJzBCdzmWGW5BTBTpu2C//y1urnt/0ZX3vr45F7WDvVL/zO3GvNAAAA",
    Pbi3DGeometry:
      "pwMAAB+LCAAAAAAABACdU1ELwiAQ/i/3bKLLaFtPUUFQD1FBD9HDxmQJa8aSYIz+e9bWqiFupSjed3ff6Xm3L2AVim1+5uDDQoZiIxMRAYKVFKm6gL8vyqNWk5GecENvpEcJGT03veB2eLmNsyzItS9zsDtgFHmYMM9DBNM+dRDrY+o6ThtKjFCT0QB90TE8dJn7RVdDpWHl/hdqILXe0WD1S9zGEzvnwkxqTocVbblAh+9tiWZOaIfSaKshW+atkLUedcVPRXDiimfgP0xgydNYHSthLVWghEwrcSeiWjXnIj6qSpgl/PppOJGJzB4d9xy6se4Lw1OepwMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1300",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "707728",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zQAAAB+LCAAAAAAABAA1jcsKwjAURP/lrkNoHn26EhUEXZQiuChdRL20gZhIjUIp/XdTq7uZ4cxMPUJ50afhgVDAwV10hVevbGsQCJROW/+Eoh4XGRApaMQytpI0iUUCU/On1n2vhoCGYKvVHT32UEQ0InBE2/puNkwwTqByXnntLBSMxmmU5ongSZrLLM8YgbO+LbDgs92jbrtwnNNM8pjAzuD71/6Ob5xx4ci+jJmaD50a21fNAAAA",
    Pbi3DGeometry:
      "IwMAAB+LCAAAAAAABACdkl0LgjAUhv/LuV5j6qxlV1FBUBdSQRfRhdHQgbmwEYT431tmmqWRbmzsPOdj493ZJeAexOZ25uDAQh7EWobiCAhcKSJ1AWeXPI/aTUZ6QopK0jMIGWWbXpDuX2njOPZuOpeamNnUQBQPGGWIYIKohQ1mmvWob1v9RlTUqkFlrV9RGRpiRk37M7cN7fKaSrmqBG1o0z2/RK0vV9HiH9r5875EbE3r79HdNhXeiSseg/MIgSWPfBXkxkoqTwkZ5eZWHAvXnAs/ULkxC/n1PXAiQxk/uj0buqnvQXSoIiMDAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "3000",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "707729",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABAA1jcsKwjAURP/lrkPIo48krkQFQRelCC5KF1FDG4iJ1CiU0n83Ut0MM8MZppmgutjT+DCg4BAutjbXqH3nDCCogvXxCaqZFpuQjGNCBV1JnJTC3P6p9TDoMaGp2Fp9N9EMoAgmCI7Gd7H/BsopQ1CHqKMNHhTFeUlKWXBWlDITMkdwtreF5UxQBHtjuz79CixywRHsnHn/xhKLjKXFJriQrvzLubn9ADEDGZTPAAAA",
    Pbi3DGeometry:
      "awMAAB+LCAAAAAAABACtk10LwiAUhv/LuTbR5citq6ggqItRQRfRxWLShDVjSTDG/nu21sf6WqMUxfN4fI8cPcsMvLWcpzsBLozVWs5UJANA4CkZ6z24y+y8NNukazrk6EZalJBuMZkB+epyrJckfmrOMgtzm1HkYMIcB1GOO4RwxNqYcst6jymntBZftd/gqnadd4EdzJllP2o0ob/eriJdTVMTWhev7gFeS1dy9A39y4M/Jbox/RzP/NqB9LdCiwRcggmCiYg3OiyNqdK+liouzYUMrlsjITehLo1hJA73jn0VqeRUNUUzxXEE10mtcmsDAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "707847",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1jcsKwjAURP/lrkNImjYvV6KCoItSBBeli6qhDcREahRK6b+bou6GmXOYeoLyYk/jw4CGQ7jYylxj6ztnAEEZrI9P0PX0jQnJGSZU0hXHigoGc/On1sPQjglNxda2dxPNAJpgguBofBd70DnOeEERVCG20QYPmuJCEKE4y7hQuVQyrWd7W+BkSsYQ7I3t+nQsMec0R7Bz5v2zFVZkMTbBhfTlX87NzQdMsVZo0AAAAA==",
    Pbi3DGeometry:
      "3QMAAB+LCAAAAAAABACVU8sKwjAQ/Jc9x7DFWJN6EhUEPYgKHsRDpUEDtZEaBBH/3VTru6YtISE7yc4s+1ieYbJW89NeQgAjvVYzHasICEy0SswBguX5frXP2LELLuSFNDzEzu2wGy6rh1s3TcOT9WVNihx9wmibM04EFcg98oV6nLZ84T9hQZEJURMupn6hns8KGDL0N4o39JPAxVomVRzsX4Jq+o7k1siLCyxNlquSVcv+X6+4ZPU6pHKblQqW1M2R909aOyd9Fe6kkSkESJHAWCYbs82NqTahUTrJzYWKnk9DqTZbkxuDWB7fP/Z0rNNsTq1kLxvHK4nVF2ndAwAA",
    "Analytic Construction": "<None>",
    Area: "3",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2640",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.09",
    Width: "1300",
  },
  {
    ID: "707857",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1jUELgjAcxb/L/zyG29zc7BQVBHUQCTqIB62hg7WFrUDE797Eur3f4/d41QRFay7jU0MOJ9+aUt9C4zqrAUHhjQsvyKtpjVFJGU6IJJsUC84EzPXf2g5DM0Y1FnvTPHTQA+QJThCctetCvwBhhCIofWiC8Q5ygnmWZEowKjKVSiUJgqu5rzKjCx616fp4LLHkkiE4WP35rRWWKeUIdt76+OXe1s71F/XsR0fQAAAA",
    Pbi3DGeometry:
      "awMAAB+LCAAAAAAABACdk10LgjAUhv/LuV5j6rSlV1FBUBdRQRfRheGogbmwEYj431tmmaRmbWzsPHv3nrGPbQqLvVgnZw4uzORerGQoAkCwkCJSF3C36WOop4mnK2SoJD2DEC/vdINs91w2jGM/0WuphQ1mmohix7YcZDDcJ4ShEvcZZSU2MbOp8TNu8K7iqnqAGTXtRo8/N5LjeusPWq+tGjccUyfcnrBe+82400FXcceE9dq2G/wNtyXUr3Ys/BNXPAaXYIJgzqODOhbBUipfCRkV4UYEr6kpF4ejKoJJyK/vwpEMZXz/NXnRn+MG6PeWrWsDAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "707859",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zAAAAB+LCAAAAAAABAA1jc0KwjAQhN9lzyEk6V8ST6KCoIdSBA+lh1RDG4iJ1CiU0nc3Wr0MO7Pf7tQTlK05jXcNEg6+NZW+BOU6qwFB6Y0LD5D1tIwRSRNMKKcrgaNSmJs/tR4GNUY0BlujbjroASTBBMFRuy70H0MTyhBUPqhgvANJcVaQQuQJywuRcpEhOJvrwiaMUwR7bbo+9grMUxbXO6tfv+Pv7423Pva4p7Vz8waFlMJezAAAAA==",
    Pbi3DGeometry:
      "IwMAAB+LCAAAAAAABACVklsLgjAUx7/LeV6ymYKXp6ggqAepoAfpQXHowFzYCET87s1LmbTMNnY5v/M/58B2/BK8kB2LKwUHtjxkB56yCBB4nGXiBo5ftlfpxq6cUKGezAjGbrPJBdX5GbbI86CQscZcI5auI1sehCCsYdQjbNh2i3TNMg0yGSly9WiosjXL0E1l7J9FG6RO90HV2j6p4gl+ovEiau1Y0tFHHKKJRdTabz8zDY0Vkd22YsGFCpqDU8fCjmaxSDpjz0UgGM8688Sil2tDWZyIzlin9P4uXPKU53W3N0M29QPA+EKlIwMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "3000",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "707861",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABFjcsKwjAURP/lrkNomppHXYkKgi5KEVyULqJe2kBMpEahlP67lSruZoZzmGqA4myP/R0hh3042xIv0fjGIRAogvXxAXk1zHFCMk4Tptgyo1JlCsb6R626zvQTOg0ba24YsYM8oQmBA/omtp/COEsJlCGaaIOHnNGFTKQWPBVSZ0oLQeBkrzPMU8UI7NA2bfzLW4evr62plEITWAcXpi//dG6s3/6QhPbQAAAA",
    Pbi3DGeometry:
      "3QMAAB+LCAAAAAAABACdU90KwiAUfpdzbeKWNV1XUUFQF1FBF9HFRlLCmrEkGKN3z2r9DWuWoni+c/w8np9lAZNYzvO9gBBGKpYzlcg1IJgomeoDhMvidjRq0jETTuiJNDxCOtfNLDit7te6WRbl5i71MWtRD1EcMMoQx0HQ5og2scd8vw7lhHmf0CqvHX3j5ZhQzqu8D/RmWzL8hdp5Hfy12/7iQ+XHv0THzmuPzle0xgeHzNe89i2+brXjUGc1uXBAHerX9ElfRjuhRQYhwQTBWKQbvS2FqdKRliotxYVcP1RDITdbXQqDRBxfDXsqUdmlT6/DtOMZDIiQZN0DAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1300",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "708088",
    Name: "Curtain Wall: SH_Curtain wall",
    Category: "Walls",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABAB9jlELgjAUhf/LfV5jtU03e4oKgnqQCHoQHxSHDtYWtgIR/3sDTQiit3vudzjnZD2kpb50dwUJHF2pU2e62llAkDpt/QOSrB/PYGAcMxmJ9WJJsKCcwoB+QI5lHLFvRnBEY/mfzaH5p3zTtkUXFoTHThc35VULCcEEwUnZ2jeTODtfeB1Gj/KqqxkdlK6b0CKw4IIi2Bv1mrwSC7biCLbOuBBrn8YM+RuGbDPVEAEAAA==",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "4",
    "Assembly Code": "B2020200",
    "Assembly Description": "Curtain Walls",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 2",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Border 1 Type": "64 x 128 rectangular",
    "Border 2 Type": "64 x 128 rectangular",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Curtain Panel": "Glazed",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "SH_Curtain wall",
    "Family and Type": "SH_Curtain wall",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "64 x 128 rectangular",
    "Join Condition": "Vertical Grid Continuous",
    Justification: "Beginning",
    Layout: "Fixed Distance",
    Length: "1481",
    Number: "4",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "1500",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Roof Line",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "SH_Curtain wall",
    "Type Id": "SH_Curtain wall",
    "Type Image": "<None>",
    "Unconnected Height": "2700",
  },
  {
    ID: "708089",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jb0KwjAYRd/lm2NIm6T5cRIVBB1KERxKh6qhDcREahRK6bsbUbfL4RxuPUF5tsfxbkDDPpxtZS6x9Z0zgKAM1scH6Hr6zqQwikkh2HIhcc5IBnPz11bD0I7JTWBj25uJZgBNMEFwML6LPWiG84JnCKoQ22iDB51hLohQBc0LoZhUmUBwstePnEpJKYKdsV2fniXmiksEW2dev1phJWhC6+BC+vJP5+bmDW50RgfRAAAA",
    Pbi3DGeometry:
      "JQQAAB+LCAAAAAAABACdU1FrwjAQ/i/3HMOl3dqmPokbCO6hbIM9iA8tBg10jXRBEPG/L12rnd2aphISct8l9x333a1OkGTy/bgXEMNSZfJN5XIDBBIlC/0F8epUX40bp2bBmbTIhCFOfw6z4by+fJuVZXo0fx986jHfI5OAMgwDwikP/Yh0YRbRx4AHLc6Q+qEX3uHoYWhh5nH+b5za8TejG7wbZyC8A21f+vZArulYqz+yZnbYoZJ2zZ1bxE7bq+z4nhrRnY7cw/LalekQmHl7kumn0KKEGCkSeBHFVu8a41XpVEtVNOaH3FxdCyG3O90Yz7k4/H44V7kqq3nHCOfVWH8D4LGoMiUEAAA=",
    "Analytic Construction": "<None>",
    Area: "3",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2620",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.09",
    Width: "1300",
  },
  {
    ID: "708090",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABFjUELgjAcxb/L/7zG5nRzdooKgjqIBB3Ew6qhg7WFrUDE795CpNt7j9+PV49QXs15eGoo4OivptK3oFxrNSAovXHhBUU9zjEiKcOEi3S94pgSwWFqFmzT92qIbBx2Rj100D0UBBMEJ+3a0P0KZTRBUPmggvEOCoozQYTkLOFCprnkHMHF3GeYJTlFcNCm7cJf3lv9WewcZ1xGZeutj2fube3UfAEZSoD+0gAAAA==",
    Pbi3DGeometry:
      "NwQAAB+LCAAAAAAABAClVN1rwjAQ/1/uOYZL07Van4YKA/cgU/Ch7KFisIHajC4IRfzfl7XVdZPQkyUk5O6X+8h9JD3Daqc39YeCBJZmp9em0HtgsDK6tJ+QpOf26GCcugkX9sMZCcRps7kFl/er2HNVZbWTDSUPpAjZKOIC44iJMX+KJhELAz5BKSn8GHHs59/r9/F/6xfIZRzE9wZ6QCtx1fQvwGuD9gqvwONO/Q3IowH0GvAGcBAYdolWMxTLA4mglx+tXCmJIwK0jnAdONfZUVlVQYIcGbyq8mDzjngzNrPalB251fsb9KL0IbcdsSjUqX9xZgpTff8AzXCN/gVlYxFpNwQAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1300",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "708091",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABFjcsKwjAURP/lrmPIo02auhIVBF2UIrgoXUQNbSAmUqNQSv/dShV3M8M5TDVAcbbH/m4gh30429JcovaNM4CgCNbHB+TVMMcJSTgmQibLBSWYSyZhrH/cqut0P8HTsLH6ZqLpICeYIDgY38T2UyinDEEZoo42eMgpTiWRSnAmpEoyJQSCk73OMGcZRbAztmnjX9468/raCmcJSxGsgwvTl386N9ZvMnh369IAAAA=",
    Pbi3DGeometry:
      "EwQAAB+LCAAAAAAABACdU80KwjAMfpeca+nWuT9PooKgB1HBg3iYWLbCXGUWYQzf3eo2f6mrtrQ0X5KvaZqsS5ht+bI4MAhhIrZ8IVK+AwQzwTN5hHBdVkelJj014YweSMcipHfb1ILzpnHr53lUKF+HYptaDlImmHq2hwIceNRHjo0DQqkJ7jt2V49/8uvwV34XW8RzP+jvcGXdsPwJa7jNIteY/xbK+/N/TZeGXpOuFrg9GLPaaLv1a9rNC8ysINu+yQg2q3bVXUMe7ZlkOYQEEwRTlsUyqYW5kJHkIqvFFd/dVWPG40TWwihlp2fDgUhFfu3u21BNfAHnNUeqEwQAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1300",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "708092",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7yGc5vb7BQVBHUQCTqIB62hg7WFrUDE797Cur33+D1+1QRFa87jQ0MOR9+aUl9D4zqrAUHhjQtPyKtpiRFhFCeZYOsVx0pkDOb6j22GoRkjG4edae466AHyBCcITtp1of8WQkmKoPShCcY7yAnmIhEqo2kmFJOKCAQXc1tgmkqC4KBN10ezxJJLimBv9fv3VliylCPYeuujy72snesPGoKiR9EAAAA=",
    Pbi3DGeometry:
      "EwQAAB+LCAAAAAAABACtk98LwiAQx/+Xeza5be5nT1FBUA9RQQ/RwyIpYc1YEkT0v2e1VhRuEimK9zn9epze4gzjlZid9hwSGMqVmMpMrIHAWIpcHSBZnB9L7ca27nAhL9JyENv3SQ+4LJ/HOkWRnvRZ5lHXcxhpBdTBMCAxjZjrE+bSGD3PiH0ahwFrwk9tA67XdiIaIkZfoVT8Q8aam/Q/eUP0pu0/hvlbzkzippxZcsuXqseNCbbkf/mSjb/AktfeqqurJ9IdV7yABCkSGPF8o7alMZEqVULmpTkX68o14GKzVaXRz/jxfWNXZrK4Vfe96SK+AnTKk78TBAAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "708093",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7zG5jbd7BQVBHUQCTqIB62hg7WFrUDE797Cur33+D1+1QRFa87jQ0MOR9+aUl9D4zqrAUHhjQtPyKtpiRHhDJM04+sVJVgQpmCu/9xmGJoxwnHYmeaugx4gJ5ggOGnXhf5bKKMJgtKHJhjvIKdYZCRTKUvSTHFFKEdwMbcFZomkCA7adH1USyyFZAj2Vr9/b4UlTwSCrbc+utzL2rn+ADkTqPvSAAAA",
    Pbi3DGeometry:
      "NwQAAB+LCAAAAAAABACtVEsLwjAM/i8515Ktkz08iQqCHkQFD+JhsqKFucosgoj/3arzTbf6aGlpvq9J2jTpdA+DuRjv1hwi6Mm5GMlUJEBgIEWmNhBN95elprGhOxzIHak5iI3zpAccZle1Zp7HO63rMeoyxyN6C2W+6xMnoD5iQDyXhshYOVFHFloQDz6MRLmPkAaeW38/1BV/NfQBbrL/hNvcwKTw1UF/iJ3JhSl2tvhHr1ZOVIXbFv9jslZlhi1e5VlXYFvEK654DhFSJNDn2UItC2EoVayEzApxIpIb1eVisVSF0En59nFjS6YyP/0A56YL/Qgl20Q8NwQAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "708715",
    Name: "M_L-Anglel-Column: L127X127X9.5",
    Category: "Structural Columns",
    Level: "Level 1",
    Pbi2DGeometry: "zAAAAB+LCAAAAAAABABNjcsKwjAQRf9l1iG0sU2auBIVBF2UIrgoXUQd2kBMpEahlP678QXu5s49M6ceoTya/XBFULD1R1PhKWjXWgQCpTcu3EDV42eMSMao5AWfS8pkzmFqftSi7/UQ0bhYGX3BgD2ohCYEduja0L1CxkRKoPJBB+MdqJTmIhGSzxgXMitkTuBgzv/sBk3bRW8qKS9ivbb4+B6/fy+99dHj7tZOzRPYoelxzAAAAA==",
    Pbi3DGeometry:
      "kwUAAB+LCAAAAAAABACdlFFrgzAQx7/LPWch0TqjfSpbx2B7KNtgD2UPloY2YM1wYVBKv/tSdWvjzjQtQTG//O/+0Tsz38Fsod62nxJyeNIL9apLtQQCM60q8wX5fNc+2mU2tgP25EhuOGPj5mYv2H/8hk3qutja2FFMo5QJktGIRzFhlJEj4oLzFkVUiCR2VAjCA5MRD8jVqpIsFT2VgwZVSC7EsQnkGb0VyQUOfoSn+0ebDeLU875+5DdxK4vTC4p7lUlTA5y6HYM00RDym7jlx+lQs55FgSb94gw20Ln/5EqTwOYL0/rc+jvzNQjeCmEV9e3sRGtPt3tVbKSRNeSHbwjPslqZdTd50aYwSlfd9F0t/5YepVqtTTeZlvL7VHinS20TwkN6GPYQ/QH/19CqkwUAAA==",
    A: "0",
    "Assembly Code": "B10",
    "Assembly Description": "Superstructure",
    b: "127",
    "Base Connection": "None",
    "Base Level": "Level 1",
    "Base Offset": "0",
    "Column Location Mark": "A-7",
    "Column Style": "Vertical",
    Cost: "0",
    d: "127",
    "Design Option": "-1",
    "Enable Analytical Model": "Yes",
    Family: "L127X127X9.5",
    "Family and Type": "L127X127X9.5",
    "Host Id": "-1",
    Image: "<None>",
    k: "22",
    Length: "6000",
    "Moves With Grids": "Yes",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Section Shape": "Not Defined",
    "Structural Material": "Metal - Steel - 345 MPa",
    t: "10",
    "Top Connection": "None",
    "Top Level": "Roof Line",
    "Top Offset": "0",
    Type: "L127X127X9.5",
    "Type Id": "L127X127X9.5",
    "Type Image": "<None>",
    Volume: "0.01",
    W: "0.181",
    x: "35",
    y: "35",
  },
  {
    ID: "709245",
    Name: "Curtain Wall: SH_Curtain wall",
    Category: "Walls",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABACFjksLwjAQhP/LnuOSpq+0nkQFQQ9FBA+lhxZDG4iJ1CiU0v9uoA/x5G1nv2Fm8h6ySl66h4AUjqaSmVFdbTQQyIzU9glp3o+nM/gMuRfE65XH0A/jCAbyhQHDKKHeH5ggjSP+w5bUmRVz+aZty84tcI+dLO/CihZSipTASejaNpM4G1ta6UaP8ipvCzoIWTeuhCMPuU9gr8R78ibIAxYS2BplXKx+KTUUHz62HjEQAQAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "8",
    "Assembly Code": "B2020200",
    "Assembly Description": "Curtain Walls",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 2",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Border 1 Type": "64 x 128 rectangular",
    "Border 2 Type": "64 x 128 rectangular",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Curtain Panel": "Glazed",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "SH_Curtain wall",
    "Family and Type": "SH_Curtain wall",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "64 x 128 rectangular",
    "Join Condition": "Vertical Grid Continuous",
    Justification: "Beginning",
    Layout: "Fixed Distance",
    Length: "3010",
    Number: "1",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "3000",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Roof Line",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "SH_Curtain wall",
    "Type Id": "SH_Curtain wall",
    "Type Image": "<None>",
    "Unconnected Height": "2700",
  },
  {
    ID: "709246",
    Name: "Entrance door: Entrance door",
    Category: "Doors",
    Level: "Level 1",
    Pbi2DGeometry:
      "1QAAAB+LCAAAAAAABAA1jcsKwjAURP/lrmPobVLzcCVaEHRRRHBRuqga2kBMpEahFP/diLobhnNm6gmqkz2MNwMatuFk9+YcW985AwSqYH28g66nb0wIK+icqWIxw4wKFDm8mj+3HIZ2THAq1ra9mmgG0BnNCOyM72IPmlORc05gH2IbbfCgGUUlEZEpgVIJjrycYUHgaC8fIaMsl0hgY2zXp3uZBgSB0pnnb0BRyfMkrIIL6c4/nHs1b/Pd6fzVAAAA",
    Pbi3DGeometry:
      "QBQAAB+LCAAAAAAABACtWMFq4zAQ/RedvUaObMtJTyW7UOgeSndhD6WHhJrWkMYlNQuh9N8rJ6kTy/OkkRNKm/q9Gb0ZzWgU/PAh7pbV3+1bKWbitl5Wf+pV9SQicVdX6+ZdzB4+9v8aWl6ZH/EZHZEfiZRXuz/mV3w+frtdbzaLrfFVKp5orSJjEutET6JpXKSTLDrFc6WKDi9iKRM9Ckfr93Bkz9VNijjLpzmP2ClAwieNtsjGOwFIsJMIkHbuNhUSJNxJXKCg7jIExeosXFByTG1OGrZGobLEEEks00y10WrzccRlPE3S1j6VWTa0bxdSue45dNJ9wuFBSxw3kAxJmpzyC6TAXt8Tp4ugMyYUUMb7hY4OOp9m1EJ9nIhoFB6gyw2Ut9doh4KUrT2FDlCCSSCJAT5oPGTPa4sBjtb34Cd9ihw8J8eDQ4EhMWhIq2qEg30Ix7dqWNUumQPt4FAIbTDmuPDYexqYU2ffpRBwv5zRGnA+jyegBr23DAf+NeOb6t7boftyYGeXKk06KJnRDjuCmFjQASkgHIb6TdAeKCQC3ykTw94ZKWEfuv4+AUQQh84S6OOwOOFEgDQzVF67EDha34lTgw81xSgcClCEVX7owOwL2KkB0lZnI3veCfGfHK8uqiaKn3sQvA6hGzeu7WBEFMGsjdc+WMCep2fk4J3ZfMJdUo44TJB5k3AupXBxVI6z70lnXR8j8bNavJZNuREz00yR+F2un5uXw8N93Syaql4fHv9VTx11U1bPL83h4deq/H9qOK9X9aZ9FSgLOW/f+H0BvlVmqkAUAAA=",
    "Analytic Construction": "<None>",
    Area: "4",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Entrance door",
    "Family and Type": "Entrance door",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2660",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Mark: "201B",
    "OmniClass Number": "23.30.10.00",
    "OmniClass Title": "Doors",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rough Height": "0",
    "Rough Width": "0",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Entrance door",
    "Type Id": "Entrance door",
    "Type Image": "<None>",
    "Type Mark": "60",
    "Visual Light Transmittance": "0",
    Volume: "0.1",
    Width: "1440",
  },
  {
    ID: "709249",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABFjV0LgjAYhf/Le72Gm7oPu4oKgroQCboQL1YNHawtbAUi/vcWIt2dc3geTj1CeTXn4amhgKO/mkrfgnKt1YCg9MaFFxT1OMeIZBTnuRDrFUkwJ5zC1Czcpu/VEOE47Ix66KB7KBKcIDhp14buV0hKKILKBxWMd1AQnPOES5ZSxmUmJGMILuY+wykVBMFBm7YLf3lv9WexBc6ZjMrWWx/P3NvaqfkCmMkAH9MAAAA=",
    Pbi3DGeometry:
      "NwQAAB+LCAAAAAAABACVVFELwiAQ/i/3bKItl62nqCCoh6igh+hhkTRhzVgSRPTfs7VqVNsuRfHuu7tPvdPVBaYbvTgfFAQwNhs9N7HeAoGp0Yk9QrC6PJYOZl3X4UremgZnrJtNbsB1/XTrpWl4dr6tJhVCSuJMqJS8Sbikwu/4pAgI4fFKoM2YxAFPjlIg4/Ak5Z73HemH/tO+LE6dvix+9QkQgVAbQqXh77uru9NKPaoAcCXzBzU6DbVAdbEiqFGJRuWnyOBe4ECHe2VVCgGjjMBEJTsb5cLM2NBqk+TiUm9f0EjpXWRzYRirU9Gwb2KT3n+ArLmHfgNvETHyNwQAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1349",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "709251",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry:
      "1gAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7yG/01zs1OUENRBJOggHrSGDtYWtgIRv3sL6/be4/feqyYoWn0eHwoyOLpWl+rqG9sZBQQKp61/QlZNiwxIzOhaRrhZYURTTBnM9Z/bDkMzBjgEe93clVcDZBGNCJyU7Xz/NciRESidb7x2FjJOUQpE5DJFIdMY43yFCYGLvi0FzgQSOCjd9eFeUJEITiA36v1bkFTELDR2zrjwZ1/GzPUHW6ie/tYAAAA=",
    Pbi3DGeometry:
      "NwQAAB+LCAAAAAAABACtVN0KwiAUfpdzbaIry62rqCCoi6igi+hiY1LCmrEkiOjds7VqW21rkaJ4vs/z4/Ho6gxTTy5OewEOjJUn5yqQPiCYKhnqAzir831paNI1HS7ohTQoId14MgMu64daL4rck9FtWZgxzpHZgjmnFrIxb1kMpXHGmjSFt21Cf8KL7OfwrB3KcYcQ/h7QJyK29A2RjekTkfdRdIpCS/WDqkzIlwmsdlA/s7k7rVszhQ6q811O/Ktca9VGOVHu2rzAgXR3QosIHIIJgokIN3qbCDOlXS1VmIhL6T+pkZCbrU6EYSCO6Y19Fajo9gPEzTz0K17YJ2s3BAAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "709253",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7yG25xudooKgjqIBB3Ew6qhg7WFrUDE797Eur33+L336hHKqzkPTw0FHP3VVPoWlGutBgSlNy68oKjHRUaEMUzSjKxXJME5ySlMzZ/b9L0aIhyDnVEPHXQPRYITBCft2tDNhjBCEVQ+qGC8g2JeI1zSjDMuZC4RXMx9QRkVBMFBm7aLxwILLhiCvdWfX1dikVKOYOutj0/ube3UfAEoiOpD0AAAAA==",
    Pbi3DGeometry:
      "NwQAAB+LCAAAAAAABACtVN0KwiAUfpdzbaJba7auooKgLqKCLqKLjaSENWNJMEbvnq1Va7VskaJ4vs/z4/HoMoVJIObJnoMHIxmImQzFGhBMpIjUAbxlel1qmnR0hxN6IA1KSCeb9IDT6qbWjWM/0bq2jS3XtZHeghmjFqIMu4QwVCQcx6ZFgjZb9Eei0keZeDbVxqxpOa9BvcEzQ2b8OaI3eMl+5QmqDNUNyJyJr3NndFE3p+XrrF8yVS6M6f6I/7FYa1TGR9zkWb/AvvB3XPEYPIIJgjGPNmqbC1OpfCVklIsLsb5TQy42W5ULg5Afixt7MpTx5QfImn7oZ0d1ylc3BAAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "709256",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1",
    Pbi2DGeometry:
      "1gAAAB+LCAAAAAAABAA1jcsKwjAURP/lrmPobRLycCUqCLooIrgoXbQa2kBMpEahiP9uRN0Nwzkz9ROqzh2mqwUD29i5vT2lNvTeAoEqupBuYOrnN2aEF5RxoeczLKhEWcKr+XOLcWynDOdi5dqLTXYEU9CCwM6GPg1gOOWl0AT2MbXJxQCGUdQKEZmWqLTkyNczFASO7vwRsq0YI7Cxrh/yvaJCC0Vg7e3jt6CplixXy+hj/gt371/NGwXGJXDWAAAA",
    Pbi3DGeometry:
      "EwQAAB+LCAAAAAAABACdU1ELwiAQ/i/3bOKybW49RQVBPUQFPUQPG0kJa8aSIKL/npWVRJtbiOJ9d353fN6tLjBNxeJ84BDDWKZiLjOxAQRTKXJ1hHh1eV61m3T1giv6IC2PkO7j0Buu69ezXlEkZ/2208a+zxjSIZgFFEU4CilD37DHsB9EAaIMe5T+CZdwG9gKDsMofJPY4dWOH/w2/p3Akfd38SUkTWtxa+AWrHbORkra/9ewOUr5a0hcJb2rTHf3VWat3R7lH2Wo9XQNRLLnihcQE0wQTHi+VTtjzKRKlJC5MZdi83aNuNjulDGGGT/ZgX2ZyeI+3YSR/n2Ib3A2YDITBAAA",
    "Analytic Construction": "<None>",
    Area: "4",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2620",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.09",
    Width: "1349",
  },
  {
    ID: "709258",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABFjV0LgjAYhf/Le73G5nIfdhUVBHUhEnQhXmgNHawtbAUi/vcWIt2dc3geTjlC3pjL8NSQwck3ptC3ULvWakCQe+PCC7JynGNEmMSEULFZUYIFFQlM1cJt+74eIhyHvakfOugeMoIJgrN2beh+hTKaICh8qIPxDjKKU0GE4izhQq2l4hzB1dxnmCWSIjhq03bhLx+s/iy2xClXUdl56+OZe1s7VV/3MSPL0wAAAA==",
    Pbi3DGeometry:
      "SQQAAB+LCAAAAAAABACVlFELwiAQx7/LPZucjTVbT1FBUA9RQQ/Rw2JSwpqxJIjou2e1alDLy+HY+fPuP73T5Rkmaz0/7RXEMDJrPTOZToHBxOjcHiBenh+fDmPHPXBh75GGQOzcX67DZfV06xZFcnK+geSIImJuCpdSNJmQPGy1W6wKwjAQP0GEKGngqVELHhoBb0ZR8CXUF/DhURvKC2o1POughCL+FSUf/2+id3c9gFIMxPL5R5yeDy/w1C5FnJhzSqKqGu5M9nWyU1YVECNHBmOVb+y2NKbGJlabvDQXOn2hodKbrS2NQaaO1Yk9k5nidifcmzv6V5d2Ln5JBAAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1440",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "709259",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABFjcsKwjAURP/lrmNokjaPuhIVBF2UIrgoXVQNbSAmUqNQSv/dSBV3M8M5TDVCcTbH4a4hh70/m1JfQuNaqwFB4Y0LD8ircY4RYRITxpYLkmBBBIWp/mGrvm+GyMZhY5qbDrqHPMEJgoN2beg+hTBCEZQ+NMF4BznBmUiE4oxyoVKpOEdwMtcZZlQSBDtt2i785a3Vr6+tsExphmDtrY9f7mntVL8Bg36mItEAAAA=",
    Pbi3DGeometry:
      "EwQAAB+LCAAAAAAABACVk1ELgjAQx7/LPS+ZLmnqU1QQ1INU0EP0YDh0YC5sBBF+95ZZCaabDsfut7v/xt3u8IDwxHf3CwMfVuLEtyLjMSAIBc/lFfzD471U2zhQA0r0IyMb46Ca1A/l8RM2LYrormIJtWxCkPKwKLUd5FnehFDUwK5L7G5Mx45rgGvtDlxpjx0VTGlL5Q9v+XfpaHiXft/tTWRMrqNP/MCcaXLZy/XlNngcAw41TXw/7nuSJoealFVfj4a66q45j85MsgJ8bGEEa5YnMq2NjZCR5CKvzT2Pv1tLxpNU1sYiY7em40xkonh1d/WpJn4CZGaIFRMEAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1349",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "709261",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry:
      "1gAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7yGfzfbtFOUENRBJOggHrSGDtYWtgIRv3sL6/be4/feqyYoWn0eHwoyOLpWl+rqG9sZBQQKp61/QlZNiwwIkzRaC75ZYUQFihjm+s9th6EZAxyCvW7uyqsBsohGBE7Kdr7/GmQYEyidb7x2FjJGMZWIyFKBMhUceb7ChMBF35YCiyUSOCjd9eFeUplIRiA36v1bSKnkcWjsnHHhz76MmesPYUhdGdYAAAA=",
    Pbi3DGeometry:
      "JQQAAB+LCAAAAAAABACtU8EKwjAM/Zeca0mdwzpPooKgB1HBg3iYrGhhrjKLMIb/bp1T53SbE1tampf0JU2TVQzTjVxEBwEOjNVGzpUvPSAwVTLQR3BW8e1o1Ng1E87kiTQYYjfZzILz+n6tF4ZuZO5anCKyNjEmlHPWJB3KW02bZHHbtlgGZ5b1A1xEnsNfWBinbUT+HswnRUL0jeIlog943kPBC4po6gdUlYsvU1fNXz+puc+sWyqFDqpyXYr/p0RrVEQpXurV9NtAunuhRQgOUiQwEcFW71JhprSrpQpScSm9h2ok5HanU2Hoi1PWsK98FV77PRmmrS/tgwJ8JQQAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "709725",
    Name: "M_L-Anglel-Column: L127X127X9.5",
    Category: "Structural Columns",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjUELwiAcxb/L/2yiy7lpp6ggqMMYQYexgyvZBNNYFoyx755Rg27vPX6PXzVC0ZjTcNcg4eAbU+pLUK61GhAU3rjwAFmN3xgRlmDBc75aUII5zRlM9cyt+14NEY7D1qibDroHSTBBcNSuDd2nsCSjCEofVDDegaQ4zUgm+DLhmWCCUIbgbK7/8F6btotqgXOWpAh2Vr9+73naeOujyz2tneo3IZVabtIAAAA=",
    Pbi3DGeometry:
      "ZQYAAB+LCAAAAAAABACdlV9LwzAUxb/LfY4h/ZMt7Z7EKYI+DBV8GD50LGyBrpEahDH23Y1bp13JzZIRWppfbs85NLftfAezhXrbfkoo4Ukv1Kuu1RIIzLRqzBeU893x0i6ziR2wJ//kJmFscjjZA/Yfp9tu27ba2nvzlArBM2JLKM94Qgoq8pSTPKPpmIkjZ1nh5P16q8PzxF/f55hvjxcpG7n0hxzTceYJqI/19fKkoCPh52f6GI/wxZ7ngTvyYNyb/5Iv1idDftLHeGj+GF9ff7ryYNyXP6D/sf48445+iM4Z6evt/4i+9eaPeF+G+36tb5B+yP4O9C/lDKp369vv9VRVG2lkCyWjjMCzbFZm3U1etKmM0k03fVfLv6VHqVZr003ua/ndL7zTtbaC8DD+Hfa38ANKo7QKZQYAAA==",
    A: "0",
    "Assembly Code": "B10",
    "Assembly Description": "Superstructure",
    b: "127",
    "Base Connection": "None",
    "Base Level": "Level 2",
    "Base Offset": "0",
    "Column Location Mark": "C-7",
    "Column Style": "Vertical",
    Cost: "0",
    d: "127",
    "Design Option": "-1",
    "Enable Analytical Model": "Yes",
    Family: "L127X127X9.5",
    "Family and Type": "L127X127X9.5",
    "Host Id": "-1",
    Image: "<None>",
    k: "22",
    Length: "3000",
    "Moves With Grids": "Yes",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Section Shape": "Not Defined",
    "Structural Material": "Metal - Steel - 345 MPa",
    t: "10",
    "Top Connection": "None",
    "Top Level": "Roof Line",
    "Top Offset": "0",
    Type: "L127X127X9.5",
    "Type Id": "L127X127X9.5",
    "Type Image": "<None>",
    Volume: "0.01",
    W: "0.181",
    x: "35",
    y: "35",
  },
  {
    ID: "724430",
    Name: "Basic Roof: Warm Roof - Timber",
    Category: "Roofs",
    "Aalto Vase Material": "0.1",
    "Architrave Offset": "71",
    "Base is Attached": "Ceiling",
    "Base Offset": "-500",
    "Coarse Poche Material": "0",
    "Coarse Scale Fill Color": "-1",
    CosAng: "0",
    "Cut-off": "None",
    "Cutoff Level": "0",
    "Default Elevation": "338",
    Description: "-1",
    "Facucent Drilling": "Warm Roof - Timber",
    Family: "Warm Roof - Timber",
    Fascia: "0",
    "Heat Load Values": "0.0000 /(·)",
    Illuminance: "<None>",
    "Maximum Power Point Voltage (STC)": "2538",
    Phase: "Working Drawings",
    "Phase Created": "None",
    Radius: "Plumb Cut",
    "Referencing Sheet": "No",
    Rim: "Yes",
    "Rough Width": "1",
    "Slab Thickness": "0.00°",
    "Text Type": "0.00 /",
    "Thermal Mass": "0.0000 (·)/",
    "Thermal Resistance (R)": "338",
    "Tumble Dryer": "Warm Roof - Timber",
    "Type Comments": "Warm Roof - Timber",
    "Type Id": "<None>",
    Voltage: "23.93",
  },
  {
    ID: "725045",
    Name: "Precast Stair: Precast Stair",
    Category: "Stairs",
    "Actual Lighting Load per area": "3",
    "Actual Power Load per area": "167",
    "Actual Riser Height": "300",
    "Base is Attached": "Ceiling",
    "Base Material": "-200",
    "Connection cable length": "Notch",
    CosAng: "0",
    Cut: "Single Zigzag",
    Description: "-1",
    "Designed By": "3",
    "Desired Number of Risers": "500",
    "Facucent Drilling": "Precast Stair",
    Family: "Precast Stair",
    "Full Step Arrow": "Interior",
    "Horizontal Align": "10",
    Illuminance: "<None>",
    "Landing Height Adjustment": "220mm Thickness",
    "Left Attachment": "0",
    "Left Lateral Offset": "None",
    "Left Support": "<None>",
    "Maximum Ridge Height": "181",
    "MCB Rating": "No",
    "Middle Support": "0",
    "Middle Support Number": "<None>",
    "Minimum Embedment": "1000",
    "Minimum Run Width": "280",
    "Non-Plan View Symbols (Default)": "100",
    "Notch Extension": "100",
    Phase: "Working Drawings",
    "Phase Created": "None",
    "Read Convention": "Rebar Cover 1",
    "Right Attachment": "0",
    "Right Lateral Offset": "None",
    "Right Support": "<None>",
    Roughness: "190mm Depth",
    "Top is Attached": "Level 2",
    "Top Material": "0",
    "Track/Bswy Length": "1",
    "Tumble Dryer": "Precast Stair",
    "Type Comments": "Precast Stair",
    "Type Id": "<None>",
    "Vertical Align": "10",
  },
  {
    ID: "725159",
    Name: "Linear Dimension Style: Feet & Inches",
    Category: "Dimensions",
    "Alignment Method": "None",
    "Base Power Load on": "0",
    "Body width": "No",
    "Center Segment": "Solid",
    "Centerline Pattern": "None",
    "Centerline Symbol": "Default",
    "Cold Water Radius": "0",
    Cost: "2",
    Description: "-1",
    "Digital Plate": "2.3813",
    "Dimension Line Extension": "6.35",
    "Dimension Line Snap Distance": "Continuous",
    "Equality Formula": "EQ",
    "Equality Text": "Tick and Line",
    "Facucent Drilling": "Feet & Inches",
    Family: "Feet & Inches",
    "Fixed Door": "2.3813",
    "Installation Type": 'Diagonal 3/64"',
    "Interior Tick Mark": "Dynamic",
    "Interior Type": "No",
    L: "<None>",
    Layout: "Yes",
    "Leader Line": "None",
    "Leader Tick Mark": "Arc",
    "Line Style": "1",
    Rangehood: "Up, then Left",
    "Show in": "Beyond Witness Lines",
    "Show Leader When Text Moves": "No",
    "Supply Voltage": "No",
    "Target Elevation": "Opaque",
    "Text Background": "Arial",
    "Text Font": "1.5875",
    "Text Offset": "2.3813",
    Thickness: 'Diagonal 3/64"',
    "Tick Mark": "5",
    "Total Input Wattage": "900",
    "Tumble Dryer": "Feet & Inches",
    "Type Comments": "Feet & Inches",
    "Underlay Orientation": "No",
    "V/G Overrides Model": "900",
    "Width (pixels)": "1",
    "Window Cill Interior": "Gap to Element",
    "Witness Line Control": "2.3813",
    "Witness Line Extension": "1.5875",
    "Witness Line Gap to Element": "2.3813",
    "Witness Line Length": "None",
  },
  {
    ID: "735739",
    Name: "Seating - Artemis - Lounge chair: Seating - Artemis - Lounge chair",
    Category: "Furniture",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry:
      "0gAAAB+LCAAAAAAABAA1zV8LgjAUBfDvcp/XmJu6Pz1FBUE9iAQ9iA9aQwdrC1uBiN+9SfV2z+F3uNUERWvO40ODgqNvTamvoXGd1YCg8MaFJ6hq+p6RUI4Zk3K9ogKnCWcw13+3GYZmjDgWO9PcddADKIIJgpN2XehBMUwopwhKH5pgvAOV4IwTLnNGcy5TITMEF3NbLMUJEdEetOn6sGSWZwLB3ur3b7xKsCBpnGy99fGXe1k71x+66PYH0gAAAA==",
    Pbi3DGeometry:
      "MwgAAB+LCAAAAAAABADtVMsKwjAQ/Jc9pyHpy7aeRAUPHkQED+KhYtBAbaRGQaT/bqn1VYnb3ktIyM7uTrJ5zOoGs41cXI8CovScJARmSqb6BNHq9phCBKxfNMjJG7E4Y/1yKDrk62faIMvia5Fr+5T5bkgsO6Shyz1icRow1yN2QIOe8wf3aRA6/I2jRMaEugNbucIZ9Xzu/PDXYWQ7Bha8rLrjSVQv6wc3EpkSWh8cgqMLNIxHK2t5kU15TPEY3u79YCyNDqf4byMZH4QWGUSMMgJTke70vjLmSsdaqrQyl3L7ck2E3O11ZYwTcfkMHKpEZQ8dKD97JwydMHTC0AnDlzCs70BiFMMzCAAA",
    Area: "1",
    Cost: "0",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "Seating - Artemis - Lounge chair",
    "Family and Type": "Seating - Artemis - Lounge chair",
    Host: "Level : Level 1 Living Rm.",
    "Host Id": "-1",
    Image: "<None>",
    "Material Base": "Chair wood",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "OmniClass Number": "23.40.20.00",
    "OmniClass Title": "General Furniture and Specialties",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Seating - Artemis - Lounge chair",
    "Type Id": "Seating - Artemis - Lounge chair",
    "Type Image": "<None>",
    Volume: "0.02",
  },
  {
    ID: "735853",
    Name: "Single Window: Standard",
    Category: "Windows",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1zssKwjAQBdB/mXUMSfrIw5WoIOiiFMFF6aLV0AZiIjUKpfTfTVF3l+Fc7lQTFK05jw8NCo6+NaW+hsZ1VgOCwhsXnqCq6RsjYQyLhPP1agmEU5jrv9sMQzNGHA8709x10AMoggmCk3Zd6EGlWDKaICh9aILxDhTFGSdc5gnLuUyFzBBczG2xBGd5Gu1Bm66PywILSSmCvdXvX3lFl1+i2Xrr45Z7WTvXH0IxoVHSAAAA",
    Pbi3DGeometry:
      "oyYAAB+LCAAAAAAABACtWt9r2zAQ/l/87BrZkiw7fRrdYLA9lG2wh9KHlIbWkMUjC4NS+r/PSdwkivTp7pxRVpb7pPvul+4u0LvX7Pah+/Hye5HNsi/9Q/e9X3aPWZ7d9t1q8yeb3b3u/zvA6nr4yd7yo+SqVOp692v4l73dv1/7sF7PX4a7VVU4pav8qrJFVTuXX5WF002TR4GmKfNKbz/bSwHIsQMON1ShTW2Oqg43OIDPcQ7EONLk0A+oSm4VHRJ2EEXkzOiep1ZePpCDDjsnH2lz6RLlkDPLh5PB0VzjdDy1xpnSB4w1W8CqWstuYA7lWg9olLFxjunkpbFnHG2aPAS00+kbkANaBTkCVRDw/TgWw5lVpwC64XNwbrxz7B08qUQ/7BEOOTnk2NdV2GTGKgkBeANzIM8hRwgczE37EStqZC7MBwFEalf8OAXkZM7lT424wakrJsCxivlqJdVOAJEGIG8ZE55aGpD0XTwmAAd8URQAOTiDRU5OdR84vOTjbkqHSwMcq6I7nCuU1b7cGq3zunBtqUP5oMiainU+rt8WyqkGnj9pFgTxqAgZFJFDApmlY0jR+YihyfPSyCH90LEQgDfYLvjVFZGfuebLj/rJ83H9QdEF1R7sonHioFhIQ9PLLtvSIMmEQcR5aeSQ/tQWD3enAGC6gOqdcJldjMT7w+9MWuzkFyD++0u68H+yk26DAmsFHGQVM0uDOSwizy0pp/vC5CnI1M9rkBcPQbZ+XiOPzMakHNlD6+flEcWftrNRZb07b4xpB3nT7PddXz7YXxtlPIKJAKI4yqWlVSvTTJfToTucr03pBnndVm0oH/Qbo2vPsYkAojjKYXZGwBZl3epIEuQA5EgkmvkGR++kcnaPggkaAVO0rjKRPMgByAFzHQbcB4L3MFEuKg5ms/ITJJWzCyOMtg8E72GiXFAZQbDJJiaTI/3y5F84jwj9eL4Ia0v6LZdqYIIxkhw7EUNlY4qwB+m/qDNPdAF/IUeTUCZnL01E/wiesbhPEARo/ooblGDk8IagYBtJbi8xU2XrDmEQJJg+3qd6gLKPtymZnCjH4DwcyNS6wZhbFAW1hgQDB1Gzg0Hol1uaWESF27F8JyMo6HFNfs3iuuDsNvFhuH35iWsjEPrMBBDFSdnbuJ69PNLxbEJNWjtNioxPquHaQgRfGLG0mBFIKuf8Ikkzo9TKa0pQnixqMr9EZnz193n2sZv/WmwW62ymCpVnXxerp83z+OFbv5lvun41fvzZPR6gz4vu6Xkzfvi0XPw9PXjTL/v19q/NVKNutn9U9g9oMdxUoyYAAA==",
    "Analytic Construction": "<None>",
    Area: "6",
    "Bottom Hung Casement": "No",
    Casement: "SH_Aluminum, Anodized Black",
    "Casement Depth": "60",
    "Casement Pivot": "No",
    "Casement Swing in Plan": "No",
    "Casement Width": "60",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    Description: "Single Window Unit - Triple Glazed",
    "Design Option": "-1",
    Family: "Standard",
    "Family and Type": "Standard",
    Frame: "SH_Aluminum, Anodized Black",
    "Frame Depth": "60",
    "Frame Depth over": "80",
    "Frame Depth under": "80",
    "Frame Width": "60",
    Glass: "Glass, Clear Glazing",
    "Head Height": "2700",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2700",
    "Host Id": "Wall - Timber Clad",
    Image: "<None>",
    "Install Depth (from outside)": "0",
    Mark: "94",
    Operation: "SinglePanel",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rough Height": "2700",
    "Rough Width": "1500",
    "Sill Height": "0",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Hung Casement": "Yes",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Type Mark": "46",
    "Visual Light Transmittance": "0",
    Volume: "0.16",
    "Wall Closure": "By host",
    Width: "1500",
    "Window Cill Exterior": "SH_Aluminum, Anodized Black",
    "Window Cill Interior": "Wood_Walnut black",
  },
  {
    ID: "736152",
    Name: "Single Window: Standard",
    Category: "Windows",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry:
      "0gAAAB+LCAAAAAAABAA1zl8LgjAUBfDvcp/XcJu6Pz1FBUE9iAQ9iA9aQwdrC1uBiN+9SfV2OfwO51YTFK05jw8NCo6+NaW+hsZ1VgOCwhsXnqCq6XtGQikWjPP1inLMqWAw13+3GYZmjDgGO9PcddADqAQnCE7adaEHlWJJCUNQ+tAE4x0ogjOecJkzmnOZCpkhuJjbYhOc5Wm0B226Pi4LLCQhCPZWv3/lFVl+iWbrrY9b7mXtXH8AB3ZpjdIAAAA=",
    Pbi3DGeometry:
      "IyYAAB+LCAAAAAAABACtWk1r20AQ/S86K2Ilrb6cU0kLhfYQ2kIPIYeEmETgWsU1hRDy3yvbsq3V7psPuYQE+83qvdmZ2ZkV5O4tun1sf7z+XkaL6Ev32H7vVu1TFEe3Xbve/okWd2+Hj73ZXPc/0Xt8Rq5SY673f/rf6P3++NiHzebhtX82y5LK5Fl8lZskrZv4Kk2qvK7jEF7XaZzlSVZWxUU44t/jx/VZsftQnYmOD4gMjoRnCGnQ4mgXkEnvFBcQaQBVyrLITnOqrRkowMZbkgjSVa4sRcqyohEkbnDVVnkwobayqYPbwu7wwpS5Zj3kN1UzxmtjiyD/XN3UFi5/Q+p6eF7l5HrEj/xB/FMehDv+jxLvOuQY0BOOhOiJo8Z+c+Oqc6Id0tCLQ419JQVayaE0Agb4BNZAO4cavuHkLrmPUCUjb2E6aEOgaJWHUaHM5lt7vsj1ooKSGQQuiY6qqsZpQ+DUa7vEjNNFGhQNFg4CIABPEGNAEoLZoVfmWg0aT9pxNqeXkQaBS8EbWZWYIndxW/YZL5OqSXMf74kKm4nWh/mbpGmyFK4ftQZGeCBCDgVwKKDydIgoWj7VZZZr4wbo4a48A3xA6r9TV1PY35aLn9np9Yjeq7ZplU8GOZL1ioRez9xfpW76yWXcYdYro4boiWs5vBd5BuEGUJXTG5YWIX3kgDO6CudfZWTnjfb9v6SE7nfyzqCQYOtWWA7CoRA4YCTO94HZ007IL2uHFw87Mb+sbXv7ZXDkD88vyyOKP+9nbdJyvz4vyx1e14frrIv3/pfWWEdgpgFJnHFtaZXG1vNxPnSn9UUf8jIpm6zx4J7d2rx0tjUHB/RnGOblYOh7lmlM4Ydfb4AaVIqFp2/YnBYXdyeUmxN/3eRVIAl6A5IAaQ5E2zVMj8FcXF4Z8h7lZkeLK6piGmvX4B2Gmbi8Lvxgs71LhSN+bfIvH0MMP+iZ+tpSvsSy3UsxPchpE3BUNZ04fxD/RW155hbwGzcagDpcfFdi+8fkGKv7BCMARq+6P8nHjWz+ya8g1I0l5KfqhkN7A+nnT/WZ7qO0wyuUBmaKcLoejmH2iiGYVpwEc/fwphhSloaCplf7SV08VZdh9SWMEeDHM/s2JfS/KjIbirSLjzY2GLwNi3DEPyr2IshygAPtrSBYSHJWEjhOcUj9YIKuixUNC2LIpVpeG7QySKq2kuQlKZDl8kpnxKG+j6OP7cOv5Xa5iRb9eY2jr8v18/Zl+PKt2z5s2249fP3ZPp1Mn5ft88t2+PJptfw7XnjTrbrN7r+9TG1udv/U9Q8qSRlcIyYAAA==",
    "Analytic Construction": "<None>",
    Area: "6",
    "Bottom Hung Casement": "No",
    Casement: "SH_Aluminum, Anodized Black",
    "Casement Depth": "60",
    "Casement Pivot": "No",
    "Casement Swing in Plan": "No",
    "Casement Width": "60",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    Description: "Single Window Unit - Triple Glazed",
    "Design Option": "-1",
    Family: "Standard",
    "Family and Type": "Standard",
    Frame: "SH_Aluminum, Anodized Black",
    "Frame Depth": "60",
    "Frame Depth over": "80",
    "Frame Depth under": "80",
    "Frame Width": "60",
    Glass: "<By Category>",
    "Head Height": "2700",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2700",
    "Host Id": "Wall - Timber Clad",
    Image: "<None>",
    "Install Depth (from outside)": "0",
    Mark: "95",
    Operation: "SinglePanel",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rough Height": "2700",
    "Rough Width": "1500",
    "Sill Height": "0",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Hung Casement": "Yes",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Type Mark": "46",
    "Visual Light Transmittance": "0",
    Volume: "0.16",
    "Wall Closure": "By host",
    Width: "1500",
    "Window Cill Exterior": "SH_Aluminum, Anodized Black",
    "Window Cill Interior": "Wood_Walnut black",
  },
  {
    ID: "736223",
    Name: "Single Window: Standard",
    Category: "Windows",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry:
      "0gAAAB+LCAAAAAAABAA1zlELgjAUBeD/cp/XcJtubj1FBUE9iAQ9iA9aQwdrC1uBiP+9SfV2OXyHc6sJitacx4cGBUffmlJfQ+M6qwFB4Y0LT1DV9D0joRTnTIj1ilHMU8lhrv9uMwzNGHEMdqa566AHUAlOEJy060IPKsWSEoag9KEJxjtQBGciEZIzyoVMc5khuJjbYhOc8TTagzZdH5dznEtCEOytfv/KK7L8Es3WWx+33Mvauf4APxcMa9IAAAA=",
    Pbi3DGeometry:
      "TyYAAB+LCAAAAAAABACtWk1r3DAQ/S8+O0ayJVtOTiUtFNpDaAs9hBwSsiSGbVy2SyGE/Pd6s453ZelpZrwlJOy+Gc+bL83IkOuX7Oqu+/H8e5WdZ1/6u+57v+7uszy76run7Z/s/Ppl/3EQq4vhJ3vND8iZVuri7c/wm73evD/2YbO5fR6eLcuiUVWZn1W20FoNH3TRVM7lUYFzOi+roqwbe6oAcrwJpidUoV17sDQ9QOM+wQyP2E/ywgiQIalDdCbYuRNQ83I6L6e8ZRAFmW5GGdK+0j1JU/M6hlO40VfTVPGKmsZoX2Cs2QmsqivZE5hDNa0ncMrYOMdycm3sjKNNk4eCqqnST0AO6BXkCExBgR/H1Aszp45woO8T0Prv9vexHXrQT3hoX8qL7O+7KZgoY2sEONKH9kG8yH6AT34m/Y+1MHAUFSCNR9pUfA7Z1FSN5UeKeIJuIx7OcYl5NPmdncYjR1w+FMSHKolLxireAnEKdH4IHBJwloaUmhgxcCvJ95h8iiVxjkuxG1lTKFv5cOWsy+uiaXUV4oMda0qWftS8KQY1g9SP5gJBO9pB7kRwZF/k5phNpB/QEvrCrCHzKKwQhw+wA/DbKsCDwHz8YJ/QR/aDdgvafLbGEXHQKIQ+dXdlezovMeFPWl2aN2A+dSNH16IA5/kPGj0dLbsLiWMHnJE2OeM9hnvuiAj+S2FSk0/gKpuA6lxWQ/D2QuR0JXF6DCxed0z7vHl48r5j2+fN7SBeAkf+0PZ5dUT5p/10Stdv+qVrdrhz++usjw/+10YZj2ChAFEccGlr1cq45TiduknfuMFAXdRt2Yb4YN+YqvYCWyhAFAccVmcU2EJp7SJFkAsgR6LQzDM4RifF2TMKFmgicNq0kTrIBZAD1jpMuC8IzsNCXNAc7GHlF0iKCxpjnm1fEJyHhbigM4Jkk0NMhiP70uKfvI8I+2h4intL+kJLDTDBGkmunYijsjVF+IPsnzSZF4aA377RJpTh7EsTOT9mx1g8JwgCtH/FA0qwcnhLUHAbSd5eYq7KrjuEQ5Bg+XpfGgGqPr5NyXCiHQN9uJCp6wZjb1EU1DUkWDiImp0Mwr7c08RFVHg7lt/JCAp6XZOvWdwQGluaWLp9/Ci0URDGzBQgiqO2t3E7ezwy8WzCTNo6TYqcT5rh+kIkX5ixNMxIJFVzfpOkmVFp5T0laE8WNVlfojK++Zs8+9jd/lptV5vsXBUqz76unh62j+OXb/32dtv1T+PXn939JPq86h4et+OXT+vV32PFy37db3b/Gaacutz9A9g/2Xt30U8mAAA=",
    "Analytic Construction": "<None>",
    Area: "6",
    "Bottom Hung Casement": "No",
    Casement: "SH_Aluminum, Anodized Black",
    "Casement Depth": "60",
    "Casement Pivot": "No",
    "Casement Swing in Plan": "No",
    "Casement Width": "60",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    Description: "Single Window Unit - Triple Glazed",
    "Design Option": "-1",
    Family: "Standard",
    "Family and Type": "Standard",
    Frame: "SH_Aluminum, Anodized Black",
    "Frame Depth": "60",
    "Frame Depth over": "80",
    "Frame Depth under": "80",
    "Frame Width": "60",
    Glass: "<By Category>",
    "Head Height": "2700",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2700",
    "Host Id": "Wall - Timber Clad",
    Image: "<None>",
    "Install Depth (from outside)": "0",
    Mark: "96",
    Operation: "SinglePanel",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rough Height": "2700",
    "Rough Width": "1500",
    "Sill Height": "0",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Hung Casement": "Yes",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Type Mark": "46",
    "Visual Light Transmittance": "0",
    Volume: "0.16",
    "Wall Closure": "By host",
    Width: "1500",
    "Window Cill Exterior": "SH_Aluminum, Anodized Black",
    "Window Cill Interior": "Wood_Walnut black",
  },
  {
    ID: "736330",
    Name: "Single Window: Standard",
    Category: "Windows",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry:
      "0gAAAB+LCAAAAAAABAA1zssKwjAQBdB/mXUMSdM2D1eigqCLUgQXpYtWQxuIidQolNJ/N0XdDcO5c6eaoGjNeXxoUHD0rSn1NTSusxoQFN648ARVTd8xkiTBgnG+XjGOM04EzPXfbYahGSOOi51p7jroARTBBMFJuy70oFIsE8oQlD40wXgHii5HuMxZknOZCpkhuJjbYgnO8jTagzZdH5sFFpJSBHur37/wii6/RLP11scu97J2rj9lWK+g0gAAAA==",
    Pbi3DGeometry:
      "oyYAAB+LCAAAAAAABACtWttq20AQ/Rc9y2Kl3dXFeSppodA+hLbQh5AHh5hE4FrFNYUQ8u+Vbfmy2j07M3IJDfWc3Tlz25kx5P4tuXtsf7z+Xibz5Ev32H7vVu1TkiZ3Xbve/knm92+H//awuul/kvf0LJnlSt3sf/X/kveH47UPm83itb9bFFmldJHOjMqUzm06y7NK13UaBOo6TwudFWVlrwUgxx443tA2y3NVnFUdb7AAh8MDQhxxcugHVCW3igwJP4gicl50vdTKywdykGFn5SNuLlmiLHJe+bAyOJhrKh1OralM7gLGmh1gVallNzCHqhoHqJWxYY7p5LmxI44mTu4DutLxG5ADWgU5PFUQcPy4KAbXKgdANxwO1o0jx97By0p0wh7ikJNDjn1dBZrMoUoCALyBOZDnkMMHTuZG/QgWNTIX5iMOhGpX/DgF5GTO5U8tfoNVVzyAZRXv1YqqPQ6EGoC8ZUx4alFA1HfxmAAc8EURAORgDRY5OdV94PCSj7spHS4KsKwK7nBVpqx25VpVeVpmVZNrX94rsqZgnQ/rb/oCNyU8f9EsCOJBETIoIIcEIkuPIUXnx8TUeWnkkH7omAfgG2wX3Ooay33XXPlZf/w81O8VnVfto0GPiL1iiZ8nl12upX6SCYOI89LIIf2xLR7uTh7AdAHVe9xlfjES7w/YIy12zhcg5vujXPg/2Ym3QUG3EHCQVcwsDeawCDy3qJzuC5OnIFM/r0FePQTZ+nmN3POXkCN7aP28PKL403bWKi/35wtV7+R1fdh3XXlvf2mUcQgmAojiLJeWVqlMPV1Oh+503ihre3nZFI0v7/Ubo0vHsYkAojjLYXYGoMkarfNAEuQA5IgkmvkGB++kcnaPggk6EVS6LAJ5kAOQA+baD7gLeO9holxUHMxm5SZIKhcUxjjaLuC9h4lyUWWMgk02MZkc6Zcn/8p5ROjH80VYW9JvuVQDE4yR6NgJGCobU4Q9SP9VnXmiC/gLOZqEMjl7aSL7x+gZi/sEQYDmr7hBCUYObwgKtpHo9hIyVbbuEAZBgunjfaoHKPt4m5LJiXIMnIcDOb5uMOYWRUGtIYGBE6ZmB4PUL7U0sogKt2P5TkZQ0OOa/JrFdaGyhQmF25VfuDYAvs9MAFFclL0N6znIAx3PRtTEtdOkyPioGq4tRPCFEYuLGYGkcs4vkjgzSq28pgTlyaIm80tkxlX/kCYf28Wv5Xa5SeYqU2nydbl+3r4MH75128W27dbDx5/t0wn6vGyfX7bDh0+r5d/Lg7fdqtvs/tpM1ep290dl/wBjHe7uoyYAAA==",
    "Analytic Construction": "<None>",
    Area: "6",
    "Bottom Hung Casement": "No",
    Casement: "SH_Aluminum, Anodized Black",
    "Casement Depth": "60",
    "Casement Pivot": "No",
    "Casement Swing in Plan": "No",
    "Casement Width": "60",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    Description: "Single Window Unit - Triple Glazed",
    "Design Option": "-1",
    Family: "Standard",
    "Family and Type": "Standard",
    Frame: "SH_Aluminum, Anodized Black",
    "Frame Depth": "60",
    "Frame Depth over": "80",
    "Frame Depth under": "80",
    "Frame Width": "60",
    Glass: "<By Category>",
    "Head Height": "2700",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2700",
    "Host Id": "Wall - Timber Clad",
    Image: "<None>",
    "Install Depth (from outside)": "0",
    Mark: "97",
    Operation: "SinglePanel",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rough Height": "2700",
    "Rough Width": "1500",
    "Sill Height": "0",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Hung Casement": "Yes",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Type Mark": "46",
    "Visual Light Transmittance": "0",
    Volume: "0.16",
    "Wall Closure": "By host",
    Width: "1500",
    "Window Cill Exterior": "SH_Aluminum, Anodized Black",
    "Window Cill Interior": "Wood_Walnut black",
  },
  {
    ID: "736435",
    Name: "Seating - Artemis - Lounge chair: Seating - Artemis - Lounge chair",
    Category: "Furniture",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry:
      "0gAAAB+LCAAAAAAABAA1zV8LgjAUBfDvcp/XmJu6Pz1FBUE9iAQ9iA9aQwdrC1uBiN+9SfV2z+F3uNUERWvO40ODgqNvTamvoXGd1YCg8MaFJ6hq+p6RUI4Zk3K9YhRTyhKY67/bDEMzRhyLnWnuOugBFMEEwUm7LvSgGCaUUwSlD00w3oFKcMYJlzmjOZepkBmCi7ktluKEiGgP2nR9WDLLM4Fgb/X7N14lWJA0Trbe+vjLvayd6w83uSyg0gAAAA==",
    Pbi3DGeometry:
      "MwgAAB+LCAAAAAAABADtVMkKwjAQ/Zc5p2G62M2TqODBg4jgQTxUDBqojdQoiPjvFq1bJU57LyEh82bmJZPlLS4wWcnZeS8gzo5pymCiZKYPEC8ujynEgN2iwZW9EctG7N6HosN1+Uzr5XlyLnIdn6PvRcxyXR54gcMsm4fodZgT8jBw/+DI/SiM3jhJZEyoOqiVSxx5x7fdH/4qTGzHwEKXVXU8iapl/eBGIlNC44MjcHKBmvFkZQ0vsi6PKZ7Cm70fiqXW4RT/bSCTndAihxg5MhiLbKO3pTFVOtFSZaU5l+uXayTkZqtLY5iK02dgX6Uqf+jA/bO3wtAKQysMrTB8CcPyBj8/QOYzCAAA",
    Area: "1",
    Cost: "0",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "Seating - Artemis - Lounge chair",
    "Family and Type": "Seating - Artemis - Lounge chair",
    Host: "Level : Level 1 Living Rm.",
    "Host Id": "-1",
    Image: "<None>",
    "Material Base": "Chair wood",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "OmniClass Number": "23.40.20.00",
    "OmniClass Title": "General Furniture and Specialties",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Seating - Artemis - Lounge chair",
    "Type Id": "Seating - Artemis - Lounge chair",
    "Type Image": "<None>",
    Volume: "0.02",
  },
  {
    ID: "736511",
    Category: "Section Boxes",
    Description: "-1",
  },
  {
    ID: "736512",
    Name: "From Yard",
    Category: "Views",
    "Callout Tag": "Explicit",
    "Circuit Prefix Separator": "Poche",
    "Created By": "Yes",
    "Crop Region Visible": "Yes",
    "Decimal Degress": "None",
    Department: "Independent",
    Description: "-1",
    "Desired Stair Height": "Medium",
    "Detail Line": "-",
    "Dimming Lamp Color Temperature Shift": "Architectural",
    "Extrusion Start": "0",
    "Facucent Drilling": "3D View",
    Family: "3D Views",
    "Family Type": "No",
    "Far Clip Active": "92545",
    "Lock Proportions": "No",
    "Neutral Rating": "Yes",
    "Nominal Width": "-1",
    "Parent View": "Show Original",
    Perimeter: "Working Drawings",
    "Phase Demolished": "Show All",
    "Projected Area": "Perspective",
    "Schedule Level": "None",
    "Scope Box": "No",
    "Sheet Name": "---",
    Summary: "No",
    Tank: "0",
    "Tumble Dryer": "3D View",
    "Type Comments": "3D View",
    "Vertical Scale": "From Yard",
    "View Scale": "-1",
    "View Template": "-1",
  },
  {
    ID: "744522",
    Name: "Single Window: Standard",
    Category: "Windows",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry:
      "0wAAAB+LCAAAAAAABAA1zcsKwjAQBdB/mXUbkqZpHq5EBUEXpQguShethjYQE6lRKKX/bkTdzcw9w61nKDtzmu4aFBx8Zyp9Ca3rrYYESm9ceICq5+8YSU4REYyt0ixDAnMCS/N363Fsp4jjYWvamw56BIURTuCoXR8GUDmSGaEJVD60wXgHiiDGMZcFzQoucyFFTM/m+sEYsSKP616bfojVAglJSAI7q1+/75QgQXk0G299LHNPa5fmDczc1anTAAAA",
    Pbi3DGeometry:
      "0SUAAB+LCAAAAAAABACtWk1r20AQ/S86O2KlXa0k51TSQqE9hLbQQ8jBISYRpFFxTSGE/Pf6Q7G13nk7M3IJCfHMzryZfTsfgdy8Ztd33Y+X38tsnn3p77rv/VN3n82y6757Xv/J5jev+183anO5+creZkfJRWHM5e7H5jt7u303+7BaLV42tq7M66qqZxdllZe+3vxS5HXTFDNnc1uKxLZpoJjyDhVj/ya3zrvI/0i8O31wc5YCIKTE0I0q49TV6S4ifVoHyVOSvuJ0iMJ3Bh+InlneQg8O2Y0ZqArfkJddubYIFa5yg4J+KL6obKBojKuSFikMoIDhRorBIo7K1jYZrjdNfaJo0+FCCz1GrIDhhoojtQfF3tVIEUY1VhyIKsJXEl5ibIEx5OAw3EExUEu83f27IhXKPKCFHiMOFyrCwiGjguCwopTFiamFRDEWEEOi0D9q1kLeAEIMqNCUGmOhB4ctIwbHZcCEK2lLXE+cUB+JGjx7TEwuTs5CDw6Hl6bDMeFKBqSwl8Adr3LWbsWVK0+lPq/bwp4uW3VuKjve5ExtGtlZ2u/ggY4hkp62qyQcOEx5pqMY7vOMnOmztF8QcNxxp0ZMnx3Pqvf3dXI8lB+TCd/jEfTwsk8IZ84j/xFlbJwwMQSsvAkUUfQIJt4EOo/8wwSIfeSsDNB5+V0ni1UkZVjUsEsXi1oKXSsIgWWuESfoTisQTTyAqjFPfmT0RFJLxYUsLnx+jnKTZnLTpXu6Woo8ozbMn09OPnp2onZHc+mca7fZeGd2S1lZFl6g8HnT7DdeJB/7p6Uj565o3LQnwaUfekbyo+9DOt4Vu6bgnPWBQVrhc9+WbUoeIiD5CGBgu/CtJQiBCgW3gBUAPCSmqQ8hsYgUhDgk5PK2Lh3BCVQo6IW0QPDxtUV1wsgl/AJaaNjw6jSNhSMWkYIQw/uK6oSRS8iFjCBoukcxnU7MLE1Ioi8KZ0vSL/13IR1ZYn4Ip57sDaYPa/oFPU3kOSenoCxg2D3VEdNn4VQULWfCOkc1ykxLrhaj4sUA9LBE55F/2MdhpOJ2xZyfMlrQCqK7C7xo0P5RBnj6TksAGqDlil+VZKMhWqGQHK1cjJ94kCR2LrAlQAuIoQ126mIRGWhvL7Fnai8jsX0BDJQEHurTkkAGI4BdkVEp7BUE0YFihJCWxxEhZLs5Qa49gTw2gJ44BYIQy5ncxHItLrwKLTmMHAIo7pp7SArF/yMaPvvJivTbuJ1lH7vFr+V6ucrmJjez7Ovy+WH9OHz41q8X665/Hj7+7O4Pqs/L7uFxPXz49LT8Oz541T/1q+3/ZpnGXG3/BesfHSNfltElAAA=",
    "Analytic Construction": "<None>",
    Area: "6",
    "Bottom Hung Casement": "No",
    Casement: "SH_Aluminum, Anodized Black",
    "Casement Depth": "60",
    "Casement Pivot": "No",
    "Casement Swing in Plan": "No",
    "Casement Width": "60",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    Description: "Single Window Unit - Triple Glazed",
    "Design Option": "-1",
    Family: "Standard",
    "Family and Type": "Standard",
    Frame: "SH_Aluminum, Anodized Black",
    "Frame Depth": "60",
    "Frame Depth over": "80",
    "Frame Depth under": "80",
    "Frame Width": "60",
    Glass: "<By Category>",
    "Head Height": "2700",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2700",
    "Host Id": "Wall - Timber Clad",
    Image: "<None>",
    "Install Depth (from outside)": "0",
    Mark: "98",
    Operation: "SinglePanel",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rough Height": "2700",
    "Rough Width": "1500",
    "Sill Height": "0",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Hung Casement": "Yes",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Type Mark": "46",
    "Visual Light Transmittance": "0",
    Volume: "0.16",
    "Wall Closure": "By host",
    Width: "1500",
    "Window Cill Exterior": "SH_Aluminum, Anodized Black",
    "Window Cill Interior": "Wood_Walnut black",
  },
  {
    ID: "744523",
    Name: "Single Window: Standard",
    Category: "Windows",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry:
      "0wAAAB+LCAAAAAAABAA1zcsKwjAQBdB/mXUbkqZpHq5EBUEXpQguShethjYQE6lRKKX/bkTdzcw9w61nKDtzmu4aFBx8Zyp9Ca3rrYYESm9ceICq5+8YSU4REYyt0owjngkKS/N363Fsp4jjYWvamw56BIURTuCoXR8GUDmSGaEJVD60wXgHiiDGMZcFzQoucyFFTM/m+sEYsSKP616bfojVAglJSAI7q1+/75QgQXk0G299LHNPa5fmDZShv6/TAAAA",
    Pbi3DGeometry:
      "USUAAB+LCAAAAAAABACtWt9L3EAQ/l/yHEOSTTYbfSq2UGgfpC30QXxQPDRwNeV6FET83xvv4l02O9/sTK6I4n07OzM73/wSvH5Jru66H8+/V8l58qW/67736+4+SZOrvnva/knOr1/2vw7H+cXwlbymR+SsyPOL3Y/hO3m9eb/2YbO5fR7uVmXW1HWTnpk8K1ybnhVZ41yRViYzpQA1ziGU0Izwie6yzkrbNHPlU3gn/a7ltANggYOhGsV7majposBKawzGyeCDy/onyy2UF3pCoze0phGlRODrwjoqyHXVFh5e1dWIk7lhi9pMcZdXNSfP6Kdx5OccH+UDf0xjOD9t7hofb1k/kbxWf4AjPz18QuThYKdoeuB55B0cqCn8nPBiR9zANuTGobvjwZ5QKlN3mUQfKN8Bb+hthO7CA69SaK+gcVRDqlrEvEKW+BvIhADXp3P0hrTiPQsIV1UYf0NrGjUJwjJOfd5XQR+K9L8FBcEU3WmjYHEpRm5oTaPppGpmvK+CAShqGnhhq+xQsQNcV+UctVnTFma+PDVZXpujhjZr27KQydJ6Rw20DwE670ysOSBMaSa9GMN5wpNJWVot7W7YWxe6S4pOx9E+EwNpHz8+xEvEo8lDQs+o5sWB9pAr3kv0KmBWHQTkTsD9sigAcaQeuk/sGif5j+SlcebrU4LyBEoDQ9aHGkRq5TzQNa1BOYr5A8RN3ICqAS9OLHryqFFx6YpLPT4vYxNlWYcF83EBijSjrhuXZ8YhGpKow9FcGmt3r7FVvlu8yrKwggObObffZxE+1U+jE+VV4aplKRF7vq8Z4Ufdh+fU1rzBVWWsJ8/hNrNt2TKwpx3AE+Vje8rbvA6pgAcaVgEfwPD4Kk1lCClFdCCL44PazLWmIfiAB2JiESfQ8jRm8/KI4RJyASe0WT9umn4SYxUxgiz68QoqJIJLmIWMINN0a+IbnJxZmhCmHQpHCquX6IVAlh0bwj/ZZDnICCubBT1E5G9mh5/MYdg61R7TsnAYinYyYZ2jGo0MyVgtEsWLDJBTEvtJq0c9nPFT2Kyi8uqpgtYOVSDgdoH4ot3HU3eJ91AeLFPR5Ug2EYKtCeFgyYqoCcYHt2aRqwG+ACeUztXFy0Qw65ShY/ZKZSTwtkVbgC/AU3zJC5D8RH2TO9L/PU4w7B1MDPB44A+wawYBcsXx8PACUsTjSL8YZ58lhbVGYRC0pERwaEAe5lj+KA7+E8Mo05fhbELcpMnH7vbXarvaJOdDwafJ19XTw/Zx/PCt395uu/5p/Pizuz8cfV51D4/b8cOn9ervVPCyX/ebt/+Nyl1++fYvUP8AkSyrkVElAAA=",
    "Analytic Construction": "<None>",
    Area: "6",
    "Bottom Hung Casement": "No",
    Casement: "SH_Aluminum, Anodized Black",
    "Casement Depth": "60",
    "Casement Pivot": "No",
    "Casement Swing in Plan": "No",
    "Casement Width": "60",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    Description: "Single Window Unit - Triple Glazed",
    "Design Option": "-1",
    Family: "Standard",
    "Family and Type": "Standard",
    Frame: "SH_Aluminum, Anodized Black",
    "Frame Depth": "60",
    "Frame Depth over": "80",
    "Frame Depth under": "80",
    "Frame Width": "60",
    Glass: "<By Category>",
    "Head Height": "2700",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2700",
    "Host Id": "Wall - Timber Clad",
    Image: "<None>",
    "Install Depth (from outside)": "0",
    Mark: "99",
    Operation: "SinglePanel",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rough Height": "2700",
    "Rough Width": "1500",
    "Sill Height": "0",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Hung Casement": "Yes",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Type Mark": "46",
    "Visual Light Transmittance": "0",
    Volume: "0.16",
    "Wall Closure": "By host",
    Width: "1500",
    "Window Cill Exterior": "SH_Aluminum, Anodized Black",
    "Window Cill Interior": "Wood_Walnut black",
  },
  {
    ID: "744524",
    Name: "Single Window: Standard",
    Category: "Windows",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry:
      "0wAAAB+LCAAAAAAABAA1zcsKwjAQBdB/mXUbmubRJK5EBUEXpQguShethjYQE6lRKKX/bkTdzcw9w61nKDtzmu4aFBx8Zyp9Ca3rrYYESm9ceICq5+8YCSUIC8ZWKckRp5LD0vzdehzbKeJ42Jr2poMeQWUoS+CoXR8GUBTJHJMEKh/aYLwDhRErskJykvNCUiFFTM/m+sEZYpzGda9NP8RqgYTEOIGd1a/fd4qRIEU0G299LHNPa5fmDWt8W4fTAAAA",
    Pbi3DGeometry:
      "fSUAAB+LCAAAAAAABACtWt9L3EAQ/l/yHMNuskn29KnYQqF9kLbQB/FB8dCANeV6FET833vepUn2dr7ZmSiieN/MzszONz9W8PI5u7jpfjz9Xmen2Zf+pvveP3S3WZ5d9N3j9k92evl8+HUnNme7r+wln5ATa8zZ/sfuO3u5+n/sw2Zz/bQ768qires2P6nqwlpT5ie2aL23uauKqhTBlfcQpqxDwdy+KaxfReYndK87GlmO09YZFNlQ3ZRLmSYBrK7OX5IHNrNseMLKgiWhpTOpr/cMSY1SX9vGk1mu3cqGAle7QUCXR2PrKhB442r2BOcDCGC4kWA4EUdVtRUbbmN8eyRY8eHCE3ofsQCGGwpGZkf8YGnCw5hm+MiSDSokTGCkD+1L/aI4B3xgNK7YQzVRuCp+pK+1H8WJ8LBNqHiQX9g9ykaEVCJqeH3oQCLQVm9KX97moQcokDcUr6/3DKdC5BrWPB+qZOykZp66HXC7vXkHLOzEhL7eM1xL8iHGhyrZe8KxgR5sla/9K1y78hhtinZlq6PXU1uYupoMuGKn4kSqtNXBAB1BhB4NJs4ZrUqZpUMYMrn8vrQqbZYON56rS+Oldefb6FBXkXqIT3cJ63ByOhb0EdcJfWQ/IiwRJ7wYcqzOBIrouAQWJgLpA/Mw/Pi58Zbwgbo8zUyPSsAEe/K00E2yAIWm5VSA7tbBmGcOB/wkjSum8NK6ojePGhX3rbjP0/sytVYWzlh6hC9AkWU0ddP6zJ5DixKNN5rL0rf72zTO7B9eZWkbgaApvD+8ZxE+t0+jM+POeresJFLXDy0jfLI9Xsd5tx8GzlVNcIAXNEWzKlccHnpA+MzBMJ2MtZ4gBAoU3AJWgOPhYpr+EBKLSEEehwu5wlu3IjiBAgW9kBbofJ62qE8SuIRfQAvtNkydZrCkiEWkII9hvqI+SeASciEjyDU9oxKTTswsTQgzF4W7hbVLDUVal90fwj/gZDXIKevmBb1N5Hdmt6AsYDg91RHTunArih5nwj5HPZrYlqleJJoXOaCXJQ6Utg/nOBOpcFwl9fWrBT1BdLnADw1EGn0DvH2XXQAeQI+r9FNJthqiJxTC0ZMrYSdeJMybC7wS4AnoQxvs0odFdECbPeadqU0G8/oCPtAl8FJfdgl0YOagNZ6+wkFAEB0IZh54PI4Iea52GuSzJ8DjA9BSSoBciPHE3cS41i9MhZacBA4dKHKdKiSF4P2IhmW/WMDXxlWefeyuf6236012agqTZ1/Xj3fb++HDt357ve36x+Hjz+52FH1ed3f32+HDp4f137nief/Qb17/j8p4c/7671L/AClwnX99JQAA",
    "Analytic Construction": "<None>",
    Area: "6",
    "Bottom Hung Casement": "No",
    Casement: "SH_Aluminum, Anodized Black",
    "Casement Depth": "60",
    "Casement Pivot": "No",
    "Casement Swing in Plan": "No",
    "Casement Width": "60",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    Description: "Single Window Unit - Triple Glazed",
    "Design Option": "-1",
    Family: "Standard",
    "Family and Type": "Standard",
    Frame: "SH_Aluminum, Anodized Black",
    "Frame Depth": "60",
    "Frame Depth over": "80",
    "Frame Depth under": "80",
    "Frame Width": "60",
    Glass: "<By Category>",
    "Head Height": "2700",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2700",
    "Host Id": "Wall - Timber Clad",
    Image: "<None>",
    "Install Depth (from outside)": "0",
    Mark: "100",
    Operation: "SinglePanel",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rough Height": "2700",
    "Rough Width": "1500",
    "Sill Height": "0",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Hung Casement": "Yes",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Type Mark": "46",
    "Visual Light Transmittance": "0",
    Volume: "0.16",
    "Wall Closure": "By host",
    Width: "1500",
    "Window Cill Exterior": "SH_Aluminum, Anodized Black",
    "Window Cill Interior": "Wood_Walnut black",
  },
  {
    ID: "744525",
    Name: "Single Window: Standard",
    Category: "Windows",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry:
      "0wAAAB+LCAAAAAAABAA1zV0LgjAUBuD/cq5tbM65j66igqAuRIIuxAutoYO1ha1AxP/epLo7H885bzVB0Zrz+NCg4OhbU+praFxnNSRQeOPCE1Q1fctIMoqIYGy9ohwxjgXM9d9thqEZI46DnWnuOugBFEY4gZN2XehBZUimhCZQ+tAE4x0osjzhMqdpzmUmpIjbi7ktGCOWZ7E9aNP1MVogIQlJYG/1+3e9IkhQHs3WWx/D3Mvauf4AzmcuDNMAAAA=",
    Pbi3DGeometry:
      "0SUAAB+LCAAAAAAABACtWktr20AQ/i86K2JXu3olp5IWCu0htIUeQg4JMYnAtYprCiHkv9eWFVtrzTc7I5eQEM/sPL95BXL7mtw8tD9efi+Sy+RL99B+75btY5ImN1272vxJLm9f979u2eZq+5W8pUfKhTXmqv+x/U7e7t7FPqzX9y9bWZ9nVVFU6YU3mXG2SC9sVtW1Tb3LXC4iu7qGZEo7ZIz0uyKz1uSn+sfk/vW7mvMYwAJHhmpUEXOp0yWCfa0zKYCETzHrorTOYIHokY1K6I1DdAkEClvWZLIL39iQ4Qs/MOhCKW3hAkZtfMFKcDYAA7o7YQwSU69c5Vh3S1NXJ4yGdxdK6G1MGdDdgDGC9sDoVY0ZgVcB4wCUDaskSCIhgW3IjUN3B8YeWqp2+7qiGco4oITextRdyAgah/YKGocdpWxODC0EipeANkQMfVFHJeQDILABGapW4yX0xuHIIIzjNuDdFY2l2Eyc0R9MD569JmY3Z0RCbxwuL9WE490VLUjZLME3njOV3ZELn59Sy6xqrDs9tqrMFO6oodmWti9lb2m9gwbahwn1dFyx5sBjSjPpxXs+z4iZfAv00g4TE3eux/Tb8a7aV+TkeUg/BhPW49HoobJPAI+8B/qnkPF+wsCQYX0mkEeTIpiZCfAe6ccBEPfIWRGg9+Jc880qocZQFCeHbpY5VKhaDghocx2Zg5tnIJjiBlSDeXaR0RtJTRU3srjx43s0tmnmDV2wN2dQkWY0huPvmS2JdicadzSWuan7aEpv+qMsz20pYJRZXe8vXkQf66epI+Xe1n5eScTCDzUj+lH3IRxvin4oeO/KQIBnlFnZ5A1HDy0g+sjAgHbjnCUAgQwFtgAVYHgITNMfQmARKMjiIQWVK3MCE8hQwAthgcbHaZv0SYQuwRfAQpsNU6cZLDFgESjIYpivSZ9E6BJwISLIND2jIpNOjCwNCDMXhbuF1Uv/XUh7xuwP4daT1SD/WDMv6G0ij5ndgjKH4fRUe0y/hVtRdJwJ+xz1aGRbxnqRaF5kgF6W2FFaP5zjjKfCcRV9r18t6ATR5QIfGgg0OgK8fecFAAXQcRU/lWSrYXJCITo6uSJ6qEUCby54JcD1DmzonZ13WBACuuwxd6Y2Gcz1BWygIPBSnxcEEhgZqExNh7BnEEAHjJEFnj71CFl22xfk2RPQpwJQU4yBTIjpkdjEdK1dmAotOBE6NKDIdayQFIz/BzQs+9kMvjbu0uRje/9rsVmsk0uTmTT5ulg9bZ6HD9+6zf2m7VbDx5/t44H1edE+PW+GD5+Wi7/jh9fdslvv/jfL1OZ69y9Y/wARthzf0SUAAA==",
    "Analytic Construction": "<None>",
    Area: "6",
    "Bottom Hung Casement": "No",
    Casement: "SH_Aluminum, Anodized Black",
    "Casement Depth": "60",
    "Casement Pivot": "No",
    "Casement Swing in Plan": "No",
    "Casement Width": "60",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    Description: "Single Window Unit - Triple Glazed",
    "Design Option": "-1",
    Family: "Standard",
    "Family and Type": "Standard",
    Frame: "SH_Aluminum, Anodized Black",
    "Frame Depth": "60",
    "Frame Depth over": "80",
    "Frame Depth under": "80",
    "Frame Width": "60",
    Glass: "<By Category>",
    "Head Height": "2700",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2700",
    "Host Id": "Wall - Timber Clad",
    Image: "<None>",
    "Install Depth (from outside)": "0",
    Mark: "101",
    Operation: "SinglePanel",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rough Height": "2700",
    "Rough Width": "1500",
    "Sill Height": "0",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Hung Casement": "Yes",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    "Type Mark": "46",
    "Visual Light Transmittance": "0",
    Volume: "0.16",
    "Wall Closure": "By host",
    Width: "1500",
    "Window Cill Exterior": "SH_Aluminum, Anodized Black",
    "Window Cill Interior": "Wood_Walnut black",
  },
  {
    ID: "744828",
    Category: "Section Boxes",
    Description: "-1",
  },
  {
    ID: "744829",
    Name: "Living Room",
    Category: "Views",
    "Callout Tag": "Explicit",
    "Circuit Prefix Separator": "Poche",
    "Created By": "Yes",
    "Crop Region Visible": "Yes",
    "Decimal Degress": "None",
    Department: "Independent",
    Description: "-1",
    "Desired Stair Height": "Medium",
    "Detail Line": "-",
    "Dimming Lamp Color Temperature Shift": "Architectural",
    "Extrusion Start": "300",
    "Facucent Drilling": "3D View",
    Family: "3D View: 3D View",
    "Family Type": "No",
    "Far Clip Active": "23005",
    "Lock Proportions": "No",
    "Neutral Rating": "Yes",
    "Nominal Width": "-1",
    "Parent View": "Show Original",
    Perimeter: "Working Drawings",
    "Phase Demolished": "Show All",
    "Projected Area": "Perspective",
    "Schedule Level": "None",
    "Scope Box": "No",
    "Sheet Name": "---",
    Summary: "No",
    Tank: "300",
    "Tumble Dryer": "3D View",
    "Type Comments": "3D View",
    "Vertical Scale": "Living Room",
    "View Scale": "None",
    "View Template": "-1",
  },
  {
    ID: "745035",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jUELgjAcxb/L/zzHpnObdooKgjqIBB3Eg9bQwdrCViDid29i3d7v8Xu8aoKi1ZfxqSCHk2t1qW6+sZ1RgKBw2voX5NW0xqBElGOSiE1EMOeUwVz/te0wNGNwQ7HXzUN5NUBOMEFwVrbz/QI0oTGC0vnGa2chpzgVRGQ8ibnImMxShuCq76ucxJIiOCrd9X5hlqYZgoNRn986llhIHiY7Z1w4s29j5voLe546BtIAAAA=",
    Pbi3DGeometry:
      "LgQAAB+LCAAAAAAABAClU02LwjAQ/S9zTsM0tmlaT6LCgnsQXdiDeKgYNFAb6QZBxP++sdtdt0I01YSEzJuPR/IyixNMV+rjuJeQwUSv1FwXag0EplqV5guyxennaN3YtxPO5IoEIWK/3uyC8/I3bVBV+dHmBiGnDEMSIOU8jAgTVAhrXmEmYkFYSlnEem08jS44xlz44HGCdflE8Ig8pnWF35SPqUhY+pzDRXGDOxO8uFuP5+FoP4cHtyvBrVs33FXfT7cXLuAg6Mp7R4JuH9iNe2hsG2+k8p00soIMKRJ4l+XGbBtjpk1ulC4b81Ot/1xvUm22pjHGhTz8DxzqQleXxq+H7e9vaxwrxi4EAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "159",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "745997",
    Name: "Basic Wall: Retaining - 300mm Concrete",
    Category: "Walls",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABAB9js0KwjAQhN9lzzGkSdrEehIVBD0UETyUHiqGNhATqVEope9uoD/ixdvOfsPM5B1kV31uHwpSOLirzpxpK2cBQea09U9I8244g2ERYc4EXXGBhSQUevRljOIolsl/JrFIePzD5syJFVP1umnKNvSHx1aXd+VVAynBBMFR2crXozg5X3odJg/yom8z2itd1aFE4pgRimBn1Hv0crykEUOwccaFWPsypi8+bxiCHA4BAAA=",
    Pbi3DGeometry:
      "EwQAAB+LCAAAAAAABACdU80KwjAMfpeca8m2zul2EhUEPYgKHsTDxKKFucosgojvbtU5dVK7SWlJvqRf/trFGcYrMTvtOYQwlCsxlYlYA4GxFKk6QLg4P0RtxkgvuJAX0nAQo/uhN1yWz2udLItP+q7n0qaPAWEBDVroEkbbruORMux4lPkOIw2kbS38jRvoc7jwbtGgyfyCpXC34GX2T7jMbglqSN3AUi8VW/3VhmFqi7UiS6Vf/HWHbYlbcR6/e2NKst48Kr+wSlH17+qJeMcVzyBEigRGPN2oba5MpIqVkGmuzsW6MA242GxVrvQTfnx37MpEakLo4m3pT3wF7fj8NBMEAAA=",
    Absorptance: "0.1",
    Area: "27",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "-1500",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "Concrete",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Retaining - 300mm Concrete",
    "Family and Type": "Retaining - 300mm Concrete",
    Function: "Retaining",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Length: "10240",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "No",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Concrete - Cast In Situ",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Unconnected",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "0",
    Type: "Retaining - 300mm Concrete",
    "Type Id": "Retaining - 300mm Concrete",
    "Type Image": "<None>",
    "Unconnected Height": "2600",
    Volume: "7.99",
    Width: "300",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "746235",
    Name: "Basic Wall: Retaining - 300mm Concrete",
    Category: "Walls",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABAB9js0KwjAQhN9lzyGkSdPGehIVBD0UETyUHloMaSAmUqNQSt/dQH/Ei7ed/YaZKXrIa33pHhIyOLpa5850yllAkDtt/ROyoh/PYGACCx7xdZziVBAKA/qyhGLOBfvPBE6TmP+wJXNm5Vy9aduqC/3hsdPVXXrZQkYwQXCSVvlmEmfnK6/D5FFe9W1BB6lVE0oE5oxQBHsj35M3xisaMQRbZ1yItS9jhvID98L10A4BAAA=",
    Pbi3DGeometry:
      "JQUAAB+LCAAAAAAABACdVE2LwjAU/C/vHEPapJ+exBUWdg+iggfx0GLQQLeRblgo4n/fqLUVMW0ioUnf5GUybxKyOcE8F6v6yCGFL5mLpSzEDhDMpSjVL6Sb0+1XT5OxbnBGHTLyCBlfO/3BeXtfNqmqrNZrQx+HCfERi3AUX0ac+B5Fz7BHMQs8hmiMaZCwt3ED/R1mmCYBYjGOQha0JE9wx8H88EW2Cbdi6YfbcvphkxTH9Af8lVtmbx2kD2VbcRuttZFtqtLxPF1NHMo3HZKt/H5rrC66hXQXgwcrcrvrVpvq9+ZDZD9c8QpSggmCb17u1aEJFlJlSsiyCddi1059crE/qCaYFfzvMXEqC6kJYUouTT9r//BDVoYlBQAA",
    Absorptance: "0.1",
    Area: "21",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "-1500",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "Concrete",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Retaining - 300mm Concrete",
    "Family and Type": "Retaining - 300mm Concrete",
    Function: "Retaining",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Length: "7226",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "No",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Concrete - Cast In Situ",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Unconnected",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "0",
    Type: "Retaining - 300mm Concrete",
    "Type Id": "Retaining - 300mm Concrete",
    "Type Image": "<None>",
    "Unconnected Height": "2600",
    Volume: "5.99",
    Width: "300",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "746589",
    Name: "Basic Wall: Retaining - 300mm Concrete",
    Category: "Walls",
    Pbi2DGeometry: "CgEAAB+LCAAAAAAABAB9js0KwjAQhN9lzyGkadM/T0UFQQ9FBA+lhxZDuxATqVEope9upLXixdvOfsPMFAPkNZ76m4QU9qbG3Ki+MRoI5Aa1vUNaDNPpDIFPhRfGKxHRkPMIRvJlIqEJ9/6imIbslyyBMyo/tVnXVb3rdo8NVldpZQcpo4zAQerGtrM4GltZdHMnecbLgnYSm9Z1xFT4jBPYKvmcvcF7jk9gbZRxsfqh1Fi+APqL7NwKAQAA",
    Pbi3DGeometry:
      "IwgAAB+LCAAAAAAABACVVVFrwyAQ/i8+OzEmxpg+jW4w2B7KNthD2UNKpRWyODIZlNL/Ppum22LUGEJCPD+/++48z/URrDby9fApQAke1Ua+qFpuAQQrJRv9Bcr18fJrpvHCPOAE/yw3CcaL7mNecHq/Lrtt2+pg1mYZwphDylBOCIMcpRRn0LJmiJMkhTlGmJKR2QInKcpoMuLgqMgIHXF40Z0OG92TxFF7VLtDDDuMVu1EzwzmAk4Qo4xBWqAc+6x9hJQjVnBiWS3sVfKIuBNhUXjBnYpYsIvZqpmA0c7x0OrR4PYWZQ3HHFf7QX/OmMPQGFp3Tcw7q776jkvRFHoeebgKJoSHd8uTKmfd+lRHdoiJVuB2GSfP00xcxFNbEKVjZiiD7hrcRHcDjKuD0HEJXmJhbJh2IHcitDOtuW3vZPUhtGhBadIHwZNodnrfD56VrrRUTT98k9vfqQchd3vdD+5r8f0fuFS1MoRgic+PudR/AOhdKB8jCAAA",
    Absorptance: "0.1",
    Area: "14",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "-1500",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "Concrete",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Retaining - 300mm Concrete",
    "Family and Type": "Retaining - 300mm Concrete",
    Function: "Retaining",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Length: "5000",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "No",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Concrete - Cast In Situ",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Unconnected",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "0",
    Type: "Retaining - 300mm Concrete",
    "Type Id": "Retaining - 300mm Concrete",
    "Type Image": "<None>",
    "Unconnected Height": "2600",
    Volume: "4.02",
    Width: "300",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "746634",
    Name: "Basic Wall: Retaining - 300mm Concrete",
    Category: "Walls",
    Pbi2DGeometry:
      "DQEAAB+LCAAAAAAABABVjsEKwjAQRP9lz2FJk2bbtCdRQdBDEcGDeKgYaiA2UqNQpP9uoFXxtrNvdmcOL6hOdtffDBSw9idbedc3vgUGlbdtuENxeI1jNJBElZMoVYIZUQYD+7EsR0lcl8RRaMr/WYJcciozgVpL8ccUoVAq3qWYkoTh+EmedV3dx/i4WNj6aoLpoODIGWxM24TLJLY+1MHGxqPc2/MXrYxtLjEjRyW5YLB05jl5U9QikQzm3vn4tn04NxzftkMFmA0BAAA=",
    Pbi3DGeometry:
      "HwYAAB+LCAAAAAAABACVVNFqwyAU/RefnWiiUdOn0Q0G20PZBnsoe2iptEIWRyaDUvrvs1myldSbGiQxHo/Hc3OvLg9osbav+0+DSvTo1vbFVXaDMFo4W/svVC4Pv59hms5CQ0f8j9wwSmftKzzo+N4vu22a1T6sLRiRQkosFCmoxJrkgnI8QDnRGcuxDD1nChcFyZhSPTwgs5xwwS40NFE8ExcaILv1MWR3ImnSgOt4iOMbJruOsicG05KFJlLpbJCBAdrbCMqca4kLSahk2WQ8rh5P7ygXEIbhhHoCyGexABmDQgdyk2L8yg9MTPxVdqLz0dKEZIASAmDgbEObpqnEC3+awXitjF5fUw5a3HFqeCfhcNPe2dWH8aZBJSUUoydTb/2uGzw7v/LW1d3wzW7+ph6M3e58N7ivzPc5ce4qFwTRnJ5auNB/AHW14dkfBgAA",
    Absorptance: "0.1",
    Area: "13",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "-1500",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "Concrete",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Retaining - 300mm Concrete",
    "Family and Type": "Retaining - 300mm Concrete",
    Function: "Retaining",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Length: "5200",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "No",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Concrete - Cast In Situ",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Unconnected",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "0",
    Type: "Retaining - 300mm Concrete",
    "Type Id": "Retaining - 300mm Concrete",
    "Type Image": "<None>",
    "Unconnected Height": "2600",
    Volume: "3.82",
    Width: "300",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "746766",
    Name: "Basic Wall: Retaining - 300mm Concrete",
    Category: "Walls",
    Pbi2DGeometry:
      "DgEAAB+LCAAAAAAABABdjksLwjAQhP/LnkPIwyRNexIVBD0UETyIh4qhBmIjNQql9L+74gu97ew3O7PbHsq9X3dnBzks4t6XMXR1bIBAGX2TLpBv++eIBm2oMowX0lJleQYD+bLMUCO5KBSnQv4xg4wZU+gM74T9YQozR1oXSlOrHmz3rh63bdVhPy6mvjq55FrIGWUElq6p0/ElVjFVyePLT7nxhw+aO18fsQRrJRMEZsHdXt4RtYJLApMYIsY21xCG3R06DqfRDgEAAA==",
    Pbi3DGeometry:
      "HgUAAB+LCAAAAAAABACllN9LwzAQx/+Xe44hza8l3ZNsA0Efhgo+DB86FrZAbaQGYYz970ZX7RiJTRmhpfdJ7nLN9y6rAyzX9nn/bqCEe7e2T662G0CwdLbxH1CuDqfPME2mYcAR9eSmIGT68woPHF9/3W7bttoHX0WxlkIgoTFXkiKONS0YusQFw1wUHEmOmRaIKzyRXIzEidg95hMWnAhmTPVBLnm3XAZMZR9cYyYIT+HMIAOpZO+pOBW5OPWf/x9iZuaDOKbEVbKNVPOMRwtuZH3mKjfI4wWdbItEYcSlSzRLXNE8+cdWYiy9oWbOPMLTnuGimdvqzXjTQkkwQfBgmq3fdcaj85W3runMF7v5m7ozdrvznbGozef5wpmrXQgIM/I9wn32Bc0Qie8eBQAA",
    Absorptance: "0.1",
    Area: "18",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "-1500",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "Concrete",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Retaining - 300mm Concrete",
    "Family and Type": "Retaining - 300mm Concrete",
    Function: "Retaining",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Length: "7096",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "No",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Concrete - Cast In Situ",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Unconnected",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "0",
    Type: "Retaining - 300mm Concrete",
    "Type Id": "Retaining - 300mm Concrete",
    "Type Image": "<None>",
    "Unconnected Height": "2600",
    Volume: "5.3",
    Width: "300",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "757198",
    Name: "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr: Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    Category: "Lighting Fixtures",
    Level: "-1",
    Pbi2DGeometry:
      "1QAAAB+LCAAAAAAABAA1jUELgjAYhv/Ld55jc5tzdooKgjqIBB3Eg9bQwdrCViDif29R3V4enoe3nqHszGm6ayjg4DtT6UtoXW81ICi9ceEBRT1/Z1SYxEIpsUqYwDJjFJbm763HsZ2iHMHWtDcd9AgFwQTBUbs+DFBQjikXDEHlQxuMdxFhIYlUGUszqbgilCM4m+vHTmNLiUCw16Yf4jkVmHGVI9hZ/fr1SY4JzxBsvPXxzj2tXZo3qmItn9UAAAA=",
    Pbi3DGeometry:
      "6wcAAB+LCAAAAAAABADtk0sLgkAUhf/LXY/D1SYtW0UFLVpEBC2ihdFQA+aETYFE/z0p7WneXCeizD1z5hvnceYnGC/VNNlJ8KNDGDIYaxWZPfjz060JPmAnfeDMHoplI3aun/SF8yIf1o3jIEnHOh53bbSZJZB7wmkzq8VRuExQutPkws5VklLsflHJGXPd4w1stN7Z72r5nxQziNV86BnFKWSTlGJ3lZ0qU0u5P3mJdVQ9r5853/yEXu2ekBR6Z9Is9VWwlUbG4CNHBiMZrc0mKybaBEbpKCtnanXvGkq13pisGITy+Gzs6VDHt4xfg1yHvg59Hfo/Cv3iAlfI86brBwAA",
    "Apparent Load": "0",
    Area: "486",
    "Assembly Code": "D5020",
    "Assembly Description": "Lighting and Branch Wiring",
    "Calculate Coefficient of Utilization": "No",
    "Coefficient of Utilization": "0",
    Cost: "0",
    "Default Elevation": "1000",
    "Design Option": "-1",
    "Diffuser Material": "SH_Aluminum, Anodized Black",
    "Electrical Data": "0 V/1-0 VA",
    "Elevation from Level": "0",
    Family: "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    "Family and Type": "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    "Frame Material": "SH_Aluminum, Anodized Black",
    Host: "Compound Ceiling : 3000 x 3000mm Grid",
    "Host Id": "-1",
    Image: "<None>",
    "Lamp 10": "No",
    "Lamp 11": "No",
    "Lamp 12": "No",
    "Lamp 2": "No",
    "Lamp 3": "No",
    "Lamp 4": "No",
    "Lamp 5": "No",
    "Lamp 6": "No",
    "Lamp 7": "No",
    "Lamp 8": "No",
    "Lamp 9": "No",
    "Lamp Quantity": "1",
    "Light Bulb Material": "Glass - Cooper Industries - Clear",
    Manufacturer: "Cooper Industries, Inc.",
    Mark: "36",
    "Number of Poles": "1",
    "OmniClass Number": "23.80.70.11.14.21",
    "OmniClass Title": "Spots and Tracklight Specialties",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Power Factor": "0",
    Rotation: "45.00°",
    "Schedule Level": "-1",
    Series: "Profile",
    Spacing: "305",
    "Spacing Left": "152",
    "Supply Voltage": "0",
    "Total Input Wattage": "0",
    "Track/Bswy Length": "1219",
    Type: "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    "Type Id": "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    "Type Image": "<None>",
    URL: "http://www.cooperlighting.com/",
    Voltage: "0",
    Volume: "381.4",
  },
  {
    ID: "764691",
    Name: "Floor: Insitu Concrete 225mm",
    Category: "Floors",
    Level: "Level 2",
    "Aalto Vase Material": "0.1",
    "Architrave Offset": "26",
    "Coarse Poche Material": "0",
    "Coarse Scale Fill Color": "-1",
    "Cooling Set Point": "225",
    CosAng: "0",
    "Default Elevation": "225",
    Description: "-1",
    Elevation: "2775",
    "Elevation at Bottom": "2775",
    "Elevation at Bottom Core": "2775",
    "Elevation at Bottom Survey": "3000",
    "Elevation at Top": "3000",
    "Elevation at Top Core": "3000",
    "Emit from Line Length": "Yes",
    "Facucent Drilling": "Insitu Concrete 225mm",
    Family: "Insitu Concrete 225mm",
    "Full Step Arrow": "Interior",
    "Heat Load Values": "4.6489 /(·)",
    "Height 1": "0",
    Illuminance: "<None>",
    "Parts Visibility": "28580",
    Phase: "Working Drawings",
    "Phase Created": "None",
    "Rebar Cover": "Rebar Cover 1",
    "Rebar Cover - Interior Face": "Rebar Cover 1",
    "Rebar Cover - Other Faces": "Rebar Cover 1",
    "Referencing Sheet": "No",
    Rim: "Yes",
    "Rough Width": "1",
    "Slab Thickness": "0.00°",
    "Story Above": "Yes",
    Structural: "Concrete, Cast In Situ",
    "Text Type": "31.59 /",
    "Thermal Mass": "0.2151 (·)/",
    "Thermal Resistance (R)": "225",
    "Tumble Dryer": "Insitu Concrete 225mm",
    "Type Comments": "Insitu Concrete 225mm",
    "Type Id": "<None>",
    Voltage: "5.89",
  },
  {
    ID: "765523",
    Name: "Basic Wall: Retaining - 300mm Concrete",
    Category: "Walls",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABAB9jlELgjAUhf/LfR5jbrote5IKgnqQCHoQH5SGDtYWtgIR/3sDTYigt3vudzjnFAPktT73dwUpHFytc2f6xllAkDtt/QPSYpjOYGAR5pzH61hiKiiDEf0yJvEqicU3o5gnRPxlS2b5qc66rupDf3hsdXVTXnWQEkwQHJVtfDuLk/OV12HyJC/6uqC90k0bSiKCI0E4gp1Rr9nMMJVEItg440KufRozlm81fwwBDwEAAA==",
    Pbi3DGeometry:
      "EwQAAB+LCAAAAAAABACVU0sLwjAM/i8515Jt3cN5kikIehAVPIiHDYsW5iqzCEP871adDyZbN0JL86X5EvLYXGGeiFVx4hDCVCZiKVOxAwJzKTJ1hnBzfT21GQda4Ea+SM9CHDwvfeC2fbsN8zwutK9jUc/zGHEC2neZTxxqBxiQKmw5lLkW++DMp36Adme8hv4N29Rz0f9nKfG/bCp4hcbAbgpak3ozS8tUmqverVoG2FhEQ6vbToYhbF1Pu05S64lsGdfQ1uaOVMj1do1EfOSK5xAiRQIznu3VoVQWUsVKyKxU12L3MU242B9UqYxTfvn9GMlUakKI8CF6ie95k8M5EwQAAA==",
    Absorptance: "0.1",
    Area: "8",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "-2000",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "Concrete",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "Yes",
    Family: "Retaining - 300mm Concrete",
    "Family and Type": "Retaining - 300mm Concrete",
    Function: "Retaining",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Length: "2840",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rebar Cover - Exterior Face": "Rebar Cover 1",
    "Rebar Cover - Interior Face": "Rebar Cover 1",
    "Rebar Cover - Other Faces": "Rebar Cover 1",
    "Related to Mass": "No",
    "Room Bounding": "No",
    Roughness: "1",
    Structural: "Yes",
    "Structural Material": "Concrete - Cast In Situ",
    "Structural Usage": "Bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "1100",
    Type: "Retaining - 300mm Concrete",
    "Type Id": "Retaining - 300mm Concrete",
    "Type Image": "<None>",
    "Unconnected Height": "3100",
    Volume: "2.5",
    Width: "300",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "765620",
    Name: "Basic Wall: Retaining - 300mm Concrete",
    Category: "Walls",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABAB9jkELgkAQhf/LnJdldVdd7RQVBHWQCDqIB6VFF7bdsC0Q8b83oAkRdJp58z3em2KAvNbn/q4gg4Orde5M3zgLBHKnrX9AVgzTigYuKY9SsRKShknIYSS/DGcaieSbpZQLHv9lS2b5qV53XdVjPx62uroprzrIGGUEjso2vp3FyfnKa3x5khd9XdBe6abFkoDRIGExgZ1Rr9nMaSiZJLBxxmGufRozlm9VLTE4DwEAAA==",
    Pbi3DGeometry:
      "EwQAAB+LCAAAAAAABACVU8kKwjAQ/Zc5x5Ca1C6epAqCHooKHsRDS4MN1EZqEET8d6PWKpU2LSHLvMm8GWbZ3SCMxeZ64uDDQsZiLTORAIJQilydwd/d3k+tJmO94I6+yMAiZPw69Ib7/mM2KYroqm2pi6ntMaRvz2YOonjoEhfVYYtiZluswpmDHZcMe+MN9B/Yw5TR0T9Lif9FU8NrNAZ2k9OG0NtZOobSnvV+2TLAxiQaSt21Mwxum2rat5M6d2RHv4aytlekRq6nayqiI1e8AJ9ggmDJ84NKS2ElVaSEzEtxK5JKNefikKpSmGX88vsxkJnUhBCQ59JD/AB5YN6KEwQAAA==",
    Absorptance: "0.1",
    Area: "8",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "-2000",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "Concrete",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "Yes",
    Family: "Retaining - 300mm Concrete",
    "Family and Type": "Retaining - 300mm Concrete",
    Function: "Retaining",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Length: "2840",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rebar Cover - Exterior Face": "Rebar Cover 1",
    "Rebar Cover - Interior Face": "Rebar Cover 1",
    "Rebar Cover - Other Faces": "Rebar Cover 1",
    "Related to Mass": "No",
    "Room Bounding": "No",
    Roughness: "1",
    Structural: "Yes",
    "Structural Material": "Concrete - Cast In Situ",
    "Structural Usage": "Bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "1100",
    Type: "Retaining - 300mm Concrete",
    "Type Id": "Retaining - 300mm Concrete",
    "Type Image": "<None>",
    "Unconnected Height": "3100",
    Volume: "2.5",
    Width: "300",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "766598",
    Name: "Foundation Slab: 150mm Foundation Slab",
    Category: "Structural Foundations",
    Level: "Level 2",
    "Aalto Vase Material": "0.1",
    "Architrave Offset": "123",
    "Coarse Poche Material": "0",
    "Coarse Scale Fill Color": "-1",
    "Cooling Set Point": "150",
    CosAng: "0",
    "Default Elevation": "150",
    Description: "-1",
    Elevation: "2850",
    "Elevation at Bottom": "2850",
    "Elevation at Bottom Core": "2850",
    "Elevation at Bottom Survey": "3000",
    "Elevation at Top": "3000",
    "Elevation at Top Core": "3000",
    "Emit from Line Length": "Yes",
    "Facucent Drilling": "150mm Foundation Slab",
    Family: "150mm Foundation Slab",
    Font: "150",
    "Heat Load Values": "6.9733 /(·)",
    "Height 1": "0",
    Illuminance: "<None>",
    Legs: "6850",
    "Parts Visibility": "64077",
    Phase: "Working Drawings",
    "Phase Created": "None",
    "Rebar Cover": "Rebar Cover 1",
    "Rebar Cover - Interior Face": "Rebar Cover 1",
    "Rebar Cover - Other Faces": "Rebar Cover 1",
    "Referencing Sheet": "No",
    "Rough Width": "1",
    "Slab Thickness": "0.00°",
    "Story Above": "Yes",
    Structural: "Concrete, Cast In Situ",
    "Text Type": "21.06 /",
    "Thermal Mass": "0.1434 (·)/",
    "Thermal Resistance (R)": "150",
    "Tumble Dryer": "150mm Foundation Slab",
    "Type Comments": "150mm Foundation Slab",
    "Type Id": "<None>",
    Voltage: "18.51",
    Wheels: "25379",
  },
  {
    ID: "766599",
    Category: "Analytical Foundation Slabs",
    "Adjust for Mullion Size": "Auto-Detect",
    "Analytic Construction": "Yes",
    "Analytical Model Correct": "Foundation",
    "Architrave Offset": "123",
    Description: "-1",
    "Family Name": "150mm Foundation Slab",
    "Parts Visibility": "64077",
    Phase: "Working Drawings",
    "Phase Created": "None",
    "Photometric Web File": "Concrete 10 MPa",
    "Surface Area": "0",
    y: "Default",
  },
  {
    ID: "767153",
    Name: "M_Pile Cap-600 Pile: 600 x 600 x 900mm",
    Category: "Structural Foundations",
    Level: "Level 2",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABABNjUEKwjAURO/y1zEktWlNXIkKgi5KEVyULlL9tIGYSI1CKb27ASu4G+Y9ZqoRisachweCgqNvTInXoF1rEQgU3rjwBFWN3xiVpaCCiXUiKctlClP9szZ9r4eoxmJn9B0D9qAYZQRO6NrQgeJUZitBoPRBB+PdjC/m9k8PaNouPiWMZrmQBPYW37O/4JzyjKcEtt76uO9e1k71B6kwJNrEAAAA",
    Pbi3DGeometry:
      "AQQAAB+LCAAAAAAABACtk1ELgjAQx7/LPa9xOS21p6ggqIeooAfpwWjowFzYCCL67q1Si4WaEGNj99vuv9vtFlxhsRPry5GDDzO5EyuZiD0QWEiRqhP4wfU11cs40A1u5E06XcTBc9AdbtvCbZhl4UX7Mps6FrqEIcUe6xOPOl3bJgW2XIqeY5W4R23XYy1xhbaJDRGXOgytr0gMXIg0YCMSA5vaFXFXiLSLpP7yP6aqXrtdBs1Ha1cQFdr1iW3Af6nB316+Adceqf/SWIQHrngGvnYgMOdppOLcWEoVKiHT3NyIfbk05SKKVW5MEn7+3DiSidSCMMJH01/2DjbsfCMBBAAA",
    Area: "0",
    "Assembly Code": "A1010130",
    "Assembly Description": "Pile Caps",
    Cost: "0",
    "Cut-off": "150",
    "Design Option": "-1",
    "Elevation at Bottom": "-3402",
    "Elevation at Bottom Survey": "-3402",
    "Elevation at Top": "2900",
    "Elevation at Top Survey": "2900",
    "Enable Analytical Model": "Yes",
    Family: "600 x 600 x 900mm",
    "Family and Type": "600 x 600 x 900mm",
    "Height Offset From Level": "-100",
    Host: "Level : Level 2",
    "Host Id": "-1",
    Image: "<None>",
    Length: "600",
    "Moves With Grids": "Yes",
    "OmniClass Number": "23.25.05.11",
    "OmniClass Title": "Foundation Piles",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Pile Type": "600mm Diameter",
    "Rebar Cover - Bottom Face": "Rebar Cover 1",
    "Rebar Cover - Other Faces": "Rebar Cover 1",
    "Rebar Cover - Top Face": "Rebar Cover 1",
    "Structural Material": "Concrete - Cast-in-Place Concrete",
    Thickness: "300",
    Type: "600 x 600 x 900mm",
    "Type Id": "600 x 600 x 900mm",
    "Type Image": "<None>",
    Volume: "0.11",
    Width: "600",
  },
  {
    ID: "767156",
    Name: "M_Pile-Steel Pipe: 600mm Diameter",
    Category: "Structural Foundations",
    Level: "Level 2",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABAA1jcsKwjAQRf9l1jEkfdimrkQFQRelCC5KF6kOaSAmUqNQSv/dFOvuzj2HufUIZasvwxOhgJNrdYU3L60yCARKp61/QVGPvxiUOKUpSzeRoCwTCUzN39r2vRyCGoq9lg/02EPBKCNwRqt8Nx9CJBmBynnptbMLvur7QvOZHlGrLixFjPI8DsXB4GfxV5xTvuYJgZ0zLvy3b2Om5gsVLlCvxAAAAA==",
    Pbi3DGeometry:
      "JBgAAB+LCAAAAAAABACVl1tr20AQhf/LPitiVxdLcp5CWii0D6Et9CH4wSEiEbhWcUUhBP/3ypJbS/J82hEmwd7RzuWcWe2Zx3fz8FR9f/tVmrX5XD9V3+pd9WwC81BX++a3WT++919bs71tP+YYXFZunLW33b/2zxw3/7bdHQ7bt3ZvnIaxtasgKsI0ylxw41zoVi4JWkOapa4zrFbpyJDZIhV32DjKT4bI5WNDHmXxyZCkLh4ZClec1uMkVYZAT54y8jAtoliXLSWFIdCTy3uDPtskTkXMkQwMgUnZwi0rDzHHEIy5izpsbVYkSjKKLBJ3EEtF1m9Y4KnbkYdFYvPrEHmYu1gILaz3QOVt92ZSO+fhKna6CAggVT2/QYiAKfVMCGj0nSZU1zWUEALJZk8Uu+9NIVusuztIwjpuwBCYLbri+giR+S6nFhT6YBShTS22keLcCYgjqcMNgwCqrrk8jxAhDZSQqi0vgUf+YVnTRwwcAATEEMxi8uAbMJZ9LEceIIOoBNhw3UvH4tMrex89Dsuql6LuzX6JoHrhXx7HU043E+ajupoGgYcBYFn1nsKCASBgBuuC/MG7jDJhsBR8Ak2mFt/sQ4OXEWxZAFI+DyNtpMkRtZRGfEFclJZTpgTFiXMBJaSaPKb9dPYPyypZjgCJYTWwAV0aFsWYiAxwghgAZuAGERsZvIygG9UANTkns6uqEUk36E2vPWmUHAxnk5tcUnuLB0/yNNowFRxXHcizJelMLBgAknnBsiB9cC6DTBAsxZ4wk5lFYQ56UXZODSvDCGdBAcCyzvDRCfQs60XieC6/q+sVpIFCQXtdUyJz/GoVPqhncCJrAnhYIcz98M2BfcWv3CMAn+aS8ja8fDHORpTV4/zl6nVN97ysFUSZCUIYktbMRV4nIDFlFTw3ZygLV8h3v0aaE1raRlVLiU1gPlTbn2VTHszahjYwX8r9S/N6/vG1brZNVe/PP39Uz/9Nn8rq5bU5//i4K/8MH7yvd3Xr0Nzb08ccN38Brws4fCQYAAA=",
    Area: "0",
    "Assembly Code": "A1020130",
    "Assembly Description": "Piles - Steel Pipe",
    Cost: "0",
    Depth: "6000",
    "Design Option": "-1",
    Diameter: "300",
    "Elevation at Bottom": "-3402",
    "Elevation at Bottom Survey": "-3402",
    "Elevation at Top": "2750",
    "Elevation at Top Survey": "2750",
    Family: "600mm Diameter",
    "Family and Type": "600mm Diameter",
    "Height Offset From Level": "-302",
    Host: "Level : Level 2",
    "Host Id": "-1",
    Image: "<None>",
    Length: "0",
    "Minimum Embedment": "152",
    "Moves With Grids": "Yes",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Radius: "150",
    "Structural Material": "Metal - Steel - 345 MPa",
    Type: "600mm Diameter",
    "Type Id": "600mm Diameter",
    "Type Image": "<None>",
    Volume: "0.42",
    Width: "0",
  },
  {
    ID: "767797",
    Name: "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr: Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    Category: "Lighting Fixtures",
    Level: "-1",
    Pbi2DGeometry:
      "1gAAAB+LCAAAAAAABAA1zc0KwjAQBOB32XMa8tMmTTyJCoIeiggexEPVpQ3ERGoUSvHdDai32eFb5jhBc3b78Y5gYRPPboeX1IbOIxBoogvpAfY4fWMmoqalkHpWyIpqJTm8T383H4Z2zDgXS9feMOEAllFGYIuhSz1YkS/GBIFdTG1yMYDltNJMGyWF0qasDTcEDu7615xVBNbouj6Pc06FqjJYeXz9/gtJjRKcwCL6mPfC0/v36QMRbkKw1gAAAA==",
    Pbi3DGeometry:
      "VwgAAB+LCAAAAAAABADtVMsKwjAQ/Jc9pyExWmM9iQoePIgIHsRDxaCB2kiNQhH/3aD1QUvY9l5CQ3cnM9tNk9ncYbHTq/ysIEqvSUJgYXRqLxBt7u9XiIAN3YAH+WUCztjwNbkHHtsPbZRlce64XNIuF5wEPUYZkyEJBB2EHU4ECnQkld0+/wK4lJdRBvDiH6BPBROyWqKcR7/JJ4R2VwEKpUpz5bxXyEdovn0ogJWoTcCaa/xH6yv5CEi+6VFCdeptkbuBEx2flFUZRE6JwFylB3ssgqWxsdUmLcK13n+hmdKHoy2CaaJu/wvHJjHZ2xle17+1itYqWqtorQKxiu0TpKfrFVcIAAA=",
    "Apparent Load": "0",
    Area: "486",
    "Assembly Code": "D5020",
    "Assembly Description": "Lighting and Branch Wiring",
    "Calculate Coefficient of Utilization": "No",
    "Coefficient of Utilization": "0",
    Cost: "0",
    "Default Elevation": "1000",
    "Design Option": "-1",
    "Diffuser Material": "SH_Aluminum, Anodized Black",
    "Electrical Data": "0 V/1-0 VA",
    "Elevation from Level": "0",
    Family: "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    "Family and Type": "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    "Frame Material": "SH_Aluminum, Anodized Black",
    Host: "Compound Ceiling : 3000 x 3000mm Grid",
    "Host Id": "-1",
    Image: "<None>",
    "Lamp 10": "No",
    "Lamp 11": "No",
    "Lamp 12": "No",
    "Lamp 2": "No",
    "Lamp 3": "No",
    "Lamp 4": "No",
    "Lamp 5": "No",
    "Lamp 6": "No",
    "Lamp 7": "No",
    "Lamp 8": "No",
    "Lamp 9": "No",
    "Lamp Quantity": "1",
    "Light Bulb Material": "Glass - Cooper Industries - Clear",
    Manufacturer: "Cooper Industries, Inc.",
    Mark: "47",
    "Number of Poles": "1",
    "OmniClass Number": "23.80.70.11.14.21",
    "OmniClass Title": "Spots and Tracklight Specialties",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Power Factor": "0",
    Rotation: "90.00°",
    "Schedule Level": "-1",
    Series: "Profile",
    Spacing: "305",
    "Spacing Left": "152",
    "Supply Voltage": "0",
    "Total Input Wattage": "0",
    "Track/Bswy Length": "1219",
    Type: "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    "Type Id": "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    "Type Image": "<None>",
    URL: "http://www.cooperlighting.com/",
    Voltage: "0",
    Volume: "381.4",
  },
  {
    ID: "767856",
    Name: "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr: Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    Category: "Lighting Fixtures",
    Level: "-1",
    Pbi2DGeometry:
      "1QAAAB+LCAAAAAAABAA1jUELgjAYhv/Ld55jc5tzdooKgjqIBB3Eg9bQwdrCViDif29R3V4enoe3nqHszGm6ayjg4DtT6UtoXW81ICi9ceEBRT1/Z1SYxEIpsUoYxTJjFJbm763HsZ2iHMHWtDcd9AgFwQTBUbs+DFBQjikXDEHlQxuMdxFhIYlUGUszqbgilCM4m+vHTmNLiUCw16Yf4jkVmHGVI9hZ/fr1SY4JzxBsvPXxzj2tXZo3aO63gtUAAAA=",
    Pbi3DGeometry:
      "6wcAAB+LCAAAAAAABADtk80LgjAYxv+X9zzHpqJlp6igQweJoEN0MBo6MBe2Aon+96S0DzPfPCei7H327Df38azO4G/kItsL8JJjHBPwlUz0AbzV+d4ED9ggf+BCnorBGRvcPvkLl3U5bJimQZaPNV3qcMaJYTnUtc0+MXqU2Q6xMd3k1OalilLq3W8qOmOpu9RiVq/KrqrNf1LPQFbzoRcUs5aNUurdbXaqSW3k/uRF1tH2vH7mfPMjert7glLwncmzNJbBTmiRgscoIzATSaijopgrHWipkqJcyu2jaypkGOmimMTi9GocqVil94zfgtyFvgt9F/o/Cv36CpfkjKTrBwAA",
    "Apparent Load": "0",
    Area: "486",
    "Assembly Code": "D5020",
    "Assembly Description": "Lighting and Branch Wiring",
    "Calculate Coefficient of Utilization": "No",
    "Coefficient of Utilization": "0",
    Cost: "0",
    "Default Elevation": "1000",
    "Design Option": "-1",
    "Diffuser Material": "SH_Aluminum, Anodized Black",
    "Electrical Data": "0 V/1-0 VA",
    "Elevation from Level": "0",
    Family: "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    "Family and Type": "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    "Frame Material": "SH_Aluminum, Anodized Black",
    Host: "Compound Ceiling : 3000 x 3000mm Grid",
    "Host Id": "-1",
    Image: "<None>",
    "Lamp 10": "No",
    "Lamp 11": "No",
    "Lamp 12": "No",
    "Lamp 2": "No",
    "Lamp 3": "No",
    "Lamp 4": "No",
    "Lamp 5": "No",
    "Lamp 6": "No",
    "Lamp 7": "No",
    "Lamp 8": "No",
    "Lamp 9": "No",
    "Lamp Quantity": "1",
    "Light Bulb Material": "Glass - Cooper Industries - Clear",
    Manufacturer: "Cooper Industries, Inc.",
    Mark: "48",
    "Number of Poles": "1",
    "OmniClass Number": "23.80.70.11.14.21",
    "OmniClass Title": "Spots and Tracklight Specialties",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Power Factor": "0",
    Rotation: "45.00°",
    "Schedule Level": "-1",
    Series: "Profile",
    Spacing: "305",
    "Spacing Left": "152",
    "Supply Voltage": "0",
    "Total Input Wattage": "0",
    "Track/Bswy Length": "1219",
    Type: "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    "Type Id": "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    "Type Image": "<None>",
    URL: "http://www.cooperlighting.com/",
    Voltage: "0",
    Volume: "381.4",
  },
  {
    ID: "767857",
    Name: "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr: Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    Category: "Lighting Fixtures",
    Level: "-1",
    Pbi2DGeometry:
      "1gAAAB+LCAAAAAAABAA1zcEKwjAQBNB/2XMaskmbNPEkKgh6KCJ4EA9VQxuIidQolOK/G1Bvs8Nb5jhBc3b78W7BwCae3c5eUhs6b4FAE11IDzDH6Rsz4TUtuVCzQiBVUiC8T383H4Z2zDgXS9febLIDGEYZga0NXerB8HwxxgnsYmqTiwEM0koxpaXgUumy1qgJHNz1r5FVBNbWdX0eR6RcVhmsvH39/gtBteRIYBF9zHvh6f379AEBVzXF1gAAAA==",
    Pbi3DGeometry:
      "VwgAAB+LCAAAAAAABADtVF0LgjAU/S/3eY6tmZk9RQU99CAR9BA9GI0amAtbQUj/vVH2gTKuvstweO/ZOdc7t7MpIN6p1f0sIcquaUog1iozF4g2xfsVImAjO+BBfhmPMzZ6TfaBx/ZDG+d5crdcHlKfC048P6D+oB8ST9Bh0ONEoEDPAmHAvwAu5WRUAbz4BxhQwURYL1HNo9/kEkK7qwGlUq25at4p5CK03z4UwEo0JmDNtf6jzZVcBCTf9iihOs22yN7AqUpO0sgcIkYZgYXMDuZYBkttEqN0VoZrtf9Cc6kOR1MGs1Te/hdOdKrztzO8rn9nFZ1VdFbRWQViFdsnw+p0gVcIAAA=",
    "Apparent Load": "0",
    Area: "486",
    "Assembly Code": "D5020",
    "Assembly Description": "Lighting and Branch Wiring",
    "Calculate Coefficient of Utilization": "No",
    "Coefficient of Utilization": "0",
    Cost: "0",
    "Default Elevation": "1000",
    "Design Option": "-1",
    "Diffuser Material": "SH_Aluminum, Anodized Black",
    "Electrical Data": "0 V/1-0 VA",
    "Elevation from Level": "0",
    Family: "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    "Family and Type": "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    "Frame Material": "SH_Aluminum, Anodized Black",
    Host: "Compound Ceiling : 3000 x 3000mm Grid",
    "Host Id": "-1",
    Image: "<None>",
    "Lamp 10": "No",
    "Lamp 11": "No",
    "Lamp 12": "No",
    "Lamp 2": "No",
    "Lamp 3": "No",
    "Lamp 4": "No",
    "Lamp 5": "No",
    "Lamp 6": "No",
    "Lamp 7": "No",
    "Lamp 8": "No",
    "Lamp 9": "No",
    "Lamp Quantity": "1",
    "Light Bulb Material": "Glass - Cooper Industries - Clear",
    Manufacturer: "Cooper Industries, Inc.",
    Mark: "49",
    "Number of Poles": "1",
    "OmniClass Number": "23.80.70.11.14.21",
    "OmniClass Title": "Spots and Tracklight Specialties",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Power Factor": "0",
    Rotation: "90.00°",
    "Schedule Level": "-1",
    Series: "Profile",
    Spacing: "0",
    "Spacing Left": "10",
    "Supply Voltage": "0",
    "Total Input Wattage": "0",
    "Track/Bswy Length": "1219",
    Type: "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    "Type Id": "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    "Type Image": "<None>",
    URL: "http://www.cooperlighting.com/",
    Voltage: "0",
    Volume: "381.4",
  },
  {
    ID: "767870",
    Name: "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr: Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    Category: "Lighting Fixtures",
    Level: "-1",
    Pbi2DGeometry:
      "1gAAAB+LCAAAAAAABAA1jV0LgjAYRv/Lez3HPpzy2lVUENSFSNCFeKE1dLC2sBWI+N9bVHcPh3N46hnKzpymu4YCDr4zlb6E1vVWA4HSGxceUNTzd0ZF5lQhqlUiBUWBHJbm763HsZ2iHMHWtDcd9AgFo4zAUbs+DFBwpJIjJ1D50AbjXURU5SzHTIosxxQZpgTO5vqxRWw5UwT22vRDPOeSKqlivrP69euTjArJJYGNtz7+uae1S/MGLMU6CNYAAAA=",
    Pbi3DGeometry:
      "MwgAAB+LCAAAAAAABADtVE2LwjAQ/S9zTsOkVaP1JO6CBw8iggfxUDFooDZLNwoi/neLxq9KnPZeQkPnzcybzjR5ixNMVnp2/FMQZ/s0ZTAxOrP/EC9Ot1eIAfvFgjN7IoFA7F+34oHz8p42yPPkWOSGkncECha0BEfZY0GHh5GIWIvCQ8GlxPbDQRJ5E8oOsrTDJY8w6n4WKOPUB/l4qM7KuOP56KuM+2h88fUHRzqoEpUTiN5q/sqqNJ7w73DN40OxVJtMcd9+dLJTVuUQI0cGY5Vt7NYZU2MTq03mzLleP1wjpTdb64zfVB1eA4cmNflNB66XvRGGRhgaYWiE4U0Ylhe7Q/b9MwgAAA==",
    "Apparent Load": "0",
    Area: "486",
    "Assembly Code": "D5020",
    "Assembly Description": "Lighting and Branch Wiring",
    "Calculate Coefficient of Utilization": "No",
    "Coefficient of Utilization": "0",
    Cost: "0",
    "Default Elevation": "1000",
    "Design Option": "-1",
    "Diffuser Material": "SH_Aluminum, Anodized Black",
    "Electrical Data": "0 V/1-0 VA",
    "Elevation from Level": "0",
    Family: "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    "Family and Type": "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    "Frame Material": "SH_Aluminum, Anodized Black",
    Host: "Compound Ceiling : 3000 x 3000mm Grid",
    "Host Id": "-1",
    Image: "<None>",
    "Lamp 10": "No",
    "Lamp 11": "No",
    "Lamp 12": "No",
    "Lamp 2": "No",
    "Lamp 3": "No",
    "Lamp 4": "No",
    "Lamp 5": "No",
    "Lamp 6": "No",
    "Lamp 7": "No",
    "Lamp 8": "No",
    "Lamp 9": "No",
    "Lamp Quantity": "1",
    "Light Bulb Material": "Glass - Cooper Industries - Clear",
    Manufacturer: "Cooper Industries, Inc.",
    Mark: "50",
    "Number of Poles": "1",
    "OmniClass Number": "23.80.70.11.14.21",
    "OmniClass Title": "Spots and Tracklight Specialties",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Power Factor": "0",
    Rotation: "75.00°",
    "Schedule Level": "-1",
    Series: "Profile",
    Spacing: "305",
    "Spacing Left": "152",
    "Supply Voltage": "0",
    "Total Input Wattage": "0",
    "Track/Bswy Length": "1219",
    Type: "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    "Type Id": "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    "Type Image": "<None>",
    URL: "http://www.cooperlighting.com/",
    Voltage: "0",
    Volume: "381.4",
  },
  {
    ID: "767871",
    Name: "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr: Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    Category: "Lighting Fixtures",
    Level: "-1",
    Pbi2DGeometry:
      "1QAAAB+LCAAAAAAABAA1jU8LgjAchr/L7zzH/qqzU1QQ1EEk6CAetIYO1ha2AhG/e4vq9vLwPLz1DGVnTtNdQwEH35lKX0LreqsBQemNCw8o6vk7o8JyLBjPVglnWDFFYWn+3noc2ynKEWxNe9NBj1AQTBActevDAAUVmArJEVQ+tMF4FxGWGclUylmaKZErpRCczfVjs9hSIhHstemHeE4l5kLlCHZWv359kmMiUgQbb328c09rl+YNU+ZqpNUAAAA=",
    Pbi3DGeometry:
      "MwgAAB+LCAAAAAAABADtlF0LgjAUhv/LuZ5jOkmzq6igiy4igi6iC6NhA3NhK4jwvyd+9KGMo/ciiufx3atnbu/+Beuj3D6vAoLkHscE1kom+gbB/lXeQgBskh+QkS+xbMYmxSU/ITvUw6ZpGj7zsbZPXZvbxHI5dXzHIZZPmTsiHOOOR8fumNcc9THpGxx9b809yhn32/5Njn2PyQfpq8Urn1ZfTW7yMen7zhvGEf/OeqSvvv+xs49Jj/C+6wf16TY/+X6by/AitEghYJQRWIkk0ueq2CgdaqmSqtzJ0+fRUsjorKtiEYvHr3CmYpWWOVBs9iEYhmAYgmEIhr9gOLwBbNjJojMIAAA=",
    "Apparent Load": "0",
    Area: "486",
    "Assembly Code": "D5020",
    "Assembly Description": "Lighting and Branch Wiring",
    "Calculate Coefficient of Utilization": "No",
    "Coefficient of Utilization": "0",
    Cost: "0",
    "Default Elevation": "1000",
    "Design Option": "-1",
    "Diffuser Material": "SH_Aluminum, Anodized Black",
    "Electrical Data": "0 V/1-0 VA",
    "Elevation from Level": "0",
    Family: "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    "Family and Type": "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    "Frame Material": "SH_Aluminum, Anodized Black",
    Host: "Compound Ceiling : 3000 x 3000mm Grid",
    "Host Id": "-1",
    Image: "<None>",
    "Lamp 10": "No",
    "Lamp 11": "No",
    "Lamp 12": "No",
    "Lamp 2": "No",
    "Lamp 3": "No",
    "Lamp 4": "No",
    "Lamp 5": "No",
    "Lamp 6": "No",
    "Lamp 7": "No",
    "Lamp 8": "No",
    "Lamp 9": "No",
    "Lamp Quantity": "1",
    "Light Bulb Material": "Glass - Cooper Industries - Clear",
    Manufacturer: "Cooper Industries, Inc.",
    Mark: "51",
    "Number of Poles": "1",
    "OmniClass Number": "23.80.70.11.14.21",
    "OmniClass Title": "Spots and Tracklight Specialties",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Power Factor": "0",
    Rotation: "45.00°",
    "Schedule Level": "-1",
    Series: "Profile",
    Spacing: "305",
    "Spacing Left": "152",
    "Supply Voltage": "0",
    "Total Input Wattage": "0",
    "Track/Bswy Length": "1219",
    Type: "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    "Type Id": "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    "Type Image": "<None>",
    URL: "http://www.cooperlighting.com/",
    Voltage: "0",
    Volume: "381.4",
  },
  {
    ID: "767916",
    Name: "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr: Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    Category: "Lighting Fixtures",
    Level: "-1",
    Pbi2DGeometry:
      "1gAAAB+LCAAAAAAABAA1jcsKwjAUBf/lrmPIo2m9dSUqCLooRXBRumg1tIGYSI1CKf13I+ruMMxwqgmK1pzGu4YcDr41pb6ExnVWA4HCGxcekFfTd0ZFZlQhqtVCLCmKVMFc/731MDRjlCPYmuamgx4gZ5QROGrXhR5yjlRy5ARKH5pgvIuIqoxlmEqRZpggw4TA2Vw/togtZ4rAXpuuj+dcUiVVzHdWv379IqVCcklg462Pf+5p7Vy/Aaflcr/WAAAA",
    Pbi3DGeometry:
      "MwgAAB+LCAAAAAAABADtVMsKwjAQ/Jc9pyFppNV6EhU8eCgieBAPFUMN1EZqFIr47watr0rY9l5Kmuzs7iSbx6yvEG/VsjxKiPJzlhGItcrNCaL19TmECNjQfnAjH8TjjA0fP9vgtnmljYoiKW2uH9KAM048EVJf+AHxAttzQXqog4d04PfeOM7kSqjh+MwvR0gFE/2/CeowtiAHDVrYn6MiqhdWh508jvi2+4bgCH3DcKyo1qfYnMmVgOAtrw9K02R/7HubqOQgjSwgYpQRmMs8NfvKWGiTGKXzylyp3ds1kyrdm8qYZvLyHTjWmS6eOvB47J0wdMLQCUMnDD/CsLkDRm9majMIAAA=",
    "Apparent Load": "0",
    Area: "486",
    "Assembly Code": "D5020",
    "Assembly Description": "Lighting and Branch Wiring",
    "Calculate Coefficient of Utilization": "No",
    "Coefficient of Utilization": "0",
    Cost: "0",
    "Default Elevation": "1000",
    "Design Option": "-1",
    "Diffuser Material": "SH_Aluminum, Anodized Black",
    "Electrical Data": "0 V/1-0 VA",
    "Elevation from Level": "0",
    Family: "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    "Family and Type": "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    "Frame Material": "SH_Aluminum, Anodized Black",
    Host: "Compound Ceiling : 3000 x 3000mm Grid",
    "Host Id": "-1",
    Image: "<None>",
    "Lamp 10": "No",
    "Lamp 11": "No",
    "Lamp 12": "No",
    "Lamp 2": "No",
    "Lamp 3": "No",
    "Lamp 4": "No",
    "Lamp 5": "No",
    "Lamp 6": "No",
    "Lamp 7": "No",
    "Lamp 8": "No",
    "Lamp 9": "No",
    "Lamp Quantity": "1",
    "Light Bulb Material": "Glass - Cooper Industries - Clear",
    Manufacturer: "Cooper Industries, Inc.",
    Mark: "52",
    "Number of Poles": "1",
    "OmniClass Number": "23.80.70.11.14.21",
    "OmniClass Title": "Spots and Tracklight Specialties",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Power Factor": "0",
    Rotation: "75.00°",
    "Schedule Level": "-1",
    Series: "Profile",
    Spacing: "100",
    "Spacing Left": "200",
    "Supply Voltage": "0",
    "Total Input Wattage": "0",
    "Track/Bswy Length": "1219",
    Type: "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    "Type Id": "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    "Type Image": "<None>",
    URL: "http://www.cooperlighting.com/",
    Voltage: "0",
    Volume: "381.4",
  },
  {
    ID: "767917",
    Name: "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr: Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    Category: "Lighting Fixtures",
    Level: "-1",
    Pbi2DGeometry: "1gAAAB+LCAAAAAAABAA1jcsKwjAURP/lrtOQpM/Elagg6KIUwUXpotXQBmIiNQql9N+9oN3NDGc49QxlZy7TU4OCk+9MpW+hdb3VQKD0xoUXqHr+RUREQRMR55sIgxRZCkuzcttxbCeEcdib9qGDHkExygictevDAEpgY0wQqHxog/EOFKdpznKZxSLLZVJIKQlczX2lOUsJHLXpB5RzTtGIwMHqz/8fxVRmghPYeevR597WLs0XN903rNYAAAA=",
    Pbi3DGeometry:
      "MwgAAB+LCAAAAAAABADtVMsKwjAQ/Jc9x5CYqrWeRAUPHooIHsRDxaCB2kiNgpT+u6HWVyVsey8hITu7O8nmMZsMwp1a3c8SguQaxwRCrRJzgWCTPacQABvZBjn5IB3O2KgYbId8+0obp2l0t7ncpx4XnHREj/pet2cndNjvciJQB/do3+dvHGdyJVRwfOWXY0AFE/7fAlUY25CDBi3sz1ESVQurwk4eR3zTc0NwhL5mOFZU41usz+RKQPCGzwelqXM+9r9NVXSSRqYQMMoILGRyMMfSWGoTGaWT0lyr/ds1l+pwNKUxi+XtO3CiY50+daD47K0wtMLQCkMrDD/CsH0AdcFdTzMIAAA=",
    "Apparent Load": "0",
    Area: "486",
    "Assembly Code": "D5020",
    "Assembly Description": "Lighting and Branch Wiring",
    "Calculate Coefficient of Utilization": "No",
    "Coefficient of Utilization": "0",
    Cost: "0",
    "Default Elevation": "1000",
    "Design Option": "-1",
    "Diffuser Material": "SH_Aluminum, Anodized Black",
    "Electrical Data": "0 V/1-0 VA",
    "Elevation from Level": "0",
    Family: "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    "Family and Type": "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    "Frame Material": "SH_Aluminum, Anodized Black",
    Host: "Compound Ceiling : 3000 x 3000mm Grid",
    "Host Id": "-1",
    Image: "<None>",
    "Lamp 10": "No",
    "Lamp 11": "No",
    "Lamp 12": "No",
    "Lamp 2": "No",
    "Lamp 3": "No",
    "Lamp 4": "No",
    "Lamp 5": "No",
    "Lamp 6": "No",
    "Lamp 7": "No",
    "Lamp 8": "No",
    "Lamp 9": "No",
    "Lamp Quantity": "1",
    "Light Bulb Material": "Glass - Cooper Industries - Clear",
    Manufacturer: "Cooper Industries, Inc.",
    Mark: "53",
    "Number of Poles": "1",
    "OmniClass Number": "23.80.70.11.14.21",
    "OmniClass Title": "Spots and Tracklight Specialties",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Power Factor": "0",
    Rotation: "90.00°",
    "Schedule Level": "-1",
    Series: "Profile",
    Spacing: "305",
    "Spacing Left": "152",
    "Supply Voltage": "0",
    "Total Input Wattage": "0",
    "Track/Bswy Length": "1219",
    Type: "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    "Type Id": "Trck_BswySystms_Cooper_RSA_Profile Series_AR111 Closed Back Integral Xfmr",
    "Type Image": "<None>",
    URL: "http://www.cooperlighting.com/",
    Voltage: "0",
    Volume: "381.4",
  },
  {
    ID: "768442",
    Name: "Basic Wall: Interior - Partition",
    Category: "Walls",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACFjksLwjAQhP/LnmNo06QvT6KCoIcigofSQ0tDuxATqVEopf/dQOvr5G1nv2Fm8gGyCk/9VUIKe1NhZlTfGA0EMoPa3iDNh+l0Bj+gggV8uQhoIgSHkXwYYzSJGPvHROhHP+wrc2LFq3rVdWXv+t1jg+VFWtlB6lGPwEHqxrazOBpbWnSTJ3nG+o12EpvWlfghZTzmBLZKPmZzQmPOBIG1Ucbl6rtSY/EEcWIU0g8BAAA=",
    Pbi3DGeometry:
      "RwYAAB+LCAAAAAAABACdVF1LwzAU/S/3OQtJtjSmexI/EPRhqODD8KFjYQvURmoQxth/N2pXS9u0txLa9J6cnFNy7836CKuNfT68G0jh3m3sk8vtFgisnC38B6Tr4+9nWGbLMOBE/pAZZ2z58woPnF7P2y7LMjuEvUJQpeSCzOZUyzBrerEQkrRhIaniQhA+p0ow8W88It+FZcJVDXOqmUw6cIstEso00x16jSP5I66cSs71GLsh3kdvnMsQfFaJ4W31EVckPOEgm9mL5XrSv0REIucVqyNcjqaV17AlogEGM4quC4zpxPaK9cU4jnJFVlGPDK7WYzoRX0RG2jpTfXv5Ef1wI1/b7M14U0LKKCPwYIqd31fBo/OZt66owhe7rZfujN3tfRXc5OazSbxyuQuCoG6/R7j4vwD9E0BzRwYAAA==",
    Absorptance: "0.1",
    Area: "14",
    "Assembly Code": "C1010145",
    "Assembly Description": "Partitions - Drywall w/ Metal Stud",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Coarse Scale Fill Color": "8421504",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Interior - Partition",
    "Family and Type": "Interior - Partition",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Length: "2880",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Wood - Stud Layer",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Line",
    "Top Extension Distance": "0",
    "Top is Attached": "Yes",
    "Top Offset": "0",
    Type: "Interior - Partition",
    "Type Id": "Interior - Partition",
    "Type Image": "<None>",
    "Unconnected Height": "3000",
    Volume: "1.62",
    Width: "120",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "771513",
    Name: "Stair Section",
    Category: "Views",
    "Angled Joins": "No",
    "Calculation Rules": "Callout Head w 3mm Corner Radius",
    "Color Scheme": "Background",
    "Created By": "No",
    "Crop Region Visible": "Yes",
    "Decimal Degress": "None",
    Department: "Independent",
    Description: "-1",
    "Desired Stair Height": "Fine",
    "Detail Line": "1",
    "Dimming Lamp Color Temperature Shift": "Architectural",
    Dishwasher: "Normal",
    "Facucent Drilling": "Section",
    Family: "Section: Building Section",
    "Far Clip Active": "26920",
    "Far Clip Settings": "0",
    "Height Offset From Level": " 1 : 50",
    "Neutral Rating": "Yes",
    "Nominal Width": "Stair Section",
    "Parent View": "Show Original",
    Perimeter: "Working Drawings",
    "Phase Demolished": "Show All",
    Rotation: "None",
    Scale: "50",
    "Schedule Level": "None",
    "Section Shape": "Section Head - Filled, Section Tail - Filled",
    "Sheet Issue Date": "Elev./ Stair Sections",
    "Sheet Name": "A105",
    "Show Drop Panel": "By Discipline",
    Summary: "No",
    "Tumble Dryer": "Building Section",
    "Type Comments": "Building Section",
    "Vertical Scale": "Stair Section",
    "View Range": " 1 : 50",
    "View Scale": "-1",
    "View Template": "-1",
  },
  {
    ID: "778316",
    Name: "Photovoltaic-Panel-SolarWorld-SunModule-(235-240): SunModule SW 245 Silver Mono - 10 Deg. Angle",
    Category: "Electrical Equipment",
    Level: "Level 1",
    Pbi2DGeometry: "zgAAAB+LCAAAAAAABAA1zV8LgjAUBfDvcp/X2B91zp6igqAeRIIexIdZQwdrC1uBiN+9SfV2Ofd3OPUEZWvO40NDAUffmkpfg3Kd1YCg9MaFJxT19D0jWWUEUybzNU1wljMKc/N3m2FQY8Qx2Bl110EPUBBMEJy060IPRYpTBJUPKhjvll+WpELQnHHGhaQ8kQgu5rZQjlm0B226Ps5SzATJEeytfv/KHGdExmjrrY877mXt3HwAcyaRqc4AAAA=",
    Pbi3DGeometry:
      "tykAAB+LCAAAAAAABACtWV1rG1cQ/S/7LC/3+8N5Cm1KoX0IbaEPwQ8OEYnAsYorCiH4v/d+SJY2mjO7sxhhYx1dnTl3Zu7M3PWH78P7j7u/vv2zHW6H3/Yfd3/uH3afhs3wfr97PPw73H743v8sH6s35TU8b87IjVbqTftVfobnu9PX3j493X8r373xfswxxo32YzAmbOwYstWbGx9GlZ1ruArmjMcx+422o3Y2za8G7EGN1tuCpzFpnyfs1obKr0zUM1aDGY3KdqNDZXNzGhG3UGPFo9IVz/ZyPVAD1yMfID2I34yVtsKFbW639Oo12n/AVU7knjp+zc+vB/xEnp34p7tirV7lB6+R5hYqJKLKaIGr0f6RGpr9OjeYnaLVQuWozoD1XIYtxGdPtyizUYYtQefqBn0ihbFYiK+oGZB9eaz5HEB2UVdBZwxm+wJ0TdeT1pGl+Iqet6bCLsRnOwTqkhQ/jN1ynO+eZb2Ppq73uuSSG6MzueMm5ob7+fLAjUUqNjk+WVPpffS8WecaHqJZkGhh1MY2uz5Ee8mDcBVt21aw1k70ILtIP+AR60F+QHapsDAnH22LxJkwSrKBMYu8j3DSC4xd4E3o/YUFk3UDMvtDnXajnusbKZVaUfFsgxh3peREootd2iWqcipOrn22rI7RQPyFBeET9kstZCeAygmOFUrA/mX+Wmh31pML54TZ/GD4F3TbuVyS5uSszZmo4miQFmtHjaVzlY7qlJXNgyfPQnTCfFLCWDS+7iiMJoU84bnEV8wgJH6pB9gFu0IqETvCgXdmPYw8JvXk7E6BTRQ95PUlGuefDCCrKMeWRGOJepFdNTqX+zxoLnpWnRNzzg3PFy1XcP874c4o13jCFEZmq7yKJ+Mn9HUiqLizEzXJNqsxtvw40yDcl9rTp980oUdm0W7ResQPcOAdoTOhVaF3UFCkMURmQQwBDBJQnLCAHkVQmgmk2VIVbNbtfOpca5TVZYJs5zD7Xi6M9xU3OvRtqeAbT/mg4Cl6zawH/K3H2tY0vdUTem26zOhr801JMWbrKBv6JO6D0mc5SCbil8mssAt9+lCXy4EcuB54AalB9HXOV/3eEXyeeI3aLVq/Rj4aCPtAFJVraDrdoVVq7DG6loIGLgbUNc/SsY05kybk8OJ+bbQdB9tLhcvpRQuQiMiFIsE4QGvBUxK5fyQFkINygHbKVS2JdlRriNVLbxuTpCOSlDvaoqRmMgw++qAOGVM7hK6HpVJ66AUnBx9XUCcpmKlj9GFFxVx4iAH8Kh2EabCCix19QIRdkWnGqC7ROCwedDNmmuVVxoi1gD1xRm3HQ6i4MeUa0rPA6Z4FbX1M5vhcPIc+rrlGP4NXmSUULYLJn/mBXWGuwkMmcCQszaRwrrEslQI3L3SWbH5gYCLQ0sSQDRAcTGTRqmwEMRWeJTIHkMx6xlTuh6zeya3Sp+FbHx9T1ytL8u5UlVy/yZT73jxeT7b1/WQnd6anrUp9ySaZIFm5SkDJX5X0AKfcIPPaqrQHOBFzWYa8WhEGGSVPTFGN53AyE5BM2XTETSSSKYC5epeodBrb5sPgjv90CqYXwKD9Ga80ptO4FnKtHYSbGHf0TXvYcsSBVW6EoXhkavC9WzpjUOTIYRwObt3C4Zmihx7m8Fd61AIjS2UChy9+EnW3GX7e3X/dHrZPw60a1Wb4ffv4+fDl+OaP/eH+sNs/Ht/+vfv08tGv293nL4fjm3cP2/8uF/60f9gXwiH+Ul/D893/bgofa7cpAAA=",
    "Apparent Load Phase A": "0",
    "Apparent Load Phase B": "0",
    "Apparent Load Phase C": "0",
    Area: "2",
    "Assembly Code": "D5090900",
    "Assembly Description": "Misc. Other Electrical Systems",
    "Backsheet Material": "Metal - SolarWorld - BackSheet - White",
    "Branch Circuit Apparent Load Phase A": "0",
    "Branch Circuit Apparent Load Phase B": "0",
    "Branch Circuit Apparent Load Phase C": "0",
    "Branch Circuit Current Phase A": "0",
    "Branch Circuit Current Phase B": "0",
    "Branch Circuit Current Phase C": "0",
    "Circuit Naming": "-1",
    "Circuit Numbering Option": "Default",
    Cost: "0",
    "Current Phase A": "0",
    "Current Phase B": "0",
    "Current Phase C": "0",
    "Default Elevation": "0",
    Description: "SolarWorld SunModule Plus  Photovoltaic Panel",
    "Design Option": "-1",
    "Distribution System": "None",
    "Electrical Data": "Junction Box 31 V/1-245 VA",
    "Elevation from Level": "1100",
    Enclosure: "Framed",
    Family: "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Family and Type": "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Feed Through Lugs": "-1",
    "Feed Through Lugs Apparent Load Phase A": "0",
    "Feed Through Lugs Apparent Load Phase B": "0",
    "Feed Through Lugs Apparent Load Phase C": "0",
    "Feed Through Lugs Current Phase A": "0",
    "Feed Through Lugs Current Phase B": "0",
    "Feed Through Lugs Current Phase C": "0",
    "Frame Material": "Metal - SolarWorld - Support Framing - Silver",
    "Front Tempered Glass Material": "Glass - SolarWorld - Tempered Glass",
    "Ground Bus": "No",
    Height: "38",
    Host: "Surface",
    "Host Id": "-1",
    Image: "<None>",
    Length: "1676",
    Mains: "0",
    Manufacturer: "SolarWorld",
    Mark: "25",
    "Max Number of Single Pole Breakers": "0",
    "Maximum Power (STC)": "245",
    "Maximum Power Point Current (STC)": "8",
    "Maximum Power Point Voltage (STC)": "31",
    "MCB Rating": "1",
    Model: "SunModule Plus SW 245 mono",
    Mounting: "10Deg Wedge",
    "Neutral Bus": "No",
    "Neutral Rating": "0.00%",
    "Number of Phases": "0",
    "Number of Wires": "0",
    "Offset from Host": "0",
    "OmniClass Number": "23.75.10.27.21",
    "OmniClass Title": "Photovoltaic Collectors",
    "Open Circuit Voltage (STC)": "38",
    "Panel Name": "Solarworld Sunmodule Plus",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Product Documentation Link": "http://www.solarworld-usa.com/system-designers/~/media/Global/PDFs/sunmodule-plus-mono.ashx",
    "Product Page URL": "http://www.solarworld-usa.com/system-designers/data-sheets-new-2.aspx",
    "Short Circuit Current (STC)": "8",
    "Solar Cell Material": "Glass - SolarWorld - Solar Cell - Black",
    "Solar Panel Angle": "10.00°",
    "SubFeed Lugs": "-1",
    "Total Connected": "0",
    "Total Connected Current": "0",
    "Total Demand Factor": "100.00%",
    "Total Estimated Demand": "0",
    "Total Estimated Demand Current": "0",
    Type: "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Type Id": "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Type Image": "<None>",
    URL: "www.solarworld-usa.com",
    Volume: "0.07",
    Wattage: "245",
    Width: "991",
  },
  {
    ID: "778420",
    Name: "DC_Tankworks_PLM_5000L: 5000L 3500x900x1860",
    Category: "Plumbing Fixtures",
    Level: "Level 2",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABAA1jcsKwjAURP/lrmNI0ndciQqCLkoRXJQuUr20gZhIjUIp/Xcj1t0w5zBTT1C2+jw+ECQcXasrvHplO4NAoHTa+ifIevrFoCSMZjkv1quM8iwWMDd/bTMMagxuKHZa3dHjAJJRRuCEtvM9SM5pEucpgcp55bWzC7/o2xdHlIk8J3BA3fXhK6U8SgSBvcH3oq9iWggeEdg648K8fRkzNx+5ZiLOxAAAAA==",
    Pbi3DGeometry:
      "DwgAAB+LCAAAAAAABADtlMsKwjAQRf9l1mlItG9XooILFyKCC3FRMWigNlKjUMR/N2h8EIlp15aS0jm9uc2kmVleYLrm8+rAIC1OeY5gKnghj5AuL49HSIH01AVX9CYeJaR3v6kB19VzWr8ss0rN9X0c0Y6PvBgnURwhz8dJh3ZREOI4oIGdB7gbJm/u9LHpDe78ruYUK5p82ZvYsRqLiyspk2sbMycT21ws8qY75uAO+5pyR04Nf19dG4v8N252ZFwmdbZFVdeQZ3smWQkpwQTBhBVbudPBTMhMclHocME3r1djxrc7qYNRzs6fwoHIRfmo+ntpt22gbQNtG/jrNrC6AVGPZDwPCAAA",
    Area: "12",
    Capacity: "5000L",
    Cost: "0",
    CWFU: "0",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-4500",
    Family: "5000L 3500x900x1860",
    "Family and Type": "5000L 3500x900x1860",
    Height: "1860",
    Host: "Surface",
    "Host Id": "-1",
    HWFU: "0",
    Image: "<None>",
    "Inlet Left": "Yes",
    "Inlet Right": "No",
    L: "3700",
    Length: "3500",
    Manufacturer: "Tankworks",
    Mark: "33",
    Model: "5000L 3500x900x1860",
    "Offset from Host": "300",
    "Outlet Left": "Yes",
    "Outlet Right": "No",
    "Overflow Left": "No",
    "Overflow Right": "Yes",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    R: "550",
    "System Classification": "Other",
    "System Type": "Undefined",
    Tank: "Tankworks - Colorbond® - Pale Eucalypt®",
    Type: "5000L 3500x900x1860",
    "Type Id": "5000L 3500x900x1860",
    "Type Image": "<None>",
    URL: "http://www.tankworks.com.au",
    Volume: "5.54",
    W: "1100",
    WFU: "0",
    Width: "900",
  },
  {
    ID: "778575",
    Name: "DC_Tankworks_PLM_5000L: 5000L 3500x900x1860",
    Category: "Plumbing Fixtures",
    Level: "Level 2",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABAA1jcsKwjAURP/lrmNImj7SuhIVBF2UIrgoXaR6aQMxkRqFUvrvRqy7Yc5hpp6gbPV5fCAUcHStrvDqle0MAoHSaeufUNTTLwYlYTSTPF+vBOUyS2Fu/tpmGNQY3FDstLqjxwEKRhmBE9rO91BwTpNYpgQq55XXzi78om9fLCiLpCRwQN314SulXCQRgb3B96KvYppHXBDYOuPCvH0ZMzcfawy23cQAAAA=",
    Pbi3DGeometry:
      "DwgAAB+LCAAAAAAABADtlF0LgjAUhv/LuV5j86PSrqKCLrqQCLqILoxGDcyFrSCk/96w9cFiTa8TmXoe37165s5ZlZBs+OJ6ZBDn5yxDkAieyxPEq/JxCzGQgTrght6kQwkZVCc14LZ+ThsWRXpVc4MA96gXoE6Ao8ij1dWjPgq7uB/S0M4p9vu+9+JOH5ve4M73ak6xotGXvYkdX2NxcSVlcm1j5mRim4tF3nTFHNxhX1PuyKnh76trY5H/xs22jMukzrKo6hrz9MAkKyAmmCCYsXwn9zqYC5lKLnIdLvn29WjK+G4vdTDJ2OVTOBKZKB5VX5V22wbaNtC2gb9uA+s7KLa1KA8IAAA=",
    Area: "12",
    Capacity: "5000L",
    Cost: "0",
    CWFU: "0",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-4500",
    Family: "5000L 3500x900x1860",
    "Family and Type": "5000L 3500x900x1860",
    Height: "1860",
    Host: "Surface",
    "Host Id": "-1",
    HWFU: "0",
    Image: "<None>",
    "Inlet Left": "Yes",
    "Inlet Right": "No",
    L: "3700",
    Length: "3500",
    Manufacturer: "Tankworks",
    Mark: "34",
    Model: "5000L 3500x900x1860",
    "Offset from Host": "300",
    "Outlet Left": "Yes",
    "Outlet Right": "No",
    "Overflow Left": "No",
    "Overflow Right": "Yes",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    R: "550",
    "System Classification": "Other",
    "System Type": "Undefined",
    Tank: "Tankworks - Colorbond® - Pale Eucalypt®",
    Type: "5000L 3500x900x1860",
    "Type Id": "5000L 3500x900x1860",
    "Type Image": "<None>",
    URL: "http://www.tankworks.com.au",
    Volume: "5.54",
    W: "1100",
    WFU: "0",
    Width: "900",
  },
  {
    ID: "800280",
    Name: "Photovoltaic-Panel-SolarWorld-SunModule-(235-240): SunModule SW 245 Silver Mono - 10 Deg. Angle",
    Category: "Electrical Equipment",
    Level: "Level 1",
    Pbi2DGeometry: "zQAAAB+LCAAAAAAABAA1zVELwiAUBeD/cp9NdLp09hQVBPUwRtDD2IOVbIJpLAvG2H/PUb0d7vkupx6hvNjT8DCg4BAutjLXqH3rDCAog/XxCaoevzGRRc6xlAVfUYIFYxSm5u/Wfa+HhNNha/XdRNODIpggOBrfxg5UjnMEVYg62uDnbslzIajMWMZEQRkvEJztbaYMZ8nujW27NEtxJohEsHPm/XtmmHKBYBNcSDP+5dzUfAC0SY0vzQAAAA==",
    Pbi3DGeometry:
      "SCkAAB+LCAAAAAAABACtWVtrW0cQ/i/n+eSw94vzFNqUQvsQ2kIfgh8cIhKBYxVXFELwf+9eZElHnm93RxhjI30afTM7MzuX448/pg+ftn99/2cz3Uy/7T5t/9zdbz9P8/Rht33Y/zvdfPxRX6aPxdv0Mz3NJ+SNFOJt+ZN+p6fb56+9e3y8+56++8aKxWuvZykXl17MelFamDnjwZoC2/TxEVaLF9HNcZHRhK40IreLlDrJmyU4f07uolaJXPgguzrdEl2cpVqMMLYrDbiZFiZYxZDhGM7FgS1IHLAjYwC7X0SwPuM6rP1FHhWJ821f49J44kgVveRuyQLiy9Sq6IvDtPRdpkRLFhCzjHsRx5YZQJhmBmbQzJd50DwgLcw0GZUSUhwn0hDcv8Cc9AVeGYU7SpE8MxYj6HW1geYejXM7/LDygpZB5T1K8BH0qobGKRlj6FXNjFk/B9Bu0Qdtj6BGxW8E7TXCIF3I4tYFNZtFBSFrigVvC43wA128gSd1GdZGZ/r4bCRQG4QuuFc60imlVnDQVasMekWDcK3rqYIxK3OAWmQ9ouGag5xPq0UxQc5BvkSHRSFkpgLUi7wGcOQFpBalFHI+8BoNQ9+TWi9Lse81hXTEVKmM8UzUG9vUh2qujT7DKmgM+x684j5agrYC0mzEwTIE+ZrlqBGNPf8NtfxeLiCVI92zlzqc7BtS2AskiAGhMA1S2trSKa25ZqTzXXzNf7CmoVdGWXh0WNGsYN5YAeCTKUAlOhElDsixTuSWMfcCd/G82D8pUkrGDu/xIzb2Ew8lDOnJwXh0TWcptYsSUZd5z583pjQH2mjL4mTO2+rwFnfCKyr9ai1DWoVLlSfL515/Ji+iikU+GrmyxihfcBVWxgP4ONu6uGIHWtGZoDzghzjpG54nITfLMzALWNED5Ch4MKgg9bipCvWiJGOmAa03XbUYaj3wIteJYBNdwa1VFXeu4CFWHudksTMkQbMYqUxDHvGn3ipVmQiEUSt6r6qZKmVIpvehoTaNquowZ0upTjiSR/xMM/Nk4MrQ4c6lkTVAHJAjWxB7HuMreuEx8qS0NNtyOP3VgUnJ0hS0PZBLUclVsOUupKsBxQF5cotRNcNiWcGO7HAbp5Tmi1DuZRQinmAkDtiZNqIRABjTmBhIemANYEelABy10VyZtqNCQ8oPLhhnexuRp41rzUhrvLSjJxovLxisGFyfo/LIuuysGwOvKSqNFIyLF7ymqIDzri/EX6VvNNoqd48jE5XbDxttGBUmEselg1QLc4HMHK4x6FCN5pxGqQTL8rQrfccdUkHXtFcmh1yr40Tm6qQWne3j2cr8NC2HMLoTP1DLTNhGT2R4Etdm0vRWXxk3BjiA6S/mDNHCqWgzk4M5RTRgKpWuSUkQVuZ9IiOC1OZ7lpyQ71nZrIIOz7O3PDyELiuLjvJ5RdB1lQnO9PF8vXV9UuGjPfEDtVxnwjxjZWujGpDGs7MewZQLmB67IucBTsabmR6vVYdROl2Rlqw638DJoCC9zEGpMZmwJgG8eDtbWQqJUM8hV/U/R1K5E55JZCnSwhZuExyGsynmYEo4wbTKxgRDkfAswRs3c8CgyJGzWjjYuZkTNElPuxejr/R4BYSUCF0DHn7ydDtPP2/vvm32m8fpRixinn7fPHzZfz28+WO3v9tvdw+Ht39vPx8/+nWz/fJ1f3jz/n7z37ngT7v7XSKc/C/5Z3q6/R+xvxoYSCkAAA==",
    "Apparent Load Phase A": "0",
    "Apparent Load Phase B": "0",
    "Apparent Load Phase C": "0",
    Area: "2",
    "Assembly Code": "D5090900",
    "Assembly Description": "Misc. Other Electrical Systems",
    "Backsheet Material": "Metal - SolarWorld - BackSheet - White",
    "Branch Circuit Apparent Load Phase A": "0",
    "Branch Circuit Apparent Load Phase B": "0",
    "Branch Circuit Apparent Load Phase C": "0",
    "Branch Circuit Current Phase A": "0",
    "Branch Circuit Current Phase B": "0",
    "Branch Circuit Current Phase C": "0",
    "Circuit Naming": "-1",
    "Circuit Numbering Option": "Default",
    Cost: "0",
    "Current Phase A": "0",
    "Current Phase B": "0",
    "Current Phase C": "0",
    "Default Elevation": "0",
    Description: "SolarWorld SunModule Plus  Photovoltaic Panel",
    "Design Option": "-1",
    "Distribution System": "None",
    "Electrical Data": "Junction Box 31 V/1-245 VA",
    "Elevation from Level": "959",
    Enclosure: "Framed",
    Family: "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Family and Type": "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Feed Through Lugs": "-1",
    "Feed Through Lugs Apparent Load Phase A": "0",
    "Feed Through Lugs Apparent Load Phase B": "0",
    "Feed Through Lugs Apparent Load Phase C": "0",
    "Feed Through Lugs Current Phase A": "0",
    "Feed Through Lugs Current Phase B": "0",
    "Feed Through Lugs Current Phase C": "0",
    "Frame Material": "Metal - SolarWorld - Support Framing - Silver",
    "Front Tempered Glass Material": "Glass - SolarWorld - Tempered Glass",
    "Ground Bus": "No",
    Height: "38",
    Host: "Surface",
    "Host Id": "-1",
    Image: "<None>",
    Length: "1676",
    Mains: "0",
    Manufacturer: "SolarWorld",
    Mark: "39",
    "Max Number of Single Pole Breakers": "0",
    "Maximum Power (STC)": "245",
    "Maximum Power Point Current (STC)": "8",
    "Maximum Power Point Voltage (STC)": "31",
    "MCB Rating": "1",
    Model: "SunModule Plus SW 245 mono",
    Mounting: "10Deg Wedge",
    "Neutral Bus": "No",
    "Neutral Rating": "0.00%",
    "Number of Phases": "0",
    "Number of Wires": "0",
    "Offset from Host": "0",
    "OmniClass Number": "23.75.10.27.21",
    "OmniClass Title": "Photovoltaic Collectors",
    "Open Circuit Voltage (STC)": "38",
    "Panel Name": "Solarworld Sunmodule Plus",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Product Documentation Link": "http://www.solarworld-usa.com/system-designers/~/media/Global/PDFs/sunmodule-plus-mono.ashx",
    "Product Page URL": "http://www.solarworld-usa.com/system-designers/data-sheets-new-2.aspx",
    "Short Circuit Current (STC)": "8",
    "Solar Cell Material": "Glass - SolarWorld - Solar Cell - Black",
    "Solar Panel Angle": "10.00°",
    "SubFeed Lugs": "-1",
    "Total Connected": "0",
    "Total Connected Current": "0",
    "Total Demand Factor": "100.00%",
    "Total Estimated Demand": "0",
    "Total Estimated Demand Current": "0",
    Type: "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Type Id": "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Type Image": "<None>",
    URL: "www.solarworld-usa.com",
    Volume: "0.07",
    Wattage: "245",
    Width: "991",
  },
  {
    ID: "800325",
    Name: "Photovoltaic-Panel-SolarWorld-SunModule-(235-240): SunModule SW 245 Silver Mono - 10 Deg. Angle",
    Category: "Electrical Equipment",
    Level: "Level 1",
    Pbi2DGeometry: "zAAAAB+LCAAAAAAABAA1zV8LgjAUBfDvcp/X0G3ujz1FBUE9iAQ9iA9aQwdrC1uBiN+9SfV2uOd3OdUERWvO40NDDkffmlJfQ+M6qwFB4Y0LT8ir6RsjWTGFOVNrjoVkBOb6rzbD0IyRxsPONHcd9AB5ghMEJ+260EOe4QxB6UMTjHdLx1kmRCoJJVSolDKF4GJuC6WYRHvQpuvjaIqJSCSCvdXv3zPBXEiKYOutjzvuZe1cfwDYdLL5zAAAAA==",
    Pbi3DGeometry:
      "xCgAAB+LCAAAAAAABACtWF1rVEkQ/S/3+Xrp74/4tOyuCPogKvggeYg46EA2I3EQRPLf7e47H/cmdbq7ZiUoyUnNqdNV1VXV+fhrePNp+/7nt81wNbzafdq+291uPw/j8Ga3vdt/H64+/pq/Tb8Wz9PX8DCekWdSiOflv/RveLg+fuyv+/ubn+mzz4ydTHRx9JNXJoxq8k76McNOapdhEcwZ9pNxUY12UsbGpjXgjlPwepRiijLIFbdVIXFLlVw0XFqZSIMbQ/qQdU2BgJsnMMEhmlHKSeiFOZICzBE7rQWQJzgYqzOsHwWLOCewvkD4Gnc+aOJAM/yEvWoNyR+X1ol8faK6z8dVUbUG3EyFT/JZlYKsATeSAsgfV0X9nLQ1WzhoK6R1pbL68OZ95hQ0Lq4uuNktwF1kJqMHvqRZIO7ORNfzD/swmB9k9eMq74EvGnDcBtIFXzLg+F21B27OAzAOKW7YDrvg1oy03plk7WTUo56ClGaGjZcZtqE93SFslctKXLAmcytX9eh0hr03oKj0CjYqe3QumiUJgG3U+TReW7sUQnsEqkkKpgxwctohnQEQD3QWGkb5YiUduaRjTaPkyZE/OnooBaBuQPjok5Mu1y1XT6rV/EU6V4KjDUw4cWcBNZd0b7VZcLL20SB4QQLgJfdSCWjnQDdNwlQCDs8KVYfLdgQ75nu7IBB3z5xslg+vBtsu27lEaSBc5oEYrUwD0QrLXeGOgcXwkvuoBLv0PvgE6xDlimQBc3cHEl4qoV2i4wCBgBvAdEw6AgtCxYtg+5TIJUgaiHdbYMfbHbgEVdVOQ4fufpdphYsuxLLDqeU8SrhM58t4tPo0R7vfaCc86ugKjVtvpchtUKnXZDyY9XJrlS14akYLOVGosoEGX+rirB7g54V1RY6cosMie5qdRFFguIEE7My4wCpgpg/GnU4fyipde9xSBT5R8phFQHnNfcCG0geUzANNh/ShAsv0TYZ9vtk6xWkmUdYXEm0yHo320ByQ57HoVRn+tig5k2s1K/ShcCe90GdeTENZp51T+gwjc5qdKTGPf1tWC7m0BlKANc2NlADuBOdKz/A6VlQIaWO2arTflYVIelVGgPMHbi8Kt4+uFJtw2JrmzhERslSVsStq8KImHOaqV3NDONwpUbGmqTnqwIQHOir7AHFwkAFwRNBl6CPiDsZTDVoJFZGu98LqIfa0KCu3l1HCsKBolLhJuC2wYg26H+tG918NfBdB56Ng3J3AbUS9mXdLAfz/50FlTLIeYWRZ8gZcZajSfYdoGbg3kDHBuScqhSME7ROVMZtWoQS7kGEVfTwkXuuS+Dk19rRP2XnPMoW8jheF5WVhjHBnduCUV5uVAdcbwUrXJWRXZkW3DnB0ZqB4m0AFJlLMKwjeLlCBqaq6oAhBMhl3h0oD8pjvVDp9vlMhe9QuHtfluTva/NCJSh8Xej0/OrS3TbzcY+VLwxP2TA58MmOIC4tRnZVbTyjn1ziAieMzg8WvcRomsswqiT/TZWFlseuQ0cMrMJUI5JS361QWDMZYrzyKlZn7h3YlYFofE62KlkR6QjOJLD3YugxrHyOEixI9Kyl//DhYA5eVfYRiYUmpvIl5awPFTYcKo/SbmLf9EtQokzX8z/zdA2bzadpqcO/fg67H4Z/tzX+b/eZ+uBKTGIfXm7sv+6+HH97u9jf77e7u8OOH7efTr15utl++7g8//Hu7+bE0/Ht3u0uEg3+Rv4aH699dWSUUxCgAAA==",
    "Apparent Load Phase A": "0",
    "Apparent Load Phase B": "0",
    "Apparent Load Phase C": "0",
    Area: "2",
    "Assembly Code": "D5090900",
    "Assembly Description": "Misc. Other Electrical Systems",
    "Backsheet Material": "Metal - SolarWorld - BackSheet - White",
    "Branch Circuit Apparent Load Phase A": "0",
    "Branch Circuit Apparent Load Phase B": "0",
    "Branch Circuit Apparent Load Phase C": "0",
    "Branch Circuit Current Phase A": "0",
    "Branch Circuit Current Phase B": "0",
    "Branch Circuit Current Phase C": "0",
    "Circuit Naming": "-1",
    "Circuit Numbering Option": "Default",
    Cost: "0",
    "Current Phase A": "0",
    "Current Phase B": "0",
    "Current Phase C": "0",
    "Default Elevation": "0",
    Description: "SolarWorld SunModule Plus  Photovoltaic Panel",
    "Design Option": "-1",
    "Distribution System": "None",
    "Electrical Data": "Junction Box 31 V/1-245 VA",
    "Elevation from Level": "816",
    Enclosure: "Framed",
    Family: "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Family and Type": "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Feed Through Lugs": "-1",
    "Feed Through Lugs Apparent Load Phase A": "0",
    "Feed Through Lugs Apparent Load Phase B": "0",
    "Feed Through Lugs Apparent Load Phase C": "0",
    "Feed Through Lugs Current Phase A": "0",
    "Feed Through Lugs Current Phase B": "0",
    "Feed Through Lugs Current Phase C": "0",
    "Frame Material": "Metal - SolarWorld - Support Framing - Silver",
    "Front Tempered Glass Material": "Glass - SolarWorld - Tempered Glass",
    "Ground Bus": "No",
    Height: "38",
    Host: "Surface",
    "Host Id": "-1",
    Image: "<None>",
    Length: "1676",
    Mains: "0",
    Manufacturer: "SolarWorld",
    Mark: "40",
    "Max Number of Single Pole Breakers": "0",
    "Maximum Power (STC)": "245",
    "Maximum Power Point Current (STC)": "8",
    "Maximum Power Point Voltage (STC)": "31",
    "MCB Rating": "1",
    Model: "SunModule Plus SW 245 mono",
    Mounting: "10Deg Wedge",
    "Neutral Bus": "No",
    "Neutral Rating": "0.00%",
    "Number of Phases": "0",
    "Number of Wires": "0",
    "Offset from Host": "0",
    "OmniClass Number": "23.75.10.27.21",
    "OmniClass Title": "Photovoltaic Collectors",
    "Open Circuit Voltage (STC)": "38",
    "Panel Name": "Solarworld Sunmodule Plus",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Product Documentation Link": "http://www.solarworld-usa.com/system-designers/~/media/Global/PDFs/sunmodule-plus-mono.ashx",
    "Product Page URL": "http://www.solarworld-usa.com/system-designers/data-sheets-new-2.aspx",
    "Short Circuit Current (STC)": "8",
    "Solar Cell Material": "Glass - SolarWorld - Solar Cell - Black",
    "Solar Panel Angle": "10.00°",
    "SubFeed Lugs": "-1",
    "Total Connected": "0",
    "Total Connected Current": "0",
    "Total Demand Factor": "100.00%",
    "Total Estimated Demand": "0",
    "Total Estimated Demand Current": "0",
    Type: "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Type Id": "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Type Image": "<None>",
    URL: "www.solarworld-usa.com",
    Volume: "0.07",
    Wattage: "245",
    Width: "991",
  },
  {
    ID: "800329",
    Name: "Photovoltaic-Panel-SolarWorld-SunModule-(235-240): SunModule SW 245 Silver Mono - 10 Deg. Angle",
    Category: "Electrical Equipment",
    Level: "Level 1",
    Pbi2DGeometry: "zQAAAB+LCAAAAAAABAA1zV8LgjAUBfDvcp/X2D+d2lNUENSDSNCD+DBr6GBtYSsQ8bs3qd4O9/wup56gbM15fGgo4OhbU+lrUK6zGhCU3rjwhKKevjGSlRBYkCxdM5zxhMPc/NlmGNQYbTzsjLrroAcoCCYITtp1oYciwQmCygcVjHdLl4pESpoxzrjMKRc5gou5LZRjFu1Bm66PqxQzSTIEe6vfv2eGKcklgq23Pu64l7Vz8wGsZVSYzQAAAA==",
    Pbi3DGeometry:
      "qycAAB+LCAAAAAAABACtWdlqHEcU/Zd+bje1V7X8FLIQSB5MEsiD0YOMB3tA0QRlCBijf09VzdatOaemLjFCSx9dnXvr7tV6/3V492H7x5e/N8Pd8Mvuw/b33eP24zAO73bbp/0/w937r4cf86/V2/wxvIwX5I1W6m39kj+Hl/vTn333/PzwJf/tG6cm44Mf7RSjn0cz6dmOBbXRmoL62Z9RMxmT0qgnM8cbopjWTcGaMIZpDrNZ0mrjMq1OyraVhcmlZEY3eRViWxSzSuzKqJvHOKm0EMUWQFHMii3AtGEKKvO6yc1rz4CTYVmZuStQZWeCQxzgK96mNKa+ypwT9auDNDW+jn1TmFCLzLuKX8sOIkyosR2Y+SoJmick0kKjcaeAwjSZOtB2ofYmLk2jPrjVAXChCR3fBYu7ACHuDWkr0qyh4vYPE5ymcgcqnUvCxtAHSyeTuE12we3OjicZIqYdrg9uDjlrQxYNUbn8zTiTDmixNTOomwORoilUG2yoxD66ljpj82PK9qEEcgvUKVOVGeWXBAS23tRjpBBWRgB1zF7MIDQDHppphK7H3oB+Q4fDq6MgyFAT8S6GyXGJOugx5l7sG4xi7wJ1r9toaHZzHYwpncaFWYhGFdFICc2OGdNcQKs8RUMbXdJeTEDKmLmYQWIDPLDMOx3qbjitYzi3Q094b0+6ZpJI0uy2rhtRIz5H2sLkvYtlnPmQhLtWaKJr3qMRTJ23yRYKp/SSYoWKBj5EL0ZAdeQcUJYQM33YFz3uxB6S+K19PKINRgn7uMeydlqRnMBO6/L8DYv79bk8npIve1ap3PM0yetXTLFcUdxy/nXdk07gnGdWRvVqYSTafMrtIwtbv9o5tdFFeA52ZUPQc4GtMiuLCXzeI/WCmihEByGikJag0BUCrxFakR9YnCVhYhpJnAiMM0uYh5gbx0oQbKgu17WOta5jKeukgz5UVHS+oqnwJqPDgSN5W0/iy+5mo29IY+o8+KyuU1oFt6KedSrmmZwImTrlGU415j3RHVZbbe0FJtKEW2Rfmde+rgFhIUzswMKEGZtBmPOWPs+2wq/chE5IpKVWkw3ssL4YGyuajsxlnyl3CxVrkhkujJlzMgXt6qAJesnMLmlAYcn1fEvK7jgUXAWxKOEV2YbnMzSCbiqIFxsBeUl1k9Px1tNvMW4bSLZvh79ch65zkFZqd77ySy+BUd2wHiD0MelzogIWFAOvPtLnEEzbESk/0ob7q5Kg/7/r8zkouCChdJRNMDozSYeBMGsFSCGPN8oOmR3kMI1RmjecDOv6Qiia+RjdHPT6Uumw+CRzfJUbfd2e5hRvwsXAehVws44XbqJSkJGNGdbvPtJgocmNmdBvBzm3zEuiWU9RFFtZJghmPQVBysjzDoZQVC3I+0Rh8VE+dSmieo1JSp/2QxVqL6yTwHp32tBtvT2kFG7CpW5NvernHnbhJipl/uPJJMhIXuXIbnFaMxgcXuYqcWITGIVYlhDfpKuS9BHnoKBjcxiFgaiULTN8jxAMcH69Tc5UkliXg+CO/zFx+uDB/HyGC4mqHVfFVDcMbTlcLLG1zSRlLjBRyRcPRCKzhN5whesB4iauasD4iivbbhE3cWwD/hZvMFgsQdAacOdLnftx+GH78Ndmv3ke7tSkxuHXzdOn/efjw2+7/cN+u3s6Pv65/Xj+1c+b7afP++PDj4+bf5eC3+8ed5lwiD+Vj+Hl/j/75BNFqycAAA==",
    "Apparent Load Phase A": "0",
    "Apparent Load Phase B": "0",
    "Apparent Load Phase C": "0",
    Area: "2",
    "Assembly Code": "D5090900",
    "Assembly Description": "Misc. Other Electrical Systems",
    "Backsheet Material": "Metal - SolarWorld - BackSheet - White",
    "Branch Circuit Apparent Load Phase A": "0",
    "Branch Circuit Apparent Load Phase B": "0",
    "Branch Circuit Apparent Load Phase C": "0",
    "Branch Circuit Current Phase A": "0",
    "Branch Circuit Current Phase B": "0",
    "Branch Circuit Current Phase C": "0",
    "Circuit Naming": "-1",
    "Circuit Numbering Option": "Default",
    Cost: "0",
    "Current Phase A": "0",
    "Current Phase B": "0",
    "Current Phase C": "0",
    "Default Elevation": "0",
    Description: "SolarWorld SunModule Plus  Photovoltaic Panel",
    "Design Option": "-1",
    "Distribution System": "None",
    "Electrical Data": "Junction Box 31 V/1-245 VA",
    "Elevation from Level": "643",
    Enclosure: "Framed",
    Family: "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Family and Type": "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Feed Through Lugs": "-1",
    "Feed Through Lugs Apparent Load Phase A": "0",
    "Feed Through Lugs Apparent Load Phase B": "0",
    "Feed Through Lugs Apparent Load Phase C": "0",
    "Feed Through Lugs Current Phase A": "0",
    "Feed Through Lugs Current Phase B": "0",
    "Feed Through Lugs Current Phase C": "0",
    "Frame Material": "Metal - SolarWorld - Support Framing - Silver",
    "Front Tempered Glass Material": "Glass - SolarWorld - Tempered Glass",
    "Ground Bus": "No",
    Height: "38",
    Host: "Surface",
    "Host Id": "-1",
    Image: "<None>",
    Length: "1676",
    Mains: "0",
    Manufacturer: "SolarWorld",
    Mark: "41",
    "Max Number of Single Pole Breakers": "0",
    "Maximum Power (STC)": "245",
    "Maximum Power Point Current (STC)": "8",
    "Maximum Power Point Voltage (STC)": "31",
    "MCB Rating": "1",
    Model: "SunModule Plus SW 245 mono",
    Mounting: "10Deg Wedge",
    "Neutral Bus": "No",
    "Neutral Rating": "0.00%",
    "Number of Phases": "0",
    "Number of Wires": "0",
    "Offset from Host": "0",
    "OmniClass Number": "23.75.10.27.21",
    "OmniClass Title": "Photovoltaic Collectors",
    "Open Circuit Voltage (STC)": "38",
    "Panel Name": "Solarworld Sunmodule Plus",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Product Documentation Link": "http://www.solarworld-usa.com/system-designers/~/media/Global/PDFs/sunmodule-plus-mono.ashx",
    "Product Page URL": "http://www.solarworld-usa.com/system-designers/data-sheets-new-2.aspx",
    "Short Circuit Current (STC)": "8",
    "Solar Cell Material": "Glass - SolarWorld - Solar Cell - Black",
    "Solar Panel Angle": "10.00°",
    "SubFeed Lugs": "-1",
    "Total Connected": "0",
    "Total Connected Current": "0",
    "Total Demand Factor": "100.00%",
    "Total Estimated Demand": "0",
    "Total Estimated Demand Current": "0",
    Type: "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Type Id": "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Type Image": "<None>",
    URL: "www.solarworld-usa.com",
    Volume: "0.07",
    Wattage: "245",
    Width: "991",
  },
  {
    ID: "800340",
    Name: "Photovoltaic-Panel-SolarWorld-SunModule-(235-240): SunModule SW 245 Silver Mono - 10 Deg. Angle",
    Category: "Electrical Equipment",
    Level: "Level 1",
    Pbi2DGeometry: "zgAAAB+LCAAAAAAABAA1zV8LgjAUBfDvcp/X2B/npj1FBUE9iAQ9iA9aQwdrC1uBiN+9SfV2uOd3OdUERWvO40NDDkffmlJfQ+M6qwFB4Y0LT8ir6RsjWaUck4yKNSVYCqpgrv9uMwzNGHE87Exz10EPkBNMEJy060IPucACQelDE4x3S5cmQkqqGGdcZpQnGYKLuS2UYxbtQZuuj7MUM0kUgr3V798zw1IRhmDrrY877mXtXH8A0mmdls4AAAA=",
    Pbi3DGeometry:
      "mCkAAB+LCAAAAAAABACtWdtqHEcQ/Zd5Hg19v8hPJhcCyYNJAnkwepCxsBcUbVCWgDH693T3jFazqzo1XYsQEpqj2lPV1aerqkcfvw8fPu3+/PbP3XA9/Lr/tPtjf7/7PIzDh/3u4fDvcP3x+/xr+bN6V76Gp/EFudJKvWs/yvfwdPP8sfePj7ffymevfJqyzXbUegrZ2NFMKVg/Xvk8KR8aHH0+wkFNWesw5sno8rxhjciDnaz2btRuSql8bsWesjeFXeWQtpwGP+moR20mZ6zZtKa5xSEW3Oo0aj8ptbYHwSBzQA/DAfR+MinGhqvTjJGJROby4E/xmJShFrXg5/Qb5oD+lciO7GeL4r2ey4O3RuSyGF9vKxsMMkcZQPsBlnoujo2lAnNh6KjOoMwwGuvDt8+3SNtYZZ34Zv1AR1O4K13wZeWDJu/fcl4KqEKD3gLOAtR8F3xJ8xNXlC74otYnL7R9+GabQK2Sokc1shPeaKDFXKdc7X0qKrIlf9bOoivqajzGx836wOEh64Z7kyu/iZnxW3DlGx6dOZeYJmWd6roKbuMJDYDtnJ2orD6JhvTKRI94ZNGg3JNe0Z4wuUG5RKtFeyjSAuMXZY3EmTwgv0hTIP0obSTOpJ9ye1afywHcahbO6wLrYK0QLtwxve5bK5eoEIfSWwuJCxnBaxIAr7hXkaBbBR03IhFFgvItS9W2y+0MdswD24JALnua6qZ8RBrscLm9l2gbKJdl0rIxtN4ZrXzsO+aWwdf8x3AYv0abipdKFU541rh04CDhdTDIKVoUsAf0yCtKTU+KUcqkqexZLfILthC9EugJs0eBSDkgnR2b0hG8yKmdnNa2TYF53apqUrWveA6rTtt/63vBi59KY1cdknFrgm94qUYnE7LJczTaxJNonEuNxjWFvESPcO39MvP6E3rgFq0K2gN+iNPZESYTsguzA7Ug20NED/YQbS0QoFSwyCsSmlAJtFs/WaVSKxYpu4K7VHLRzqGPtuG13xY8G73wLElWxa+blPOcPeKvvdbF2j2NSSf00YVG74pECr1nvNYB1ix3RpPTSzQoSkAvDLLAKtk6g8SVNQyGNkfkIBbE3mZ7M8/89SqyyhixUmAtDx1NoEq3FTnVGkN4vi+b+fLh4nxHMtAaURd5Odfk5SrZMzd3R6d8ls/5suB2yrI/4sge8cuihHMAiIabGyh6EAxiB5UArpXpsMLoYaUh7bvuHCfaI5TKnOx+YXPXefi6gziToG5ckHhQIwUnXnpy0GlFBZKAYQljTiuq4qJTzOBv0T1wa5Xe7Gitynoi04lRcaJgrnpQXplW+Vo2slDQghiXLlfY+pbdnOMigvLcRNDMs7fLK3Cf3LzQxr6B1yCjn3cvmSM/cCvVKj5n/WlkCjMZOWwr/ZGAxQtzJZofWJzaaJkupCMEixM6ukiPaFdFZ4ncEeS1njET2hnz9VZSUvFcOe3yXrrcVlwtpEtxmAtVLVE8Wk+11/OpTvpIDTyK08hITCBUpgiQwV8geBqmUiDM2AV6Bzi11SJhvFnxJaUkVqOorjM4uRu0V9lExE0gop6Pb9khzrVE2TYTWr/8X8m4ueZZbY54o7EzjbNtMNEJwzWYML9/zO29yoIDr9zAQvLIooHXbOlQQZCjhLE4uGcLB2Zyn1CGOfyNXqvAnaV2kMO7XzrdjMOPu9u/7w53j8O1mtQ4/Hb38OXwdXn4fX+4Pez2D8vjX7vPxz/9crf78vWwPPx0f/ff2vCH/f2+EA7x5/o1PN38D+Xa7u6YKQAA",
    "Apparent Load Phase A": "0",
    "Apparent Load Phase B": "0",
    "Apparent Load Phase C": "0",
    Area: "2",
    "Assembly Code": "D5090900",
    "Assembly Description": "Misc. Other Electrical Systems",
    "Backsheet Material": "Metal - SolarWorld - BackSheet - White",
    "Branch Circuit Apparent Load Phase A": "0",
    "Branch Circuit Apparent Load Phase B": "0",
    "Branch Circuit Apparent Load Phase C": "0",
    "Branch Circuit Current Phase A": "0",
    "Branch Circuit Current Phase B": "0",
    "Branch Circuit Current Phase C": "0",
    "Circuit Naming": "-1",
    "Circuit Numbering Option": "Default",
    Cost: "0",
    "Current Phase A": "0",
    "Current Phase B": "0",
    "Current Phase C": "0",
    "Default Elevation": "0",
    Description: "SolarWorld SunModule Plus  Photovoltaic Panel",
    "Design Option": "-1",
    "Distribution System": "None",
    "Electrical Data": "Junction Box 31 V/1-245 VA",
    "Elevation from Level": "847",
    Enclosure: "Framed",
    Family: "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Family and Type": "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Feed Through Lugs": "-1",
    "Feed Through Lugs Apparent Load Phase A": "0",
    "Feed Through Lugs Apparent Load Phase B": "0",
    "Feed Through Lugs Apparent Load Phase C": "0",
    "Feed Through Lugs Current Phase A": "0",
    "Feed Through Lugs Current Phase B": "0",
    "Feed Through Lugs Current Phase C": "0",
    "Frame Material": "Metal - SolarWorld - Support Framing - Silver",
    "Front Tempered Glass Material": "Glass - SolarWorld - Tempered Glass",
    "Ground Bus": "No",
    Height: "38",
    Host: "Surface",
    "Host Id": "-1",
    Image: "<None>",
    Length: "1676",
    Mains: "0",
    Manufacturer: "SolarWorld",
    Mark: "42",
    "Max Number of Single Pole Breakers": "0",
    "Maximum Power (STC)": "245",
    "Maximum Power Point Current (STC)": "8",
    "Maximum Power Point Voltage (STC)": "31",
    "MCB Rating": "1",
    Model: "SunModule Plus SW 245 mono",
    Mounting: "10Deg Wedge",
    "Neutral Bus": "No",
    "Neutral Rating": "0.00%",
    "Number of Phases": "0",
    "Number of Wires": "0",
    "Offset from Host": "0",
    "OmniClass Number": "23.75.10.27.21",
    "OmniClass Title": "Photovoltaic Collectors",
    "Open Circuit Voltage (STC)": "38",
    "Panel Name": "Solarworld Sunmodule Plus",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Product Documentation Link": "http://www.solarworld-usa.com/system-designers/~/media/Global/PDFs/sunmodule-plus-mono.ashx",
    "Product Page URL": "http://www.solarworld-usa.com/system-designers/data-sheets-new-2.aspx",
    "Short Circuit Current (STC)": "8",
    "Solar Cell Material": "Glass - SolarWorld - Solar Cell - Black",
    "Solar Panel Angle": "10.00°",
    "SubFeed Lugs": "-1",
    "Total Connected": "0",
    "Total Connected Current": "0",
    "Total Demand Factor": "100.00%",
    "Total Estimated Demand": "0",
    "Total Estimated Demand Current": "0",
    Type: "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Type Id": "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Type Image": "<None>",
    URL: "www.solarworld-usa.com",
    Volume: "0.07",
    Wattage: "245",
    Width: "991",
  },
  {
    ID: "800342",
    Name: "Photovoltaic-Panel-SolarWorld-SunModule-(235-240): SunModule SW 245 Silver Mono - 10 Deg. Angle",
    Category: "Electrical Equipment",
    Level: "Level 1",
    Pbi2DGeometry: "zQAAAB+LCAAAAAAABAA1zV8LgjAUBfDvcp/X2B/npj1FBUE9iAQ9iA9aQwdrC1uBiN+9SfV2uOd3OdUERWvO40NDDkffmlJfQ+M6qwFB4Y0LT8ir6RsjWQmJlaB0nWJFmIK5/rPNMDRjtPGwM81dBz1ATjBBcNKuCz3kAgsEpQ9NMN4tXZoIKalinHGZUZ5kCC7mtlCOWbQHbbo+rlLMJFEI9la/f88MJynnCLbe+rjjXtbO9Qda+bGozQAAAA==",
    Pbi3DGeometry:
      "mygAAB+LCAAAAAAABACtWE1rHEcQ/S9zHg/d09/yySQOgeRgkkAORgcZL/aCrA3KEjBG/z3VPSvtzKped5cQQmL3qebVZ1dVz8cfw4dP+7++/7MbrobfDp/2fx5u95+Hcfhw2N8d/x2uPv5YPtK/1Vv6GR7GM/JGK/W2/KHf4eH68bF39/c33+nZN85MPqUxTMEaO86Tsz6MGY3ahQzP4Yy6yQc9j26avfUtYZ44Tiq4UaspGb9ldjYRs7YhNRUmelr5MU422LkpDbhF9hGctB21npRbiwNLkDhg503hub2alA0mwy7ElpdIWm73FrfeGMafE3zJXpdG5BdltaDPHKqrvCyJqjTiFhl4mcy6IbwwT4zMANSXBVH3kZeWms23Ek62UlF9eOsUS+oYBKUXrisF4vJE9MAv6RGIuyvJ1dTDzsvPC67ocXH3wC+ZZqKW0Qu/aJ6J22gP3BwAYPxx3KgBdqCtgRhCdCTsDRWOmVzydoFtmjMcfBwbPQChYY7FDGWJ2GtdVeddhgNZx1aT31a1LRwx6jUHj4bksiPBWb02g9fHm8wyiGwATrPa+MCDSCA/eBjkSZJqpJCPMo9ybgNtfOBA7EGxgMjxXrMat+3VUM9vdHkaCrn3aGuFMHF7XVfJt9JAj2fpFAG6ouDRNfHaDNC6gdE8icgO4LcoSk2FzdB1DPB2IQDqnmnYrBpZ6bVVtrOIUsCppLGXwkxjz81WuqI9xhXAF9xPlvAqMxxVzCQqhA3JCpZuCCy8toRRWXEHGAi4AczEpC+wIFSyCDa8rKgESQPxbhvYcSUHKkFVtdPQYbdAZZx00GVXs+spRPBM5zJfe/R5dHbfwJ5wbXUo7NFvLlVAqZqp0WQaZbb7K30q8t7ElTVakSsEx1SK4mw7wGkt1ae91G/okVrkLZJH/ABH0ZFGE/IL44NKQZZEGH0+iSi3bP3JihUoRNkTVgGjNLcBGlH5TFrlCNWexnGB6VOBvclwoGV14aBukU10Jh/4sq4icUBeZqg1eT4HkzbkhvpCJk8+z9ZgrMZK8z4aywrto0pnGIkDeqGRBPtQdguzlga2AGmeG1kCuPOWrkOBL6LFRhGIiw0HK57XxZ+kyxhw8+OFlj4Qd4oZ9sp5LM1z56AoU0rLG7/h5m/QjEIKCXGWkATlzzgQZ6lF1qFlBhhS2Qo410ESkJd8s2GdhE1MaDXoKFxIui4Nm0J7XpaVIywoYlRR/HsI5ijh1iCINOqAwjPdfTbwYQTdj4NxhwLHETVo4TEF8CtMBTwt+69iqCyFc64yXEHr4ZpGrTtwcamMv+flIrMFLRcVlbQWERx9Oa5xTqf0O1vSX6RJw2m10os73s8tuBhIC1pOXDJnbqBSWKD4aPWHsNZ8GcsrI6PfFOC+MFiynaACM0mWlYRwK6jhTGXJ6xClU3SAuEwAnflczXM5Vz53J+3s4/psSp8sl41AJKd+4JZLiPO6iZezbMvbhfzK+Ikc6JTFsFJZ/eWJTz5j9wtqnIcZ54Whktc4DzM5FhXEa/RZWFXiGuxv4hWYywLSKdt4KluGYLRXLsizX5pHNppYdHQnY2xpcHE2ZzizmIXFFXIP0WKIW6JS3oEsskBhZSNhSARmVC7GsoWBoQZBqsD8tVi2/3LcKI01/HXef8BkPstaBe19LXQ9Dj/vb77tjrv74YoeHIffd3dfjl9PX/44HG+O+8Pd6evf+89P//p1t//y9Xj68v52999a8KfD7YEIh/BL/hkerv8HbMNR85soAAA=",
    "Apparent Load Phase A": "0",
    "Apparent Load Phase B": "0",
    "Apparent Load Phase C": "0",
    Area: "2",
    "Assembly Code": "D5090900",
    "Assembly Description": "Misc. Other Electrical Systems",
    "Backsheet Material": "Metal - SolarWorld - BackSheet - White",
    "Branch Circuit Apparent Load Phase A": "0",
    "Branch Circuit Apparent Load Phase B": "0",
    "Branch Circuit Apparent Load Phase C": "0",
    "Branch Circuit Current Phase A": "0",
    "Branch Circuit Current Phase B": "0",
    "Branch Circuit Current Phase C": "0",
    "Circuit Naming": "-1",
    "Circuit Numbering Option": "Default",
    Cost: "0",
    "Current Phase A": "0",
    "Current Phase B": "0",
    "Current Phase C": "0",
    "Default Elevation": "0",
    Description: "SolarWorld SunModule Plus  Photovoltaic Panel",
    "Design Option": "-1",
    "Distribution System": "None",
    "Electrical Data": "Junction Box 31 V/1-245 VA",
    "Elevation from Level": "751",
    Enclosure: "Framed",
    Family: "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Family and Type": "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Feed Through Lugs": "-1",
    "Feed Through Lugs Apparent Load Phase A": "0",
    "Feed Through Lugs Apparent Load Phase B": "0",
    "Feed Through Lugs Apparent Load Phase C": "0",
    "Feed Through Lugs Current Phase A": "0",
    "Feed Through Lugs Current Phase B": "0",
    "Feed Through Lugs Current Phase C": "0",
    "Frame Material": "Metal - SolarWorld - Support Framing - Silver",
    "Front Tempered Glass Material": "Glass - SolarWorld - Tempered Glass",
    "Ground Bus": "No",
    Height: "38",
    Host: "Surface",
    "Host Id": "-1",
    Image: "<None>",
    Length: "1676",
    Mains: "0",
    Manufacturer: "SolarWorld",
    Mark: "43",
    "Max Number of Single Pole Breakers": "0",
    "Maximum Power (STC)": "245",
    "Maximum Power Point Current (STC)": "8",
    "Maximum Power Point Voltage (STC)": "31",
    "MCB Rating": "1",
    Model: "SunModule Plus SW 245 mono",
    Mounting: "10Deg Wedge",
    "Neutral Bus": "No",
    "Neutral Rating": "0.00%",
    "Number of Phases": "0",
    "Number of Wires": "0",
    "Offset from Host": "0",
    "OmniClass Number": "23.75.10.27.21",
    "OmniClass Title": "Photovoltaic Collectors",
    "Open Circuit Voltage (STC)": "38",
    "Panel Name": "Solarworld Sunmodule Plus",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Product Documentation Link": "http://www.solarworld-usa.com/system-designers/~/media/Global/PDFs/sunmodule-plus-mono.ashx",
    "Product Page URL": "http://www.solarworld-usa.com/system-designers/data-sheets-new-2.aspx",
    "Short Circuit Current (STC)": "8",
    "Solar Cell Material": "Glass - SolarWorld - Solar Cell - Black",
    "Solar Panel Angle": "10.00°",
    "SubFeed Lugs": "-1",
    "Total Connected": "0",
    "Total Connected Current": "0",
    "Total Demand Factor": "100.00%",
    "Total Estimated Demand": "0",
    "Total Estimated Demand Current": "0",
    Type: "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Type Id": "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Type Image": "<None>",
    URL: "www.solarworld-usa.com",
    Volume: "0.07",
    Wattage: "245",
    Width: "991",
  },
  {
    ID: "800348",
    Name: "Photovoltaic-Panel-SolarWorld-SunModule-(235-240): SunModule SW 245 Silver Mono - 10 Deg. Angle",
    Category: "Electrical Equipment",
    Level: "Level 1",
    Pbi2DGeometry: "zQAAAB+LCAAAAAAABAA1zVELgjAUBeD/cp/XcJtzzp6igqAeRIIexIdZQwdrC1uBiP+9SfV2uOe7nHqCsjXn8aGhgKNvTaWvQbnOakBQeuPCE4p6+sZIVpzijCRiTXHOmYS5+bPNMKgx2njYGXXXQQ9QJDhBcNKuCz0UHHMElQ8qGO+WLku5ECSnjDIhCUslgou5LZRhGu1Bm66PqwRTkeQI9la/f88Ey5wJBFtvfdxxL2vn5gMIJCrhzQAAAA==",
    Pbi3DGeometry:
      "aScAAB+LCAAAAAAABACtWctqHEcU/Zdet5t6V7W8CnlgcBYmCWRhtJDxYA8omiAPBmP076mqeXVrzunqq5hBQnPmzrm37rta77937z5s//r276a76d7uPmz/3N1vP3Z99263fdh/6W7efz/8mT9Wr/Ore+ovyCut1Ov6K/90T7enr/30+Hj3LX/3lUuD8yn0doij870ZVIh9QX30tqAx6RPq1eCsGns9WO3Dsizm9WZI1sU+DGOKacqrs5Ae9JjGZW3eDWFUtneDN1npsizkFVmWUa91HwetJrLYBiwLeYkNmNcNScUCqrlzgMugqNDaCaqz0fb6EGd4ztySxtzP0mfCPTlKS+M8/C1pTC0y71kAG4YQaXZ0EgRyyHkmNA5JhKVm45YBPcIzqg03K3Z9BrN0aqKtTgALTub6NvyCVoB514V0OdK0reIxAFOc53IbfsGMEjeIFfBLxpS4YbbhZpfHUw0Q81a3Am6NO2+zkB1CThg7aB3SAVUpFQYTG+OZoylVG7wv9Npqt6TOVKnkHM6iCRiUq9rsqKcMBPbelXMk5c3MCqiPmYw5hIbAczON0PvQHcRz+Hx4nxSEmmgjTsYwOTNRCN3GfAwdBEHs4GtlVy3VL3Z2G1zpHiZ4L0R90ojYL7fOWvbGjZqBfhGckV4sgLqYuYRjvRHwvDLnNJUtO6w5pFthx7TNadfKEEmOrdHWChpxOlLocv3m+nClvCRL18mTBJyTHi1guqJTLqO5caQpxQxdP/MZejECqsPHgKKEl6nDrmj7ErtH4rTFs2FdMEDYvWvsWkwnkg3YX6uc3jB4vT4zjFaFsmSNkxmSV6+kUr6hqODPI2/VLemCjkrbwmDj9OaDtcWUv5plvZvtm9qZgmo3zowIrjC4OhAvBmP0vEHGCTFRB49BZCEvRrEjJE4j2gR+wG6XhIhoIyEiMEwqUQJiYhwkSZiRulzNplT4qMvQyaWmD3UUs1CBo6twHkkHhvw+MyhXtrc6Wqk0ZC5TzpWxZfyMd7TVMpeDn3l9NpupKxuhqytstOZiBLGNUK+3LYMm1nmfJrLECCyMiZEJmLZuxrquy/aZf8DZiLTYYrxombqiGGdq347myGx1ZXZj0atNoMKEOadQsCWFvHZxykzvq9cKszuiq6VudDyhWJYQi4zDkxgaQRcSRIttwLywpNnhaLtZbzBsFUBy3Z5+SSqQgaxCV2frwp2WXe9BjdHyl7mYtDdR+QpKgdcebHBXIO9DuO5I5xWUI0H/d6OnQ2/15QekoWhe8fFIugqEef0DjXSQgZyQmUHOQhXmRSajtlwegspRPITa10jXeFy6Wwx154m2CRfbQo1U3m/OzFifJA0XykbgOdZQoc18BggMwQcXeUky2RfQq8CuzwHJUF9Ar9NFnHE4eKIaQY4nGkvp6FRrp15QQjwta+bwMLV2QGPSqcP4ejdQ0TThUqzO1Y6mzIkaKxT5jqfQ6izklQ0sFmcyRMGhJQ4SZjICUUQl4f8RvROnijzfBH2Zw8D5ROP6JWVhPxAMZ3ZNTaE2B+Wrk2w6/ofD2VjNyN85wZXC1JZqQmVO3nK42OHro7axPmo7wljlwkqBSGSWkMuqaO4DXuKmJRjeVgW7KooKcegC/AOeQLAQglgtwCsfyNz23S/bu382+81jd6MG1Xe/bx4+7T8f3/yx29/tt7uH49u/tx/PH73ZbD993h/f/Hq/+ToV/Hl3v8uEXfytvLqn2/8A0Lkg82knAAA=",
    "Apparent Load Phase A": "0",
    "Apparent Load Phase B": "0",
    "Apparent Load Phase C": "0",
    Area: "2",
    "Assembly Code": "D5090900",
    "Assembly Description": "Misc. Other Electrical Systems",
    "Backsheet Material": "Metal - SolarWorld - BackSheet - White",
    "Branch Circuit Apparent Load Phase A": "0",
    "Branch Circuit Apparent Load Phase B": "0",
    "Branch Circuit Apparent Load Phase C": "0",
    "Branch Circuit Current Phase A": "0",
    "Branch Circuit Current Phase B": "0",
    "Branch Circuit Current Phase C": "0",
    "Circuit Naming": "-1",
    "Circuit Numbering Option": "Default",
    Cost: "0",
    "Current Phase A": "0",
    "Current Phase B": "0",
    "Current Phase C": "0",
    "Default Elevation": "0",
    Description: "SolarWorld SunModule Plus  Photovoltaic Panel",
    "Design Option": "-1",
    "Distribution System": "None",
    "Electrical Data": "Junction Box 31 V/1-245 VA",
    "Elevation from Level": "605",
    Enclosure: "Framed",
    Family: "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Family and Type": "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Feed Through Lugs": "-1",
    "Feed Through Lugs Apparent Load Phase A": "0",
    "Feed Through Lugs Apparent Load Phase B": "0",
    "Feed Through Lugs Apparent Load Phase C": "0",
    "Feed Through Lugs Current Phase A": "0",
    "Feed Through Lugs Current Phase B": "0",
    "Feed Through Lugs Current Phase C": "0",
    "Frame Material": "Metal - SolarWorld - Support Framing - Silver",
    "Front Tempered Glass Material": "Glass - SolarWorld - Tempered Glass",
    "Ground Bus": "No",
    Height: "38",
    Host: "Surface",
    "Host Id": "-1",
    Image: "<None>",
    Length: "1676",
    Mains: "0",
    Manufacturer: "SolarWorld",
    Mark: "44",
    "Max Number of Single Pole Breakers": "0",
    "Maximum Power (STC)": "245",
    "Maximum Power Point Current (STC)": "8",
    "Maximum Power Point Voltage (STC)": "31",
    "MCB Rating": "1",
    Model: "SunModule Plus SW 245 mono",
    Mounting: "10Deg Wedge",
    "Neutral Bus": "No",
    "Neutral Rating": "0.00%",
    "Number of Phases": "0",
    "Number of Wires": "0",
    "Offset from Host": "0",
    "OmniClass Number": "23.75.10.27.21",
    "OmniClass Title": "Photovoltaic Collectors",
    "Open Circuit Voltage (STC)": "38",
    "Panel Name": "Solarworld Sunmodule Plus",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Product Documentation Link": "http://www.solarworld-usa.com/system-designers/~/media/Global/PDFs/sunmodule-plus-mono.ashx",
    "Product Page URL": "http://www.solarworld-usa.com/system-designers/data-sheets-new-2.aspx",
    "Short Circuit Current (STC)": "8",
    "Solar Cell Material": "Glass - SolarWorld - Solar Cell - Black",
    "Solar Panel Angle": "10.00°",
    "SubFeed Lugs": "-1",
    "Total Connected": "0",
    "Total Connected Current": "0",
    "Total Demand Factor": "100.00%",
    "Total Estimated Demand": "0",
    "Total Estimated Demand Current": "0",
    Type: "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Type Id": "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Type Image": "<None>",
    URL: "www.solarworld-usa.com",
    Volume: "0.07",
    Wattage: "245",
    Width: "991",
  },
  {
    ID: "800350",
    Name: "Photovoltaic-Panel-SolarWorld-SunModule-(235-240): SunModule SW 245 Silver Mono - 10 Deg. Angle",
    Category: "Electrical Equipment",
    Level: "Level 1",
    Pbi2DGeometry: "zQAAAB+LCAAAAAAABAA1zV8LgjAUBfDvcp/n2B/XnD1FBUE9iAQ9iA9aQwdrC1uBiN+9SfV2Ofd3ONUERWvO40NDDkffmlJfQ+M6qwFB4Y0LT8ir6XtGkqQSc0n4OqGYKAFz/WebYWjGaGOwM81dBz1ATjBBcNKuCz3kAgsEpQ9NMN4tv1UqpKQZ44xLRXmqEFzMbaEcs2gP2nR9XKWYSZIh2Fv9/pUp5orFaOutjzvuZe1cfwAHP+KjzQAAAA==",
    Pbi3DGeometry:
      "sygAAB+LCAAAAAAABACtWE1rHDkQ/S99bjf6Vss5hSRLYPcQdgM5BB8cMiQDjmdxhoUQ/N9XpR67p2fqSV2TYPwxz+pXT1WlqlJ//Nm9+7R9/+PfTXfd/bn7tP1nd7f93PXdu932fv+9u/74c/oz/1u9yF/dYz8jV1qpF+VH/u4eb54ee/nwcPsjP3vl7GD0aPorNWjvXK8HF4PuCbfWpYJHNc64H3RSvr8yQ7DWttcj/jj45GxvB2XHtKCPThN99G2jaXAupV4NPgbXXs6TCxXGIWgVM6y9D00pYDXgRlIAeRp8CIHg0Noku1SqeQnbZEZmKwf4lLu+GnCfJdUz+fFu6hbPkqG+nKUWyjsLY0MKWo/4gRxEf5IRtY3yS+W6UU3h18PMWgU3j7Ekm0FmNcFWcWBPnyQAbVReFHja1VFtRBtVW9Qn+FyvJPU6/MJ+Ji4bq+DL+pm0lq6CWz0AND+WGxfClXizLaYYabnxWasZfP494WF0BTe6XQkquIuTmmQLvaPg1MyOruBaOZRiC/k2uGLXqDQe80Bcu7It7Wxc6AF2kX7EI9UD/YD8xocFuQduC+EojMJsQFFEXkNRQV5AdoE3YVRQViF3AjewZk+qdGr0C5O3SGVrtO4CPCXFNK7UqsTGqVDwlMYKnlr4Cf+sBnUApB7wiPXwXhD5bKXNpi9XzAeN3IDM6/prO5dkGbnOajOmMBqs3Tx86dxG1RBMkM1/qQ4uWA8isDF6Xh3nwwKTDRsAnjVwxtg9MAsBJzIFvNByI+eYtc5q7Im1wkcFXeHrmhoZBBKAd9Qqbzf1Ckzm61BShuY5P3ecDDrl6I6k87PP/XLlPW2GQ+56mXk8eTnDGcwNWBOF8ssRN9qR1mbJxzKMpc8pHbdJCM8D63KO5S2il0FAH+DmYeQQkfsQt8gnfNAF8UK+ZuMFoghyTJCPwByIlSjgrMV8iGIqZ9wZGjBVSmaCbV5GcJ7rDI2r4UASy1Y8ocGPGi8G1NT2bGna0ZTZdeb2lgTmGkSjaAgWm8yDqJoGY6PjDPOLAbNQX8bHOA0DIdp5PZCCliN6oAaw08Ct0gRrs/AWt1W0XK6dn83GaY6JairEo366yurp8pJSSWfrK8t58uwWY0tuZW0Lbnh9ZmxGGrFKJYjFuRMKFiNukUC2d/MyUJvnaHkNPC848Wh7uHwJNINacr521Zh/lGBcOuIDLMjeSibBFw3cUcLlQepuUAVl51p0PCpHEpVCFsfFChxKvliLjioP/3p3wP1y/QWKy05Rm8OdFdQcDsbV4dxgrflxGSJTArZTM5qnIcK1IlzlC/Ah6rSA3loRTTEy7TOWQSuMbZgkltuDD9rN3MimKC0r50niRVh6OeG4YYikoP0L3SWcCSowE2hhXohmAowyOSRPRD6cohPEhQFYpINFO6eDRTVMje5peDbTW1/tCM8PP9UgV24ffrRNmA5zUeK1nbmBSZkDa1klSE588hnhFyQ4wLn9i5x1QX6zMB9lYVL8lmILUkieiIJKjmEmEsCicNCBA8b61l65HTtfiocPBIcy3xUh1k5CvJ9xojFT/TXGl+mD9EKc1PhJTXn9cYCBVTyWcCRSLZUbsnB6YOmRy2o4f0eWzcA8O/BwBf71lyEopEzsKvC610M3ffd6e/tts988dNdqUH331+b+y/7r4cPfu/3tfru7P3z8sP38/K+3m+2Xr/vDhzd3m/+OF77a3e0yYRf/oK/u8eZ/uyH5u7MoAAA=",
    "Apparent Load Phase A": "0",
    "Apparent Load Phase B": "0",
    "Apparent Load Phase C": "0",
    Area: "2",
    "Assembly Code": "D5090900",
    "Assembly Description": "Misc. Other Electrical Systems",
    "Backsheet Material": "Metal - SolarWorld - BackSheet - White",
    "Branch Circuit Apparent Load Phase A": "0",
    "Branch Circuit Apparent Load Phase B": "0",
    "Branch Circuit Apparent Load Phase C": "0",
    "Branch Circuit Current Phase A": "0",
    "Branch Circuit Current Phase B": "0",
    "Branch Circuit Current Phase C": "0",
    "Circuit Naming": "-1",
    "Circuit Numbering Option": "Default",
    Cost: "0",
    "Current Phase A": "0",
    "Current Phase B": "0",
    "Current Phase C": "0",
    "Default Elevation": "0",
    Description: "SolarWorld SunModule Plus  Photovoltaic Panel",
    "Design Option": "-1",
    "Distribution System": "None",
    "Electrical Data": "Junction Box 31 V/1-245 VA",
    "Elevation from Level": "425",
    Enclosure: "Framed",
    Family: "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Family and Type": "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Feed Through Lugs": "-1",
    "Feed Through Lugs Apparent Load Phase A": "0",
    "Feed Through Lugs Apparent Load Phase B": "0",
    "Feed Through Lugs Apparent Load Phase C": "0",
    "Feed Through Lugs Current Phase A": "0",
    "Feed Through Lugs Current Phase B": "0",
    "Feed Through Lugs Current Phase C": "0",
    "Frame Material": "Metal - SolarWorld - Support Framing - Silver",
    "Front Tempered Glass Material": "Glass - SolarWorld - Tempered Glass",
    "Ground Bus": "No",
    Height: "38",
    Host: "Surface",
    "Host Id": "-1",
    Image: "<None>",
    Length: "1676",
    Mains: "0",
    Manufacturer: "SolarWorld",
    Mark: "45",
    "Max Number of Single Pole Breakers": "0",
    "Maximum Power (STC)": "245",
    "Maximum Power Point Current (STC)": "8",
    "Maximum Power Point Voltage (STC)": "31",
    "MCB Rating": "1",
    Model: "SunModule Plus SW 245 mono",
    Mounting: "10Deg Wedge",
    "Neutral Bus": "No",
    "Neutral Rating": "0.00%",
    "Number of Phases": "0",
    "Number of Wires": "0",
    "Offset from Host": "0",
    "OmniClass Number": "23.75.10.27.21",
    "OmniClass Title": "Photovoltaic Collectors",
    "Open Circuit Voltage (STC)": "38",
    "Panel Name": "Solarworld Sunmodule Plus",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Product Documentation Link": "http://www.solarworld-usa.com/system-designers/~/media/Global/PDFs/sunmodule-plus-mono.ashx",
    "Product Page URL": "http://www.solarworld-usa.com/system-designers/data-sheets-new-2.aspx",
    "Short Circuit Current (STC)": "8",
    "Solar Cell Material": "Glass - SolarWorld - Solar Cell - Black",
    "Solar Panel Angle": "10.00°",
    "SubFeed Lugs": "-1",
    "Total Connected": "0",
    "Total Connected Current": "0",
    "Total Demand Factor": "100.00%",
    "Total Estimated Demand": "0",
    "Total Estimated Demand Current": "0",
    Type: "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Type Id": "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Type Image": "<None>",
    URL: "www.solarworld-usa.com",
    Volume: "0.07",
    Wattage: "245",
    Width: "991",
  },
  {
    ID: "800381",
    Name: "Photovoltaic-Panel-SolarWorld-SunModule-(235-240): SunModule SW 245 Silver Mono - 10 Deg. Angle",
    Category: "Electrical Equipment",
    Level: "Level 1",
    Pbi2DGeometry: "zQAAAB+LCAAAAAAABAA1zV8LgjAUBfDvcp/X2B/nnD1FBUE9iAQ9iA9aQwdrC1uBiN+9SfV2uOd3OdUERWvO40NDDkffmlJfQ+M6qwFB4Y0LT8ir6RsjWaUpJoKzdYozRgXM9Z9thqEZo42HnWnuOugBcoIJgpN2XeghF1ggKH1ogvFu6dJESEkzxhmXivJEIbiY20I5ZtEetOn6uEoxkyRDsLf6/XumWKmFbL31cce9rJ3rD/+J6Y3NAAAA",
    Pbi3DGeometry:
      "nigAAB+LCAAAAAAABACtWNtqHEcQ/Zd5Hg19v9hPJhcCyYNJAnkwepDxYi8o2qAsAWP076nuHWlm5DrTXUIsErtna0+drqqu6p4P34b3H49/fv3nMLwZfj19PP5xuj1+Gsbh/el4d/53ePPh2+Utfa3e0mt4GBfkSiv1tv6jv+Hh+vFn7+7vb77Sb6+CnrLSY5xiMKOZVPRpvAr0RsdYUOfDAtspRWtHP5lk29Ysc5hMjHrUasre2w21D5modQi+6TFN2po4psllk5vWgFukj/Bs/ag1AW0hwBqRs0oAdZqMy67A8VmguDUCa7HsFUxis/Hfr+YJ35I3zQH7tqhW5OsFtXxuC6JlDbhlAte5bOlgbQEvUAGYt+XQWiGwlqhmS5i1xNXUhpt7V1C+sJI64HZbANtOGP42/MK+ALibqd3PN3AG5gModFzRbfiFA0zaJjrgF04wee/swTv6Php6LD3IXBfcMwyT8mQePBWRnbShX1XYa1Pg7F2jESDQqirDmFB4nTK77kIMBCdtntdV4krZxepRhbiQALhEJtoCR5M2SjiXWDdHIlYCFg9ccikAMcHLATCbMknOAS+INYDBwlmHXOxwAkDhgNiBhXMun7dd32r9KqTSkKwVoj4rbgL5RnPNhkYkwWSOYd+At9yLEtDPedk8h1AIWLskUF0eW/HrGOztWkDc7THZLh1R9fU4bCUS5IBxSIMwZ0uD0LsN2nFse4ophDfUswzkUCcaxERhgt1QbGDJmQHCixDeJVoMEAi4AcxGpCuqIFKyALYWiVzyKQPR7tHXvJbzHvmC6klBU3W3wzBZmpjluBbWw4dgUw7NdAOy65nZdRlbwdbZWGG1nnjQqTEXa6O351hPQ7eYJ+PWWqwq1xzCdXAb7QCno6mZj6Zb8cAtWCqwRuQAR6ERRhLSC2ODykCWQBh5kEGYWVB90mJFbkEKRXXAO6UmEOiCRHvSZ03mIad8gXXtGMEV7qicm0lyrgojfW1JcMTWgLoMToo2zeRyM1tzW+pORaCmmxhxB5qV2Gc5htbDc8jZLzAyR/QykQUuoFvbAiWsLeAFKgAzwc7W87p6Fil2icBcKBsc6IItqzEq1/af9MwcXbk4RB3qvca6HWvATSFRvhZVqlephRtcjjiXFJLyuW6pbBYcmANymUIw35EUfBzgyIEURI52PVjoTiMTagc9hbPuvCys7mDflefOJu4tZVxXAOa2FGoPwlijPijc3YJ9grcm6oIMjLsV2JqoUQu3LIBfYzrsTE3RZYwtT+nEg1MWdCEO3msUnE9cAVy9yLTw69nxGEL16Asc9GM5R1+zb+oJK/j5lmDU5alucrmNF4EUjZK3mJ/IeZfC+sQ7SxDAnf7L6MajQ6CEX7wkULLDwQ7MJFhUDcKzwd4W4YpHXoMwl6K9wyQC+Sx7iiJQ9lS9FoVkH5ukvzwlrvcNU64rF5Z4uYdEl9p42ce0orKRY1rYgVNhGHFt9VbnzqbnZEtLnEW5hcvCJK5wHubyK6uGV2qxqHheUIP9HRyiXCKQS9lpZ+eEIRjq+I5s0qV3lGfPREIHjVlLqB1OqbzAhcXbylLznJ2GaNERL0LqM8IZRh7hWYQjkejAF2TRWYFhBkHagcHtWHT05bhRUPfw13kEAnPJZG0H7nwydD0OPx5v/j6cD/fDGzWpcfjtcPf5/GX+8PvpfHM+nu7mj38dPz199cvh+PnLef7w0+3hv7XhD6fbExEO8efyGh6u/weplfqInigAAA==",
    "Apparent Load Phase A": "0",
    "Apparent Load Phase B": "0",
    "Apparent Load Phase C": "0",
    Area: "2",
    "Assembly Code": "D5090900",
    "Assembly Description": "Misc. Other Electrical Systems",
    "Backsheet Material": "Metal - SolarWorld - BackSheet - White",
    "Branch Circuit Apparent Load Phase A": "0",
    "Branch Circuit Apparent Load Phase B": "0",
    "Branch Circuit Apparent Load Phase C": "0",
    "Branch Circuit Current Phase A": "0",
    "Branch Circuit Current Phase B": "0",
    "Branch Circuit Current Phase C": "0",
    "Circuit Naming": "-1",
    "Circuit Numbering Option": "Default",
    Cost: "0",
    "Current Phase A": "0",
    "Current Phase B": "0",
    "Current Phase C": "0",
    "Default Elevation": "0",
    Description: "SolarWorld SunModule Plus  Photovoltaic Panel",
    "Design Option": "-1",
    "Distribution System": "None",
    "Electrical Data": "Junction Box 31 V/1-245 VA",
    "Elevation from Level": "607",
    Enclosure: "Framed",
    Family: "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Family and Type": "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Feed Through Lugs": "-1",
    "Feed Through Lugs Apparent Load Phase A": "0",
    "Feed Through Lugs Apparent Load Phase B": "0",
    "Feed Through Lugs Apparent Load Phase C": "0",
    "Feed Through Lugs Current Phase A": "0",
    "Feed Through Lugs Current Phase B": "0",
    "Feed Through Lugs Current Phase C": "0",
    "Frame Material": "Metal - SolarWorld - Support Framing - Silver",
    "Front Tempered Glass Material": "Glass - SolarWorld - Tempered Glass",
    "Ground Bus": "No",
    Height: "38",
    Host: "Surface",
    "Host Id": "-1",
    Image: "<None>",
    Length: "1676",
    Mains: "0",
    Manufacturer: "SolarWorld",
    Mark: "46",
    "Max Number of Single Pole Breakers": "0",
    "Maximum Power (STC)": "245",
    "Maximum Power Point Current (STC)": "8",
    "Maximum Power Point Voltage (STC)": "31",
    "MCB Rating": "1",
    Model: "SunModule Plus SW 245 mono",
    Mounting: "10Deg Wedge",
    "Neutral Bus": "No",
    "Neutral Rating": "0.00%",
    "Number of Phases": "0",
    "Number of Wires": "0",
    "Offset from Host": "0",
    "OmniClass Number": "23.75.10.27.21",
    "OmniClass Title": "Photovoltaic Collectors",
    "Open Circuit Voltage (STC)": "38",
    "Panel Name": "Solarworld Sunmodule Plus",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Product Documentation Link": "http://www.solarworld-usa.com/system-designers/~/media/Global/PDFs/sunmodule-plus-mono.ashx",
    "Product Page URL": "http://www.solarworld-usa.com/system-designers/data-sheets-new-2.aspx",
    "Short Circuit Current (STC)": "8",
    "Solar Cell Material": "Glass - SolarWorld - Solar Cell - Black",
    "Solar Panel Angle": "10.00°",
    "SubFeed Lugs": "-1",
    "Total Connected": "0",
    "Total Connected Current": "0",
    "Total Demand Factor": "100.00%",
    "Total Estimated Demand": "0",
    "Total Estimated Demand Current": "0",
    Type: "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Type Id": "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Type Image": "<None>",
    URL: "www.solarworld-usa.com",
    Volume: "0.07",
    Wattage: "245",
    Width: "991",
  },
  {
    ID: "800383",
    Name: "Photovoltaic-Panel-SolarWorld-SunModule-(235-240): SunModule SW 245 Silver Mono - 10 Deg. Angle",
    Category: "Electrical Equipment",
    Level: "Level 1",
    Pbi2DGeometry: "zQAAAB+LCAAAAAAABAA1zV8LgjAUBfDvcp/X2B/npj1FBUE9iAQ9iA9aQwdrC1uBiN+9SfV2uOd3OdUERWvO40NDDkffmlJfQ+M6qwFB4Y0LT8ir6RsjWaUEK8rUmmElmYC5/rPNMDRjtPGwM81dBz1ATjBBcNKuCz3kAgsEpQ9NMN4tXZoIKalinHGZUZ5kCC7mtlCOWbQHbbo+rlLMJFEI9la/f88US84TBFtvfdxxL2vn+gN8weUfzQAAAA==",
    Pbi3DGeometry:
      "MCgAAB+LCAAAAAAABACtWNtqHEcQ/Zd5Hg99v8hPIRcCyYNJAnkwepDxYi8o2qAsAWP076nu3dXOaOr0dMlB2No56j116tJV3fP+6/Duw/6PL3/vhpvhl8OH/e+H+/3HYRzeHfYPx3+Gm/dfTx/pz+ot/QxP4xV5o5V6W/+jf8PT7eVr3z0+3n2h777xYQpBhdFOSVs9avoV0ljgGKMlOOYQr3CagjWZnq11dnM1zx30pCwti5NSwS24dfD0bHQMWyaDmVI2dnSTdzZvCgTcIoEF9rQsTtrMV/NK0GrgPFACuC19OxfURL/lJL9YrnoBRwov48wZfsndXs1zr2rqvPqFN02Lq2po6+OpRfJWeWwKQauB60AJ4H5ZDS0nwWKxbNBKuNWNkuqBNzewoIr5vHehbXv8YmkGeuBX9AVE3Zncds5hvwVzgt1LuLB74FcNMlnD6IRfM8jkPbQH3uz9YOwx3LgBdsFb0zA6ZcpqReVDcgMVU4W1SgV2wY8bTaABZ+UKSbSxcCetmyZNLHAK9mVVuZM7i/pOitwh2Mc0JwFw9CEXbmPTQglvEunmSYRKeOeRST4NICYogsBLcBwVZR6ZBPHmYeA8MslHEMUbhArAIN6cyWXrNZPdGAI+1J1nktNCmLitbpsEPTbV0JkQI4LnJACecc+V8CaRbkAiU8I7LwzVtsmOCG7P+e2CQNw983KrfGQ12GFyO5cgDZxJGozZp3qAyk52jruEFaBL4osMZI9gZzzBrrSDOckMlh4gWHiuhDMJveH1AWpkkQtJR1RBnGTh23ARGuTzBULdIW/zmo4qhK+njgx0yBaY1JO2JpQTnJ5NoXKwSyYVOM2mZ+/F7BnWigY4kfiwuG2xJtWU6VOBo11Q61A5rPULISHoMUx0HHUL2QC2IZ2OqTNuaJFzBi7mmCEMAiILHzIpighIuyRj2CRIGYD5ShPWJcfN50yUdmCQdrsxuuwmTWc4M9EOzKdNFlOocBHtnLdnjuwLhymjLeeU4FqeuI7HMnKNs0vi7HMhDqFczpRyBtmr5816To5ehasMXhxglqgrqMkVVvPFvA60mncc6ADUBCtbz+U+uEWYGB/BarlscGgzth7OVO3vxpypra0XhBALnOi2ARfzzKWagq/VZK2dU6MrIGOxRCSSzxQRp+xVCNAHuEUCwfjmheDjDOc60AGo+X0OfGy0oX7ZoIWwi/suAYsyWxdlY/cKShjfq0GhcZsJtgZhtEH3E21rwQbBW5JvfwyKWxTYkHxzFm1TBH/zOMDDsftmBXaBZLKBSQoaDoAbbWE9SvG8WxWHUAbrSsNeMAWmy3ChuBSYjbqmuy7O6nJwirm+qd1Gizbys6QqP/Oy1oSlCLdPf9xAnjjJjcHQqwJ43R8g2cRvwOuUivIvm/gteFUu8ooD+RPtknW2eXFl69TbsSkvX2nvGHc5DLvTi916YaBddzmpx3qPMD5twuUD+VI2a8pXbt6kKHiNYuqrRryzGcXSemZRzmVRgOT1zMNMXmVV8H+0UL5i5GXX2Z0hyGUbaJOcV/AxoXc84xttSrU9GFdeKRDDJa2+di9vrmihcKesel3PDhCtIqKvIuq7ihPKm8MHijWFRATwWTjzGV4+PBjl77Gi0+qaGQWzAX/7SwqUvXWqMdr1wuZ2HH7Y3/21O+4ehxs1qXH4dffw6fj5/PDb4Xh33B8ezo9/7j8+/+nn3f7T5+P54cf73b/zhd8f7g9EOMSfys/wdPsfKbhQIzAoAAA=",
    "Apparent Load Phase A": "0",
    "Apparent Load Phase B": "0",
    "Apparent Load Phase C": "0",
    Area: "2",
    "Assembly Code": "D5090900",
    "Assembly Description": "Misc. Other Electrical Systems",
    "Backsheet Material": "Metal - SolarWorld - BackSheet - White",
    "Branch Circuit Apparent Load Phase A": "0",
    "Branch Circuit Apparent Load Phase B": "0",
    "Branch Circuit Apparent Load Phase C": "0",
    "Branch Circuit Current Phase A": "0",
    "Branch Circuit Current Phase B": "0",
    "Branch Circuit Current Phase C": "0",
    "Circuit Naming": "-1",
    "Circuit Numbering Option": "Default",
    Cost: "0",
    "Current Phase A": "0",
    "Current Phase B": "0",
    "Current Phase C": "0",
    "Default Elevation": "0",
    Description: "SolarWorld SunModule Plus  Photovoltaic Panel",
    "Design Option": "-1",
    "Distribution System": "None",
    "Electrical Data": "Junction Box 31 V/1-245 VA",
    "Elevation from Level": "528",
    Enclosure: "Framed",
    Family: "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Family and Type": "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Feed Through Lugs": "-1",
    "Feed Through Lugs Apparent Load Phase A": "0",
    "Feed Through Lugs Apparent Load Phase B": "0",
    "Feed Through Lugs Apparent Load Phase C": "0",
    "Feed Through Lugs Current Phase A": "0",
    "Feed Through Lugs Current Phase B": "0",
    "Feed Through Lugs Current Phase C": "0",
    "Frame Material": "Metal - SolarWorld - Support Framing - Silver",
    "Front Tempered Glass Material": "Glass - SolarWorld - Tempered Glass",
    "Ground Bus": "No",
    Height: "38",
    Host: "Surface",
    "Host Id": "-1",
    Image: "<None>",
    Length: "1676",
    Mains: "0",
    Manufacturer: "SolarWorld",
    Mark: "47",
    "Max Number of Single Pole Breakers": "0",
    "Maximum Power (STC)": "245",
    "Maximum Power Point Current (STC)": "8",
    "Maximum Power Point Voltage (STC)": "31",
    "MCB Rating": "1",
    Model: "SunModule Plus SW 245 mono",
    Mounting: "10Deg Wedge",
    "Neutral Bus": "No",
    "Neutral Rating": "0.00%",
    "Number of Phases": "0",
    "Number of Wires": "0",
    "Offset from Host": "0",
    "OmniClass Number": "23.75.10.27.21",
    "OmniClass Title": "Photovoltaic Collectors",
    "Open Circuit Voltage (STC)": "38",
    "Panel Name": "Solarworld Sunmodule Plus",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Product Documentation Link": "http://www.solarworld-usa.com/system-designers/~/media/Global/PDFs/sunmodule-plus-mono.ashx",
    "Product Page URL": "http://www.solarworld-usa.com/system-designers/data-sheets-new-2.aspx",
    "Short Circuit Current (STC)": "8",
    "Solar Cell Material": "Glass - SolarWorld - Solar Cell - Black",
    "Solar Panel Angle": "10.00°",
    "SubFeed Lugs": "-1",
    "Total Connected": "0",
    "Total Connected Current": "0",
    "Total Demand Factor": "100.00%",
    "Total Estimated Demand": "0",
    "Total Estimated Demand Current": "0",
    Type: "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Type Id": "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Type Image": "<None>",
    URL: "www.solarworld-usa.com",
    Volume: "0.07",
    Wattage: "245",
    Width: "991",
  },
  {
    ID: "800389",
    Name: "Photovoltaic-Panel-SolarWorld-SunModule-(235-240): SunModule SW 245 Silver Mono - 10 Deg. Angle",
    Category: "Electrical Equipment",
    Level: "Level 1",
    Pbi2DGeometry: "zgAAAB+LCAAAAAAABAA1jdEKgjAYhd/lv15jbs6pXUUFQV2IBF2IF1pDB2sLW4GI794v1d3hO9/hVBMUrTmPDw05HH1rSn0NjeusBgKFNy48Ia+mb0RlJSWVisfrVUSZSmKY67+3GYZmRBnBzjR3HfQAOaOMwEm7LvSQ45RA6UMTjHdLl8RSqSjlgguVRSLOCFzMbVEF5egetOl6vI0oVywlsLf6/RsjShJEW289/riXtXP9AXdzvDnOAAAA",
    Pbi3DGeometry:
      "5igAAB+LCAAAAAAABACtWNtqG0kQ/Zd5Hg99vzhPYS8Esg9hd2Efgh8cIhKB11ocEQjB/77dPaPLWHW6u4Qxtqyj0qnquvd8/Dl8+LT9+8d/m+F2eL/7tP1r97D9PIzDh932cf9tuP34c/43fSzepJ/heTwhN1KIN+VP+h2e7w5fe/v0dP8jfffGyskoocYbMUltwygnbYUcM261L7BV6gTrSUdlxxs1OWl8Uxyx28lHp0c9Cevtit07mdm9lqat1U/OyjiKyUbblkbsTCPtFKTyCZbeqJYtQBhQI0tobj95F1xGfXppHhOIM+1ew8q5QBxngV9Q14UB9cvEOlKvD1PVeJEQVWlAzbPvIpINU5A8oAfGIPaLlKgfFYnzjUe9hZaH2dUFN6uZk9Ewv7rgVqcAhcgNRh9+XbdA9N2xbuQAbsZgkJB1UEn4Pvy6acdtKB3oVZOO2WC74MZYACORpIa9sQtujsoYQxZXRupRJb/FOONe2IIL1THkK3hhkd6qxG6kMXWtwRVcBOvovNIr2KUzZTxKdU4Dcelmc5SVK3OAWtp4xMK1BjqBdhkICHANPBLCUfy4eYAiiJyGQkI7AWkFroQhAfkEfIl8QGq96MmhOSOUK73KmcCGQ36pKgW915g0VDOepmsFDy38Bf/JHtTzgfmAhm0OcgPPa51qm97sXAuaKQL5+yZrM6eYmdmntRlcFBRKa9q8ZLBplDpj+WtgaMEr7sUSrFIomUlUsCuSFczZOWj0ZAbQB85CS9PUQCFwR49PgZd4zmueEaik4wXu/T32NdMMZAjtwI4YtIxm6Es3p6jK0ueCPw2oBJtUj+lCpZPYcbp2Xu1OsFMxw8KvL2u0Sm+cytLnEzSh3mYOEYxbGaJs1ijyoc7NpuG02Zp5s11zkxrRgyTaPMBMw8ghLPchbpZHUNhZEUPepkOGIgkyjZWXSCUdM07YSYWpmoL0ufSczHtg9FrNsA6qwF4WOHWCmSTKbF6KmEorpJJYGFDnCWnLzEubpl5xW1sMlAt5urwhlWl9FcsuHYM+4bQ0oGYamPAUyoKb4E/yyBYkj/iBOYg+reSHfV+5lb+oswLpK2xHy1xYFplQ1ptsw3xt0KbQh3LjERELI+7kF2VLegVjVtzgun2pMTlFu5wVUZojSIvStEzbwCgnzcBjn2JGhpDUoObpI+L+xbEZNBNKuvticJZjVE7iMmalMMwnGqWqCXcInsNBH2TVdX9x4HJEbZDEK32Krki6UTPqlERfYS7gUcm7ZlFZyZpyeLCCpkPBsDNc6qtNPiJDeHaAw9R02lB0xvKEKoSc6CXubn5yFWyOsNFx2f91LHtWWbOqaLYwmGKhkCdqpJKRlbiWGA5ELZeyGY8Jhh3o4Ew/sZYAjFLR5WYDYw2A4GXe8HOPDCOrZqgA0PpyJWk7V1K5EEQbDruyWWaELdUu5WGZd+Wu4dNLC87lW7qcS/eXIzfSyfNfLaEYeQmLnTD8itQGOHl+nreuyW4apyPNzYzX6LEgjfjJ2N+/MUzEAijkbjdwsegf55ULcVo/MofNDyWskocNx86dLc6Gz3hmMQuLLud0wVTwbIwvz/5cefa3wLRSvIhQHFxTKhdi5sZA0iOP1XBwJ2YuvjQ/7WKMvsLTDxBSInYVuO950N04/Lq9/3ez3zwNt2IS4/DH5vHL/uvy5s/d/n6/3T0ub//Zfj5+9G6z/fJ1v7z57WHz/Vzwl93DLhEO/vf8Mzzf/Q98Katz5igAAA==",
    "Apparent Load Phase A": "0",
    "Apparent Load Phase B": "0",
    "Apparent Load Phase C": "0",
    Area: "2",
    "Assembly Code": "D5090900",
    "Assembly Description": "Misc. Other Electrical Systems",
    "Backsheet Material": "Metal - SolarWorld - BackSheet - White",
    "Branch Circuit Apparent Load Phase A": "0",
    "Branch Circuit Apparent Load Phase B": "0",
    "Branch Circuit Apparent Load Phase C": "0",
    "Branch Circuit Current Phase A": "0",
    "Branch Circuit Current Phase B": "0",
    "Branch Circuit Current Phase C": "0",
    "Circuit Naming": "-1",
    "Circuit Numbering Option": "Default",
    Cost: "0",
    "Current Phase A": "0",
    "Current Phase B": "0",
    "Current Phase C": "0",
    "Default Elevation": "0",
    Description: "SolarWorld SunModule Plus  Photovoltaic Panel",
    "Design Option": "-1",
    "Distribution System": "None",
    "Electrical Data": "Junction Box 31 V/1-245 VA",
    "Elevation from Level": "386",
    Enclosure: "Framed",
    Family: "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Family and Type": "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Feed Through Lugs": "-1",
    "Feed Through Lugs Apparent Load Phase A": "0",
    "Feed Through Lugs Apparent Load Phase B": "0",
    "Feed Through Lugs Apparent Load Phase C": "0",
    "Feed Through Lugs Current Phase A": "0",
    "Feed Through Lugs Current Phase B": "0",
    "Feed Through Lugs Current Phase C": "0",
    "Frame Material": "Metal - SolarWorld - Support Framing - Silver",
    "Front Tempered Glass Material": "Glass - SolarWorld - Tempered Glass",
    "Ground Bus": "No",
    Height: "38",
    Host: "Surface",
    "Host Id": "-1",
    Image: "<None>",
    Length: "1676",
    Mains: "0",
    Manufacturer: "SolarWorld",
    Mark: "48",
    "Max Number of Single Pole Breakers": "0",
    "Maximum Power (STC)": "245",
    "Maximum Power Point Current (STC)": "8",
    "Maximum Power Point Voltage (STC)": "31",
    "MCB Rating": "1",
    Model: "SunModule Plus SW 245 mono",
    Mounting: "10Deg Wedge",
    "Neutral Bus": "No",
    "Neutral Rating": "0.00%",
    "Number of Phases": "0",
    "Number of Wires": "0",
    "Offset from Host": "0",
    "OmniClass Number": "23.75.10.27.21",
    "OmniClass Title": "Photovoltaic Collectors",
    "Open Circuit Voltage (STC)": "38",
    "Panel Name": "Solarworld Sunmodule Plus",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Product Documentation Link": "http://www.solarworld-usa.com/system-designers/~/media/Global/PDFs/sunmodule-plus-mono.ashx",
    "Product Page URL": "http://www.solarworld-usa.com/system-designers/data-sheets-new-2.aspx",
    "Short Circuit Current (STC)": "8",
    "Solar Cell Material": "Glass - SolarWorld - Solar Cell - Black",
    "Solar Panel Angle": "10.00°",
    "SubFeed Lugs": "-1",
    "Total Connected": "0",
    "Total Connected Current": "0",
    "Total Demand Factor": "100.00%",
    "Total Estimated Demand": "0",
    "Total Estimated Demand Current": "0",
    Type: "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Type Id": "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Type Image": "<None>",
    URL: "www.solarworld-usa.com",
    Volume: "0.07",
    Wattage: "245",
    Width: "991",
  },
  {
    ID: "800391",
    Name: "Photovoltaic-Panel-SolarWorld-SunModule-(235-240): SunModule SW 245 Silver Mono - 10 Deg. Angle",
    Category: "Electrical Equipment",
    Level: "Level 1",
    Pbi2DGeometry: "zQAAAB+LCAAAAAAABAA9zVELgjAUBeD/cp/nmJtrup6igqAeRIIexIdZQwdrC1uBiP+9SdTb5dzvcOoJytacx4cGCUffmkpfg3Kd1YCg9MaFJ8h6+p6RJJxgxug64ZhQzmBufmwzDGqMNgY7o+466AEkwQTBSbsu9CA55ggqH1Qw3i2/VcaFSHPKKBNFyrICwcXcFsowjfagTdfH1RRTQXIEe6vf/7KgS7T11scd97J2bj4Bi8oTzQAAAA==",
    Pbi3DGeometry:
      "NCoAAB+LCAAAAAAABACtWNtqHEcQ/Zd5Xg19v8hPJhcCyYNJAnkwepDxYi8o2qAsAWP07+nLrHZG26emaxDGRnvcOnW6+nRV9X78Pnz4dPjz2z/74Xb49fjp8Mfx4fB52A0fjofH07/D7cfv9cf03+Jd+jM87y7IjRTiXfkn/R2e786/9v7p6f5b+t0b40bpY9zdmFEE43diDMKoXcZVdC7jUkh5wcMorUo/uNE67dbXA34rRmvT8vQ5SrOg1zZkeheEXg1r1WiktLsbPWqr47pMxM+TmWGvTMa9ny8HcuB6kAWkBtGr0aqgC+5fZa21W7R+i/wl7pUIjW1N8BU9vRywX1vthf7Vruiw1x5ZkYn4mTqvT5fWA9ejPCA9iP/KJfR+0foN+lHpaa6n3NaHr991lsux3zrx1WKCbin7XPrwbdUE8nef+4ofcM1GLad97wj/9+EbWyO/znTi23rjhjLcA6+3ENBIG+RE6ezE1/qrstGU5VGonRxD1lpwLWTBrVyfDqjhScQqRxmZ+V2wdFzjCi60QU5Tc1wnooIbIec8CFfelX0JbxZyUFgkv03DVoOygMKCU0HZgdsCODxFphtgXJB9AIMswKggmzD7KGsIR9lvxn1VreWo17qHCPmOJlxqz8YTvwwrcUFVVkLpsj7vD+EzHoQv+Od6QFyoH/Cw9YA8cPPWFbcjn11TQ4dPIH9f1131FdefXXE7zhedSzNubrA+yNJgheZPi+c8E/iC/6yHiGuc9Bk3SpgFzxznTyVtfK4HxIX7QjoRP8JBfrryjPLGzWfHfmFcdI4o/z06e75bQHGR33rOpUc/K64YnZWxzIxh1tcyLpQsuDTqpS/3vxpfcKdUnUnNchJGca3IdSnhyiwHam1twZ3RCz3pNzMedfHJhQfhLyOyXdCjsGi7aD2gb8MoOdxkoqjM3EAvcM8QxUVnCHDkQbZnUVx0iEwztOOm2mBkrQ3B5x5olNf1LkYfKi7zXTda+Ykn+MLjTcZjcIpYD/hL77V1drBFz4U/DbWFXyefJP4oHY6bZ15XR3ZpvL7oQToRP1Nnxk2os0mcrwd64HqUB6QH8Se8+D/jr/LW2i9av0U/mhlNna3SaFV6RX1C5TeKrvwqxuLD8hGtB/zZb8FUvzljF/zwnd+Im+9LnOqS9faiB+lE/EydcEYAeqgZqpkHpAfxg/qA9kvVMaZ+VH+a63vfKAsfNnxL3XeWzwm/Ibx574h6wsw/rJ/cOsC5R9T9RfWziRP1DdxfVOfZ9xrhb9JfiP7LfAu27wuzbxL9GtWrNk7Vk1a/pvppwz9sPWBfZNw8dyXcyIxrI8zkB6fLuet6XvE8H8ZQ5zpX+FfwrHOSGeKFHoRl25a4dqx04rLdkk91HY4cmAZe1tjDBoU3Dp1rEu6wQeINU20yJzpd5uVquQHJzHcux8l3TuYalpJ3ntn19D24yW+v6Oz5beHqG8irVTjfdOtrhYwXchCUm0vSa/2WpepCQ/0W4wO8mQRezjb5HuCtA+ca5M2KcttRfF9ySj4Bt4wAJDLHJmpM4YwF1HNd+FpZvC4p8+dXpK1q0tB8RjOJqWU6DTdldlEG40WMq6kJ5TuaCW8HpUaaFg1XDvFUZ48cTf520jAKnuncsfqaHSWYgN/oqxl0rC0XUHj3N1d3u+HHw/3f+9P+abgVo9gNv+0fv5y+Th9+P57uT4fj4/Txr8Pnl//6ZX/48vU0ffjpYf/ffOEPx4djIhz8z/nP8Hz3P7XfWtk0KgAA",
    "Apparent Load Phase A": "0",
    "Apparent Load Phase B": "0",
    "Apparent Load Phase C": "0",
    Area: "2",
    "Assembly Code": "D5090900",
    "Assembly Description": "Misc. Other Electrical Systems",
    "Backsheet Material": "Metal - SolarWorld - BackSheet - White",
    "Branch Circuit Apparent Load Phase A": "0",
    "Branch Circuit Apparent Load Phase B": "0",
    "Branch Circuit Apparent Load Phase C": "0",
    "Branch Circuit Current Phase A": "0",
    "Branch Circuit Current Phase B": "0",
    "Branch Circuit Current Phase C": "0",
    "Circuit Naming": "-1",
    "Circuit Numbering Option": "Default",
    Cost: "0",
    "Current Phase A": "0",
    "Current Phase B": "0",
    "Current Phase C": "0",
    "Default Elevation": "0",
    Description: "SolarWorld SunModule Plus  Photovoltaic Panel",
    "Design Option": "-1",
    "Distribution System": "None",
    "Electrical Data": "Junction Box 31 V/1-245 VA",
    "Elevation from Level": "220",
    Enclosure: "Framed",
    Family: "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Family and Type": "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Feed Through Lugs": "-1",
    "Feed Through Lugs Apparent Load Phase A": "0",
    "Feed Through Lugs Apparent Load Phase B": "0",
    "Feed Through Lugs Apparent Load Phase C": "0",
    "Feed Through Lugs Current Phase A": "0",
    "Feed Through Lugs Current Phase B": "0",
    "Feed Through Lugs Current Phase C": "0",
    "Frame Material": "Metal - SolarWorld - Support Framing - Silver",
    "Front Tempered Glass Material": "Glass - SolarWorld - Tempered Glass",
    "Ground Bus": "No",
    Height: "38",
    Host: "Surface",
    "Host Id": "-1",
    Image: "<None>",
    Length: "1676",
    Mains: "0",
    Manufacturer: "SolarWorld",
    Mark: "49",
    "Max Number of Single Pole Breakers": "0",
    "Maximum Power (STC)": "245",
    "Maximum Power Point Current (STC)": "8",
    "Maximum Power Point Voltage (STC)": "31",
    "MCB Rating": "1",
    Model: "SunModule Plus SW 245 mono",
    Mounting: "10Deg Wedge",
    "Neutral Bus": "No",
    "Neutral Rating": "0.00%",
    "Number of Phases": "0",
    "Number of Wires": "0",
    "Offset from Host": "0",
    "OmniClass Number": "23.75.10.27.21",
    "OmniClass Title": "Photovoltaic Collectors",
    "Open Circuit Voltage (STC)": "38",
    "Panel Name": "Solarworld Sunmodule Plus",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Product Documentation Link": "http://www.solarworld-usa.com/system-designers/~/media/Global/PDFs/sunmodule-plus-mono.ashx",
    "Product Page URL": "http://www.solarworld-usa.com/system-designers/data-sheets-new-2.aspx",
    "Short Circuit Current (STC)": "8",
    "Solar Cell Material": "Glass - SolarWorld - Solar Cell - Black",
    "Solar Panel Angle": "10.00°",
    "SubFeed Lugs": "-1",
    "Total Connected": "0",
    "Total Connected Current": "0",
    "Total Demand Factor": "100.00%",
    "Total Estimated Demand": "0",
    "Total Estimated Demand Current": "0",
    Type: "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Type Id": "SunModule SW 245 Silver Mono - 10 Deg. Angle",
    "Type Image": "<None>",
    URL: "www.solarworld-usa.com",
    Volume: "0.07",
    Wattage: "245",
    Width: "991",
  },
  {
    ID: "802782",
    Name: "SH_Lighting-Pendant-Litecontrol-Mod66-8_Foot_09: P-D-66N28T8",
    Category: "Lighting Fixtures",
    Level: "Level 1",
    Pbi2DGeometry: "vQAAAB+LCAAAAAAABAA1jVELgjAUhf/LfV7D2VRcT1FBUA8iQQ/iw8yLXlhb2ApE/O8tsrfD+T7OqSYoGrqMDwQFJ9dQiTevbWcQGBSOrH+CqqZfDErOMyHEZpXwOJEpzPXf2g6DHoMaij3pO3ocQEU8YnBG2/kelFjzLMsTBqXz2pOzC79S+8URD+iI1PXhR4Z5BgeD78WUPJVxymDnjAvD9mXMXH8AZmMsG70AAAA=",
    Pbi3DGeometry:
      "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",
    "120Volt": "No",
    "277Volt": "Yes",
    "Apparent Load": "0",
    Area: "2",
    "Assembly Code": "D5020210",
    "Assembly Description": "Lighting - Fluorescent",
    "Ballast Factor": "0",
    "Ballast Type": "ELB",
    "Calculate Coefficient of Utilization": "No",
    "Coefficient of Utilization": "0",
    "Color Filter": "16777215",
    Cost: "0",
    "Default Elevation": "914",
    Depth: "0",
    Description: "Pendant-Mounted Direct",
    "Design Option": "-1",
    "Dimming Lamp Color Temperature Shift": "<None>",
    Efficacy: "149 /",
    "Electrical Data": "Power 277 V/1-0 VA",
    "Elevation from Level": "2750",
    "Emit from Line Length": "4174",
    Family: "P-D-66N28T8",
    "Family and Type": "P-D-66N28T8",
    Height: "610",
    Host: "Compound Ceiling : 3000 x 3000mm Grid",
    "Host Id": "-1",
    Illuminance: "12",
    Image: "<None>",
    "Initial Color": "0",
    "Initial Color Temperature": "3200",
    "Initial Intensity": "0",
    Lamp: "T8",
    Length: "4225",
    Length1: "4200",
    Length2: "2100",
    Length3: "76",
    "Light Loss Factor": "0",
    "Light Source Definition (family)": "Line+Photometric Web",
    "Luminous Flux": "1380",
    "Luminous Intensity": "110",
    Manufacturer: "Litecontrol",
    Mark: "56",
    Material: "SH_Aluminum, Anodized Black",
    Model: "Mod-66",
    "Number Of Lamps": "2",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Photometric Web File": "12121300.ies",
    "Schedule Level": "Level 1",
    "Tilt Angle": "-90.00°",
    "Total Light Loss Factor": "1",
    Type: "P-D-66N28T8",
    "Type Id": "P-D-66N28T8",
    "Type Image": "<None>",
    URL: "http://www.litecontrol.com/contentmgr/showdetails.php/id/368",
    Voltage: "277",
    Volume: "0.05",
    Wattage: "9",
    Width: "0",
  },
  {
    ID: "812954",
    Name: "SH_Lighting-Pendant-Litecontrol-Mod66-8_Foot_09: P-D-66N28T8",
    Category: "Lighting Fixtures",
    Level: "Level 1",
    Pbi2DGeometry: "zQAAAB+LCAAAAAAABAA1zVELgjAUBeD/cp/nmDq3aU9RQVAPIkEP4oPW0MHawlYg4n/vRvV27+E7nHqGsjOn6a6hgIPvTKUvoXW91UCg9MaFBxT1/D2RRJKqTGWriFEhYg5L82frcWwntBhsTXvTQY9QMMoIHLXrwwBFnFIp84xA5UMbjHcY0UwymYs0ETLnSilB4GyuH80oyr02/YC7nCb47ax+/YqcCp4g3njrccc9rV2aN8Qf4RfNAAAA",
    Pbi3DGeometry:
      "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",
    "120Volt": "No",
    "277Volt": "Yes",
    "Apparent Load": "0",
    Area: "2",
    "Assembly Code": "D5020210",
    "Assembly Description": "Lighting - Fluorescent",
    "Ballast Factor": "0",
    "Ballast Type": "ELB",
    "Calculate Coefficient of Utilization": "No",
    "Coefficient of Utilization": "0",
    "Color Filter": "16777215",
    Cost: "0",
    "Default Elevation": "914",
    Depth: "0",
    Description: "Pendant-Mounted Direct",
    "Design Option": "-1",
    "Dimming Lamp Color Temperature Shift": "<None>",
    Efficacy: "149 /",
    "Electrical Data": "Power 277 V/1-0 VA",
    "Elevation from Level": "2750",
    "Emit from Line Length": "4174",
    Family: "P-D-66N28T8",
    "Family and Type": "P-D-66N28T8",
    Height: "610",
    Host: "Compound Ceiling : 3000 x 3000mm Grid",
    "Host Id": "-1",
    Illuminance: "12",
    Image: "<None>",
    "Initial Color": "0",
    "Initial Color Temperature": "3200",
    "Initial Intensity": "0",
    Lamp: "T8",
    Length: "4225",
    Length1: "4200",
    Length2: "2100",
    Length3: "76",
    "Light Loss Factor": "0",
    "Light Source Definition (family)": "Line+Photometric Web",
    "Luminous Flux": "1380",
    "Luminous Intensity": "110",
    Manufacturer: "Litecontrol",
    Mark: "57",
    Material: "SH_Aluminum, Anodized Black",
    Model: "Mod-66",
    "Number Of Lamps": "2",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Photometric Web File": "12121300.ies",
    "Schedule Level": "Level 1",
    "Tilt Angle": "-90.00°",
    "Total Light Loss Factor": "1",
    Type: "P-D-66N28T8",
    "Type Id": "P-D-66N28T8",
    "Type Image": "<None>",
    URL: "http://www.litecontrol.com/contentmgr/showdetails.php/id/368",
    Voltage: "277",
    Volume: "0.05",
    Wattage: "9",
    Width: "0",
  },
  {
    ID: "845266",
    Name: "Basic Wall: Wall - Timber Clad",
    Category: "Walls",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABAB9jlELgjAUhf/LfZ5jc3OaPUUFQT1IBD2ID4pDB2sLW4GI/72BVkTQ2z33O5xz8gGySp36q4QU9rZSmdV9Yw0gyKwy7gZpPkynNzCGKRd0GVCCF4KFMKJfyDGPRPyNQswTxv+hT2Txql51Xdn7fv/YqPIinewgJZggOEjTuHYWR+tKp/zkSZ5V/UY7qZrWt/hsIcIYwVbLx2wOKE4IjxCsrbY+2Ny1Hosni+Q2XhABAAA=",
    Pbi3DGeometry:
      "XgoAAB+LCAAAAAAABACVVttqAjEQ/Zc8Z0OyyV7Up9ILhfZB2kIfpA8rLhqwpmyXgoj/3tiu7i2TiSyKOXvmzIlJJrM4kPlSv+2/SjIlT2apX81Wrwglc6N39TeZLg7/P+1rPrMPOdIWiQTns78v+yHHj3PYTVUVexsrJRMqFTTKGRcZ5YzTCyQEU3Gc0pzlSS7HeCRYzlVCQzQAboCEYipJndDQFxgLTeCMx0zlUlm2nCg1Rtv8fWIXkiyTAlJ0EPtyPZdo3kDbgR4dhqKYiYxDzPD4AM3hPjjDo33T5/eUHRAYDiy9dZeJWKK6DQ2IHsPOKbtyAQquqXGWcDkJogKThSTcxoA5tCuMHCsUxxcfrSZQqYKXMGC/tjyPnL9geRJg5wYufw4bcJFE6lYXggO7Xn3yEOQubYPF8qKeqh522hC2V3pQ+LD9DmRETh2m7nXovgPcvoG/D7KHdQF+J4hr7/V87aWAwUjrEdqqBCVFagQMNXq2UbvTxWdZlxWZnmjkudyt600zeDF1UWuza4bvenV59Vjq9aZuBvfb8qdLvDVbYwXJw+T02H7wF9tpB9leCgAA",
    Absorptance: "0.1",
    Area: "14",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    Cost: "0",
    "Cross-Section": "Vertical",
    Description: "Structural Insulation Panel Wall with Kiln Dried Timber Panel Rainscreen",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Wall - Timber Clad",
    "Family and Type": "Wall - Timber Clad",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Keynote: "F10",
    Length: "4700",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Structure - Timber Insulated Panel - Insulation",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 1",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "2700",
    Type: "Wall - Timber Clad",
    "Type Id": "Wall - Timber Clad",
    "Type Image": "<None>",
    "Unconnected Height": "2700",
    Volume: "2.76",
    Width: "202",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Both",
  },
  {
    ID: "846332",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1zV8LgjAUBfDvcp/X2B/npj1FBUE9iAQ9iA9aQwdrC1uBiN+9hfV27uF3OdUERWvO40NDDkffmlJfQ+M6qwFB4Y0LT8iraYmRrGiKCZfrlcBCMQlz/WebYWjGaGOxM81dBz1ATjBBcNKuC/33oJwyBKUPTTDeQU6xkERmKWepzBKViQTBxdwWzJmiCA7adH1cTrBiKkOwt/r9+2YJJoJFs/XWxzH3snauP00FDenSAAAA",
    Pbi3DGeometry:
      "LgQAAB+LCAAAAAAABACdk99rwjAQx/+Xe07DJeSX9WlswkAfZBvsQfZQMWiga6QLgoj/u1nXOTfJ2pqS0vvcXb5pLrc4wHzpXvZbCzlM/dI9+9KtgMDcuyp8QL44fH1GN47jA0fyQzKGOG5eccLx7Tvtrq6LfczNmKIcGckklYZrwgVlQmly5kiVYoJwQ41hl1hqbLA2SnRzScWINcuj5Ix0yqbir9aX1Gg+usWR3tIfnkzoof378Lr41Wl0SiczknUbgv/ZT8+y3f4DaYmB0ukiDLvCad6jyLHxHlzxboOtIUeKBGa2WodNazz5UATnq9Z8dauz69G69Sa0xqS0u8vAe1/6+rPxmxH7+wS61JeALgQAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2081",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "846333",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jdEKgjAYhd/lv17Dber87SoqCOpCJOhCvNAaOlhb2ApEfPcW4t05h+/wVRMUrb6OLwU5nF2rS3X3je2MAgKF09a/Ia+mJQZkw1IaCbmNKU8QYa5XajcMzRjQMBx081ReDZBHNCJwUbbz/b8wwTiB0vnGa2chZzSRkcRU8FRinKFEAjf9WGDBM0bgpHTXB3FMkYvQj0Z91zfSBOOw7Z1xQWY/xsz1DxBJMtTRAAAA",
    Pbi3DGeometry:
      "CgQAAB+LCAAAAAAABACdk1FrwjAQgP/LPceQxKQ29UncQNAH2QQfZA8Vgwa6ZtQgiPjfTbXqNrnFLiVt77vL3XGXWxxgurSz/ZeBDMZuad9dYVdAYOps6beQLQ6X36Bm/fDAkdxJhzPWP7/ChuPH9digqvJ9ONvhCRWME0mF0poISRXvCXLFKdUsVYRrmoTPnaa8q2uqtOQxLClPVLd2LUUiSCQiYv3gW9G0J3RrjibzC2Pm0bA/6/U3fihBJCpmj3XpeYpn8lyT/pk46r5VVLTobW4piuMNDUP1YvNP400FGaOMwMSUa79phDfnc29d2Yhzu7qpRsauN74RXguz+244dIWr6qE+rzC7JwW4vI0KBAAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2044",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "846334",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABFjV0LgjAYhf/Le73GPmxzdhUVBHUhEnQhXmgNHawtbAUi/vcWIt2dc3geTjlC3pjL8NSQwck3ptC3ULvWakCQe+PCC7JynGNEVlRgwuVmRQlmjCQwVQu37ft6iHAc9qZ+6KB7yAgmCM7ataH7FcopQ1D4UAfjHWQUryWRSnAmpEpSJQSCq7nPMGcpRXDUpu3CXz5Y/VlshQVVCYKdtz6eube1U/UF/6nvEdMAAAA=",
    Pbi3DGeometry:
      "QAQAAB+LCAAAAAAABACllFFrwjAQx7/LPachcbY19UmmMNAHcYM9lD20GNpAbaQLgojf3dPFbVCPVpqQkrtf/vyTHGl6gnVuPo57DQksbW7ebWW2wGBtTe2+IUlPP1PEYoodzuwvE0ghprcPDjh/3WWzpsmOqA1kyCfxSLEg5NF48sKk4nEoYvYIRFKNEUR8JOSQPGnggRcoriLkrTy1/tkNScGFUg8AZUwKWg7k3XUC0qMNaMkT9l21uIPWnXS7k5LuAvbLkwb9CzjgFJRJT3N8inOT7bTTDSSIGKx0XbjSBxvrMmds7cNPs/1Fb9oUpfPBotKH/wtfbWWb66/g1vDFXwD/yT1bQAQAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1394",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "846335",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jUELgjAcxb/L/zyH29ymdooKgjqIBB3Ew6qhg7WFrUDE795ChHd47/F7vGaC6mYu40tDCSd/M7W+B+U6qwFB5Y0LbyibabERSYjAKZObhGOeUwlzu2LbYVBjZGOxN+qpgx6gTHGK4KxdF/p/IIxQBLUPKhjvoCSYy1QWglEhiyyPQnA1jwVmNCcIjtp0fXzOMMuoQHCw+ruuCyxyjmDnrY9f7mPt3P4A0IrsTtEAAAA=",
    Pbi3DGeometry:
      "iQMAAB+LCAAAAAAABACdU00LwjAM/S85d6Wt+95JVBD0ICp4GB4mllmYq8wiiPjfrXPq/Cgba2lpXl4SeE3iC8w2Ynk+cAhhIjdiITOxBQQzKXJ1hDC+PJ7aTSK94YreiEUJicpLH7iun2H9okjOOtaiLmaEIsvBru33EA2w6zvoG2Y9HBBq13GHeojZmDDPawkbcv/C/8mfmR3seyzoijfUNJCbc3+J1dbRvrCJbvqlTnj3uiaFOnZNKzl1Tw9FsueKFxASTBBMeZ6qXWXMpUqUkHllrsT25Rpzke5UZYwyfqoTBzKTxX2myqVH5wYKfM1AiQMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1360",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "846351",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABFjdEKgjAYhd/lv15jc7o5u4oKgroQCboQL6x+dLC2sBWI+O4ZIt2dc/g+TjlAfjXn/omQwdFfTYG3ULvGIhDIvXHhBVk5zHFCVlxSJtQ6piJKEhirhdp0Xd1P6DTsTP3AgB1kjDICJ3RNaH+FCx4RKHyog/EOMk4TxZSWIpJKx6mWksDF3GdYRCkncEDTtOEv7y1+FltTyXVMYOutn87c29qx+gKHyt6x0QAAAA==",
    Pbi3DGeometry:
      "EwQAAB+LCAAAAAAABACVk0sLwjAMgP9Lzl1p9948iQqCHkQFD+Jhw6KFucoswhD/u1XrA7Wua2lpvqTpI8nyBJOcz+s9gxRGIuczUfA1IJgIXsoDpMvTfanUpKM6nNGLOJSQzm1SA86rx7ZuVWW12uvQELuEIh97bhAgmuCQJj5yaIDjyE0seBSQ6A//dG/A2vtf6xiHoef9wFGcfDsx4HZHGqy/fOvXt+WNl7ELhvnYjw9r4M1BtUsCY6DaYOsMa3xsm/QwYpufVNXV59mOSVZBSjBBMGblRm61MBUyk1yUWlzw9VM1ZHyzlVoYFOz4btgThaiu1X1rqogvhvK+gBMEAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1397",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "846402",
    Name: "Linear Dimension Style: Feet & Inches",
    Category: "Dimensions",
    "Alignment Method": "None",
    "Base Power Load on": "0",
    "Body width": "No",
    "Center Segment": "Solid",
    "Centerline Pattern": "None",
    "Centerline Symbol": "Default",
    "Cold Water Radius": "0",
    Cost: "3",
    Description: "-1",
    "Digital Plate": "2.3813",
    "Dimension Line Extension": "6.35",
    "Dimension Line Snap Distance": "Continuous",
    "End Segment Weight": "Value",
    "Equality Formula": "EQ",
    "Equality Text": "Tick and Line",
    "Facucent Drilling": "Feet & Inches",
    Family: "Feet & Inches",
    "Fixed Door": "2.3813",
    "Installation Type": 'Diagonal 3/64"',
    "Interior Tick Mark": "Dynamic",
    "Interior Type": "No",
    L: "<None>",
    Layout: "Yes",
    "Leader Line": "None",
    "Leader Tick Mark": "Arc",
    "Line Style": "1",
    Rangehood: "Up, then Left",
    "Show in": "Beyond Witness Lines",
    "Show Leader When Text Moves": "No",
    "Supply Voltage": "No",
    "Target Elevation": "Opaque",
    "Text Background": "Arial",
    "Text Font": "1.5875",
    "Text Offset": "2.3813",
    Thickness: 'Diagonal 3/64"',
    "Tick Mark": "5",
    "Total Input Wattage": "6000",
    "Tumble Dryer": "Feet & Inches",
    "Type Comments": "Feet & Inches",
    "Underlay Orientation": "No",
    "Width (pixels)": "1",
    "Window Cill Interior": "Gap to Element",
    "Witness Line Control": "2.3813",
    "Witness Line Extension": "1.5875",
    "Witness Line Gap to Element": "2.3813",
    "Witness Line Length": "None",
  },
  {
    ID: "846939",
    Name: "Curtain Wall: SH_Curtain wall",
    Category: "Walls",
    Pbi2DGeometry: "DQEAAB+LCAAAAAAABACFjs0KwjAQhN9lzzE0SX9CPYkKgh6KCB5KDy2GNhCzUqNQSt/dQG3Vk7ed/YaZyXvIKn3qbgpS2GOlMzRdjRYIZKitu0Oa9+PpDQsWUx6w5YJxysJQwEA+kHMqRZL8gZLKWEQ/bE6dWDGVr9q27PwC/9jo8qqcaiENaEDgoGztmrc4oiud9qNHedaXGe2Urhtf4qMjKQhsjXp+e9do0GfahzFD8QKJTJnbDQEAAA==",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "32",
    "Assembly Code": "B2020200",
    "Assembly Description": "Curtain Walls",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 1",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Border 1 Type": "64 x 128 rectangular",
    "Border 2 Type": "64 x 128 rectangular",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Curtain Panel": "Glazed",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "SH_Curtain wall",
    "Family and Type": "SH_Curtain wall",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "64 x 128 rectangular",
    "Join Condition": "Vertical Grid Continuous",
    Justification: "Center",
    Layout: "Fixed Distance",
    Length: "11899",
    Number: "7",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "1500",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Ceiling",
    "Top is Attached": "No",
    "Top Offset": "0",
    Type: "SH_Curtain wall",
    "Type Id": "SH_Curtain wall",
    "Type Image": "<None>",
    "Unconnected Height": "2700",
  },
  {
    ID: "847436",
    Name: "Curtain Wall: SH_Curtain wall",
    Category: "Walls",
    Pbi2DGeometry: "DQEAAB+LCAAAAAAABAB9js0KwjAQhN9lz2lIU1KSehIVBD0UETyUHloMbSBmpUahlL67gfqL4G1nv2FmigHy2uz7s4YMNlibHG3foAMCORrnL5AVw3QGQ5TSWHE5i2JGBUsUjOQXKipiLr4RTylniv9l79DyWT7vuqoPC8JjaaqT9rqDjFFGYKtd49uH2KGvvAmjJ3kwxxdaa9O0oUZSKWRCYGX17dO7QIsh012tHcs7Dr+2qg0BAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "16",
    "Assembly Code": "B2020200",
    "Assembly Description": "Curtain Walls",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 1",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Border 1 Type": "64 x 128 rectangular",
    "Border 2 Type": "64 x 128 rectangular",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Curtain Panel": "Glazed",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "SH_Curtain wall",
    "Family and Type": "SH_Curtain wall",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "64 x 128 rectangular",
    "Join Condition": "Vertical Grid Continuous",
    Justification: "Beginning",
    Layout: "Fixed Distance",
    Length: "6101",
    Number: "5",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "1500",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Ceiling",
    "Top is Attached": "No",
    "Top Offset": "0",
    Type: "SH_Curtain wall",
    "Type Id": "SH_Curtain wall",
    "Type Image": "<None>",
    "Unconnected Height": "2700",
  },
  {
    ID: "849032",
    Name: "Basic Wall: Wall - Timber Clad",
    Category: "Walls",
    Pbi2DGeometry: "EwEAAB+LCAAAAAAABACFjk8LgkAUxL/LO6/L/kFl7RQVBHWQCDqIB6VFF7bdsC0Q8bv3QBOCoNub9xtmphggr825v2vI4OBrk3vbN94BgdwbFx6QFcN0okEIGrNEriLO8JAKRvIDJozKVIlvKClPFP8Dl9jyU7/uuqrHDfjYmuqmg+4gY5QROGrXhHYWJx+qYHD2JC/muqC9Nk2LLVzQVMWSwM7q12yOJFUyJbDx1mOue1o7lm+LTt2nEwEAAA==",
    Pbi3DGeometry:
      "GA4AAB+LCAAAAAAABAClV01rwzAM/S8+J8aO89mexj4YbIeyDXYoO7Q0tIGuGV0YlNL/PrdLs8XOi5yO0OI8y0+yLEvKdM8m8+Jl95GzEXso58VzuS4WzGOTsthUn2w03f8M9bQY64cdvF/El0KMT3/6xw5v52VX2+1sp9cGAY9ErDw/FlwlWeClPI1S5TV4KLhQMvISLiKV2rgveSrCiF6AFEihByqzccnDIIg9X/FMJTaPiZMGWROICVoKLIIKAk0UxiGeMH1E+UIrooUROTqYM0+bfIhG5Bi4/272LtDZhYrLOJO2jQ0u9SCObbyWT3ggkw4eCwc80B7DNyZ+2q1J0uy2V7p1cJfuh7L7H/b1UHe60AxQise6d81ExtMktPgj7QIVJxZu5gFXeWS/ZQ9SgGID2I/3CxwHFwz1BCRCO4CBQmyNChUqE8GjAWrbMMViug1ZQ2hF8T9ULZKnUt2lFZg6dBQ9VJ01cdfK76qX8jNV95GdsDaRF9V9gqx/cIVZ5il8uAZStWsCd+1UEO6qd3Dv6ppgycRLRkZ3LXduk3rbNdw0UDeuu+0YDFIXHPUo/R0qkc0GdUW9wlSab+P6E+ummL3nVb5loyMve8w3y2pVvzyV1awqyk39+losmqn7vFiuqvrldp1//RW8LtelJmR32fHRX3Lf76q52xgOAAA=",
    Absorptance: "0.1",
    Area: "43",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "-1200",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    Cost: "0",
    "Cross-Section": "Vertical",
    Description: "Structural Insulation Panel Wall with Kiln Dried Timber Panel Rainscreen",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Wall - Timber Clad",
    "Family and Type": "Wall - Timber Clad",
    Function: "Exterior",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Keynote: "F10",
    Length: "15202",
    "Location Line": "Finish Face: Interior",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Structure - Timber Insulated Panel - Insulation",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Wall - Timber Clad",
    "Type Id": "Wall - Timber Clad",
    "Type Image": "<None>",
    "Unconnected Height": "3900",
    Volume: "8.64",
    Width: "202",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Both",
  },
  {
    ID: "849035",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "849036",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "849037",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "849038",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "857191",
    Name: "Master Bedroom 206",
    Category: "Rooms",
    Level: "Level 2",
    Pbi2DGeometry:
      "9wMAAB+LCAAAAAAABACl0ztrwzAQAOD/crNz6PSwLXcqTaHQDqYUOoQMDhGOwLWCqxZMyH/vQZx0aAK2O0m6T5yetzpAufFv/d5BAc9h48vQ9HVoIYEy+DZ+QrE6nLo8QaHMM3lnkXIiOCa/sqAUhcpm0oIEGqHsBNSYcbp/oECS6UTRmBo1niQnsmY2SWPtaNKopNYzSXAjx5PAlLJpMvycOXJl37eFkAxdPesI+fMWt+Wyg+lyroP1ucTuu67quc44sPTVh4uug0KgSODFtXXcDYPXEKvouTRPw3e/vdCT8/WOl5DEt2hMAo+N+x4mW8y15NBDaALnbb+a5rj+AWm+cgr3AwAA",
    Pbi3DGeometry:
      "fBEAAB+LCAAAAAAABAClVk1v2zAM/S86O4Ikyx9KT8M2YMB6KLoBOxQ5pKjRGvDiIfMKFEX+e7XNcWyalGgXQZPqkXp8oj7Iu1dxc19/f/lVia342t7X39qmfhCJuGnrQ/dbbO9e///rzerKf8QpuSAbrdTVvy//J06787QPx+P+xc/dWFnoUidKapMnTpbWZMlG51KlhR96kx7Q3tXKPEvzEZoaaz1qMucG1Hg+l0G091X+x7gIL6ohlaYsDBTWu/plykylM+Lp2nqQ50wxUwnCloenQslcF8BVS51pOpXj9AyuURCfjyYyBK6OhG8vvpHspPTTQaax6Xj6Q6SMSOj0yO7F95Q4VVNUO2mVzkECl6CsaMOJ/8uhTXoxKE+WlYlx0tgRDkLy4GXXDJJQ7nPtkTtPL3a9YdFzY0pZamsu3jDJpFC2YdGbCFlQb1x68PIbK7UqXIQihIZrBn6tpijUsApmBgy8BJ440/5SUupYMKvaBtG5jBUwK+Cs6I9Rv9m5cjmpjgWHA6LFYQJCEavgUDi0lkzBgRVXxkAZsUJl75xbXBYHDcViFE4gYAXKikV3M+e7hsvioKFYaDs1BWcCFqOMWKHOD/QNIBQHZbXrRCfxjiI3M1AhAB48gfhh5z2UODHxuOPxCAr0JcDPRnDDWA0kIXjJAY1RwIcdLcLBvJGalyQOlUG1Y6BRiZ1rHgvZf6DFh1gkWS8xbiJ/RPNN6Iu06nDteCELr2bqvUvEp3r/s+qqo9gqqRJxXR0eu6d+cNt2+65uD/3wR/0wmL5U9eNT1w8+N9Xz2PFj27Se8PCnaU67NxhZGgZ8EQAA",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "27",
    "Area per Person": "106",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "6500",
    Number: "206",
    "Number of People": "0",
    "Occupancy Unit": "Number of people",
    Perimeter: "29060",
    Phase: "Working Drawings",
    "Phase Id": "Working Drawings",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "10.76 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "6500",
    "Upper Limit": "Level 2",
    Volume: "118.32",
  },
  {
    ID: "857192",
    Name: "M_Room Tag: Room Tag With Area",
    Category: "Room Tags",
    Description: "-1",
    "Facucent Drilling": "Room Tag With Area",
    Family: "Room Tag With Area",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Ordinate Dimension Settings": "Horizontal",
    "Short Circuit Rating": "Yes",
    "Show Opening Height": "Yes",
    "Show Up Text": "No",
    "Tumble Dryer": "Room Tag With Area",
    "Type Comments": "Room Tag With Area",
  },
  {
    ID: "857194",
    Name: "Master Bath 207",
    Category: "Rooms",
    Level: "Level 2",
    Pbi2DGeometry:
      "cQMAAB+LCAAAAAAABACl081qwzAMAOB30TkVtmw3TnYa62DQHsIY7FB6SJlJDW48MrcQSt99gv7ssHVk2c3SZ2RjycsDVGv/0r87KGEe176KoW9iCxlU0bfpA8rl4bTkDRONirS+m0iBRqgCjtkXKiSb03gTKHJhhxLnNIl/mEJBajrYJCojzXjSMldDie8xlfmfidBYc6PiMPv+Ir+ZQCtVMd5+7s5tuwzfWLsO3+oy3PddV/c84ZyY+Xrrkuug5BIZLFzbpM05eI6pTp4/xSl89W9XenK+2fApxO0kYzJ4DG5/3lyg1cSphxgi1213IRxXn4s2tY9xAwAA",
    Pbi3DGeometry:
      "ERAAAB+LCAAAAAAABACdV11rwjAU/S95bkOatprq09gGg+1BtsEexAfFooWuHa4biPjfF1w/k9zktsjEnt6ce3Lbe262vpDVLns/f6VkQZ7LXfZW5tmeeGRVZkX1TRbry/9PeZst5YdcvQ7xA8aWty/5R66bZtnd6bQ9y7U+o7Ng7vkhjYJ56CVURDz2AhrGQayiIeVizj3JRmMWJg7YzsEomzNhRzsGxsNZg8qgiDNksIu4L20UcRuswYZy+hENeRRpJfI5jUWsC4HCjeRA+cdyN/hw8/JSBDIKgpXddzkx8LiUQLQz5YQ3OEjkKh7qxRp/A5e43hNPKAuE6MFcxDeYR5IckonFUS0IkVgbthEOtJAK6/ucANu7tgcPaghJUfuZz+iMCb3PNRxIi/IsLHkj0mxFCopW7sCt9md2UAWVzJwnmuwmIQ52WbbJboeoLmMCbE8IeK0CN9SAPhyMTmlz4PaZQwqRuCMrMCUU2CBmEo7Mqjd+g6tGYVaJxMcNUI3FPhNb8cBQVGDDXifhjlHcwcNKQmqmT1cgMfJMg6VXB48aDzgH0MfAUAdIwCMJMNcAM52WFMcNDRJXuPp6QF4DPiZ7fZHhmLfA/BprC9xmOc5BICeC+woq6FizH8ZD/MCDdJxacYc85/kMay7uYuLiXeY1jJf/Xz9k28+0Sk9kIZd45CUtDtWxvngtq22VlUV9+ZHt21tPaXY4VvXFY57+9gPvy7yUhMVPnl83f2Btm6QREAAA",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "7",
    "Area per Person": "106",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "6500",
    Number: "207",
    "Number of People": "0",
    "Occupancy Unit": "Number of people",
    Perimeter: "15200",
    Phase: "Working Drawings",
    "Phase Id": "Working Drawings",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "10.76 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "6500",
    "Upper Limit": "Level 2",
    Volume: "31.47",
  },
  {
    ID: "857195",
    Name: "M_Room Tag: Room Tag",
    Category: "Room Tags",
    Description: "-1",
    "Facucent Drilling": "Room Tag",
    Family: "Room Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Ordinate Dimension Settings": "Horizontal",
    "Short Circuit Rating": "No",
    "Show Opening Height": "No",
    "Show Up Text": "No",
    "Tumble Dryer": "Room Tag",
    "Type Comments": "Room Tag",
  },
  {
    ID: "857197",
    Name: "Bedroom 204",
    Category: "Rooms",
    Level: "Level 2",
    Pbi2DGeometry:
      "iwIAAB+LCAAAAAAABACl0kuLwjAQAOD/Muc65NGpbfe06IKwHooIexAPFUMNxEa6caGU/ncHrCt48XXLzDdMmExWHRQbu2wPBnL49htbeNdWvoYICm/r8Av5qjsfuUBjkorsYyQFktAZ9NHVZIyUEr2DhEKQetw0apW8YRrH3PxpUyj17Qj3KUZF2cM0vPQrIlCq5Cm4bmV9Wftn05Qt754TU1vuTTAN5AJFBHNTV2E3BAsfymD5u5zDH7v9p5mx1Y4vUZKHJIrgy5m/oTjDNFacmnjnuW99dK5fnwAKnoOriwIAAA==",
    Pbi3DGeometry:
      "YwoAAB+LCAAAAAAABAClVl1PwjAU/S99Ljft3co2eDJqYqIPRE18ID5AWKDJ3AxOE0L471YpIF2/hllY1tPbcw6Xe++YbslkLp837yUZkftmLp+aSi4IJZNG1u0HGU23+0e1zcbqIjt6QgacsfHvTX3I7vVw7Gq9nm3UWZ5AgkNBU0BRFLSAPEVBDygCT5IjmsAwZ4UZmoLIhaADAYwJ7MCcgWBJh9kMt8Na0STRMAOOw0CoS89hz8PcI0Nnx48OEsiUZtw3tjKca7l4XYk3cV5AyjHpJK4vHqvr+AE0jClkDNFtM34jIBxXgB0/F+KRqo7a0DAKKBj3mIzE41R1meEQMsz4KZoB5iKnWACmP3kPmQzgvYrbJLFHO5zbO1ejKleCZxji8MN2at/8OAdNExfBEXK2ubbHMIecp+jwFYNGzGajgnwG+o6jmHdBTKiV9uAtPIMiG9OfkC59aDjFHggKOAz1bX1XGoz4PnURGkNGg/r7yz8ozOhedfsfezZi9Y/tRs7eyrZckxEDRslDWS/blV48Nu2slU2tly9ycdy6K+Vy1erFbVV+/Q28bqpGEdafVbV7/Qbx9415YwoAAA==",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "14",
    "Area per Person": "106",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "6500",
    Number: "204",
    "Number of People": "0",
    "Occupancy Unit": "Number of people",
    Perimeter: "15647",
    Phase: "Working Drawings",
    "Phase Id": "Working Drawings",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "10.76 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "6500",
    "Upper Limit": "Level 2",
    Volume: "63.97",
  },
  {
    ID: "857198",
    Name: "M_Room Tag: Room Tag With Area",
    Category: "Room Tags",
    Description: "-1",
    "Facucent Drilling": "Room Tag With Area",
    Family: "Room Tag With Area",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Ordinate Dimension Settings": "Horizontal",
    "Short Circuit Rating": "Yes",
    "Show Opening Height": "Yes",
    "Show Up Text": "No",
    "Tumble Dryer": "Room Tag With Area",
    "Type Comments": "Room Tag With Area",
  },
  {
    ID: "857200",
    Name: "Bath 203",
    Category: "Rooms",
    Level: "Level 2",
    Pbi2DGeometry:
      "gwEAAB+LCAAAAAAABAClkEELwjAMhf9LzjV03crsPA0VBD0METyMHTYsW6G2Mqswxv67hc15Fb0l7wvJe8l7yCp16m4SEtjbSmVWd7U1QCCzyrg7JHk/ln4giFDEgq0WAUVOQwED+UDGMI559A/kSClnX7PZzq9sNlO846ZtW3Y+sxc2qrxKJ1tIKFICB2lq10zN0brSKf+msT2ry4x2UtWNv8ICDBnnBLZaPqdhgcuIeWlttfV7zUProXgBgMGiCoMBAAA=",
    Pbi3DGeometry:
      "IQQAAB+LCAAAAAAABACdk1FrwyAQx7/LPTu5XJXM9GlshcH6ULbBHkofUiqt4GLJXKGUfPdJm3Yjks4UUbzfnfdXT+cHmC3N+36roYAXtzRvzpoVMJg5U/kvKOaH0zS4cRwaNOyX3GWI4+MQOjSL87KHui73YW0muMoVsRDCJY4UU/xekGQXLjmipDMm4nkuxVDcl7zD++IjnikuMhrFiYY7UqWvH5gEz5Gof6fpjuvCPXXp4mg/N/JE1f/qG91+RzaVD30/0SXfqBvx1PKG//Zkyk/tdQ0FcmQw1dXab1rj1fnSG1e15odZXVzP2qw3vjUmVu/+Bj4660LC6tvaZvEDD87C6CEEAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "4",
    "Area per Person": "106",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "6500",
    Number: "203",
    "Number of People": "0",
    "Occupancy Unit": "Number of people",
    Perimeter: "8105",
    Phase: "Working Drawings",
    "Phase Id": "Working Drawings",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "10.76 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "6500",
    "Upper Limit": "Level 2",
    Volume: "14.83",
  },
  {
    ID: "857201",
    Name: "M_Room Tag: Room Tag",
    Category: "Room Tags",
    Description: "-1",
    "Facucent Drilling": "Room Tag",
    Family: "Room Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Ordinate Dimension Settings": "Horizontal",
    "Short Circuit Rating": "No",
    "Show Opening Height": "No",
    "Show Up Text": "No",
    "Tumble Dryer": "Room Tag",
    "Type Comments": "Room Tag",
  },
  {
    ID: "857203",
    Name: "Bath 205",
    Category: "Rooms",
    Level: "Level 2",
    Pbi2DGeometry:
      "dwEAAB+LCAAAAAAABACdkEELwjAMhf9LzrWsrXVunkQFQQ9DBA9jhw3LVqitzCqMsf9uYNODQxBvSb6Q917SFpJCH5urghh2rtCJM03pLBBInLb+BnHa9iUuMEFDHvAFo5EIoSNjMhFUztjvjDMqGYv+ZmMn38mH++wVcVnXeYM5cbDW+UV5VUMc0IDAXtnSV0NzcD73Gl/Ttyd9fqOt0mWFEqgtuJQENkY9huWIzqccRytnHN61d2O67AkSLL3edwEAAA==",
    Pbi3DGeometry:
      "BwUAAB+LCAAAAAAABACllFFLwzAQx7/LPWchua5b0z2JCoI+DBV8GHvoWNgCsZEahTH63Q3aTo1Nm05K2t4vl38ud0dWR1hu1OPhRUIOt2ajHoxWWyCwNKq0r5Cvjl+/bpot3AM1+SYTztji8+UG1Ot22UVVFQe3lid0jgwJpyKZE0GzKaYEOU05F91wktB0xodwqxvAv5RPvoxilmYEBcUpJp4zztzHKfnKjjPBxCDv3nJMeL3CbXiRaYqNeojHFScQopfvUIyxfEz3+Bo9/ecXvrM43SccT//Tp+fm7Q8P6YfqFeB96YujkTu6W+VKFc/SygpyRhmBO1nu7L4x7o0trDJlYz6p7WnqRqrd3jbGtZbvPx0vjTZOsHzTul5/AOA/h7YHBQAA",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "4",
    "Area per Person": "106",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "6500",
    Number: "205",
    "Number of People": "0",
    "Occupancy Unit": "Number of people",
    Perimeter: "8102",
    Phase: "Working Drawings",
    "Phase Id": "Working Drawings",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "10.76 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "6500",
    "Upper Limit": "Level 2",
    Volume: "21.83",
  },
  {
    ID: "857204",
    Name: "M_Room Tag: Room Tag",
    Category: "Room Tags",
    Description: "-1",
    "Facucent Drilling": "Room Tag",
    Family: "Room Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Ordinate Dimension Settings": "Horizontal",
    "Short Circuit Rating": "No",
    "Show Opening Height": "No",
    "Show Up Text": "No",
    "Tumble Dryer": "Room Tag",
    "Type Comments": "Room Tag",
  },
  {
    ID: "857206",
    Name: "Bedroom 202",
    Category: "Rooms",
    Level: "Level 2",
    Pbi2DGeometry:
      "XQIAAB+LCAAAAAAABACd0j0LwjAQBuD/cnN75LM2dRIVBB2KCA7iUDHUQGykRqGI/91Aq4si1S13z5HAvdncIN+ZVXPSkMHc7UzubFO6CiLInan8GbLNrT2GAc5QpFwMY0pQEq7gHr2jQCZVb2IUFZHJn8SQcv4zxRxlQgf9jSNNFP3fBKYkFb/bpzV/xfeAts8gR3VdNCHN0JiY4qi9riEjSCJY6Kr0h65YOl94Ez5AW67N/kUzbcpDeCWsijMpI5hafe2GFaaChdbYWRfurS7W3rcPZk3oLV0CAAA=",
    Pbi3DGeometry:
      "igkAAB+LCAAAAAAABACdVl1rgzAU/S95Ti9JTNS0T2MbDLaHsg32UPrQUmkDzozODUrpf1/YtB+Z8cYiijm5nnuu90NnezJdmtfdR0HG5NEuzYstzYpQMrWmqj/JeLb/u3XbbOIOcqAnZMQZm/xe3EkO8/axm+12sXPPJgJknkgqQSitqYZcCkVFAjzVnI4SUCnPjjAHzVRKBfAkwYy7mVvUSQLFzki6qRu0m2OQ5mGhSMhZLlHRrXkIv6RBXpTP4oUpJCieiZM5A5GrnAoNQorkPw3XIPmgjWGZ82l6k9Sq786oh/qhXgX3llB/uTWoSCETGQ+pi4OjHPq5RIS0BeRwpplG8YDTqI6Ioz4qDDShB8cKx3Ck9ZE2bGCXuFzzHpGReKRXbIa0bYXKRHDEL9b8YT3Xb8SOUy8yfID57RNShAc3tCZCUkOKQgUdGAC+fZA/xIP49doX+7ZEfoqw8RXHjszXS3L3Y3NnFu9FXWzJmAGj5Kmo1vWmWTzbelEbWzXLN7M6bj0UZr2pm8V9WXyfG97a0jrC6qssD/MfRxyU1YoJAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "14",
    "Area per Person": "106",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "6500",
    Number: "202",
    "Number of People": "0",
    "Occupancy Unit": "Number of people",
    Perimeter: "15448",
    Phase: "Working Drawings",
    "Phase Id": "Working Drawings",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "10.76 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "6500",
    "Upper Limit": "Level 2",
    Volume: "64.32",
  },
  {
    ID: "857207",
    Name: "M_Room Tag: Room Tag With Area",
    Category: "Room Tags",
    Description: "-1",
    "Facucent Drilling": "Room Tag With Area",
    Family: "Room Tag With Area",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Ordinate Dimension Settings": "Horizontal",
    "Short Circuit Rating": "Yes",
    "Show Opening Height": "Yes",
    "Show Up Text": "No",
    "Tumble Dryer": "Room Tag With Area",
    "Type Comments": "Room Tag With Area",
  },
  {
    ID: "857209",
    Name: "Entry Hall 201",
    Category: "Rooms",
    Level: "Level 2",
    Pbi2DGeometry:
      "iQIAAB+LCAAAAAAABACd0ktrwzAMAOD/onMmLL9ip6exDgbbIYzBDqWHlJnU4MUl8wah9L9P0G6HPaDpzdInLGF5tYd2E5+mXYAG7vMmtjlNfR6ggjbHobxBs9ofj1ygFJK2tNBojbJwqH7TFQmsqZbno5ZYK+8vQ2ekXHgkR3Qu8TCCyM4ltE74i+Sv1/pXSKGRSs8kSVgL52bSz3Wuv5Z+PY7dxJvnxDJ2r6GEERqBooKHMPRlewoec+lK5M9yDJ/jyzfdhdhvuQd3V9KYCm5T+DgVe3Racuomp8z3Du8pHdafmN5BR4kCAAA=",
    Pbi3DGeometry:
      "YQoAAB+LCAAAAAAABAClVk1rwkAQ/S97Xpf9SrLRU2kLhfYgbaEH8aAYdCHNFpsWRPzv3bZq03Um2SiiuG8mM2/n45HJlozn9nnzVpAhuXdz++RKuyCUjJ2t6ncynGx//3ozH/kP2dE/ZCA4H/38+C/ZTQ+PXa3Xs41/VgqWcWOoZmmiUpozo2VChWKJVDpAFUsNz/1JGCGOoGJCpyJw1ZJlKs+pz8wykcnQ+wRHQnMh0gCFGcM04AienEmkjLoImg2Ii5YCyIYVqLXyPdox4EyaxFCZM6mlCrlJzQTP8tN+CO/PM9FtgMuP9bvDGwl+YIkV6wSPZt9t6OhT0FUfRnM/EN/uuR+XsPwo03hDv3FqhIHdIfboWDfRxlWRCkTA7XsEDvY/EGHcD45I17aGxx2CmUWgbblgIQjQgMIZaGs2WPwC9BAXoRYHn6ftkFYg7OLgONVCpPWC3W4aIPk4V9UBFULCI+uCqHFP6UO0BqQOrg0yREhTseuAobEY4O60r1/kDWF2MA//vnZjZ69FXazJkDNOyUNRLevV/vDo6lltXbU/vtjF0XRX2OWq3h9uy+Kz6XjtSucDVh9luZt+AUaic8lhCgAA",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "30",
    "Area per Person": "106",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "6500",
    Number: "201",
    "Number of People": "0",
    "Occupancy Unit": "Number of people",
    Perimeter: "35701",
    Phase: "Working Drawings",
    "Phase Id": "Working Drawings",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "10.76 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "6500",
    "Upper Limit": "Level 2",
    Volume: "123.46",
  },
  {
    ID: "857210",
    Name: "M_Room Tag: Room Tag With Area",
    Category: "Room Tags",
    Description: "-1",
    "Facucent Drilling": "Room Tag With Area",
    Family: "Room Tag With Area",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Ordinate Dimension Settings": "Horizontal",
    "Short Circuit Rating": "Yes",
    "Show Opening Height": "Yes",
    "Show Up Text": "No",
    "Tumble Dryer": "Room Tag With Area",
    "Type Comments": "Room Tag With Area",
  },
  {
    ID: "857279",
    Name: "Kitchen & Dining 101",
    Category: "Rooms",
    Level: "Level 1",
    Pbi2DGeometry:
      "UAQAAB+LCAAAAAAABACl01FrwyAQAOD/cs+JeGq0yZ7GOhhsD2EM9lD6kFJJBRdL5gah9L/voEsZ2yiJfRH1O/Q8vNUB6o17GfYWKngMG1cHP7Shgwzq4Lr4DtXqcJpSgBCs4Fre5IIphQqO2V9TjMbZUuhippSMI0+gAsVkylEzwTGRcuR0siyn47m+V6EqFyYBDTPazDDJUJeYbv8+4yIqtuCivAYFMyjkdBvTSTVF9vv/XrKx3qk29uV6bN/bvm8G6mHaWLrmzUbbQ8UZz+DJdm3cfS+eQ2yio7Y/LV/d9kwP1rU7ugQpbyFVBvfefv4Mvgs+0KHdh/fH9RdNIrslUAQAAA==",
    Pbi3DGeometry:
      "WU0AAB+LCAAAAAAABAClW11vHTUQ/S/3Obna9X6XJwRISPCAAIkH1IdWRDRSaFAJSBXqf8e717v2jM8Ze4uqpMnJeDye8Xz52r/+e/nh7ePPH/98uLy6fPf89vGn56fH3y53lx+eH9+//HV59eu/tx/9n5sv/L/Lp7uI3LdN88X2zX9dPr3eh3354cObj37sfXN109TdNdd+mUf/X3Pn3HVoxu5uuQ6tGxTUtM0N8gP7bdw4DhMbB7h7qG2b1v/cNW5m3Heovw6jFiHlPi7bz3PTuB1aumadcF7miVFhXmQ5uQj9df2+In4tzi3bmobekjMTqr22c7NqZBlmqYV7d+37tg/8XdO5bQnjAbVzt4nb9NbAQLW0M+MELGHuhsM4YNX+y/Ub27nriPoMy0einFG+YEPr0TSmVjLdxXHAMh7qu2ndOsu0BGT0+myFkQGR33jdIjmBcYjV0vdO7BfnpXJipwMiyCqTIWflVdRsKjo2f6WgYKBX6LKpIXo80mjGC/mNu07jthniBnXrcpd0f2C5MiEALzhwWaZebK377toM0yC2TaV6/MhpmqTTBTIfkv16u4VPYQyWEmcKQYvgAmeSZLNG6fZo4rprOy5+bH+d2j067pjXdOuCE/Z+l62ummBZaDo8NWG2u7jfOuPcifCxbmk3jGm0WH2vGVvJbfIGnyZGBiYgchBhk7CCB3LJUqUBaQ9FptiuyNRYByEEEcd0ZmAaSIckRCuxtgQam2DItAddu3nxQbjlJ084u7YrC6gG57NYukYbWTiLJU06cwqmo/vb4GWehyqGcezu4ql/hEiQbjns4yEUpnrYI2Y6Mxucz4IYksFbvhBrJoS5OKGOW/OXs3QTqi1P51wrk7PHuqY9svqWlla6uTWkxrOg0WjmW7ZNhN4Tt5QPKSHk7qKA/5MjUA0Q+n+ZEyir1icYnd4L0CUKyVYH9bx6vCHzdR48Sx37z8GlifIuY0UUMyiPAdpTgIYrQBkzKAsFi5Owsk9xw9KYKKslixVbxu40eqrQ0mBgiYWqQs8FsAxUTD8br5oRpsYN1N6jpqvGyzMaRQlgyoQz8VMlnsI0z8+Ci5OZ9eTOlEhWB/PprDorYDtPXX6dxU/VdZRrST8lvFzJGwW1Zqo0VAcXJ0N0xBafBdPJrL6KJFalmDr4TBPHWBYsY8NGxzh141q/uNnXY2G06lMxehveLl27VjXTvOxtrzjzm69tt82FzhTzsR7qb9CQzIs5tsNNmqbv3D4cCAhW4lk1/Q0e2uGo7rJGTWNx+NyuJagvBCd3NAp5Ga6wfbi7jnMzr1z96KNiF1gkzVsS3Awt/dxqO2rSI3v6YnTYClk3tPK8TFXpAovL76Zhm2xpequvTKE4t6/VbnMv7cRg1DgUOYiWgsBBsmF284p5PRxYVtxLKK7eb9JJWg+00BqzLVpj/OiG+pQ9ASKRdi7PpmvmRasYtahQkb6DGadRsiQHdykW3RW6NooB2Wpucy96dI1I1dEiSpQSYjQMx4TaOCLAVsfcQJge5x2EiKM+9yN6yGFTwSpOngifxFtOOFFcbrY2LBZWFxG2goERxFQEtAOjiDWRtBSC7GAtsMgU5SAQ10T6iqNxuCPExRRok1aIgJZq5SWsFRQvS54bORZDJiGNMXz7VdgZnWApLPFLdztfOgKPxuJM4CjKq3nRugPHdhKLHNGR7dy1YxYRFGlSf6TUJzgEUl+vtnLn5KeEAons+mXppCvi1ItyLFRmnd4LllOHgAqKPNHCBRb3HbInOnFNt0IcDUssLCjKtVB4aHRQs8LiFFtOYAkpcCRRCe8Y+OACmg3X5mhrog1f2cAYbQ20Z53pba3UKBBXGNV1h50GScbMC+e6+h6Rmhu9FAlt34MhBloFdkKkBsC1BaoMKhgESUW+OZGGLJPUWY948ImQTLzwhHPamRumaPyhGjwMIKUsKnxpdCPZD8VM0tMXA1wkzXMl2R5wf6M9Ux5vJctyVrSsUmfAQndIGkkgAm5SajYBL74qkrAR2RAdTOBkk1ScEdHDrLqeQwvgh3bCK8QtIQKrgmPoulNNrTU8WH/w8Sy1PuHqbkK5aRmlo6WC0jVtLh2OONJYJa+WpZBKLb5L6hd+PU9Cateut7qaSWzaAKnondxXa8A9yFvSl2aUdDLF+v3g4hXG/C6igFRq2NLcoStwyy+FVKT3HMd5IWjaNaqp2fDkXiUE03Doo0knKgV5zzFBVCZLjQSvD6YQt1uVgfNYJ679pVgeQaMPhcAkFZtfQs3VF8/6DmbwUwFYFXPPRU4O1hIr85RBWaYTwUDnuEBKYJElc9LMRCqgIsyKpvLGJonSgJKrhHU1SM8qGFaHSOwu1U6kUlwjrqsSgaCWgJjl4UbMkvHOjIJJgFGFGYs6VjxOENVF2ve+ZUKSZV8W2jBpIaMZhBWT58szsg1UAwmLFe4Z2dqREdOpti8xavY4RCLR4Ybbu4QjrCgoEuoHDHtNl6oMvmVJIVXyyocc27G68gpJGNGUtnp4INxOj9M9Al/lpJA6nEidDCZUkDrhE5QKVZuWCn188swkQaLQYMEppKpx+9GPMrtqo6SzQAnznImF1haG9SWoJKGNUkgegCQuourVIBywGrAPqZzzzYe2c21rYXYc0PfKZqbaqNFauWErVAh2DQ/THHisUyzCAZ25lwuBzfQsHDeQIWCXAlM2LgPyRF4c3CQHgpKukEIM/dcYCjtndVjFTlbtemaSRfkUvkED7TcuLEERykIVzlkg9OFGuhCuIkeQ3+AewJs33xnFwWZ+szOZYYQaa1ndGWnjwOSwPSibmxVGNUmTBylABbMt2A/lExhQTtfW+wEt3XIXN8CZYwOUcsjjknnDX8pFS0oc4YFHfIZcGSlgi5238GQiWS45o4ILw3JBV8CtOrnpSvv6IEk8IC9clc1sRtJBbkmoGxh/WaUNSLHCC/MnBqNFfa5vNp5TKhWypxe4nYTHmoQB7ocBW3KkgFr2U3MR2nq+rJSCRxH4NAgeI9e/y6GLqDcEK6HR4RfjgA/K0IoxB3KMQU412Usc0uGceVHEmyR4zELUwT6EAXrGH/fZK6GvPc49iZDX9PEdVPICwAzB8jlMwy5moI+q+XTwfiziXHoGoTNM9UKobFAK9iSm9LRGzVmwLHlpUSU4WybhXaCuYnKPb2mw52Rkk5T2DnuURlR70pn4Czn2HE8tqaQBEdLItRbynoHERXr/A97U4FzI/Rh86YVyYbczsYhwTs6cXCNC9wIMncO7z+z5J7sADK/mkisKmMn5J6rsGhm4UkNoOWvyAIbcQMbU5+zGyfP1cF0R+xDe0PjGVkF+SG4R0dUAN3x9d/n68c0fDy8PHy6v1gb68v3D+99f3oVffnx+efPy+Pw+/PrL42/Hn759ePz93Uv45Zunh39Swq+en549w/d/Pz19ev0fuKFfU1lNAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "73",
    "Area per Person": "106",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "4000",
    Number: "101",
    "Number of People": "0",
    "Occupancy Unit": "Number of people",
    Perimeter: "40088",
    Phase: "Working Drawings",
    "Phase Id": "Working Drawings",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "10.76 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "4000",
    "Upper Limit": "Level 1",
    Volume: "195.92",
  },
  {
    ID: "857292",
    Name: "Laundry 104",
    Category: "Rooms",
    Level: "Level 1",
    Pbi2DGeometry:
      "8AEAAB+LCAAAAAAABACdkcsKwjAQRf9l1jHkVftwJSoIuigiuChdtBjaQEykRqFI/91AbXWp3c3Mucxw72RPSEt1bK8SEtjZUqVWt5U1gCC1yrgbJNmzL72AMywiLhYzhkPKOHTow1iIaRyx/1mAuRDz6YwSHBAe/w5HF9NhhBmdwgYf+RDvsmmK1mfsB2tVXKSTDSQEEwR7aSpXv5uDdYVT/i19e1LnEW2lqmp/hHLsVwsEGy0f3+KV1dYvNXetu/wFvPi33/ABAAA=",
    Pbi3DGeometry:
      "3wUAAB+LCAAAAAAABACdlNFqwyAUht/lXFsxmqw2vRpbYbBdlG2wi9KLlEoruFgyNygl7z632mxNNSYlJMTP43/+HI9ZHGC+kq/7nYAcHvVKvmgl14BgrmVpPiBfHI6vdppM7QU1+iOjhJDp78PeUC9Py26rqtjbtTTDLE1vkA3BGWETRDBBDaR4nFB2ZGOcTDg9Z97FnkBGccpZikYc08TFNSwSN1jP+yUxh23GMc84uzA5DEfr1sGcZMBXTxxN1lmrk2jAWT8cTOfdrwvYVr2WxzP6Wsmx9va2kvXmVx2FQIsFrHXjvueuu81DzRfai0h4P5Vokc+tD/ToV7F/y3tZvAsjKsh/6gRPotyYrRs8a1MYqUs3fJPrZupByM3WuMFMia//gXdaaStYfipVL78B/LGVQ98FAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "5",
    "Area per Person": "106",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "4000",
    Number: "104",
    "Number of People": "0",
    "Occupancy Unit": "Number of people",
    Perimeter: "9102",
    Phase: "Working Drawings",
    "Phase Id": "Working Drawings",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "10.76 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "4000",
    "Upper Limit": "Level 1",
    Volume: "13.95",
  },
  {
    ID: "857293",
    Name: "M_Room Tag: Room Tag",
    Category: "Room Tags",
    Description: "-1",
    "Facucent Drilling": "Room Tag",
    Family: "Room Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Ordinate Dimension Settings": "Horizontal",
    "Short Circuit Rating": "No",
    "Show Opening Height": "No",
    "Show Up Text": "No",
    "Tumble Dryer": "Room Tag",
    "Type Comments": "Room Tag",
  },
  {
    ID: "857346",
    Name: "Bath 103",
    Category: "Rooms",
    Level: "Level 1",
    Pbi2DGeometry: "eAEAAB+LCAAAAAAABACdkE8LwjAMxb9LzrWsf9h0nkQFQQ9DBA9jhw1LF6itzCqMse9uYU49ym55+T2SvOQdZBWe2puCFPauwsyZVjsLBDKH1t8hzbuhDAbBqZwLuRQ0ESyGnnwRT6iMF2wimnHKkuh/Nh4ylY2nFGPMVdOUbcgaGhssr8qrBtKIRgQOympfv8XR+dJjeM8gz3j5oJ1CXYcdTFDGhSSwNer5a14748JQ+zCmL15CRDJoeAEAAA==",
    Pbi3DGeometry:
      "tQMAAB+LCAAAAAAABACdk90KwiAUgN/lXDtxc7W1rqKCoC6igi5GFxuTEmzGsiBi757V+kFWsxDF851/D8ZnmKZ8cdoxiGAsUz6XgmeAYCp5rvYQxef7VatJVy8o0Ys4LiHd26E3lKuHW68okpP2pR72Q+ojigPqthHBBD2Q42E3IHfmBdhvd1xrVhPuDdVYGSjEYSukpu8vtCHPt0aqgPUlWdFPmeqe1mRGxP9wU7LP8zFe08hjie3m/r2l/yqwGJb+AwOebJliBUTXsmDC8rXaVMJMqkRxmVfikmdP1Yjx9UZVwlCw47thXwqpA+YHIcrVBTYYokq1AwAA",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "3",
    "Area per Person": "106",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "4000",
    Number: "103",
    "Number of People": "0",
    "Occupancy Unit": "Number of people",
    Perimeter: "6655",
    Phase: "Working Drawings",
    "Phase Id": "Working Drawings",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "10.76 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "4000",
    "Upper Limit": "Level 1",
    Volume: "7.42",
  },
  {
    ID: "857347",
    Name: "M_Room Tag: Room Tag",
    Category: "Room Tags",
    Description: "-1",
    "Facucent Drilling": "Room Tag",
    Family: "Room Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Ordinate Dimension Settings": "Horizontal",
    "Short Circuit Rating": "No",
    "Show Opening Height": "No",
    "Show Up Text": "No",
    "Tumble Dryer": "Room Tag",
    "Type Comments": "Room Tag",
  },
  {
    ID: "857426",
    Name: "M_Room Tag: Room Tag With Area",
    Category: "Room Tags",
    Description: "-1",
    "Facucent Drilling": "Room Tag With Area",
    Family: "Room Tag With Area",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Ordinate Dimension Settings": "Horizontal",
    "Short Circuit Rating": "Yes",
    "Show Opening Height": "Yes",
    "Show Up Text": "No",
    "Tumble Dryer": "Room Tag With Area",
    "Type Comments": "Room Tag With Area",
  },
  {
    ID: "857545",
    Name: "Hall 105",
    Category: "Rooms",
    Level: "Level 1",
    Pbi2DGeometry:
      "MwMAAB+LCAAAAAAABACl0k1LxDAQBuD/Muc6ZJJpTOtJVBD0UETwsOyhi6EbiI3UKJRl/7sD6xfLsnTrLZNnmAzhXWygWYXH8dVDDXdpFZoUxy71UECTQp/foF5sdkdpMAYVkb2okBwRbItf0hpLZc1MYjQV82Q6R6qcPpFkeWJLM+lMIzPNMIeaTHW6ESFrbacja3Ql/w+V/PneQpOQ0Zbm8NAjdCAQR2g/fMvviF4OQztKTuXiOrQvPvsBaoWqgHvfd3n9VTyk3OYg0d6VT+H5h2596NbyhpPHnSngJvqPv71XKSaZ2b/HuF1+Aq4aitYzAwAA",
    Pbi3DGeometry:
      "4g0AAB+LCAAAAAAABAClV1FrwjAQ/i95rqFJY231aWyDwfYg22AP4oNi0UDXDtcNRPzvy1y72fTuknaIYj6/fHe53l3OxZHN1/r58JaxKbsv1/qpzPWGBWxe6qJ6Z9PF8eer+TmcmRc7BX/ISITh7Pxh3uy0bLZd7ferg9mrJE/GSgSGwsdhlAaJWSdR0OCKx+MobtAo4kLFhi25UkLZsOJRqhQt0aApF4kQNmq74TA4SrgUXadHQnARxx2bqLrFx3CnTtsdOeEiTaQVFkMOhYitAEhpFOPIRkEFhFujFhfzAXhgsGcoF3owaNp4C8P5YR0u5KEdhTPUPiwGdTdaDtbQpXeIFrGxiQwiZkUKEbOi4a/VSVXMNdgPzILjnLTVujpamKkwJSXh82VN00xQEzEOp6MdfSjFnNCQMsdFgbzFoSH9ARD1qyKyNfk0Ibic7MxzQ8M6HSYKlS2FDemSpC5UJQTmaam5ySZm1yRx33yIOibjKm0XkRLtcZSuvQasyY5u0iZjIt64R/9qn8U1jeEDCabzz/bqkAVw8jigG47hihQBbjwc8jQEswFZ+p6mB90+Q7FzUHFApBHvsuqRAz65gdn1yT2fWd0bp+2aP0w3evWaVdmeTb9jyx6yYlvt6sVjWa0qXRb18kVvfn+6y/R2V9WL2zz7vCRel3lpBIuPPD8tvwBbVBoa4g0AAA==",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "23",
    "Area per Person": "106",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "2700",
    Number: "105",
    "Number of People": "0",
    "Occupancy Unit": "Number of people",
    Perimeter: "24964",
    Phase: "Working Drawings",
    "Phase Id": "Working Drawings",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "10.76 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "2700",
    "Upper Limit": "Level 1",
    Volume: "62.83",
  },
  {
    ID: "857546",
    Name: "M_Room Tag: Room Tag With Area",
    Category: "Room Tags",
    Description: "-1",
    "Facucent Drilling": "Room Tag With Area",
    Family: "Room Tag With Area",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Ordinate Dimension Settings": "Horizontal",
    "Short Circuit Rating": "Yes",
    "Show Opening Height": "Yes",
    "Show Up Text": "No",
    "Tumble Dryer": "Room Tag With Area",
    "Type Comments": "Room Tag With Area",
  },
  {
    ID: "857552",
    Name: "Living 106",
    Category: "Rooms",
    Level: "Level 1",
    Pbi2DGeometry:
      "LgIAAB+LCAAAAAAABACdkU8LwjAMxb9LzrOsbfbXk6gg6GGI4EE8bFi2Ql1lVmGMfXcLUxGcMnZL8gvvkbxDA0kmd/VFQAxrnclEqzrXJTiQaFmaK8SHpivtAjISekinE4xIGCC0Tg+jlCBj/nDILaQYjIDMIxyjcAxEEkTBL9m/kBPqRz9OGQZ7vvePfX39+ApnVlVpbROyg4VMz8KICmKXuA5sRJmb4tlstUmNtKF27V6e3mglZF5YE2r9GUcHlkrcP5fnWmkrWt6Uao8P3aA7hC4CAAA=",
    Pbi3DGeometry:
      "/QYAAB+LCAAAAAAABACdldFqwyAUht/F61SisTVJr8Y2GGwXZRvsovQipdIKWRyZG5SSd5/rkm0xnmhKSIifx//86hHXJ7Tayufjm0A5uldb+aRKuUMRWilZ6XeUr08/v6Y7XpoHNdEfmZE4Xp4/5kXNpht2VdfF0YylCSaLjEQzQjCjdBHFOI4owzzj3IJdJMtwytmZJRSnhFmBzMA56we6BrvixgV7duY4YVnq9xg8GadiuKEB5JgSng6mOQ2D6ZzGBtBWvZSDGd3bYMNWFrIXzOGMzk22YSsL2Qvm/rIahZ0sZC+U+zOOnMBOFDIXyqecbqDmfdbG8cRkUMl7j05fBgqHTEN76ltmSwaqUHf4VJOQutu8uUtuZPEqtKhR/r3i6EFUe31oG49KF1qqqm2+yN1v152Q+4NuG7el+PwfeK1KZQSrj7JsNl9Axyq3/QYAAA==",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "70",
    "Area per Person": "106",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "4000",
    Number: "106",
    "Number of People": "0",
    "Occupancy Unit": "Number of people",
    Perimeter: "35440",
    Phase: "Working Drawings",
    "Phase Id": "Working Drawings",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "10.76 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "4000",
    "Upper Limit": "Level 1",
    Volume: "154.7",
  },
  {
    ID: "857553",
    Name: "M_Room Tag: Room Tag With Area",
    Category: "Room Tags",
    Description: "-1",
    "Facucent Drilling": "Room Tag With Area",
    Family: "Room Tag With Area",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Ordinate Dimension Settings": "Horizontal",
    "Short Circuit Rating": "Yes",
    "Show Opening Height": "Yes",
    "Show Up Text": "No",
    "Tumble Dryer": "Room Tag With Area",
    "Type Comments": "Room Tag With Area",
  },
  {
    ID: "906885",
    Name: "Basic Wall: Interior - 165 Partition (1-hr)",
    Category: "Walls",
    Pbi2DGeometry: "BwEAAB+LCAAAAAAABAB9jksLwjAQhP/LnmPoI/blSVQQ9BBE8FB6aDG0CzErNQql9L8bqBZF8Laz3zAzeQ+ywmN3VZDBjiqUpLuaDDCQhMbeIMv78XSGIOYiSv3FLOBC+AIG9ssE96Lwm0Q8DWLxh0x5xbt22bZl57rdY43lRVnVQuZxj8Femdo2L3EgW1p0c0d5wvOEtgrrxpUkPJknIYONVo9P74o0uUxz13oonjpk4lAHAQAA",
    Pbi3DGeometry:
      "uQMAAB+LCAAAAAAABACVU8kKwjAQ/Zc5x5AuNrU9iQuCHkQFD+KhxWADtZEahCL+u7HWurWxZUjIvMmb5YVsLjAP+So7MvBgKkK+FDHfAYK54Ik8gbe5PI4qTHxlcEUvpGMQ4uebWnDdPmn9NA0yxTUptp2egSxMLcNBBBP0BbnY7bpWiXZMbFDSFq7Im0MO7pnU/mEX8FcHn+g7X5NSV6aqSQ39T+F6JTUqNJq4Rp52T9HsOZtVrFVKM7C+rWY669XSDvpKqv7AkAcHJlkK3r0IzFiyl1HhLIQMJBdJ4a75rgxNGN9HsnBGMTu/XxyIWKiEQMd3U1/tBlwwTIG5AwAA",
    Absorptance: "0.1",
    Area: "5",
    "Assembly Code": "C1010145",
    "Assembly Description": "Partitions - Drywall w/ Metal Stud",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Coarse Scale Fill Color": "0",
    "Coarse Scale Fill Pattern": "-1",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Interior - 165 Partition (1-hr)",
    "Family and Type": "Interior - 165 Partition (1-hr)",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Length: "1983",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Wood - Stud Layer",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Ceiling",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "0",
    Type: "Interior - 165 Partition (1-hr)",
    "Type Id": "Interior - 165 Partition (1-hr)",
    "Type Image": "<None>",
    "Unconnected Height": "2700",
    Volume: "0.8",
    Width: "165",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "906922",
    Name: "Mech. 102",
    Category: "Rooms",
    Level: "Level 1",
    Pbi2DGeometry:
      "sAEAAB+LCAAAAAAABACdkM0KwjAQhN9lzzHkpza2nkQFQQ9FBA+lhxZDG4iJ1CiU0nc3UBVREeptZ79hl5m0haRQu+YkIYa1LVRidVNaAwgSq4w7Q5y2/egNjGMaRnTKseA0hA59ohHDVJABbIyJ4JPhLMQRE8Hf7FuEH+gtePaoZ1bXeeM78ouFyo/SyRpiggmCjTSlq+5ia13ulK+1l3t1eKKVVGXlf1D/gvEAwVLL66t5brX1R81F6y67AVCAi7SwAQAA",
    Pbi3DGeometry:
      "tQQAAB+LCAAAAAAABACdlNFqwjAUht/lXMeQNLOt9WrMwcBdiA68EC9aDBqIzahREOm7L7rUzdKmjZSUnC8nf/4kh6wuMMvE1/mbQwJTlYmFkmIDCGZK5PoAyery2zXDZGw+KNEfGVBCxrefaVCuq2mvRZGezdxgiEnEYjQIMI1IiAgmKGCYhiOKGI4YtSjEoyB6eUANWQ6xB9aU17CCRZ1yNRbjeBizukEf6mW8xmqKz+GuU3KxSrLFVz/ctVh7bVSCLa76YY+aa75Ppycn7VnbbkkfU25hr6LuddfmDZiIdM81LyC5bg0+eb7VOxvMlU61ULkNl2JzH/rgYrvTNniX/PQ/8U1JZQTzo5Tl+gc6C8X/tQQAAA==",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "2",
    "Area per Person": "106",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "4000",
    Number: "102",
    "Number of People": "0",
    "Occupancy Unit": "Number of people",
    Perimeter: "5889",
    Phase: "Working Drawings",
    "Phase Id": "Working Drawings",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "10.76 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "4000",
    "Upper Limit": "Level 1",
    Volume: "5.56",
  },
  {
    ID: "906923",
    Name: "M_Room Tag: Room Tag",
    Category: "Room Tags",
    Description: "-1",
    "Facucent Drilling": "Room Tag",
    Family: "Room Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Ordinate Dimension Settings": "Horizontal",
    "Short Circuit Rating": "No",
    "Show Opening Height": "No",
    "Show Up Text": "No",
    "Tumble Dryer": "Room Tag",
    "Type Comments": "Room Tag",
  },
  {
    ID: "906937",
    Name: "M_Double-Flush: 1730 x 2134mm",
    Category: "Doors",
    Level: "Level 1",
    Pbi2DGeometry: "zAAAAB+LCAAAAAAABAA1jcsKwjAURP/lrkNI06a3jStRQdBFKYKL0kXU0AZiIjUKpfTfja/dMHNmppmgOpnDeNMgYedPptbnoFxnNRCovHHhDrKZvjIinNMiRVwwiqVIYW7/1HIY1BjRaKyNuuqgB5CMMgJ77brQg8xpgpkgUPuggvEOZEIFMizzlOdYZkUZw6O5vFlGkxxTAlttuj7+IuWCIYGN1c9f+bO98tbHH/ewdm5f8qRWyswAAAA=",
    Pbi3DGeometry:
      "XhQAAB+LCAAAAAAABAClV8FKw0AQ/Zc9x7DZtImtp9oKgh5EBQ/SQ4vBBmojNQgi/XdjTZvNZufNpFIs5nX2vZfZmdnk+VvdLfPHr/dMjdVNscwfinX+ogJ1V+Sb8kONn7///q1+1hfVR+2CBjmLtL7Yf1V/ajc/LJtst4uvaq0x4cAM4iAOz89NEqShGeo0aNAkjk2Fah3FR/TMhHqwD27B/mCKeI/qUNusZmTcQEKrDnbWg0i/Pu+qvikPRCTFc0vY5VAnrkwN2WbsKGdtW+UA2WZamF+5gzr5wRS+YEgsMNbZOHCz/kCRV7QrDAwyjkqCqFKOkrl9Yd3RYb3T6+9WGoXNDqSo8gIdLLIl5KWb0TMsKAgOGqbdaYieUMwcY+i5EQHHPT8v8SyTNWKPgyiuch9FrSpsoKYpHMy/+rCPOJg00IvZdWun9gg1Gw21KbRVnNCQPxby1raiZERA9v3YUENnr22kQWw3yScQd6w6hXLArB1C4jTczjPw5I/FxLiqT8mWvLKkjcHL0RVDNwXwyRYgU7lM29FRDD1XBbAHKYP/Ky16KolsCXlBL3mKmIDg8OS6FWDolGAOE1aCbUXm0Og8G+owHQ1j9+isUenbgeDBvKOTpHHqEuyxtrYNOYsxJVYirCIGoQmQ1V6pgSidL2r7JPtMKfh2SVoOfCWxEuz29H3tgs+Wsjzyqe2IUNlt69qQsxYyQp3eZSY0ALLZJykQpVN10vsIk/mT+4utnn/ONlETzwM1yxdvWZlt1fhXRN1mm9dyVV/cF+WizItNffmUvxx/us7y11VZX1yts087cFqsi4pQzabTy8lE7eY/Z0JoOV4UAAA=",
    "Analytic Construction": "Metal",
    Area: "5",
    "Construction Type Id": "MDOOR",
    Cost: "0",
    "Define Thermal Properties by": "Schematic Type",
    "Design Option": "-1",
    "Door Material": "Door - Panel",
    Family: "1730 x 2134mm",
    "Family and Type": "1730 x 2134mm",
    Function: "Interior",
    "Head Height": "2134",
    "Heat Transfer Coefficient (U)": "3.7021 /(·)",
    Height: "2134",
    "Host Id": "Wall - Timber Clad",
    Image: "<None>",
    Mark: "105",
    "OmniClass Number": "23.30.10.00",
    "OmniClass Title": "Doors",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rough Height": "0",
    "Rough Width": "0",
    "Sill Height": "0",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.2701 (·)/",
    Thickness: "51",
    "Trim Projection Ext": "25",
    "Trim Projection Int": "25",
    "Trim Width": "76",
    Type: "1730 x 2134mm",
    "Type Id": "1730 x 2134mm",
    "Type Image": "<None>",
    "Type Mark": "65",
    "Visual Light Transmittance": "0",
    Volume: "0.21",
    "Wall Closure": "By host",
    Width: "1730",
  },
  {
    ID: "909735",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry:
      "1QAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7yGm5ub6xQlBHUQCTqIB62hg7WFrUDE796iuj0ev9979QxlZ07TXYOCg+9MpS+hdb3VgKD0xoUHqHr+xohQjrOM8vWK5VgKBkvzxzbj2E6RjcXOtDcd9AgqwQmCo3Z9GEAxLChjCCof2mC8A5ViymSWkFQKmXMiqShWhCM4m+tHiLZMUwR7bfohvhMsBBEICqtfvwWOCU9yBFtvffxzT2uX5g2noDqw1QAAAA==",
    Pbi3DGeometry:
      "JQQAAB+LCAAAAAAABACdU9GqwjAM/Zc815J1bq7zSVQQ9EH0wn0QHzYsWpirzCKI+O9W3byXyciU0tKcpCfhNFldYJ7qn/NBQQxTk+qlyfQGGMyNzu0R4tXleXVu7LsFV/aHdDzE/uNwG67r6tmgKJKzeysijqLbY50AOXoyYgH3ApTsDQ+5FCJkwuc+ov893sRf4VV8V3Lph8GLp4qn8Dp/Ha/zU3mb6m/i+bQeSoe2urXN21bP+j9+2idN/JTOlP5UnVQfUnnb9gn1X09+N28jneyVVQXEzsNgpvKt3ZXGwtjEapOX5q/evFwTpbc7WxrjTJ3+Bw5NZor7vGOEw/tY3wCfbaa+JQQAAA==",
    "Analytic Construction": "<None>",
    Area: "1",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "540",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.02",
    Width: "1440",
  },
  {
    ID: "909736",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry:
      "0gAAAB+LCAAAAAAABAA1jUELgjAcxb/L/zzH5lyb6xQlBHUQCTqIB62hg7WFrUDE796iuj0ev/d79QxlZ07TXYOCg+9MpS+hdb3VgKD0xoUHqHr+xogwgjmn6yTLsRQZLM2f2oxjO0U0FjvT3nTQIyiCCYKjdn0YQGVY5AgqH9pgvAPFcJrJFaFMCplzKlNRJJQjOJvrB49byRiCvTb9EK8pFoIKBIXVr5+BY8pJdG699fHNPa1dmjdNKoh10gAAAA==",
    Pbi3DGeometry:
      "EwQAAB+LCAAAAAAABACdU1ELgjAQ/i/3PMe0Js6eooKgHqSCHqIHo6EDc2EjiPC/N1MrDJvG2Nh9d/vu+Ha3u0NwEJvbmYMPC3kQa5mIIyAIpEjVBfzdvbxqNxnpBTl6I5ZNyOh56A35vn42zrLwpt8OHMyGLrIowcRmHqLYpoShJuxi5jgucjztpux/vIW+gl/hQ4bZwKU1TR1ugBvkDfiL3JC0rfY2nn7VmBToJljHnN1kbPxdv85o4TaKaxL9d43GvjOl7dobpm8q+fV0TUV44opn4GsPgiVPIxVXxkqqUAmZVuZWHF+uORdRrCpjlvDrZ+BEJjIrppt4ZFIM8QNzepSeEwQAAA==",
    "Analytic Construction": "<None>",
    Area: "1",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "540",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.02",
    Width: "1460",
  },
  {
    ID: "909737",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry:
      "0wAAAB+LCAAAAAAABAA1jUELgjAcxb/L/zyHc1ub6xQlBHUQCTqIB62hg7WFrUDE796iuj0ev/d79QxlZ07TXYOCg+9MpS+hdb3VgKD0xoUHqHr+xohQjpnIsnXCciwFg6X5Y5txbKfIxmJn2psOegSV4hTBUbs+DKAYFjmCyoc2GO9AUZwxuUoJlULmnMhMFAnhCM7m+sHjVlKKYK9NP8RvgoUgAkFh9etn4JjwNDq33vr45p7WLs0b7GzsvNMAAAA=",
    Pbi3DGeometry:
      "JQQAAB+LCAAAAAAABAClU00LwjAM/S8515Jt7qPzJCoIehAVPIiHiUULc5VZBBH/u1U3lcnIREpL85K+hNdkeYHJWs3PBwkxjPRazXSqNsBgolVmjhAvL8+rdWPHLriyN9JyEDuPw264rspn3TxPzvatF/IoCF3W8pGjIyLmc8dHwb7wgAvXDZjncQz/wev4S7yMbwsuvMB/8ZTxFF7lr+JVfipvXf11PL/WQ+nQVLemeZvqWf3HX/ukjp/SmdKfqpPqQypv0z6h/uvJb+etr5K9NDKH2HoYjGW2NbvCmGqTGKWzwlyozcs1lGq7M4UxSOXpM7CnU53f5x0j7N3H+gYl9EYMJQQAAA==",
    "Analytic Construction": "<None>",
    Area: "1",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "540",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.02",
    Width: "1460",
  },
  {
    ID: "909738",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry:
      "1QAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7zG5qab6xQlBHUQCTqIB62hg7WFrUDE796iuj0ev9979QxlZ07TXYOCg+9MpS+hdb3VgKD0xoUHqHr+xohwgllGxHrFcywFh6X5Y5txbKfIxmJn2psOegRFMEFw1K4PAyiORcI5gsqHNhjvQDGccJkRyqSQeUplIooVTRGczfUjRFsyhmCvTT/Ed4qFoAJBYfXrt5BimpIcwdZbH//c09qleQNngFE+1QAAAA==",
    Pbi3DGeometry:
      "JQQAAB+LCAAAAAAABACdU00LwjAM/S8519JVO9d5EhUEPYgKHsTDxKKFucosgoj/3eo+lMnIlNLSvKQv4TVZ32C21cvrSUEIE7PVCxPrHRCYGZ3YM4TrW3Z1btZzC+7kjbQ8xnqvw224b4pn/TSNru5th9Mu55K0BKPMkwER1BNMki/cp5Jzn7S7VMpA/I/X8ed4Gd+RVLZ9UfCU8Rhe5a/gX/xI3rr663h+rQfVoaFujfM21bPyj7/2SR0/qjOmP1In2odY3qZ9gv1Xxu/mbaijo7IqhdB5CExVsreH3JgbG1ltktxc6V3pGiu9P9jcGMXq8hk4MLFJn/POAjZ4jvUDWKnCtSUEAAA=",
    "Analytic Construction": "<None>",
    Area: "1",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "540",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.02",
    Width: "1440",
  },
  {
    ID: "909751",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry:
      "1QAAAB+LCAAAAAAABAA1jcsKwjAQRf9l1mnI007rSlQQdCFFcCEuUg01EBOpUZDivxup7ubOPTPnMMC2dbvXzUIN69i6xp6SCZ23QGAbXUh3qA/DOGZECYpa8WmhKoqlgvfxj8363rwymxcLZ6422R5qRhmBjQ1dunwDl1wQaGIyycUAtaRC4YRxiSVWmqMolwXXBPbuPB5IgZzAyrruku2cVhPM9dLb5++Dpgy1JDCPPmZfeHj/Pn4AfpDCr9UAAAA=",
    Pbi3DGeometry:
      "aAMAAB+LCAAAAAAABACVk10LwiAUhv/LuTZxa7Kvq6ggqIuooIvoYiMpYc1YEozRf+/UVqvYViqK5/H1PeLHpoB5LFf5SUAAUxXLpUrkDgjMlUz1GYJNUQ5xmoVY4Upq0rMYCx8dNrhun8sGWRbluNaxqccdi/Qcn7oWcSnjfY8gdW3bb6OcUYbxT1w6t+Bv6w8xp8zj/Q4Ps4184BbvGreoO71Njq+kf+ZrFjcfnjn9la1Z+8cFmuGuhPhkRzI6Ci0yCFBOYCbSvT5UwULpSEuVVuFa7l5TEyH3B10F40Rc3oVDlajs/mUeBX/GDYrw7EhoAwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "600",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "909752",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7yGm1O3dYoKgjqIBB3Ew6yhg7WFrUDE797Cur33+L336gnK1pzHhwYJR9+aSl+Dcp3VgKD0xoUnyHpaZERoikkuyHrFBOYFg7n5Y5thUGNkY7Az6q6DHkAmOEFw0q4L/deQlFAElQ8qGO9AxjFGMkHzLM24KASCi7ktaEo5QXDQpuvjb445FxzB3ur3r7simCcsQ7D11scr97J2bj7DQAjv0AAAAA==",
    Pbi3DGeometry:
      "egMAAB+LCAAAAAAABACdk10LgjAUhv/LuV7j2LTMrqKCoC6igi6iC6NRA3NhI4jov3dKy6Jm2sbU85x375F9LM4wXqnZaS8hgKFeqamO1BoYjLWKzQGCxTn9pDS2qcOF5aTmILbvDxpwWT6mdZIkPNHcuuBOo+WwmtviTXo53EfXY4QForBiDzkKvwxP3W38w/5N7nH0PVHkUvVv3rjFPscWdbF5tYVMccmS38WWNfwH/yr4XVtmK6vyopp0iHsq3EkjEwhIzmAk443ZZsFEm9AoHWfhXK2fqYFUm63Jgn4kj6/Cro50crtE90Z35QoAYzKzegMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2100",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "909753",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABFjUELwiAcxb/L/2yibtO5TlFBUIcxgg5jByvZBNNYFoyx756xott7j9+PV49Qns1xuGsoYO/PptKXoFxrNSAovXHhAUU9zjEiLMeEpWK5SCXORQpT88NWfa+GyMZhY9RNB91DQTBBcNCuDd2n0IQyBJUPKhjvoKA4E0RInjAuZJpLzhGczHWGE5ZTBDtt2i785a3Vr6+dYUKlQLD21scv97R2at5vNDHA0QAAAA==",
    Pbi3DGeometry:
      "7wMAAB+LCAAAAAAABACVk9EKgjAUht/lXM9xzMTUq6ggqIuooIvoQnHUwFzYCCJ691aZleS2Jhueb2f/xr+d9QVmKV+eDwwimIiUL0TOMyAwE7yQR4jWl+evmsZYfXAlb+K4iPFjUB2um9eyflkmZ7W206PY6QbE8ZGi1yM+RTcMSI27IQ3cVur6GJpoLdyCn8oe9RC9pkaTfue2SJjwb2ntoQ0adgcxOP2fTwb7dFR/tVbvwG47G6P1VPfq9LvZXaDB+09pVTlDnuyZZCVEKp3AlBVbuauCuZCJ5KKowhXP6qkx49udrIJRzk6fiQORi/JeuY+mCvQGqGhxs+8DAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1440",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "909754",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABFjUELwiAcxb/L/2yim9Npp6ggqMMYQYexg5VsgmksC8bYd2+xott7j9+PVw1QnO2xvxtQsA9nW5pL1L5xBhAUwfr4AFUNc5yQNMGS8eWCSZwLBmP9o1Zdp/sJnYaN1TcTTQeKYILgYHwT20+hKU0QlCHqaIMHRXEmiJA8TbiQLJecIzjZ6wynSU4R7Ixt2viXt868vnaGCZUCwTq4MH35p3Nj/QZmJh0Z0AAAAA==",
    Pbi3DGeometry:
      "3QMAAB+LCAAAAAAABACVk10LgjAUhv/LuZ4yK9PpVVQQ1IVU0IV0oThqYC5sBBH+95aZ2YdzKYrnOWfvxns84RWCmK0vRwoezHnMVjxlCSAIOMvECbzw+viUaezLGwr0IoaFsV++5APF9rlslOfRRa7t90wyGCLDxibuu8g2sUUc9KQDYjpWG7RsTNSwFv1NS9WeK7M2+VD4ou+1LRJd+Le04shdElrnUFv8l0cd1imosqMazdfcS8NhJWz/0Tq20uqb2vOmsJyTCYsOVNAcPFmNYEGzndhXwZKLSDCeVeGGJXVqRtluL6pgmtJzs3DMU57f57S85DjeAPEcA3rdAwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "909755",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABFjcsKwjAURP/lrmNI+sjLlagg6KIUwUXpImpoAzGRGoVS+u9WqribGc5hqgGKsz32dwMK9uFsS3OJ2jfOAIIiWB8foKphjhOSciwYT5aLTGLBMxjrH7bqOt1P7DRsrL6ZaDpQBBMEB+Ob2H4KTWmCoAxRRxs8KIpzTrhkacK4zIRkDMHJXmc4TQRFsDO2aeNf3jrz+to5JlRyBOvgwvTln86N9RtUqm000QAAAA==",
    Pbi3DGeometry:
      "7wMAAB+LCAAAAAAABACVk10LwiAUhv/LuTZxreU+rqKCoC6igi5GFxuTEtaMJUFE/z2rtT6n5lB2Ho+v8uqJTzBN+eK4YxDCWKR8LnKeAYKp4IXcQxif7r9qmkTqgzN6kpZDSHQbVIfz6rGsV5bJUa11Kfa7tI1aHsHE9ZGHiRNQVONOgKnTSB2PBCZaCzfgu7KLCf3W+KTvuQ0SJvxbWntog4bdQQxO/+eTwT4d1V+t1Tuw287GaD3VvTr9bnYXaPD+VVpVzoAnWyZZCaFKRzBhxVpuqmAmZCK5KKpwybN6asT4eiOrYJizw2tiX+SivFburakCvQAD4dOZ7wMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "909756",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABFjdEKgjAYhd/lv15jm7o5u4oKgroQCboQL6x+dLC2sBWI+O4ZFt2dc/g+TjlAfjbH/o6Qwd6fTYGXULvGIhDIvXHhAVk5zHFCYkGVEHq5iDVNVQxj9cNWXVf3EzsNG1PfMGAHGaOMwAFdE9pP4REXBAof6mC8g4zTRDGlZSSk0nGqpSRwMtcZjkTKCezQNG34y1uLr6+dUMa1IrD21k9f7mntWL0BDyxZTtEAAAA=",
    Pbi3DGeometry:
      "7wMAAB+LCAAAAAAABACVk10LwiAUhv/LuXbivliuq6ggqItRQRfRxWJSwpqxJIjYf8/WWutj0xzKzuPxVV496ytEW768HBmEMBVbvhApTwBBJHgmTxCur49fNU366oMCvYhlE9IvB9Wh2DyXDfI8vqi1noMDx6HI8gkmbg/5mNg0QDX2KA7sVmr7hOpoLdyCS2U3wJT2/A+NL/qe2yKhw7+luw6t0zA6iM7p/3zS2NdBNVdr8g4MtzMxupt2vDrNbkYXqPO+Ka0qZ8TjA5Msh1ClI5ixbCf3VTAXMpZcZFW44kk9NWF8t5dVME7ZuZk4FKnI75VbNlWgN7rxy/LvAwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1440",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "909757",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry:
      "1QAAAB+LCAAAAAAABAA1jcsKwjAQRf9l1jHk0cekrkQLgi6KCC7ERdTQBmIiNQql9N+NqLu5c8/MOY7QnO1+uBuoYBPOdmcuUfvWGSDQBOvjA6rj+B0TIpAyxeR8limKZQbT6Y8t+l4PiU2LldU3E00PFaOMwNb4NnafwCUXBHYh6miDh0pSkWHBuMQSVc5RlPWM5wQO9vo9kAI5gbWxbZfsnKoCU1078/p9yCnDXBJYBheSzz+dm05vfrKHnNUAAAA=",
    Pbi3DGeometry:
      "aAMAAB+LCAAAAAAABACVk10LgjAUhv/LuV5jpsOPrqKCoC6kgi6kC6ORA3NhIxDxv3dK+0RNNzZ2nr17z9hHkIO/l5vsLMCDhdrLtYrlAQj4Sib6Al6Ql0OcZiOsUJA3GRiMjR4dNih2z2XjNA0zXDt0qMG5SwaWS22D2JRx0yFI2dCymyhnlGH8F5fODfjX+kvMKXO42eLRbyNfuMH7jRvUrd59jq+kHfPVi+sPrz/9l61e2+EC++G2hPhkpzI8CS1S8FBOYCmSo46qYKV0qKVKqnArD6+puZDHSFfBLBbXT+FExSq9f5lHwZ9xA1I9mlpoAwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "600",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "909758",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry:
      "1QAAAB+LCAAAAAAABAA1jcsKwjAQRf9l1mnINH2kdSVaEHRRiuCidNFqaAMxkRqFUvrvRqq7uXPPzKlnKDt1nh4ScjjaTlXy6lrTawkESquMe0Jez+voEc4pQ0w2QZRRkUawNH9sO47t5Fm/2Kv2Lp0cIWeUEThJ07vhG5BjSKCyrnXKGsg5DSORMOQiFVmMIkyLAGMCF3VbD3gokMBBqn7wdqRZInxdaPn+fYgpEzEnsLPaep95ab00H2ApNmTVAAAA",
    Pbi3DGeometry:
      "WQMAAB+LCAAAAAAABACVk1sLgjAYhv/Ld73GbJqnq6ggqAupoAvpwmjowFzYCET87y0PnVDRjY19z96939jBz8E780N2Y+DARpz5XsT8Agg8wRN5B8fPq6GaJq6qUKAPmWiEuGWnGhSnZtk8TYNMraUUE9OcooluY1NDJiYGtRCdYlufdUCDYKLCftrYduBf4z+xgYll0E6PMdv4pR3GDW4X9xoPP7UKDkrVKm0/sfG0N1e7dNCljcN9CdUbXfLgyiRLwVFyBFuWhDKqg52QgeQiqcMjv7yn1oyHkayDVcwe38KFiEX6+iNlUV/hCdoc9E5ZAwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "600",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "909759",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry:
      "1QAAAB+LCAAAAAAABAA1jVsLgjAYhv/Ldz3HDk6nXUUJQV2IBF2IF1pDB2sLW4GI/72Fdfcdnvd96hnKTp+nh4Icjq7Tlbr61vZGAYLSaeufkNfzOgaEpzjjTG6iOMMyjWFp/th2HNspsOGw1+1deTVCTjBBcFK298N3oZwyBJXzrdfOQs4xi2VCKJepzASVLC0iKhBc9G0NBBVFcFC6H4Kd4iyR4V0Y9f41CEyk4Ah2zrjgsy9jluYD4xsGT9UAAAA=",
    Pbi3DGeometry:
      "aAMAAB+LCAAAAAAABACVk10LgjAUhv/LuZ5jZcuPrqKCoC6igi6kC6ORA3NhI5Dov3dSyww13djYefbuPWMf3h1WB7lNLgJcWKiD3KhQHoHASslIX8H17tkQp9kIKzxIQYweY6O0wwaP/XvZOI79BNeaFnUcmxNj4FCrRyzKuGkTpPbQ6tdRzijD+C/OnGvwr3VJzCmzudng0W0jJVzjXeAadaN3l+PLaMt81eLqw+tO/2Wr1ra4wG64KSE+2an0z0KLGFyUE1iK6KSDPFgr7WupojzcyeNnai7kKdB5MAvF7Vs4UaGKX18mLfgzntSXllpoAwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "600",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "929139",
    Name: "M_Break Line: M_Break Line",
    Category: "Detail Items",
    Level: "-1",
    Pbi2DGeometry: "tgAAAB+LCAAAAAAABABNjMEKwjAQRP9lzyU0tr3Ek6hQ0EMpgofSQ6pLuhATiatQSv/dgFG8zZt5TDdDM9BpuiMoOPiBWrywdsYiZNB4cvwA1c2fGJWiEquqkGtZClkWEpb+q21C0FN0Y7EjfUPGACoXeQZHdIbHBK1nzeRdwjNdf1ONZEZOsLf4+he33vp46J7WLv0b5xLxH7YAAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    Cost: "0",
    "Design Option": "-1",
    Family: "M_Break Line",
    "Family and Type": "M_Break Line",
    "Host Id": "-1",
    Image: "<None>",
    "Jag Depth": "336",
    "Jag Width": "310",
    left: "1239",
    "Masking depth": "225",
    right: "1349",
    "Section Shape": "Not Defined",
    Type: "M_Break Line",
    "Type Id": "M_Break Line",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "931377",
    Name: "Railing: SH_1100mm",
    Category: "Railings",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABACFjkELgkAQhf/LnJdFXSXXTlFBUAeJoIN4MFp0YNsJ2wIR/3sDmhAdOs28+R7vTdFDfsFTdzeQwZ4umJPtanIgICd0/gFZ0Y8rG1QqVRImS546iRcwiF8WBjLQOv1m+j+bM8tP9aptq477+bDB6ma8aSHjBAEH42rfTOJIvvLIL4/yjNcZ7QzWDZfEMg61ErC15jV5tQxUFAlYkyWOdU9rh/INAkgGkA4BAAA=",
    Pbi3DGeometry:
      "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",
    "Angled Joins": "Add Vertical/Horizontal Segments",
    "Baluster Offset": "0",
    "Base Level": "Level 2",
    "Base Offset": "0",
    Cost: "0",
    "Design Option": "-1",
    Family: "SH_1100mm",
    "Family and Type": "SH_1100mm",
    Height: "0",
    Image: "<None>",
    "Landing Height Adjustment": "0",
    "Lateral Offset": "0",
    Length: "8795",
    "Offset from Path": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "None",
    "Rail Connections": "Trim",
    "Railing Height": "1100",
    "Tangent Joins": "Extend Rails to Meet",
    Type: "SH_1100mm",
    "Type Id": "SH_1100mm",
    "Type Image": "<None>",
    "Use Landing Height Adjustment": "No",
    "Use Top Rail": "Yes",
  },
  {
    ID: "931541",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "931544",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "931548",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
  },
  {
    ID: "931569",
    Name: "Railing: SH_1100mm",
    Category: "Railings",
    Pbi2DGeometry: "DgEAAB+LCAAAAAAABACFjkELgkAQhf/LnJdFXTXXTlJBUAeJoIN4UFp0YNsN2wIR/3sDmhAdus2b7/HeKwbIazz3dwUpHGyNudV9Yw0wyC0a94C0GKaTDMLncZTEa5FwGYUrGNkv8z3uSZl8s+A/WzLLT3XWdVVP/fTYYnVTTnWQUgKDozKNa2dxsq5ySJMnecHrgvYKm5ZKQh76UjDYafWavZJ7IggYbKy2FGueWo/lG+M+lPkOAQAA",
    Pbi3DGeometry:
      "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",
    "Angled Joins": "Add Vertical/Horizontal Segments",
    "Baluster Offset": "0",
    "Base Level": "Level 2",
    "Base Offset": "0",
    Cost: "0",
    "Design Option": "-1",
    Family: "SH_1100mm",
    "Family and Type": "SH_1100mm",
    Height: "1100",
    Image: "<None>",
    "Landing Height Adjustment": "0",
    "Lateral Offset": "0",
    Length: "8795",
    "Offset from Path": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "None",
    "Rail Connections": "Trim",
    "Railing Height": "1100",
    "Tangent Joins": "Extend Rails to Meet",
    Type: "SH_1100mm",
    "Type Id": "SH_1100mm",
    "Type Image": "<None>",
    "Use Landing Height Adjustment": "No",
    "Use Top Rail": "Yes",
  },
  {
    ID: "931577",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "931580",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "931584",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
  },
  {
    ID: "931630",
    Name: "Railing: SH_1100mm",
    Category: "Railings",
    Pbi2DGeometry: "EAEAAB+LCAAAAAAABACFjs0KwjAQhN9lz2lI0yKmnkQFQQ9FBA+lhxZDGohZqVEope/uQmsPInjan2+YmaKHvLbn7q4hgwPWNkfXGfTAIEfrwwOyoh9XEkRS8IWUySpSXKVSwcB+wCUNEX+x+D+bTctP+Lptq44a0GNrq5sOuoVMcMHgqL0JzXScMFTBUunxvNjrjPbamoZSUp7GKmGwc/o1aRUXiZQMNuiQbP3TuaF8A4UsyeMQAQAA",
    Pbi3DGeometry:
      "y+MAAB+LCAAAAAAABAClnU+P3MYRxb/LnlcDssnhkPYpSAIESA5GEiAHQwcZFuwFFG2gKAEMQ989M9GK7Kp5v+ouGUGCqJusqn6vuv7N7uz3vz5898PT33/519uHbx7+/PzD09+e3z39+PD48N3z0/uP/3745vtfP//f6/bw7fU/D58ej5VX4zB8+///uf734dPrL6/97sOHN79c331VxtNYpuXx1Xba5rI9juW0nefp8fPGsMHG7DfWlw0n6bw0X1jtxnJ52bic7cb2RfdlshtNSbhBRo2XtFGkg0URtuN2AagQQ+SvOKjmsaV8BQLxHHlz8Q3WcSmS8vEyajoCSfAGMhuIshvLuGlfODbYe+wL4FSHIAftMoEnLHRh9zc8GYcoUs7nzlvl3HAhx13ms/aEZWixEfhIp/O0+fO3ZoGrfKCO1iIdSCBaS6izDqTDhdwd9e54aJxkPS1lGF20GNz6dJxCrl8V1Ot1TJfyrZg9L5GY64nr9fU4b71cu0zOGv08ykEztT2k90Z9Cn1aLxaePa8AW6SXznu7UIoufJ7ORTiQnGtM0PwW5Q5IF7qJFo80WtpNCFbr7rgmlsvnF/u4BNOEILluSTc5Rz2P1pOV1tn2XOCcc4GQccQ9JJdQNqSboJeTk9QL+LtLsTTEIPxEL8CJzxPtRCM5uQ21FcwQgqH877tDHV0B6A1aHplZkqEfExQ0VFjzk15KpAEthDP2ZQq3CGfq4wAgjQT3fUhMrneNoMbWJ8UB9mmoOpAkEzNp4PYNUj+mckrZ2FFiTUDNHuVsnZuzJUS6ZcSiAJJ8UGNh9y65DJhBKtMacgOFyCuQfT0ECHjT/PDIgh0JO/qMh0WOoRXrgiIqQKDZ7SpTzfPa0mQtgB0i1SZUykSNsYQC5FPjjUAEiOIwgEpwmDcEEwo6mj4DaWCsNaaggMlESVl3oTEOTxoCSbIHQA1wZuyQFKTZzoYnYDhAwWIZimJtJ/Z3OMmimpuKQSr6CCEc+RGRAdTJoWKgITdsDJyFfAtGqUQazI+1+MiHcBCdcq7ej1yONyymS1mKvODVxuw3ZHm/lIsu1+sXVruxLvIYyzQWeYylbPqeVKJwg6xyUbvHKtLBoghcF7grrBBEJLA4rJq6VyAQj5G3Ft9gHTYbH5S7hH/QEYiCN5DZQJTdmOBDl2qDvceuz+DSE+SoZTqDK0wQ1443PB2HKFLOB89b5Rzx2HCeOy2z9oWptOgInKTTe9oE+nuzM4josrnIBzKI5hLsrAP5cFF3h707Ik56Al0FjMGtl+MUct0kRhvVpXwr5rI0xJj8WqUZU11Zp8mZo59HOWintof02vK/A35aLxafJWaL1NJxbX9kE5F8no5FMJAc05XX9BbpDkgXuomWjzRa2ifdY+PtMtFcPm9gNnFLiiHxlvZJt2o2ZmlzYN16254OnHdOuumrIh/SSzAb2k3Yy8lJ6gX83bU4+Eq6A/ILeOLzxDvxSG5uo22FM0Vh6gL67lFHc0Cag95H5pdk/Mc0BZ0V1v6kl9JpwAwijR2aRC6CGls6wEiDwS0gcpPrYyO0sQ1K0UAtG2oOBKn8DPK5j4P8jwmdEje2llgZYNdHqRtSdLaUSDePXBxAsg9qLWzkFZkBN0hmVkFqshB5BbKvpwEBa5odnl0EjoStfcrDIscA1bquiOoQaHu76lXzvDY1WRFgq4glCpU0UYsssSAF2IQjFgGoOBmgahyGD8G4gg4HhyAVAd4aV1LBlKKorNPQWIcHD4Ek2RCgBjo0NkwS1WyjwzMxnKhg6QwlMhiKDR8Ot6gEp8KQ6j+CCKeAxGWAdXLOGGjIzR8Dd0H3gvEq0gZTZVAQ+RHOp1MO1vtRzATFatlW/TMp1cbsN2Spf82f5+YL5tjTMJzlMaZhGuUxpmHUV6UShRtklYvePVaRDhZF4LrwXWGFICKB9l6U7aJzR6V8BQbxHHlz8Q3WYfPywblL/QcfgSh4A6kNRLkN+PnLaoPdx64vTUkW3Gm46KA6DavueY83HB2VKFLOB89bNWywUdw1X/VHStMwt+gInKTXe5oEuntzMIjosrnIBzKI5hLsrAP58GF3TofE2kuOzFUFjMGty99wqdZNZrRhXcq3YrZzQ4xJsFWeMRWWdZqcOfp5lIN2antIr+0COuCndVOlVbkF6CK9dF7bKdlMJJ+ncxEOJMf06DW/RfoD8oV+ouUjj453/cPZdL1sOJfPL2a5DlxSDImfrJw676jn0Xwys9jruMrPlCq9YA/TSzBb2ucmvSQnqRfwt9ei4ivpDsgv4InPE+/EI7m5C7dzMwxTH9B5j9rtAWkOuh+ZYJIJAPMU9FZY/ZNeyqcBM4g09mgSuQhqbOoAIw0GN4HITa6TjdDGPihFAzZtqDqQJDM0aeBeDmoAzOmUu7G9xOIAOz/K3pCls9VEuoHk+gDyfVBvYTcv6QzIQTbTGnIDhsgx0AH0UCAgThPEI4zAl7DDTzlZ5BugWlcXUTUC3W9f1To33ThZF2DHiIUKFTZRpyyxIAXYiyMWAag4IKCaHGYQwdSCDgeHIBUB3hpXUsGUoqis09B0h+cPgSTZFqAGOjS2TRLVbLvDozEcrGABDYUyGIptH864qBCn8pCqQIIIh4HEZYB1ctwYaMiNIQN3QfeCKSvSBsNlUBD5EY6pUw7W/ZGM/P2v8bSpIWO1PLvlQdTit/Vxbr6w2o2ijnDbOKsj3DYmNQQ3onCDrDKRu88q0sGiNLQmcBukEEKgrliclk2ViJXiFbjDE+RNxTdYR52Na7ZNwq+ZCETBG0hqIMptyA9izAY7jl1fm5I8uBv4wTqofrd+446OjW6l/PziN1rl3PDYcI67DuqbA246FvLQS9tJer2nSeDdvVnpJm/k7LKuNiAig2guwc46kA8fcPcf2egOhmoibQLGYNfvi4lqtcqFPphL2VbInpFITJVSTXapairvMDlz9PMoB+3U9pDeuu7vgF6vFoPNkVEkUaSRTlp3RT7/yOfpRIQAyan6cctskZ6ATKGHaPnIoGNcNdfRpdrA00QZ68OVFEPiLekm26jn0Xwy0zrbngWcax56wR6ml2C2tNfRLicnqRfw99di/Up3QH4BT3yeeCceyc1doD1wpgBMdX/nPWq3A6Q56HZkakmGfsxQ0EtBvU9adRYNWEGUsR+TqEUwYwMH+GgguOFDXnJdKyONfU+CAmzQQC1KkTmZpHPXJnM+ZnHK1thGYjmAHR7la8jL2foh3ShyRQAZHmsr6NclkUgLspiUnhkeRO6AtOuWP6BL08IDisCDsH9PuVbkEaBaVxFR1QG9bV91Wj+vTU3mf+wHsSChAibqgyUWpAA7bcQiABXbf6q9YcIQzCTocHAIUhHgrXElFUwpiso6Dc1ueLoQSJLlP2qgQ2N7JFHNtjU8+MKxCRbKUBCDodje4QSLCm4qBaniI4hw1EdcBlgnh4mBhtyQMXAXdC+YoSJtMDoGBZEf4RA65WDdH7XIX+8aT8usfsKgXp/9uiztl3lSv4lmX1jtxqwPscwavmWW34xtJOEGGeVCd4dRpIIlAbIucldAIYLEXXFA7T/YR6pXIA8PkTcW32AdNiEffLucv3MRSNIvEKmBILcBH7NUG+g3Zvksv+TSCHLAnkfwgjPc1P0Fz8QhiXTzsdNGOQ88g8uei/p6gJvqlVxza3pHp9e0qPO3ZecOgWVbkQokD60FxFkFUeHD7BfEu0OgnjdXMWJw66qGOJZNDrQxXEq3UvY8RGJMKq2SiqmljLfkrNHPoxw0U5pDam2134YelovFZs8jmilSSme17ZDNOvJ5OhSBQHJMI15RW6QnIFXkIVI6Eej41h013ikTu+XzBmITqqQYEm8ZP4sfvPNRSlsD69bR9ujv/PKsI8Ue6ohXgtjyXce5lJicVkDeXYaz+jr9HkdAZjWU+DgQTgSCd7vgekBMQZdK/L7b0y78SXHQ1shskgz3mJSgaaLKntRC6mRWEGXqvCRqEczYqgE+Gghu7ZCXXHsaII0NToYC7MVIMcuRqZjkc4emcz0mb0rS2DNiFYDtHKVpyMfZsiHbFnIhoDM711TUnUsmmRfkMSs/NS2IPAKZ1y1+wJhmhgcSgRNhy57yrsApQLMuI6KyAzrarrK0flwamisAqA3EeoTql6j5lTiQAmyvEYgAUOr4qeaGkUIwhKCzwRlIRQC3hpVUIKEoKekwNKrBgQLLkTU/yqcDY0skEU22MjziwjkJ1shQDIOd2NHhvIqKbagCodgDfGiiRzQyzLmJYSA/NUkM3ATdCsakyBfMhkFB5EA4ZU55Vu8nKauuhqdx0j9cUm3MbkNX9NMIDlC/sNqNRZ9iGlf1vX63jYseZFeicIOscgG7xyrSwaIIXBeyK6wQRCSwOKwmnS4q5SswiOfIm4tvsA6big/OXbI/+AhEwRtIbSDKbhT4SKXaYPexL8jvqjSSHLhlAl8odGf3NzwdhyhSzgfPWzX4N8B1y6x/ZGsqA3hoZS46Saf3tAn092ZnENFlc5EPZBDNJdhZB/Lhwu4Oe3dILHrcXAWMwa7vqk1RUa2bxGjDupRvxejpZh3rJ7N+qXygXq+dJmeOfh7loJ3aHtJrK/8O+Gm9WHwmWUravCbtgfPa5shmIvk8nYtwIDmmI6/5LdIfkC/0Ey0febS8F91i4/Uy4Vw+b2A2gUuKIfGWdpN31PNoPplp3a2oPxhu9II9TC/BbGg3cS8nJ6kX8HfX4uAr6Q7IL+CJzxPvxCO5uQ23Fc4UhqkP6LtHHe0BaQ66H5lgkgkA8xT0Vlj9k17KpwEziDT2aBK5CGps6gAjDQY3gchNrpON0MY+KEUDNm2oOpAkMzRp4F4OagDM6ZS7sb3E4gA7P8rekKWz1US6geT6APJ9UG9hNy/pDMhBNtMacgOGyDHQAfRQICBOE8QjjMCXsMNPOVnkG6BaVxdRNQLdb1fVap7XpibrAuwYsVChwibqlCUWpAB7ccQiABUHBFSTwwwimFrQ4eAQpCLAW+NKKphSFJV1Gpru8PwhkCTbAtRAh8a2SaKabXd4NIaDFSygoVAGQ7HtwxkXFeJUHlIVSBDhMJC4DLBOjhsDDbkxZOAu6F4wZUXaYLgMCiI/wjF1ysF6P5I53qhhHU7bun/xXX3NzcbsNlTBf1u/qN81sy+sdmNVx7hubIP6Xr/bG/Krro0o3CCrTPTus4p0sCgC14RvgxWCiAQWh9VZ5Q6jfAUG8Rx5c/EN1lHn5Zpzk/prPgJR8AZSG4iyG5v8SMZssPvYdfldlUaSA3c7gy9sdGf3NzwdhyhSzgfPWzX4N8B15c/73NZLi43ARzqdp82fvzY7gQgum4t0IIFoLqHOOpAOF3V32Lsj4qZG0yZeDHa9/qNNcr1KjD6qS/lWzJ6aSEyVX02aqQos7zQ5c/TzKAft1PaQ3roJ6IKf1ovF5yxKbp/WpD1w3rpR8olIPk/nIhxITtWiW36L9AfkC/1Ey0ceLe+b6reD62WiuXzewGwClxRD4i3tm/pzOz5oaXNg3bqb+ooMoxbMYXYJZcO6CXs5OUm9AL+7FZv62vweb0B6AU98nmgnGsnLbbStcKYoTF1A3zXqaA5Ic9D7yPySjP+YpqCzwtqf9FI6DZhBpLFDk8hFUGNLBxhpMLgFRG5yfWyENnZBKRqwZUPVgSSZoEkDd3JQAmBKp9SNzSXWBtj3UfKGJJ0tJtLtI5cHkO6Dcgt7eUlnQA6ymdaQGy9EjoEOoEcCAXGaIB5gBL6E/X3KySLfANW6uoiqEWh+u4pW87w2NVkXYMOIhQoVNlGjLLEgBdiKIxYBqDgfoJIcRhDB0IIOB4cgFQHeGldSwZSiqKzTwGyHpw+BINUUkHw6MbZMEtJsq8NTMRyqYPUMVTIYii0fzreoCqfakEpAggjngMBkAHVy0MgKUvPHwFfQt2C6ipzBUBkURE6E4+mUd/V+FLPJXwAbTstZ/jl1szG7DV3qL2f1oaJ93px6WQb1RYu3jaJ+4+q2Ib/52ojCDbLKhe0eq0gHiyJsXdyusEIQkT97K64bOmlUyldNIB4jby2+wTpsPj4odyn/oCMQBW8gs4EotwEfxFQb7D12XX6bpZHkwF0u4ArLRYfg4w1PxyGKlPPB81YN/g0dz68b6oe+bhtzi47ASXq9p0mgvzY7g4gum4t8IINoLsHOOpAPH3XndETUI+kqYAx2Xf2FdrNu8qKN6lK+FSN+gN1G+smsj3Iian0mZ41+HuWgndoe0muL/w70ad0UaFVmAbZIL53XNkgmD8nH6VgEA8kxnXlNb5HugHShm2j5SKOjXbfZeLlMMJfPG5RN2JJiSLxl3WQd9TyaT2Zab1vU3w43esEeppdgtrTPTXpJTlIv4O9uxaK+WL/HHZBfwBOfJ96JR3JzF23nZhSmJqDzHrV7A9IcdD4qvSTDPyUp3VVh3U9aKZUGtCDM2J1J2CKcsZ0DhCQW3P0RL6kGNoIa+58UB9iroepAkkzNpIF7OEj+mMwhaVNTiTUB9nuUtSE7J4uIdNfIZQGk+aDKwg5echkwg1SmNeSGCpFXEP16EMC0aXpwaBH4Efb0KQeLHANU64oiqkCg3+2rVOemDydrAewRsTihYibqjSUWpAC7b8QiABVHAlSHw9QhmFPQ4eAQpCLAW+NKKphSFJV1Gprn8MQhkCRbAdRAh8ZWSaKabXF4GIajFCyaoTgGQ7HVw6kWFd9UFVLxRxDh+I+4DLBODhgDDbnBY+Au6F4wV0XaYJwMCiI/wsF0ysG6P4P58sYyfd5Yp+1xOw3TyydMwzq218fpVNbLHG8YDbiRUT2MvC5Nwo3wEB2q9yNE6/LMeVtJBcIa6s4cwoGBmtuwdsPR3vg6/+s4dpebdbhrqHc9nS/beCcmXr47rlivpdN6t9ZrDYzLwhhaD41va30xPVoWJ80aCeIJyFBtt/EeAVLaALIbg8b6V3lZ+7Ad3tR2yUjlq/NpWK5JdzutX752/fOtbKzfxw+xYTTgRrfq+RoQBl6/Nwk3WofoUP35CI31+zPnbSUVCGtLd/ch7sFAzQ1YM3A0Nr7a/zqO3eVmHe4a6x1O4zzO93Ia6/cnFhtGA24kVA/njdeVSbgRH6JD9ZcjhOvqzHlbSQXCGutOHMKDgZqbsPbD0dz4Sv/rOHaXm3W4a6h3Pl0u23YnJl6+O65Yr6XTerfWdRlxWRhD66Hxba0vpkfL4qRZI0E8ARmq7TbeI0BKG0B2Y9BY/yovax+2w5vaLnmv8vXjwx+e3vzz7ce3Hx6+ud7Lx4e/vH3/08efX/7x1+ePbz4+Pb9/+ec/nn7ct/709umnnz++/OOP797+t37w98/vnq8C3//n3btPr/8HjptM0MvjAAA=",
    "Angled Joins": "Add Vertical/Horizontal Segments",
    "Baluster Offset": "0",
    "Base Level": "Level 2",
    "Base Offset": "0",
    Cost: "0",
    "Design Option": "-1",
    Family: "SH_1100mm",
    "Family and Type": "SH_1100mm",
    Height: "0",
    Image: "<None>",
    "Landing Height Adjustment": "0",
    "Lateral Offset": "0",
    Length: "5658",
    "Offset from Path": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "None",
    "Rail Connections": "Trim",
    "Railing Height": "1100",
    "Tangent Joins": "Extend Rails to Meet",
    Type: "SH_1100mm",
    "Type Id": "SH_1100mm",
    "Type Image": "<None>",
    "Use Landing Height Adjustment": "No",
    "Use Top Rail": "Yes",
  },
  {
    ID: "931637",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "931640",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "931644",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
  },
  {
    ID: "931858",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jdEKgjAYhd/lv15Dne7f1lVUENSFSNCFeGE1dLC2sBWI+O4tQjgXh8P3ceoJyqs5j08NCo7+aip9C63rrAYCpTcuvEDV079GZJVymjBcc8oFIszNQm2GoR0jGoedaR866AFUQhMCJ+260IPKKWZ5TqDyoQ3GO1ApLTBByVnGUeYihsDF3H9wNAVjBA7adH08zqjI0oLA3urPYnOKEiWBrbc+nrm3tXPzBV3zESrRAAAA",
    Pbi3DGeometry:
      "RQUAAB+LCAAAAAAABAClVF1rwjAU/S/3OYYb7UdufRoqDLYH2QZ7kD1UDBromtGFgYj/felW59SmjUhJyT05OTfcnNzFDuZL/bL9UJDBg1nqZ1PoFTCYG13aT8gWu9+pW8ax+2DPjshAII5/fm7A/u2w7a6q8q3bOxAJF3IoGXGMiJggPoqkZBd4wlNK6YhLnkqKa34iKOrHIz4axvGlzgEP5fv0W86J5Igt+if4Ob9FvxP35W2pZyffp++rQ19eXx0C8M76+/xwhX7Qvfj8cIOvOvNece9BPg/gB/nK5x/fOz3H+95LgH6Qz0N9cqrv+tFU5+/Kqgoy5MjgUZVru2mCJ2Nzq03ZhK969bd0r/R6Y5tgVqiv/8SJKUxV90OUOKnb3jetVPA3RQUAAA==",
    "Analytic Construction": "<None>",
    Area: "1",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "0",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.03",
    Width: "0",
  },
  {
    ID: "931859",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 2",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABAA1jVELgjAUhf/LfV7DOXVuPUUFQT2IBD2ID1pDB2sLW4GI/70rIdyHw+X7zqkmKFpzHV8aFJx9a0p9D43rrAYChTcuvEFV0z8ismEZjbjYMiqkjGGuV2o3DM2IKD4OpnnqoAdQEY0IXLTrQg8qQYVA6UMTjHegGE1FJGTG40zIJMcjcDOPBUUv55zASZuux9mY5jFLCRyt/q52hnVL4d5bj1PuY+1c/wAdN1HezwAAAA==",
    Pbi3DGeometry:
      "NwQAAB+LCAAAAAAABACVVN8LwiAQ/l/u2cktWs31FBUE9RAV9BA9LCYlrBlLgjH637NarV9zE1H87tP71LtzncNsK5bZkUMAE7kVCxmLCAjMpEjUCYJ1/phqGnu6wYWUFsdF7N0H3eGyeW7rp2mY6b2O26Gu3/KJg9Rjnk807rIuI78Eox2XtUuiTTVs2dsrBd4IZMz75+hu/3eiT+LbU61EA+mqOxj9WJ3IHAfr56snmjysOQesssYsXhVt2zSzyddGwg1ibQzQp39dgUMRHrjiKQRIkcCUJzu1L8BcqlAJmRRwJaIXNeZit1cFGMX8/L5wIGOZ3n4A9HFwK/QrX7E9sDcEAAA=",
    "Analytic Construction": "<None>",
    Area: "1",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "860",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.03",
    Width: "1460",
  },
  {
    ID: "931860",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 2",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABAA1jc8LgjAcxf+X73mO/dBN1ykqCOogEnQQD1ZDB2sLW4GI/3uTEN7h8fi89+oJypu5jC8NCk7+Zip9D63rrAYEpTcuvEHV099GJKECEy43CceUMZibldoOQztGNAZ70z510AMoggmCs3Zd6EGlWBYIKh/aYLwDRXEmiSwEZ0IWaR6F4GoeCxp7OecIjtp0fbxlOGc0Q3Cw+ru2RZxbBnfe+njlPtbOzQ+IsphbzwAAAA==",
    Pbi3DGeometry:
      "JQQAAB+LCAAAAAAABACdU8sKwjAQ/Jc9p2Ej1jb1JCoIehAVPIiHSoMGaiM1CCL+u1GrVmpjlJCQmWRnl30sTjBeydlxJyCCoVrJqUplAgTGSmZ6D9HidL+aZ2ybBWfyYjyG2L4dZsN5+TDr5Hl8NLYea1EWNkLi+dRnATEw4AEnFZ7TFuPNEo80aPzB1+mXeOTc/6Rz56vxvPEVnS/6Dn7r4rfruMdjz/+vefvCO+TTXnf3PrH7ravvr33l3p9Ofh3qa6/Lm76Zt56Mt0KLHCKkSGAksrXeFGCidKylygo4l8nzaSDkeqML0E/Fofyxq1KVX+cdQ+xex/oCTzLzpiUEAAA=",
    "Analytic Construction": "<None>",
    Area: "1",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "860",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.03",
    Width: "1460",
  },
  {
    ID: "931861",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 2",
    Pbi2DGeometry:
      "0gAAAB+LCAAAAAAABAA1jUELgjAcxb/L/zzH3KbTdYoKgjqIBB3Ew6yhg7WFrUDE794ihHd4PH4/XjND1ZnL9NQg4eQ7U+tbUK63GhBU3rjwAtnM/xqRJM0xYWKTFJikJIOlXbHtOKopsnHYG/XQQY8gCSYIztr1YQDJsaCcI6h9UMF4BzLFmSCizBnNRcmLGARXc//B0SwYQ3DUph/iM8UFTTMEB6s/q51jUYoSwc5bH8/c29ql/QJpYiqv0gAAAA==",
    Pbi3DGeometry:
      "kwUAAB+LCAAAAAAABACdVF1rwjAU/S/3OQ2JtWlTn0SFwfYgm+CD7KFi0EBtRhcGIv73xVm/ZtKkUlpye+7Judyc3MUepks5230JyOFVLeWHKuUKEEyVrPQ35Iv9aWlgMjAPHND1T0QJGfx9zAuHzzNtWNfFznAjyjDNehmKEsz6WYwox4zyPnoEGE55ym8ASjDh3EZpReK0l9p3OyEcxwkL5jh0LEWbzMQu8w+xcR5kfIizAEufPYxWeUdnvPLuxgQhvpNpM00HmeAzc5umm5066DzjjeDrYav6aQ+GAJ4h4L9p3dVDvOlx072GmW5jWWyFFjXkpmAEb6Ja600TvCtdaKmqJpzL1QV6EXK90U0wKcXPbeJIlao+TleSkdFxiP4CsVwF35MFAAA=",
    "Analytic Construction": "<None>",
    Area: "1",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "0",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.03",
    Width: "0",
  },
  {
    ID: "931877",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jcsKwjAQRf9l1mnIwyZtXYkKgi5KEVyULlINbSAmUqNQSv/dSCnMYubeM5x6grI11/GloYCzb02l70G5zmpAUHrjwhuKelrWiCRUYMLlNqEEp4TnMDcrtxsGNUY4BgejnjroAQqCCYKLdl3o/wfllCGofFDBeAcFxakkMhecCZlvsjgIbuaxwJxlFMFJm66PaoZFLI9Wf9dfgSVnHMHeWx9V7mPt3PwAkoGBwNEAAAA=",
    Pbi3DGeometry:
      "wgMAAB+LCAAAAAAABAClk10LwiAUhv/LuTZxs7W2XUUFQV2MCrqILjaSEtYMkyBi/z231gcraWuK4vHx5ZWjZ32FMObLy5GBD1MR84VI+BYQhIKn6gT++npfakwC3SFDr52ORUhQTHpAtnnIBlJGF63tWD1sEwvpI9gh1EM6dqlN0SfwcNeqAOrabg6o0+s2AUaPL8CoqHg4uO/aXkvy298sqWVTSWUD0uwGZo3xMf8FrezNSWvzy+plWRfDiEcHppgEn2CCYMbSndqXwVyoSHGRluGKb59owvhur8pgnLDz+8GhSITMi7FouuZudd5fmcIDAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "817",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "931878",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 2",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1jU0LgjAcxr/L/7zG5nQvdooKgjqIBB3Eg9bQwdrCViDid29h3Z6X38NTTVC05jw+NORw9K0p9TU0rrMaEBTeuPCEvJoWGZEV5ZgwsVaYSkphrv/UZhiaMaIx2JnmroMeICeYIDhp14X+ayijCYLShyYY7yCnOBNEKM4SLlQqlWQILua2wCyRFMFBm66PxxzL2CPYW/3+rRWWaZIh2Hrr45d7WTvXHz4iwYbQAAAA",
    Pbi3DGeometry:
      "dAMAAB+LCAAAAAAABACdk10LgjAUhv/LuV6y+ZFfV1FBUBdSQRfRheLQgbmwEUT431tmmcRS25h6nvPuPbKP/Q2CiG2vJwoeLHnENjxjMSAIOMvFGbz97fkp09iXHUrUkBHB2K8eckB5eE2bFEV4lXNHxNIcW3eRqxGHEPlyTN1CHxibrtvgsaZjMpAqjNu4JZaRbeiG0uOfv6iowvgbK9Rta8Ua9cKdJVXyLvdeq93GA4qq9D82cwjtqCiP74yFRypoAR7WMIIVzROR1sGai1AwntfhjsXv1IKyJBV1MM/o5VM45RkvHtenavKW3AERw1rndAMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2100",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "931879",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABFjdEKgjAYhd/lv15jc/pP7SoqCOpCJOhCvLAaOlhb2ApEfPcWIt2dc/g+TjVCcdXn4akgh6O76lLdfGNbo4BA4bT1L8ircY4BWXGkTMh1TEWUJDDVC7Xp+2YIaBh2unkor3rIGWUETsq2vvsVLnhEoHS+8dpZyDlNJJMZighlFqcZIoGLvs+wiFJO4KB02/m/vDfqs9hIEVES2Drjwpl9GzPVX+rIr/PRAAAA",
    Pbi3DGeometry:
      "EwQAAB+LCAAAAAAABACdU18LwiAQ/y737MSttuX2FBUE9RAV9DB6WEyWsGYsCSL67lmt1h9MS1G83939PM+75AiTFZ8ftgwiGIkVn4mCZ4BgIngpdxAlx9tRqUmsJpxQgzguIfF1UwtOy7tbt6rSg/J13AB7xEVt3PJ8HykpCIIQOa6PO6FHLfCQhvQL/k6vgV/ZKSZtSj/ZG7y2v9H8C+vIbULXWP8Wysf7f8uWhluXLANuDMauMszXGtJuXWF2FWn8KBvYrtxVd/V5umGSVRARTBCMWZnLdS1MhUwlF2UtLnj2UA0Zz9eyFgYF2z8b9kQhqkt3X4dq4jO2lAljEwQAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1440",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "931880",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABFjdEKgjAYhd/lv15j0/yndhUVBHUhEnQhXswaOlhb2ApEfPcWIt2dc/g+TjVC0ejL8FSQw8k1ulQ3L21rFBAonLb+BXk1zjEgK46UxWKzYjTJkhSmesG2fS+HwIZhr+VDedVDzigjcFa29d2v8JhHBErnpdfOQs5pIpjIMI5QZOs0QyRw1fcZjqOUEzgq3Xb+Lx+M+iw2UkQUBHbOuHBm38ZM9ReWDBy+0gAAAA==",
    Pbi3DGeometry:
      "JQQAAB+LCAAAAAAABACdU8kKwjAQ/Zc5pyEpdkk9iQqCHkQFD+Kh0qCB2kgNgkj/3djWjRKbmpCQebO8YTKzucF8J1bXE4cIpnInljIVCSCYS5GpM0SbW/XUatLXGwr0RhxKSL+89IFi+3Qb5Hl81b4O9bFLKHII9pgXIi36vh8gh3o4DFxmpQhYwH4pGhQm/JuhhynruU2CN17bV3H+hU3BrZI3mHfLpVmBrhUzhDcVrAW3yMeySdqZW6rfodks27P1x2xg2+bX8zYS8ZErnkNEMEEw49leHWphIVWshMxqcS2Sl2rCxf6gamGc8sun4VCmMn/Me7n0WN8B+AnjxyUEAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "931881",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABFjdEKgjAYhd/lv15jc/lP7SoqCOpCJOhCvNAaOlhb2ApEfPcWIt2dc/g+TjlC3ujL8FSQwck1ulA3X9vWKCCQO239C7JynGNAVhwpE3KzimnMJUzVQm37vh4CGoa9rh/Kqx4yRhmBs7Kt736FCx4RKJyvvXYWMk5jyWSKIkKZrpMUkcBV32dYRAkncFS67fxfPhj1WWykiCgJ7Jxx4cy+jZmqL9FhNhnRAAAA",
    Pbi3DGeometry:
      "EwQAAB+LCAAAAAAABACdU18LwiAQ/y737EQHm209RQVBPUQFPUQPi2QJa8aSYIy+e1b2h5FpKYr3u7uf53m3amC6EYv6wCGFsdyIuSzEFhBMpSjVEdJVcz9qNenqCWf0QgJKSPe26QXn9cOtV1VZrX0DGuOQUBREOKIMaSmOY4YCGuEOCxMPnCUs+YK36S1wi51gFn5if+LG3tD8CdvIvUK3WP8WSvv9v2XLwm1Llgt3BeNZGc5rHWn3rjDPinR9lBfsVe66uwYi23PFK0gJJggmvMzVzggzqTIlZGnEpdg+VSMu8p0ywrDgp3fDvixkde3u29BNfAG5CANqEwQAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "931882",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 2",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABFjdEKgjAYhd/lv55jc/VP7SoqCOpCJOhCvNAaOlhb2ApEfPcWIt2dc/g+TjlC3ujL8FSQwck1ulA3X9vWKCCQO239C7JynGNAIo6UCbmJOKNCxhKmauG2fV8PAQ7DXtcP5VUPGaOMwFnZ1ne/wgWPCRTO1147Cxmna8lkiiJGma6SFJHAVd9nWMQJJ3BUuu38Xz4Y9VlspIgoCeycceHMvo2Zqi/CGyQO0wAAAA==",
    Pbi3DGeometry:
      "SQQAAB+LCAAAAAAABACdVM0KAiEQfpc5m7hbabudooKgDlFBh+iwkZSwrbFJENG7N5X9UNm6KYozn+On8+PsCMOFmhy2EmLo64Ua61QtgcBQq8zsIJ4db0uEWRM7nMhTUwkYa14nHHCa381aeZ4c0LYScBqygOAWWhWhIChzzgUq6rQhwsgTEZGIfiKfNE7gjaVOea1R/ULyBKyFPep/vZPA8xEug7I3+nRGefe5KJzeKwR8buWdOx70RdEolYbeqVscQz+9d3FgTXZUspFG5hAzyggMZLYyayuMtEmM0pkVp2r5gHpSrdbGCt1U7l83tnWq88ufcG1Y+meZBe8hSQQAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1440",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "931883",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jdEKgjAUht/lXK/hNnVuXUUFQV2IBF2IF7OGDtYWtgIR372FCOfinP//Dl89Qdma6/jSIOHsW1Ppe1CusxoQlN648AZZT8sakQ3JccL4NsU0EwLmZqV2w6DGiMbgYNRTBz2ATHCC4KJdF/r/QRihCCofVDDegSQ44wkXOaM5F2kRB8HNPBaY0YIgOGnT9VFMschorI9Wf9fvHHNGGYK9tz7K3MfaufkBmD0fktEAAAA=",
    Pbi3DGeometry:
      "7QIAAB+LCAAAAAAABACdktEKgjAUht/lXK8xZ2baVVQQ1IVU0IV0oTR0YC5sBCK+e6ustDK1jY393/l3DmzHzcDx+SY9MrBhIXy+FhHfAwJH8FiewHaz+1GFyUhNyNGL9DRCRrdNLch3j2vjJPFSdbenDTAlGupjzepTpJSpUx29YwsPhkaJ6tQwutGaxB+4xl1NbeChSa0/cVPJOntT9upLtcPti9b5v/9Pd/q7ouqbKfcOTLIEbIIJgiWLAxkWYiWkJ7mIC7nl+2dozngQykLMInYuGyciEsm1b29DtecFsKWXfu0CAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "900",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "931884",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jcsKwjAQRf9l1mnIo03auhIVBF2UIrgoXUQNbSAmUqNQSv/dSCnMYubeM5xmgupmLuNLQwknfzO1vgflOqsBQeWNC28om2lZI5JQgQmXm4RgIWgKc7ti22FQY2RjsDfqqYMeoCSYIDhr14X+f1BOGYLaBxWMd1BSnEkiC8GZkEWax0FwNY8F5iynCI7adH00M1xkLNYHq7/rt8CSM45g562PMvexdm5/FkkwD9IAAAA=",
    Pbi3DGeometry:
      "+QIAAB+LCAAAAAAABACdkl0LgjAUhv/LuZ5jKn5fRQVBXUgFXUQXSkMH5mKNQMT/3iorraxsY2PnOefdC9tZlxDGbFnsKfgw5TFb8IxtAUHIWS4P4K/L61GlSaAmVOhBNJ2Q4LKpBdXmJhsIERVKq+k2NoiONIIdw0EqckzDRM/Yw7ZrNanlWW5f3HH3K+4qb99uYdcxvP/5V99OwXeH1qP9hvvYdgne/1Vv+tlR9dCIRTsqqQCfYIJgRvNEpnUw5zKSjOd1uGLbe2pCWZLKOhhn9NgsHPKMi3MPX4Zq1RNYpW1O+QIAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "900",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "931885",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 2",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jcsKwjAQRf9l1mnIwyRtXYkKgi5KEVyULloNbSAmUqNQSv/dSCnMYubeM5xqgqI11/GlIYezb02p76FxndWAoPDGhTfk1bSsEUmoxISrbSKwSJmCuV6x3TA0Y2RjcDDNUwc9QE4wQXDRrgv9/6CcMgSlD00w3kFOsVBEZZIzqbJNGgfBzTwWmLOUIjhp0/XRzHAmWKyPVn/Xb4kVZxzB3lsfZe5j7Vz/AA5Bp63SAAAA",
    Pbi3DGeometry:
      "+QIAAB+LCAAAAAAABACdkl0LgjAUhv/LuZ5jan6kV1FBUBdSQRfSheLQgbmwEYj431tmZcSw3Nhh73O+YDthDUHM9tWZggdrHrMdz1kCCALOCnEBL6wfV+kmvtzQoDfRdEL81sgDzfGZNivLqJK5mm5jg+hIs7A9cU0kpWMaJvriU2y7Vh9buvMfVVX+5orwj9oWdh1jOhIPtVSFD1b/fKtf+R99lQmKXxqDB9rKGVqw6EQFLcEjmCDY0CIVWSe2XESC8aKTB5a8XCvK0kx0YpnTaz9wznNe3me4XXJUbwqgNT35AgAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "900",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "932401",
    Name: "Railing: SH_1100mm",
    Category: "Railings",
    Pbi2DGeometry:
      "hgEAAB+LCAAAAAAABACdkFELgjAUhf/LfV5jc7qlPUUFQT1IBD2ID0ZDB2sLW4GI/72BGgQ+SG/33O9wLudmLaRXdW4eEhI42KtKrW5KawBBapVxT0iyth+9IQiwoISuFpRiyjmHDk1BgVnMxB8wIJiFPPyFbA6cjJ0Hxyr5WHld10Xje/vFVhV36WQNCcEEwVGa0lWDOFlXOOVf1cuLun3RXqqy8lc4JlEsEOy0fA9egWO2jBBsrLY+1ry07vIPzFR47oYBAAA=",
    Pbi3DGeometry:
      "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",
    "Angled Joins": "Add Vertical/Horizontal Segments",
    "Baluster Offset": "0",
    "Base Level": "-1",
    "Base Offset": "0",
    Cost: "0",
    "Design Option": "-1",
    Family: "SH_1100mm",
    "Family and Type": "SH_1100mm",
    Height: "0",
    Image: "<None>",
    "Landing Height Adjustment": "0",
    "Lateral Offset": "0",
    Length: "2928",
    "Offset from Path": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "None",
    "Rail Connections": "Trim",
    "Railing Height": "1100",
    "Tangent Joins": "Extend Rails to Meet",
    Type: "SH_1100mm",
    "Type Id": "SH_1100mm",
    "Type Image": "<None>",
    "Use Landing Height Adjustment": "No",
    "Use Top Rail": "Yes",
  },
  {
    ID: "932546",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "932549",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "932553",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
  },
  {
    ID: "932862",
    Name: "Railing: SH_1100mm",
    Category: "Railings",
    Pbi2DGeometry: "EgEAAB+LCAAAAAAABACNjkELgkAQhf/LnLfFdUTRTlFBUAeJoIN4MFp0YNsJ2wIR/3sLahB06DZvvsd7r+ghv9Cpu2vIYM8Xytl0NVsQkDNZ94Cs6MfTG6JQokK1XCglVRzHMIhfMJGYYvIN8S84x5Zz/aptq85v8I8NVTftdAtZIAMBB21r10ziyK5y5GeP8kzXD9ppqhvfEslIpShga/Rr8qYywDAUsGbDPtY+jRnKN8ukw2ASAQAA",
    Pbi3DGeometry:
      "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",
    "Angled Joins": "Add Vertical/Horizontal Segments",
    "Baluster Offset": "0",
    "Base Level": "Level 2",
    "Base Offset": "0",
    Cost: "0",
    "Design Option": "-1",
    Family: "SH_1100mm",
    "Family and Type": "SH_1100mm",
    Height: "0",
    Image: "<None>",
    "Landing Height Adjustment": "0",
    "Lateral Offset": "0",
    Length: "1898",
    "Offset from Path": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "None",
    "Rail Connections": "Trim",
    "Railing Height": "1100",
    "Tangent Joins": "Extend Rails to Meet",
    Type: "SH_1100mm",
    "Type Id": "SH_1100mm",
    "Type Image": "<None>",
    "Use Landing Height Adjustment": "No",
    "Use Top Rail": "Yes",
  },
  {
    ID: "932869",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "932872",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "932876",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
  },
  {
    ID: "933811",
    Name: "Railing: SH_1100mm",
    Category: "Railings",
    Pbi2DGeometry:
      "hgEAAB+LCAAAAAAABACdkFELgjAUhf/LfV5jc7qlPUUFQT1IBD2ID0pDB2sLW4GE/72BGgQ+SG/33O9wLudmb0hLdW7vEhI42FKlVreVNYAgtcq4ByTZux+9IQwwo4yuFpRiyjmHDk1BgVnMxB8wIJiFPPyFbA6cjJ0Hxyr5WHndNEXre/vFVhU36WQDCcEEwVGaytWDOFlXOOVf1cuLun7RXqqq9lc4JlEsEOy0fA1egWO2jBBsrLY+1jy17vIPl5j+XYYBAAA=",
    Pbi3DGeometry:
      "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",
    "Angled Joins": "Add Vertical/Horizontal Segments",
    "Baluster Offset": "0",
    "Base Level": "-1",
    "Base Offset": "0",
    Cost: "0",
    "Design Option": "-1",
    Family: "SH_1100mm",
    "Family and Type": "SH_1100mm",
    Height: "1100",
    Image: "<None>",
    "Landing Height Adjustment": "0",
    "Lateral Offset": "0",
    Length: "2928",
    "Offset from Path": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "None",
    "Rail Connections": "Trim",
    "Railing Height": "1100",
    "Tangent Joins": "Extend Rails to Meet",
    Type: "SH_1100mm",
    "Type Id": "SH_1100mm",
    "Type Image": "<None>",
    "Use Landing Height Adjustment": "No",
    "Use Top Rail": "Yes",
  },
  {
    ID: "933818",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "933821",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "933825",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
  },
  {
    ID: "933840",
    Name: "Railing: SH_1100mm",
    Category: "Railings",
    Pbi2DGeometry:
      "+gEAAB+LCAAAAAAABACNkcsKwjAQRf9l1nFo87APV6KCoIsiggtxUTG0gdhIjUIR/91ItWKt4i6TM9y5c2d9gWSrltVBQgwzs1WJ0VVmCiCQGFXYI8TrS/10DZRi4IV80KM+sj4TcCUdkHOMBA3eIUNaQ4G8DTnFkPrsC2TIatgh28C7oajP2rJ/wE7ZxhD/NPRapRv+DKEV3+YZ87As08pl7T7GKt1LK0uIPfQIzGWR2fxRLIxNrXLnqcuV2jVoKlWWuynOlB8xAhMtz4/eAIUQIYGR0cbJFietr5sbJzG5AvoBAAA=",
    Pbi3DGeometry:
      "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",
    "Angled Joins": "Add Vertical/Horizontal Segments",
    "Baluster Offset": "0",
    "Base Level": "Ceiling",
    "Base Offset": "-150",
    Cost: "0",
    "Design Option": "-1",
    Family: "SH_1100mm",
    "Family and Type": "SH_1100mm",
    Height: "1100",
    Image: "<None>",
    "Landing Height Adjustment": "0",
    "Lateral Offset": "0",
    Length: "20348",
    "Offset from Path": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "None",
    "Rail Connections": "Trim",
    "Railing Height": "1100",
    "Tangent Joins": "Extend Rails to Meet",
    Type: "SH_1100mm",
    "Type Id": "SH_1100mm",
    "Type Image": "<None>",
    "Use Landing Height Adjustment": "No",
    "Use Top Rail": "Yes",
  },
  {
    ID: "934465",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "934468",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "934474",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
  },
  {
    ID: "935747",
    Name: "Walvit_Hung Bowl_604118 W: Walvit",
    Category: "Generic Models",
    Level: "Level 1",
    Pbi2DGeometry: "uwAAAB+LCAAAAAAABAA9jV8LgjAUxb/LfV5Dp9JcT1FBUA9SQQ/ig+JFL6xN1gpE/O4NKt/Onx/nlBMUDd3GAUHByTZ0HXp0CAwKS8Y/QZXTV4Ze5DxJpNysIi6zDObqT22dq8eAhmBP9QM9OlAxj2UqGJzRdL4HFfGIwcX62pM1P3undqmOSF0fbgRfp5lkcND4XthY5GFqZ7UNy+al9Vx9ABMfECS7AAAA",
    Pbi3DGeometry:
      "xwcAAB+LCAAAAAAABADtk80LgjAYxv+X9zzHtiw/OkUFHTpEBB3Cg9GwgbmwFUT0vye1Plg68xoiE9+fzx73zj2rC8zWYnHecwizY5oimEmRqQOEq8vjEUIg/eKCK3oThxLSv9+KAdfoOW2Q5/G5mMs87PYCihyKXdejiGDKAoZYgDuu51diglmPBS9cY1KhNnDNJzVm2Pe6X9YGta+j3KKmFwNrD6MVg1ZYlIubbZId261/EttbafSvfvMoF1tpk6Nhd6jfiiI5IxHvuOI5hAQTBFOeJWqri7lUsRIy0+VSbF6vJlwkW6WLccpPn8KhTGX+SPQ9tm3E24i3Ef/biEc3QzqujMcHAAA=",
    Area: "1",
    "Bowl Height": "406",
    "Button Height": "813",
    Cost: "0",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "Walvit",
    "Family and Type": "Walvit",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    Manufacturer: "Caroma",
    Model: "Walvit Round Front Plus",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Porcelain: "Porcelain",
    "Silver Button": "Steel buttons",
    Type: "Walvit",
    "Type Id": "Walvit",
    "Type Image": "<None>",
    URL: "http://www.caromausa.com/Walvit-RFP",
    Volume: "0.02",
  },
  {
    ID: "936823",
    Name: "Lavatory-TOTO-Luminist_Rectangle_Vessel_LLT151: Standard",
    Category: "Plumbing Fixtures",
    Level: "Level 1",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABAA9jcsKwjAURP/lrkNJH3nVlagg6KIUwUXpotVLG4iJ1CiU0n83pehuznCGqSYoWn0Znwg5nFyrS7z5xnYGgUDhtPUvyKtpjUFJRKRUtkkiFgsBc/2TtsPQjMEMxV43D/Q4QE4jSuCMtvM95HHEGVUESucbr51dGiaoUDxNuFCZVDIlcNX3VaacBjyi7nq/cCpFRuBg8PNfp1wyAjtnXPiyb2Pm+guie/vfzwAAAA==",
    Pbi3DGeometry:
      "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",
    "ADA Compliant": "Yes",
    Area: "0",
    "Assembly Code": "D2010310",
    "Assembly Description": "Lavatories - Single",
    "CADworks URL": "http://www.CADworks.net",
    "Chrome Drain Fitting Visibility": "Yes",
    "Cold Water Connection NPT": "10",
    "Cold Water Connection Radius": "5",
    Cost: "0",
    CWFU: "0",
    "Default Elevation": "0",
    Description: "Rectangle Vessel Lavatory",
    "Design Option": "-1",
    "Distance from Wall": "75",
    "Elevation from Level": "750",
    Family: "Standard",
    "Family and Type": "Standard",
    Finish: "Epoxy Resin - TOTO - 61 Angelic White",
    "Flow Pressure": "0",
    Host: "Level : Level 1",
    "Host Id": "-1",
    "Hot Water Connection NPT": "10",
    "Hot Water Connection Radius": "5",
    HWFU: "0",
    Image: "<None>",
    Manufacturer: "TOTO",
    Mark: "36",
    Model: "LLT151",
    "Nominal Height": "115",
    "Nominal Length": "320",
    "Nominal Width": "500",
    "Offset from Host": "750",
    "OmniClass Number": "23.45.05.14.14",
    "OmniClass Title": "Sinks/Lavatories",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Product URL": "http://www.totousa.com/ProductDetail/tabid/75/Default.aspx?ProductId=bed3c6ef-3249-4991-8e7d-95b38e7deef4&SearchId=38911d30-d0e8-4fd9-a60f-54114ef37070",
    Series: "Luminist",
    "Shipping Weight": "0.06",
    "System Classification": "Sanitary,Domestic Cold Water,Domestic Hot Water",
    "System Type": "Undefined",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    URL: "http://www.totousa.com",
    Volume: "0",
    "Waste Connection NPT": "32",
    "Waste Connection Radius": "16",
    WFU: "0",
  },
  {
    ID: "937138",
    Name: "M_Shower Stall-2D: small",
    Category: "Plumbing Fixtures",
    Level: "Level 2",
    Pbi2DGeometry: "vwAAAB+LCAAAAAAABAA1zDELwjAQhuH/cnMMIbG2jZOoIOhQiuBQOqR6tAcxkRqFUvrfjVi343sfrhqhaOg8PBA0HH1DJV6Dca1FYFB4cuEJuhp/ZyQLwZdSyPVCcSHVCqb6zzZ9b4Zo47Ajc8eAPWjBBYMTujZ0oBVPRaoYlD6YQN7N+UK3b5U8T2TG4IDUdmFue4vv2eY8S7KcwdZbHz+7l7VT/QHeMdXCvwAAAA==",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    Cost: "0",
    CWFU: "0",
    "Default Elevation": "0",
    Depth: "900",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "small",
    "Family and Type": "small",
    Host: "Level : Level 2",
    "Host Id": "-1",
    HWFU: "0",
    Image: "<None>",
    Mark: "37",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "OmniClass Number": "23.45.05.14.17",
    "OmniClass Title": "Showers",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "System Type": "Undefined",
    Type: "small",
    "Type Id": "small",
    "Type Image": "<None>",
    Volume: "0",
    WFU: "0",
    Width: "1130",
  },
  {
    ID: "937571",
    Name: "Walvit_Hung Bowl_604118 W: Walvit",
    Category: "Generic Models",
    Level: "Level 2",
    Pbi2DGeometry: "uwAAAB+LCAAAAAAABAA9jc0KwjAQhN9lzzE0JTVtPIkKgh6KCh5KDxWXdiEmJUahlL67Aau3+fmYqUYob3QZegQNB3ejc9+hR2BQOrLhCboavzL2ouAylXK1WPJcZTDVP2rtfTNENAZbah4Y0IMWXOQyZXBE24YOdMITBicXmkDOzvZK93+1R2q7eJNyJbOcwc7ge2YLXiihGGyccXHZvoyZ6g/9VOskuwAAAA==",
    Pbi3DGeometry:
      "DwgAAB+LCAAAAAAABADtlM8LgjAUx/+Xd55j0yy1U1TQoUNE0CE6GI0amAtbQYT/e8O0H8qcnhNRfB+/76tv7r3NAxY7vrqfGQTxNYoQLASP5QWCzeN1CwGQoTogRR9iUUKG2UWdkG6LtFGShHeVSz3sObaDrD72PMdHPvYHdIBsggnt97TYxYS4doFNJhr1Lza9MsfUxgq7FfMKr/8WnU19RWVcuJRLqnCNjU7ebsHqscG8qdxQUsu/19BFJzfxtpvG6NNscVR3TXh4YpIlEKhUBHMWH+QxD5ZChpKLOA/XfP9+NGP8cJR5MI3Y7Vs4FpFIXl2ftXY3Brox0I2Bvx4D2yfa/ixeDwgAAA==",
    Area: "1",
    "Bowl Height": "406",
    "Button Height": "813",
    Cost: "0",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "Walvit",
    "Family and Type": "Walvit",
    Host: "Floor : Generic 300",
    "Host Id": "-1",
    Image: "<None>",
    Manufacturer: "Caroma",
    Model: "Walvit Round Front Plus",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Porcelain: "Porcelain",
    "Silver Button": "Steel buttons",
    Type: "Walvit",
    "Type Id": "Walvit",
    "Type Image": "<None>",
    URL: "http://www.caromausa.com/Walvit-RFP",
    Volume: "0.02",
  },
  {
    ID: "937572",
    Name: "M_Shower Stall-2D: M_Shower Stall-2D",
    Category: "Plumbing Fixtures",
    Level: "Level 2",
    Pbi2DGeometry: "zgAAAB+LCAAAAAAABAA1zV8LgjAUBfDvcp/XmLo/bj1FBUE9iAQ9iA9aQwdrC1uBiN+9RfZ2OfzOudUERWvO40ODgqNvTamvoXGd1YCg8MaFJ6hq+p2RJBRLIdP1imFCWApz/WebYWjGaGOwM81dBz2AIpggOGnXhR5UiqnMKILShyYY70AlmAkiJM9SLiSVhHMEF3P7YhZxLhActOn6sCztrX4vVYlzlksEW299fORe1s71B9bz/vfOAAAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    Cost: "0",
    CWFU: "0",
    "Default Elevation": "0",
    Depth: "760",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "M_Shower Stall-2D",
    "Family and Type": "M_Shower Stall-2D",
    Host: "Floor : Generic 300",
    "Host Id": "-1",
    HWFU: "0",
    Image: "<None>",
    Mark: "38",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "OmniClass Number": "23.45.05.14.17",
    "OmniClass Title": "Showers",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "System Type": "Undefined",
    Type: "M_Shower Stall-2D",
    "Type Id": "M_Shower Stall-2D",
    "Type Image": "<None>",
    Volume: "0",
    WFU: "0",
    Width: "1676",
  },
  {
    ID: "937573",
    Name: "Lavatory-TOTO-Luminist_Rectangle_Vessel_LLT151: Standard",
    Category: "Plumbing Fixtures",
    Level: "Level 2",
    Pbi2DGeometry:
      "1QAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7zGNt3SdYoSgjqIBB3Ew6yhg7WFrUDE797Cur33+L336gnK1pzHhwYJR9+aSl+Dcp3VgKD0xoUnyHpaZEQYxZyLfLPimCeEwdz8se0wqDGyMdgbdddBDyAJJghO2nWhB0mx4CRHUPmggvEOZIYZ5TFMMsaYoDxLixXlCC7mthSIIAmCgzZdH74+ydYpgsLq92+B0jhBEey89fHPvaydmw8UPRLq1QAAAA==",
    Pbi3DGeometry:
      "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",
    "ADA Compliant": "Yes",
    Area: "0",
    "Assembly Code": "D2010310",
    "Assembly Description": "Lavatories - Single",
    "CADworks URL": "http://www.CADworks.net",
    "Chrome Drain Fitting Visibility": "Yes",
    "Cold Water Connection NPT": "10",
    "Cold Water Connection Radius": "5",
    Cost: "0",
    CWFU: "0",
    "Default Elevation": "0",
    Description: "Rectangle Vessel Lavatory",
    "Design Option": "-1",
    "Distance from Wall": "75",
    "Elevation from Level": "750",
    Family: "Standard",
    "Family and Type": "Standard",
    Finish: "Epoxy Resin - TOTO - 61 Angelic White",
    "Flow Pressure": "0",
    Host: "Level : Level 2",
    "Host Id": "-1",
    "Hot Water Connection NPT": "10",
    "Hot Water Connection Radius": "5",
    HWFU: "0",
    Image: "<None>",
    Manufacturer: "TOTO",
    Mark: "39",
    Model: "LLT151",
    "Nominal Height": "115",
    "Nominal Length": "320",
    "Nominal Width": "500",
    "Offset from Host": "750",
    "OmniClass Number": "23.45.05.14.14",
    "OmniClass Title": "Sinks/Lavatories",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Product URL": "http://www.totousa.com/ProductDetail/tabid/75/Default.aspx?ProductId=bed3c6ef-3249-4991-8e7d-95b38e7deef4&SearchId=38911d30-d0e8-4fd9-a60f-54114ef37070",
    Series: "Luminist",
    "Shipping Weight": "0.06",
    "System Classification": "Sanitary,Domestic Cold Water,Domestic Hot Water",
    "System Type": "Undefined",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    URL: "http://www.totousa.com",
    Volume: "0",
    "Waste Connection NPT": "32",
    "Waste Connection Radius": "16",
    WFU: "0",
  },
  {
    ID: "937935",
    Name: "Basic Wall: Interior - Partition",
    Category: "Walls",
    Pbi2DGeometry: "EQEAAB+LCAAAAAAABACFjsEKwjAQRP9lzzGkbaJJPYkKgh6KCB5KDxVDuxATqVEopf9uoK0HEbzt7BtmJu8gu+CpvWtIYe8umDnTVs4Cgcyh9Q9I8244gyHiVEghljNOJZMcevKDRYzKRCTfUC1U/AdOqcVUvmqasg0LwmOD5U173UDKKCNw0Lby9SiOzpcew+hBnvH6QTuNVR1KQocUak5ga/RrNCsqeSwIrJ1xIdc+jemLNzUKNE4RAQAA",
    Pbi3DGeometry:
      "JQQAAB+LCAAAAAAABACVU9FqwjAU/Zf7nIXbtKGmfRJ1CPNB5mAPsoeKoQZqM2oYiPjvZtqtW2uaSkjJPSc59/bcZH2C5Ua9HT8lJPCiN2qlC7UFAkutSnOAZH26LS2NqR1wJg3yFCCm14+dcP74OTauquxozwYR5SPOid1COYaCCDqKGCcdPBA0CljYEJwickZYRGNkbDDu0m9wEQt2T+aG36nnP9EW8iTw53WU36syvJh+9x80zYc7Tet010s4Ku30y4N7/ez1wdWsR/53UJmDb3krgX1vU5XtpZEVJEiRwEKWudnVwas2mVG6rMN3tf2l5lLlO1MHs0J+/d040YW2ghA/fw/7rC8tZKJYJQQAAA==",
    Absorptance: "0.1",
    Area: "6",
    "Assembly Code": "C1010145",
    "Assembly Description": "Partitions - Drywall w/ Metal Stud",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Coarse Scale Fill Color": "8421504",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Interior - Partition",
    "Family and Type": "Interior - Partition",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Length: "1837",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Wood - Stud Layer",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Line",
    "Top Extension Distance": "0",
    "Top is Attached": "Yes",
    "Top Offset": "0",
    Type: "Interior - Partition",
    "Type Id": "Interior - Partition",
    "Type Image": "<None>",
    "Unconnected Height": "3000",
    Volume: "0.75",
    Width: "120",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "938761",
    Name: "Walvit_Hung Bowl_604118 W: Walvit",
    Category: "Generic Models",
    Level: "Level 2",
    Pbi2DGeometry: "vAAAAB+LCAAAAAAABAA9jc0KwjAQhN9lzzE0UpsmnkQFQQ9FBQ+lhxaXdiEmJUahlL67Aau3+fmYKUcoGroOPYKGo2vo0nfoERgUjmx4gi7Hr4y9kDzJMrleCJ4poWCqftjG+3qIbAx2VD8woActuMjTJYMT2jZ0oBOeMDi7UAdydrY3uv+rA1LbxZ8ll+kqZ7A3+J5ZxZUUksHWGReX7cuYqfoAJ1mbF7wAAAA=",
    Pbi3DGeometry:
      "6wcAAB+LCAAAAAAABADtk08LgjAYxr/Le15jq5xmp6igQ4eIoIN0MBo1MBe2ggi/e0PN/q7pOZHp3p/PHn2nT3CF2VosLgcOfnyKIgQzKWJ1BD+45lPwgfT1ASl6kBYlpJ+d9IB0dV82SJLwotdShrtul6FWBzuMuqiHe66+UBczx/OMmGLmdUpq8fgufqWW5xWYtrHGzrv1B/75IgYTSzNvuDR5becDG1wM6jo79YtajCuJba3U/GLVXExyK6/5o9hsquyMztJIhHuueAI+wQTBlMdbtSuKuVShEjIuyqXYlLcmXGx3qijGET8/C4cykkme8SzITeib0Deh/6PQr27pED+X6wcAAA==",
    Area: "1",
    "Bowl Height": "406",
    "Button Height": "813",
    Cost: "0",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "Walvit",
    "Family and Type": "Walvit",
    Host: "Floor : Generic 300",
    "Host Id": "-1",
    Image: "<None>",
    Manufacturer: "Caroma",
    Model: "Walvit Round Front Plus",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Porcelain: "Porcelain",
    "Silver Button": "Steel buttons",
    Type: "Walvit",
    "Type Id": "Walvit",
    "Type Image": "<None>",
    URL: "http://www.caromausa.com/Walvit-RFP",
    Volume: "0.02",
  },
  {
    ID: "938762",
    Name: "M_Shower Stall-2D: M_Shower Stall-2D",
    Category: "Plumbing Fixtures",
    Level: "Level 2",
    Pbi2DGeometry: "zQAAAB+LCAAAAAAABAA1zV8LgjAUBfDvcp/XcM65Pz1FBUE9iAQ9iA9aQwdrC1uBiN+9RfZ2OfzOudUERWvO40ODgqNvTamvoXGd1YCg8MaFJ6hq+p2RpAQzQuR6RTHLCYe5/rPNMDRjtDHYmeaugx5AJThBcNKuCz2oFGeSZghKH5pgvAMVx3jCZU7TnMtMSIrgYm5fy6IVHMFBm64Py9De6vfSlFgwIRFsvfXxj3tZO9cfQm6v/s0AAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    Cost: "0",
    CWFU: "0",
    "Default Elevation": "0",
    Depth: "760",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "M_Shower Stall-2D",
    "Family and Type": "M_Shower Stall-2D",
    Host: "Floor : Generic 300",
    "Host Id": "-1",
    HWFU: "0",
    Image: "<None>",
    Mark: "42",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "OmniClass Number": "23.45.05.14.17",
    "OmniClass Title": "Showers",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "System Type": "Undefined",
    Type: "M_Shower Stall-2D",
    "Type Id": "M_Shower Stall-2D",
    "Type Image": "<None>",
    Volume: "0",
    WFU: "0",
    Width: "1676",
  },
  {
    ID: "938763",
    Name: "Lavatory-TOTO-Luminist_Rectangle_Vessel_LLT151: Standard",
    Category: "Plumbing Fixtures",
    Level: "Level 2",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jcsKwjAURP/lrmPIbfpKXIkKgi5KEVyULloNbSAmUqNQSv/dSHU3ZzjDVBMUrT6PDwUSjq7Vpbr6xnZGAYHCaeufIKtpiUHBmAoeR+sVp4ynGcz1X9sMQzMGNxQ73dyVVwNIRhmBk7Kd70EiTRMmCJTON147C5JTjDERUZrwJBeZQE7gom+LzFIW8KB01/sv8zyLCeyNev/WiDRCJLB1xoUv+zJmrj++8PIt0QAAAA==",
    Pbi3DGeometry:
      "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",
    "ADA Compliant": "Yes",
    Area: "0",
    "Assembly Code": "D2010310",
    "Assembly Description": "Lavatories - Single",
    "CADworks URL": "http://www.CADworks.net",
    "Chrome Drain Fitting Visibility": "Yes",
    "Cold Water Connection NPT": "10",
    "Cold Water Connection Radius": "5",
    Cost: "0",
    CWFU: "0",
    "Default Elevation": "0",
    Description: "Rectangle Vessel Lavatory",
    "Design Option": "-1",
    "Distance from Wall": "75",
    "Elevation from Level": "750",
    Family: "Standard",
    "Family and Type": "Standard",
    Finish: "Epoxy Resin - TOTO - 61 Angelic White",
    "Flow Pressure": "0",
    Host: "Level : Level 2",
    "Host Id": "-1",
    "Hot Water Connection NPT": "10",
    "Hot Water Connection Radius": "5",
    HWFU: "0",
    Image: "<None>",
    Manufacturer: "TOTO",
    Mark: "43",
    Model: "LLT151",
    "Nominal Height": "115",
    "Nominal Length": "320",
    "Nominal Width": "500",
    "Offset from Host": "750",
    "OmniClass Number": "23.45.05.14.14",
    "OmniClass Title": "Sinks/Lavatories",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Product URL": "http://www.totousa.com/ProductDetail/tabid/75/Default.aspx?ProductId=bed3c6ef-3249-4991-8e7d-95b38e7deef4&SearchId=38911d30-d0e8-4fd9-a60f-54114ef37070",
    Series: "Luminist",
    "Shipping Weight": "0.06",
    "System Classification": "Sanitary,Domestic Cold Water,Domestic Hot Water",
    "System Type": "Undefined",
    Type: "Standard",
    "Type Id": "Standard",
    "Type Image": "<None>",
    URL: "http://www.totousa.com",
    Volume: "0",
    "Waste Connection NPT": "32",
    "Waste Connection Radius": "16",
    WFU: "0",
  },
  {
    ID: "938974",
    Name: "Basic Wall: Interior - Partition",
    Category: "Walls",
    Pbi2DGeometry: "DQEAAB+LCAAAAAAABAB9jkELgkAUhP/LO2+Lq666dooKgjpIBB3Eg+KiC9u+sC0Q8b+3oHko6PbmfcPM5ANklbr0dwkpHLFSGeq+QQMEMlTGPiDNh+l0Bp9R4fFovQpozBMOI/llIQ15FH8jzpj4h5bE4lO86bqyd+3usVPlTVrZQepRj8BJmsa2szijLa1ygyd5VfWCDlI1rSthggZCJAT2Wr5ms6BJ6HMCW9Tocs1T67F4A/T67GUNAQAA",
    Pbi3DGeometry:
      "NQcAAB+LCAAAAAAABACdVV1rwyAU/S8+W1ETk9g+lX0w2B7KNthD2UNKpRWyODIZlNL/PttmbYgfMSUkxOP13HP1qMs9WKzk++5bgCl4Viv5piq5BhAslKz1D5gu9+df041n5gEHeEUmBOPZ6WNecPj8HzZvmnJnxlKCOGYZnCSIZSSHNEOYYw77OEdFStkFThFl3ESliJGcWtF9Fl84RrRgBaQc0ZQmsexuLVeUEcI9KEVJgnNPbCffCXZU0yUxMKPDLB7YrcSUlFigXXdQnifhmdoE8+Q4aIDEsTQBFs+M3KRwsHj3onsc4ifugyGCUc5zZnMvd9COURWPMX+0QUObMDzxlo0G8Lh5HoCtM8vjXS8eL/6mvNaeGXn4+cSPSxraqG6F0caIOOfajOb+uZfll9CiAVOMMAQvot7obdt4VbrUUtVt80OuL11PQm62um08VOK3G3inKmUIQf54fMw19wehlu6UNQcAAA==",
    Absorptance: "0.1",
    Area: "13",
    "Assembly Code": "C1010145",
    "Assembly Description": "Partitions - Drywall w/ Metal Stud",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Coarse Scale Fill Color": "8421504",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Interior - Partition",
    "Family and Type": "Interior - Partition",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Length: "2504",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Wood - Stud Layer",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Line",
    "Top Extension Distance": "0",
    "Top is Attached": "Yes",
    "Top Offset": "0",
    Type: "Interior - Partition",
    "Type Id": "Interior - Partition",
    "Type Image": "<None>",
    "Unconnected Height": "3000",
    Volume: "1.51",
    Width: "120",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "939084",
    Name: "Basic Wall: Interior - Partition",
    Category: "Walls",
    Pbi2DGeometry: "CQEAAB+LCAAAAAAABAB9jk8LgkAUxL/LOy/L/lFc7RQVBHWQCDqIB6VFF7Z9YVsg4ndvQS26dHvzfsPMFAPktTn3dw0ZHLA2Odq+QQcEcjTOPyArhukMBsFpwpRaCSolS2AkX8QljYWM/iFOU/lLlryZlEvpuuuqPjSHx9ZUN+11BxmjjMBRu8a3szihr7wJYyd5MdcP2mvTtKGCJ5SpVBDYWf2azSlVkYgJbNBiyHVPa8fyDXlw97AJAQAA",
    Pbi3DGeometry:
      "9wcAAB+LCAAAAAAABACVVVtLwzAU/i95jiFJ792TeEHQh6GCD8OHjpUtUBupRRhj/93o2tmmJ+kZpaX58uU7J+eSrA5kuVav+8+S5ORRr9WLrtSGULLUqm6/SL46nH7NNF+YhxzpP3IlOF/8fcxLju/9suumKfZmrRQsEiKjkgUBT2jG0lBGVCRMhjLsUZGxOI2oxZUxiySW3AsHLJFc+s31whfZM8ppHIspCtkbo2dhFxkSdjnhEB5KOGBLQ7AsmDhxAkGmUc0CkWCoVtht5mD5QBRtClLtUzmyPwZ7UZDqcnW6KVh0vB5GvYULe+VIlRuERVE9Mm9rNln4one03gUZ84IoY45TwdF5YIHMg3YpYFsUWfdeEHmAwe0I9rhHwIva28XFBgwkpkRsFJl4fwH7IoRDUfbMDXqrio+yLRuSc8YpeSrrbbvrBs+6LVql6274pjbnqYdSbXdtN7iryu8h8UZX2giS5P73MRf1D8PZfuL3BwAA",
    Absorptance: "0.1",
    Area: "10",
    "Assembly Code": "C1010145",
    "Assembly Description": "Partitions - Drywall w/ Metal Stud",
    "Base Constraint": "Level 2",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Coarse Scale Fill Color": "8421504",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Interior - Partition",
    "Family and Type": "Interior - Partition",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Length: "2495",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Wood - Stud Layer",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Roof Line",
    "Top Extension Distance": "0",
    "Top is Attached": "Yes",
    "Top Offset": "0",
    Type: "Interior - Partition",
    "Type Id": "Interior - Partition",
    "Type Image": "<None>",
    "Unconnected Height": "3000",
    Volume: "1.2",
    Width: "120",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "939962",
    Name: "Pocket_Slider_Door_5851: 2.027 x 0.945",
    Category: "Doors",
    Level: "Level 2",
    Pbi2DGeometry: "zgAAAB+LCAAAAAAABAA1jcsKwjAUBf/lrkNIm0ebuBIVBF2UIrgoXUQNbSAmUqNQSv/d+NodhjlMM0F1sofxZkDBLpxsbc5R+84ZQFAF6+MdVDN9Z1IyiQWlYsEw46KAuf1by2HQY1ITWFt9NdEMoAgmCPbGd7EHRXFGCENQh6ijDf5DWMZlLjjlpSwkgqO9vFWCqaQFgq2xXZ+yAgtOKIKNM8/fV+KS5RzBKriQSv7h3Ny+AJeSzkTOAAAA",
    Pbi3DGeometry:
      "3RUAAB+LCAAAAAAABAClV01rGzEQ/S86b5eV9sNa5+Q6gUJ7CG2hh+CDQ5ZkwfUGdymE4P9eOZbriXZmNHIIDt7n5zdPo9FofPeqbu/7ny/PnZqrr8N9/2PY9A8qU7dDvx3/qPnd6/Gt+7i4cn9qn52RT7oort7+uZfar05fW+x26xf3XW1zo6tZVuVNXTZZm9vK1JlDdWtLh9ZlUQO0sGU15XrU1G0b5eK6OIo78yjOxT0EqI9WWoOguLOAm6LrneFooICvGM8k5OomLxtdZ0bn2pY2IDu0qE3DoycJQjmw4eCqNZYRwdgybd5fsERgBF85Qb7cNb8DQYGmwbFCYI8Jg4JwcQmCfIBnMM8QxbmEMCkhJLMrwW3Ak5mCXtYd4Imf7rSMzLoIHGMS57xBMoLSZJk5nCxNxlv/S4PZzno+2ZB7Xl+AQu60C+DhGBTkE1MObEz7i4Qt0+b9BUsERtir/AOuU6WJPiyA2Us6enlQrc7OIu0rqowfwyRlojGSS0Gl8euR9OFgPHcTFF9gWLsn8qzC4lFsVJpKdJI0Xh1Ez8SVqVZ6YE+VGXexHuZRRliIiqLhJYAPkilDJ6ubjE5bbjgtCmBhQMHlEexSGnzZ/hPCkZplYGHB4b2B2JQLYDZgdJ4mtlviIyoiGfjpkHwzF7KF2vjId/FMLPohwI9wYbNMOC3ySZcZJqMhiWlGeJwJJ/zcwl1NYlg6KrXWHAy2Wr8zCGBw/v1qUlFCGKbPl44xJZzYjmQGnSq/gwNlPiBhmtBIMxJduSRPspDC9MHtSqoDXDiWUibRrLVYfTHRxEXAbclRepWp6379uxu7nZoXeZGpb932cXzyD9+HcT32w9Y//uof/n/0pesfn0b/cLPp/kLictgMTlBdL5efFwu1X/0Dfp3j6d0VAAA=",
    "Analytic Construction": "<None>",
    "Architrave Offset": "5",
    Area: "4",
    "Assembly Code": "C1020",
    "Assembly Description": "Interior Doors",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    Description: "Internal Single Pocket Slider",
    "Design Option": "-1",
    "Door Ironmongery": "Door - Handle",
    "Door Material": "Door - Panel",
    "Door Panel Width": "910",
    Family: "2.027 x 0.945",
    "Family and Type": "2.027 x 0.945",
    "Frame Thickness": "40",
    Function: "Interior",
    "Handle position - X": "125",
    "Handle position - Z": "700",
    "Head Height": "2027",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2027",
    "Host Id": "Interior - Partition",
    Image: "<None>",
    "Jamb Pocket": "50",
    "Jamb Rebate": "45",
    Mark: "208B",
    "Open dist Elevation 3D": "2",
    "Open dist Plan 2D": "600",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rough Height": "35",
    "Rough Width": "0",
    "Sill Height": "0",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "40",
    Type: "2.027 x 0.945",
    "Type Id": "2.027 x 0.945",
    "Type Image": "<None>",
    "Type Mark": "51",
    "Vis - Architrave": "No",
    "Visual Light Transmittance": "0",
    Volume: "0.09",
    "Wall Closure": "By host",
    Width: "945",
  },
  {
    ID: "940221",
    Name: "Pocket_Slider_Door_5851: 2.027 x 0.945",
    Category: "Doors",
    Level: "Level 2",
    Pbi2DGeometry:
      "1AAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7zGnJu6dYoSgjqIBB3Ew6qhg7WFrUDE796kuj0ev997zQTVxZzGhwYJB38xtb4G5TqrAUHljQtPkM30jRFJOOai4GuGGc9ymNs/tRkGNUY0Fjuj7jroASTBBMFRuy70IFOcEMIQ1D6oYLxbGspIQinPKBO5KHJWrhKO4Gxui0BwKtIcwV6bro/nGc44SRGUVr9/CwIXjEZj662Pf+5l7dx+AMTRib3UAAAA",
    Pbi3DGeometry:
      "yxUAAB+LCAAAAAAABAClV9tq20AQ/Zd9VoVWq6vz5DqFQvsQ2kIfgh8cIhKBaxVXFELwv1dxFGUvc9uakGAdHZ85Ozs7O7l9Vjd3/Y+n351aqS/DXf992Pf3KlE3Q38Y/6jV7fPrx+l1djX9qFPyjnzQWXZ1/jP9qtP27Wvr43H3NH1X16kumjop0qo0VdKmTZGXyYRmxrQTWpqstFFdl1IurDujedm2oe4F0WbUNHkrjeahCBfUJbMDR4MVfNRasa5SU2kilVB6ilTXbRVIuPA7OSsaI5RwXUxw0ebNRZ45acyejVrkGNdomkBttz4tbWQ1SN1SKFxJSDwKFp6TRaIm10eVOUV+U14SyqDU+mAN9wQFKMyNyRBxXoO8wad44boJkglT7cEVXvLDwaFlxBxDZpTP7S/c1CAgmzphY3XjLSfbh2fPjoZLZpQj7w3YnO0i7EbxnjlpzJ6Nhn1OKI2kCdFGrg+aLco1OWkgd0ppprdMj0GvGqj+ObKkA7Jk0DN8PVJk6RV71pAqm7qAYL/U/yd3MBlR9k4LYwM2jTU8hh3aC3xgEi8wTA4OPowKGpvEWsxsyNXLzCWqiNOlh1m/EOF4JBoVz987pBHHbAi5pVStiN2JaoivQj77XGOVFwGBcja4mdzvt8g/DaAIv3JQGzEoYvP3hKcNTHFMmxLM68xU7emC5ciNgcjEQQ2Nl55PxKDISewRFcxm4kmJusGR29CeNIumeDHYam3PSoYG7ekOQF1ZBPaFyzw3ofAZtc7+q0A0CusyKCIhWh2ToYhF09SYYHja6VSStvjKgbc9atcYckw4ZNPseNtEXfe7X93YHdUqS7NEfe0OD+Pj/PBtGHdjPxzmx5/9/fLqc9c/PI7zw6d999cmbob9MAmq683m43qtTtt/fsH/8csVAAA=",
    "Analytic Construction": "<None>",
    "Architrave Offset": "5",
    Area: "4",
    "Assembly Code": "C1020",
    "Assembly Description": "Interior Doors",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    Description: "Internal Single Pocket Slider",
    "Design Option": "-1",
    "Door Ironmongery": "Door - Handle",
    "Door Material": "Door - Panel",
    "Door Panel Width": "910",
    Family: "2.027 x 0.945",
    "Family and Type": "2.027 x 0.945",
    "Frame Thickness": "40",
    Function: "Interior",
    "Handle position - X": "125",
    "Handle position - Z": "700",
    "Head Height": "2027",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2027",
    "Host Id": "Interior - Partition",
    Image: "<None>",
    "Jamb Pocket": "50",
    "Jamb Rebate": "45",
    Mark: "208A",
    "Open dist Elevation 3D": "2",
    "Open dist Plan 2D": "600",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Rough Height": "35",
    "Rough Width": "0",
    "Sill Height": "0",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "40",
    Type: "2.027 x 0.945",
    "Type Id": "2.027 x 0.945",
    "Type Image": "<None>",
    "Type Mark": "51",
    "Vis - Architrave": "No",
    "Visual Light Transmittance": "0",
    Volume: "0.09",
    "Wall Closure": "By host",
    Width: "945",
  },
  {
    ID: "940325",
    Name: "Linen 208",
    Category: "Rooms",
    Level: "Level 2",
    Pbi2DGeometry:
      "dwEAAB+LCAAAAAAABACdkEELwjAMhf9LzqW03crsPIkKgh6GCB7GDhuWrVBbmVUYY//dwDa9ym5JvpD3XvIesspcuoeGFI6+Mpm3Xe0dEMi8ceEJad6PJS4ITiXnah1TIZWCgfwQj2gimFiIBI0ilvyLZhvL0GyjmCNu2rbsMCcOdqa866BbSBllBE7a1aGZmrMPZTD4mrG9mtsXHbSpG9RAiUhISWBv9XtaVnQVCxxtvfV4172sHYoPnJ2ruHcBAAA=",
    Pbi3DGeometry:
      "6wMAAB+LCAAAAAAABACdk99rwyAQx/+Xe3ail2RZkqfSDQbdQ1gLeyh9SKmkgo0jtYUS8r9P2mQ/JAumiOJ99O57nrpuIN/K1eVTQAoLvZVLreQOCORaVuYI6bq5Te0yy2yDlvyQB85Ydh1sh3bTu83qurhYX+Q04jwhIcUoSUhCn0KMSE+RBgGLe8oDGiPDSXQ47l86vNehGFrXGN0Q07CX4Ojx8JFG+H92fnhUcLj2DnXTuAt7CY5eoFtmR88PT3kbbkHvEnSx1x3an/Msi4MwooaUUUbgTVSl2XfGuzaFkbrqzA+5+156FbLcm854UeL8e+NcK20DViel2s0XfjFfBesDAAA=",
    "Actual Lighting Load": "0",
    "Actual Lighting Load per area": "0.00 /",
    "Actual Power Load": "0",
    "Actual Power Load per area": "0.00 /",
    Area: "1",
    "Area per Person": "106",
    "Base Lighting Load on": "By Space Type",
    "Base Offset": "0",
    "Base Power Load on": "By Space Type",
    "Calculated Cooling Load per area": "0.00 /",
    "Calculated Heating Load per area": "0.00 /",
    "Calculated Supply Airflow per area": "0.00 /(·)",
    "Computation Height": "0",
    "Design Option": "-1",
    "Heat Load Values": "By Space Type",
    Image: "<None>",
    "Latent Heat Gain per person": "59",
    "Lighting Load Units": "Power Density",
    "Limit Offset": "6500",
    Number: "208",
    "Number of People": "0",
    "Occupancy Unit": "Number of people",
    Perimeter: "5926",
    Phase: "Working Drawings",
    "Phase Id": "Working Drawings",
    "Plenum Lighting Contribution": "20.00%",
    "Power Load Units": "Power Density",
    "Sensible Heat Gain per person": "73",
    "Specified Lighting Load": "0",
    "Specified Lighting Load per area": "10.76 /",
    "Specified Power Load": "0",
    "Specified Power Load per area": "10.76 /",
    "Total Heat Gain per person": "132",
    "Unbounded Height": "6500",
    "Upper Limit": "Level 2",
    Volume: "6.67",
  },
  {
    ID: "940326",
    Name: "M_Room Tag: Room Tag",
    Category: "Room Tags",
    Description: "-1",
    "Facucent Drilling": "Room Tag",
    Family: "Room Tag",
    Leader: "None",
    "Leader Arrowhead": "Yes",
    "Ordinate Dimension Settings": "Horizontal",
    "Short Circuit Rating": "No",
    "Show Opening Height": "No",
    "Show Up Text": "No",
    "Tumble Dryer": "Room Tag",
    "Type Comments": "Room Tag",
  },
  {
    ID: "940773",
    Name: "Text: 3.5mm Arial",
    Category: "Text Notes",
    "Approved By": "No",
    "b 1": "Opaque",
    "Body width": "No",
    "Cold Water Radius": "0",
    Description: "-1",
    "Facucent Drilling": "3.5mm Arial",
    Family: "3.5mm Arial",
    Hieght: "Left",
    "Interior Type": "No",
    k: "Yes",
    Leader: "Arrow 30 Degree",
    "Leader Type": "2.032",
    left: "Top",
    "Line Style": "1",
    right: "Bottom",
    "Show Arrowhead to Cut Mark": "Yes",
    t: "12.7",
    "Text Background": "Arial",
    "Text Offset": "3.5",
    "Tumble Dryer": "3.5mm Arial",
    "Type Comments": "3.5mm Arial",
    "Underlay Orientation": "No",
    Vents: "Top",
    "Width (pixels)": "1",
  },
  {
    ID: "940801",
    Name: "Text: 3.5mm Arial",
    Category: "Text Notes",
    "Approved By": "No",
    "b 1": "Opaque",
    "Body width": "No",
    "Cold Water Radius": "0",
    Description: "-1",
    "Facucent Drilling": "3.5mm Arial",
    Family: "3.5mm Arial",
    Hieght: "Left",
    "Interior Type": "No",
    k: "Yes",
    Leader: "Arrow 30 Degree",
    "Leader Type": "2.032",
    left: "Top",
    "Line Style": "1",
    right: "Bottom",
    "Show Arrowhead to Cut Mark": "Yes",
    t: "12.7",
    "Text Background": "Arial",
    "Text Offset": "3.5",
    "Tumble Dryer": "3.5mm Arial",
    "Type Comments": "3.5mm Arial",
    "Underlay Orientation": "No",
    Vents: "Top",
    "Width (pixels)": "1",
  },
  {
    ID: "940871",
    Name: "M_Window Tag: M_Window Tag",
    Category: "Window Tags",
    Description: "-1",
    "Facucent Drilling": "M_Window Tag",
    Family: "M_Window Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "M_Window Tag",
    "Type Comments": "M_Window Tag",
  },
  {
    ID: "940907",
    Name: "M_Window Tag: M_Window Tag",
    Category: "Window Tags",
    Description: "-1",
    "Facucent Drilling": "M_Window Tag",
    Family: "M_Window Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "M_Window Tag",
    "Type Comments": "M_Window Tag",
  },
  {
    ID: "940913",
    Name: "M_Window Tag: M_Window Tag",
    Category: "Window Tags",
    Description: "-1",
    "Facucent Drilling": "M_Window Tag",
    Family: "M_Window Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "M_Window Tag",
    "Type Comments": "M_Window Tag",
  },
  {
    ID: "940917",
    Name: "M_Window Tag: M_Window Tag",
    Category: "Window Tags",
    Description: "-1",
    "Facucent Drilling": "M_Window Tag",
    Family: "M_Window Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "M_Window Tag",
    "Type Comments": "M_Window Tag",
  },
  {
    ID: "940919",
    Name: "M_Window Tag: M_Window Tag",
    Category: "Window Tags",
    Description: "-1",
    "Facucent Drilling": "M_Window Tag",
    Family: "M_Window Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "M_Window Tag",
    "Type Comments": "M_Window Tag",
  },
  {
    ID: "940931",
    Name: "M_Window Tag: M_Window Tag",
    Category: "Window Tags",
    Description: "-1",
    "Facucent Drilling": "M_Window Tag",
    Family: "M_Window Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "M_Window Tag",
    "Type Comments": "M_Window Tag",
  },
  {
    ID: "940933",
    Name: "M_Window Tag: M_Window Tag",
    Category: "Window Tags",
    Description: "-1",
    "Facucent Drilling": "M_Window Tag",
    Family: "M_Window Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "M_Window Tag",
    "Type Comments": "M_Window Tag",
  },
  {
    ID: "940956",
    Name: "M_Door Tag: M_Door Tag",
    Category: "Door Tags",
    Description: "-1",
    "Facucent Drilling": "M_Door Tag",
    Family: "M_Door Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "M_Door Tag",
    "Type Comments": "M_Door Tag",
  },
  {
    ID: "940961",
    Name: "M_Door Tag: M_Door Tag",
    Category: "Door Tags",
    Description: "-1",
    "Facucent Drilling": "M_Door Tag",
    Family: "M_Door Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "M_Door Tag",
    "Type Comments": "M_Door Tag",
  },
  {
    ID: "940964",
    Name: "M_Door Tag: M_Door Tag",
    Category: "Door Tags",
    Description: "-1",
    "Facucent Drilling": "M_Door Tag",
    Family: "M_Door Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "M_Door Tag",
    "Type Comments": "M_Door Tag",
  },
  {
    ID: "940969",
    Name: "M_Door Tag: M_Door Tag",
    Category: "Door Tags",
    Description: "-1",
    "Facucent Drilling": "M_Door Tag",
    Family: "M_Door Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "M_Door Tag",
    "Type Comments": "M_Door Tag",
  },
  {
    ID: "940981",
    Name: "M_Door Tag: M_Door Tag",
    Category: "Door Tags",
    Description: "-1",
    "Facucent Drilling": "M_Door Tag",
    Family: "M_Door Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "M_Door Tag",
    "Type Comments": "M_Door Tag",
  },
  {
    ID: "940988",
    Name: "M_Door Tag: M_Door Tag",
    Category: "Door Tags",
    Description: "-1",
    "Facucent Drilling": "M_Door Tag",
    Family: "M_Door Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "M_Door Tag",
    "Type Comments": "M_Door Tag",
  },
  {
    ID: "940996",
    Name: "M_Door Tag: M_Door Tag",
    Category: "Door Tags",
    Description: "-1",
    "Facucent Drilling": "M_Door Tag",
    Family: "M_Door Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "M_Door Tag",
    "Type Comments": "M_Door Tag",
  },
  {
    ID: "941002",
    Name: "M_Door Tag: M_Door Tag",
    Category: "Door Tags",
    Description: "-1",
    "Facucent Drilling": "M_Door Tag",
    Family: "M_Door Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "M_Door Tag",
    "Type Comments": "M_Door Tag",
  },
  {
    ID: "941009",
    Name: "M_Door Tag: M_Door Tag",
    Category: "Door Tags",
    Description: "-1",
    "Facucent Drilling": "M_Door Tag",
    Family: "M_Door Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "M_Door Tag",
    "Type Comments": "M_Door Tag",
  },
  {
    ID: "941015",
    Name: "M_Door Tag: M_Door Tag",
    Category: "Door Tags",
    Description: "-1",
    "Facucent Drilling": "M_Door Tag",
    Family: "M_Door Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "M_Door Tag",
    "Type Comments": "M_Door Tag",
  },
  {
    ID: "941135",
    Name: "M_Door Tag: M_Door Tag",
    Category: "Door Tags",
    Description: "-1",
    "Facucent Drilling": "M_Door Tag",
    Family: "M_Door Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "M_Door Tag",
    "Type Comments": "M_Door Tag",
  },
  {
    ID: "941201",
    Name: "M_Window Tag: M_Window Tag",
    Category: "Window Tags",
    Description: "-1",
    "Facucent Drilling": "M_Window Tag",
    Family: "M_Window Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "M_Window Tag",
    "Type Comments": "M_Window Tag",
  },
  {
    ID: "941203",
    Name: "M_Window Tag: M_Window Tag",
    Category: "Window Tags",
    Description: "-1",
    "Facucent Drilling": "M_Window Tag",
    Family: "M_Window Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "M_Window Tag",
    "Type Comments": "M_Window Tag",
  },
  {
    ID: "941204",
    Name: "M_Window Tag: M_Window Tag",
    Category: "Window Tags",
    Description: "-1",
    "Facucent Drilling": "M_Window Tag",
    Family: "M_Window Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "M_Window Tag",
    "Type Comments": "M_Window Tag",
  },
  {
    ID: "941206",
    Name: "M_Window Tag: M_Window Tag",
    Category: "Window Tags",
    Description: "-1",
    "Facucent Drilling": "M_Window Tag",
    Family: "M_Window Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "M_Window Tag",
    "Type Comments": "M_Window Tag",
  },
  {
    ID: "941210",
    Name: "M_Window Tag: M_Window Tag",
    Category: "Window Tags",
    Description: "-1",
    "Facucent Drilling": "M_Window Tag",
    Family: "M_Window Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "M_Window Tag",
    "Type Comments": "M_Window Tag",
  },
  {
    ID: "941211",
    Name: "M_Window Tag: M_Window Tag",
    Category: "Window Tags",
    Description: "-1",
    "Facucent Drilling": "M_Window Tag",
    Family: "M_Window Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "M_Window Tag",
    "Type Comments": "M_Window Tag",
  },
  {
    ID: "941212",
    Name: "M_Window Tag: M_Window Tag",
    Category: "Window Tags",
    Description: "-1",
    "Facucent Drilling": "M_Window Tag",
    Family: "M_Window Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "M_Window Tag",
    "Type Comments": "M_Window Tag",
  },
  {
    ID: "941213",
    Name: "M_Window Tag: M_Window Tag",
    Category: "Window Tags",
    Description: "-1",
    "Facucent Drilling": "M_Window Tag",
    Family: "M_Window Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "M_Window Tag",
    "Type Comments": "M_Window Tag",
  },
  {
    ID: "941252",
    Name: "M_Door Tag: M_Door Tag",
    Category: "Door Tags",
    Description: "-1",
    "Facucent Drilling": "M_Door Tag",
    Family: "M_Door Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "M_Door Tag",
    "Type Comments": "M_Door Tag",
  },
  {
    ID: "941262",
    Name: "M_Door Tag: M_Door Tag",
    Category: "Door Tags",
    Description: "-1",
    "Facucent Drilling": "M_Door Tag",
    Family: "M_Door Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "M_Door Tag",
    "Type Comments": "M_Door Tag",
  },
  {
    ID: "941265",
    Name: "M_Door Tag: M_Door Tag",
    Category: "Door Tags",
    Description: "-1",
    "Facucent Drilling": "M_Door Tag",
    Family: "M_Door Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "M_Door Tag",
    "Type Comments": "M_Door Tag",
  },
  {
    ID: "941271",
    Name: "M_Door Tag: M_Door Tag",
    Category: "Door Tags",
    Description: "-1",
    "Facucent Drilling": "M_Door Tag",
    Family: "M_Door Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "M_Door Tag",
    "Type Comments": "M_Door Tag",
  },
  {
    ID: "941275",
    Name: "M_Door Tag: M_Door Tag",
    Category: "Door Tags",
    Description: "-1",
    "Facucent Drilling": "M_Door Tag",
    Family: "M_Door Tag",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "M_Door Tag",
    "Type Comments": "M_Door Tag",
  },
  {
    ID: "941324",
    Name: "Color Fill Legend: 1",
    Category: "Color Fill Legends",
    "b 1": "Opaque",
    "Body width": "No",
    "Cold Water Radius": "0",
    Description: "-1",
    "Facucent Drilling": "1",
    Family: "1",
    "Flow Pressure": "Arial",
    "Interior Type": "No",
    "Show Room Number": "Yes",
    SinAng: "4.5",
    "Surface Number": "9.5",
    "Swatch Height": "9.5",
    "Tumble Dryer": "1",
    "Type Comments": "1",
    "Underlay Orientation": "No",
    Value: "By View",
  },
  {
    ID: "941334",
    Name: "Color Fill Legend: 1",
    Category: "Color Fill Legends",
    "b 1": "Opaque",
    "Body width": "No",
    "Cold Water Radius": "0",
    Description: "-1",
    "Facucent Drilling": "1",
    Family: "1",
    "Flow Pressure": "Arial",
    "Interior Type": "No",
    "Show Room Number": "Yes",
    SinAng: "4.5",
    "Surface Number": "9.5",
    "Swatch Height": "9.5",
    "Tumble Dryer": "1",
    "Type Comments": "1",
    "Underlay Orientation": "No",
    Value: "By View",
  },
  {
    ID: "941338",
    Name: "Text: 3.5mm Arial",
    Category: "Text Notes",
    "Approved By": "No",
    "b 1": "Opaque",
    "Body width": "No",
    "Cold Water Radius": "0",
    Description: "-1",
    "Facucent Drilling": "3.5mm Arial",
    Family: "3.5mm Arial",
    Hieght: "Left",
    "Interior Type": "No",
    k: "Yes",
    Leader: "Arrow 30 Degree",
    "Leader Type": "2.032",
    left: "Top",
    "Line Style": "1",
    right: "Bottom",
    "Show Arrowhead to Cut Mark": "Yes",
    t: "12.7",
    "Text Background": "Arial",
    "Text Offset": "3.5",
    "Tumble Dryer": "3.5mm Arial",
    "Type Comments": "3.5mm Arial",
    "Underlay Orientation": "No",
    Vents: "Top",
    "Width (pixels)": "1",
  },
  {
    ID: "941365",
    Name: "Text: 3.5mm Arial",
    Category: "Text Notes",
    "Approved By": "No",
    "b 1": "Opaque",
    "Body width": "No",
    "Cold Water Radius": "0",
    Description: "-1",
    "Facucent Drilling": "3.5mm Arial",
    Family: "3.5mm Arial",
    Hieght: "Left",
    "Interior Type": "No",
    k: "Yes",
    Leader: "Arrow 30 Degree",
    "Leader Type": "2.032",
    left: "Top",
    "Line Style": "1",
    right: "Bottom",
    "Show Arrowhead to Cut Mark": "Yes",
    t: "12.7",
    "Text Background": "Arial",
    "Text Offset": "3.5",
    "Tumble Dryer": "3.5mm Arial",
    "Type Comments": "3.5mm Arial",
    "Underlay Orientation": "No",
    Vents: "Top",
    "Width (pixels)": "1",
  },
  {
    ID: "941384",
    Name: "Text: 3.5mm Arial",
    Category: "Text Notes",
    "Approved By": "Yes",
    "b 1": "Opaque",
    "Body width": "No",
    "Cold Water Radius": "0",
    Description: "-1",
    "Facucent Drilling": "3.5mm Arial",
    Family: "3.5mm Arial",
    Hieght: "Left",
    "Interior Type": "No",
    k: "Yes",
    Leader: "Arrow 30 Degree",
    "Leader Type": "2.032",
    left: "Top",
    "Line Style": "1",
    right: "Bottom",
    "Show Arrowhead to Cut Mark": "Yes",
    t: "12.7",
    "Text Background": "Arial",
    "Text Offset": "3.5",
    "Tumble Dryer": "3.5mm Arial",
    "Type Comments": "3.5mm Arial",
    "Underlay Orientation": "No",
    Vents: "Top",
    "Width (pixels)": "1",
  },
  {
    ID: "941385",
    Name: "Linear Dimension Style: Feet & Inches",
    Category: "Dimensions",
    "Alignment Method": "None",
    "Base Power Load on": "0",
    "Body width": "No",
    "Center Segment": "Solid",
    "Centerline Pattern": "None",
    "Centerline Symbol": "Default",
    "Cold Water Radius": "0",
    Cost: "7",
    Description: "-1",
    "Digital Plate": "2.3813",
    "Dimension Line Extension": "6.35",
    "Dimension Line Snap Distance": "Continuous",
    "End Segment Weight": "Value",
    "Equality Formula": "EQ",
    "Equality Text": "Tick and Line",
    "Facucent Drilling": "Feet & Inches",
    Family: "Feet & Inches",
    "Fixed Door": "2.3813",
    "Installation Type": 'Diagonal 3/64"',
    "Interior Tick Mark": "Dynamic",
    "Interior Type": "No",
    L: "<None>",
    Layout: "Yes",
    "Leader Line": "None",
    "Leader Tick Mark": "Arc",
    "Line Style": "1",
    Rangehood: "Up, then Left",
    "Show in": "Beyond Witness Lines",
    "Show Leader When Text Moves": "No",
    "Supply Voltage": "No",
    "Target Elevation": "Opaque",
    "Text Background": "Arial",
    "Text Font": "1.5875",
    "Text Offset": "2.3813",
    Thickness: 'Diagonal 3/64"',
    "Tick Mark": "5",
    "Total Input Wattage": "18000",
    "Tumble Dryer": "Feet & Inches",
    "Type Comments": "Feet & Inches",
    "Underlay Orientation": "No",
    "Width (pixels)": "1",
    "Window Cill Interior": "Gap to Element",
    "Witness Line Control": "2.3813",
    "Witness Line Extension": "1.5875",
    "Witness Line Gap to Element": "2.3813",
    "Witness Line Length": "None",
  },
  {
    ID: "941440",
    Name: "Linear Dimension Style: Feet & Inches",
    Category: "Dimensions",
    "Alignment Method": "None",
    "Base Power Load on": "0",
    "Body width": "No",
    "Center Segment": "Solid",
    "Centerline Pattern": "None",
    "Centerline Symbol": "Default",
    "Cold Water Radius": "0",
    Cost: "6",
    Description: "-1",
    "Digital Plate": "2.3813",
    "Dimension Line Extension": "6.35",
    "Dimension Line Snap Distance": "Continuous",
    "End Segment Weight": "Value",
    "Equality Formula": "EQ",
    "Equality Text": "Tick and Line",
    "Facucent Drilling": "Feet & Inches",
    Family: "Feet & Inches",
    "Fixed Door": "2.3813",
    "Installation Type": 'Diagonal 3/64"',
    "Interior Tick Mark": "Dynamic",
    "Interior Type": "No",
    L: "<None>",
    Layout: "Yes",
    "Leader Line": "None",
    "Leader Tick Mark": "Arc",
    "Line Style": "1",
    Rangehood: "Up, then Left",
    "Show in": "Beyond Witness Lines",
    "Show Leader When Text Moves": "No",
    "Supply Voltage": "No",
    "Target Elevation": "Opaque",
    "Text Background": "Arial",
    "Text Font": "1.5875",
    "Text Offset": "2.3813",
    Thickness: 'Diagonal 3/64"',
    "Tick Mark": "5",
    "Total Input Wattage": "18000",
    "Tumble Dryer": "Feet & Inches",
    "Type Comments": "Feet & Inches",
    "Underlay Orientation": "No",
    "Width (pixels)": "1",
    "Window Cill Interior": "Gap to Element",
    "Witness Line Control": "2.3813",
    "Witness Line Extension": "1.5875",
    "Witness Line Gap to Element": "2.3813",
    "Witness Line Length": "None",
  },
  {
    ID: "941493",
    Category: "Lines",
    Pbi2DGeometry: "DwEAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzIz6lMz89T0lEKyM/MKylWsoquhjCBCoyN9UwsLc2sdU3M9AwMDIyUanVoIxkLs96xqCixEugGoIBLZmJuaklqkZKVgZ6BjpJPal56SQaUE5RfkliSCXQ2hBuemQKX8kjNTM8ogXJcc1LLoAot9SxMjEx1lJzzc/KBZuaV5uTUxgIAus61qg8BAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Center Mark Visible": "No",
    "Design Option": "-1",
    "Detail Line": "Yes",
    Length: "935",
    "Line Style": "<Thin Lines>",
  },
  {
    ID: "941502",
    Name: "Text: 3.5mm Arial",
    Category: "Text Notes",
    "Approved By": "Yes",
    "b 1": "Opaque",
    "Body width": "No",
    "Cold Water Radius": "0",
    Description: "-1",
    "Facucent Drilling": "3.5mm Arial",
    Family: "3.5mm Arial",
    Hieght: "Left",
    "Interior Type": "No",
    k: "Yes",
    Leader: "Arrow 30 Degree",
    "Leader Type": "2.032",
    left: "Top",
    "Line Style": "1",
    right: "Bottom",
    "Show Arrowhead to Cut Mark": "Yes",
    t: "12.7",
    "Text Background": "Arial",
    "Text Offset": "3.5",
    "Tumble Dryer": "3.5mm Arial",
    "Type Comments": "3.5mm Arial",
    "Underlay Orientation": "No",
    Vents: "Top",
    "Width (pixels)": "1",
  },
  {
    ID: "941537",
    Name: "Text: 3.5mm Arial",
    Category: "Text Notes",
    "Approved By": "Yes",
    "b 1": "Opaque",
    "Body width": "No",
    "Cold Water Radius": "0",
    Description: "-1",
    "Facucent Drilling": "3.5mm Arial",
    Family: "3.5mm Arial",
    Hieght: "Left",
    "Interior Type": "No",
    k: "Yes",
    Leader: "Arrow 30 Degree",
    "Leader Type": "2.032",
    left: "Top",
    "Line Style": "1",
    right: "Bottom",
    "Show Arrowhead to Cut Mark": "Yes",
    t: "12.7",
    "Text Background": "Arial",
    "Text Offset": "3.5",
    "Tumble Dryer": "3.5mm Arial",
    "Type Comments": "3.5mm Arial",
    "Underlay Orientation": "No",
    Vents: "Top",
    "Width (pixels)": "1",
  },
  {
    ID: "941866",
    Name: "North Arrow 2: North Arrow 2",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "yAAAAB+LCAAAAAAABAA9jcEKgkAURf/lrU1mdGzSVlFBUAuRoIW4GOuhA9NM2CsQ8d+byNzdczmXWw6Q1/rcPxAyOLpaF3glZRuDEEDutKUnZOXwi15JWMgjwdcLniahYDGHsfqLm65Tvbd9sdPqjoQdZCxkAZzQNtROUDhSpJ394lIkUvJVFEexTJlMRQAXfZvVA+qmpQn2Bt/z0PPWGecP7MuYsfoAumPVv8gAAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Design Option": "-1",
    Family: "North Arrow 2",
    "Family and Type": "North Arrow 2",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    Type: "North Arrow 2",
    "Type Id": "North Arrow 2",
    Volume: "0",
  },
  {
    ID: "946164",
    Name: "RPC Tree - Deciduous: Scarlet Oak - 42'",
    Category: "Planting",
    Level: "Level 1",
    Pbi2DGeometry: "1AAAAB+LCAAAAAAABAA1jcsKwjAQRf9l1jHk3YcrUUHQRSmCi9JF1dAGYiI1CqX0302x7ubOPTOnGqG4mvPw1JDD0V9NqW+hca3VgKDwxoUX5NX4GyOyYhwrLpO1SjHhGYWp/nObvm+GCMfFzjQPHXQPOcEEwUm7NnSQK4IpJwpB6UMTjHdzr4RMEpoyzniSEZkJBBdzX3Cm5nzQpu2iXbD5297qz3JNBRaSSARbb320ube1U/0FSGg7jdQAAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Assembly Code": "G2050500",
    "Assembly Description": "Planting",
    Cost: "0",
    "Default Elevation": "0",
    Description: "Scarlet Oak",
    "Design Option": "-1",
    "Elevation from Level": "4405",
    Family: "Scarlet Oak - 42'",
    "Family and Type": "Scarlet Oak - 42'",
    Height: "12802",
    Host: "Surface",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "OmniClass Number": "23.40.05.17.24",
    "OmniClass Title": "Deciduous Trees",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Render Appearance": "RPC-16-G0FB-J5PX-0LX6-U000-ST1L-LVER-AU",
    "Render Appearance Properties":
      "{2, 15},{39, RPC-16-G0FB-J5PX-0LX6-U000-ST1L-LVER-AU},{1, 0},{1, 0},{2, 36},{1, 8},{5, Color},{1, 0},{1, 0},{3, 0.8},{3, 0.8},{3, 0.8},{1, 8},{7, BBoxMin},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{1, 8},{7, BBoxMax},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{2, 11},{9, RPCTypeId},{1, 0},{1, 0},{39, RPC-16-G0FB-J5PX-0LX6-U000-ST1L-LVER-AU},{1, 6},{14, RPCPlantHeight},{1, 0},{1, 0},{2, 42},{2, 11},{7, keyword},{1, 0},{1, 0},{128, :Geometry:RPC:Scarlet_Oak:Quercus palustris:Occurs in southern Ontario at the east and west ends of Lake Erie; locally abundant.},{2, 11},{8, category},{1, 0},{1, 0},{16, :Trees [General]},{2, 11},{12, LocalizedUID},{1, 0},{1, 0},{11, Scarlet_Oak},{2, 14},{6, Height},{1, 0},{1, 0},{2, 42},{1, 2},{16, Cast Reflections},{1, 0},{1, 0},{1, 0},{1, 2},{12, Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{9, Lock View},{1, 0},{1, 0},{1, 0},{1, 4},{5, ViewC},{1, 0},{1, 0},{1, 0},{2, 11},{11, RPCFilePath},{1, 0},{1, 0},{98, C:\\RevitRender\\Version2015940\\2017\\assetlibrary_base.fbm\\RPCs\\ArchVision_Stills_T5_Scarlet_Oak.rpc},{2, 11},{20, AdvancedUIDefinition},{1, 0},{1, 0},{0, },{2, 11},{10, AssetLibID},{1, 0},{1, 0},{36, 4D3F6E72-3F99-4203-98E9-AF80B3C7A7A4},{2, 11},{10, BaseSchema},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{12, ExchangeGUID},{1, 0},{1, 0},{0, },{1, 2},{6, Hidden},{1, 0},{1, 0},{1, 0},{1, 4},{11, RPCCategory},{1, 0},{1, 0},{1, 0},{2, 11},{8, RPCImage},{1, 0},{1, 0},{0, },{1, 4},{13, SchemaVersion},{1, 0},{1, 0},{1, 5},{2, 11},{12, UIDefinition},{1, 0},{1, 0},{0, },{2, 11},{6, UIName},{1, 0},{1, 0},{39, RPC-16-G0FB-J5PX-0LX6-U000-ST1L-LVER-AU},{2, 11},{11, VersionGUID},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{9, assettype},{1, 0},{1, 0},{11, RPCGeometry},{2, 11},{11, description},{1, 0},{1, 0},{0, },{2, 11},{9, localname},{1, 0},{1, 0},{3, RPC},{2, 11},{9, localtype},{1, 0},{1, 0},{3, RPC},{1, 4},{8, revision},{1, 0},{1, 0},{1, 1},{2, 11},{9, thumbnail},{1, 0},{1, 0},{0, },{1, 4},{7, version},{1, 0},{1, 0},{1, 1},{1, 2},{20, RPC_Cast Reflections},{1, 0},{1, 0},{1, 1},{1, 2},{16, RPC_Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{13, RPC_Lock View},{1, 0},{1, 0},{1, 0},{1, 4},{9, RPC_ViewC},{1, 0},{1, 0},{1, 0},{21, assetlibrary_base.fbx},{1, 5},",
    Type: "Scarlet Oak - 42'",
    "Type Comments": "Scarlet Oak",
    "Type Id": "Scarlet Oak - 42'",
    "Type Image": "<None>",
    "Type Mark": "T5",
    Volume: "0",
  },
  {
    ID: "946385",
    Name: "RPC Tree - Deciduous: Honey Locust - 25'",
    Category: "Planting",
    Level: "Level 1",
    Pbi2DGeometry: "1AAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7yG+286tVNUENRBJOggHqyGDtYWtgIRv3uT7PZ47/feq0Yorvo8PBXkcHRXXaqbb2xrFBAonLb+BXk1/mRAVlxQyUS6TgRFnqUw1X9u0/fNEOBg7HTzUF71kEc0InBStvUd5CgpIiYESucbr52d80TEUrIUOXKZRXEmCFz0fcEFY5zAQem2C+8Yz2t7oz5Lm3GKSYYEts648Gbfxkz1F7xK5NHUAAAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Assembly Code": "G2050500",
    "Assembly Description": "Planting",
    Cost: "0",
    "Default Elevation": "0",
    Description: "Honey Locust",
    "Design Option": "-1",
    "Elevation from Level": "4044",
    Family: "Honey Locust - 25'",
    "Family and Type": "Honey Locust - 25'",
    Height: "7620",
    Host: "Surface",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "OmniClass Number": "23.40.05.17.24",
    "OmniClass Title": "Deciduous Trees",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Render Appearance": "RPC-16-G2VH-N100-5X50-0000-ST1L-LVER-AU",
    "Render Appearance Properties":
      "{2, 15},{39, RPC-16-G2VH-N100-5X50-0000-ST1L-LVER-AU},{1, 0},{1, 0},{2, 36},{1, 8},{5, Color},{1, 0},{1, 0},{3, 0.8},{3, 0.8},{3, 0.8},{1, 8},{7, BBoxMin},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{1, 8},{7, BBoxMax},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{2, 11},{9, RPCTypeId},{1, 0},{1, 0},{39, RPC-16-G2VH-N100-5X50-0000-ST1L-LVER-AU},{1, 6},{14, RPCPlantHeight},{1, 0},{1, 0},{2, 25},{2, 11},{7, keyword},{1, 0},{1, 0},{224, :Geometry:RPC:Honey-Locust:Gleditsia triacanthos L.  Rare in Canada; occurs in southwestern Ontario; commonly planted beyond its range because of its tolerance to droughty and alkaline soils; frequently becoming naturalized.},{2, 11},{8, category},{1, 0},{1, 0},{16, :Trees [General]},{2, 11},{12, LocalizedUID},{1, 0},{1, 0},{12, Honey-Locust},{2, 14},{6, Height},{1, 0},{1, 0},{2, 25},{1, 2},{16, Cast Reflections},{1, 0},{1, 0},{1, 0},{1, 2},{12, Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{9, Lock View},{1, 0},{1, 0},{1, 0},{1, 4},{5, ViewC},{1, 0},{1, 0},{1, 0},{2, 11},{11, RPCFilePath},{1, 0},{1, 0},{99, C:\\RevitRender\\Version2015940\\2017\\assetlibrary_base.fbm\\RPCs\\ArchVision_Stills_T5_Honey_Locust.rpc},{2, 11},{20, AdvancedUIDefinition},{1, 0},{1, 0},{0, },{2, 11},{10, AssetLibID},{1, 0},{1, 0},{36, 4D3F6E72-3F99-4203-98E9-AF80B3C7A7A4},{2, 11},{10, BaseSchema},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{12, ExchangeGUID},{1, 0},{1, 0},{0, },{1, 2},{6, Hidden},{1, 0},{1, 0},{1, 0},{1, 4},{11, RPCCategory},{1, 0},{1, 0},{1, 0},{2, 11},{8, RPCImage},{1, 0},{1, 0},{0, },{1, 4},{13, SchemaVersion},{1, 0},{1, 0},{1, 5},{2, 11},{12, UIDefinition},{1, 0},{1, 0},{0, },{2, 11},{6, UIName},{1, 0},{1, 0},{39, RPC-16-G2VH-N100-5X50-0000-ST1L-LVER-AU},{2, 11},{11, VersionGUID},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{9, assettype},{1, 0},{1, 0},{11, RPCGeometry},{2, 11},{11, description},{1, 0},{1, 0},{0, },{2, 11},{9, localname},{1, 0},{1, 0},{3, RPC},{2, 11},{9, localtype},{1, 0},{1, 0},{3, RPC},{1, 4},{8, revision},{1, 0},{1, 0},{1, 1},{2, 11},{9, thumbnail},{1, 0},{1, 0},{0, },{1, 4},{7, version},{1, 0},{1, 0},{1, 1},{1, 2},{20, RPC_Cast Reflections},{1, 0},{1, 0},{1, 1},{1, 2},{16, RPC_Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{13, RPC_Lock View},{1, 0},{1, 0},{1, 0},{1, 4},{9, RPC_ViewC},{1, 0},{1, 0},{1, 0},{21, assetlibrary_base.fbx},{1, 5},",
    Type: "Honey Locust - 25'",
    "Type Comments": "Honey Locust",
    "Type Id": "Honey Locust - 25'",
    "Type Image": "<None>",
    "Type Mark": "T1",
    Volume: "0",
  },
  {
    ID: "946484",
    Name: "RPC Tree - Deciduous: Red Maple - 30'",
    Category: "Planting",
    Level: "Level 1",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1zcsKwjAQBdB/mXUMeTRNU1eigqCLUgQXpYuqoQ3ERGoUSum/Gx/dDTPnzq1GKM7mONw15LD3Z1PqS2hcazUgKLxx4QF5Nf7GSBYsw0Jk2VIInDCZwlTPbtX3zRBxXGxMc9NB95ATTBActGtDBzlPsJIUQelDE4x3n3OaCClpxjjjUhGhEgQnc521IArBTpu2i+X8+2xr9eufpgxTKqNYe+tjmXtaO9VvReXpUdMAAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Assembly Code": "G2050500",
    "Assembly Description": "Planting",
    Cost: "0",
    "Default Elevation": "0",
    Description: "Red Maple",
    "Design Option": "-1",
    "Elevation from Level": "3694",
    Family: "Red Maple - 30'",
    "Family and Type": "Red Maple - 30'",
    Height: "9144",
    Host: "Surface",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "OmniClass Number": "23.40.05.17.24",
    "OmniClass Title": "Deciduous Trees",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Render Appearance": "RPC-16-G0SR-83PX-Q347-6000-ST1L-LVER-AU",
    "Render Appearance Properties":
      "{2, 15},{39, RPC-16-G0SR-83PX-Q347-6000-ST1L-LVER-AU},{1, 0},{1, 0},{2, 36},{1, 8},{5, Color},{1, 0},{1, 0},{3, 0.8},{3, 0.8},{3, 0.8},{1, 8},{7, BBoxMin},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{1, 8},{7, BBoxMax},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{2, 11},{9, RPCTypeId},{1, 0},{1, 0},{39, RPC-16-G0SR-83PX-Q347-6000-ST1L-LVER-AU},{1, 6},{14, RPCPlantHeight},{1, 0},{1, 0},{2, 30},{2, 11},{7, keyword},{1, 0},{1, 0},{241, :Geometry:RPC:Red Maple:A common species of the forests of eastern North America:ranging as far south as Florida.  Widely planted as a shade tree.  The twings:buds:flowers:immature fruits:leaf stalks:and autumn leaves are usually bright red.},{2, 11},{8, category},{1, 0},{1, 0},{16, :Trees [General]},{2, 11},{12, LocalizedUID},{1, 0},{1, 0},{9, Red Maple},{2, 14},{6, Height},{1, 0},{1, 0},{2, 30},{1, 2},{16, Cast Reflections},{1, 0},{1, 0},{1, 0},{1, 2},{12, Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{9, Lock View},{1, 0},{1, 0},{1, 0},{1, 4},{5, ViewC},{1, 0},{1, 0},{1, 0},{2, 11},{11, RPCFilePath},{1, 0},{1, 0},{96, C:\\RevitRender\\Version2015940\\2017\\assetlibrary_base.fbm\\RPCs\\ArchVision_Stills_T5_Red_Maple.rpc},{2, 11},{20, AdvancedUIDefinition},{1, 0},{1, 0},{0, },{2, 11},{10, AssetLibID},{1, 0},{1, 0},{36, 4D3F6E72-3F99-4203-98E9-AF80B3C7A7A4},{2, 11},{10, BaseSchema},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{12, ExchangeGUID},{1, 0},{1, 0},{0, },{1, 2},{6, Hidden},{1, 0},{1, 0},{1, 0},{1, 4},{11, RPCCategory},{1, 0},{1, 0},{1, 0},{2, 11},{8, RPCImage},{1, 0},{1, 0},{0, },{1, 4},{13, SchemaVersion},{1, 0},{1, 0},{1, 5},{2, 11},{12, UIDefinition},{1, 0},{1, 0},{0, },{2, 11},{6, UIName},{1, 0},{1, 0},{39, RPC-16-G0SR-83PX-Q347-6000-ST1L-LVER-AU},{2, 11},{11, VersionGUID},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{9, assettype},{1, 0},{1, 0},{11, RPCGeometry},{2, 11},{11, description},{1, 0},{1, 0},{0, },{2, 11},{9, localname},{1, 0},{1, 0},{3, RPC},{2, 11},{9, localtype},{1, 0},{1, 0},{3, RPC},{1, 4},{8, revision},{1, 0},{1, 0},{1, 1},{2, 11},{9, thumbnail},{1, 0},{1, 0},{0, },{1, 4},{7, version},{1, 0},{1, 0},{1, 1},{1, 2},{20, RPC_Cast Reflections},{1, 0},{1, 0},{1, 1},{1, 2},{16, RPC_Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{13, RPC_Lock View},{1, 0},{1, 0},{1, 0},{1, 4},{9, RPC_ViewC},{1, 0},{1, 0},{1, 0},{21, assetlibrary_base.fbx},{1, 5},",
    Type: "Red Maple - 30'",
    "Type Comments": "Red Maple",
    "Type Id": "Red Maple - 30'",
    "Type Image": "<None>",
    "Type Mark": "T4",
    Volume: "0",
  },
  {
    ID: "946631",
    Name: "RPC Tree - Deciduous: Red Ash - 25'",
    Category: "Planting",
    Level: "Level 1",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABAA9jT0LwjAYhP/LO8eQJk2T1ElUEHQoRXAoHaqGNhATqVEopf/dFD+24+65u2qE4myOw11DDnt/NqW+hMa1VgOCwhsXHpBX40dGZCGxUpQtGcUSpvrHrPq+GSIYjY1pbjroHnKCCYKDdm3oIE8U5ikRCEofmmC8m/Ms5UIkkjLKhCJcpQhO5vrHkwzBTpu2i8+Uz2tbq1/ftsQZUwzB2lsfz9zT2ql+A3YagufPAAAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Assembly Code": "G2050500",
    "Assembly Description": "Planting",
    Cost: "0",
    "Default Elevation": "0",
    Description: "Red Ash",
    "Design Option": "-1",
    "Elevation from Level": "2633",
    Family: "Red Ash - 25'",
    "Family and Type": "Red Ash - 25'",
    Height: "7620",
    Host: "Surface",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "OmniClass Number": "23.40.05.17.24",
    "OmniClass Title": "Deciduous Trees",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Render Appearance": "RPC-8-G3GR-497X-PHW5-6",
    "Render Appearance Properties":
      "{2, 15},{22, RPC-8-G3GR-497X-PHW5-6},{1, 0},{1, 0},{2, 38},{1, 8},{5, Color},{1, 0},{1, 0},{3, 0.8},{3, 0.8},{3, 0.8},{1, 8},{7, BBoxMin},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{1, 8},{7, BBoxMax},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{2, 11},{9, RPCTypeId},{1, 0},{1, 0},{22, RPC-8-G3GR-497X-PHW5-6},{1, 6},{14, RPCPlantHeight},{1, 0},{1, 0},{2, 25},{2, 11},{7, keyword},{1, 0},{1, 0},{78, :Geometry:RPC:Red Ash:red ash:frainus pennsylvanica:frene rouge:deciduous:tree},{2, 11},{8, category},{1, 0},{1, 0},{16, :Trees [General]},{2, 11},{12, LocalizedUID},{1, 0},{1, 0},{7, Red Ash},{2, 14},{6, Height},{1, 0},{1, 0},{2, 25},{1, 2},{16, Cast Reflections},{1, 0},{1, 0},{1, 0},{1, 2},{6, Jitter},{1, 0},{1, 0},{1, 1},{1, 2},{9, Billboard},{1, 0},{1, 0},{1, 0},{1, 2},{12, Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{20, Apply Filter Effects},{1, 0},{1, 0},{1, 0},{2, 11},{28, Apply Filter Effects-Text-FC},{1, 0},{1, 0},{4, None},{2, 11},{11, RPCFilePath},{1, 0},{1, 0},{87, C:\\RevitRender\\Version2015940\\2017\\assetlibrary_base.fbm\\RPCs\\ArchVision_T1_Red_Ash.rpc},{2, 11},{20, AdvancedUIDefinition},{1, 0},{1, 0},{0, },{2, 11},{10, AssetLibID},{1, 0},{1, 0},{36, 4D3F6E72-3F99-4203-98E9-AF80B3C7A7A4},{2, 11},{10, BaseSchema},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{12, ExchangeGUID},{1, 0},{1, 0},{0, },{1, 2},{6, Hidden},{1, 0},{1, 0},{1, 0},{1, 4},{11, RPCCategory},{1, 0},{1, 0},{1, 0},{2, 11},{8, RPCImage},{1, 0},{1, 0},{0, },{1, 4},{13, SchemaVersion},{1, 0},{1, 0},{1, 5},{2, 11},{12, UIDefinition},{1, 0},{1, 0},{0, },{2, 11},{6, UIName},{1, 0},{1, 0},{22, RPC-8-G3GR-497X-PHW5-6},{2, 11},{11, VersionGUID},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{9, assettype},{1, 0},{1, 0},{11, RPCGeometry},{2, 11},{11, description},{1, 0},{1, 0},{0, },{2, 11},{9, localname},{1, 0},{1, 0},{3, RPC},{2, 11},{9, localtype},{1, 0},{1, 0},{3, RPC},{1, 4},{8, revision},{1, 0},{1, 0},{1, 1},{2, 11},{9, thumbnail},{1, 0},{1, 0},{0, },{1, 4},{7, version},{1, 0},{1, 0},{1, 1},{1, 2},{20, RPC_Cast Reflections},{1, 0},{1, 0},{1, 1},{1, 2},{10, RPC_Jitter},{1, 0},{1, 0},{1, 1},{1, 2},{13, RPC_Billboard},{1, 0},{1, 0},{1, 0},{1, 2},{16, RPC_Cast Shadows},{1, 0},{1, 0},{1, 1},{21, assetlibrary_base.fbx},{1, 5},",
    Type: "Red Ash - 25'",
    "Type Comments": "Red Maple",
    "Type Id": "Red Ash - 25'",
    "Type Image": "<None>",
    "Type Mark": "T6",
    Volume: "0",
  },
  {
    ID: "946708",
    Name: "RPC Tree - Deciduous: Honey Locust - 25'",
    Category: "Planting",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7zGNp1udooKgjqIBB3Ew6qhg7WFrUDE794kuz3e+7336hHKqzkPTw0FHP3VVPoWlGutBgSlNy68oKjHn4zIimaYEbpOJOZCpDA1f2zT92qIbDR2Rj100D0UBBMEJ+3a0EHBcswYyxBUPqhgvJvzLOV5TgVLWJJLwmWK4GLuC55SmiA4aNN28ZzxeW1v9WdpS5yJmG+99fHLva2dmi/rHKA20QAAAA==",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Assembly Code": "G2050500",
    "Assembly Description": "Planting",
    Cost: "0",
    "Default Elevation": "0",
    Description: "Honey Locust",
    "Design Option": "-1",
    "Elevation from Level": "2951",
    Family: "Honey Locust - 25'",
    "Family and Type": "Honey Locust - 25'",
    Height: "7620",
    Host: "Surface",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "OmniClass Number": "23.40.05.17.24",
    "OmniClass Title": "Deciduous Trees",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Render Appearance": "RPC-16-G2VH-N100-5X50-0000-ST1L-LVER-AU",
    "Render Appearance Properties":
      "{2, 15},{39, RPC-16-G2VH-N100-5X50-0000-ST1L-LVER-AU},{1, 0},{1, 0},{2, 36},{1, 8},{5, Color},{1, 0},{1, 0},{3, 0.8},{3, 0.8},{3, 0.8},{1, 8},{7, BBoxMin},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{1, 8},{7, BBoxMax},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{2, 11},{9, RPCTypeId},{1, 0},{1, 0},{39, RPC-16-G2VH-N100-5X50-0000-ST1L-LVER-AU},{1, 6},{14, RPCPlantHeight},{1, 0},{1, 0},{2, 25},{2, 11},{7, keyword},{1, 0},{1, 0},{224, :Geometry:RPC:Honey-Locust:Gleditsia triacanthos L.  Rare in Canada; occurs in southwestern Ontario; commonly planted beyond its range because of its tolerance to droughty and alkaline soils; frequently becoming naturalized.},{2, 11},{8, category},{1, 0},{1, 0},{16, :Trees [General]},{2, 11},{12, LocalizedUID},{1, 0},{1, 0},{12, Honey-Locust},{2, 14},{6, Height},{1, 0},{1, 0},{2, 25},{1, 2},{16, Cast Reflections},{1, 0},{1, 0},{1, 0},{1, 2},{12, Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{9, Lock View},{1, 0},{1, 0},{1, 0},{1, 4},{5, ViewC},{1, 0},{1, 0},{1, 0},{2, 11},{11, RPCFilePath},{1, 0},{1, 0},{99, C:\\RevitRender\\Version2015940\\2017\\assetlibrary_base.fbm\\RPCs\\ArchVision_Stills_T5_Honey_Locust.rpc},{2, 11},{20, AdvancedUIDefinition},{1, 0},{1, 0},{0, },{2, 11},{10, AssetLibID},{1, 0},{1, 0},{36, 4D3F6E72-3F99-4203-98E9-AF80B3C7A7A4},{2, 11},{10, BaseSchema},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{12, ExchangeGUID},{1, 0},{1, 0},{0, },{1, 2},{6, Hidden},{1, 0},{1, 0},{1, 0},{1, 4},{11, RPCCategory},{1, 0},{1, 0},{1, 0},{2, 11},{8, RPCImage},{1, 0},{1, 0},{0, },{1, 4},{13, SchemaVersion},{1, 0},{1, 0},{1, 5},{2, 11},{12, UIDefinition},{1, 0},{1, 0},{0, },{2, 11},{6, UIName},{1, 0},{1, 0},{39, RPC-16-G2VH-N100-5X50-0000-ST1L-LVER-AU},{2, 11},{11, VersionGUID},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{9, assettype},{1, 0},{1, 0},{11, RPCGeometry},{2, 11},{11, description},{1, 0},{1, 0},{0, },{2, 11},{9, localname},{1, 0},{1, 0},{3, RPC},{2, 11},{9, localtype},{1, 0},{1, 0},{3, RPC},{1, 4},{8, revision},{1, 0},{1, 0},{1, 1},{2, 11},{9, thumbnail},{1, 0},{1, 0},{0, },{1, 4},{7, version},{1, 0},{1, 0},{1, 1},{1, 2},{20, RPC_Cast Reflections},{1, 0},{1, 0},{1, 1},{1, 2},{16, RPC_Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{13, RPC_Lock View},{1, 0},{1, 0},{1, 0},{1, 4},{9, RPC_ViewC},{1, 0},{1, 0},{1, 0},{21, assetlibrary_base.fbx},{1, 5},",
    Type: "Honey Locust - 25'",
    "Type Comments": "Honey Locust",
    "Type Id": "Honey Locust - 25'",
    "Type Image": "<None>",
    "Type Mark": "T1",
    Volume: "0",
  },
  {
    ID: "946759",
    Name: "RPC Tree - Deciduous: Lombardy Poplar - 40'",
    Category: "Planting",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jcsKwjAURP/lrmNoXiatK1FB0EUpgovSRauhDcREahRK6b8bH90NM2dmyhHyxpyGu4YMDr4xhb6E2rVWA4LcGxcekJXjT0ZkQQmWSqwYxUQqClM1Y+u+r4fIRmNr6psOuocswQmCo3Zt6CBjAjOVpggKH+pgvPvkSy6kJIoyymSaiJQjOJvrjHNCEey1abt4zr9rO6tf/7bCRDCJYOOtj2fuae1UvQETjeSb0gAAAA==",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Assembly Code": "G2050500",
    "Assembly Description": "Planting",
    Cost: "0",
    "Default Elevation": "0",
    Description: "Lombardy Poplar",
    "Design Option": "-1",
    "Elevation from Level": "2485",
    Family: "Lombardy Poplar - 40'",
    "Family and Type": "Lombardy Poplar - 40'",
    Height: "12192",
    Host: "Surface",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "OmniClass Number": "23.40.05.17.24",
    "OmniClass Title": "Deciduous Trees",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Render Appearance": "RPC-16-FVA4-CP7X-CFP7-S000-ST1L-LVER-AU",
    "Render Appearance Properties":
      "{2, 15},{39, RPC-16-FVA4-CP7X-CFP7-S000-ST1L-LVER-AU},{1, 0},{1, 0},{2, 36},{1, 8},{5, Color},{1, 0},{1, 0},{3, 0.8},{3, 0.8},{3, 0.8},{1, 8},{7, BBoxMin},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{1, 8},{7, BBoxMax},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{2, 11},{9, RPCTypeId},{1, 0},{1, 0},{39, RPC-16-FVA4-CP7X-CFP7-S000-ST1L-LVER-AU},{1, 6},{14, RPCPlantHeight},{1, 0},{1, 0},{2, 40},{2, 11},{7, keyword},{1, 0},{1, 0},{135, :Geometry:RPC:Lombardy Poplar:Populus nigra.:a cultivar from Europe; a very common ornamental:planted for its slender:tapering crown.  },{2, 11},{8, category},{1, 0},{1, 0},{16, :Trees [General]},{2, 11},{12, LocalizedUID},{1, 0},{1, 0},{15, Lombardy Poplar},{2, 14},{6, Height},{1, 0},{1, 0},{2, 40},{1, 2},{16, Cast Reflections},{1, 0},{1, 0},{1, 0},{1, 2},{12, Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{9, Lock View},{1, 0},{1, 0},{1, 0},{1, 4},{5, ViewC},{1, 0},{1, 0},{1, 0},{2, 11},{11, RPCFilePath},{1, 0},{1, 0},{102, C:\\RevitRender\\Version2015940\\2017\\assetlibrary_base.fbm\\RPCs\\ArchVision_Stills_T5_Lombardy_Poplar.rpc},{2, 11},{20, AdvancedUIDefinition},{1, 0},{1, 0},{0, },{2, 11},{10, AssetLibID},{1, 0},{1, 0},{36, 4D3F6E72-3F99-4203-98E9-AF80B3C7A7A4},{2, 11},{10, BaseSchema},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{12, ExchangeGUID},{1, 0},{1, 0},{0, },{1, 2},{6, Hidden},{1, 0},{1, 0},{1, 0},{1, 4},{11, RPCCategory},{1, 0},{1, 0},{1, 0},{2, 11},{8, RPCImage},{1, 0},{1, 0},{0, },{1, 4},{13, SchemaVersion},{1, 0},{1, 0},{1, 5},{2, 11},{12, UIDefinition},{1, 0},{1, 0},{0, },{2, 11},{6, UIName},{1, 0},{1, 0},{39, RPC-16-FVA4-CP7X-CFP7-S000-ST1L-LVER-AU},{2, 11},{11, VersionGUID},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{9, assettype},{1, 0},{1, 0},{11, RPCGeometry},{2, 11},{11, description},{1, 0},{1, 0},{0, },{2, 11},{9, localname},{1, 0},{1, 0},{3, RPC},{2, 11},{9, localtype},{1, 0},{1, 0},{3, RPC},{1, 4},{8, revision},{1, 0},{1, 0},{1, 1},{2, 11},{9, thumbnail},{1, 0},{1, 0},{0, },{1, 4},{7, version},{1, 0},{1, 0},{1, 1},{1, 2},{20, RPC_Cast Reflections},{1, 0},{1, 0},{1, 1},{1, 2},{16, RPC_Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{13, RPC_Lock View},{1, 0},{1, 0},{1, 0},{1, 4},{9, RPC_ViewC},{1, 0},{1, 0},{1, 0},{21, assetlibrary_base.fbx},{1, 5},",
    Type: "Lombardy Poplar - 40'",
    "Type Comments": "Lombardy Poplar",
    "Type Id": "Lombardy Poplar - 40'",
    "Type Image": "<None>",
    "Type Mark": "T7",
    Volume: "0",
  },
  {
    ID: "946816",
    Name: "RPC Tree - Deciduous: Honey Locust - 25'",
    Category: "Planting",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7yG/uecs1NUENRBJOggHqyGDtYWtgIRv3uT7PZ47/feq0Yorvo8PBXkcHRXXaqbb2xrFBAonLb+BXk1/mRABKccI1yvGKMy4TDVf2zT980Q2GDsdPNQXvWQRzQicFK29R3kKCgipgRK5xuvnZ3zNOFCxBkyZEJGXCYELvq+4EkcMwIHpdsunCOf1/ZGfZZ2HPYySWDrjAtn9m3MVH8BkIAuA9IAAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Assembly Code": "G2050500",
    "Assembly Description": "Planting",
    Cost: "0",
    "Default Elevation": "0",
    Description: "Honey Locust",
    "Design Option": "-1",
    "Elevation from Level": "375",
    Family: "Honey Locust - 25'",
    "Family and Type": "Honey Locust - 25'",
    Height: "7620",
    Host: "Surface",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "OmniClass Number": "23.40.05.17.24",
    "OmniClass Title": "Deciduous Trees",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Render Appearance": "RPC-16-G2VH-N100-5X50-0000-ST1L-LVER-AU",
    "Render Appearance Properties":
      "{2, 15},{39, RPC-16-G2VH-N100-5X50-0000-ST1L-LVER-AU},{1, 0},{1, 0},{2, 36},{1, 8},{5, Color},{1, 0},{1, 0},{3, 0.8},{3, 0.8},{3, 0.8},{1, 8},{7, BBoxMin},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{1, 8},{7, BBoxMax},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{2, 11},{9, RPCTypeId},{1, 0},{1, 0},{39, RPC-16-G2VH-N100-5X50-0000-ST1L-LVER-AU},{1, 6},{14, RPCPlantHeight},{1, 0},{1, 0},{2, 25},{2, 11},{7, keyword},{1, 0},{1, 0},{224, :Geometry:RPC:Honey-Locust:Gleditsia triacanthos L.  Rare in Canada; occurs in southwestern Ontario; commonly planted beyond its range because of its tolerance to droughty and alkaline soils; frequently becoming naturalized.},{2, 11},{8, category},{1, 0},{1, 0},{16, :Trees [General]},{2, 11},{12, LocalizedUID},{1, 0},{1, 0},{12, Honey-Locust},{2, 14},{6, Height},{1, 0},{1, 0},{2, 25},{1, 2},{16, Cast Reflections},{1, 0},{1, 0},{1, 0},{1, 2},{12, Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{9, Lock View},{1, 0},{1, 0},{1, 0},{1, 4},{5, ViewC},{1, 0},{1, 0},{1, 0},{2, 11},{11, RPCFilePath},{1, 0},{1, 0},{99, C:\\RevitRender\\Version2015940\\2017\\assetlibrary_base.fbm\\RPCs\\ArchVision_Stills_T5_Honey_Locust.rpc},{2, 11},{20, AdvancedUIDefinition},{1, 0},{1, 0},{0, },{2, 11},{10, AssetLibID},{1, 0},{1, 0},{36, 4D3F6E72-3F99-4203-98E9-AF80B3C7A7A4},{2, 11},{10, BaseSchema},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{12, ExchangeGUID},{1, 0},{1, 0},{0, },{1, 2},{6, Hidden},{1, 0},{1, 0},{1, 0},{1, 4},{11, RPCCategory},{1, 0},{1, 0},{1, 0},{2, 11},{8, RPCImage},{1, 0},{1, 0},{0, },{1, 4},{13, SchemaVersion},{1, 0},{1, 0},{1, 5},{2, 11},{12, UIDefinition},{1, 0},{1, 0},{0, },{2, 11},{6, UIName},{1, 0},{1, 0},{39, RPC-16-G2VH-N100-5X50-0000-ST1L-LVER-AU},{2, 11},{11, VersionGUID},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{9, assettype},{1, 0},{1, 0},{11, RPCGeometry},{2, 11},{11, description},{1, 0},{1, 0},{0, },{2, 11},{9, localname},{1, 0},{1, 0},{3, RPC},{2, 11},{9, localtype},{1, 0},{1, 0},{3, RPC},{1, 4},{8, revision},{1, 0},{1, 0},{1, 1},{2, 11},{9, thumbnail},{1, 0},{1, 0},{0, },{1, 4},{7, version},{1, 0},{1, 0},{1, 1},{1, 2},{20, RPC_Cast Reflections},{1, 0},{1, 0},{1, 1},{1, 2},{16, RPC_Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{13, RPC_Lock View},{1, 0},{1, 0},{1, 0},{1, 4},{9, RPC_ViewC},{1, 0},{1, 0},{1, 0},{21, assetlibrary_base.fbx},{1, 5},",
    Type: "Honey Locust - 25'",
    "Type Comments": "Honey Locust",
    "Type Id": "Honey Locust - 25'",
    "Type Image": "<None>",
    "Type Mark": "T1",
    Volume: "0",
  },
  {
    ID: "946835",
    Name: "RPC Tree - Deciduous: Scarlet Oak - 42'",
    Category: "Planting",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA9jcsKwjAQRf9l1jEkbZqYuhIVBF2UIrgoXaQa2kBMpEahlP67KT52c+eemVONUDTmNNw15HDwjSn1JSjXWg0ICm9ceEBejZ8xIoJhQiVbLRjDjAiY6h+27ns1RDYutkbddNA95AQTBEft2tBBzgmmKeEISh9UMN7NPWeZEHSZpEkqJMkkQ3A21y+e8DnvtWm7KGfJ/G1n9et/nVEhEWy89VHmntZO9RsvHjJi0gAAAA==",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Assembly Code": "G2050500",
    "Assembly Description": "Planting",
    Cost: "0",
    "Default Elevation": "0",
    Description: "Scarlet Oak",
    "Design Option": "-1",
    "Elevation from Level": "158",
    Family: "Scarlet Oak - 42'",
    "Family and Type": "Scarlet Oak - 42'",
    Height: "12802",
    Host: "Surface",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "OmniClass Number": "23.40.05.17.24",
    "OmniClass Title": "Deciduous Trees",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Render Appearance": "RPC-16-G0FB-J5PX-0LX6-U000-ST1L-LVER-AU",
    "Render Appearance Properties":
      "{2, 15},{39, RPC-16-G0FB-J5PX-0LX6-U000-ST1L-LVER-AU},{1, 0},{1, 0},{2, 36},{1, 8},{5, Color},{1, 0},{1, 0},{3, 0.8},{3, 0.8},{3, 0.8},{1, 8},{7, BBoxMin},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{1, 8},{7, BBoxMax},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{2, 11},{9, RPCTypeId},{1, 0},{1, 0},{39, RPC-16-G0FB-J5PX-0LX6-U000-ST1L-LVER-AU},{1, 6},{14, RPCPlantHeight},{1, 0},{1, 0},{2, 42},{2, 11},{7, keyword},{1, 0},{1, 0},{128, :Geometry:RPC:Scarlet_Oak:Quercus palustris:Occurs in southern Ontario at the east and west ends of Lake Erie; locally abundant.},{2, 11},{8, category},{1, 0},{1, 0},{16, :Trees [General]},{2, 11},{12, LocalizedUID},{1, 0},{1, 0},{11, Scarlet_Oak},{2, 14},{6, Height},{1, 0},{1, 0},{2, 42},{1, 2},{16, Cast Reflections},{1, 0},{1, 0},{1, 0},{1, 2},{12, Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{9, Lock View},{1, 0},{1, 0},{1, 0},{1, 4},{5, ViewC},{1, 0},{1, 0},{1, 0},{2, 11},{11, RPCFilePath},{1, 0},{1, 0},{98, C:\\RevitRender\\Version2015940\\2017\\assetlibrary_base.fbm\\RPCs\\ArchVision_Stills_T5_Scarlet_Oak.rpc},{2, 11},{20, AdvancedUIDefinition},{1, 0},{1, 0},{0, },{2, 11},{10, AssetLibID},{1, 0},{1, 0},{36, 4D3F6E72-3F99-4203-98E9-AF80B3C7A7A4},{2, 11},{10, BaseSchema},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{12, ExchangeGUID},{1, 0},{1, 0},{0, },{1, 2},{6, Hidden},{1, 0},{1, 0},{1, 0},{1, 4},{11, RPCCategory},{1, 0},{1, 0},{1, 0},{2, 11},{8, RPCImage},{1, 0},{1, 0},{0, },{1, 4},{13, SchemaVersion},{1, 0},{1, 0},{1, 5},{2, 11},{12, UIDefinition},{1, 0},{1, 0},{0, },{2, 11},{6, UIName},{1, 0},{1, 0},{39, RPC-16-G0FB-J5PX-0LX6-U000-ST1L-LVER-AU},{2, 11},{11, VersionGUID},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{9, assettype},{1, 0},{1, 0},{11, RPCGeometry},{2, 11},{11, description},{1, 0},{1, 0},{0, },{2, 11},{9, localname},{1, 0},{1, 0},{3, RPC},{2, 11},{9, localtype},{1, 0},{1, 0},{3, RPC},{1, 4},{8, revision},{1, 0},{1, 0},{1, 1},{2, 11},{9, thumbnail},{1, 0},{1, 0},{0, },{1, 4},{7, version},{1, 0},{1, 0},{1, 1},{1, 2},{20, RPC_Cast Reflections},{1, 0},{1, 0},{1, 1},{1, 2},{16, RPC_Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{13, RPC_Lock View},{1, 0},{1, 0},{1, 0},{1, 4},{9, RPC_ViewC},{1, 0},{1, 0},{1, 0},{21, assetlibrary_base.fbx},{1, 5},",
    Type: "Scarlet Oak - 42'",
    "Type Comments": "Scarlet Oak",
    "Type Id": "Scarlet Oak - 42'",
    "Type Image": "<None>",
    "Type Mark": "T5",
    Volume: "0",
  },
  {
    ID: "946912",
    Name: "RPC Tree - Deciduous: Honey Locust - 25'",
    Category: "Planting",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA9jU0LgkAYhP/Le94W3Q9X7RQVBHUQCTqIB6sXXdh2w7ZAxP/eSh+3YeaZmWqE4qyPwx0hh7076xIvvrGtQSBQOG39A/Jq/MiAqIwmMubLheSUpSlM9Q9b9X0zBDYYG93c0GMPeUQjAge0re8gZ4oyxhICpfON187OeSKkUnHKOOMqi2QmCJz09YuLOOYEdqjbLpwzOa9tDb7+7UwoAmtnXPiyT2Om+g2PCUoS0QAAAA==",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Assembly Code": "G2050500",
    "Assembly Description": "Planting",
    Cost: "0",
    "Default Elevation": "0",
    Description: "Honey Locust",
    "Design Option": "-1",
    "Elevation from Level": "289",
    Family: "Honey Locust - 25'",
    "Family and Type": "Honey Locust - 25'",
    Height: "7620",
    Host: "Surface",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "OmniClass Number": "23.40.05.17.24",
    "OmniClass Title": "Deciduous Trees",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Render Appearance": "RPC-16-G2VH-N100-5X50-0000-ST1L-LVER-AU",
    "Render Appearance Properties":
      "{2, 15},{39, RPC-16-G2VH-N100-5X50-0000-ST1L-LVER-AU},{1, 0},{1, 0},{2, 36},{1, 8},{5, Color},{1, 0},{1, 0},{3, 0.8},{3, 0.8},{3, 0.8},{1, 8},{7, BBoxMin},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{1, 8},{7, BBoxMax},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{2, 11},{9, RPCTypeId},{1, 0},{1, 0},{39, RPC-16-G2VH-N100-5X50-0000-ST1L-LVER-AU},{1, 6},{14, RPCPlantHeight},{1, 0},{1, 0},{2, 25},{2, 11},{7, keyword},{1, 0},{1, 0},{224, :Geometry:RPC:Honey-Locust:Gleditsia triacanthos L.  Rare in Canada; occurs in southwestern Ontario; commonly planted beyond its range because of its tolerance to droughty and alkaline soils; frequently becoming naturalized.},{2, 11},{8, category},{1, 0},{1, 0},{16, :Trees [General]},{2, 11},{12, LocalizedUID},{1, 0},{1, 0},{12, Honey-Locust},{2, 14},{6, Height},{1, 0},{1, 0},{2, 25},{1, 2},{16, Cast Reflections},{1, 0},{1, 0},{1, 0},{1, 2},{12, Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{9, Lock View},{1, 0},{1, 0},{1, 0},{1, 4},{5, ViewC},{1, 0},{1, 0},{1, 0},{2, 11},{11, RPCFilePath},{1, 0},{1, 0},{99, C:\\RevitRender\\Version2015940\\2017\\assetlibrary_base.fbm\\RPCs\\ArchVision_Stills_T5_Honey_Locust.rpc},{2, 11},{20, AdvancedUIDefinition},{1, 0},{1, 0},{0, },{2, 11},{10, AssetLibID},{1, 0},{1, 0},{36, 4D3F6E72-3F99-4203-98E9-AF80B3C7A7A4},{2, 11},{10, BaseSchema},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{12, ExchangeGUID},{1, 0},{1, 0},{0, },{1, 2},{6, Hidden},{1, 0},{1, 0},{1, 0},{1, 4},{11, RPCCategory},{1, 0},{1, 0},{1, 0},{2, 11},{8, RPCImage},{1, 0},{1, 0},{0, },{1, 4},{13, SchemaVersion},{1, 0},{1, 0},{1, 5},{2, 11},{12, UIDefinition},{1, 0},{1, 0},{0, },{2, 11},{6, UIName},{1, 0},{1, 0},{39, RPC-16-G2VH-N100-5X50-0000-ST1L-LVER-AU},{2, 11},{11, VersionGUID},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{9, assettype},{1, 0},{1, 0},{11, RPCGeometry},{2, 11},{11, description},{1, 0},{1, 0},{0, },{2, 11},{9, localname},{1, 0},{1, 0},{3, RPC},{2, 11},{9, localtype},{1, 0},{1, 0},{3, RPC},{1, 4},{8, revision},{1, 0},{1, 0},{1, 1},{2, 11},{9, thumbnail},{1, 0},{1, 0},{0, },{1, 4},{7, version},{1, 0},{1, 0},{1, 1},{1, 2},{20, RPC_Cast Reflections},{1, 0},{1, 0},{1, 1},{1, 2},{16, RPC_Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{13, RPC_Lock View},{1, 0},{1, 0},{1, 0},{1, 4},{9, RPC_ViewC},{1, 0},{1, 0},{1, 0},{21, assetlibrary_base.fbx},{1, 5},",
    Type: "Honey Locust - 25'",
    "Type Comments": "Honey Locust",
    "Type Id": "Honey Locust - 25'",
    "Type Image": "<None>",
    "Type Mark": "T1",
    Volume: "0",
  },
  {
    ID: "946949",
    Name: "RPC Tree - Deciduous: Honey Locust - 25'",
    Category: "Planting",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA9zcsKwjAQBdB/mXUM7SRp2roSFQRdlCK4KF1UDW0gJlKjUEr/3RQfu2Hm3LnVCMVZH4e7ghz27qxLdfGNbY0CAoXT1j8gr8bPGEgaU0yZWC4STlEkMNU/tur7Zgg2LDa6uSmvesgjGhE4KNv6DnKUFBETAqXzjdfOzveECynjFBkymUUi4wRO+vrlPI4ZgZ3SbRfKUczftka9/ulU8ADWzrhQZp/GTPUbFaDS2tIAAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Assembly Code": "G2050500",
    "Assembly Description": "Planting",
    Cost: "0",
    "Default Elevation": "0",
    Description: "Honey Locust",
    "Design Option": "-1",
    "Elevation from Level": "260",
    Family: "Honey Locust - 25'",
    "Family and Type": "Honey Locust - 25'",
    Height: "7620",
    Host: "Surface",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "OmniClass Number": "23.40.05.17.24",
    "OmniClass Title": "Deciduous Trees",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Render Appearance": "RPC-16-G2VH-N100-5X50-0000-ST1L-LVER-AU",
    "Render Appearance Properties":
      "{2, 15},{39, RPC-16-G2VH-N100-5X50-0000-ST1L-LVER-AU},{1, 0},{1, 0},{2, 36},{1, 8},{5, Color},{1, 0},{1, 0},{3, 0.8},{3, 0.8},{3, 0.8},{1, 8},{7, BBoxMin},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{1, 8},{7, BBoxMax},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{2, 11},{9, RPCTypeId},{1, 0},{1, 0},{39, RPC-16-G2VH-N100-5X50-0000-ST1L-LVER-AU},{1, 6},{14, RPCPlantHeight},{1, 0},{1, 0},{2, 25},{2, 11},{7, keyword},{1, 0},{1, 0},{224, :Geometry:RPC:Honey-Locust:Gleditsia triacanthos L.  Rare in Canada; occurs in southwestern Ontario; commonly planted beyond its range because of its tolerance to droughty and alkaline soils; frequently becoming naturalized.},{2, 11},{8, category},{1, 0},{1, 0},{16, :Trees [General]},{2, 11},{12, LocalizedUID},{1, 0},{1, 0},{12, Honey-Locust},{2, 14},{6, Height},{1, 0},{1, 0},{2, 25},{1, 2},{16, Cast Reflections},{1, 0},{1, 0},{1, 0},{1, 2},{12, Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{9, Lock View},{1, 0},{1, 0},{1, 0},{1, 4},{5, ViewC},{1, 0},{1, 0},{1, 0},{2, 11},{11, RPCFilePath},{1, 0},{1, 0},{99, C:\\RevitRender\\Version2015940\\2017\\assetlibrary_base.fbm\\RPCs\\ArchVision_Stills_T5_Honey_Locust.rpc},{2, 11},{20, AdvancedUIDefinition},{1, 0},{1, 0},{0, },{2, 11},{10, AssetLibID},{1, 0},{1, 0},{36, 4D3F6E72-3F99-4203-98E9-AF80B3C7A7A4},{2, 11},{10, BaseSchema},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{12, ExchangeGUID},{1, 0},{1, 0},{0, },{1, 2},{6, Hidden},{1, 0},{1, 0},{1, 0},{1, 4},{11, RPCCategory},{1, 0},{1, 0},{1, 0},{2, 11},{8, RPCImage},{1, 0},{1, 0},{0, },{1, 4},{13, SchemaVersion},{1, 0},{1, 0},{1, 5},{2, 11},{12, UIDefinition},{1, 0},{1, 0},{0, },{2, 11},{6, UIName},{1, 0},{1, 0},{39, RPC-16-G2VH-N100-5X50-0000-ST1L-LVER-AU},{2, 11},{11, VersionGUID},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{9, assettype},{1, 0},{1, 0},{11, RPCGeometry},{2, 11},{11, description},{1, 0},{1, 0},{0, },{2, 11},{9, localname},{1, 0},{1, 0},{3, RPC},{2, 11},{9, localtype},{1, 0},{1, 0},{3, RPC},{1, 4},{8, revision},{1, 0},{1, 0},{1, 1},{2, 11},{9, thumbnail},{1, 0},{1, 0},{0, },{1, 4},{7, version},{1, 0},{1, 0},{1, 1},{1, 2},{20, RPC_Cast Reflections},{1, 0},{1, 0},{1, 1},{1, 2},{16, RPC_Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{13, RPC_Lock View},{1, 0},{1, 0},{1, 0},{1, 4},{9, RPC_ViewC},{1, 0},{1, 0},{1, 0},{21, assetlibrary_base.fbx},{1, 5},",
    Type: "Honey Locust - 25'",
    "Type Comments": "Honey Locust",
    "Type Id": "Honey Locust - 25'",
    "Type Image": "<None>",
    "Type Mark": "T1",
    Volume: "0",
  },
  {
    ID: "947002",
    Name: "RPC Tree - Deciduous: Red Maple - 30'",
    Category: "Planting",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA9jT0LwjAYhP/LO8eS5sO0cRIVBB1KERxKh1RDG4iJ1CiU0v9uVOp23D13V41QNOY03DVIOPjGlPoSlGutBgSFNy48QFbjT0ZEZAkhlK8WgiVMYAZTPXPrvldDhKOxNeqmg+5B4gQjOGrXhg4kZUkuUgSlDyoY7z7xknEh0oxQQkWOec4QnM11pjnOEey1abt4Tr9jO6tf/3ZKOEGw8dbHL/e0dqrfrFSl29IAAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Assembly Code": "G2050500",
    "Assembly Description": "Planting",
    Cost: "0",
    "Default Elevation": "0",
    Description: "Red Maple",
    "Design Option": "-1",
    "Elevation from Level": "38",
    Family: "Red Maple - 30'",
    "Family and Type": "Red Maple - 30'",
    Height: "9144",
    Host: "Surface",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "OmniClass Number": "23.40.05.17.24",
    "OmniClass Title": "Deciduous Trees",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Render Appearance": "RPC-16-G0SR-83PX-Q347-6000-ST1L-LVER-AU",
    "Render Appearance Properties":
      "{2, 15},{39, RPC-16-G0SR-83PX-Q347-6000-ST1L-LVER-AU},{1, 0},{1, 0},{2, 36},{1, 8},{5, Color},{1, 0},{1, 0},{3, 0.8},{3, 0.8},{3, 0.8},{1, 8},{7, BBoxMin},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{1, 8},{7, BBoxMax},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{2, 11},{9, RPCTypeId},{1, 0},{1, 0},{39, RPC-16-G0SR-83PX-Q347-6000-ST1L-LVER-AU},{1, 6},{14, RPCPlantHeight},{1, 0},{1, 0},{2, 30},{2, 11},{7, keyword},{1, 0},{1, 0},{241, :Geometry:RPC:Red Maple:A common species of the forests of eastern North America:ranging as far south as Florida.  Widely planted as a shade tree.  The twings:buds:flowers:immature fruits:leaf stalks:and autumn leaves are usually bright red.},{2, 11},{8, category},{1, 0},{1, 0},{16, :Trees [General]},{2, 11},{12, LocalizedUID},{1, 0},{1, 0},{9, Red Maple},{2, 14},{6, Height},{1, 0},{1, 0},{2, 30},{1, 2},{16, Cast Reflections},{1, 0},{1, 0},{1, 0},{1, 2},{12, Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{9, Lock View},{1, 0},{1, 0},{1, 0},{1, 4},{5, ViewC},{1, 0},{1, 0},{1, 0},{2, 11},{11, RPCFilePath},{1, 0},{1, 0},{96, C:\\RevitRender\\Version2015940\\2017\\assetlibrary_base.fbm\\RPCs\\ArchVision_Stills_T5_Red_Maple.rpc},{2, 11},{20, AdvancedUIDefinition},{1, 0},{1, 0},{0, },{2, 11},{10, AssetLibID},{1, 0},{1, 0},{36, 4D3F6E72-3F99-4203-98E9-AF80B3C7A7A4},{2, 11},{10, BaseSchema},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{12, ExchangeGUID},{1, 0},{1, 0},{0, },{1, 2},{6, Hidden},{1, 0},{1, 0},{1, 0},{1, 4},{11, RPCCategory},{1, 0},{1, 0},{1, 0},{2, 11},{8, RPCImage},{1, 0},{1, 0},{0, },{1, 4},{13, SchemaVersion},{1, 0},{1, 0},{1, 5},{2, 11},{12, UIDefinition},{1, 0},{1, 0},{0, },{2, 11},{6, UIName},{1, 0},{1, 0},{39, RPC-16-G0SR-83PX-Q347-6000-ST1L-LVER-AU},{2, 11},{11, VersionGUID},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{9, assettype},{1, 0},{1, 0},{11, RPCGeometry},{2, 11},{11, description},{1, 0},{1, 0},{0, },{2, 11},{9, localname},{1, 0},{1, 0},{3, RPC},{2, 11},{9, localtype},{1, 0},{1, 0},{3, RPC},{1, 4},{8, revision},{1, 0},{1, 0},{1, 1},{2, 11},{9, thumbnail},{1, 0},{1, 0},{0, },{1, 4},{7, version},{1, 0},{1, 0},{1, 1},{1, 2},{20, RPC_Cast Reflections},{1, 0},{1, 0},{1, 1},{1, 2},{16, RPC_Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{13, RPC_Lock View},{1, 0},{1, 0},{1, 0},{1, 4},{9, RPC_ViewC},{1, 0},{1, 0},{1, 0},{21, assetlibrary_base.fbx},{1, 5},",
    Type: "Red Maple - 30'",
    "Type Comments": "Red Maple",
    "Type Id": "Red Maple - 30'",
    "Type Image": "<None>",
    "Type Mark": "T4",
    Volume: "0",
  },
  {
    ID: "947057",
    Name: "RPC Tree - Deciduous: Honey Locust - 25'",
    Category: "Planting",
    Level: "Level 1",
    Pbi2DGeometry: "1AAAAB+LCAAAAAAABAA1jUELgjAcxb/L/zzH3JybdooKgjqIBB3Eg9bQwdrCViDid2+S3R7v/d571QRFqy/jU0EOJ9fqUt18YzujAEHhtPUvyKvpJwMiOJacJZtIUixlGsNc/7ntMDRjgIOx181DeTVATjBBcFa28z3kVGBKaYqgdL7x2tklTxMuRCwpo0xkhGcJgqu+r3gSxwzBUemuD++UL2sHoz5rOyKYEcYR7Jxx4c2+jZnrLwDAjgfUAAAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Assembly Code": "G2050500",
    "Assembly Description": "Planting",
    Cost: "0",
    "Default Elevation": "0",
    Description: "Honey Locust",
    "Design Option": "-1",
    "Elevation from Level": "-93",
    Family: "Honey Locust - 25'",
    "Family and Type": "Honey Locust - 25'",
    Height: "7620",
    Host: "Surface",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "OmniClass Number": "23.40.05.17.24",
    "OmniClass Title": "Deciduous Trees",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Render Appearance": "RPC-16-G2VH-N100-5X50-0000-ST1L-LVER-AU",
    "Render Appearance Properties":
      "{2, 15},{39, RPC-16-G2VH-N100-5X50-0000-ST1L-LVER-AU},{1, 0},{1, 0},{2, 36},{1, 8},{5, Color},{1, 0},{1, 0},{3, 0.8},{3, 0.8},{3, 0.8},{1, 8},{7, BBoxMin},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{1, 8},{7, BBoxMax},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{2, 11},{9, RPCTypeId},{1, 0},{1, 0},{39, RPC-16-G2VH-N100-5X50-0000-ST1L-LVER-AU},{1, 6},{14, RPCPlantHeight},{1, 0},{1, 0},{2, 25},{2, 11},{7, keyword},{1, 0},{1, 0},{224, :Geometry:RPC:Honey-Locust:Gleditsia triacanthos L.  Rare in Canada; occurs in southwestern Ontario; commonly planted beyond its range because of its tolerance to droughty and alkaline soils; frequently becoming naturalized.},{2, 11},{8, category},{1, 0},{1, 0},{16, :Trees [General]},{2, 11},{12, LocalizedUID},{1, 0},{1, 0},{12, Honey-Locust},{2, 14},{6, Height},{1, 0},{1, 0},{2, 25},{1, 2},{16, Cast Reflections},{1, 0},{1, 0},{1, 0},{1, 2},{12, Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{9, Lock View},{1, 0},{1, 0},{1, 0},{1, 4},{5, ViewC},{1, 0},{1, 0},{1, 0},{2, 11},{11, RPCFilePath},{1, 0},{1, 0},{99, C:\\RevitRender\\Version2015940\\2017\\assetlibrary_base.fbm\\RPCs\\ArchVision_Stills_T5_Honey_Locust.rpc},{2, 11},{20, AdvancedUIDefinition},{1, 0},{1, 0},{0, },{2, 11},{10, AssetLibID},{1, 0},{1, 0},{36, 4D3F6E72-3F99-4203-98E9-AF80B3C7A7A4},{2, 11},{10, BaseSchema},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{12, ExchangeGUID},{1, 0},{1, 0},{0, },{1, 2},{6, Hidden},{1, 0},{1, 0},{1, 0},{1, 4},{11, RPCCategory},{1, 0},{1, 0},{1, 0},{2, 11},{8, RPCImage},{1, 0},{1, 0},{0, },{1, 4},{13, SchemaVersion},{1, 0},{1, 0},{1, 5},{2, 11},{12, UIDefinition},{1, 0},{1, 0},{0, },{2, 11},{6, UIName},{1, 0},{1, 0},{39, RPC-16-G2VH-N100-5X50-0000-ST1L-LVER-AU},{2, 11},{11, VersionGUID},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{9, assettype},{1, 0},{1, 0},{11, RPCGeometry},{2, 11},{11, description},{1, 0},{1, 0},{0, },{2, 11},{9, localname},{1, 0},{1, 0},{3, RPC},{2, 11},{9, localtype},{1, 0},{1, 0},{3, RPC},{1, 4},{8, revision},{1, 0},{1, 0},{1, 1},{2, 11},{9, thumbnail},{1, 0},{1, 0},{0, },{1, 4},{7, version},{1, 0},{1, 0},{1, 1},{1, 2},{20, RPC_Cast Reflections},{1, 0},{1, 0},{1, 1},{1, 2},{16, RPC_Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{13, RPC_Lock View},{1, 0},{1, 0},{1, 0},{1, 4},{9, RPC_ViewC},{1, 0},{1, 0},{1, 0},{21, assetlibrary_base.fbx},{1, 5},",
    Type: "Honey Locust - 25'",
    "Type Comments": "Honey Locust",
    "Type Id": "Honey Locust - 25'",
    "Type Image": "<None>",
    "Type Mark": "T1",
    Volume: "0",
  },
  {
    ID: "947108",
    Name: "RPC Tree - Deciduous: Largetooth Aspen - 25'",
    Category: "Planting",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA9jUEKwjAQRe8y6xiSNG2auhIVBF2UIrgoXUQNbSAmUqNQSu9uitjd/Plv5tUjlFdzHp4aCjj6q6n0LSjXWg0ISm9ceEFRj78xIjnBlAu5XskEp5zmMDV/btP3aohwXOyMeuigeygIJghO2rWhg4IJTBOGoPJBBePdXGc8FYLmLGGJkCSVHMHF3Beax3zQpu2inKXzs73Vn+WaZ5lEsPXWR5d7Wzs1X5mBSh7SAAAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Assembly Code": "G2050500",
    "Assembly Description": "Planting",
    Cost: "0",
    "Default Elevation": "0",
    Description: "Large Tooth Aspen",
    "Design Option": "-1",
    "Elevation from Level": "142",
    Family: "Largetooth Aspen - 25'",
    "Family and Type": "Largetooth Aspen - 25'",
    Height: "7620",
    Host: "Surface",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "OmniClass Number": "23.40.05.17.24",
    "OmniClass Title": "Deciduous Trees",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Render Appearance": "RPC-16-G0VG-J3PX-MQ0P-J000-ST1L-LVER-AU",
    "Render Appearance Properties":
      "{2, 15},{39, RPC-16-G0VG-J3PX-MQ0P-J000-ST1L-LVER-AU},{1, 0},{1, 0},{2, 36},{1, 8},{5, Color},{1, 0},{1, 0},{3, 0.8},{3, 0.8},{3, 0.8},{1, 8},{7, BBoxMin},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{1, 8},{7, BBoxMax},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{2, 11},{9, RPCTypeId},{1, 0},{1, 0},{39, RPC-16-G0VG-J3PX-MQ0P-J000-ST1L-LVER-AU},{1, 6},{14, RPCPlantHeight},{1, 0},{1, 0},{2, 25},{2, 11},{7, keyword},{1, 0},{1, 0},{178, :Geometry:RPC:Largetooth Aspen:Populus grandidentata:similar in form and aspect to trembling aspen; range does not extend as far west:east:or north; usually found on drier sites.},{2, 11},{8, category},{1, 0},{1, 0},{16, :Trees [General]},{2, 11},{12, LocalizedUID},{1, 0},{1, 0},{16, Largetooth Aspen},{2, 14},{6, Height},{1, 0},{1, 0},{2, 25},{1, 2},{16, Cast Reflections},{1, 0},{1, 0},{1, 0},{1, 2},{12, Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{9, Lock View},{1, 0},{1, 0},{1, 0},{1, 4},{5, ViewC},{1, 0},{1, 0},{1, 0},{2, 11},{11, RPCFilePath},{1, 0},{1, 0},{103, C:\\RevitRender\\Version2015940\\2017\\assetlibrary_base.fbm\\RPCs\\ArchVision_Stills_T5_Largetooth_Aspen.rpc},{2, 11},{20, AdvancedUIDefinition},{1, 0},{1, 0},{0, },{2, 11},{10, AssetLibID},{1, 0},{1, 0},{36, 4D3F6E72-3F99-4203-98E9-AF80B3C7A7A4},{2, 11},{10, BaseSchema},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{12, ExchangeGUID},{1, 0},{1, 0},{0, },{1, 2},{6, Hidden},{1, 0},{1, 0},{1, 0},{1, 4},{11, RPCCategory},{1, 0},{1, 0},{1, 0},{2, 11},{8, RPCImage},{1, 0},{1, 0},{0, },{1, 4},{13, SchemaVersion},{1, 0},{1, 0},{1, 5},{2, 11},{12, UIDefinition},{1, 0},{1, 0},{0, },{2, 11},{6, UIName},{1, 0},{1, 0},{39, RPC-16-G0VG-J3PX-MQ0P-J000-ST1L-LVER-AU},{2, 11},{11, VersionGUID},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{9, assettype},{1, 0},{1, 0},{11, RPCGeometry},{2, 11},{11, description},{1, 0},{1, 0},{0, },{2, 11},{9, localname},{1, 0},{1, 0},{3, RPC},{2, 11},{9, localtype},{1, 0},{1, 0},{3, RPC},{1, 4},{8, revision},{1, 0},{1, 0},{1, 1},{2, 11},{9, thumbnail},{1, 0},{1, 0},{0, },{1, 4},{7, version},{1, 0},{1, 0},{1, 1},{1, 2},{20, RPC_Cast Reflections},{1, 0},{1, 0},{1, 1},{1, 2},{16, RPC_Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{13, RPC_Lock View},{1, 0},{1, 0},{1, 0},{1, 4},{9, RPC_ViewC},{1, 0},{1, 0},{1, 0},{21, assetlibrary_base.fbx},{1, 5},",
    Type: "Largetooth Aspen - 25'",
    "Type Comments": "Largetooth Aspen",
    "Type Id": "Largetooth Aspen - 25'",
    "Type Image": "<None>",
    "Type Mark": "T3",
    Volume: "0",
  },
  {
    ID: "947273",
    Name: "RPC Tree - Deciduous: Hawthorn - 25'",
    Category: "Planting",
    Level: "Level 1",
    Pbi2DGeometry:
      "1QAAAB+LCAAAAAAABAA1jcsKwjAURP/lrtOQ5mGSuhIVBF1IEVyULloNNRATqVEoxX839bEbZs7MVCPsW3sYbgYK2IbWluYUG985Awj2wfp4h6IavzIhM44V1WKe5YxgSrmCV/0HF33fDIlOxso2VxNNDwXBBMHO+C5eoGASM5kLBGWITbTBT/mMCylzRRllUhOhOYKjPX9whXNONIKNsd0l3VMxra2def7aGcFKaopgGVxIb/7h3Kt+A677IZTVAAAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Assembly Code": "G2050500",
    "Assembly Description": "Planting",
    Cost: "0",
    "Default Elevation": "0",
    Description: "Hawthorn",
    "Design Option": "-1",
    "Elevation from Level": "-268",
    Family: "Hawthorn - 25'",
    "Family and Type": "Hawthorn - 25'",
    Height: "7620",
    Host: "Surface",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "OmniClass Number": "23.40.05.17.24",
    "OmniClass Title": "Deciduous Trees",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Render Appearance": "RPC-16-FUM5-EJG0-UA9J-L000-ST1L-LVER-AU",
    "Render Appearance Properties":
      "{2, 15},{39, RPC-16-FUM5-EJG0-UA9J-L000-ST1L-LVER-AU},{1, 0},{1, 0},{2, 36},{1, 8},{5, Color},{1, 0},{1, 0},{3, 0.8},{3, 0.8},{3, 0.8},{1, 8},{7, BBoxMin},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{1, 8},{7, BBoxMax},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{2, 11},{9, RPCTypeId},{1, 0},{1, 0},{39, RPC-16-FUM5-EJG0-UA9J-L000-ST1L-LVER-AU},{1, 6},{14, RPCPlantHeight},{1, 0},{1, 0},{2, 25},{2, 11},{7, keyword},{1, 0},{1, 0},{240, :Geometry:RPC:Hawthorn:Genus Crataegus:hawthorns comprise a very large genus of small trees and coarse shrubs distributed throuhout the North Temperature Zone; about 30 to Canada:most occurring from southern Ontario easrward to Nova Scotia.},{2, 11},{8, category},{1, 0},{1, 0},{16, :Trees [General]},{2, 11},{12, LocalizedUID},{1, 0},{1, 0},{8, Hawthorn},{2, 14},{6, Height},{1, 0},{1, 0},{2, 25},{1, 2},{16, Cast Reflections},{1, 0},{1, 0},{1, 0},{1, 2},{12, Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{9, Lock View},{1, 0},{1, 0},{1, 0},{1, 4},{5, ViewC},{1, 0},{1, 0},{1, 0},{2, 11},{11, RPCFilePath},{1, 0},{1, 0},{95, C:\\RevitRender\\Version2015940\\2017\\assetlibrary_base.fbm\\RPCs\\ArchVision_Stills_T5_Hawthorn.rpc},{2, 11},{20, AdvancedUIDefinition},{1, 0},{1, 0},{0, },{2, 11},{10, AssetLibID},{1, 0},{1, 0},{36, 4D3F6E72-3F99-4203-98E9-AF80B3C7A7A4},{2, 11},{10, BaseSchema},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{12, ExchangeGUID},{1, 0},{1, 0},{0, },{1, 2},{6, Hidden},{1, 0},{1, 0},{1, 0},{1, 4},{11, RPCCategory},{1, 0},{1, 0},{1, 0},{2, 11},{8, RPCImage},{1, 0},{1, 0},{0, },{1, 4},{13, SchemaVersion},{1, 0},{1, 0},{1, 5},{2, 11},{12, UIDefinition},{1, 0},{1, 0},{0, },{2, 11},{6, UIName},{1, 0},{1, 0},{39, RPC-16-FUM5-EJG0-UA9J-L000-ST1L-LVER-AU},{2, 11},{11, VersionGUID},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{9, assettype},{1, 0},{1, 0},{11, RPCGeometry},{2, 11},{11, description},{1, 0},{1, 0},{0, },{2, 11},{9, localname},{1, 0},{1, 0},{3, RPC},{2, 11},{9, localtype},{1, 0},{1, 0},{3, RPC},{1, 4},{8, revision},{1, 0},{1, 0},{1, 1},{2, 11},{9, thumbnail},{1, 0},{1, 0},{0, },{1, 4},{7, version},{1, 0},{1, 0},{1, 1},{1, 2},{20, RPC_Cast Reflections},{1, 0},{1, 0},{1, 1},{1, 2},{16, RPC_Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{13, RPC_Lock View},{1, 0},{1, 0},{1, 0},{1, 4},{9, RPC_ViewC},{1, 0},{1, 0},{1, 0},{21, assetlibrary_base.fbx},{1, 5},",
    Type: "Hawthorn - 25'",
    "Type Comments": "Hawthorn",
    "Type Id": "Hawthorn - 25'",
    "Type Image": "<None>",
    "Type Mark": "T2",
    Volume: "0",
  },
  {
    ID: "947330",
    Name: "RPC Tree - Deciduous: Honey Locust - 25'",
    Category: "Planting",
    Level: "Level 1",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7yG29yWdooKgjqIBB3Ew6yhg7WFrUDE794kuz3e+733qhGKxlyGp4YcTr4xpb4F5VqrAUHhjQsvyKvxJyPCBSYZEZsVYQJTJmCq/9y279UQ4WjsjXrooHvIE5wgOGvXhg5yKjGlVCAofVDBeDfnIuVSkjVllMks4VmK4GruC54SwhActWm7+E75vHaw+rO0VwTHLoKdtz6eube1U/0Fy4LkAtMAAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Assembly Code": "G2050500",
    "Assembly Description": "Planting",
    Cost: "0",
    "Default Elevation": "0",
    Description: "Honey Locust",
    "Design Option": "-1",
    "Elevation from Level": "-540",
    Family: "Honey Locust - 25'",
    "Family and Type": "Honey Locust - 25'",
    Height: "7620",
    Host: "Surface",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "OmniClass Number": "23.40.05.17.24",
    "OmniClass Title": "Deciduous Trees",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Render Appearance": "RPC-16-G2VH-N100-5X50-0000-ST1L-LVER-AU",
    "Render Appearance Properties":
      "{2, 15},{39, RPC-16-G2VH-N100-5X50-0000-ST1L-LVER-AU},{1, 0},{1, 0},{2, 36},{1, 8},{5, Color},{1, 0},{1, 0},{3, 0.8},{3, 0.8},{3, 0.8},{1, 8},{7, BBoxMin},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{1, 8},{7, BBoxMax},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{2, 11},{9, RPCTypeId},{1, 0},{1, 0},{39, RPC-16-G2VH-N100-5X50-0000-ST1L-LVER-AU},{1, 6},{14, RPCPlantHeight},{1, 0},{1, 0},{2, 25},{2, 11},{7, keyword},{1, 0},{1, 0},{224, :Geometry:RPC:Honey-Locust:Gleditsia triacanthos L.  Rare in Canada; occurs in southwestern Ontario; commonly planted beyond its range because of its tolerance to droughty and alkaline soils; frequently becoming naturalized.},{2, 11},{8, category},{1, 0},{1, 0},{16, :Trees [General]},{2, 11},{12, LocalizedUID},{1, 0},{1, 0},{12, Honey-Locust},{2, 14},{6, Height},{1, 0},{1, 0},{2, 25},{1, 2},{16, Cast Reflections},{1, 0},{1, 0},{1, 0},{1, 2},{12, Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{9, Lock View},{1, 0},{1, 0},{1, 0},{1, 4},{5, ViewC},{1, 0},{1, 0},{1, 0},{2, 11},{11, RPCFilePath},{1, 0},{1, 0},{99, C:\\RevitRender\\Version2015940\\2017\\assetlibrary_base.fbm\\RPCs\\ArchVision_Stills_T5_Honey_Locust.rpc},{2, 11},{20, AdvancedUIDefinition},{1, 0},{1, 0},{0, },{2, 11},{10, AssetLibID},{1, 0},{1, 0},{36, 4D3F6E72-3F99-4203-98E9-AF80B3C7A7A4},{2, 11},{10, BaseSchema},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{12, ExchangeGUID},{1, 0},{1, 0},{0, },{1, 2},{6, Hidden},{1, 0},{1, 0},{1, 0},{1, 4},{11, RPCCategory},{1, 0},{1, 0},{1, 0},{2, 11},{8, RPCImage},{1, 0},{1, 0},{0, },{1, 4},{13, SchemaVersion},{1, 0},{1, 0},{1, 5},{2, 11},{12, UIDefinition},{1, 0},{1, 0},{0, },{2, 11},{6, UIName},{1, 0},{1, 0},{39, RPC-16-G2VH-N100-5X50-0000-ST1L-LVER-AU},{2, 11},{11, VersionGUID},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{9, assettype},{1, 0},{1, 0},{11, RPCGeometry},{2, 11},{11, description},{1, 0},{1, 0},{0, },{2, 11},{9, localname},{1, 0},{1, 0},{3, RPC},{2, 11},{9, localtype},{1, 0},{1, 0},{3, RPC},{1, 4},{8, revision},{1, 0},{1, 0},{1, 1},{2, 11},{9, thumbnail},{1, 0},{1, 0},{0, },{1, 4},{7, version},{1, 0},{1, 0},{1, 1},{1, 2},{20, RPC_Cast Reflections},{1, 0},{1, 0},{1, 1},{1, 2},{16, RPC_Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{13, RPC_Lock View},{1, 0},{1, 0},{1, 0},{1, 4},{9, RPC_ViewC},{1, 0},{1, 0},{1, 0},{21, assetlibrary_base.fbx},{1, 5},",
    Type: "Honey Locust - 25'",
    "Type Comments": "Honey Locust",
    "Type Id": "Honey Locust - 25'",
    "Type Image": "<None>",
    "Type Mark": "T1",
    Volume: "0",
  },
  {
    ID: "947379",
    Name: "RPC Tree - Deciduous: Honey Locust - 25'",
    Category: "Planting",
    Level: "Level 1",
    Pbi2DGeometry: "1AAAAB+LCAAAAAAABAA1jcsKwjAURP/lrtOQ3KZPV6KCoItSBBeli1ZDG4iJ1CiU0n83xbobZs7MVBMUrbqMTwk5nGyrSnlzjem0BAKFVca9IK+mn/RILCiLEDcBF0h5lAmY6z+4HYZm9LQ39qp5SCcHyBllBM7SdK6HHBOKiDGB0rrGKWuWPBZRkvAUQwyTjPlJAld1X3HBeUjgKFXX+3uMlrWDlp+1HTDK45TAzmrrz8xb67n+Ajz0OgrUAAAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Assembly Code": "G2050500",
    "Assembly Description": "Planting",
    Cost: "0",
    "Default Elevation": "0",
    Description: "Honey Locust",
    "Design Option": "-1",
    "Elevation from Level": "-51",
    Family: "Honey Locust - 25'",
    "Family and Type": "Honey Locust - 25'",
    Height: "7620",
    Host: "Surface",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "OmniClass Number": "23.40.05.17.24",
    "OmniClass Title": "Deciduous Trees",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Render Appearance": "RPC-16-G2VH-N100-5X50-0000-ST1L-LVER-AU",
    "Render Appearance Properties":
      "{2, 15},{39, RPC-16-G2VH-N100-5X50-0000-ST1L-LVER-AU},{1, 0},{1, 0},{2, 36},{1, 8},{5, Color},{1, 0},{1, 0},{3, 0.8},{3, 0.8},{3, 0.8},{1, 8},{7, BBoxMin},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{1, 8},{7, BBoxMax},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{2, 11},{9, RPCTypeId},{1, 0},{1, 0},{39, RPC-16-G2VH-N100-5X50-0000-ST1L-LVER-AU},{1, 6},{14, RPCPlantHeight},{1, 0},{1, 0},{2, 25},{2, 11},{7, keyword},{1, 0},{1, 0},{224, :Geometry:RPC:Honey-Locust:Gleditsia triacanthos L.  Rare in Canada; occurs in southwestern Ontario; commonly planted beyond its range because of its tolerance to droughty and alkaline soils; frequently becoming naturalized.},{2, 11},{8, category},{1, 0},{1, 0},{16, :Trees [General]},{2, 11},{12, LocalizedUID},{1, 0},{1, 0},{12, Honey-Locust},{2, 14},{6, Height},{1, 0},{1, 0},{2, 25},{1, 2},{16, Cast Reflections},{1, 0},{1, 0},{1, 0},{1, 2},{12, Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{9, Lock View},{1, 0},{1, 0},{1, 0},{1, 4},{5, ViewC},{1, 0},{1, 0},{1, 0},{2, 11},{11, RPCFilePath},{1, 0},{1, 0},{99, C:\\RevitRender\\Version2015940\\2017\\assetlibrary_base.fbm\\RPCs\\ArchVision_Stills_T5_Honey_Locust.rpc},{2, 11},{20, AdvancedUIDefinition},{1, 0},{1, 0},{0, },{2, 11},{10, AssetLibID},{1, 0},{1, 0},{36, 4D3F6E72-3F99-4203-98E9-AF80B3C7A7A4},{2, 11},{10, BaseSchema},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{12, ExchangeGUID},{1, 0},{1, 0},{0, },{1, 2},{6, Hidden},{1, 0},{1, 0},{1, 0},{1, 4},{11, RPCCategory},{1, 0},{1, 0},{1, 0},{2, 11},{8, RPCImage},{1, 0},{1, 0},{0, },{1, 4},{13, SchemaVersion},{1, 0},{1, 0},{1, 5},{2, 11},{12, UIDefinition},{1, 0},{1, 0},{0, },{2, 11},{6, UIName},{1, 0},{1, 0},{39, RPC-16-G2VH-N100-5X50-0000-ST1L-LVER-AU},{2, 11},{11, VersionGUID},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{9, assettype},{1, 0},{1, 0},{11, RPCGeometry},{2, 11},{11, description},{1, 0},{1, 0},{0, },{2, 11},{9, localname},{1, 0},{1, 0},{3, RPC},{2, 11},{9, localtype},{1, 0},{1, 0},{3, RPC},{1, 4},{8, revision},{1, 0},{1, 0},{1, 1},{2, 11},{9, thumbnail},{1, 0},{1, 0},{0, },{1, 4},{7, version},{1, 0},{1, 0},{1, 1},{1, 2},{20, RPC_Cast Reflections},{1, 0},{1, 0},{1, 1},{1, 2},{16, RPC_Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{13, RPC_Lock View},{1, 0},{1, 0},{1, 0},{1, 4},{9, RPC_ViewC},{1, 0},{1, 0},{1, 0},{21, assetlibrary_base.fbx},{1, 5},",
    Type: "Honey Locust - 25'",
    "Type Comments": "Honey Locust",
    "Type Id": "Honey Locust - 25'",
    "Type Image": "<None>",
    "Type Mark": "T1",
    Volume: "0",
  },
  {
    ID: "948595",
    Name: "Property Line Tag: Degress Minutes Seconds",
    Category: "Property Line Segment Tags",
    "Date/Time Stamp": "No",
    "Define Thermal Properties by": "Yes",
    Description: "-1",
    "Facucent Drilling": "Degress Minutes Seconds",
    Family: "Degress Minutes Seconds",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "Degress Minutes Seconds",
    "Type Comments": "Degress Minutes Seconds",
  },
  {
    ID: "948601",
    Name: "Property Line Tag: Degress Minutes Seconds",
    Category: "Property Line Segment Tags",
    "Date/Time Stamp": "No",
    "Define Thermal Properties by": "Yes",
    Description: "-1",
    "Facucent Drilling": "Degress Minutes Seconds",
    Family: "Degress Minutes Seconds",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "Degress Minutes Seconds",
    "Type Comments": "Degress Minutes Seconds",
  },
  {
    ID: "948606",
    Name: "Property Line Tag: Degress Minutes Seconds",
    Category: "Property Line Segment Tags",
    "Date/Time Stamp": "No",
    "Define Thermal Properties by": "Yes",
    Description: "-1",
    "Facucent Drilling": "Degress Minutes Seconds",
    Family: "Degress Minutes Seconds",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "Degress Minutes Seconds",
    "Type Comments": "Degress Minutes Seconds",
  },
  {
    ID: "948608",
    Name: "Property Line Tag: Degress Minutes Seconds",
    Category: "Property Line Segment Tags",
    "Date/Time Stamp": "No",
    "Define Thermal Properties by": "Yes",
    Description: "-1",
    "Facucent Drilling": "Degress Minutes Seconds",
    Family: "Degress Minutes Seconds",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "Degress Minutes Seconds",
    "Type Comments": "Degress Minutes Seconds",
  },
  {
    ID: "948610",
    Name: "Property Line Tag: Degress Minutes Seconds",
    Category: "Property Line Segment Tags",
    "Date/Time Stamp": "No",
    "Define Thermal Properties by": "Yes",
    Description: "-1",
    "Facucent Drilling": "Degress Minutes Seconds",
    Family: "Degress Minutes Seconds",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "Degress Minutes Seconds",
    "Type Comments": "Degress Minutes Seconds",
  },
  {
    ID: "948616",
    Name: "Property Line Tag: Degress Minutes Seconds",
    Category: "Property Line Segment Tags",
    "Date/Time Stamp": "No",
    "Define Thermal Properties by": "Yes",
    Description: "-1",
    "Facucent Drilling": "Degress Minutes Seconds",
    Family: "Degress Minutes Seconds",
    Leader: "None",
    "Leader Arrowhead": "No",
    "Leader Tick Mark": "Attached End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "Degress Minutes Seconds",
    "Type Comments": "Degress Minutes Seconds",
  },
  {
    ID: "950367",
    Name: "M_RPC Beetle: M_RPC Beetle",
    Category: "Entourage",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jcsKwjAURP/lrkNIm1cTV6KCoItSBBeli1ZDG4iJ1CiU0n83ou6G4ZyZeoays6fpbkDDIXS2MpfY+t4ZQFAG6+MDdD1/Y0Iyimku+IpTLAouYWn+2Hoc2ymxqdja9maiGUETTBAcje/jADq5nCqKoAqxjTb4VGEuiVQibUrFCpUpBGd7/dACk0wwBHtj+yFdM6w4lwh2zrx+tsIFyxFsggvpyz+dW5o37AJ20tEAAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    Cost: "0",
    "Design Option": "-1",
    Family: "M_RPC Beetle",
    "Family and Type": "M_RPC Beetle",
    Height: "0",
    Host: "Surface",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "600",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Render Appearance": "RPC-16-0U6E-L4EG-ENH1-J3KF-SVEL-0TX4-C0",
    "Render Appearance Properties":
      "{2, 15},{39, RPC-16-0U6E-L4EG-ENH1-J3KF-SVEL-0TX4-C0},{1, 0},{1, 0},{2, 46},{1, 8},{5, Color},{1, 0},{1, 0},{3, 0.8},{3, 0.8},{3, 0.8},{1, 8},{7, BBoxMin},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{1, 8},{7, BBoxMax},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{2, 11},{9, RPCTypeId},{1, 0},{1, 0},{39, RPC-16-0U6E-L4EG-ENH1-J3KF-SVEL-0TX4-C0},{1, 6},{14, RPCPlantHeight},{1, 0},{1, 0},{4, 4.92},{2, 11},{7, keyword},{1, 0},{1, 0},{27, :Geometry:RPC:VW Beetle [4]},{2, 11},{8, category},{1, 0},{1, 0},{21, :Auto_Economy/Midsize},{2, 11},{12, LocalizedUID},{1, 0},{1, 0},{13, VW Beetle [4]},{2, 14},{6, Height},{1, 0},{1, 0},{4, 4.92},{1, 2},{16, Cast Reflections},{1, 0},{1, 0},{1, 0},{1, 4},{12, Transparency},{1, 0},{1, 0},{2, 18},{1, 4},{7, Tinting},{1, 0},{1, 0},{2, 50},{1, 2},{11, Use Tinting},{1, 0},{1, 0},{1, 0},{1, 2},{13, License Plate},{1, 0},{1, 0},{1, 0},{2, 11},{21, License Plate Texture},{1, 0},{1, 0},{64, __RPC:/object data/textures/car/plate/textures/default/rgb/0/0/0},{2, 11},{23, i_License Plate Texture},{1, 0},{1, 0},{0, },{1, 2},{12, Custom Plate},{1, 0},{1, 0},{1, 0},{2, 11},{23, License Plate File Name},{1, 0},{1, 0},{0, },{2, 11},{11, RPCFilePath},{1, 0},{1, 0},{92, C:\\RevitRender\\Version2015940\\2017\\assetlibrary_base.fbm\\RPCs\\ArchVision_Demo_VW_Beetle4.rpc},{2, 11},{20, AdvancedUIDefinition},{1, 0},{1, 0},{0, },{2, 11},{10, AssetLibID},{1, 0},{1, 0},{36, 4D3F6E72-3F99-4203-98E9-AF80B3C7A7A4},{2, 11},{10, BaseSchema},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{12, ExchangeGUID},{1, 0},{1, 0},{0, },{1, 2},{6, Hidden},{1, 0},{1, 0},{1, 0},{1, 4},{11, RPCCategory},{1, 0},{1, 0},{1, 0},{2, 11},{8, RPCImage},{1, 0},{1, 0},{0, },{1, 4},{13, SchemaVersion},{1, 0},{1, 0},{1, 5},{2, 11},{12, UIDefinition},{1, 0},{1, 0},{0, },{2, 11},{6, UIName},{1, 0},{1, 0},{39, RPC-16-0U6E-L4EG-ENH1-J3KF-SVEL-0TX4-C0},{2, 11},{11, VersionGUID},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{9, assettype},{1, 0},{1, 0},{11, RPCGeometry},{2, 11},{11, description},{1, 0},{1, 0},{0, },{2, 11},{9, localname},{1, 0},{1, 0},{3, RPC},{2, 11},{9, localtype},{1, 0},{1, 0},{3, RPC},{1, 4},{8, revision},{1, 0},{1, 0},{1, 1},{2, 11},{9, thumbnail},{1, 0},{1, 0},{0, },{1, 4},{7, version},{1, 0},{1, 0},{1, 1},{1, 2},{20, RPC_Cast Reflections},{1, 0},{1, 0},{1, 1},{1, 4},{16, RPC_Transparency},{1, 0},{1, 0},{2, 18},{1, 4},{11, RPC_Tinting},{1, 0},{1, 0},{2, 50},{1, 2},{15, RPC_Use Tinting},{1, 0},{1, 0},{1, 0},{1, 2},{17, RPC_License Plate},{1, 0},{1, 0},{1, 0},{2, 11},{25, RPC_License Plate Texture},{1, 0},{1, 0},{64, __RPC:/object data/textures/car/plate/textures/default/rgb/0/0/0},{2, 11},{27, RPC_i_License Plate Texture},{1, 0},{1, 0},{0, },{1, 2},{16, RPC_Custom Plate},{1, 0},{1, 0},{1, 0},{2, 11},{27, RPC_License Plate File Name},{1, 0},{1, 0},{0, },{21, assetlibrary_base.fbx},{1, 5},",
    Type: "M_RPC Beetle",
    "Type Id": "M_RPC Beetle",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "950798",
    Category: "Section Boxes",
    Description: "-1",
  },
  {
    ID: "950799",
    Name: "Approach",
    Category: "Views",
    "Callout Tag": "Explicit",
    "Circuit Prefix Separator": "Poche",
    "Created By": "No",
    "Crop Region Visible": "Yes",
    "Decimal Degress": "None",
    Department: "Independent",
    Description: "-1",
    "Desired Stair Height": "Medium",
    "Detail Line": "-",
    "Dimming Lamp Color Temperature Shift": "Architectural",
    "Extrusion Start": "10000",
    "Facucent Drilling": "3D View",
    Family: "3D View",
    "Family Type": "Yes",
    "Far Clip Active": "65886",
    "Lock Proportions": "Yes",
    "Neutral Rating": "Yes",
    "Nominal Width": "-1",
    "Parent View": "Show Original",
    Perimeter: "Working Drawings",
    "Phase Demolished": "Show All",
    "Projected Area": "Perspective",
    "Schedule Level": "None",
    "Scope Box": "No",
    "Sheet Name": "---",
    Summary: "No",
    Tank: "1750",
    "Tumble Dryer": "3D View",
    "Type Comments": "3D View",
    "Vertical Scale": "Approach",
    "View Scale": "-1",
    "View Template": "-1",
  },
  {
    ID: "950805",
    Category: "Section Boxes",
    Description: "-1",
  },
  {
    ID: "950806",
    Name: "Section Perspective",
    Category: "Views",
    "Callout Tag": "Explicit",
    "Circuit Prefix Separator": "Poche",
    "Created By": "Yes",
    "Crop Region Visible": "Yes",
    "Decimal Degress": "None",
    Department: "Independent",
    Description: "-1",
    "Desired Stair Height": "Medium",
    "Detail Line": "-",
    "Dimming Lamp Color Temperature Shift": "Architectural",
    "Extrusion Start": "1750",
    "Facucent Drilling": "3D View",
    Family: "3D View: 3D View",
    "Family Type": "No",
    "Far Clip Active": "80112",
    "Lock Proportions": "No",
    "Neutral Rating": "Yes",
    "Nominal Width": "-1",
    "Parent View": "Show Original",
    Perimeter: "Working Drawings",
    "Phase Demolished": "Show All",
    "Projected Area": "Perspective",
    "Schedule Level": "None",
    "Scope Box": "Yes",
    "Sheet Name": "---",
    Summary: "No",
    Tank: "1750",
    "Tumble Dryer": "3D View",
    "Type Comments": "3D View",
    "Vertical Scale": "Section Perspective",
    "View Scale": "-1",
    "View Template": "-1",
  },
  {
    ID: "954641",
    Name: "RPC Female: YinYin",
    Category: "Entourage",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABNjcsKwjAURP/lrtPQ5tG0cSUqCLooRXBRuoga2kBMpEahlP67ERXcDWfOMM0E1ckcxpsGCTt/MrU+B+U6qwFB5Y0Ld5DN9IlRoTkWRZ4vEl5gljICc/vzlsOgxihHsDbqqoMeQKY4RbDXrgs9SIK5EDmC2gcVjHfvOhOMU1ISnpUlo0RQBEdz+be32nR9/OZYcAQbq5/fcZLhImWRrbz18cs9rJ3bF6pPbqHSAAAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    Cost: "0",
    "Design Option": "-1",
    Family: "YinYin",
    "Family and Type": "YinYin",
    Height: "0",
    Host: "Level : Level 1 Living Rm.",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Render Appearance": "RPC-8-FUM5-CKXX-U6B5-E",
    "Render Appearance Properties":
      "{2, 15},{22, RPC-8-FUM5-CKXX-U6B5-E},{1, 0},{1, 0},{2, 38},{1, 8},{5, Color},{1, 0},{1, 0},{3, 0.8},{3, 0.8},{3, 0.8},{1, 8},{7, BBoxMin},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{1, 8},{7, BBoxMax},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{2, 11},{9, RPCTypeId},{1, 0},{1, 0},{22, RPC-8-FUM5-CKXX-U6B5-E},{1, 6},{14, RPCPlantHeight},{1, 0},{1, 0},{4, 5.75},{2, 11},{7, keyword},{1, 0},{1, 0},{43, :Geometry:RPC:YinYin:Woman:Asian:Black Hair},{2, 11},{8, category},{1, 0},{1, 0},{17, :People [Resorts]},{2, 11},{12, LocalizedUID},{1, 0},{1, 0},{6, YinYin},{2, 14},{6, Height},{1, 0},{1, 0},{4, 5.75},{1, 2},{16, Cast Reflections},{1, 0},{1, 0},{1, 0},{1, 2},{6, Jitter},{1, 0},{1, 0},{1, 1},{1, 2},{9, Billboard},{1, 0},{1, 0},{1, 0},{1, 2},{12, Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{20, Apply Filter Effects},{1, 0},{1, 0},{1, 0},{2, 11},{28, Apply Filter Effects-Text-FC},{1, 0},{1, 0},{4, None},{2, 11},{11, RPCFilePath},{1, 0},{1, 0},{85, C:\\RevitRender\\Version2015940\\2017\\assetlibrary_base.fbm\\RPCs\\ArchVision_R_YinYin.rpc},{2, 11},{20, AdvancedUIDefinition},{1, 0},{1, 0},{0, },{2, 11},{10, AssetLibID},{1, 0},{1, 0},{36, 4D3F6E72-3F99-4203-98E9-AF80B3C7A7A4},{2, 11},{10, BaseSchema},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{12, ExchangeGUID},{1, 0},{1, 0},{0, },{1, 2},{6, Hidden},{1, 0},{1, 0},{1, 0},{1, 4},{11, RPCCategory},{1, 0},{1, 0},{1, 0},{2, 11},{8, RPCImage},{1, 0},{1, 0},{0, },{1, 4},{13, SchemaVersion},{1, 0},{1, 0},{1, 5},{2, 11},{12, UIDefinition},{1, 0},{1, 0},{0, },{2, 11},{6, UIName},{1, 0},{1, 0},{22, RPC-8-FUM5-CKXX-U6B5-E},{2, 11},{11, VersionGUID},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{9, assettype},{1, 0},{1, 0},{11, RPCGeometry},{2, 11},{11, description},{1, 0},{1, 0},{0, },{2, 11},{9, localname},{1, 0},{1, 0},{3, RPC},{2, 11},{9, localtype},{1, 0},{1, 0},{3, RPC},{1, 4},{8, revision},{1, 0},{1, 0},{1, 1},{2, 11},{9, thumbnail},{1, 0},{1, 0},{0, },{1, 4},{7, version},{1, 0},{1, 0},{1, 1},{1, 2},{20, RPC_Cast Reflections},{1, 0},{1, 0},{1, 1},{1, 2},{10, RPC_Jitter},{1, 0},{1, 0},{1, 1},{1, 2},{13, RPC_Billboard},{1, 0},{1, 0},{1, 0},{1, 2},{16, RPC_Cast Shadows},{1, 0},{1, 0},{1, 1},{21, assetlibrary_base.fbx},{1, 5},",
    Type: "YinYin",
    "Type Id": "YinYin",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "954779",
    Name: "RPC Male: Alex",
    Category: "Entourage",
    Level: "Ceiling",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABABNjdEKgjAYhd/lv15D97s57SoqCOpCJOhCvNAaOlhb2ApEfPcWFXR3OOc7fNUERauP401BDnvX6lKdfWM7o4BA4bT1d8ir6RMDwjhlCWfLBQqaMCZgrn/cahiaMcCh2OjmqrwaII9oROCgbOd7yJGyLBIESucbr519z1maokxQxnEsJEPkBE768k/vlO764OZUIiKBrVHP711SFCImsHbGBZl9GDPXL2yjGgzTAAAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    Cost: "0",
    "Design Option": "-1",
    Family: "Alex",
    "Family and Type": "Alex",
    Height: "0",
    Host: "Level : Ceiling",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "-150",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Render Appearance": "RPC-8-X9C2-NGU9-LXF5-4",
    "Render Appearance Properties":
      "{2, 15},{22, RPC-8-X9C2-NGU9-LXF5-4},{1, 0},{1, 0},{2, 40},{1, 8},{5, Color},{1, 0},{1, 0},{3, 0.8},{3, 0.8},{3, 0.8},{1, 8},{7, BBoxMin},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{1, 8},{7, BBoxMax},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{2, 11},{9, RPCTypeId},{1, 0},{1, 0},{22, RPC-8-X9C2-NGU9-LXF5-4},{1, 6},{14, RPCPlantHeight},{1, 0},{1, 0},{7, 5.83333},{2, 11},{7, keyword},{1, 0},{1, 0},{18, :Geometry:RPC:Alex},{2, 11},{8, category},{1, 0},{1, 0},{16, :People [Casual]},{2, 11},{12, LocalizedUID},{1, 0},{1, 0},{4, Alex},{2, 14},{6, Height},{1, 0},{1, 0},{7, 5.83333},{1, 2},{16, Cast Reflections},{1, 0},{1, 0},{1, 0},{1, 2},{6, Jitter},{1, 0},{1, 0},{1, 1},{1, 2},{9, Billboard},{1, 0},{1, 0},{1, 0},{1, 2},{12, Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{20, Apply Filter Effects},{1, 0},{1, 0},{1, 0},{2, 11},{28, Apply Filter Effects-Text-FC},{1, 0},{1, 0},{4, None},{2, 11},{11, RPCFilePath},{1, 0},{1, 0},{84, C:\\RevitRender\\Version2015940\\2017\\assetlibrary_base.fbm\\RPCs\\ArchVision_C1_Alex.rpc},{2, 11},{20, AdvancedUIDefinition},{1, 0},{1, 0},{0, },{2, 11},{10, AssetLibID},{1, 0},{1, 0},{36, 4D3F6E72-3F99-4203-98E9-AF80B3C7A7A4},{2, 11},{10, BaseSchema},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{12, ExchangeGUID},{1, 0},{1, 0},{0, },{1, 2},{6, Hidden},{1, 0},{1, 0},{1, 0},{1, 4},{11, RPCCategory},{1, 0},{1, 0},{1, 0},{2, 11},{8, RPCImage},{1, 0},{1, 0},{0, },{1, 4},{13, SchemaVersion},{1, 0},{1, 0},{1, 5},{2, 11},{12, UIDefinition},{1, 0},{1, 0},{0, },{2, 11},{6, UIName},{1, 0},{1, 0},{22, RPC-8-X9C2-NGU9-LXF5-4},{2, 11},{11, VersionGUID},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{9, assettype},{1, 0},{1, 0},{11, RPCGeometry},{2, 11},{11, description},{1, 0},{1, 0},{0, },{2, 11},{9, localname},{1, 0},{1, 0},{3, RPC},{2, 11},{9, localtype},{1, 0},{1, 0},{3, RPC},{1, 4},{8, revision},{1, 0},{1, 0},{1, 1},{2, 11},{9, thumbnail},{1, 0},{1, 0},{0, },{1, 4},{7, version},{1, 0},{1, 0},{1, 1},{1, 2},{20, RPC_Cast Reflections},{1, 0},{1, 0},{1, 1},{1, 2},{10, RPC_Jitter},{1, 0},{1, 0},{1, 1},{1, 2},{13, RPC_Billboard},{1, 0},{1, 0},{1, 0},{1, 2},{16, RPC_Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{24, RPC_Apply Filter Effects},{1, 0},{1, 0},{1, 0},{2, 11},{32, RPC_Apply Filter Effects-Text-FC},{1, 0},{1, 0},{4, None},{21, assetlibrary_base.fbx},{1, 5},",
    Type: "Alex",
    "Type Id": "Alex",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "954992",
    Name: "RPC Female: YinYin",
    Category: "Entourage",
    Level: "Level 2",
    Pbi2DGeometry: "zQAAAB+LCAAAAAAABABNjUELwiAYhv/LdzaZOue0U1QQ1GGMoMPYwUo2wTSWBWPsvydU0O3l4Xl5mgmqsz2OdwMK9uFsa3OJ2nfOAIIqWB8foJrpM5OyIBIXXC4JlkzA3P6k1TDoMZkJbKy+mWgGUBnOEByM72IPimIuRIGgDlFHGzwogkXOGZWUEylzxliJ4GSv//LO2K5PXY4FR7B15vX9SlzmNKF1cCGV/NO5uX0DqCaTSc0AAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    Cost: "0",
    "Design Option": "-1",
    Family: "YinYin",
    "Family and Type": "YinYin",
    Height: "0",
    Host: "Floor : Generic 300",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Render Appearance": "RPC-8-FUM5-CKXX-U6B5-E",
    "Render Appearance Properties":
      "{2, 15},{22, RPC-8-FUM5-CKXX-U6B5-E},{1, 0},{1, 0},{2, 38},{1, 8},{5, Color},{1, 0},{1, 0},{3, 0.8},{3, 0.8},{3, 0.8},{1, 8},{7, BBoxMin},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{1, 8},{7, BBoxMax},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{2, 11},{9, RPCTypeId},{1, 0},{1, 0},{22, RPC-8-FUM5-CKXX-U6B5-E},{1, 6},{14, RPCPlantHeight},{1, 0},{1, 0},{4, 5.75},{2, 11},{7, keyword},{1, 0},{1, 0},{43, :Geometry:RPC:YinYin:Woman:Asian:Black Hair},{2, 11},{8, category},{1, 0},{1, 0},{17, :People [Resorts]},{2, 11},{12, LocalizedUID},{1, 0},{1, 0},{6, YinYin},{2, 14},{6, Height},{1, 0},{1, 0},{4, 5.75},{1, 2},{16, Cast Reflections},{1, 0},{1, 0},{1, 0},{1, 2},{6, Jitter},{1, 0},{1, 0},{1, 1},{1, 2},{9, Billboard},{1, 0},{1, 0},{1, 0},{1, 2},{12, Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{20, Apply Filter Effects},{1, 0},{1, 0},{1, 0},{2, 11},{28, Apply Filter Effects-Text-FC},{1, 0},{1, 0},{4, None},{2, 11},{11, RPCFilePath},{1, 0},{1, 0},{85, C:\\RevitRender\\Version2015940\\2017\\assetlibrary_base.fbm\\RPCs\\ArchVision_R_YinYin.rpc},{2, 11},{20, AdvancedUIDefinition},{1, 0},{1, 0},{0, },{2, 11},{10, AssetLibID},{1, 0},{1, 0},{36, 4D3F6E72-3F99-4203-98E9-AF80B3C7A7A4},{2, 11},{10, BaseSchema},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{12, ExchangeGUID},{1, 0},{1, 0},{0, },{1, 2},{6, Hidden},{1, 0},{1, 0},{1, 0},{1, 4},{11, RPCCategory},{1, 0},{1, 0},{1, 0},{2, 11},{8, RPCImage},{1, 0},{1, 0},{0, },{1, 4},{13, SchemaVersion},{1, 0},{1, 0},{1, 5},{2, 11},{12, UIDefinition},{1, 0},{1, 0},{0, },{2, 11},{6, UIName},{1, 0},{1, 0},{22, RPC-8-FUM5-CKXX-U6B5-E},{2, 11},{11, VersionGUID},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{9, assettype},{1, 0},{1, 0},{11, RPCGeometry},{2, 11},{11, description},{1, 0},{1, 0},{0, },{2, 11},{9, localname},{1, 0},{1, 0},{3, RPC},{2, 11},{9, localtype},{1, 0},{1, 0},{3, RPC},{1, 4},{8, revision},{1, 0},{1, 0},{1, 1},{2, 11},{9, thumbnail},{1, 0},{1, 0},{0, },{1, 4},{7, version},{1, 0},{1, 0},{1, 1},{1, 2},{20, RPC_Cast Reflections},{1, 0},{1, 0},{1, 1},{1, 2},{10, RPC_Jitter},{1, 0},{1, 0},{1, 1},{1, 2},{13, RPC_Billboard},{1, 0},{1, 0},{1, 0},{1, 2},{16, RPC_Cast Shadows},{1, 0},{1, 0},{1, 1},{21, assetlibrary_base.fbx},{1, 5},",
    Type: "YinYin",
    "Type Id": "YinYin",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "955125",
    Name: "RPC Female: YinYin",
    Category: "Entourage",
    Level: "Level 2",
    Pbi2DGeometry: "wAAAAB+LCAAAAAAABABNjdEKgjAYhd/lvx7DTZdtXUUFQV2IBF2IFzN/dLC2sBWI+O4NMuju8J2Pc6oJisZcxgeCgpNvTIm3oF1nEQgU3rjwBFVN3xiVdEWZzOWGCZpmksFc/7TtMOgxuhHsjb5jwAFUQhMCZ3Rd6EFxyrlgBEofdDDeLfXVtP/tEU3XxytBc0HgYPG9yJKuMx7Rzlsfp93L2rn+ABythVjAAAAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    Cost: "0",
    "Design Option": "-1",
    Family: "YinYin",
    "Family and Type": "YinYin",
    Height: "0",
    Host: "Floor : Insitu Concrete 225mm",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Render Appearance": "RPC-8-FUM5-CKXX-U6B5-E",
    "Render Appearance Properties":
      "{2, 15},{22, RPC-8-FUM5-CKXX-U6B5-E},{1, 0},{1, 0},{2, 38},{1, 8},{5, Color},{1, 0},{1, 0},{3, 0.8},{3, 0.8},{3, 0.8},{1, 8},{7, BBoxMin},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{1, 8},{7, BBoxMax},{1, 0},{1, 0},{1, 0},{1, 0},{1, 0},{2, 11},{9, RPCTypeId},{1, 0},{1, 0},{22, RPC-8-FUM5-CKXX-U6B5-E},{1, 6},{14, RPCPlantHeight},{1, 0},{1, 0},{4, 5.75},{2, 11},{7, keyword},{1, 0},{1, 0},{43, :Geometry:RPC:YinYin:Woman:Asian:Black Hair},{2, 11},{8, category},{1, 0},{1, 0},{17, :People [Resorts]},{2, 11},{12, LocalizedUID},{1, 0},{1, 0},{6, YinYin},{2, 14},{6, Height},{1, 0},{1, 0},{4, 5.75},{1, 2},{16, Cast Reflections},{1, 0},{1, 0},{1, 0},{1, 2},{6, Jitter},{1, 0},{1, 0},{1, 1},{1, 2},{9, Billboard},{1, 0},{1, 0},{1, 0},{1, 2},{12, Cast Shadows},{1, 0},{1, 0},{1, 1},{1, 2},{20, Apply Filter Effects},{1, 0},{1, 0},{1, 0},{2, 11},{28, Apply Filter Effects-Text-FC},{1, 0},{1, 0},{4, None},{2, 11},{11, RPCFilePath},{1, 0},{1, 0},{85, C:\\RevitRender\\Version2015940\\2017\\assetlibrary_base.fbm\\RPCs\\ArchVision_R_YinYin.rpc},{2, 11},{20, AdvancedUIDefinition},{1, 0},{1, 0},{0, },{2, 11},{10, AssetLibID},{1, 0},{1, 0},{36, 4D3F6E72-3F99-4203-98E9-AF80B3C7A7A4},{2, 11},{10, BaseSchema},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{12, ExchangeGUID},{1, 0},{1, 0},{0, },{1, 2},{6, Hidden},{1, 0},{1, 0},{1, 0},{1, 4},{11, RPCCategory},{1, 0},{1, 0},{1, 0},{2, 11},{8, RPCImage},{1, 0},{1, 0},{0, },{1, 4},{13, SchemaVersion},{1, 0},{1, 0},{1, 5},{2, 11},{12, UIDefinition},{1, 0},{1, 0},{0, },{2, 11},{6, UIName},{1, 0},{1, 0},{22, RPC-8-FUM5-CKXX-U6B5-E},{2, 11},{11, VersionGUID},{1, 0},{1, 0},{9, RPCSchema},{2, 11},{9, assettype},{1, 0},{1, 0},{11, RPCGeometry},{2, 11},{11, description},{1, 0},{1, 0},{0, },{2, 11},{9, localname},{1, 0},{1, 0},{3, RPC},{2, 11},{9, localtype},{1, 0},{1, 0},{3, RPC},{1, 4},{8, revision},{1, 0},{1, 0},{1, 1},{2, 11},{9, thumbnail},{1, 0},{1, 0},{0, },{1, 4},{7, version},{1, 0},{1, 0},{1, 1},{1, 2},{20, RPC_Cast Reflections},{1, 0},{1, 0},{1, 1},{1, 2},{10, RPC_Jitter},{1, 0},{1, 0},{1, 1},{1, 2},{13, RPC_Billboard},{1, 0},{1, 0},{1, 0},{1, 2},{16, RPC_Cast Shadows},{1, 0},{1, 0},{1, 1},{21, assetlibrary_base.fbx},{1, 5},",
    Type: "YinYin",
    "Type Id": "YinYin",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "958184",
    Name: "Elevations/Sections - A103",
    Category: "Sheets",
    "Apparent Load Phase C": "Yes",
    "Appears In Sheet List": "Approver",
    "Centerline Tick Mark": "JLH",
    "Current Revision Description": "No",
    Department: "Independent",
    Description: "-1",
    "Design Option": "Designer",
    "Draw Layer": "SM",
    "Facucent Drilling": "Sheet",
    Family: "Sheet",
    "Feed Through Lugs Current Phase C": "C:\\Program Files\\Autodesk\\Revit 2021\\Samples\\rac_basic_sample_project.rvt",
    "Ground Bus": "<None>",
    "Nominal Width": "Elevations/Sections",
    "Sash Material": " 1 : 100",
    "Sheet Height": "11/15/12",
    "Sheet Issue Date": "Elevations/Sections",
    "Tumble Dryer": "Sheet",
    "Type Comments": "Sheet",
    "View Scale": "None",
  },
  {
    ID: "958188",
    Name: "A1 metric: A1 metric",
    Category: "Title Blocks",
    Level: "-1",
    Pbi2DGeometry: "qgAAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygxKTS5JzEvPSVXSUQrIz8wrKVayiq6GMIFKDKwNlGpjYVKORUWJlUB5oIBLZmJuaklqkZKVgZ6BjpJPal56SQaUE5RfkliSmZ8H5YZnpsClPFIz0zNKoBzXnNQyZIXO+Tn5QAPzSnNyamMB1gT9gKoAAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Approved By": "Approver",
    Area: "0",
    "Checked By": "JLH",
    "Date/Time Stamp": "11/15/12",
    "Design Option": "-1",
    "Designed By": "Designer",
    "Drawn By": "SM",
    Family: "A1 metric",
    "Family and Type": "A1 metric",
    "File Path": "C:\\Program Files\\Autodesk\\Revit 2021\\Samples\\rac_basic_sample_project.rvt",
    "Host Id": "-1",
    Scale: " 1 : 100",
    "Sheet Height": "594",
    "Sheet Issue Date": "11/15/12",
    "Sheet Name": "Elevations/Sections",
    "Sheet Number": "A103",
    "Sheet Width": "840",
    Type: "A1 metric",
    "Type Id": "A1 metric",
    Volume: "0",
  },
  {
    ID: "958251",
    Name: "Elev./ Stair Sections - A105",
    Category: "Sheets",
    "Apparent Load Phase C": "Yes",
    "Appears In Sheet List": "Approver",
    "Centerline Tick Mark": "JLH",
    "Current Revision Description": "No",
    Department: "Independent",
    Description: "-1",
    "Design Option": "Designer",
    "Draw Layer": "SM",
    "Facucent Drilling": "Sheet",
    Family: "Sheet",
    "Feed Through Lugs Current Phase C": "C:\\Program Files\\Autodesk\\Revit 2021\\Samples\\rac_basic_sample_project.rvt",
    "Ground Bus": "<None>",
    "Nominal Width": "Elev./ Stair Sections",
    "Sash Material": "As indicated",
    "Sheet Height": "11/15/12",
    "Sheet Issue Date": "Elev./ Stair Sections",
    "Sheet Name": "A105",
    "Tumble Dryer": "Sheet",
    "Type Comments": "Sheet",
    "View Scale": "None",
  },
  {
    ID: "958255",
    Name: "A1 metric: A1 metric",
    Category: "Title Blocks",
    Level: "-1",
    Pbi2DGeometry: "qgAAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygxKTS5JzEvPSVXSUQrIz8wrKVayiq6GMIFKDKwNlGpjYVKORUWJlUB5oIBLZmJuaklqkZKVgZ6BjpJPal56SQaUE5RfkliSmZ8H5YZnpsClPFIz0zNKoBzXnNQyZIXO+Tn5QAPzSnNyamMB1gT9gKoAAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Approved By": "Approver",
    Area: "0",
    "Checked By": "JLH",
    "Date/Time Stamp": "11/15/12",
    "Design Option": "-1",
    "Designed By": "Designer",
    "Drawn By": "SM",
    Family: "A1 metric",
    "Family and Type": "A1 metric",
    "File Path": "C:\\Program Files\\Autodesk\\Revit 2021\\Samples\\rac_basic_sample_project.rvt",
    "Host Id": "-1",
    Scale: "As indicated",
    "Sheet Height": "594",
    "Sheet Issue Date": "11/15/12",
    "Sheet Name": "Elev./ Stair Sections",
    "Sheet Number": "A105",
    "Sheet Width": "840",
    Type: "A1 metric",
    "Type Id": "A1 metric",
    Volume: "0",
  },
  {
    ID: "958268",
    Name: "Typ. Wall Section",
    Category: "Views",
    "Angled Joins": "Yes",
    "Calculation Rules": "Callout Head w 3mm Corner Radius",
    "Color Scheme": "Background",
    "Created By": "No",
    "Crop Region Visible": "Yes",
    "Decimal Degress": "None",
    Department: "Independent",
    Description: "-1",
    "Desired Stair Height": "Fine",
    "Detail Line": "3",
    "Dimming Lamp Color Temperature Shift": "Architectural",
    Dishwasher: "Normal",
    "Facucent Drilling": "Sections",
    Family: "Section: Wall Section",
    "Far Clip Active": "21301",
    "Far Clip Offset": "Same as parent view",
    "Far Clip Settings": "0",
    "Height Offset From Level": " 1 : 100",
    "Neutral Rating": "Yes",
    "Nominal Width": "Typ. Wall Section",
    "Panel Name": "Building Section",
    "Parent View": "Show Original",
    Perimeter: "Working Drawings",
    "Phase Demolished": "Show All",
    "Reference Level": "1",
    "Referencing Detail": "A104",
    Rotation: "None",
    Scale: "20",
    "Schedule Level": "None",
    "Section Shape": "Section Head - Filled, Section Tail - Filled",
    "Sheet Issue Date": "Elev./Sec./Det.",
    "Sheet Name": "A104",
    "Show Drop Panel": "By Discipline",
    "Show Hidden Lines": "Parent View Only",
    Summary: "No",
    "Tumble Dryer": "Wall Section",
    "Type Comments": "Wall Section",
    "Vertical Scale": "Typ. Wall Section",
    "View Range": " 1 : 20",
    "View Scale": "None",
    "View Template": "-1",
  },
  {
    ID: "958303",
    Name: "Typical Wall Roof Connection",
    Category: "Views",
    "Angled Joins": "Yes",
    "Calculation Rules": "Callout Head w 3mm Corner Radius",
    "Color Scheme": "Background",
    "Created By": "No",
    "Crop Region Visible": "Yes",
    "Decimal Degress": "None",
    Department: "Independent",
    Description: "-1",
    "Desired Stair Height": "Medium",
    "Detail Line": "4",
    "Dimming Lamp Color Temperature Shift": "Architectural",
    Dishwasher: "Normal",
    "Facucent Drilling": "Detail View",
    Family: "Detail View: Detail",
    "Far Clip Active": "21301",
    "Far Clip Offset": "Same as parent view",
    "Far Clip Settings": "0",
    "Height Offset From Level": " 1 : 20",
    "Neutral Rating": "Yes",
    "Nominal Width": "Typical Wall Roof Connection",
    "Panel Name": "Typ. Wall Section",
    "Parent View": "Show Original",
    Perimeter: "Working Drawings",
    "Phase Demolished": "Show All",
    "Reference Level": "3",
    "Referencing Detail": "A104",
    Rotation: "None",
    Scale: "10",
    "Schedule Level": "None",
    "Section Shape": "Section Head - No Arrow, Section Tail - Filled Horizontal",
    "Sheet Issue Date": "Elev./Sec./Det.",
    "Sheet Name": "A104",
    "Show Drop Panel": "By Discipline",
    "Show Hidden Lines": "Parent View Only",
    Summary: "No",
    "Tumble Dryer": "Detail",
    "Type Comments": "Detail",
    "Vertical Scale": "Typical Wall Roof Connection",
    "View Range": " 1 : 10",
    "View Scale": "None",
    "View Template": "-1",
  },
  {
    ID: "958316",
    Name: "Typical Floor Wall Connection",
    Category: "Views",
    "Angled Joins": "Yes",
    "Calculation Rules": "Callout Head w 3mm Corner Radius",
    "Color Scheme": "Background",
    "Created By": "No",
    "Crop Region Visible": "Yes",
    "Decimal Degress": "None",
    Department: "Independent",
    Description: "-1",
    "Desired Stair Height": "Fine",
    "Detail Line": "5",
    "Dimming Lamp Color Temperature Shift": "Architectural",
    Dishwasher: "Normal",
    "Facucent Drilling": "Detail Views",
    Family: "Detail View: Detail",
    "Far Clip Active": "21301",
    "Far Clip Offset": "Same as parent view",
    "Far Clip Settings": "0",
    "Height Offset From Level": " 1 : 20",
    "Neutral Rating": "Yes",
    "Nominal Width": "Typical Floor Wall Connection",
    "Panel Name": "Typ. Wall Section",
    "Parent View": "Show Original",
    Perimeter: "Working Drawings",
    "Phase Demolished": "Show All",
    "Reference Level": "3",
    "Referencing Detail": "A104",
    Rotation: "None",
    Scale: "10",
    "Schedule Level": "None",
    "Section Shape": "Section Head - No Arrow, Section Tail - Filled Horizontal",
    "Sheet Issue Date": "Elev./Sec./Det.",
    "Sheet Name": "A104",
    "Show Drop Panel": "By Discipline",
    "Show Hidden Lines": "Parent View Only",
    Summary: "No",
    "Tumble Dryer": "Detail",
    "Type Comments": "Detail",
    "Vertical Scale": "Typical Floor Wall Connection",
    "View Range": " 1 : 10",
    "View Scale": "None",
    "View Template": "-1",
  },
  {
    ID: "958329",
    Name: "Typical Foundation Detail",
    Category: "Views",
    "Angled Joins": "Yes",
    "Calculation Rules": "Callout Head w 3mm Corner Radius",
    "Color Scheme": "Background",
    "Created By": "No",
    "Crop Region Visible": "Yes",
    "Decimal Degress": "None",
    Department: "Independent",
    Description: "-1",
    "Desired Stair Height": "Medium",
    "Detail Line": "6",
    "Dimming Lamp Color Temperature Shift": "Architectural",
    Dishwasher: "Normal",
    "Facucent Drilling": "Detail View",
    Family: "Detail Views (Detail)",
    "Far Clip Active": "21301",
    "Far Clip Offset": "Same as parent view",
    "Far Clip Settings": "0",
    "Height Offset From Level": " 1 : 20",
    "Neutral Rating": "Yes",
    "Nominal Width": "Typical Foundation Detail",
    "Panel Name": "Typ. Wall Section",
    "Parent View": "Show Original",
    Perimeter: "Working Drawings",
    "Phase Demolished": "Show All",
    "Reference Level": "3",
    "Referencing Detail": "A104",
    Rotation: "None",
    Scale: "10",
    "Schedule Level": "None",
    "Section Shape": "Section Head - No Arrow, Section Tail - Filled Horizontal",
    "Sheet Issue Date": "Elev./Sec./Det.",
    "Sheet Name": "A104",
    "Show Drop Panel": "By Discipline",
    "Show Hidden Lines": "Parent View Only",
    Summary: "No",
    "Tumble Dryer": "Detail",
    "Type Comments": "Detail",
    "Vertical Scale": "Typical Foundation Detail",
    "View Range": " 1 : 10",
    "View Scale": "None",
    "View Template": "-1",
  },
  {
    ID: "958461",
    Name: "Main Stair Detail",
    Category: "Views",
    "Angled Joins": "Yes",
    "Calculation Rules": "Callout Head w 3mm Corner Radius",
    "Color Scheme": "Background",
    "Created By": "No",
    "Crop Region Visible": "Yes",
    "Decimal Degress": "None",
    Department: "Independent",
    Description: "-1",
    "Desired Stair Height": "Fine",
    "Detail Line": "4",
    "Dimming Lamp Color Temperature Shift": "Architectural",
    Dishwasher: "Normal",
    "Facucent Drilling": "Detail Views",
    Family: "Detail Views (Detail)",
    "Far Clip Active": "26920",
    "Far Clip Offset": "Same as parent view",
    "Far Clip Settings": "0",
    "Height Offset From Level": " 1 : 50",
    "Neutral Rating": "Yes",
    "Nominal Width": "Main Stair Detail",
    "Panel Name": "Stair Section",
    "Parent View": "Show Original",
    Perimeter: "Working Drawings",
    "Phase Demolished": "Show All",
    "Reference Level": "1",
    "Referencing Detail": "A105",
    Rotation: "None",
    Scale: "20",
    "Schedule Level": "None",
    "Section Shape": "Section Head - No Arrow, Section Tail - Filled Horizontal",
    "Sheet Issue Date": "Elev./ Stair Sections",
    "Sheet Name": "A105",
    "Show Drop Panel": "By Discipline",
    "Show Hidden Lines": "Parent View Only",
    Summary: "No",
    "Tumble Dryer": "Detail",
    "Type Comments": "Detail",
    "Vertical Scale": "Main Stair Detail",
    "View Range": " 1 : 20",
    "View Scale": "-1",
    "View Template": "-1",
  },
  {
    ID: "959070",
    Category: "Section Boxes",
    Description: "-1",
  },
  {
    ID: "959071",
    Name: "Solar Analysis",
    Category: "Views",
    "Angled Joins": "No",
    "Callout Tag": "Adjusting",
    "Circuit Prefix Separator": "Poche",
    "Created By": "No",
    "Crop Region Visible": "No",
    "Decimal Degress": "None",
    Department: "Independent",
    Description: "-1",
    "Desired Stair Height": "Medium",
    "Detail Line": "2",
    "Dimming Lamp Color Temperature Shift": "Coordination",
    "Extrusion Start": "49271",
    "Facucent Drilling": "3D View",
    Family: "3D Views",
    "Family Type": "No",
    "Far Clip Active": "304800",
    "Lock Proportions": "No",
    "Neutral Rating": "Yes",
    "Nominal Width": "-1",
    "Parent View": "Show Original",
    Perimeter: "Working Drawings",
    "Phase Demolished": "Show All",
    "Projected Area": "Orthographic",
    Rotation: "None",
    Scale: "500",
    "Schedule Level": "None",
    "Scope Box": "Yes",
    "Sheet Issue Date": "Site Plan",
    "Sheet Name": "A101",
    "Show Drop Panel": "By Discipline",
    Summary: "Yes",
    Tank: "170",
    "Tumble Dryer": "3D View",
    "Type Comments": "3D View",
    "Vertical Scale": "Solar Analysis",
    "View Range": " 1 : 500",
    "View Scale": "-1",
    "View Template": "-1",
  },
  {
    ID: "959135",
    Name: "Site Plan - A101",
    Category: "Sheets",
    "Apparent Load Phase C": "Yes",
    "Appears In Sheet List": "Approver",
    "Centerline Tick Mark": "JLH",
    "Current Revision Description": "No",
    Department: "Independent",
    Description: "-1",
    "Design Option": "Designer",
    "Draw Layer": "SM",
    "Facucent Drilling": "Sheets",
    Family: "Sheets",
    "Feed Through Lugs Current Phase C": "C:\\Program Files\\Autodesk\\Revit 2021\\Samples\\rac_basic_sample_project.rvt",
    "Ground Bus": "<None>",
    "Nominal Width": "Site Plan",
    "Sash Material": " 1 : 200",
    "Sheet Height": "11/16/12",
    "Sheet Issue Date": "Site Plan",
    "Tumble Dryer": "Sheet",
    "Type Comments": "Sheet",
    "View Scale": "None",
  },
  {
    ID: "959139",
    Name: "A1 metric: A1 metric",
    Category: "Title Blocks",
    Level: "-1",
    Pbi2DGeometry: "qgAAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygxKTS5JzEvPSVXSUQrIz8wrKVayiq6GMIFKDKwNlGpjYVKORUWJlUB5oIBLZmJuaklqkZKVgZ6BjpJPal56SQaUE5RfkliSmZ8H5YZnpsClPFIz0zNKoBzXnNQyZIXO+Tn5QAPzSnNyamMB1gT9gKoAAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Approved By": "Approver",
    Area: "0",
    "Checked By": "JLH",
    "Date/Time Stamp": "11/16/12",
    "Design Option": "-1",
    "Designed By": "Designer",
    "Drawn By": "SM",
    Family: "A1 metric",
    "Family and Type": "A1 metric",
    "File Path": "C:\\Program Files\\Autodesk\\Revit 2021\\Samples\\rac_basic_sample_project.rvt",
    "Host Id": "-1",
    Scale: " 1 : 200",
    "Sheet Height": "594",
    "Sheet Issue Date": "11/16/12",
    "Sheet Name": "Site Plan",
    "Sheet Number": "A101",
    "Sheet Width": "840",
    Type: "A1 metric",
    "Type Id": "A1 metric",
    Volume: "0",
  },
  {
    ID: "959432",
    Name: "Planting Tag: Boxed",
    Category: "Planting Tags",
    "Bowl Height": "Yes",
    Description: "-1",
    "Facucent Drilling": "Boxed",
    Family: "Boxed",
    Leader: "None",
    "Leader Arrowhead": "Yes",
    "Leader Tick Mark": "Free End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "Boxed",
    "Type Comments": "Boxed",
  },
  {
    ID: "959437",
    Name: "Planting Tag: Boxed",
    Category: "Planting Tags",
    "Bowl Height": "Yes",
    Description: "-1",
    "Facucent Drilling": "Boxed",
    Family: "Boxed",
    Leader: "None",
    "Leader Arrowhead": "Yes",
    "Leader Tick Mark": "Free End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "Boxed",
    "Type Comments": "Boxed",
  },
  {
    ID: "959440",
    Name: "Planting Tag: Boxed",
    Category: "Planting Tags",
    "Bowl Height": "Yes",
    Description: "-1",
    "Facucent Drilling": "Boxed",
    Family: "Boxed",
    Leader: "None",
    "Leader Arrowhead": "Yes",
    "Leader Tick Mark": "Free End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "Boxed",
    "Type Comments": "Boxed",
  },
  {
    ID: "959450",
    Name: "Planting Tag: Boxed",
    Category: "Planting Tags",
    "Bowl Height": "Yes",
    Description: "-1",
    "Facucent Drilling": "Boxed",
    Family: "Boxed",
    Leader: "None",
    "Leader Arrowhead": "Yes",
    "Leader Tick Mark": "Free End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "Boxed",
    "Type Comments": "Boxed",
  },
  {
    ID: "959452",
    Name: "Planting Tag: Boxed",
    Category: "Planting Tags",
    "Bowl Height": "Yes",
    Description: "-1",
    "Facucent Drilling": "Boxed",
    Family: "Boxed",
    Leader: "None",
    "Leader Arrowhead": "Yes",
    "Leader Tick Mark": "Free End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "Boxed",
    "Type Comments": "Boxed",
  },
  {
    ID: "959455",
    Name: "Planting Tag: Boxed",
    Category: "Planting Tags",
    "Bowl Height": "Yes",
    Description: "-1",
    "Facucent Drilling": "Boxed",
    Family: "Boxed",
    Leader: "None",
    "Leader Arrowhead": "Yes",
    "Leader Tick Mark": "Free End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "Boxed",
    "Type Comments": "Boxed",
  },
  {
    ID: "959459",
    Name: "Planting Tag: Boxed",
    Category: "Planting Tags",
    "Bowl Height": "Yes",
    Description: "-1",
    "Facucent Drilling": "Boxed",
    Family: "Boxed",
    Leader: "None",
    "Leader Arrowhead": "Yes",
    "Leader Tick Mark": "Free End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "Boxed",
    "Type Comments": "Boxed",
  },
  {
    ID: "959464",
    Name: "Planting Tag: Boxed",
    Category: "Planting Tags",
    "Bowl Height": "Yes",
    Description: "-1",
    "Facucent Drilling": "Boxed",
    Family: "Boxed",
    Leader: "None",
    "Leader Arrowhead": "Yes",
    "Leader Tick Mark": "Free End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "Boxed",
    "Type Comments": "Boxed",
  },
  {
    ID: "959469",
    Name: "Planting Tag: Boxed",
    Category: "Planting Tags",
    "Bowl Height": "Yes",
    Description: "-1",
    "Facucent Drilling": "Boxed",
    Family: "Boxed",
    Leader: "None",
    "Leader Arrowhead": "Yes",
    "Leader Tick Mark": "Free End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "Boxed",
    "Type Comments": "Boxed",
  },
  {
    ID: "959474",
    Name: "Planting Tag: Boxed",
    Category: "Planting Tags",
    "Bowl Height": "Yes",
    Description: "-1",
    "Facucent Drilling": "Boxed",
    Family: "Boxed",
    Leader: "None",
    "Leader Arrowhead": "Yes",
    "Leader Tick Mark": "Free End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "Boxed",
    "Type Comments": "Boxed",
  },
  {
    ID: "959479",
    Name: "Planting Tag: Boxed",
    Category: "Planting Tags",
    "Bowl Height": "Yes",
    Description: "-1",
    "Facucent Drilling": "Boxed",
    Family: "Boxed",
    Leader: "None",
    "Leader Arrowhead": "Yes",
    "Leader Tick Mark": "Free End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "Boxed",
    "Type Comments": "Boxed",
  },
  {
    ID: "959480",
    Name: "Planting Tag: Boxed",
    Category: "Planting Tags",
    "Bowl Height": "Yes",
    Description: "-1",
    "Facucent Drilling": "Boxed",
    Family: "Boxed",
    Leader: "None",
    "Leader Arrowhead": "Yes",
    "Leader Tick Mark": "Free End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "Boxed",
    "Type Comments": "Boxed",
  },
  {
    ID: "959482",
    Name: "Planting Tag: Boxed",
    Category: "Planting Tags",
    "Bowl Height": "Yes",
    Description: "-1",
    "Facucent Drilling": "Boxed",
    Family: "Boxed",
    Leader: "None",
    "Leader Arrowhead": "Yes",
    "Leader Tick Mark": "Free End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "Boxed",
    "Type Comments": "Boxed",
  },
  {
    ID: "959484",
    Name: "Planting Tag: Boxed",
    Category: "Planting Tags",
    "Bowl Height": "Yes",
    Description: "-1",
    "Facucent Drilling": "Boxed",
    Family: "Boxed",
    Leader: "None",
    "Leader Arrowhead": "Yes",
    "Leader Tick Mark": "Free End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "Boxed",
    "Type Comments": "Boxed",
  },
  {
    ID: "959486",
    Name: "Planting Tag: Boxed",
    Category: "Planting Tags",
    "Bowl Height": "Yes",
    Description: "-1",
    "Facucent Drilling": "Boxed",
    Family: "Boxed",
    Leader: "None",
    "Leader Arrowhead": "Yes",
    "Leader Tick Mark": "Free End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "Boxed",
    "Type Comments": "Boxed",
  },
  {
    ID: "959488",
    Name: "Planting Tag: Boxed",
    Category: "Planting Tags",
    "Bowl Height": "Yes",
    Description: "-1",
    "Facucent Drilling": "Boxed",
    Family: "Boxed",
    Leader: "None",
    "Leader Arrowhead": "Yes",
    "Leader Tick Mark": "Free End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "Boxed",
    "Type Comments": "Boxed",
  },
  {
    ID: "959490",
    Name: "Planting Tag: Boxed",
    Category: "Planting Tags",
    "Bowl Height": "Yes",
    Description: "-1",
    "Facucent Drilling": "Boxed",
    Family: "Boxed",
    Leader: "None",
    "Leader Arrowhead": "Yes",
    "Leader Tick Mark": "Free End",
    "Ordinate Dimension Settings": "Horizontal",
    "Tumble Dryer": "Boxed",
    "Type Comments": "Boxed",
  },
  {
    ID: "959497",
    Category: "Schedule Graphics",
    Description: "-1",
  },
  {
    ID: "959510",
    Name: "Title Sheet - A001",
    Category: "Sheets",
    "Apparent Load Phase C": "Yes",
    "Appears In Sheet List": "Approver",
    "Centerline Tick Mark": "JLH",
    "Current Revision Description": "No",
    Department: "Independent",
    Description: "-1",
    "Design Option": "Designer",
    "Draw Layer": "SM",
    "Facucent Drilling": "Sheet",
    Family: "Sheets",
    "Feed Through Lugs Current Phase C": "C:\\Program Files\\Autodesk\\Revit 2021\\Samples\\rac_basic_sample_project.rvt",
    "Ground Bus": "<None>",
    "Nominal Width": "Title Sheet",
    "Sash Material": " 1 : 1",
    "Sheet Height": "11/16/12",
    "Sheet Issue Date": "Title Sheet",
    "Sheet Name": "A001",
    "Tumble Dryer": "Sheet",
    "Type Comments": "Sheet",
    "View Scale": "None",
  },
  {
    ID: "959514",
    Name: "A1 metric: A1 metric",
    Category: "Title Blocks",
    Level: "-1",
    Pbi2DGeometry: "qgAAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygxKTS5JzEvPSVXSUQrIz8wrKVayiq6GMIFKDKwNlGpjYVKORUWJlUB5oIBLZmJuaklqkZKVgZ6BjpJPal56SQaUE5RfkliSmZ8H5YZnpsClPFIz0zNKoBzXnNQyZIXO+Tn5QAPzSnNyamMB1gT9gKoAAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Approved By": "Approver",
    Area: "0",
    "Checked By": "JLH",
    "Date/Time Stamp": "11/16/12",
    "Design Option": "-1",
    "Designed By": "Designer",
    "Drawn By": "SM",
    Family: "A1 metric",
    "Family and Type": "A1 metric",
    "File Path": "C:\\Program Files\\Autodesk\\Revit 2021\\Samples\\rac_basic_sample_project.rvt",
    "Host Id": "-1",
    Scale: " 1 : 1",
    "Sheet Height": "594",
    "Sheet Issue Date": "11/16/12",
    "Sheet Name": "Title Sheet",
    "Sheet Number": "A001",
    "Sheet Width": "840",
    Type: "A1 metric",
    "Type Id": "A1 metric",
    Volume: "0",
  },
  {
    ID: "960043",
    Name: "Text: 18mm Arial",
    Category: "Text Notes",
    "Approved By": "No",
    "b 1": "Transparent",
    "Body width": "No",
    "Cold Water Radius": "0",
    Description: "-1",
    "Facucent Drilling": "18mm Arial",
    Family: "18mm Arial",
    Hieght: "Left",
    "Interior Type": "No",
    k: "Yes",
    Leader: "Arrow 30 Degree",
    "Leader Type": "2.032",
    left: "Top",
    "Line Style": "1",
    right: "Bottom",
    "Show Arrowhead to Cut Mark": "No",
    t: "12.7",
    "Text Background": "Arial",
    "Text Offset": "18",
    "Tumble Dryer": "18mm Arial",
    "Type Comments": "18mm Arial",
    "Underlay Orientation": "No",
    Vents: "Top",
    "Width (pixels)": "1",
  },
  {
    ID: "960046",
    Name: "Text: 10mm Arial",
    Category: "Text Notes",
    "Approved By": "No",
    "b 1": "Transparent",
    "Body width": "No",
    "Cold Water Radius": "0",
    Description: "-1",
    "Facucent Drilling": "10mm Arial",
    Family: "10mm Arial",
    Hieght: "Left",
    "Interior Type": "No",
    k: "Yes",
    Leader: "Arrow 30 Degree",
    "Leader Type": "2.032",
    left: "Top",
    "Line Style": "1",
    right: "Bottom",
    "Show Arrowhead to Cut Mark": "No",
    t: "12.7",
    "Text Background": "Arial",
    "Text Offset": "8",
    "Tumble Dryer": "10mm Arial",
    "Type Comments": "10mm Arial",
    "Underlay Orientation": "No",
    Vents: "Top",
    "Width (pixels)": "1",
  },
  {
    ID: "960060",
    Name: "Text: 10mm Arial",
    Category: "Text Notes",
    "Approved By": "No",
    "b 1": "Transparent",
    "Body width": "No",
    "Cold Water Radius": "0",
    Description: "-1",
    "Facucent Drilling": "10mm Arial",
    Family: "10mm Arial",
    Hieght: "Left",
    "Interior Type": "No",
    k: "Yes",
    Leader: "Arrow 30 Degree",
    "Leader Type": "2.032",
    left: "Top",
    "Line Style": "1",
    right: "Bottom",
    "Show Arrowhead to Cut Mark": "No",
    t: "12.7",
    "Text Background": "Arial",
    "Text Offset": "8",
    "Tumble Dryer": "10mm Arial",
    "Type Comments": "10mm Arial",
    "Underlay Orientation": "No",
    Vents: "Top",
    "Width (pixels)": "1",
  },
  {
    ID: "960064",
    Name: "Approach",
    Category: "Views",
    Department: "Independent",
    Description: "-1",
    "Detail Line": "5",
    "Facucent Drilling": "Rendering",
    Family: "Rendering",
    "Neutral Rating": "Yes",
    "Nominal Width": "Approach",
    Rotation: "None",
    Scale: "1",
    "Sheet Issue Date": "Title Sheet",
    "Sheet Name": "A001",
    "Tumble Dryer": "Rendering",
    "Type Comments": "Rendering",
    "Vertical Scale": "Approach",
    "View Scale": "None",
    "View Template": "-1",
  },
  {
    ID: "960072",
    Name: "Raster image: Approach",
    Category: "Raster Images",
    Description: "-1",
    "Down Text": "Background",
    "Facucent Drilling": "Approach",
    Family: "Approach",
    "Heating Set Point": "246",
    Height: "484",
    "Horizontal Gap Distance": "1",
    "Location Line": "Yes",
    "Rendering Settings": "50",
    "Tumble Dryer": "Approach",
    "Type Comments": "Approach",
    "Vertical Gap Distance": "1",
    "Vertical Scale": "Approach",
    Wheels: "450",
    Width: "886",
  },
  {
    ID: "960076",
    Name: "From Yard",
    Category: "Views",
    Department: "Independent",
    Description: "-1",
    "Detail Line": "4",
    "Facucent Drilling": "Renderings",
    Family: "Rendering: Rendering",
    "Neutral Rating": "Yes",
    "Nominal Width": "From Yard",
    Rotation: "None",
    Scale: "1",
    "Sheet Issue Date": "Title Sheet",
    "Sheet Name": "A001",
    "Tumble Dryer": "Rendering",
    "Type Comments": "Rendering",
    "Vertical Scale": "From Yard",
    "View Scale": "-1",
    "View Template": "-1",
  },
  {
    ID: "960084",
    Name: "Raster image: From Yard",
    Category: "Raster Images",
    Description: "-1",
    "Down Text": "Background",
    "Facucent Drilling": "From Yard",
    Family: "From Yard",
    "Heating Set Point": "110",
    Height: "484",
    "Horizontal Gap Distance": "1",
    "Location Line": "Yes",
    "Rendering Settings": "112",
    "Tumble Dryer": "From Yard",
    "Type Comments": "From Yard",
    "Vertical Gap Distance": "1",
    "Vertical Scale": "From Yard",
    Wheels: "201",
    Width: "886",
  },
  {
    ID: "960620",
    Category: "Section Boxes",
    Description: "-1",
  },
  {
    ID: "960621",
    Name: "{3D}",
    Category: "Views",
    "Angled Joins": "No",
    "Callout Tag": "Adjusting",
    "Circuit Prefix Separator": "Poche",
    "Created By": "No",
    "Crop Region Visible": "No",
    "Decimal Degress": "None",
    Department: "Independent",
    Description: "-1",
    "Desired Stair Height": "Medium",
    "Detail Line": "-",
    "Dimming Lamp Color Temperature Shift": "Architectural",
    "Extrusion Start": "20632",
    "Facucent Drilling": "3D View",
    Family: "3D View",
    "Family Type": "No",
    "Far Clip Active": "304800",
    "Lock Proportions": "No",
    "Neutral Rating": "Yes",
    "Nominal Width": "-1",
    "Parent View": "Show Original",
    Perimeter: "Working Drawings",
    "Phase Demolished": "Show All",
    "Projected Area": "Orthographic",
    Scale: "100",
    "Schedule Level": "None",
    "Scope Box": "Yes",
    "Sheet Name": "---",
    "Show Drop Panel": "By Discipline",
    Summary: "No",
    Tank: "-4334",
    "Tumble Dryer": "3D View",
    "Type Comments": "3D View",
    "Vertical Scale": "{3D}",
    "View Range": " 1 : 100",
    "View Scale": "None",
    "View Template": "-1",
  },
  {
    ID: "960812",
    Name: "E,S,D - Highlight Learning Content",
    Category: "Views",
    "Color Scheme": "Background",
    Description: "-1",
    "Desired Stair Height": "Fine",
    "Dimming Lamp Color Temperature Shift": "Architectural",
    Dishwasher: "Normal",
    "Far Clip Settings": "0",
    "Parent View": "Show Original",
    "Phase Demolished": "Show All",
    Scale: "100",
    "Show Drop Panel": "By Discipline",
    Summary: "No",
    "View Range": " 1 : 100",
    "View Scale": "None",
  },
  {
    ID: "960887",
    Name: "Architectural Plan",
    Category: "Views",
    "Color Scheme": "Background",
    Depth: "0",
    Description: "-1",
    "Desired Stair Height": "Medium",
    "Dimming Lamp Color Temperature Shift": "Architectural",
    Dishwasher: "Normal",
    "Ordinate Dimension Settings": "Project North",
    "Parent View": "Show Original",
    "Phase Demolished": "Show All",
    Scale: "100",
    "Show Drop Panel": "By Discipline",
    Summary: "No",
    "Unconnected Height": "Look down",
    "View Range": " 1 : 100",
    "View Scale": "None",
  },
  {
    ID: "960889",
    Name: "Plan - Highlight Learning Content",
    Category: "Views",
    "Color Scheme": "Background",
    Depth: "0",
    Description: "-1",
    "Desired Stair Height": "Medium",
    "Dimming Lamp Color Temperature Shift": "Architectural",
    Dishwasher: "Normal",
    "Ordinate Dimension Settings": "Project North",
    "Parent View": "Show Original",
    "Phase Demolished": "Show All",
    Scale: "100",
    "Show Drop Panel": "By Discipline",
    Summary: "No",
    "Unconnected Height": "Look down",
    "View Range": " 1 : 100",
    "View Scale": "None",
  },
  {
    ID: "961104",
    Name: "Site Plan",
    Category: "Views",
    "Color Scheme": "Background",
    Depth: "0",
    Description: "-1",
    "Desired Stair Height": "Coarse",
    "Dimming Lamp Color Temperature Shift": "Architectural",
    Dishwasher: "Normal",
    "Ordinate Dimension Settings": "True North",
    "Parent View": "Show Original",
    "Phase Demolished": "Show All",
    Scale: "200",
    "Show Drop Panel": "By Discipline",
    Summary: "No",
    "Unconnected Height": "Look down",
    "View Range": " 1 : 200",
    "View Scale": "None",
  },
  {
    ID: "961260",
    Name: "Highlight Learning Content",
    Category: "Views",
    Description: "-1",
    "Desired Stair Height": "Medium",
    "Dimming Lamp Color Temperature Shift": "Architectural",
    "Parent View": "Show Original",
    "Phase Demolished": "Show All",
    Scale: "100",
    "Show Drop Panel": "By Discipline",
    Summary: "No",
    "View Range": " 1 : 100",
    "View Scale": "None",
  },
  {
    ID: "961262",
    Name: "3D View",
    Category: "Views",
    Description: "-1",
    "Desired Stair Height": "Medium",
    "Dimming Lamp Color Temperature Shift": "Architectural",
    "Parent View": "Show Original",
    "Phase Demolished": "Show All",
    Scale: "100",
    "Show Drop Panel": "By Discipline",
    Summary: "No",
    "View Range": " 1 : 100",
    "View Scale": "None",
  },
  {
    ID: "961284",
    Name: "Elevation: Building Elevation",
    Category: "Elevations",
    "Calculation Rules": "Callout Head w 3mm Corner Radius",
    Description: "-1",
    "Elevation from Level": "12mm Circle",
    "Facucent Drilling": "Building Elevation",
    Family: "Building Elevation",
    "Neutral Rating": "Yes",
    "Sheet Name": "-",
    "Tumble Dryer": "Building Elevation",
    "Type Comments": "Building Elevation",
    "View Template": "-1",
  },
  {
    ID: "961492",
    Name: "Elevation: Building Elevation",
    Category: "Elevations",
    "Calculation Rules": "Callout Head w 3mm Corner Radius",
    Description: "-1",
    "Elevation from Level": "12mm Circle",
    "Facucent Drilling": "Building Elevation",
    Family: "Building Elevation",
    "Neutral Rating": "Yes",
    "Sheet Name": "-",
    "Tumble Dryer": "Building Elevation",
    "Type Comments": "Building Elevation",
    "View Template": "-1",
  },
  {
    ID: "961502",
    Name: "Elevation: Building Elevation",
    Category: "Elevations",
    "Calculation Rules": "Callout Head w 3mm Corner Radius",
    Description: "-1",
    "Elevation from Level": "12mm Circle",
    "Facucent Drilling": "Building Elevation",
    Family: "Building Elevation",
    "Neutral Rating": "Yes",
    "Sheet Name": "-",
    "Tumble Dryer": "Building Elevation",
    "Type Comments": "Building Elevation",
    "View Template": "-1",
  },
  {
    ID: "961512",
    Name: "Elevation: Building Elevation",
    Category: "Elevations",
    "Calculation Rules": "Callout Head w 3mm Corner Radius",
    Description: "-1",
    "Elevation from Level": "12mm Circle",
    "Facucent Drilling": "Building Elevation",
    Family: "Building Elevation",
    "Neutral Rating": "Yes",
    "Sheet Name": "-",
    "Tumble Dryer": "Building Elevation",
    "Type Comments": "Building Elevation",
    "View Template": "-1",
  },
  {
    ID: "964238",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "twAAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygxKTS5JzEvPSVXSUQrIz8wrKVayiq6GMIFKdA3N9UwtTY2tDS30DEzMzZRqY2HqHIuKEiuBioECLpmJuaklqUVKVgZ6BjpKPql56SUZUE5QfkliSWZ+HpQbnpkCl/JIzUzPKIFyXHNSy5AVOufn5AMNzCvNyamNBQCAg3eWtwAAAA==",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "01 - Basic",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=EXLINK_ADDGRIDS",
    Location: "Floor Plan Level 1",
    Order: "2",
    Summary: "Place grids into a project and control grid heads display.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "964239",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "tQAAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygxKTS5JzEvPSVXSUQrIz8wrKVayiq6GMIFKLPQsDU2NrI1N9QyMzEyUamNhqhyLihIrgUqBAi6ZibmpJalFSlYGegY6Sj6peeklGVBOUH5JYklmfh6UG56ZApfySM1MzyiBclxzUsuQFTrn5+QDDcwrzcmpjQUArg3nybUAAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "01 - Basic",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=EXLINK_SECTION",
    Location: "Floor Plan Level 1",
    Order: "12",
    Summary: "Create section views.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "964240",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "tQAAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygxKTS5JzEvPSVXSUQrIz8wrKVayiq6GMIFKjCz0DAzNLawNDfVMTS2VamNhqhyLihIrgUqBAi6ZibmpJalFSlYGegY6Sj6peeklGVBOUH5JYklmfh6UG56ZApfySM1MzyiBclxzUsuQFTrn5+QDDcwrzcmpjQUADfB8/rUAAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "01 - Basic",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=EXLINK_WALLS",
    Location: "Floor Plan Level 1",
    Order: "3",
    Summary: "Place walls and doors into your project.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "964241",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "tgAAAB+LCAAAAAAABABNjMEKwjAQRP9lzzU0VSzEk6gg6KEUwUPpIdUlXYiJxFUopf9uwCje5s08phmh6ug03BEUHHxHNV5YO2MRMqg8OX6AasZPjMpCCimX5WpWiFIWc5jar7YOQQ/RjcWW9A0ZA6hc5Bkc0RnuE9SeNZN3Cc90/U17JNNzgp3F17+48dbHQ/e0dmrfeq1OQbYAAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "01 - Basic",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=HID_FAM_OBJECT_STAIRS",
    Location: "Floor Plan Level 1",
    Order: "8",
    Summary: "Create a stair by sketching boundaries and risers.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "964242",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "tgAAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygxKTS5JzEvPSVXSUQrIz8wrKVayiq6GMIFKjE31jIwNrXVNDfVMjc0MlWpjYcoci4oSK4FqgQIumYm5qSWpRUpWBnoGOko+qXnpJRlQTlB+SWJJZn4elBuemQKX8kjNTM8ogXJcc1LLkBU65+fkAw3MK83JqY0FAGWeVNO2AAAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "01 - Basic",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=EXLINK_CURTAINWALLS",
    Location: "Floor Plan Level 1",
    Order: "9",
    Summary: "Create a curtain wall.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "964525",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "tgAAAB+LCAAAAAAABABNjMEKwjAQRP9lzyXEChHjSVQQ9FCK4KH0kOqSLsRE4iqU0n83YBRv82Ye04xQdXQa7ggaDqGjGi9svHUIBVSBPD9AN+MnJmW+EEup1KpUQqlZCVP71dYxmiG5qdiSuSFjBC2FLOCI3nKfoQ5smILPeKbrb9oj2Z4z7By+/sVNcCEd+qdzU/sGAkZoS7YAAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "01 - Basic",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=HID_ANNOTATIONS_DIMENSION_ALIGNED",
    Location: "Floor Plan Level 1",
    Order: "19",
    Summary: "Add aligned dimensions to a view.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "964539",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "tQAAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygxKTS5JzEvPSVXSUQrIz8wrKVayiq6GMIFKzEz1LCwszKxN9ExNLQ2VamNhqhyLihIrgUqBAi6ZibmpJalFSlYGegY6Sj6peeklGVBOUH5JYklmfh6UG56ZApfySM1MzyiBclxzUsuQFTrn5+QDDcwrzcmpjQUAFASG7LUAAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "01 - Basic",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=EXLINK_TEXTNOTE",
    Location: "Floor Plan Level 1",
    Order: "20",
    Summary: "Add text notes to a view.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "970093",
    Category: "Schedule Graphics",
    Description: "-1",
  },
  {
    ID: "970378",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "tQAAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygxKTS5JzEvPSVXSUQrIz8wrKVayiq6GMIFKjCz1jMxMzK0N9cyMTEyVamNhqhyLihIrgUqBAi6ZibmpJalFSlYGegY6Sj6peeklGVBOUH5JYklmfh6UG56ZApfySM1MzyiBclxzUsuQFTrn5+QDDcwrzcmpjQUA+lSmSrUAAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "01 - Basic",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=EXLINK_DOORS",
    Location: "Floor Plan Level 2",
    Order: "4",
    Summary: "Add doors to the project.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "970380",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "twAAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygxKTS5JzEvPSVXSUQrIz8wrKVayiq6GMIFKdA0N9YwNDE2tQbS5hbFSbSxMnWNRUWIlUDFQwCUzMTe1JLVIycpAz0BHySc1L70kA8oJyi9JLMnMz4NywzNT4FIeqZnpGSVQjmtOahmyQuf8nHyggXmlOTm1sQB+HFg+twAAAA==",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "01 - Basic",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=EXLINK_WINDOWS",
    Location: "Floor Plan Level 2",
    Order: "5",
    Summary: "Add a window to the project.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "970384",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "tgAAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygxKTS5JzEvPSVXSUQrIz8wrKVayiq6GMIFKzPRMLYyMrHUNzfVMDIwtlWpjYcoci4oSK4FqgQIumYm5qSWpRUpWBnoGOko+qXnpJRlQTlB+SWJJZn4elBuemQKX8kjNTM8ogXJcc1LLkBU65+fkAw3MK83JqY0FAJ0tjd62AAAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "03 - Advanced",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=HID_OBJECTS_ROOM_FILL",
    Location: "Floor Plan Level 2",
    Order: "3",
    Summary: "Add a color fill legend.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "970388",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "twAAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygxKTS5JzEvPSVXSUQrIz8wrKVayiq6GMIFKjC30TIwMLK11DU30DMwNjZVqY2HqHIuKEiuBioECLpmJuaklqUVKVgZ6BjpKPql56SUZUE5QfkliSWZ+HpQbnpkCl/JIzUzPKIFyXHNSy5AVOufn5AMNzCvNyamNBQCSXHbXtwAAAA==",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "02 - Intermediate",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=EXLINK_DOORTOCW",
    Location: "Floor Plan Level 2",
    Order: "4",
    Summary: "Add a dor to a curtain wall.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "970472",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "uAAAAB+LCAAAAAAABABNjMEKwjAQRP9lz21oKakST6KCoIdSBA+lh1SXdCEmUlehlP67AaN4mzfzmGaCqqPTeEdQcPAd1Xhh7YxFSKDy5PgBqpk+MShpLsVCFuUqLXKxLKWEuf2K62HQY7BDsSV9Q8YBVCayBI7oDPcRas+aybuIZ7r+pj2S6TnCzuLrX9x468Ohe1o7t298909/uAAAAA==",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "03 - Advanced",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=EXLINK_CREATECOLORSCHEME",
    Location: "Floor Plan Level 2",
    Order: "2",
    Summary: "Create a color scheme for a view.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "970476",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "xQAAAB+LCAAAAAAABAA9jMEKgkAURf/lrVUcR8eyVVQQ1EIkaCEuRnvowDQT9gpE/PcmMnf3XM695Qh5rS7DAyGDk61VgQ1J02oED3KrDD0hK8dfdIrPeBAnbOMLFsSR4DBVf2/b93Jwsiv2St6RsIcsDEIPzmha6mYoLElS1nxRxEmaslXEI56uQ+HBVd0W8Yiq7WiGg8b3MnO8s9q6e/PSeqo+xr1IZsUAAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "02 - Intermediate",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=HID_SITE_TOPO_SURFACE",
    Location: "Floor Plans - Site",
    Order: "1",
    Summary: "Create a topographic surface.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "970480",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "xgAAAB+LCAAAAAAABAA9jE0LgkAURf/LW6uMH71JW0UFQS1EghbiYrSHDkwzYVMg4n9vInN3z+XcW46Q1/IyPAgyOJlaFtRYoVtF4EFupLZPyMrxF53iIwYYJunGxzTgyBKYqr+47XsxONsVeynuZKmHjAXMgzPp1nYzFMYKK43+IiYrzsN1FEcxTxl6cJW3RTySbDs7w0HRe5k53hll3L1+KTVVH4R3F8fGAAAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "02 - Intermediate",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=EXLINK_PROPLINES",
    Location: "Floor Plans - Site",
    Order: "5",
    Summary: "Add Property lines to a site plan.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "970482",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABAA9jMEKgkAURf/lrUVGJ8e0VVQQ1EIkaCEupnrog2km7BWI+O9NZO7uuZx7qwGKC536B0IOB3ehEq+sbWMQAigcWX5CXg2/6JU4CjORqJWKQpVJCWP919Zdp3vv+mJL+o6MHeQiFAEc0TbcTlA61kzOflEtkjSNlrGMZZoJFcCZbrO4R2panmBn8D3PPG+ccf7evowZ6w+USFalxAAAAA==",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "02 - Intermediate",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=EXLINK_BUILDINGPAD",
    Location: "Floor Plans - Site",
    Order: "2",
    Summary: "Add a building pad to a toposurface.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "970484",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "xgAAAB+LCAAAAAAABAA9jE0LgkAURf/LW5vMqPnVKioIaiEStBAXUz30wTQT9gpE/O9NZO7uuZx7qwGKC536B0IOB3uhEq+sTKMRPCgsGX5CXg2/6JQ48kUkwtVCysxPAyFhrP/iuutU72xXbEndkbGDXPjCgyOahtsJSsuKyZovxtEySWQahEGYZCL24Ey3WdwjNS1PsNP4nmeON1Zbd29eWo/1B5wOLdnGAAAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "01 - Basic",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=EXLINK_PLACE_PLANTS",
    Location: "Floor Plan - Site",
    Order: "11",
    Summary: "Add plants and entourage to the project.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "970492",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "xQAAAB+LCAAAAAAABAA9jEEKwjAURO/y1yW0miZNXIkKgi5KEVyULlL9pIGYSI1CKb27Qau7ecObqUcoW3Ma7ggSDr41FV6CctoiJFB648IDZD1+Y1QoJTwXYlVkhFLGYWp+2rrv1RDdWGyNumHAHmRK0gSO6HToZqh8UMF4BzIjOU+5YMsF44IWgrEEzub6N/dodBdm2Fl8zbsPb7z18d89rZ2aNwA7BBvFAAAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "01 - Basic",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=EXLINK_ADDING_LEVELS",
    Location: "Elevations - East",
    Order: "1",
    Summary: "Add levels to the project.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "970494",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "xgAAAB+LCAAAAAAABAA9jMEKwjAQRP9lzzXU2iZNPIkKgh5KETxID6kubSAmUlehlP67Qau3ecObOQ9Q1ObY3xEU7H1tSryQdo1FiKDwxtED1Hn4xqCkKROZlMtZIliWcw5j9fNWXaf7IIdiY/QNCTtQMYsjOKBrqJ2g9KTJeAdqzjIRC8kXCRcyzSXnEZzM9W/u0DQtTbC1+Jp2H15768O/e1o7Vm9bjyatxgAAAA==",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "01 - Basic",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=EXLINK_RAILING",
    Location: "Elevation - East",
    Order: "10",
    Summary: "Create a frestanding railing.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "970496",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "xQAAAB+LCAAAAAAABAA9jMEKwjAQRP9lzyW0miYmnkQFQQ+lCB5KD1GXdiEmUqNQSv/doNXbvOHNVAMUZzr2dwQNe3+mEi/BuMYiJFB4cuEBuhq+MSqcM5krtZQZU1nOYax/2qrrTB/dWGzI3DBgBzplaQIHdE1oJyh9MIG8A52xXKZSiflMSMUXSogETnT9mzukpg0TbC2+pt2H1976+O+e1o71G4q7lj3FAAAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "02 - Intermediate",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=EXLINK_LEVELOFFSET",
    Location: "Elevations - East",
    Order: "7",
    Summary: "Offset level head from the level line.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "970498",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "xQAAAB+LCAAAAAAABAA9jMEKwjAQRP9lzyVEbRMTT6KCoIdSBA+lh1SXdiEmUqNQSv/doNXbvOHNlAPkNZ36O4KGg6+pwEswrrEICeSeXHiALodvjEqaMpkptVooJrhQMFY/bd11po9uLLZkbhiwA80ZT+CIrgntBIUPJpB3oGcsk1wqsZgLqdKlEiKBM13/5h6pacMEO4uvaffhjbc+/runtWP1BjTRc6PFAAAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "03 - Advanced",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=EXLINK_SITESETTINGS",
    Location: "Elevation - East",
    Order: "6",
    Summary: "Control the way the site looks in section.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "970500",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "xgAAAB+LCAAAAAAABAA9jEEKwjAURO/y1zXENk1MXIkKgi5KEVxIF6l+2kBMpEahlN7doNXdvOHNnAcoanPs7wgK9r42JV6Cdo1FSKDwxoUHqPPwjVFhjIhcyuWM5YSmPIOx+nmrrtN9lGOxMfqGATtQlNAEDuia0E5Q+qCD8Q7UnOSCCsmzlAvJFpLzBE7m+jd3aJo2TLC1+Jp2H1576+O/e1o7Vm81aqhgxgAAAA==",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "03 - Advanced",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=HDIALOG_REVIT_MODELGRAPHICSSTYLE",
    Location: "Elevations - East",
    Order: "5",
    Summary: "Assign a color gradient as a background.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "970504",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "xQAAAB+LCAAAAAAABAA9jMEKwjAQRP9lzzWktk1sPIkKgh5KETyUHqIubSAmUlehlP67Qau3ecObqQYozubY3xEU7P3ZlHgh7RqLEEHhjaMHqGr4xqDEnMWJTJezjCW5EDDWP23VdboPbig2Rt+QsAPFGY/ggK6hdoLSkybjHaiYZZLLXCRzIfN0Ed4iOJnr39yhaVqaYGvxNe0+vPbWh3/3tHas37XIM7/FAAAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "01 - Basic",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=EXLINK_ROOFS",
    Location: "Sections - Building Section",
    Order: "7",
    Summary: "Create a roof.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "970506",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "xQAAAB+LCAAAAAAABAA9jEEKwjAURO/y1yUktiYmrkQFQRelCC5KF6n9tIGYSI1CKb27Qau7ecObKUfIa3Me7ggKjr42BV6Ddq1FSCD3xoUHqHL8xqgwSlgqsjWTJOWUwVT9tE3f6yG6sdgZfcOAPShKaAIndG3oZih80MF4B4qRpaBC8nTBhcxWkvMELqb5mwc0bRdm2Ft8zbsPb7318d89rZ2qN6v+8yHFAAAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "01 - Basic",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=HID_VIEW_NEW_CALLOUT",
    Location: "Sections - Building Section",
    Order: "13",
    Summary: "Add a callout",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "970508",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "xgAAAB+LCAAAAAAABAA9jEEKwjAURO/y1zUktiZNXIkKgi5KEVyULqJ+2kBMpEahlN7doNXdvOHNVAMUZ3Ps7wgK9v5sSrwE7RqLkEDhjQsPUNXwjVFhlLBUZMtZlhPOqISx/nmrrtN9lGOxMfqGATtQlNAEDuia0E5Q+qCD8Q4UIwtBheTpnAuZ5ZLzBE7m+jd3aJo2TLC1+Jp2H1576+O/e1o71m9DZJ4nxgAAAA==",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "02 - Intermediate",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=EXLINK_COMPOUNDSTRUCTURE",
    Location: "Sections - Building Section",
    Order: "3",
    Summary: "Create an element with compound structure.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "970510",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "xQAAAB+LCAAAAAAABAA9jNEKgjAYhd/lv7axpW66rqKCoC5Egi7Ei1k/Olhb2ApEfPdGWXfnO3znVCMUjT4NdwQJB9foEi9e2dYgRFA4bf0DZDV+Y1AYJSwWyWrBUpLxBKb6p637Xg3BDcVWqxt67EFSQiM4om19N0PpvPLaWZCMpIKKnMdLLvIkyzmP4Kyvf3OPuu38DDuDr3n34Y0zLvzbpzFT/QZNyuRLxQAAAA==",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "03 - Advanced",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=EXLINK_MODIFYOBJECTSTYLES",
    Location: "Sections - Building Section",
    Order: "4",
    Summary: "Control the cut and projected lineweights of elements.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "970518",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "xQAAAB+LCAAAAAAABAA9jMsKwjAQRf9l1qWkD5M2rkQFQRelCC5KF6kd2oGYSI1CKf13g1ZXc8/l3KkmKBo6j3cECUfbUIlXp0ynEQIoLBn3AFlN3+iViIVRItK1vyKLBcz1T9sMgxq964sdqRs6HECykAVwQtO5foHSOuXIGpBRuBJM5DyJucjTLOc8gAu1f/OA1PVugb3G17L78NZq6/+bp9Zz/QZsTSIbxQAAAA==",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "01 - Basic",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=EXLINK_CREATEDETAILVIEW",
    Location: "Sections (Wall Section) - Typ. Wall Section",
    Order: "14",
    Summary: "Create a detail view.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "970526",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABAA9jFELgjAUhf/LfZYxSzddT1FBUA8iQQ/iw6yLXlhb2ApE/O+Nst7Od/jOqUYoGjoNdwQFB9dQiRevbWsQIigcWf8AVY3fGJSYs3gpk5VgWZYmMNU/a933eghqKLakb+ixB8UZj+CItvXdDKXz2pOzoGKWSi5zsVwImSdZLkQEZ7r+zT1S2/kZdgZf8+7DG2dc+LdPY6b6DfwUOJ7EAAAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "01 - Basic",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=EXLINK_VIEW_SCALE",
    Location: "Sections (Wall Section) - Typ. Wall Section",
    Order: "15",
    Summary: "Set the scale of a view.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "970530",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "xQAAAB+LCAAAAAAABAA9jMsKwjAQRf9l1qWkDxMTV6KCoItSBBeli6hDOxATqVEopf9u1Opq7rmcO9UAxYkO/Q1Bwc6dqMSz17YxCBEUjqy/g6qGbwxKwuIkE/nifdNMwlj/tGXX6T64oViTvqLHDhSLWQR7tI1vJyid156cBZXEM8GE5FnKhcznkvMIjnT5m1ukpvUTbAw+p92HV8648N8+jBnrF6bp7KzFAAAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "01 - Basic",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=HControl_Revit_ViewFrameDetaillevel",
    Location: "Sections (Wall Section) -Typ. Wall Section",
    Order: "16",
    Summary: "Specify the detail level of a view",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "970834",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABAA9jEEKwjAURO/y1yUktiZNXIkKgi5KEVyULlL9tIGYSI1CKb27Qau7ecObqUYoGnMa7ggKDr4xJV6Cdq1FSKDwxoUHqGr8xqgwSlgqspUkNMsZTPXPWve9HqIai63RNwzYg6KEJnBE14ZuhtIHHYx3oBhZCiokTxdcyCyXnCdwNte/uUfTdmGGncXXvPvwxlsf/93T2ql+AwdFwarEAAAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "02 - Intermediate",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=HID_OBJECTS_INSULATION",
    Location: "Detail Views - Typ. Wall Roof Connection",
    Order: "9",
    Summary: "Add insulation in a detail view.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "970942",
    Category: "Lines",
    Pbi2DGeometry: "CwEAAB+LCAAAAAAABACtjs0KwjAMx98l51IaHJTNk6gg6GGI4GHssGHZArWRWYUy9u4GNn0Cb/8v8ks1QtnSJT0cFHDklkr2qeMACkqmEJ9QVOMsZYBG48pm61xbtBYm9e+q/mI3w9AkYUuwo+buohugMNooOLnQxX4xZ45NJHl3tle6/aqDo64XBgoBcwV7797LFq3OM4MKtuxZ7oaX91P9AUEfgXELAQAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Design Option": "-1",
    "Detail Line": "Yes",
    Length: "345",
    "Line Style": "<Hidden>",
  },
  {
    ID: "971509",
    Name: "M_Break Line: M_Break Line",
    Category: "Detail Items",
    Level: "-1",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABAA9jMsKwjAURP/lrktIHyYmrkQFQRelCC5KF6le2kBMpEahlP67QaO7OcOZqScoW30a7wgSDq7VFV68sp1BSKB02voHyHr6xqCklKQ5L1aCFBnPYG5+1noY1BjUUGy1uqHHASQlNIEj2s73ESrnldfOgkzJglMuWJ4xLoqlYCyBs77+zT3qrvcRdgZfcffhjTMu/NunMXPzBnv6iNPEAAAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    Cost: "0",
    "Design Option": "-1",
    Family: "M_Break Line",
    "Family and Type": "M_Break Line",
    "Host Id": "-1",
    Image: "<None>",
    "Jag Depth": "51",
    "Jag Width": "76",
    left: "187",
    "Masking depth": "113",
    right: "174",
    "Section Shape": "Not Defined",
    Type: "M_Break Line",
    "Type Id": "M_Break Line",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "971595",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABAA9jEEKwjAURO/y1yWktiZpXIkKgi5KEVyULlL9pIGYSI1CKb27Qau7ecObqUcoW3Ma7ggSDr41FV6CctoiJFB648IDZD1+Y1RSStKM5ytBmGACpuZnrfteDVGNxdaoGwbsQVJCEzii06GbofJBBeMdyJQsOeUFyxaMF7koGEvgbK5/c49Gd2GGncXXvPvwxlsf/93T2ql5A+zfsFjEAAAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "01 - Basic",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=EXLINK_DETAILCOMPONENT",
    Location: "Detail Views - Typ. Wall Roof Connection",
    Order: "17",
    Summary: "Add a detail component to a view.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "971597",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "xQAAAB+LCAAAAAAABAA9jMEKwjAQRP9lz6U0tk1MPIkKgh5KETyUHlJd2oWYSI1CKf13g1ZPO294s9UIRUOn4Y6g4OAaKvHitW0NQgSFI+sfoKrxG4PCkpilIluFmzCZw1T/tHXf6yG4odiSvqHHHlSwIjiibX03Q+m89uQsKBbnIhGSpwsuZLaUnEdwpuvf3CO1nZ9hZ/A17z68ccaF//ZpzFS/AXUh27PFAAAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "01 - Basic",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=EXLINK_DETAILLINES",
    Location: "Detail Views - Typ. Wall Roof Connection",
    Order: "18",
    Summary: "Add detail,ines to a view.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "971895",
    Name: "M_Break Line: M_Break Line",
    Category: "Detail Items",
    Level: "-1",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABAA9jMsKwjAURP/lrktIX0kbV6KCoItSBBeli1QvaSAmUqNQSv/doNXdnOHMNBNUnT6NdwQBB9fpGi9eWmUQIqictv4Bopm+MSgxJXHKs1VBCponMLc/az0McgxqKLZa3tDjAIISGsERrfL9ArXz0mtnQcQk55SXLE0YL7OiZCyCs77+zT1q1fsFdgZfy+7DG2dc+LdPY+b2DaEi5iPEAAAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    Cost: "0",
    "Design Option": "-1",
    Family: "M_Break Line",
    "Family and Type": "M_Break Line",
    "Host Id": "-1",
    Image: "<None>",
    "Jag Depth": "51",
    "Jag Width": "76",
    left: "187",
    "Masking depth": "241",
    right: "174",
    "Section Shape": "Not Defined",
    Type: "M_Break Line",
    "Type Id": "M_Break Line",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "972381",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "tAAAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygxKTS5JzEvPSVXSUQrIz8wrKVayiq6GMIFKDPXMjA2NrA31LIwMLZVqY2GKHIuKEiuBKoECLpmJuaklqUVKVgZ6BjpKPql56SUZUE5QfkliSWZ+HpQbnpkCl/JIzUzPKIFyXHNSy5AVOufn5AMNzCvNyamNBQCFHDVCtAAAAA==",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "02 - Intermediate",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=HControl_Revit_CropRegionBarModify",
    Location: "Sheets - A001",
    Order: "8",
    Summary: "Control the size of a view.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "972385",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "tAAAAB+LCAAAAAAABABNjMEKwjAQRP9lzyUkYDzEk6gg6KEUwUPpIdUlXYiJxFUopf9uwCje5s08pp2g7uk03hEMHGJPDV7YBucRKqgjBX6AaadPzIoSUku1UkIvlhrm7iutU7JjNnOxJXtDxgRGClnBEYPjoUAT2TLFUPBM19+0R3IDF9h5fP2Lm+hjPgxP7+fuDafZEeu0AAAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "02 - Intermediate",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=EXLINK_CREATERENDERING",
    Location: "Sheet - A001",
    Order: "10",
    Summary: "Create renderings.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "972389",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "tAAAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygxKTS5JzEvPSVXSUQrIz8wrKVayiq6GMIFKDPXMjA2NrA30LCwtzJVqY2GKHIuKEiuBKoECLpmJuaklqUVKVgZ6BjpKPql56SUZUE5QfkliSWZ+HpQbnpkCl/JIzUzPKIFyXHNSy5AVOufn5AMNzCvNyamNBQAHby6ytAAAAA==",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "03 - Advanced",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=EXLINK_CHANGEEXTENTS",
    Location: "Sheet - A001",
    Order: "1",
    Summary: "Create a 3d section view.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "972393",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "tAAAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygxKTS5JzEvPSVXSUQrIz8wrKVayiq6GMIFKjPTMDSwsrQ30DEwMTZRqY2GKHIuKEiuBKoECLpmJuaklqUVKVkBVOko+qXnpJRlQTlB+SWJJZn4elBuemQKX8kjNTM8ogXJcc1LLkBU65+fkAw3MK83JqY0FAB1EMt+0AAAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "01 - Basic",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=HID_VIEW_NEW_SHEET",
    Location: "Sheet - A001",
    Order: "21",
    Summary: "Add a sheet to the project.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "972398",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "tAAAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygxKTS5JzEvPSVXSUQrIz8wrKVayiq6GMIFKDPVMLEyMrA31zI0NLJRqY2GKHIuKEiuBKoECLpmJuaklqUVKVgZ6BjpKPql56SUZUE5QfkliSWZ+HpQbnpkCl/JIzUzPKIFyXHNSy5AVOufn5AMNzCvNyamNBQDaO9HLtAAAAA==",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "03 - Advanced",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=EXLINK_USESUNPATH",
    Location: "Sheet - A101",
    Order: "8",
    Summary: "Use the sun path.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "972402",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "tAAAAB+LCAAAAAAABABNjMEKwjAQRP9lzyVEJT3Ek6hQ0EMpgofSQ6pLuhATiatQSv/dgFG8zZt5TDtB3dNpvCNoOISeGryw8dYhFFAH8vwA3U6fmBQpFmpVrqVQqlzC3H2lTYxmTGYqdmRuyBhBSyELOKK3PGRoAhum4DOe6fqbKiQ7cIa9w9e/uA0upEP/dG7u3vSYSTS0AAAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "02 - Intermediate",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=EXLINK_SPACE_SCHED",
    Location: "Sheet - A101",
    Order: "6",
    Summary: "Create a schedule.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "972407",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "swAAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygxKTS5JzEvPSVXSUQrIz8wrKVayiq6GMIFKDPQMzSysDfTMzU0NlWpjYWoci4oSK4EKgQIumYm5qSWpRUpWBnoGOko+qXnpJRlQTlB+SWJJZn4elBuemQKX8kjNTM8ogXJcc1LLkBU65+fkAw3MK83JqY0FAEjuUmCzAAAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "01 - Basic",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=EXLINK_ADD_VIEW_TO_SHEET",
    Location: "Sheet - A102",
    Order: "22",
    Summary: "Add views to a sheet.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "972417",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "swAAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygxKTS5JzEvPSVXSUQrIz8wrKVayiq6GMIFKDPXMjA2NrA31jE0tlGpjYWoci4oSK4EKgQIumYm5qSWpRUpWBnoGOko+qXnpJRlQTlB+SWJJZn4elBuemQKX8kjNTM8ogXJcc1LLkBU65+fkAw3MK83JqY0FAE26u8azAAAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "03 - Advanced",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=EXLINK_RENDEREDEXPOSURE",
    Location: "Sheet - A001",
    Order: "7",
    Summary: "Adjust rendered image exposure.",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "972953",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "xQAAAB+LCAAAAAAABAA9jNEKgjAYhd/lv7axpW65rqKCoC5Egi7Ei2k/Olhb2ApEfPdGWXfnO3znlCPktT4PdwQJR1frAhuvbGsQIsidtv4Bshy/MSiMEhaLZL2IScqZgKn6aZu+V0NwQ7HT6oYee5CU0AhOaFvfzVA4r7x2FiQjqaAi4/GSiyxZZZxHcNHXv3lA3XZ+hr3B17z78NYZF/7t05ipegOQbvJPxQAAAA==",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "01 - Basic",
    "Learning Link": "http://help.autodesk.com/view/RVT/2021/ENU/?contextId=EXLINK_FLOORS",
    Location: "Sections - Building Section",
    Order: "6",
    Summary: "Add floors to the project",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "973780",
    Name: "Help Button: Select for Help Link",
    Category: "Generic Annotations",
    Level: "-1",
    Pbi2DGeometry: "tAAAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygxKTS5JzEvPSVXSUQrIz8wrKVayiq6GMIFKDPTMzUwsrQ30LM0NjZRqY2GKHIuKEiuBKoECLpmJuaklqUVKVgZ6BjpKPql56SUZUE5QfkliSWZ+HpQbnpkCl/JIzUzPKIFyXHNSy5AVOufn5AMNzCvNyamNBQB7RVwitAAAAA==",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Area: "0",
    "Content Reviewed": "No",
    "Design Option": "-1",
    Family: "Select for Help Link",
    "Family and Type": "Select for Help Link",
    "Host Id": "-1",
    "Leader Arrowhead": "None",
    "Learning Level": "01 - Basic",
    Location: "Sheets - A001",
    Order: "0",
    Type: "Select for Help Link",
    "Type Id": "Select for Help Link",
    Volume: "0",
  },
  {
    ID: "976752",
    Name: "Basic Wall: Interior - Partition",
    Category: "Walls",
    Pbi2DGeometry: "DQEAAB+LCAAAAAAABACFjs0KwjAQhN9lz2lI2tSWehIVBD0UETyUHloM6UJMpEahlL67gbb+nLztzDfMbNFDXuOpu0nIYG9rzK3ulDVAILdo3B2yoh9PHxAR5WkcL4OUMp7AQD4oCmnKRfIHCc5+2VfjyMp5eNW2VefXvbHB6iqdbCFjlBE4SKNcM4mjdZVD//Aoz3h5o51E1fiRkC5CkRDYavmcssHsra22vtc8tB7KF8CsKHgNAQAA",
    Pbi3DGeometry:
      "VgQAAB+LCAAAAAAABAClVMkKwjAQ/Zc5pyGp6UI9iQuCHkQFD+KhxaCB2kgNgoj/btS61aYLEloyb2ZeZ14nWZ5hEon5ac8hgJGMxEzGYg0IJlIk6gDB8vzYajdp6wUX9EYsSkj7/tIPXFbPtE6ahiedy2zsO4wiy8eEeohggnKQZWPXZh5qtTBl7hum2CfM+YHLo//iLiguBzFKHthHphEr+PgXnuc14SWamSialmIQuZ6aJj0q+jD1lqNr+GPqilrRYnVNBTNUKnXNCWk2+kXM5fXqA9oT4Y4rnkJwC4MxTzZqmxlTqUIlZJKZC7F+uYZcbLYqM/oxP34GdmUsNSF4g9vS98AVXGnYOFYEAAA=",
    Absorptance: "0.1",
    Area: "2",
    "Assembly Code": "C1010145",
    "Assembly Description": "Partitions - Drywall w/ Metal Stud",
    "Base Constraint": "Foundation",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Coarse Scale Fill Color": "8421504",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Interior - Partition",
    "Family and Type": "Interior - Partition",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Image: "<None>",
    Length: "3161",
    "Location Line": "Wall Centerline",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "Wood - Stud Layer",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.00 /",
    "Thermal Resistance (R)": "0.0000 (·)/",
    "Top Constraint": "Level 1",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "0",
    Type: "Interior - Partition",
    "Type Id": "Interior - Partition",
    "Type Image": "<None>",
    "Unconnected Height": "800",
    Volume: "0.28",
    Width: "120",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "976935",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1",
    Pbi2DGeometry: "xQAAAB+LCAAAAAAABAA9jNEKgjAYhd/lv9axac5cV1FBUBciQRfixayfOVhb2ApEfPdGWXfnO3zn1COUrT4NdwQBB9fqCi9eWmUQIiidtv4Boh6/MSgx4yShbBUzStKMpzA1P2/d93IIcii2Wt7QYw+CEhrBEa3y3QyV89JrZ0EwkuU0L3ia8LxYLIssgrO+/sU9atX5GXYGX/PswxtnXLi3T2Om5g0baTzqxQAAAA==",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Analytic Construction": "<None>",
    Area: "0",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "0",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0",
    Width: "0",
  },
  {
    ID: "976937",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABAA9jMEKwjAQRP9lzzWkraZNPIkKgh5KETxID6kubSAmUlehlP67Qau3ecObOQ9Q1ObY3xEU7H1tSryQdo1FiKDwxtED1Hn4xqDMYsESHi8lS6XIYax+1qrrdB/UUGyMviFhB4ozHsEBXUPtBKUnTcY7UDFbZDyTIk1EJue5FCKCk7n+zR2apqUJthZf0+7Da299+HdPa8fqDcAldYTEAAAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "0",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "976938",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "xgAAAB+LCAAAAAAABAA9jNEKgjAYhd/lv9axaU1dV1FBUBciQRfixayfOVhb2ApEfPdGWXfnO3zn1COUrT4NdwQBB9fqCi9eWmUQIiidtv4Boh6/MSgx4yShbBUzStI8T2Fqft667+UQ5FBstbyhxx4EJTSCI1rluxkq56XXzoJgZJnRrOBpwrNikRecR3DW17+5R606P8PO4GvefXjjjAv/9mnM1LwBVFphQsYAAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "0",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "976939",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zAAAAB+LCAAAAAAABAA1jT0LwjAYhP/LO8eQD9MmdRIVBB1KERxKh1ZDG4iJ1CiU0v9utLrdHc/dlSPkjTkNdw0ZHHxjCn0JtWutBgS5Ny48ICvHWUZkQRPMCF0pLCgTMFV/at339RDRGGxNfdNB95ARTBActWtD9zGUU4ag8KEOxjvIKBYpSVXCWZKqpVQCwdlcZ5YzSRHstWm7+CuxFJIj2Fn9+pW/2xtvffxxT2un6g09pWGwzAAAAA==",
    Pbi3DGeometry:
      "uQMAAB+LCAAAAAAABAClk98LgjAQx/+Xe16yNTSzp6ggqIeooAfpwXDowFzYCET635s/KimXShsbu8/uvhu3nZvB5sT36YWBAytx4jsRcR8QbASP5RUcNyuXahtPVIc7epMBwXhSTGrA/fgMmyaJl6rYAbEMTEdobFCbUIQNjHJELZNomEmG5k9WyjUgrZpt2KZNvw6u4ZpAR6oR/sTayzY79r5Xv6Q0y2ly0gG351/L2lPXAf/znVpftJVqTlI1MOfemUmWgJP7wJrFgQwrYyukJ7mIK/PA/dfWkvEglJWxiNit7jgTkUjyGiyaKrUHso9QL7kDAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "976940",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABAA1jV0LgjAUhv/LuZ5jH6mbXUUFQV2IBF2IF1pDB2sLW4GI/72ZdXfe8z7nPOUIeaPPw0NBBkfX6EJdfW1bowBB7rT1T8jKcRkDEtEEM0LXESU4JlzCVP25Td/XQ4DDYqfru/Kqh4xgguCkbOu7OVBOGYLC+dprZyGjOE5JKhPOklSuhBQcwUXfFpgzQREclG67oBZYxHO9N+r9u/4+3zrjgsi+jJmqD7m40m7PAAAA",
    Pbi3DGeometry:
      "AQQAAB+LCAAAAAAABACtk98LgjAQx/+Xe54yG6bpU1QQ1ENU0EP0oDhqYC5sBBH+703TfsCak3Iou8/3dnfcvO0NFjFbX08UApjxmK14yhJAsOAsE2cItrfHVso4lAsK9CKWg3FYfeQLxa45Nszz6CrPWk7fxsRD0sUmXs9Dvu27PkElJ33X0QsuJgMjoUnxjeszYBsrCmroRwwjqA76QdsKVjp3LOuH/iiDq9tjQrvciF7Qd9WE/vEH1N57O2xJKGdpzKIjFTSHoAwAc5rtxaE2llxEgvGsNjcseUpTyvYHURuTlF7eHUc85Xk5y9UjR/YOW5wp7gEEAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "976942",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1",
    Pbi2DGeometry: "zgAAAB+LCAAAAAAABAA1jU8LgjAchr/L7zzH5tT96RQVBHUQCTqIB62hg7WFrUDE796iur28PA9PPUPZmdN016Dg4DtT6UtoXW81ICi9ceEBqp6/MyIJLXBK6CrhWHBewNL8sfU4tlNk47E17U0HPYIimCA4ateHAVSGuURQ+dAG4x0oinNOuCxYWnCZCZkjOJvrh4yaYAzBXpt+iFmBc5kLBDurXz+ZYMpoimDjrY8h97R2ad4KPQKazgAAAA==",
    Pbi3DGeometry:
      "JQQAAB+LCAAAAAAABACdU8GKwjAQ/Zc5p2GSalvqaVFBWA9lV9hD2UPFoIHaSA0LIv13o3a1pdsmLiEh85J5M8mbSc+QrOXqdBAQw7tay0+Vyw0QSJQs9BHi9HzfmmOcmAEVeSIeQ5zcFjOh+v51eyvL7GR8PRZQHvhj4o3pKOIBQcp8xkkHj2jIwwbMkPLwH3gffwP3R0H0F9Ed7+TTgjs0NnqHuL0PsDC5pzSswMtfZ8GtPzoovHOdDMbsU/fVsnKuTrewLuJaRGmFMP02k9leaFFCjBQJLEWx1bva+FA601IVtfklN4+jhZDbna6NeS5+mhenKlfltd8xwum1rS/9AW02JQQAAA==",
    "Analytic Construction": "<None>",
    Area: "4",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2620",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.1",
    Width: "1460",
  },
  {
    ID: "976944",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1",
    Pbi2DGeometry: "zgAAAB+LCAAAAAAABAA1jUELgjAYhv/Ld55jc865dYoKgjqIBB3Eg9bQwdrCViDif29R3V5enoennqHszGm6a1Bw8J2p9CW0rrcaEJTeuPAAVc/fGZGE5jgldJWkWPKcwdL8sfU4tlNk47E17U0HPYIimCA4ateHAVSGhURQ+dAG4x0oirkgQuYszYXMCskRnM31Q0atYAzBXpt+iNkCc8kLBDurXz+ZYMpoimDjrY8h97R2ad6aqZI/zgAAAA==",
    Pbi3DGeometry:
      "EwQAAB+LCAAAAAAABACVU1FrgzAQ/i/3HMPFqBV9Gm4wWB9KN+hD2YPS0AacGS4URPrfm66utThjJCTkvuS+O+6727awKuRH8y0ggTdVyHdVyh0QWClZ6R9Itu31ap4xNQtO5I54DDH9PcyG0+ef21Nd543x9VhE/YiHxEMaRowTpIwznwzwmC78RQ8OKQ9ZMBMeI+/hPIjif2iu8CCXB3jAMsE+HXUseTuNezr2ys8t2gQ+WUyr3s7tYY05ouu8ZnLtSJeQDqLaxejTm+l6lvmX0KKGBCkSWIpqrw+dsVY611JVnbmRu9vTq5D7g+6Ml1Ic+x8zVar6Mt0YY3YZ4jNR2SGmEwQAAA==",
    "Analytic Construction": "<None>",
    Area: "4",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2620",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.1",
    Width: "1460",
  },
  {
    ID: "976946",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1",
    Pbi2DGeometry: "zQAAAB+LCAAAAAAABAA1jcsKwjAUBf/lrmNI+kziSlQQdFGK4KJ0EfXSBmIiNQql9N+NqLvDYYZpJqjO5jjeERTs/dnUeAnadRaBQOWNCw9QzfSdEVnwgiaMLzmVRSZhbv/Uahj0GNF4bIy+YcABFKOMwAFdF3pQGS0lgdoHHYx3oDjNS1bKIk2KUmZC5gRO5vohoybSlMAOTdfHqqC5zAWBrcXXT2aUpzwhsPbWx5B7Wju3bzHBrNPNAAAA",
    Pbi3DGeometry:
      "AQQAAB+LCAAAAAAABACVU02LwjAQ/S9zTsOkaWutJ3EXhN2DrIIH8VAxaKA20g0LRfzvG7Vq/WiaEhIyL5k3w7yZxQEmKzkr9wIS+FIrOVWZXAOBiZK5/oVkcbhczTMOzIIjuSMeQxycD7PhuLy6DYsiLY2vxyLqRzwkAeVhv0+QMs588gzHtOf37qiHNODIOsIN3DWYB1H8huUMv2RSR585WqjbQzYlbqVxTsZW8Y7VssNtNbRo7NoQlnANSnbrHtcOdInoIKRVgwd6M0sfMt0JLQpIkCKBb5Fv9LYyfpROtVR5Zc7l+vY0FnKz1ZXxmYm/+seRylRxmmWMcXQa2X96FvH6AQQAAA==",
    "Analytic Construction": "<None>",
    Area: "4",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2620",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.1",
    Width: "1460",
  },
  {
    ID: "976953",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "xgAAAB+LCAAAAAAABAA9jNEKgjAYhd/lv9axaU1dV1FBUBciQRfixayfOVhb2ApEfPdGWXfnO3zn1COUrT4NdwQBB9fqCi9eWmUQIiidtv4Boh6/MSgx4yShbBUzStI8T2Fqft667+UQ5FBstbyhxx4EJTSCI1rluxkq56XXzoJgZJnRrOBpwrNikRecR3DW17+5R606P8PO4GvefXjjjAv/9mnM1LwBVFphQsYAAAA=",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "0",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "976954",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABFjUELgjAcxb/L/zzHNnWbdooKgjqIBB3Eg9bQwdrCViDid29h0e29x+/HqyYoWn0a7wpyOLhWl+riG9sZBQgKp61/QF5NSwxIRDlmhK6iFCeScZjrH7YehmYMbBi2urkprwbICSYIjsp2vv8UGlOGoHS+8dpZyClOBREZjxkXWSIzzhGc9XWBYyYpgr3SXe//8s6o19eWWDCBYOOMC1f2acxcvwFLrWqi0AAAAA==",
    Pbi3DGeometry:
      "EwQAAB+LCAAAAAAABACdU8sKwjAQ/Jc9pyFt7YN6EhUEPRQVPBQPFYMN1EZqEErpvxtrfaEx0YSE7Gx2smxmkxriDVtWBwoRTPmGLXjOtoAg5qwQR4iS+nqUbtKXExr0QCybkH67yQXN+hY2KMu0krGW7WPiBsjycC90fBTiwJGWRF3fs/Vw6IXuV/yVXAG/ktsEO8En9ofjFtDS/Asr2Y2SV13/LZu3EvxULwWzqlrfcU0qRrrQv6kvuqHCzASp/yUz3EjwsrtGLN1TQUuICCYIZrTYiawz5lykgvGiM1dse3dNKNtlojPGOT09XxzynJeX7m6HbOIzUcMguhMEAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "976955",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABFjcsKwjAURP/lrtOQh03auhIVBF2UIrgoXUQNbSAmUqNQSv/dSBV3M8M5TD1CeTbH4a6hgL0/m0pfgnKt1YCg9MaFBxT1OMeIJFRgRugyITgVlMPU/LBV36shsnHYGHXTQfdQEEwQHLRrQ/cplFOGoPJBBeMdFBSnkshccCZkvshyIRCczHWGOcsogp02bRf+8tbq19fOsGQSwdpbH6/c09qpeQMqUHdl0AAAAA==",
    Pbi3DGeometry:
      "AQQAAB+LCAAAAAAABACdk98LwiAQx/+Xe3aimdtYT1FBUA9RQQ+jh0VSwpqxJIjY/56trR/U0nI4dh/Pr+ftLj7DZCXnp72ACEZqJWcqlWtAMFEy0weI4vPt0yyTjnmgQA/iUUI65ctMKJb1tm6eJyez16M+JixAHsHcpwyFOGgZy1Dmc2rHIQ/ZV/4q3oBfxTlmnLbfxe+8di9F/qJNyk5hN3j/EsjbzX9K02fhhiR9xZY4nGrBdqI1144l5VaBtp/jhJ3K2/RSXyY7oUUOEcEEwVhkG72tjKnSiZYqq8yFXN+XhkJutroyBqk4Pjv2VKryay+Xw7TsBZi2cmcBBAAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "976956",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABABFjbEKwjAYhN/ln9OQpJq0cRIVBB1KERxKh6ihDcREahRK6bsbreJ2d3x3Vw1QnMyhv2mQsPMnU+pzUK6xGhAU3rhwB1kNk4xIQjlmhC4SSjATjMNY/7hl16k+wjFYG3XVQXcgCSYI9to1oX0bmlKGoPRBBeMdSIrngoicp4yLfJblnCM4mssEpyyjCLbaNG34lzdWP7/tz/jKWx+P3MPasX4BOAtAys8AAAA=",
    Pbi3DGeometry:
      "7wMAAB+LCAAAAAAABACdU1ELwiAQ/i/3bEO3tmJ7igqCeogKehg9LCYlrBkmwYj+e26tFbVNl6J4331+6nkX3mC5Z5vsTMGHOd+zNU9YDAiWnKXyAn54ey6VGweqwx29kR7BOCgmNeC+e20bCRFlam+PeBZ2BkhRLHtgewhbxCE2ynHHc4mRA7egX+K14Jewa/WHP7oVWJELkT/hWmXdheuI3c6veXKn+DRoN0WoHddfxjQTtCe3hNssl4xSr/V/NJg2mVXlTFh0opIK8HMWLGh6kMfSWHEZScbT0tyyuHLNKDscZWlME3r9JI55wkVeuUVTBfoA6+UUnu8DAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "976957",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zgAAAB+LCAAAAAAABABFjcsKwjAURP/lrtOQR5s+XIkKgi5KEVyULqKGNhATqVEopf9utIq7meHMTD1CedKH4aaggJ076UqdvbStUYCgdNr6OxT1OMuARFRgRugiSjBPaAxT88OWfS+HwIZgreVVedVDQTBBsFe29d3bUE4Zgsp56bWzUFCcpCTNBWcizeMsFwLBUV9mmLOMItgq3Xb+X94Y9fy2P+MrZ1w4sg9jpuYFG5HuJc4AAAA=",
    Pbi3DGeometry:
      "3QMAAB+LCAAAAAAABACdk1ELgjAQx7/LPU/ZWhrYU1QQ1INU0EP0YDR0YC5sBCJ996aZlanTNibeb7f/ttvdPgX3yLfJhYEDS3HkGxHyEyBwBY/kFZx9+vxV03isOtzRmxgE43H+UQPuh9eySRx7iVprENvEdIQMy6QWGSJsEkoGKMPUtkgHjpvht3Adq4hi07IJrYiWsHTONf7Etcqa49b59dv+98I9YtMg3BSddq47Scfn127bEucuCdQl21qfRcM06avqZMa9M5MsBidzghWLfBkUxlpIT3IRFeaOn8qpBeN+IAtjHrLbp+NUhCLO6jRvqhwfhOaZhN0DAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "976958",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zgAAAB+LCAAAAAAABABFjcsKwjAURP/lrtOQR00frkQFQRelCC5KF6mGNhATqVEopf9utIq7meHMTDVC0ejjcFOQw941ulRnL21rFCAonLb+Dnk1zjIgERWYEbqMCI45oTDVP2zV93IIbAg2Wl6VVz3kBBMEB2Vb370N5ZQhKJ2XXjsLOcWLhCSZ4EwkWZxmQiA46csMc5ZSBDul287/y1ujnt/2Z3ztjAtH9mHMVL8AFcHuRc4AAAA=",
    Pbi3DGeometry:
      "ywMAAB+LCAAAAAAABACdk98LgjAQx/+Xe56yNTXSp6ggqIeooIfoQWnkwFzYCET635tmljB/tTHxPrt9t93ujhlsAr5PbwxcWImA70TEz4BgI3gs7+Aes/evmsae6vBEX2IQjL3iowY8T59l0yTxU7XWII6J6RgZ2LQoJgibhJIRyjF1bNKD42ZYF9axuqhlUnsyqWtWrHLNFf6iOtX2g2rchuysueeAkOh1G4LShjuP0e/JuzZtDm+fjOmRXm2v0Yq6klVVxZz7VyZZAm7uBGsWX2RYGlshfclFXJoHfq6mloxfQlkai4g9fh1nIhJJXpVFU8X3AjlHEvLLAwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "976959",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zgAAAB+LCAAAAAAABAA1jT0LwjAYhP/LO6chH7ZN4yQqCDqUIjiUDlFDG4iJ1CiU0v9utLrdHc/d1SOUZ3Mc7hok7P3ZVPoSlGutBgSlNy48QNbjLCOS0AwzQpcJJZhzwWBq/tyq79UQ4RhsjLrpoHuQBBMEB+3a0H0M5ZQhqHxQwXgHkuI0J3mRcZblxUIUKYKTuc4sZ4Ii2GnTdvFZYJEKjmBr9etX/m6vvfXxxz2tnZo339Kmuc4AAAA=",
    Pbi3DGeometry:
      "AQQAAB+LCAAAAAAABAClU1sLgjAU/i/necrMvKRPUUFQD1JBD9KD4qiBubARSPTfm6bdcLZqY2Pn+86Nc3bCMwQxXRUHAh7MWEyXLKUJIAgYzfgRvPB8ewoa+2LDBT0QzcDYry5x4LJpzIZ5HhXCVjNsHZsOEip6H5sDhHWMStC0LaMD7Tk9+wPauG0FO7y6umu5ZksST8SLmy9waYB3ojN5mfJPWX5fLplbabUUCbUedaAqhVUk/v+GCt1XwqUxxSyNabQnnOTglVowJ9mW72phwXjEKctqcU2TOzUldLvjtTBJyelZccRSlpezXC0xsldrolteAQQAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "976960",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zAAAAB+LCAAAAAAABAA1jUELgjAcxb/L/zyHc06nnaKCoA4iQQfxoPVHB2sLW4GI372VdXvv8XvvVRMUrTqNd4QcDrZVJV5cYzqNQKCwyrgH5NW0SI8ELKFRyFaBoDFLYa7/1HoYmtGjPtiq5oYOB8hDGhI4oulc/zGMs4hAaV3jlDWQMyrSMM0SHiVpFstMEDir68LySDICe1Rd738llUJyAjuNr1/5u72x2vof89R6rt+6BTu4zAAAAA==",
    Pbi3DGeometry:
      "3QMAAB+LCAAAAAAABAClk1ELwiAQx7/LPbvhsq2xPUUFQT1EBT2MHhaTJawZS4Ix+u65ZTUqy0pRvN+df+X0ogpmG7Ys9xQCmPANW/CMJYBgxlkuDhBE1WUp3TiUHU7oTiwH47CZ5IDT+rqtXxRxKfdajmdj0kOWa3f9joewjVHNiOc6Wkhcp/seKslXTK/o277rk+fjW7ytYYx14o/8zaU1oT9c79sMaSR1CTLiJi+ihwaZNOJ/frXP72yAdcfJOhmyeEcFLSCog2BK81RslTHnIhaM58pcseTmGlOWboUyRhk9tgMHPONFXadNk+V4BhftNDXdAwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "976961",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zQAAAB+LCAAAAAAABAA1jUELgjAcxb/L/zzHNp1udooKgjqIBB3Eg9bQwdrCViDid29l3d57/N571QRFq0/jXUEOB9fqUl18YzujAEHhtPUPyKtpkQGJaIoZoauI4ETyDOb6j62HoRkDG4Ktbm7KqwFyggmCo7Kd7z+GxpQhKJ1vvHYWcop5RjKZxizNZCIkR3DW14WNmaAI9kp3fTgWWHARI9gZ9fqVv9sbZ1z4sU9j5voNf40qd80AAAA=",
    Pbi3DGeometry:
      "3QMAAB+LCAAAAAAABAClk1ELwiAQx7/LPTtRbGusp6ggqIeooIfoYZGUsGaYBGPsu+fWqlFZVori/e78K6e3zGGyFvPswCGCkVyLmUzEBhBMpEj1EaJlflkaN+mYDgW6E48S0qkmM6BYXbd1lYozs9ejASasjTyC/YAyRDBBJWOBT62wxQh9D2vJV8yuGOLQD9nz8Q3e1HDGNvFH/ubSltAfrvdthiyStgQ5cZcXsUOHTDrxP7/a53d2wLbjTJ30RbznmiuIyiAY83Srd7UxlTrWQqa1uRCbm2vIxXana2OQ8FMzsCcTqco6rZopxzNEWpRE3QMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977133",
    Name: "Basic Wall: Cavity wall_sliders",
    Category: "Walls",
    Pbi2DGeometry:
      "FAEAAB+LCAAAAAAABACFjsELgjAYxf+X7zzHNnVNO0UFQR0kgg7iQWnoYG1hKxDxf2+gJp26fe/7Pd57eQ9ZpS7dQ0IKR1upzOqutgYQZFYZ94Q078fTG1iIKU/oOqAUR4xxGNACQ4YFjVb/IMExCZMfuMTOsJjrN21bdn6Df+xUeZdOtpASTBCcpKldM4mzdaVTfvYor+r2RQep6sa3+GzBuECw1/I9mQOKEy5iBFurrQ82L62H4gNl3sSYFAEAAA==",
    Pbi3DGeometry:
      "5wYAAB+LCAAAAAAABACVVd9LwzAQ/l/uuQtpk9a0exKdCPowVPBh+NCxsAW6RmoQxtj/bqatnU3TnISW5H58311yl6yOsFyrl8O7hAIe9Fo960ptIIKlVrX5gGJ1/JlaNZ3bAaeol8xiSuffP/vB6a1zu26a8mB9WUK4YDyaxTHhSZLZCRGUp5GjEESkgkUJI3GWx72cEuoaW5Q8EyMoHbwD03k4in/xThl7KRFBUpJSlg9gWmHHya1Tkrvyob2b6QV6H8vA2qsYDzIljPPMCcaPgnXosvLYj0cT3Jq/x+c9Vh9pMHgfPi4eL68vL2wphHjDTYKtEoQi1Ij4DsWUxLRwqm1xPT7FFdxGfO6+229wh4ZOI9Se+GsaTxHouZbBvhi3qtxLIxsoztnCo6y3ZtcunrQpjdJ1u3xVm1/VvVTbnWkXi0p+Xhre6EpbQLi6Ow/7MH0BE9qiyucGAAA=",
    Absorptance: "0.1",
    Area: "9",
    "Assembly Code": "C1010145",
    "Assembly Description": "Partitions - Drywall w/ Metal Stud",
    "Base Constraint": "Level 1",
    "Base Extension Distance": "0",
    "Base is Attached": "No",
    "Base Offset": "-600",
    "Coarse Scale Fill Color": "8421504",
    "Coarse Scale Fill Pattern": "<Solid fill>",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "Cavity wall_sliders",
    "Family and Type": "Cavity wall_sliders",
    Function: "Interior",
    "Heat Transfer Coefficient (U)": "0.0962 /(·)",
    Image: "<None>",
    Length: "2940",
    "Location Line": "Finish Face: Exterior",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Roughness: "1",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Thermal Mass": "0.03 /",
    "Thermal Resistance (R)": "10.4000 (·)/",
    "Top Constraint": "Level 2",
    "Top Extension Distance": "0",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "Cavity wall_sliders",
    "Type Id": "Cavity wall_sliders",
    "Type Image": "<None>",
    "Unconnected Height": "3300",
    Volume: "2.62",
    Width: "280",
    "Wrapping at Ends": "None",
    "Wrapping at Inserts": "Do not wrap",
  },
  {
    ID: "977136",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "977137",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "977138",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "977139",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "977182",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1",
    Pbi2DGeometry:
      "1gAAAB+LCAAAAAAABAA1jcsKwjAURP/lrtOQePtI40q0IOiiFMFF6aLV0AZiIjUKpfTfjai7YThnpp6h7PRpuiuQcHCdrtTFt7Y3CgiUTlv/AFnP3xiQiCMVGeI64owmDHNYmj+4Gcd2CnQodrq9Ka9GkIwyAkdlez+AjCnmSKByvvXaWZBIeSyESNM45ikiZlkR8YTAWV8/fJAFBmGvdD+Ee0GTPBEECqNevwVGOfIVga0zLtzZpzFL8wZ8CuKR1gAAAA==",
    Pbi3DGeometry:
      "NwQAAB+LCAAAAAAABACdVF0LwiAU/S/32eTah1vrKSoI6iEq6CF62EhKWDOWBBH991yttT62XIjiucfr0XuvLs8wCeT8tBfgwUgFcqZCuQYCEyUjfQBveb5PDY0d0+BCnpYaQ+zcBtPhsnq4dePYPxnfGmOUO9whZg3lzbZLkLIGq5NPwqVOPYGcIjfwb3uhQEbkPFqcN7Odcg6l9m8Kr8S7wk/pwksU7lT9UDbxsIygtXiF0L4ktXLVFAlYBLw0Eb8OalGVpbqVSqY8bTcJ8wL70t8JLWLwkCKBsYg2epuCqdK+lipK4UKuM2oo5GarUzAIxTG/sKdCFSc/ALrYSx76FaJHuHs3BAAA",
    "Analytic Construction": "<None>",
    Area: "4",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2620",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.09",
    Width: "1339",
  },
  {
    ID: "977191",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1",
    Pbi2DGeometry:
      "1AAAAB+LCAAAAAAABAA1jUELgjAcxb/L/zzH1jad6xQlBHUQCTqIB62hg7WFrUDE796iuj0ev/d+9QxlZ07TXYOCg+9MpS+hdb3VgKD0xoUHqHr+xogkOaaCiHVCCRaE5bA0f24zju0U4VjsTHvTQY+gCCYIjtr1YQDFcZYjqHxog/EOFMOUSynTlHOaMsayrEioQHA21w8et5IxBHtt+iHKJRa5kAgKq1+/B4IpoysEW299tLmntUvzBl/VUYHUAAAA",
    Pbi3DGeometry:
      "JQQAAB+LCAAAAAAABAClU1ELgjAQ/i/3vMYsp6ZPUUFQD1FBD9GD0aiBubARiPTfm6ZllGsSY2P37e677dvdJoP5jq/SMwMfpmLHlyLie0AwFzyWF/A32WOrjkmgBtzQC+lYhATFoibctlXYIEnCVMV2HOxSSpFywY7d9xDBVs/qog/cw27XVaaFqf0P3sRf4fUA6jh2RVTz18Ff6N/wD/pfeRsf0MjU9komShhJZ5rYWNH6R7askwZyE5W16usvaVKF2rStykT/W0UK1W8jHp6YZAn4BBMEMxYf5LE0FkKGkou4NNd8/zyaMH44ytIYR+xadxyKSCR5vxOPDPO2vgOKScNjJQQAAA==",
    "Analytic Construction": "<None>",
    Area: "4",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2620",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.1",
    Width: "1460",
  },
  {
    ID: "977193",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1",
    Pbi2DGeometry:
      "1AAAAB+LCAAAAAAABAA1jUELgjAcxb/L/zzH5jad6xQlBHUQCTqIB6uhg7WFrUDE796iuj0ev/d+zQzV2RynuwYFe382tb6EzvVWA4LKGxceoJr5GyOScJymRbpKKMGCsAKW9s+tx7GbIhyLreluOugRFMEEwUG7PgygOM4LBLUPXTDegWKYcilllnFOM8ZYnpcJFQhO5vrB41YyhmCnTT9EucSiEBJBafXr90AwZTRFsPHWR5t7Wru0b5vhkdHUAAAA",
    Pbi3DGeometry:
      "EwQAAB+LCAAAAAAABACdU1ELgjAQ/i/3PMc0m2ZPUUFQD1FBD9KD0qiBubARRPTfm6ZlklNjbOy+3X13fLvz77AM+eZ2ZuDBXIR8LSK+BwRLwWN5Ac+/v67qmQzVggf6IIZJyDA71IbHrggbJUlwU7GGid2ebSHlgqk9cBHBZs9M7QruYsdykEExtf6H68gLvOTfp9QuaEruOvgH+xdeZW/IWld8HU3XclqI0Eq0tnlbi1n+wY7tUUPerLBOeH2Fza2nS9mhN7SflNGr6Zrw4MQkS8AjmCBYsPggj7mxEjKQXMS5ueX799OM8cNR5sY0Ytey41hEIkmnm7hknA7xE7cJwf0TBAAA",
    "Analytic Construction": "<None>",
    Area: "4",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2620",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.1",
    Width: "1460",
  },
  {
    ID: "977195",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1",
    Pbi2DGeometry:
      "0gAAAB+LCAAAAAAABAA1jUELgjAcxb/L/7zG5nRu6xQlBHUQCTqIB62hg7WFrUDE796iuj0ev/d+9QxlZ07TXYOCg+9MpS+hdb3VgKD0xoUHqHr+xogQzGWyXlGCM8IkLM2f2oxjO0U0FjvT3nTQIyiCCYKjdn0YQKU4lwgqH9pgvAPFME2FEJynKeWMsTwvVjRDcDbXDx63gjEEe236IaoFzmQmEBRWv34PBFNGEwRbb320uae1S/MGzF4VUtIAAAA=",
    Pbi3DGeometry:
      "3QMAAB+LCAAAAAAABACdU8EKwjAM/Zeca8k23eY8iQqCHkQFD+JhYtHCXGUWQcR/t9Pqhm7dJqWleUle0qRZ32C25cvriUEAE7HlCxHxHRCYCR7LMwTr2+uq1NhTC+4kQ1oWYu95qA33zdutnyThVfk6FH2PKAPqtrs+QWo5lk2+UJ96dipSD53/0GJejeaMO67b1hSZbTn4Q5tHv2mN0UoSLuFokkblm6sLVCtcrarlWtSg84WklXU0VNeQVuV/MgSr3XhTJ57Uak6GPDwyyRIIkCKBKYv38qCFuZCh5CLW4orvPqox4/uD1MIoYpe84UBEIknnFH0cpOP4AFN14oTdAwAA",
    "Analytic Construction": "<None>",
    Area: "4",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2620",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.1",
    Width: "1460",
  },
  {
    ID: "977197",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1",
    Pbi2DGeometry:
      "0wAAAB+LCAAAAAAABAA1jUEKwjAURO/y1zEk/iZN40q0IOiiiOBCXEQNbSAmUqNQinc3ou6G4c28wwjNye2GmwUN63hyW3tOJrTeAoEmupDuoA/jN2ZEUMkRZxPOqGBYwev4x+Z9b4bM5mLpzNUm24NmlBHY2NCmDnRBy4rANiaTXAygkfJCKSVlUXCJiGVZT7ggsHeXD563CpHAyrq2y25FRSUUgdrb5++BUY58SmARfcy28PD+dXwDYVpRAdMAAAA=",
    Pbi3DGeometry:
      "7wMAAB+LCAAAAAAABACdU80KwjAMfpeca8k2nXWeRAVBD6KCB/GwYdHCXGUWQcR3t2rVoq6bUlqar8mXND+LE4wTMTvuOEQwlImYylSsgMBYikztIVqc7lf9jG294ExeSM1DbN8OveG8fJh18jw+altGEVlAtAYN6y1GkHqB55N3mNGm3yQB9b1/0QJiA1vajTCsGw5L2YF+MtvwO7PTYUHQBRy/BVL+8wp5quiyYvqscv3UB9+JS1PqSLQrtNL+cnir3ASuktyo9eT0RLzliucQIUUCI56t1cYIE6liJWRmxLlYPZ8GXKw3ygj9lB9sxa5MZX6dXGTYvQ7oBaTDDB3vAwAA",
    "Analytic Construction": "<None>",
    Area: "4",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2620",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.1",
    Width: "1460",
  },
  {
    ID: "977199",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1",
    Pbi2DGeometry:
      "1AAAAB+LCAAAAAAABAA1jUEKwjAURO/y12lI/GmaxpWoIOhCRHBRuogaaiAmUqMgxbubou4ew5uZZoDt0e1fNwsa1vHodvaUTOi8BQLb6EK6g26GL2aFM1qikNNiBIY1vNu/N+t788pyDhbOXG2yPWhGGYGNDV26gBa0qgnsYjLJxQAaKRdKKSmF4BIRq2pZ8JLAwZ1HPXcVIoGVdd0lnyta1qUisPT2+VtglCOfEJhHH/NbeHj/bj8ouBjB1AAAAA==",
    Pbi3DGeometry:
      "AQQAAB+LCAAAAAAABACdU80KAiEQfpc5m+hubftzigqCOkQFHaLDRlLCtsYmQSz77llZSbVmIYrzzfjNOD+LEsYrPjvtGcQwFCs+FRlfA4Kx4Lk8QLwob1elJolaUKEn0qCEJNdDbaiW92edokhP6i31cORFAVImOGhGISKY+tRDb3iI215bndSPWv+hdcwaN8xbQdDUJKa1Df5AbuKv5FafNYHXcPwaisP/XdLl7NY5j0bpfuyKGvKv2bXk3Bre136zuHNuCFttrtRqlno83THJCogJJghGLN/IrRYmQqaSi1yLc75+qAaMb7ZSC/2MHU3DrshEcZllEpLuZWTPPBmB5wEEAAA=",
    "Analytic Construction": "<None>",
    Area: "4",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2620",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.1",
    Width: "1460",
  },
  {
    ID: "977201",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1",
    Pbi2DGeometry:
      "1AAAAB+LCAAAAAAABAA1jUELgjAcxb/L/zzH1jad6xQlBHUQCTqIB62hg7WFrUDE796iuj0ev/d+9QxlZ07TXYOCg+9MpS+hdb3VgKD0xoUHqHr+xohQgbkQcp1QggVhOSzNn9uMYztFOBY709500CMoggmCo3Z9GEBxnOUIKh/aYLwDxTDlUso05ZymjLEsKxIqEJzN9YPHrWQMwV6bfohyiUUuJILC6tfvgWDK6ArB1lsfbe5p7dK8Acmk7+7UAAAA",
    Pbi3DGeometry:
      "EwQAAB+LCAAAAAAABACdU00LwjAM/S8515L6sdV5EhUEPYgKHsTDhkULc5VZBBH/u1U3nR/rNiktzWvyEl6T5RkmgZyf9gI8GKlAzlQo10BgomSkD+Atz4+recaOWXAhL6TGEDv3w2y4rNKwbhz7JxPLXMpbyIlxoU6zzQlS1mB18oVz6tZdwhoUnf/hPPIUz/i3HKeZ0mTcbfAP9jf8k70ga17xeTRVyykhQinRyuYtLWb2Byu2Rw55scI24e0VFreeLWWF3rB+0p3eTFdf+juhRQweUiQwFtFGbxNjqrSvpYoScyHXz6ehkJutToxBKI5Zx54KVXybbuTYuw3xFaPdqCATBAAA",
    "Analytic Construction": "<None>",
    Area: "4",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2620",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.1",
    Width: "1460",
  },
  {
    ID: "977203",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1",
    Pbi2DGeometry:
      "1QAAAB+LCAAAAAAABAA1jssKwjAURP/lrmNIevtI40q0IOiiFMFF6aLV0AZiIjUKpfTfjai7YTjzqGcoO32a7gokHFynK3Xxre2NAgKl09Y/QNbzVwYkYpRnIl2vOKMJwxyW5s9txrGdAhyMnW5vyqsRJKOMwFHZ3g8gY4o5Eqicb712FiRSHgsh0jSOeYqIWVaseELgrK8fPoQFhsBe6X4I64ImeSIIFEa9fg3hDvKIwNYZF+bs05ileQPo5jJ31QAAAA==",
    Pbi3DGeometry:
      "EwQAAB+LCAAAAAAABACdU1ELwiAQ/i/3bKK2trWeYgVBPUQFPUQPG0kJa8aSIKL/npWVUBMXonifd98dn3erC0xzsTgfOCQwlrmYy0JsAMFUilIdIVldnlf9THp6wRV9kBYlpPc49Ibr+hXWr6rsrGMZw+2oQ5F2wWHQjRHBtE0Z+sJjHLEI0Qh3Y/Y3XEducNu/E4aBobHdXfAPdhv/YndnrSu+jqZpOT4i+IjmnddbTOsHG7ZHDbmHwi7hnRV6tJ4rZYPecH7Sg15P10Bke654BQnBBMGEl1u1M8ZMqkwJWRpzKTbvpxEX250yxrDgJ9sxlYWs7tNNYpLeh/gG8i4x2RMEAAA=",
    "Analytic Construction": "<None>",
    Area: "4",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2620",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.09",
    Width: "1339",
  },
  {
    ID: "977247",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "1AAAAB+LCAAAAAAABAA1jVELgjAUhf/LfZ7D63Que4oSgnoQCXoQH7SGDtYWtgIR/3sr6+2ey3fOV01QtOo03iVkcLCtKuXFNabTEggUVhn3gKyaltMjASLliLgOMKRJyFYw139wMwzN6Gn/2KnmJp0cIAtpSOAoTef6T0CGEYHSusYpayBjFGMhBOdxjJwxlqZ5gAmBs7ouBRYJJLCXquu9X1CRCEYg1/L1W/gKtlZbLzNPref6DVZDYZvUAAAA",
    Pbi3DGeometry:
      "AQQAAB+LCAAAAAAABAClU1ELgjAQ/i/3PGVimtpTVBDUg1TQQ/RgNHRgLmwEIv33pplpTG20sbH77u6743Z3yME/0V12JeDBip3olsX0DAh8RhN+A++Qv55CjSdiwwN9EM3AeFJe4sDj+HabpmmQCV/NMHR7bI+RsNFt20FYx6gFmqbr1qg1sixlVErbBNv+ju5YjilJQqYoaH7AW7nI8O8A0uS7WFSz6S/CYLkGadXL2Po4hX7oZB4ubL/i/zZU+f0+vDOmmKU5DS6EkxS8wgrWJAl5VAkbxgNOWVKJe3quVUtCw4hXwiIm96bhjMUsLWa5XGJkn7/T3O4BBAAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977248",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jVELgjAUhf/LfZ5jczqnPUUJQT2IBD2ID6uGDtYWtgIR/3sr6+2ey3fO10xQnfVxvCsoYO/OulYXL21nFCConLb+AUUzLWdAIo65yPNVRAlOCcthbv/cehjkGODw2Gp5U14NUBBMEByU7Xz/CZTRGEHtvPTaWSgYpokQgvMkoZwxlmVlRFMEJ31dCiwWFMFO6a4PeoFFKhiC0qjXb+Er2Djjgsw+jZnbN1EkXIPTAAAA",
    Pbi3DGeometry:
      "3QMAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzOz8lMUdJRCsjPzCspVrKKroYwgdIG1kCoVKuDENE1NDCwBhNArFQbC9PmWFSUWAnUq2umZ25qaqoDVKJnZmahY6BnoIMsZmxsaQkTNDMyMSJREJuRSGKomi30LEwtjDGtxyIOMoOgMIorsAijGY7N0TiMIM0deH1OIIQIGUlqwCHHEtERj8tUgiGJV5zCpEZ8POMRxmUdMJ+4ZCbmppakFilZgRQp+aTmpZdkQDlB+SWJJZn5eVBueGYKXMojNTM9owTKcc1JLUNW6Jyfk18EyqdgAMyOAO2B+jPdAwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977249",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jVELgjAUhf/LfZ5jczqXPUUJQT2IBD2ID7OGDtYWtgIR/3sr6+2ey3fOV09Qtvo03hXkcHCtrtTFS9sZBQhKp61/QF5PyxmQiOKMC76OKMEpYSuYmz+3GQY5Bjg8dlrelFcD5AQTBEdlO99/AmU0RlA5L712FnKGaSKE4DxJKGeMZVkR0RTBWV+XAosFRbBXuuuDXmCRCoagMOr1W/gKts64ILNPY+bmDVL9/A3TAAAA",
    Pbi3DGeometry:
      "ywMAAB+LCAAAAAAABAClk1ELgjAQx7/LPS+ZrWzpU1QQ1INU0EP0YDR0YC5sBCJ+92ZprdJMUhTvt7v/zrvdNgV3z9fJiYENc7HnKxHyAyBwBY/kGextev9Uy9hRN2ToSTomxs7tpR7IdmXYKI69RMV2TIOSXhcpF8OyKMIGRjojZDgs4QCTVqxKT2MvodSgfUo+t67guUQj1nP4pG/SFQlXx7fL4dtPN9SmSbFtzfT2/NzvOtWGKn7Dfx2vX7tbT2t2UlMx4d6RSRaDnfvAgkW+DApjKaQnuYgKc8MPj6UZ434gC2MasovuOBahiPOpvF1q+K7pz4vkywMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977250",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jVELgjAUhf/LfZ6yOadrPUUJQT2IBD2ID7OGDtYWtgIR/3sr6+3cw3fPV09Qtvo03hUIOLhWV+ripe2MAgSl09Y/QNTTEgNCY8KSfB0RHDNMVzA3f2wzDHIMbCh2Wt6UVwMIHGMER2U7338OQkmCoHJeeu0siLCWcs6zLE1JRinN8yIiDMFZX5cHmnCCYK901wc7jznjFEFh1Ou38BVsnXFBZp/GzM0b041nWtIAAAA=",
    Pbi3DGeometry:
      "pwMAAB+LCAAAAAAABAClk1ELgjAQx7/LPS+ZSTX1KSoI6kEq6EF6MBo2MBc2AhG/e7MsNXUpORy73+5/p3ebm4BzZLv4SsGCFT+yLQ/YCRA4nIXiBpabvJZyG9tyQIoKMtAxtp+TfCE9vGXTKPJiqTU0TCZIOmjjMUFYw6gghmGaORrqxOjF6tEKUhUSjYyk/ZW2RjO5GlZy12k1bMOHNuu751f8qKoaylh9KlRqQ6eeNkf7VS8V/uP4dO1iO23JJE/8nHkXKmgEVuYDaxr64pwbGy48wXiYm3t2+mwtKfPPIjcWAb2XHWc84FF2456PvFgPryGRL6cDAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977251",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABAA1jcsKwjAQRf9l1mlIOn2kdSVaEHRRiuCidFE1tIGYSI1CKf13o9Xd3OHce+oJyrM6jncJOeztWVXy4lrTaQkESquMe0BeT8vpEUFZitkq4IzGDDOYmz+2HoZ29Kx/bFV7k04OkDPKCByk6Vz/CRx5SKCyrnXKGsiR8kgIkSRRxBNETNMi4DGBk7ouBQwFJ7CTquu9XVARCyRQaPn6LXwFG6utl5mn1nPzBqDrAAbSAAAA",
    Pbi3DGeometry:
      "uQMAAB+LCAAAAAAABAClk98LgjAQx/+Xe14yGcnUp6ggqAepoIfoQWnkwFysEYj0vzfLUvNXkqJ4n919b97t9il4Ad8mFwYOLEXANyLiR0DgCR6rKzj79PWpl7Grb7ijgoxMjN3nSz9wP7zDJlL6iY6lBsaUIO1hWBZF2MCohAix7ZyZxB4PYg1yBapGUoOOtct34jrOBHpoJX+dVoUbNtscP2QHXb/bWZQeuWGlKrXkxw63KPaVrgv/c5x+7Wg7bcmkZ2DG/TNTTIKT+cCKxScV5sZaKF9xEefmjh8/SwvGT6HKjXnEbmXHqYiEzGbweelRewA4BkW6uQMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977252",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry:
      "0wAAAB+LCAAAAAAABAA1jV0LgjAUhv/LuZ5jH06nXUUJQV2IBF2IF1ZDB2sLW4GI/72VdXfew/O+Tz1BedbH8a4gh70760pdfGs7owBB6bT1D8jraTkDQhnOMsFWESVYEJ7B3Py59TC0Y4DDY6vbm/JqgJxgguCgbOf7T6CcMgSV863XzkLOMY2llEkSxzThnKdpEVGB4KSvS4EzSRHslO76oJdYCskRFEa9fgtfwcYZF2T2aczcvAEKsmD70wAAAA==",
    Pbi3DGeometry:
      "3QMAAB+LCAAAAAAABAClk98LgjAQx/+Xe15jKcnUp6ggqAepoIfoQXHkwFzYCET835tmZeVPUhTvs7vvzrvdIQXH47vkwsCClfD4VoTcBwSO4JG8gnVIH59qmdjqhgy9yWhMiF281APZ8Rk2jWM3UbFjDZuaaSDlgg2DIoIJqjJdN80H1DExCB0I6yRf7DuYYjqh+u/2NTzX6MBfWdTgD/G6pBskhuXR8eetFeqWHFq4d5d6N75JtUclW/mfR61/n1tw03ZqTubcPTPJYrByJ1iz6CSD0tgI6UouotLcc/+1tGT8FMjSWITsVnWciVDE+ZwWlxrHO63U2PHdAwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977253",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jVELgjAUhf/LfZ7D66ZOe4oSgnoQCXoQH6yGDtYWtgIR/3sr6+2ey3fOV09QntVxvEvIYW/PqpIX15pOSyBQWmXcA/J6Wk6PYEozTPgqwJDGIctgbv7cehja0cP+sVXtTTo5QB7SkMBBms71n4AMIwKVda1T1kDOKHIhRJJwjgljLE2LAGMCJ3VdCiwSSGAnVdd7vaAiFoxAoeXrt/AVbKy2XmaeWs/NG8prZ2HTAAAA",
    Pbi3DGeometry:
      "3QMAAB+LCAAAAAAABAClk1ELgjAQx7/LPS+ZSTXtKSoI6kEq6EF6MBo6MBdrBCF+96ZpWU1NUhTvt7v/zrudl4B7YNvbmYIDS35gGx6xIyBwOYvlBRwveXyqZTxWN6ToRXomxuP8pR5I92XYRAj/pmLNkUEGmCDlYgyHBGEDoyqzLNsuoU36Zkeok6yw92CifIj1vb2GZxqt+C0LDf4Q1yVdI9Etj8Y/b6lQm2TXwlW79HPj61RbK9nI/zxqv/e5Addtp+ZkxvwTlVSAkznBisaBDAtjzaUvGY8Lc8eOz6UFZUEoC2Me0WvVccojLrI5zS81jneiN8lr3QMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977377",
    Name: "Curtain Wall: SH_Curtain wall",
    Category: "Walls",
    Pbi2DGeometry: "CQEAAB+LCAAAAAAABAB9js0KwjAQhN9lzzE0kdq0nooKgh6KCB5KDy2GdiFmpUahlL67gVp/Lt529htmJu8hq/DYXTUksKMKMzJdTRYYZITW3SDJ+/H0Bil5KGS8FIKLUMYwsA+biQWXgfjLIq4iKX7QFDmhYipO27bsfLt/rLG8aKdbSAIeMNhrW7vmJQ7kSod+8ChPeH6jrca68R2Kq1DNGWyMfnx7V2TIZ9q7MUPxBHEdpREJAQAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Adjust for Mullion Size": "No",
    Angle: "0.00°",
    Area: "32",
    "Assembly Code": "B2020200",
    "Assembly Description": "Curtain Walls",
    "Automatically Embed": "Yes",
    "Base Constraint": "Level 1",
    "Base is Attached": "No",
    "Base Offset": "0",
    "Border 1 Type": "64 x 128 rectangular",
    "Border 2 Type": "64 x 128 rectangular",
    Cost: "0",
    "Cross-Section": "Vertical",
    "Curtain Panel": "Glazed",
    "Design Option": "-1",
    "Enable Analytical Model": "No",
    Family: "SH_Curtain wall",
    "Family and Type": "SH_Curtain wall",
    Function: "Exterior",
    Image: "<None>",
    "Interior Type": "64 x 128 rectangular",
    "Join Condition": "Vertical Grid Continuous",
    Justification: "Center",
    Layout: "Fixed Distance",
    Length: "11800",
    Number: "7",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Related to Mass": "No",
    "Room Bounding": "Yes",
    Spacing: "1500",
    Structural: "No",
    "Structural Material": "<By Category>",
    "Structural Usage": "Non-bearing",
    "Top Constraint": "Level 2",
    "Top is Attached": "No",
    "Top Offset": "-300",
    Type: "SH_Curtain wall",
    "Type Id": "SH_Curtain wall",
    "Type Image": "<None>",
    "Unconnected Height": "2700",
  },
  {
    ID: "977406",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1zsEKwjAMBuB3ybmUtV23rp5EBUEPYwgexg6blq1QW5lVGGPvbkS9heT7+VPPUHb2NN0NaDiEzlbmElvfOwMEymB9fICu5++IhCeUKSFXBZWMS1iav1qPYzshxcXWtjcTzQg6oQmBo/F9HECnVBSZIFCF2EYbPGhBWcpkwTMppMJbnhM42+sHY1IJxHtj+wGLFZWFVAR2zrx+afxEME5gE1zALv90bmne2KgK5tAAAAA=",
    Pbi3DGeometry:
      "uQMAAB+LCAAAAAAABACVU98LwiAQ/l/u2UQ3lraeooKgHqKCHqKHxaSENWNJMEb/e1bWVu1XiOJ93n2n33mbDOY7uUpPAnyYqp1cqkiGgGCuZKzP4G+y59Yck74ZcEU50qGE9B+LmXDdvsIGSRKkJpYy3OOei3q463EXEUxd6qAvlGPmMOQ42OWU/Q+Wk1o09/WYZ+Nzzyrsh7IAfjLWpCm/Zml4++xNr2xWpEWuNjIV6vFHkcs467Wr1LPmQg2/pipNuwLX6P4gNT0wksFRaJGATzBBMBPxXh+ssVA60FLF1lzL8H00EXJ/0NYYR+JSdByqSCX3HiScDO+tdgPvyn9vuQMAAA==",
    "Analytic Construction": "<None>",
    Area: "4",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2620",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.09",
    Width: "1340",
  },
  {
    ID: "977408",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABABFjcsKwjAURP/lrmNIUptHXYkKgi5KEVyULloNbSAmUqNQSv/dSBV3M8M5TDlC3pjTcNeQwcE3ptCXULvWakCQe+PCA7JynGNEFpRjwpVcKZxSlsJU/bB139dDZOOwNfVNB91DRjBBcNSuDd2n0IQyBIUPdTDeQUZxKohQPGFcqKVUAsHZXGc2YZIi2GvTduHv7qx+fWWJBYvCxlsfn9zT2ql6Azs5+LHPAAAA",
    Pbi3DGeometry:
      "7wMAAB+LCAAAAAAABACVk9EKwiAUht/lXNtwrW1uu4oKgrqICroYXWwkS1gzlgRj9O5ZrRrV1BTF86m/8uuJa1ikbF0dKYQw4ylb8ZztAMGCs0KcIIzrx1BO40hWuKA36dkYR/dONrhsn9uGZZlUcm/P9izsBQQFlud7LiKW3/dRizoDMuikxCWOAW6UO/BD2pah435pfOKPxb8llLRDWH1nnYjBPTQ+/+WR0jkV1TyrwRcwO83QZDVW/jndiUbvp3O/pS0zZ8ySAxW0hBBbGMGcFpnYN8GSi0QwXjThhu1eU1PKsr1ogklOz+2FI57z8pa59yIT9ArY+VDX7wMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1340",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977409",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zQAAAB+LCAAAAAAABABFjbEKwjAYhN/ln0NoEts0cRIVBB1KERxKh1RDG4iJ1CiU0nc3WsXt7vjurhqhaMxxuGmQsPeNKfU5KNdaDQgKb1y4g6zGWUaEUsxywpcCp4SmMNU/atX3aohoDDZGXXXQPcgEJwgO2rWhexvCCEVQ+qCC8Q4kwSlPuMgYzbhY5CLLEJzMZYYZzQmCnTZtF/7lrdXPb/szvvbWxyP3sHaqX27cW9fNAAAA",
    Pbi3DGeometry:
      "pwMAAB+LCAAAAAAABACNk10LgjAUhv/LuV6y+ZEfXUUFQV1IBV1IF0qjBubCRhDhf2+apZRuKorn2XnPkfds0RPChO0eVwoBrHjCtjxlR0AQcpaJGwTR8/0pl/FE3lCghowIxpPqJR8oDh/ZNM/jh9SapmF5xEW+MXbHDsIGsYiJGmrZnt1LsRrVFTtQVY64hu85Vlv7h34Su+VK2lG08x+VQn1fnY+DvVA6pKC6kenHO7CbxtB+1LeHlB1U81G6+6kld/ycxRcqaA5BmQJrmp3EuQ42XMSC8awO9+z4XVpSdjqLOlik9N5OnPGU5+WJqy55sF4cLFbepwMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1340",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977410",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zQAAAB+LCAAAAAAABAA1jbEKwjAYhN/ln2NoEtOmcRIVBB1KERxKh1RDG4iJ1CiU0nc3Wt3uju/uqhGKxpyGuwYJB9+YUl+Ccq3VgKDwxoUHyGqcZUQWJMU0Iascc0I5TPWfWve9GiIag61RNx10DzLBCYKjdm3oPoYwQhGUPqhgvAPJMFkSntOUMy7ylGUZgrO5zjCjgiDYa9N28VhgwQVDsLP69Wt/xzfe+njkntZO9Rts/FAdzQAAAA==",
    Pbi3DGeometry:
      "uQMAAB+LCAAAAAAABACdk98LgjAQx/+Xe54y02zpU1QQ1ENU0IP0oDh0YC5sBCH9702zsvxZDsX7bPfd7W7npLD22O56omDBkntsyyPmA4I1Z7E4g+Wkj185jW054IbeRNEwtvOPfOF2eLpNksS9Sl9FM1Vsjgkaq+bIHCKsYlRiukGMFxtgrTeqE/tgJU+ikiHRK9tWcS7QjUsRVOi3ck209e6/hdB84s7EtCv+lrCPwvQtc4NkW/5a6P8XqmdFW2j9PrIHZsw9UkETsLIlsKJxIMLC2HDhCsbjwtwz/zW1oCwIRWHMI3opL5zyiCdZD+aPbLU7mH3ri7kDAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977411",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1jU8LgjAUwL/LO6/htqbTTlFCUAeRoIN4mDV0sLawFYj43ZtZ7/L+/d77VSMUjT4PDwUZHF2jS3X10rZGAYLCaeufkFXjUgaEUswJTTfpnDhM9Z/a9r0cAhoGey3vyqsesghHCE7Ktr6bG8IIRVA6L712FjKCOY8TQlgSIqZrSvMVYQgu+rYcMCoIgoPSbRfkAgsuwjo36v378BXsnHFBZl/GTPUHsajWY9EAAAA=",
    Pbi3DGeometry:
      "pwMAAB+LCAAAAAAABAClk9EKgjAUht/lXK8xNWvZVVQQ1EVU0EV0YTR0YC5sBCK9e8usprhSciieb/v/s51tuwyWB75Jzww8mIsDX4uIHwHBUvBYXsDbZc9f1U2GqsENfUjHImSYf9QLt/1LNkoSP1Va28YOtfpogHv9nosopi510Ic6XdrVqGvZg5a03rdCdQeCSXUCZZRrzUjPW0a6V/3sarTNkn5dVqMSmE2bVaVS/Ta7WmNqrpgJ/X90fu6fCX1Lok78hPsnJlkC3kMLCxYHMiyClZC+5CIuwi0/vrtmjAehLIJpxK76wLGIRPK4cfmjLtYdV9WbMqcDAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977413",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1",
    Pbi2DGeometry: "zgAAAB+LCAAAAAAABAA1jUELgjAYhv/Ldx7DOT/d1ikqCOogEnQQD1pDB2sLW4GI/71FdXt5eR6eeoayM6fprkHBwXem0pfQut5qIFB648IDVD1/Z0QY0gwlW0mKLEVYmj+1Hsd2img8tqa96aBHUAlNCBy168MAKqOFJFD50AbjHShOWcZQpjlyFDLnRUHgbK4fNHqCcwJ7bfohZgVFiYLAzurXz04o4ywlsPHWx5J7Wrs0b0c68oTOAAAA",
    Pbi3DGeometry:
      "uQMAAB+LCAAAAAAABACdU00LwjAM/S8515I69+E8iQqCHkQFD+JhYtHCXGUWYYj/3arbnLrVKaWleU1e2pdmeYbJWsyTAwcfRnItZjIUGyAwkSJSR/CX58dWH2NHD7iQJ9JgiJ37oidcVllYN46DRMcyi6LTYqRNHduzCFJmsSZ5Qz3qNl3CXOrZ/4DlpBma+9quncXnnlXYB2URfGE0pSm/Zml4/exfXllDke+56shUrMcPRS7jNGpXqafpQuZfU5WmXoENut9JdQ/0RbDnisfgI0UCYx5t1S41plIFSsgoNRdikx8NudjuVGoMQn4qOvZkKONbD6KHvVurXQFw3TobuQMAAA==",
    "Analytic Construction": "<None>",
    Area: "4",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2620",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.1",
    Width: "1460",
  },
  {
    ID: "977415",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1",
    Pbi2DGeometry: "zgAAAB+LCAAAAAAABAA1jb0KwjAYRd/lm0NImqb5cRIVBB1KERxKh1ZDG4iJ1CiU0nc3om6Xyzmceoays6fpbkDDIXS2MpfY+t4ZQFAG6+MDdD1/Z0IowZwJuVKY04zD0vyp9Ti2U0LTsbXtzUQzgiaYIDga38cBdI6FQlCF2EYbPGiGaU65ygrOuFQFEwLB2V4/aPIkYwj2xvZDykrMFZcIds68fjbBlNEMwSa4kEr+6dzSvAF10BEozgAAAA==",
    Pbi3DGeometry:
      "pwMAAB+LCAAAAAAABACdU1ELwiAQ/i/3bKJba7Y9RQVBPUQFPUQPG5MS1owlQUT/PStrK7Y5QhTv8+47/c7bXGEei9XlyCGAqYzFUqYiAQRzKTJ1gmBzfW31MQn1gBsqkA4lJHwuesJt+w4b5Hl00bEM067DUB/3POYigqlLHfQNMuw7PqIO7rv/gJWcBixcPd8z4R/HGuiXr4R90zXkqL5iZXjb3Jb3WaWw5rGrU6pB67JW8DULViti/WUsv6QuS7uiNsj9JNU/fiSiA1c8h4BggmDGs53aG2MhVaSEzIy5FsnnaMLFbq+MMU75uew4lKnMHx1HGBk+GusO5F3QD6cDAAA=",
    "Analytic Construction": "<None>",
    Area: "4",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2620",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.1",
    Width: "1460",
  },
  {
    ID: "977417",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1",
    Pbi2DGeometry: "zQAAAB+LCAAAAAAABAA1jUELwiAYhv/LdxaZczq1U1QQ1GGMoMPYwZVsgmksC8bYf8+obi8vz8PTzFB19jTdDSg4hM7W5hK1750BBFWwPj5ANfN3JoRhTjhfScxIzmBp/9B6HPWUyHRsrb6ZaEZQGc4QHI3v4wCqwKVEUIeoow0eFMWkIEzmnFEmJKdlieBsrx80eYJSBHtj+yFVBWaSCQQ7Z14/O8OEkhzBJriQSv7p3NK+ARFU5I7NAAAA",
    Pbi3DGeometry:
      "lQMAAB+LCAAAAAAABACVU00LwjAM/S8515Ju7MN5EhUEPYgKHsTDxKKFucoswhD/u1XrnLJuk9LQvCYv6Wu7vsJsK5b5iUMEE7kVC5mIHRCYSZGqM0Tr62upt7GnB9zIB+kwxN7T6Am3zTutn2VxrnNd6jjMJ13qe6FLkDKXOeQbDGngBNoi+x+rJDRgEekFnkku4izQL10J+2KzV6hsryq3bd36ozWK0FimWZiS+K1vs4KvTiybfvZOap+GpUKbm7Sr/CTU73so4iNXPIMIKRKY8nSvDsaZSxUrIVPjrsSu2BpzsT8o44wSfikHDmQis8f/whAHj290By+7rU6VAwAA",
    "Analytic Construction": "<None>",
    Area: "4",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2620",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.1",
    Width: "1460",
  },
  {
    ID: "977419",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1",
    Pbi2DGeometry: "zQAAAB+LCAAAAAAABAA1jUELwiAYhv/LdxbROTe1U1QQ1GGMoMPYwZVsgmksC8bYf8+obi8vz8PTzFB19jTdDSg4hM7W5hK1750BBFWwPj5ANfN3JoTgQnK2kpjTjMPS/qH1OOopkenYWn0z0YygCCYIjsb3cQCV41IiqEPU0QYPimGaUy6zgjMuZMHKEsHZXj9o8gRjCPbG9kOqCswlFwh2zrx+NsGU0QzBJriQSv7p3NK+AY3G9xrNAAAA",
    Pbi3DGeometry:
      "pwMAAB+LCAAAAAAABACVU00LwjAM/S8515I55j48iQqCHoYKHsTDZEULc5VZBBn773Zadeo6J6WleU1e2pdmnUO45cvLkUEAU7HlC5HwGAiEgqfyBME6v2/VMfbVgIK8kI6F2L8takKxeYQNsiy6qNiORXu+7xKf9hzPJkgt2+qSD9SjbtclNkUf7X+xekaNPl0d19HRL0cT9sVYAd8IzUlqr1gX2z7zjwf+1qJFqjYKVQrxR23rOJt0M0nZcJvGr2JI0aaqZrlvhOrHj3h0YJJlECBFAjOW7uReG3MhI8lFqs0Vj59HE8Z3e6mNccLOVcehSERWdhx6OCwb6wolLThEpwMAAA==",
    "Analytic Construction": "<None>",
    Area: "4",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2620",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.1",
    Width: "1460",
  },
  {
    ID: "977421",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1",
    Pbi2DGeometry: "zgAAAB+LCAAAAAAABAA1jUELwiAYhv/LdzaZOje1U1QQ1GGMoMPYwUo2wTSWBWPsv2dUt5eX5+FpJqjO9jjeDSjYh7OtzSVq3zkDCKpgfXyAaqbvTMgix5RyuZSYE8phbv/Uahj0mNB0bKy+mWgGUBnOEByM72IPKselRFCHqKMNHhTDJCdc0oIzLmTByhLByV4/aPIEYwh2xnZ9ygrMJRcIts68fnaGCSMUwTq4kEr+6dzcvgG7YdCczgAAAA==",
    Pbi3DGeometry:
      "pwMAAB+LCAAAAAAABACVU00LwjAM/S85dyXd2IfzJCoIehAVPIiHiUULc5VZhDH871bddMrWTUpL85q8tC/NJof5TqyyM4cQpnInljIWeyAwlyJRFwg3+Wurj7GvB9zIB7EYYv+56Am3bRk2SNMo07GWRz2bkR713MAhSJnDbPINBtS3fWIxGjjY+x+s5SzBt6vru2V46dgA/fJVsS86U476K9aGd81tfl+7FG152tWp1qBzWWv4jII1imi4jPmXNGXpVlSD3E9S/eNHIjpxxVMIkSKBGU8O6lgYC6kiJWRSmGuxfx9NuDgcVWGMY36tOg5lLNNHx2GAw0dj3QGyMtNzpwMAAA==",
    "Analytic Construction": "<None>",
    Area: "4",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2620",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.1",
    Width: "1460",
  },
  {
    ID: "977423",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1",
    Pbi2DGeometry: "zgAAAB+LCAAAAAAABAA1jcsKwjAURP/lrmNokqZ5uBIVBF2UIrgoXVQNbSAmUqNQSv/diLobhnNm6gnKsz2OdwMa9uFsK3OJre+cAQRlsD4+QNfTNyZkoTDJBV0qzAnlMDd/ajUM7ZjQVGxsezPRDKAznCE4GN/FHnSOhUJQhdhGGzxolpYIV7TgjEtVMCEQnOz1gyZPMoZgZ2zXp1uJueISwdaZ18/OMGGEIlgHF9KTfzo3N28xDu2HzgAAAA==",
    Pbi3DGeometry:
      "ywMAAB+LCAAAAAAABACdU80KwjAMfpecu9JO6+Y8iQqCHkQFD+JhYtHCXGUWQcR3t5v7U7c6pbQ0X5IvadKsbzDbiuX1xMGDidyKhQzEDhDMpAjVGbz17XnVatLTC+6oQCxKSC859Ib7JnPrR5F/1b4WpZi1bRt1cYe5LUQwbVEbvcMudmwHWR3ssH/AGtYMzo2ZwzKCwrQW/GQtoy+kpkjVqVa6/xL/21ubFKZJvGb1Kvfmp5ZX8hrLWFtaY1LmX1QXp1mzDQ1ISPVUDIV/5IpH4BFMEEx5uFeHVJhL5Sshw1RciV2uGnOxP6hUGAX8UjYcyEBG8VQSlwzi4XsAfFTFbcsDAAA=",
    "Analytic Construction": "<None>",
    Area: "4",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2620",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.1",
    Width: "1460",
  },
  {
    ID: "977425",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1zcEKwjAQBNB/2XMMTdO0STyJCoIeShE8lB6qhjYQE6lRKKX/7op6W2bfMPUE5dkex7sBDftwtpW5xNZ3zgCBMlgfH6Dr6XsiWTBOZcHypaKCpQLm5s9Ww9COaDHY2PZmohlAJzQhcDC+iz3ojHKVcwJViG20wYPmlGVMqDQXXEj8FQWBk71+MDYlR7wztutxWVKhhCSwdeb1ayeUcZYSWAcXcMs/nZubN5Y1s3bRAAAA",
    Pbi3DGeometry:
      "3QMAAB+LCAAAAAAABACdU80KwjAMfpeca0kd+3E7iQqCHkQFD+JhYtHCXGUWYYjvbtVZndo5pbQ0X5IvadLMjzBaimm+4xDCQC7FRCZiBQRGUqRqD+H8eLtqNUZ6wYk8kAZDjK6H3nBa3N3aWRbn2rfBPIpeKyAt6rmBQ5AyhzXJKxxQv+lrlFHPd9x/UAuxgY2167uGwthawXfaElpirY5lSfczwy85fHtwrfLUCFivaKUW/dT7j7zVpbTXtzqvLx/KGqtu36s6cSXWc9IV8ZYrnkGIFAkMebpWm0IYSxUrIdNCnImVUfW5WG9UIfQSfng27MhEZpc5xQA7l3E8A6vdocvdAwAA",
    "Analytic Construction": "<None>",
    Area: "4",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2620",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.09",
    Width: "1340",
  },
  {
    ID: "977433",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABABFjUEKwjAURO/y1yE0qUmauBIVBF2UIrgoXVT9tIGYSI1CKb27lSruZob3mHKA/GyP/R3BwD6cbYGXWPvGIRDIg/XxAaYc5jghTFGdiXSpqWBcwFj9qFXX1f2ETsPG1jeM2IFJaELggL6J7aewlHECRYh1tMGDYVSoRGmZcqn0ItNSEjjZ6wynPGMEdmibNv7lrcPX186o4orAOrgwXfmnc2P1Bm5YmGzPAAAA",
    Pbi3DGeometry:
      "ywMAAB+LCAAAAAAABACVk8sKwjAQRf9l1jGkz8S6EhUEXYgKLsRFi0EDtZEaBBH/3aj13Xa0oSVzkrkJdzrzI4wSNT1sJUQw0Ima6FQtgcBIq8zsIJofb1O7zFp2wIk8ScNhrHX92BdOi3taO8/jg811OG2KwCNNGvIwIIJyl5Mn9HzhV0ERCA+lhWo5vci6LvWEwz8Evuj71tL8OlguWnNXTAG7AeLrH7bUeVUJkQpitf7toJ9MraXV/xV2GF4rzOwXXdsVXRVvpJE5RIwyAkOZrcy6CMbaxEbprAhnavlY6ku1Wpsi6KVy/7qxo1OdX7ry+tjmOwOj8LHfywMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1340",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977434",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABABFjdEKgjAYhd/lvx7DbbqpXUUFQV2IBF2IF7N+dLC2sBWI+O4ZFt2dc/g+TjVC0ZjTcEfI4eAbU+IlaNdaBAKFNy48IK/GJc4IEzSSMVtlNGE8gan+Ueu+18OMzsPW6BsG7CGPaETgiK4N3acwwTiB0gcdjHeQM5qoSGVScKmyOM2kJHA21wUWPGUE9mjaLvzlncXX106p4orAxls/X7mntVP9Bli8dQ/PAAAA",
    Pbi3DGeometry:
      "ywMAAB+LCAAAAAAABACVk10LgjAUhv/LuV5j5md2FRUEdREVdCFdGI0cmAsbgUj/vWWrrGwzRfE8Z+fdeI8nKmG+ZaviSCGEKd+yJU/ZDhDMOcvECcKovH/KNOnLGy7oRToWIf3qJR+4bB5lgzyPC1lr2Zh4joV62PM9FwXY7/roBW0ncH7BwA1sI1WqzbSS9WXyW+CTvi9trNfBZlHdWQ0KxhPoff3DFp1Xv6G+g8Zet9qolalaqvmvDJu16JXB7JqunIoRiw9U0BxCggmCGc32IlHBgotYMJ6pcM12z9SEsn0iVDBO6bm+cMhTnt+msrrk8F0BYjxJ78sDAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977435",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zgAAAB+LCAAAAAAABABFjcsKwjAURP/lrkNo0kcerkQFQRelCC5KF6mGNhATqVEopf9upIq7meEcpp6gbM1pvGuQcPCtqfQlKNdZDQhKb1x4gKynJUaEY5JRvhI4JzSHuflB62FQYyTjsDXqpoMeQCY4QXDUrgv9p5CUUASVDyoY70ASnLOEiSKlBRMZF0WB4GyuC5xSThDsten68Jd3Vr++NseMMgQbb328ck9r5+YNgx8K+84AAAA=",
    Pbi3DGeometry:
      "uQMAAB+LCAAAAAAABACNk10LgjAUhv/LuV5jfpRLr6KCoC6igi6kC6NhA3NhIwjxv7fMzEg3HcrOs5134z2eMIf1ke8eVwY+LMWRb0XCT4BgLXgqb+CH+XuqlkmgBhToSwYWIUH5US8Uh0/aJMuih8ql2HJtisZ45I2GiGLP9lDNHJe6HYwOqWOAlWIrfElaNh47f+l/9Hdra74Otot239QkYLqA1tD+luh86oTawhkK3O+UPm7qYOevZDrJXCK9yQ1V1QMzHl2YZBn4BBMEK5bG8lwFGyEjyUVahXt+qpcWjMdnWQXzhN2bG6ciEdmrB8tHtdoTQkxwqrkDAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977436",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zgAAAB+LCAAAAAAABABFjUELwiAcxb/L/ywytem0U1QQ1GGMoMPYwUo2wTSWBWPsu2es6Pbe4/fj1SOUZ3sc7gYU7MPZVuYStW+dAQRlsD4+QNXjHBPCMKWELyXOCc1han7Qqu/1kMg0bKy+mWh6UBnOEByMb2P3KYQRiqAKUUcbPCiCc5EJyRnlQi4KyTmCk73OMKMFQbAztu3iX9468/raBRZUIFgHF9KVfzo3NW/fQYDAzgAAAA==",
    Pbi3DGeometry:
      "pwMAAB+LCAAAAAAABACNk10LgjAUhv/LuV5jfi+9igqCuogKupAuFEcNzIWNQKT/3iqzL506FM+zveeM92xhCcuYb4oTAx/mIuZrkfIEECwFz+QZ/LB8/qppEqgBV/QmA4OQ4PFRL1x3L9koz6NCaS1smoaLhtj1XAdR7JkeqpllU7uFUYdaHbDK2AjvKSkmxp/6F34tbBJrWGPC9j3q5R21tT72dkLjThvTNqujqX1q9DBRB1vPjr5OZ1/03n7kVCd+wqMjkywHn2CCYMGyvTxUwUrISHKRVeGWJ/XUjPH9QVbBNGWXz4VjkYr8fuMej7pYN6trUnGnAwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977437",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABABFjUELwiAcxb/L/2wyXdNpp6ggqMMYQYexgyvZBNNYFoyx756xott7j9+PV41QNOY03DVIOPjGlPoSlGutBgSFNy48QFbjHCOyIJgJwVcCZ4RmMNU/at33aohoHLZG3XTQPcgEJwiO2rWh+xSSEoqg9EEF4x1IgjOecMFSyrhY5oIxBGdzneGU5gTBXpu2C395Z/Xra+eYU45g462PV+5p7VS/AddyKbLPAAAA",
    Pbi3DGeometry:
      "uQMAAB+LCAAAAAAABACNk10LgjAUhv/LuZ5jpvnVVVQQ1EVU0IV0oTRqYC5sBCH+95ZZmuimonie7T1H3rMT5rCJ2f55oxDAisdsxxN2AgQbzlJxhyDMP59ymUzkDQWqiWESMilf8oHi+JVNsyx6Sq1hYsf3XeRjx3XGyMPuyEU1tGzP7oPe2LO0tMraTd9pLUx8YrX0bfi3sUusYJ0JFX+p1muKa+wc7obCoT6m6Zquv0PKDPFSSfsPkrqUtkE6jxtZ5QzMWXSlgmYQEEwQrGl6Fpcq2HIRCcbTKjyw029pSdn5IqpgkdBHc+OMJzx7z2B5yVF7Ad7+NGu5AwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977438",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zgAAAB+LCAAAAAAABABFjUELwiAcxb/L/2wyXdNpp6ggqMMYQYexgyvZBNNYFoyx756xott7j9+PV41QNOY03DVIOPjGlPoSlGutBgSFNy48QFbjHCOyYJhRshI4IzSDqf5B675XQyTjsDXqpoPuQSY4QXDUrg3dp5CUUASlDyoY70ASnPGEC5ZSxsUyF4whOJvrDKc0Jwj22rRd+Ms7q19fO8eccgQbb328ck9rp/oN3EKd/s4AAAA=",
    Pbi3DGeometry:
      "uQMAAB+LCAAAAAAABACNk10LgjAUhv/LuV5j5tfSq6ggqIuooAvpwmjowFzYCET67y2zT3TToew823k33uOJKlgd+LY8MwhgIQ58IzJ+BAQrwXN5gSCqnlO1TEI14IY+ZGAREtYf9cJt/0obF0VcqtyBh72hhUbY8z0XUewPffRmtkOdDkZdahtgo9gKa0kLU5uM/tP/6e/W1nwdbBfV3NQgYLyAztD+luh86oa6wpkK3OuUPm7qYPevZDipR4m0Jn+pqh6Y8vjEJCsgIJggWLI8kWkTrIWMJRd5E+748b00ZzxJZRPMMnb93jgRmSgePVg/qtXuHpe5mrkDAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977439",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABFjcsKwjAURP/lrmNo0kfauBIVBF2UIrgoXUS9tIGYSI1CKf13I1XczQxnZuoRyrM+DncECXt31hVevLKtQSBQOm39A2Q9zjIgC8ZomnC+LGjKeApT88NWfa+GwIZgo9UNPfYgIxoROKBtffcxLGacQOW88tpZkGFLRKLIYp6JIsmDIHDS1xmOec4I7FC3nf+XtwZf33ZOBRcE1s64cGWfxkzNG+9HySjQAAAA",
    Pbi3DGeometry:
      "3QMAAB+LCAAAAAAABACVk10LgjAUhv/LuV5jml/ZVVQQ1IVU0EV0oThqYC5sBCL+95ZZ2YebOZSdZzvvxns82wKCiK3zEwUf5jxiK56wGBAEnKXiDP62uE/lMhnKASV6kZ5ByLD6yBfK3SNtlGVhLnN7hoFtyzTRADuuYyMPu6aLGrRveVYr9Wyv3wHXyi24knawa39LfNL3rT/zVfC3qPK2GgntFXT2/mONyq92qCulvuydzurmrRqrfjLNeR2KpjW9oSz7ZMLCIxU0A59ggmBB07041MGSi1AwntbhhsXPpRll+4Oog2lCL82NY57w7Nan1SPb8QqqkTqY3QMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977440",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zQAAAB+LCAAAAAAABABFjbEKwjAYhN/ln0Np0iZp4iQqCDqUIjiUDlFDG4iJ1CiU0nc3WsXt7vjurh6hPJnDcNMgYedPptLnoFxrNSAovXHhDrIeZxkRzJOC5nghEooJhan5Ucu+V0NEY7A26qqD7kGmSYpgr10burfBGSYIKh9UMN6BxAnlKRcsI4yLvBCMITiaywxnpMAIttq0XfiXN1Y/v+3P+MpbH4/cw9qpeQHGNTXxzQAAAA==",
    Pbi3DGeometry:
      "pwMAAB+LCAAAAAAABACNk1ELgjAQx7/LPS/Z0szsKSoI6kEq6EF6UBw1MBdrBCJ+91bNDNGponi/3f9O/reFBQQxO+Z3Cj5secwOPGUJIAg4y+QD/LD4fqplPFc3lKgmI4Lx/PNSD5TnSrYQIsqVlkwtb+IQNLPcqTtB2CI2GaOa2o7ndFJsRrpiC/qWsy3sNrRN1EhslxtpS9H2fzQJB/Tt8XGwF0aHTLRnZAPGO6xbj6HdqHMPmToY52Nyt6qldvyKRTcqqQD/nQI7ml3kVQd7LiPJeKbDE0t+SxvKLlepg3VKn/+JS55y8T5xn0sdrBd/00hKpwMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977441",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zQAAAB+LCAAAAAAABABFjcsKwjAURP/lrkNoUvtIXIkKgi5KEVyULlK9tIGYSI1CKf13o1XczQxnZqoRikYfhxuChL1rdIlnr2xrEAgUTlt/B1mNswwI41TEPF8KmjCewFT/qFXfqyGgIdhodUWPPciIRgQOaFvfvQ2LGSdQOq+8dhYko0kWZSKNeZqJRS7SlMBJX2Y4vDACO9Rt5//lrcHnt/0ZXzvjwpF9GDPVL+P/NvTNAAAA",
    Pbi3DGeometry:
      "lQMAAB+LCAAAAAAABACNU10LgjAU/S/3ecmmVn48RQVBPUgFPUgPisMG5sJGEOJ/b5pWls42NnbP7jkb525+Dl7I9vcLBQfWPGQ7nrAIEHicpeIKjp8/l3Ibu7JDgd7IiGDsVpMcUBwb2izLgrvkEl2zDd1CtjaZTsYIa8QgOnqjhmmZvShWQ7ViB1TJWRox29RvpJ3WyVWBv4Kdt1PQBo8csu9fC1S+9INDZRou6V9nqX3sh/oejUJfURSlqY2SfN8LFpypoBk4ZQpsaBqLUx1suQgE42kdHlj02lpRFp9EHSwTevtMnPOEZ+X/qpr8Rg8tDeislQMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977442",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zAAAAB+LCAAAAAAABABFjbEKwjAYhN/ln0NIUps2cRIVBB1KERxKh1RDG4iJ1CiU0nc3WsXt7vjurhqhaMxxuGmQsPeNKfU5KNdaDQgKb1y4g6zGWUYkx4RSvhQ4pSyFqf5Bq75XQyRjsDHqqoPuQRJMEBy0a0P3NjShDEHpgwrGO5AUpxnJBE8Yz8QiF5wjOJnLDCcspwh22rRd+Je3Vj+/7c/42lsfj9zD2ql+AbFXUbPMAAAA",
    Pbi3DGeometry:
      "gwMAAB+LCAAAAAAABACNk1ELgjAQx7/LPS/Z1KzsKSoI6kEq6CF6UBo6MBc2Aom+e9PUMvNKcXi/3f8/vdv2N/ACsc3OHFxYykBsZCyOQMCTIlEXcPe356uepmN9w528SI9ROi4G/cD9UMkmaepnWjs0KGMOGRnOwOkTajCLmaSGlj20uyDFSOnWJoWVZZhmU/hJmmlftRhsG377NkT1c0W8bn/+PlaTboh352cf/1oILWAn6dgniDnSC6SYlY/ezTPhn7jiKbh5Bqx4EqqoDNZS+UrIpAx34lhPLbgII1UG85hf3xOnMpZpfpqKSx+aBxyn+HyDAwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977443",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zAAAAB+LCAAAAAAABABFjcsKwjAURP/lrkPIwz4SV6KCoItSBBeli1RDG4iJ1CiU0n83WsXdzHBmphqhaMxxuGmQsPeNKfU5KNdaDQgKb1y4g6zGWUaEYyIIXwqcUJbAVP+gVd+rIZIx2Bh11UH3IAkmCA7ataF7G8opQ1D6oILxDiTFSUYykXKWZmKRizRFcDKXGeYspwh22rRd+Je3Vj+/7c/42lsfj9zD2ql+AaM15prMAAAA",
    Pbi3DGeometry:
      "lQMAAB+LCAAAAAAABACNU9EKgjAU/Zf7vGQ2s9SnqCCoh6igh+hBcejAXNgIQvz3pplF6c2Njd2ze87Gudsxh00g9vcLBxdWMhA7mYgQCGykSNUV3GP+XOpt6ukOBXkjA5NSr5r0gOL0ok2zzL9rLjOoQxlxDHtsjwg1TGYOSQMya2J1gRRDarVfpJIamIbtOONP5g/0ldhOR9EW0bYborz/x+IG9vUBdQdB8Ur9rWnPo3AnO5GOZ4PKY2VBXH0p6fc9F/6ZK56BW2bAmqeRiutgK5WvhEzr8CDCZmvJRRSrOlgk/PaZOJOJzMr/VTX9jR59vMdwlQMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977444",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zQAAAB+LCAAAAAAABABFjT0LwjAYhP/LO8eQD5s2dRIVBB1KERxKh6ihDcREahRK6X83WsXt7njurhqgOJlDf9OQw86fTKnPQbnGakBQeOPCHfJqmGREZhRnnMiFxAllCYz1j1p2neojGoO1UVcddAc5wQTBXrsmtG9DOWUISh9UMN5BTnGSklQKzkQq55kUAsHRXCaYs4wi2GrTtOFf3lj9/LY/4ytvfTxyD2vH+gUUPQzrzQAAAA==",
    Pbi3DGeometry:
      "lQMAAB+LCAAAAAAABACNU9EKgjAU/Zf7vGRTM7WnqCCoB6mgB+nBaOTAXNgIJPr3ZmlmuenGxu7ZPWfj3C28Q3Bg2/xCwYclP7ANT9gREAScpeIKfnh/L+U2HssOD1QjA4Lx+DXJAY99RZtkWZRL7oAYroU95BnOyBkibBCLmKhGLdu1lSjWQ6ViC/SWcwzHJA3qD9JMa+XqwH/B9tupad1HdtjX1wKdLxqwo0w9StrnLL2Pakj5aNT6uqLoTK2U5PuesehMBc3AL1JgRdOTiMtgzUUkGE/LcMeOn60FZadYlME8obfvxClPeFb8r1eT3+gJUXDAr5UDAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977445",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zQAAAB+LCAAAAAAABABFjbEKwjAYhN/ln2NoUpM0dRIVBB1KERxKh6ihDcREahRK6bsbreJ2d3x3Vw1QnMyhv2nIYedPptTnoFxjNSAovHHhDnk1TDIiM44Fo3QhMSOUwVj/qGXXqT6iMVgbddVBd5AnOEGw164J7duQlFAEpQ8qGO8gJ5iJREieUi7kPJOcIziaywSnNCMItto0bfiXN1Y/v+3P+MpbH4/cw9qxfgHZyDZxzQAAAA==",
    Pbi3DGeometry:
      "uQMAAB+LCAAAAAAABACNU8sKwjAQ/Jc9x5L0qfUkKgh6KCp4KB5aDG2gNlKDUMR/N31Z0TZtQkJ2sjsbZrP+E7yQHfMbBRe2PGQHnrALIPA4S8UdXP9ZHeU1nssJL9QiE4LxvNzkgte5CVtkWZDL2ImtOZauo5lmO7aFsEYMoqMWNcyp2YtiNVQzdkAVHSGaZf4E/2G/rj0MariLuPul6tAxyQcEHS+KWislPFC+EaUem29I2X6o90upc6hLpZK5YZM9sGLBlQqagVu4wI6mkYhrY89FIBhPa/PELp+rDWVRLGpjndDHt+OSJzwrerAcstXe+OFcl7kDAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977446",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zgAAAB+LCAAAAAAABABFjbEKwjAYhN/ln2NoEpM0dRIVBB1KERxKh6qhDcREahRK6bsbreJ2d3x3Vw6Qn8yhv2nIYOdPptDnULvGakCQe+PCHbJymGREZoRgIRlfKMwJ5TBWP2zZdXUf2RisTX3VQXeQJThBsNeuCe3bEEYogsKHOhjvICOYy0QqwaiQap4qIRAczWWCGU0Jgq02TRv+5Y3Vz2/7M77y1scj97B2rF77pWxRzgAAAA==",
    Pbi3DGeometry:
      "ywMAAB+LCAAAAAAABACVU98LgjAQ/l/uecqWaWlPUUFQD1FBD9KD0qiBubARRPS/t2r9Er3Zxpz33d138p0XX2CWiuX5wCGCiUzFQmZiAwRmUuTqCFF8eb5qN+3pDVfyQRxGae/x0Aeu61davyiSs851GHODjueTUF+BT6jLPNYiX7DX7rbrYWrDDGsVZigDlwZh9ze9jJVDaxhwuIq47lvR3EbVbbr+IQyuFw7b+tio6w1LWgVGMOT/QstYeobK/eLTUzEUyZ4rXkB0j4Epz7dqZ4y5VIkSMjfmSmzerjEX250yxijjp+/AgcxkcZ/Kx9LDdwP25CdEywMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1340",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977447",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zQAAAB+LCAAAAAAABAA1jT0LwjAYhP/LO4fQJKb5cBIVBB1KERxKh6qhDcREahRK6X83Wt3ujufuqhGKsz0OdwMa9uFsS3OJjW+dAQRFsD4+QFfjLBNCBFZEiaXCnFAOU/2nVn3fDAlNwcY2NxNNDzrDGYKD8W3sPoYwQhGUITbRBg+aYbIgXNGcMy5VzoRAcLLXGWZUEgQ7Y9suHUssuWQIts68fu3v+Dq4kI7807mpfgM4SsX+zQAAAA==",
    Pbi3DGeometry:
      "pwMAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzOz8lMUdJRCsjPzCspVrKKroYwgdIG1kCoVKuDENE1NDCwBhNArFQbC9PmWFSUWAnUa2iuZ2lhaqxjqWdmbmaqY6BnoIMQMjaxMIEJWZiaGBIthMUsZCFkjRZAnoUxuqUYomDthESRbccQRTMXi0uxayfFAbj9SiBE8BpHSjghRwZxEYvdOLyBhkeU7AREZCziEcVuDzDFu2Qm5qaWpBYpWYGUKPmk5qWXZEA5QfkliSWZ+XlQbnhmClzKIzUzPaMEynHNSS1DVuicn5NfBMpxYADMWABU442gpwMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977448",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zQAAAB+LCAAAAAAABAA1jUELwiAcxb/L/ywyNTe1U1QQ1GGMoMPYwUo2wTSWBWPsu2etbu89fu+9eoTybI/D3YCCfTjbylyi9q0zgKAM1scHqHqcZUIIxVIKvpSYE8phav7Uqu/1kNAUbKy+mWh6UBnOEByMb2P3MYQRiqAKUUcbPCiGyYJwSXPOuJA5KwoEJ3udYUYFQbAztu3SscCCC4Zg68zr1/6Or4ML6cg/nZuaNz0TygnNAAAA",
    Pbi3DGeometry:
      "pwMAAB+LCAAAAAAABACdk1ELgjAQx7/LPa8x02zpU1QQ1ENU0EP0YDRsYC5sBCJ996ZZZo1pORy73/a/2+62bQaLPV+nZwYezMSer0TED4BgIXgsL+Bts8dQTRNfNbihinQsQvyiUz/cdk/ZMEmCVGktGxPXsdAAu323hwgmqEK2Q50H6uKB3aWtkcZXhepCimmP2p9Bv2ghN9N69C9a86vZqV7+ywZMZzVmpMHdL3mqitGusHp3DUkz0L8vUMsqGqg+jrrxYx6cmGQJePkSmLM4lMfSWAoZSC7i0tzww2tqynh4lKUxidj1feFIRCLJX1zxqYd1B77/QXynAwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977449",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zAAAAB+LCAAAAAAABAA1jUELwiAcxb/L/ywyNaezU1QQ1GGMoMPYwUo2wTSWBWPsu2etbu89fu+9eoTybI/D3YCCfTjbylyi9q0zgKAM1scHqHqcZUIkzoSgywJzQjlMzR9a9b0eEpmCjdU3E00PKsMZgoPxbew+hjBCEVQh6miDB8UwWRBe0JwzLoucCYHgZK8zzKgkCHbGtl36lVhyyRBsnXn92t/xdXAhHfmnc1PzBtfKsczMAAAA",
    Pbi3DGeometry:
      "gwMAAB+LCAAAAAAABACdk1ELgjAQx7/LPS+Zabb0KSoI6kEq6CF6UBo6MBc2ghC/e9OslqmMNjZ2v+1/t922Qw5+yHb3CwUXVjxkW56wEyDwOUvFFdxD/hzKaezJCgX6kIGJsVd1skFxfMmmWRbcpZYYpj0kaGI4Y2eEsIHRm1g2sWuCTdPRJL9+FKKqiEFGxGqEa8JK2w/VuE347fN3h61a/dCdB+xNQp8r/cwomde5wVZXfVnqhv89Eq376oatIeRrnrPgTAXNwC1XwJqmkYhrY8NFIBhPa3PPTu+pJWVRLGpjkdCbunDGE56Vv6kq8tM8AGnpdMWDAwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977450",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zAAAAB+LCAAAAAAABAA1jUELwiAcxb/L/ywyNTe1U1QQ1GGMoMPYwUo2wTSWBWPsu2etbu89fu+9eoTybI/D3YCCfTjbylyi9q0zgKAM1scHqHqcZUIYJpzLpcScUA5T84dWfa+HRKZgY/XNRNODynCG4GB8G7uPIYxQBFWIOtrgQaWtBeGS5pxxIXNWFAhO9jrDjAqCYGds26VfgQUXDMHWmdev/R1fBxfSkX86NzVv7VAwN8wAAAA=",
    Pbi3DGeometry:
      "gwMAAB+LCAAAAAAABACdk1sLwiAUx7/LebZhu7XLU1QQ1MOooIfRw0ZSwpqxJIix755bq2w3JEXx/PR/jh41zCGI6e5xJeDBisV0yxJ6BAQBoym/gRfmr6GYxr6oUKAvGY0x9qtONCgOb9k0y6KH0Bqaro9t5Gr2xLYQ1jD6EMN0zJpgFxuKpO1HIrLK0RzLMRrhmrDSDkM5bhP++mzvsFOrHrr3gINJGHKlnhkp8yo32OlqKEv98L9HonRf/bAzhHjNcxpdCCcZeOUKWJP0xM+1sWE84pSltbmnx8/UktDTmdfGIiF3eeGMJSwrf1NVxKd5AoOyz1iDAwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977451",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zQAAAB+LCAAAAAAABAA1jbEKwjAYhN/ln2NoEtOmcRIVBB1KERxKh1RDG4iJ1CiU0nc3Wt3uju/uqhGKxpyGuwYJB9+YUl+Ccq3VgKDwxoUHyGqcZUQWBGcpZ6scc0I5TPWfWve9GiIag61RNx10DzLBCYKjdm3oPoYwQhGUPqhgvAPJMFkSntM4yEWesixDcDbXGWZUEAR7bdouHgssuGAIdla/fu3v+MZbH4/c09qpfgMSeaV9zQAAAA==",
    Pbi3DGeometry:
      "pwMAAB+LCAAAAAAABACdk98LwiAQx/+Xe3ZirJZbT1FBUA+jgh6ih41JCWvGkiBG/3u2Vslm+9Fk4n30e6d3usvAD/nmdmbgwUKEfC1iHgECX/BEXsDbZa+hmiYj1eCOvsTqETLKO/XDff+WjdM0uCmt1cOO6w6Ri52hM0AEE/RFdp/234jaxG2NDL50pAsppgNql4NWaC5vonr0Ci35NezULO+ygd9nbchIrbsuedKL0a6wZne1Sauhf1+gllWsoeY46sZPeXBikqXgPZfAkiUHeSyMlZCB5CIpzC2PPlNzxg9HWRizmF31hRMRi/T54vJPPawHi1D+MacDAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977452",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zQAAAB+LCAAAAAAABAA1jbEKwjAYhN/ln2NoGpOmcRIVBB1KERxKh1RDG4iJ1CiU0nc3Wt3uju/uqhGKxpyGuwYJB9+YUl+Ccq3VgKDwxoUHyGqcZUQWHHPB+SrHjKQMpvpPrfteDRGNwdaomw66B5ngBMFRuzZ0H0MoSRGUPqhgvANJMVkSlqecUSZyTrMMwdlcZ5imgiDYa9N28VhgwQRFsLP69Wt/xzfe+njkntZO9Ru3BAUHzQAAAA==",
    Pbi3DGeometry:
      "lQMAAB+LCAAAAAAABACdk1ELgjAQx7/LPU9Zpmb6FBUE9SAV9CA9GA4bmAsbQYTfvWVmQ22NJhve7/a/07stukN4oNvbmYAPS3agG5bRBBCEjOb8An50f70KNw7EAyX6EGOAcVAtYkK5f8smRRHfhNZwTdcaoLHpjlwHYROjhgxtz36TkWNZ2qgbSiayzjM9xxu2UrZhJf4B5cwd2ora85X9cv30X/9SXQpFLP3yyA3QaWVvKGWlFPTfA6PZOQXtzyPO94zGJ8JJAf5zC6xInvJjbawZjzlleW3uaNK4FoSmR14b84xc5Y1TlrHieb+qIa7RA7wF6AiVAwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977453",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zgAAAB+LCAAAAAAABAA1jbEKwjAYhN/ln2NoEtOmcRIVBB1KERxKh1RDG4iJ1CiU0nc3Wt3uju/uqhGKxpyGuwYJB9+YUl+Ccq3VgKDwxoUHyGqcZUQWhOA0ycQqx5xQDlP9x9Z9r4bIxmBr1E0H3YNMcILgqF0buo8hjFAEpQ8qGO9AMkyWhOc05YyLPGVZhuBsrjPMqCAI9tq0XXwWWHDBEOysfv3a3/GNtz4euae1U/0GgAXp5c4AAAA=",
    Pbi3DGeometry:
      "ywMAAB+LCAAAAAAABAClk98LgjAQx/+Xe14yf5s9RQVBPUgFPUQPiiMH5sJGIOL/3jIrS11JDsX7bPfd7W63y8EL6CY7EXBhwQK6ZjENAYHHaMLP4O7y+6+YxiMxoEAvMlAxHpUf8UKxf7iN09TPhO9AVRXT0DQ0VCzbMhFWMKox3XCMJ7Ns3ezB2vTeWN3XURzT0RtbN3Gp8B3XY2jiT+22iDsU+oUhOfbX9Mgl+2XtrT6/1rtDUp5DGf7ncv1cWxnu2Ex0xZT6R8JJCu5tDSxJcuBRZawY9zllSWVuaficmhN6iHhlzGJyqS+csJilt64sH9F8V4Bwt+DLAwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977507",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1",
    Pbi2DGeometry: "zQAAAB+LCAAAAAAABAA1jb0KwjAYRd/lm2NI0jZ/TqKCoEMpgkPpUDW0gZhIjUIpfXcj6na5nMOpJyjP9jjeDWjYh7OtzCW2vnMGEJTB+vgAXU/fmZAF5ZgRuuRYSs5gbv7UahjaMaHp2Nj2ZqIZQBNMEByM72IPOsdCIahCbKMNHjTFhSBC8YxxoXKpCgQne/2QSZNZhmBnbNenqsSFKiSCrTOvn0wwzShDsA4upJB/Ojc3b4bU33zNAAAA",
    Pbi3DGeometry:
      "7wMAAB+LCAAAAAAABACVU0sLgkAQ/i9z3pb1kamdooKgDlFBB+mgtOiCuWFLEOJ/bytL0VyVZR/zzc43wzy8DLYBOzyuFFxY84DteczOgGDLWSJu4HrZ5ynVZCoX5KhERhoh0/chN+Snr9ksTf2HtB1pFtYtY4wcrNuajgjWDHnVYRtP9EmJmth0BqItxBXYMC27yfFGG1FU0TqFmrnTYUvQKo7egagyPSxPargrfYrS9u0Dhbv/NRzSMz27rttbdwFVua9Sy8lZMP9CBU3BJZgg2NAkFFEh7LjwBeNJIR7Z+adaURZGohCWMb1XP855zNPX5BKbzF8D+gS2pdpE7wMAAA==",
    "Analytic Construction": "<None>",
    Area: "4",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "2620",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0.1",
    Width: "1460",
  },
  {
    ID: "977513",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABABFjUELwiAcxb/L/2wy3abTTlFBUIcxgg5jByvZBNNYFoyx756xott7j9+PV49Qns1xuGuQsPdnU+lLUK61GhCU3rjwAFmPc4zIgjBME7LMcJoLAVPzo1Z9r4aIxmFj1E0H3YNMcILgoF0buk8hKaEIKh9UMN6BJDjnCRcspYyLrBCMITiZ6wyntCAIdtq0XfjLW6tfX7vAnHIEa299vHJPa6fmDc/0XhzPAAAA",
    Pbi3DGeometry:
      "7wMAAB+LCAAAAAAABACdk1ELgjAQx7/LPc8xm6bpU1QQ1INU0EP0YDR0YC5sBCF+92ZZFqWuJhPvt9t/t/Nuk0Ow46vLkYEHM7HjS5HwPSAIBE/lCbxNfv9Uy8RXDxSoJoZJiH97qQnF9rFtmGXhRe01zD4m1EEWpvZggFzs9BxUQtq3zS7q2i5tw2/C3+mbsEGwRYn5oVzzh3up8R9tUtYIusH5lzg+7v1Dir6rNiSoDbcHoVEAncd1JlmrjnSKrvOf6GCdgladM+bhgUmWgUcwQTBnaSTjylgIGUou0spc8/1zacp4FMvKmCTs/Oo4EonIys69DdWgVzijI+PvAwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977514",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zQAAAB+LCAAAAAAABABFjbEKwjAYhN/ln2NI0po2cRIVBB1KERxKh6ihDcREahRK6bsbreJ2d3x3Vw1QnMyhv2mQsPMnU+pzUK6xGhAU3rhwB1kNk4zIjHLMCF2kOBWUwVj/qGXXqT6iMVgbddVBdyAJJgj22jWhfRuaUIag9EEF4x1IiucZyQRPGM9EmgvOERzNZYITllMEW22aNvzLG6uf3/ZnfOWtj0fuYe1YvwAHqGs1zQAAAA==",
    Pbi3DGeometry:
      "uQMAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzOz8lMUdJRCsjPzCspVrKKroYwgdIG1kCoVKuDENE1NDCwBhNArFQbC9PmWFSUWAnUq2topmdgbK5jomdiaWikY6BnaAykQKLGZqaGBIUNcIqhGIpFCNVASz0jC3QD4WJwpSADyBLFZipeZ2JRRYrFmL4kOjiwG4ojQPAJE3ADUfFMyEbc4Uo4mRBOUfgiAa8Q/uQJzAMumYm5qSWpRUpWIDVKPql56SUZUE5QfkliSWZ+HpQbnpkCl/JIzUzPKIFyXHNSy5AVOufn5BeB8iAYALMaABD3GPS5AwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977515",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zAAAAB+LCAAAAAAABAA1jT0LwjAYhP/LO8eQj6ZN6yQqCDqUIjiUDlFDG4iJ1CiU0v9utLrdHc/d1SOUZ3Mc7hoK2PuzqfQlKNdaDQhKb1x4QFGPs4zIgqaYEbpMcMKEgKn5U6u+V0NEY7Ax6qaD7qEgmCA4aNeG7mMopwxB5YMKxjsoKBYZyfKUszTLE5kLBCdznVnOJEWw06bt4q/EUkiOYGv161f+bq+99fHHPa2dmjdqdnKIzAAAAA==",
    Pbi3DGeometry:
      "uQMAAB+LCAAAAAAABAClk10LgjAUhv/LuV4yM8uPq6ggqAupoIvoQnHowFzYCET8782PSsql0sbGzrNz3o2znVMGjkcP6ZWABRvm0T2LqA8IHEZjfgPrlFVLsY1t0SFHbzJSMbbLSQzIz8+weZK4qYgdqVMFazM0UTTdNBFWMCqQNtVVCZuY6vgnq+RakFTNUAzd0L4ObuCGQE8qEf7E0su2Ow6+17CktMtJctIDd+dfyrpT1wP/8506X7STSk4SNbCk7oVwkoBV+MCWxAEPa2PHuMspi2vzSP3X1prQIOS1sYrIvem4YBFLihosmyi1B4iaPBq5AwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977594",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABFjcsKwjAURP/lrmPIwzZtXIkKgi5KEVyULlINbSAmUqNQSv/dSBV3M8M5TDVC0ZjTcNcg4eAbU+pLUK61GhAU3rjwAFmNc4wIY5iLhK4WlOCE8Bym+set+14NEY7D1qibDroHSTBBcNSuDd2nUE4ZgtIHFYx3IClOBBF5ylkq8mUWA4Kzuc4wZxlFsNem7cJf3ln9+toZFkwg2Hjr45V7WjvVb5aZMs7RAAAA",
    Pbi3DGeometry:
      "AQQAAB+LCAAAAAAABACVk1ELwiAQx7/LPZu4jTa3nqKCoB6igh5GD4ukhDVjSTCi755tq0Ztaori/Tz/yp0X32Cx4+vizCCCmdjxlUj5HhAsBM/kBaL4Vi3VNhmoDnf0IT2HkEE5qQH37evYMM+TQp11XewFfQcpF+z7FFEcuAFqUs8Lw25M+9Sz4pV4B36KOwEOqfsr0sK/3dtFdLRLWfdsCxXTQ8zR/itM2uBpsEV6jX/B/kbrWBu47gfaXGtOpUUiGuKqlsY8OTHJcogIJgjmLDvIY20shUwkF1ltbvj+vTVl/HCUtTFJ2bXpOBKpyJ+1XDZVsg9SyFTsAQQAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1339",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977595",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0gAAAB+LCAAAAAAABABFjdEKgjAYhd/lv55j09x0XUUFQV2IBF2IF6t+dLC2sBWI+O4ZFt2dc/g+TjVAcTbH/o6gYO/PpsRL0K6xCAQKb1x4gKqGOU5IxDkVUshlxBlNWZLDWP/AVdfpfqKnYWP0DQN2oBhlBA7omtB+Ck94TKD0QQfjHShOU8lkLpJYyHyR5UIQOJnrDCdxxgns0DRt+Mtbi6+vnVEZSwJrb/105Z7WjvUb68300dIAAAA=",
    Pbi3DGeometry:
      "JQQAAB+LCAAAAAAABACVU1ELgjAQ/i/3vMZMmtOeooKgHqSCHqIHo1EDc2EjiPC/t9JKMPXc2Nh93+6+cbfbPiDcq/X9IiGAud6rlY7VAQiEWiXmCsH2kR8tzYZ2QkZ+SM9hbPje7IJs93EbpWl0t749x6Hc4x6xdyjnggjq9V9WCXZd32/AxUC4SCIXqMNzAU4Z98WfOFWi4lATpxGujd7yfEQgxHPas98xZ82pbMYRNcd8Ebxsh9y3ES2/E6ONKi+iMiUB228TFZ2lkSkEjDICC5kczakwltpERumkMDfq8KVmUh1PpjCmsbyVL451rNNXv7+Hbesnj0ujeCUEAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1339",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977596",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABFjcsKwjAURP/lrtOQh0nauhIVBF2UIrgoXVQNbSAmUqNQSv/dSBV3M8M5TDVCcTbH4a4hh70/m1JfQuNaqwFB4Y0LD8ircY4RSSRWQohlQgkWhGcw1T9u1ffNEOE4bExz00H3kBNMEBy0a0P3KZRThqD0oQnGO8gpFoqoTHImVbZIMykRnMx1hjlLKYKdNm0X/vLW6tfXTrFiCsHaWx+v3NPaqX4DYVcFLdEAAAA=",
    Pbi3DGeometry:
      "EwQAAB+LCAAAAAAABACVU80KwjAMfpeca+mc3eY8iQqCHoYKHsTDhkULc5VZBJG9u3VOHWh/bGlpviRfSn42N0gyvrqeGMQwExlfipzvAEEieCHPEG9uz6dSk4HaUKEP0vEIGdSXOlBtX27DskyvyrcT4JBSipQJDoIIRTjshqiN+n6/r4cjGvlO+JNcA9fknodp7xfLD8WXg4bHCGvZjZ934bH/xpr2//JlTqMRt5fa3hd/xHRPugU3NqRTYJeq2ivSolfTNebpkUlWQkwwQTBnxV4eGmEhZCq5KBpxzXdv1ZTx/UE2wiRnl7bhSOSifEx3vdQQ3wG57LNFEwQAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977597",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABFjV0LgjAYhf/Lez3HPtTpuooKgroQCboQL2YNHawtbAUi/vcMi+7OOTwPpxqhaMxpuGuQcPCNKfUlKNdaDQgKb1x4gKzGJc5IRHHGY7aKKMEJ4TlM9Y9b970aZngetkbddNA9SIIJgqN2beg+hXLKEJQ+qGC8A0lxIojIU85SkcdZnqYIzua6wJxlFMFem7YLf3ln9etrZ1gwgWDjrZ+v3NPaqX4DKLMXLtEAAAA=",
    Pbi3DGeometry:
      "AQQAAB+LCAAAAAAABACVk1ELwiAQx7/LPZu4rTa3nqKCoB6igh5GD4ukhDVjSTBG3z1bq0Y1NUXxfp5/5c6LS5hv+ao4MYhgKrZ8KVK+AwRzwTN5higuH0u1TfqqwxW9ScchpF9NasB18zw2yPOkUGc7DqZe10XKBfs+RRQHboCa1PPCsB3THvWs+EO8BVfiPvbdXyLf/NP9t4iOtilrn21WMT7EGO2/wqQNng6b02v+C9Y3WsfawLU/0OJai1SaE9EQV7U04smRSZZDRDBBMGPZXh5qYyFkIrnIanPNd6+tCeP7g6yNccouTcehSEV+r+WqqZK9Ack8I1wBBAAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977598",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABABFjdEKgjAYhd/lv15jc+l0XUUFQV2IBF2IF7N+dLC2sBWI+O4ZFt2dc/g+TjlAXptTf0dQcPC1KfAStGssAoHcGxceoMphjhMiKEvlasEZjZnIYKx+1LrrdD+h07A1+oYBO1CMMgJHdE1oP4ULHhEofNDBeAeK01gymSUiSmS2TLMkIXA21xkWUcoJ7NE0bfjLO4uvr51SGUkCG2/9dOWe1o7VG1z/9iTPAAAA",
    Pbi3DGeometry:
      "ywMAAB+LCAAAAAAABACNk1ELgjAQx7/LPa+xGuWyp6ggqAepoIfowXDUwFysEYj43ZtpKdWciuL9dvff+J93yCA4iV164+DDSp7EVsYiAgSBFIm+g3/Iyk+zTCbmhhzVpNcnZPJ6mQfy47tsqlSYmlqKCfOQScCjEUMMewMP1YzS8dgG2ZBRJy1F/8JCtNfHHqE/9b/4K/mvQgu0qNoP61RwnKDd1u6utFllp44GOjrddaduprZS+4/l3s7ZLYffDVkzFXMRXrnmCnyCCYI1T876UgUbqUMtZFKFexF9lpZcnC+6ChYxfzQTZzKWqpjK12WG7wnV597yywMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977599",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABFjUELwiAcxb/L/2yis01np6ggqMMYQYexgyvZBNNYFoyx756xott7j9+PV41QNOY03DVIOPjGlPoSlGutBgSFNy48QFbjHCMiMCGCrRaU4JSwHKb6h637Xg2RjcPWqJsOugdJMEFw1K4N3adQRhMEpQ8qGO9AUpxywvOMJRnPlyLPMgRnc51hlgiKYK9N24W/vLP69bUF5glHsPHWxyv3tHaq3yJgTaDQAAAA",
    Pbi3DGeometry:
      "3QMAAB+LCAAAAAAABACVk1ELgjAQx7/LPa8xG9myp6ggqIeooAfpwWjkwFzYCCL87s2yktJdOZTdb7f/xv+88ArzrVpdjhICmOqtWupE7YDAXKvUnCAIr4+pXWZ9OyAnb9LyGOvfP/aFfPPcNsiy6GL3CsqY4MRmUN8XRNBuu0sqkPNer5GKjo1x/BCup4Uwp22vRuEbfyTXKjhgg6rjuqgEcgXM3T+ccdnVTNFKYkX/9bAfvXVjx1+Gn4iWDfW9Imz7ZKSigzQyg4BRRmAm072Jy2ChTWSUTstwrXavpYlU+9iUwTiR52riUCc6K/r0/th2vAFPWpAp3QMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977600",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABABFjUELwiAcxb/L/2yirum0U1QQ1GGMoMPYwZVsgmksC8bYd2+xott7j9+PVw6Q1/bU3w0oOITaFuYStW+cAQR5sD4+QJXDHCeEMiyZ5KsFJTgliYSx+nHrrtP9BE/D1uqbiaYDRTBBcDS+ie2n0IQyBEWIOtrgQVGcCiIkTxgXcplJzhGc7XWGE5ZRBHtjmzb+5Z0zr6+dYcEEgk1wYbryT+fG6g39Ybsx0QAAAA==",
    Pbi3DGeometry:
      "7wMAAB+LCAAAAAAABACVk9EKgjAUht/lXK8xFXWzq6ggqIuooAvpwmjkwFzYCCR691ZZSaZbDmXn29m/8R9PfIH5VqzKI4cIpnIrljITO0AwlyJXJ4jiy3Oql0lfD7iiD+k5hPQfH/3CdfPaNiiKpNR7HRczlwVIp+AgoIji0A1RnXoeY+2Y+tSz4k/xFnwXp9jxmN/QaOKv5J8KHbBFtevCRg3DHcwm/+NOl2Xt1KKkxvrbnmdrsYF3/XLmQ431s/C/Jq07ZySSA1e8gIhggmDG871Kq2AhVaKEzKtwLXbvpQkX+1RVwTjj53riUGayuHfu49ENegOe2Cc97wMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977601",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABFjUELwiAcxb/L/2yis01dp6ggqMMYQYexgyvZBNNYFoyx756xott7j9+PV41QNOY03DXkcPCNKfUlKNdaDQgKb1x4QF6Nc4wI5VikRKwWlOCUMAlT/ePWfa+GCMdha9RNB91DTjBBcNSuDd2nUEYTBKUPKhjvIKc45YTLjCUZl0shOYKzuc4sSwRFsNem7cLf3Vn9+soC8yQKG299fHJPa6f6DfzwzT7QAAAA",
    Pbi3DGeometry:
      "AQQAAB+LCAAAAAAABACVk1ELwiAQx7/LPZu4xja3nqKCoB6igh6ih8WkhDVjSTBi3z3bVo1qaori/Tz/yp23vcFiz9fFmUEEM7HnK5HyBBAsBM/kBaLtrV6qbTJQHUr0Jj2HkEE1qQHl7nlsmOdxoc46AaYeoUi5YN+niOKgH6A2dd0w7MbUo64Vr8U7cCXuYuL/Evnmn+6/RXS0S1n7bLOK8SHGaP8VJm3wdNicXvNfsL7ROtYGrv2BFtdapNKciJa4qqUxj09MshwiggmCOcsO8tgYSyFjyUXWmBuevLamjB+OsjEmKbu2HUciFfmjlqumSvYOmLPq9QEEAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977602",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABFjUELgjAcxb/L/zzH5nI6O0UFQR1Egg7iYdbQwdrCViDid29l0e29x++9V41QNPo43BTksHeNLtXZS9saBQgKp62/Q16NswxIRDkmXGTLiBKcECZgqn/gqu/lEOgQbLS8Kq96yAkmCA7Ktr57G8pojKB0XnrtLOQUJylJBWcxT8UiE5wjOOnLDLM4owh2Sred/5e3Rj2/7c/42hkXjuzDmKl+AbG2BMXQAAAA",
    Pbi3DGeometry:
      "AQQAAB+LCAAAAAAABACVU8kKwjAQ/Zc5pyWxENt6EhUEPYgKHsRDS0MbqI3UIEjpv5su7raJCQmZNzNvwiz7AlYh315PDHxYiJBvRMojQLASPJNn8PdF81RqPFIbSvRELILxqL7UgfJwdxvneXBVvhahNqaei5SNTamLsE0cMkBvuON4Xp8Cm6AN+U+wJSY2HdLhJ8U3+m3eRdOP/2bv/LbO3+gTBtn+K1GaBOoUJkU264o/YhvlvRft7URtQE1JdaW4k6pZmvLgyCTLwa+sYMmyWCatsBYykFxkrbjj0UM1ZzxOZCvMUnZ5NZyIVOTVLNdLjewN9rujhQEEAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1339",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977603",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABABFjUELgjAcxb/L/zxlc246O0UFQR1Egg7iYdXQwdrCViDid29l0e29x++9V49QnvRhuCkoYOdOulJnL21rFCAonbb+DkU9zjIgESExSxlbRATHDFMBU/MDl30vh0CHYK3lVXnVQ4FjjGCvbOu7tyGUJAgq56XXzkIR1jKcCU4Tnok0F5wjOOrLDNMkJwi2Sred/5c3Rj2/7c/4yhkXjuzDmKl5AWmI9ufQAAAA",
    Pbi3DGeometry:
      "7wMAAB+LCAAAAAAABACVU18LgjAQ/y73PGXLtLSnqCCoh6igB+lBceTAXNgIRPrurdT+oM61sbH73d3vxv3xC9iEbJ9fKHiw4iHb8YRFgGDDWSqu4PlF+ZRqPJEb7uiDGATjyeuSB+7H2m2aZUEufQ1CTHto20jamI4zRtgkFhmgH9yyXFelwDpoSd4KlsSOObIbDE2wYdzBoYRbmbs+3OOtEV8nyf/kR502Na5VWK1O0I+sk24lqmq9vnDKOvZWoKaUkzNnwZkKmoH3tII1TU8iroQtF4FgPK3EA4veqiVlp1hUwiKht2/DGU949pzc15ID+gDphLc67wMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977604",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABABFjU0LgkAYhP/Le15lP3T96BQVBHUQCTqIB6sXXdh2w7ZAxP/elkW3meGZmWqE4qQOww0hh509qRLPrjGtRiBQWGXcHfJqnKVHAhlKHvFFwGgYU5HBVP+4Zd83g4d9sFbNFR32kNOQEtijaV33NkwwTqC0rnHKGshZGCc0yaTgMsmiNJOSwFFdZljwlBHYomo79y9vND6/7c/4ymrrj8xD66l+AbzjZlTPAAAA",
    Pbi3DGeometry:
      "3QMAAB+LCAAAAAAABACVU98LgjAQ/l/uWWW2kNSnqCCoB6mgB+lBcejAXNgIIvrfm79KULe1sbH7dvfd+G4XviCI6el5I+DBjsX0yHKagAEBowW/gxe+mqO4Rr6Y8DZ+iGkj5NebWPC+dGHLsoyeItZ0LGc2nxnCxXKchYEsG9vC7MEYu64ER2qwIR7DGlLbWuBB/BAcOE9wSOFR5onnKoI10qvV/UMbuWRyXKOeOuXXT6uhswyU/DZVLmn5FMp3hKJP1jS6Ek5K8Con2JMi5VlrHBiPOGVFa55p8r3aEppmvDU2OXn0HVcsZ2XVp/UQ7fgBnXUPAd0DAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977605",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zgAAAB+LCAAAAAAABABFjUELgjAcxb/L/zxlc7mpnaKCoA4iQQfxoPVHB2sLW4GI372VRbf3Hr/3XjlC3qjjcEPIYG8bVeDZ1abVCARyq4y7Q1aOs/RIwEJJ+TJgNIwpT2Gqftiq7+vBsz7YqPqKDnvIaEgJHNC0rnsbxllEoLCudsoayFgYSypTwSMh00WSCkHgpC4zzKOEEdihajv3L281Pr/tz/jaauuPzEPrqXoBxwbfvs4AAAA=",
    Pbi3DGeometry:
      "pwMAAB+LCAAAAAAABACNk1ELgjAQx7/LPS+ZDdT0KSoI6kEq6EF6MBo6MBc2AhG/e9O0rHRTUbzf7n8n/9uCAvwzO+Q3Ci5s+JntecIugMDnLBV3cIPi9SmXsSdvKNGHTEyMvfolHyhPrWyeZWEutRPTsDFBMsOwLAdhwyTmFHUoIbPZMMY69irag+qCxMCO/a39Qz+JvWoF7KnY+4Mqna6n1sSxLqisUVD9uPSzHdlPZ6eCDW4hZZPh+aj9bUvJHb9k4ZUKmoFb5cCWppGIm2DHRSgYT5vwyC7vpTVlUSyaYJXQRzdxwROeVSeuvuTBegJwQWuopwMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977606",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zgAAAB+LCAAAAAAABABFjT0LwjAYhP/LO8eQD5s2dRIVBB1KERxKh6ihDcREahRK6X83WsXt7njurhqgOJlDf9OQw86fTKnPQbnGakBQeOPCHfJqmGREOGY044sZJTghXMJY/7Bl16k+sjFYG3XVQXeQE0wQ7LVrQvs2lFOGoPRBBeMd5BQnKUml4Eykcp5JIRAczWWCOcsogq02TRv+5Y3Vz2/7M77y1scj97B2rF9yD4vHzgAAAA==",
    Pbi3DGeometry:
      "uQMAAB+LCAAAAAAABACNU8sKwjAQ/Jc9x5I0IH2cRAVBD6KCh+KhpaEGaiM1CKX0300fPqht0oSE7GR3NsxmgxL2ET8VdwYebEXEjyLlMSDYC57JB3hB2R7VNfbVhAp9kRnB2G82taC6vMMWeR4WKpZaNnEoUh7WfO4gbBFKbPSDUuq64zA2YS3pANQQOhbG/eB/rO86TKBDh1gHn6mPNCY2qjlZDq1IOthcOnOdJ2c06qrBRn+UIY2mVHqh32SqB1Y8vDHJcvBqH9ixLJHXzjgIGUouss488/hztWE8ucrOWKfs+eu4FKnI6x5shmq1Fx18mQy5AwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977607",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zgAAAB+LCAAAAAAABABFjbEKwjAYhN/ln2NIGps2cRIVBB1KERxKh6ihDcREahRK6bsbreJ2d3x3Vw1QnMyhv2mQsPMnU+pzUK6xGhAU3rhwB1kNk4xIjikT6WJGCU4JEzDWP2zZdaqPbAzWRl110B1IggmCvXZNaN+GMpogKH1QwXgHkuI0I5ngLOGZmOeCcwRHc5lgluQUwVabpg3/8sbq57f9GV956+ORe1g71i9bs7cQzgAAAA==",
    Pbi3DGeometry:
      "ywMAAB+LCAAAAAAABACVU98LgjAQ/l/ueclUkqZPUUFQD1FBD9KD0tCBuVgjCPF/b/mjjHSrjY3dt7vvxne7sIBNzPb3CwUfVjxmO56xEyDYcJbLK/hhUR/VNQ7UhBK9kZGNcVBtakF5bMOmQkR3FTuxbJeMkfKwPG+CsDJtB3VQ1yVkGMYmrCbtgSpC27GIQ7zP6B7wy3mAQwv3Mvc+1hRrzm6U9Xdd9HJpcXMZzTX/I6dZYA02+MGMiXRV0yve0qmumLPoTCUV4D99YE3zRKaNseUykoznjXlgp9fVkrIklY2xyOit6zjjGRfPrqyGar4HYAaxlMsDAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977608",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABABFjbEKwjAYhN/ln2NIGps2cRIVBB1KERxKh6ihDcREahRK6bsbreJ2d3x3Vw1QnMyhv2mQsPMnU+pzUK6xGhAU3rhwB1kNk4wIZZhwki9mlOCUMAFj/eOWXaf6CMdgbdRVB92BJJgg2GvXhPZtKKMJgtIHFYx3IClOM5IJzhKeiXkuOEdwNJcJZklOEWy1adrwL2+sfn7bn/GVtz4euYe1Y/0CcPcE6M8AAAA=",
    Pbi3DGeometry:
      "3QMAAB+LCAAAAAAABACVU98LgjAQ/l/ueclMMrWnqCCoh6igB+nBcOjAXNgIRPrfm79KULe1sbH7dvfd+G7nF3C40XP+IODBjt3oiSU0BAQHRlP+BM8v6qO4xgsx4Y1+yMTEeFFtYsH72oYtsyzIRaxpGdjGDhIuhm07CBumZU5RF7Ys15XgWA3WxENYTTo3nFkvvg/2nEc4pPAg88hzFcEa6dXq/qGNXDI5rlFPnfLrp9XQWQZKfpsql7R8CuVbQtEnaxrcCScZeKUT7Eka8bgxjowHnLK0MS80/F5tCY1i3hibhLy6jiuWsKzs02qIdvwArlCIB90DAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977609",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABABFjbEKwjAYhN/ln2NJGps0dRIVBB1KERxKh6o/bSAmUqNQSt/daBW3u+O7u3KA/KQP/Q0hg5076QLPvraNQSCQO239HbJymGRAmIxUGrPFjNEooVzBWP24ZdfVfYBDsNb1FT12kNGIEtijbXz7NoyzmEDhfO21s5CxKJFUKsFjIdU8VUIQOOrLBPM4ZQS2qJvW/8sbg89v+zO+csaFI/swZqxeZbzIb88AAAA=",
    Pbi3DGeometry:
      "3QMAAB+LCAAAAAAABACVU8sKwjAQ/Jc9x5I0qH2cRAVBD6KCB/FQaWgDtZEaBBH/3fSlom3SJiRkJ7uzYTZ7eMD6xHf3CwMPluLEtyLhISBYC57KK3iHR3lU19hXE57ogwwIxn6xqQXPYx02ybLgrmLJ2HIdmyDlYo1GDsIWocRG3zClrqvBsRksiZuwgtS2LToe/sQ3gH/OLRxauJG5+bmmYHP6Dur20EYvmRbvUs8O5e+RtoPOOrD9txlz6cpnUr4mVH0y48GZSZaBlzvBiqWRjCtjI2QguUgrc8/D99WC8SiWlTFP2O3bcSoSkeV9WgzVji/zGsl43QMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1339",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977610",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "0wAAAB+LCAAAAAAABAA1jVELgjAUhf/LfZ7idnUue4oSgnoQCXoQH7SGDtYWtgIR/3sr6+3cw3fPV01QtOo03iVkcLCtKuXFNabTEggUVhn3gKyalugRxsIk4rgOaOQDrmCu/9xmGJrRw77YqeYmnRwgi8KIwFGazvWfgyJlBErrGqesgQxDGgshOI9jyhExTfOAJgTO6ro8IBOUwF6qrvd6EYpEIIFcy9dv4SvYWm29zDy1nus3RVl9odMAAAA=",
    Pbi3DGeometry:
      "3QMAAB+LCAAAAAAABACLrlYKSMoMqSxIVbJS8s5PygzOz8lMUdJRCsjPzCspVrKKroYwgdIG1kCoVKuDENE1NDCwBhNArFQbC9PmWFSUWAnUa2SkZ2xuaqgDVKJnZmahY6BnoIMsZmxsaQkTNDUwMyZREJuRSGKomi30LEwtjDGtxyIOMoOgMIorsAijGY7N0TiMIM0deH1OIIQIGUlqwCHHEtERj8tUgiGJV5zCpEZ8POMRxmUdMJ+4ZCbmppakFilZgRQp+aTmpZdkQDlB+SWJJZn5eVBueGYKXMojNTM9owTKcc1JLUNW6Jyfk18EyqdgAMyOAOJKU6HdAwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "977611",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zQAAAB+LCAAAAAAABAA1jbEKwjAYhN/ln9OQNKamcRIVBB1KERxKh1RDG4iJ1CiU0nc3Wt3uju/uqhGKxpyGuwYJB9+YUl+Ccq3VgKDwxoUHyGqcZUQSmuGU0FVCCeaE5TDVf27d92qIcAy2Rt100D1IggmCo3Zt6D6GMpoiKH1QwXgHkmG6oDxPM864yJc5grO5zihLBUWw16bt4rHAgguGYGf169f9Tm+89fHGPa2d6jcWZTR4zQAAAA==",
    Pbi3DGeometry:
      "7wMAAB+LCAAAAAAABACtk1ELgjAQx7/LPa8xk2TaU1QQ1INU0IP0YDRyYC5sBCJ+96ZZqalp5FC83+3+u912Tgz2gW+jCwMLluLAN8LnR0BgCx7IK1hO/PhVbjJWAxL0JgONkHH2US8k+2fYJAzdSMUONAMTw6RIzcGGQRHFdER1VOK6bppFx5BoP/Em/QovyRBMapL5oKlEKyzmUGUlyYZk6+K7r/5tqx0r067dp17VI+p9B+r1WyvaDP926bqcdhNrX0t1zoy7ZyZZCFYaDisWnKSXG2shXclFkJs7fny5FoyfPJkbc5/dihOnwhdh2rnZoxr0DnYtyZzvAwAA",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "978551",
    Name: "System Panel: Glazed",
    Category: "Curtain Panels",
    Level: "Level 1",
    Pbi2DGeometry: "wwAAAB+LCAAAAAAABAA9jMsKwjAURP/lrmtIa1+JK1FB0EUpgovSRaqX9kJMpEahlP67Qau7OcOZqUYoGjoNdwQJB9tQiRenTKsRAigsGfcAWY3f6JVFmLKIhyvBYhHlMNU/a933avCqL7akbuiwB8kZD+CIpnXdDKV1ypE1IEOWZDwT6TJKMxHnIgngTNe/uEdqOzfDTuNrnn14Y7X19+ap9VS/Aa/tV0rDAAAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    "Analytic Construction": "<None>",
    Area: "0",
    Cost: "0",
    "Define Thermal Properties by": "Building Type",
    "Design Option": "-1",
    Family: "Glazed",
    "Family and Type": "Glazed",
    "Heat Transfer Coefficient (U)": "0.0000 /(·)",
    Height: "0",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Material: "Glass",
    Offset: "32",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Solar Heat Gain Coefficient": "0",
    "Thermal Resistance (R)": "0.0000 (·)/",
    Thickness: "25",
    Type: "Glazed",
    "Type Id": "Glazed",
    "Type Image": "<None>",
    "Visual Light Transmittance": "0",
    Volume: "0",
    Width: "0",
  },
  {
    ID: "978557",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABABFjUELwiAcxb/L/2yirnTaKSoI6jBG0GHsYCWbYBrLgjH23TNWdHvv8fvxqgGKsz32dwMK9uFsS3OJ2jfOAIIiWB8foKphigmZUY4ZoUuJWU4ZjPWPWnWd7hOaho3VNxNNB4pgguBgfBPbT6EZZQjKEHW0wYOieCGIkDxjXMh5LjlHcLLXCc7SAYKdsU0b//LWmdfXzrFgAsE6uJCu/NO5sX4Dn6Et388AAAA=",
    Pbi3DGeometry:
      "3QMAAB+LCAAAAAAABACdk1ELgjAQx7/LPa8xtXLaU1QQ1ENU0IP0oDRyYC7WCCL67s0yK1q6Uhzeb7f/bre76AyzhC9PewYhTETCFyLjG0AwEzxXBwij8/1XT5OefuGCnqTlENK7DfqDy/qxrC9lfNJrW04XE89HAXap4yKKfddHBfS6HaeJ0g716vCbsJm+CbdxOzAIV/jhXCj8Ab+oWoRr9rUP4eO4P2TGKGrOSw2tj8Di0hs2a8qtVeHYVFnDVVhQm/LVfTLk8Y4pJiEkmCCYsnyr0tKYCxUrLvLSXPFNNTVmfJuq0hhl7PjqOBCZkEWf3h7djldTQZfX3QMAAA==",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "1460",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "978558",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABAA9jMEKwjAQRP9lzzWkraZNPIkKgh5KETxID6kubSAmUlehlP67Qau3ecObOQ9Q1ObY3xEU7H1tSryQdo1FiKDwxtED1Hn4xqDMYsESHi8lS6XIYax+1qrrdB/UUGyMviFhB4ozHsEBXUPtBKUnTcY7UDFbZDyTIk1EJue5FCKCk7n+zR2apqUJthZf0+7Da299+HdPa8fqDcAldYTEAAAA",
    Pbi3DGeometry: "AgAAAB+LCAAAAAAABACLjgUAKbtMDQIAAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "0",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "978559",
    Name: "Rectangular Mullion: 64 x 128 rectangular",
    Category: "Curtain Wall Mullions",
    Level: "Level 1",
    Pbi2DGeometry: "zAAAAB+LCAAAAAAABAA1jcsKwjAURP/lrmPIo480rkQFQRelCC5KF1FDG4iJ1CiU0n83Wt3NDGdm6hHKszkOdw0S9v5sKn0JyrVWA4LSGxceIOtxlhFZ0AwzQpcF5kkmYGr+1Krv1RDRGGyMuumge5AEEwQH7drQfQzllCGofFDBeAeS4jQneZFxluVFIooUwclcZ5YzQRHstGm7+CuwSAVHsLX69St/t9fe+vjjntZOzRvfGLWSzAAAAA==",
    Pbi3DGeometry:
      "uQMAAB+LCAAAAAAABAClk1ELgjAQx7/LPa+xaZrpU1QQ1INU0EP0oDRqYC5sBCJ+96ZZSbk02tjY/Xb337jtthn4IV+nZwYuzEXIVyLie0DgCx7LC7jb7L5U28RTHXL0Ij1KiFdOakC+e4SNkiRIVWyP2piYAzTEhkMNRDBBBTJti2pYnxr9r+wu14C0ag52LMf8OLiGawIdqUb4HWsv2+z4871+S0qznCYnHXB7/rWsPXUd8D/fqfVFW6nmJFUDEx6cmGQJuIUPLFh8kMfKWAoZSC7iytzw/XNrxvjhKCtjGrFr3XEsIpEUNVg2VWo3kKA7rbkDAAA=",
    Angle: "0.00°",
    Area: "0",
    "Corner Mullion": "No",
    Cost: "0",
    "Design Option": "-1",
    Family: "64 x 128 rectangular",
    "Family and Type": "64 x 128 rectangular",
    "Host Id": "SH_Curtain wall",
    Image: "<None>",
    Length: "2700",
    Material: "Metal - Paint Finish - Dark Gray, Matte",
    Offset: "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Position: "Perpendicular to Face",
    Profile: "System Mullion Profile: Rectangular",
    Thickness: "100",
    Type: "64 x 128 rectangular",
    "Type Id": "64 x 128 rectangular",
    "Type Image": "<None>",
    Volume: "0.01",
    "Width on side 1": "20",
    "Width on side 2": "20",
  },
  {
    ID: "981963",
    Name: "Seat - Single with Island: Model with Island",
    Category: "Furniture",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry:
      "0wAAAB+LCAAAAAAABAA1jUELgjAYhv/Ld55jm845O0UFQR1Egg7iYdbQwdrCViDif29R3V4enoe3maHqzGm6ayjh4DtT60tQrrcaEFTeuPCAspm/MyoZwZwLvkpSikWeFrC0f289jmqKcgRbo2466BFKggmCo3Z9GKCkDGeMUQS1DyoY7yLCXBAh85TlQmaF5AjO5vqROSZUSAR7bfohXjMsBEsR7Kx+/eKE4oJkMdl46+OZe1q7tG8YWX2Y0wAAAA==",
    Pbi3DGeometry:
      "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",
    Area: "14",
    Cost: "0",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "Model with Island",
    "Family and Type": "Model with Island",
    Host: "Level : Level 1 Living Rm.",
    "Host Id": "-1",
    Image: "<None>",
    "Leg Material": "Herman Miller - Veneer Z5 Maple",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Sofa Material": "Herman Miller - Seat Fabric 8T07 Crossing Pumpkin",
    Type: "Model with Island",
    "Type Id": "Model with Island",
    "Type Image": "<None>",
    Volume: "1.88",
  },
  {
    ID: "982762",
    Name: "Sofa - Ottoman: W600XD600",
    Category: "Furniture",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry: "wgAAAB+LCAAAAAAABABNjNEKgjAYhd/lv55ja2q6rqKCoC5Egi7Ei1k/Olhb2ApEfPcWGXR3zvk+TjVC0ejTcEeQcHCNLvHilW0NAoHCaesfIKvxG4MiBGWcp6tIMLpI4hSm+uet+14NQQ7DVqsbeuxBMsoIHNG2vgPJab7MCZTOK6+dnelZX//gHnXb+U/lcSYI7Ay+ZjviNGNxQmDjjAvf9mnMVL8B0g98VsIAAAA=",
    Pbi3DGeometry:
      "/RYAAB+LCAAAAAAABAClWF1r20AQ/C/3rIj70klyntKmUGgfQlvoQ/CDQ0wicK3iikII/u89S7JrWzd7tzYhIc54dmbvtLvePL6Lh6fmx9vvpZiJL+1T871dNc8iEw9ts+7+iNnj+/Crh+Wt/xLb7P9fbpSUt/0P/y228z3tbrNZvHmu0bkqKpfdGJUrWfpfZO4KpzNj8spZCtB1bqVKAfYaEIiLq7yStggwzoGDRhSY2D0HrtJwO2ZIgw8kiqec1aAB7XKAiDg8xABwqnEVkCie8jCc3sdEnANExHUudWl6QJfSHCc4AD6UNlVFADIvq9ImAAcNCBxpGFWNgB1CFSai0TN6wNoThrX1EKoq6x7Q/p1xxg7QSp8w6Dygq1AeNMDKA9p1xaBh5ODK1dZdE2oHSGlPQkGNejgqY4pewpWmpCPVwxGq0uhjgtLjk2vc2KedTCDsAKumhJAlrjKeKZCBPIEpFNUIpUeeLLyK0N2FS9/kdb2XoIF9AUAgvYuc94RJZZDiynIqHDI8UFaG6AmszGGF4wTZeUC78CFhhvJAUVqiJySXOIzkASM1p8Yhww/AuiK6QsgUU5uqZeQWmIIfgKlPrSgUvibQ9sD1Rat/MsYnwHlxQCBeTscaqGSxxo4xmb3Uo04zJpM0mgd0lV79F+UB7cIKvDDUZKrwq5wK1TMmI42qApoxGdmUK7Y4XmchA7mKLMBQI5QgfbqsPo2KM7KocHYeoAFXNKItAfFLdulI60u3S3zwgZtxhME/RKgR7+1RxiV5gIUrfbBcY5cQD/Zdaj8Mb3uwi1L7YXh3g0fCz4NKkJ8HtAu7DzMU3GP484O9zsLuipcusCJSnnjS1IxAZrmbLvX/Vriuw1tC8zR4ffNM3DeLX8tuuREzmctMfF2uX7rX8cW3tlt0TbseX/5sng/Q52Xz8tqNLz6tln+P3/ixXbU+oPhw77RxYjv/BxYoaMf9FgAA",
    Area: "1",
    Cost: "0",
    "Default Elevation": "0",
    Depth: "600",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "W600XD600",
    "Family and Type": "W600XD600",
    Host: "Level : Level 1 Living Rm.",
    "Host Id": "-1",
    Image: "<None>",
    Keynote: "12490.Y3",
    "Main Unit": "Herman Miller - Seat Fabric 8T07 Crossing Pumpkin",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "W600XD600",
    "Type Id": "W600XD600",
    "Type Image": "<None>",
    Volume: "0.12",
    Width: "600",
  },
  {
    ID: "983030",
    Name: "Sofa - Ottoman: W600XD600 2",
    Category: "Furniture",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry: "wQAAAB+LCAAAAAAABABNjMEKwjAQRP9lz2lI2qptPIkKgh5KETyUHqIubSAmUlehlP67ESt4m5n3mGqA4myO/R1Bwd6fTYkX0q6xCAwKbxw9QFXDNwYlSbiQcr6M4ozLOIax/mmrrtN9cMOwMfqGhB0owQWDA7qGWlCS54ucQelJk/Fuoidz/YM7NE1LnyrTLGGwtfia7EjyTKQzBmtvffh2T2vH+g3+lzZfwQAAAA==",
    Pbi3DGeometry:
      "qRYAAB+LCAAAAAAABAClWN9r2zAQ/l/87AhZv5U+ja0w2B7KNthD6UNLTWvI4pGZQSn936faSZba+k5SSkiI73Tfdyf57ny+fq6u7rofT7/bal196e+67/2mu6/q6qrvtsOfan39PP0Nan4RPtVL/V+yaji/GH/Ct3q5OZh92O1un4KtFKzRztQr4Zi3ul5xZrQRtZTMGUXJLRPGp+VHfCRP8DbMcaWX6xfyPX5KPvdzIT8b33BrYvil8kze5P5M+MjPfDnNi/ZtKZ/hny3P5E2e+2z/Z7z5cppXMC6sHOWNtO40sL3Cs4YbSSg4s86qHMWBAypOOGTjJoUSYrTQMsExWbwqGvfGQik/QWmtRoUICzIsPOPO2TcWiTigV5E4EoqSOKC7Ru85rBk5jFfmXVBBYabIj1CQw09bJbgcKYyVlkby0xZyxe2pQSMON66cCrHhOeuDgvvl+ohDhbywYaD1wJ94g0niL+OiNxSeQOTI4hkvmffa5SgO9z1U5BePRSmYJwRJ3qiSxIYWQWGdpEpBSeQwsXGAxXFAd+FNUggVFNoqqhTkZjZECgrJRUFuQ4PQ9bwjikHEpTJmIouBp3GH0OMs8RgKcPDpgDIHTi2d9POmvVAscgIqkll0yoEyFXOMFvNOS93hCYt530zHAb3KTvqz4oDuwsQ7F2reTMqTm4KaLOadjEiChMGsR1M+lVLDsRStBx4lxliEv4wssaklVRnlZGIUyR5pAAGavYhKFGcuH4pTpS7XVeLxBs25KYPi3UMMyTqetDgjCDBJ5feQ93hLkEdLLDX4xcc4WDCpwS8+lMEtKY+DCrA8DugurDiFUHBSKW8VxXMqKqh4qoqPf5RHRcRERwCOls2vxAtSNH/Dw0E9M3pqN3X1qbv91Q7trlpzxuvqa7t9GB73F9/64Xbo+u3+8md3f1R9bruHx2F/cblp/54u/Nhv+gBYWaUv9eur5X9mFtUTqRYAAA==",
    Area: "1",
    Cost: "0",
    "Default Elevation": "0",
    Depth: "600",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "W600XD600 2",
    "Family and Type": "W600XD600 2",
    Host: "Level : Level 1 Living Rm.",
    "Host Id": "-1",
    Image: "<None>",
    Keynote: "12490.Y3",
    "Main Unit": "Herman Miller - Veneer Z5 Maple",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "W600XD600 2",
    "Type Id": "W600XD600 2",
    "Type Image": "<None>",
    Volume: "0.12",
    Width: "600",
  },
  {
    ID: "983156",
    Name: "Sofa - Ottoman: W600XD600",
    Category: "Furniture",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry: "wgAAAB+LCAAAAAAABABNjNEKgjAYhd/lv55jSy23rqKCoC5Egi7Ei2k/Olhb2ApEfPcWGXR3zvk+TjlCXuvzcEeQcHS1LrDxyrYGgUDutPUPkOX4jUGJY8o4X66jRUpFJlKYqp+36Xs1BDkMO61u6LEHySgjcELb+g4kp2IlCBTOK6+dnelFX//gAXXb+U/lSRYT2Bt8zXbEacaSlMDWGRe+7dOYqXoDkUIWYcIAAAA=",
    Pbi3DGeometry:
      "/RYAAB+LCAAAAAAABAClWMFq20AQ/Zc9y8tqV1pJziltCoX2ENpCD8EHh4hE4FrFFYUQ/O/dWFKqSPtmd2xCQpznN+/NrmbGk7sXcXvf/Hj+XYu1+NLeN9/bXfMgEnHbNvvuj1jfvfS/OlhduS9xTP7/ZZUqdXX64b7FcTPSrg+H7bPjGi3TvLTJSltZZjpPVkra3OrEGFnajARymRobA7xpQCAonspSZbmHsQBGjSCwsLsALtGwqrBeDT4QKx5xVr0GtMsBAuLwED3ATOMSIFY84mGY3cdcnAMExLVUujAnQKlcTxMcACurwhQEoGRRFlkMMGpAYKJh0nIAqj5UbgIaPcMBtjLvGFlW9aG0Lk+Adu+MYDjgtSNMGYE8oCtPHgGAkwe0a/NBI+td2SqzF4VygMnNu1BQoxqOqlAnCft6MmSkajhCVaZTQqrHJ1cNfdqqGIKrgcJ6CB5LXGU8UyADeQJTKKzhSY8+WXgVnrvzl76RVTVK0MBYABCI7yKLnjCvDFI8zTgVDhkOKEpD9QRO5rDCcYLsPKBd+JAwQzkgLzKqJ8SWOIzkAKM0p8Yhww3AqqS6gscUU5uqZeQWmIIfgKlPrSgUvibQ9sD1hat/PsYXwKI4IBAsp6kGKlmscWLMZy/1qAcY80kazgO6iq7+s/KAdmEFnhtqPlX4VU6F6hnzkUZVQYAxH9mUK7Y4XmchA7kKLcBQw5Ng4HQ5fRoVZ2hRYew8QAOuaERbAuLn7NKh1hdtl/jgAzfjEIN/iFAj2NuDjHPyAAtX/GC5xC4h7u271H7o3/ZgF6X2Q//uBo+EnweVID8PaBd2H2YouMfw5wd7nYXdFS9dYEWkPPGkqRmBzHI3Xer/rXBdh7eE5qn3+jaJuGm2v+quPoi1kioRX+v9Y/c0vPjWdtuuaffDy5/Nwxv0uW4en7rhxadd/Xf6xo/trnUBxYcbq40Vx80/r0GnXf0WAAA=",
    Area: "1",
    Cost: "0",
    "Default Elevation": "0",
    Depth: "600",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "W600XD600",
    "Family and Type": "W600XD600",
    Host: "Level : Level 1 Living Rm.",
    "Host Id": "-1",
    Image: "<None>",
    Keynote: "12490.Y3",
    "Main Unit": "Herman Miller - Seat Fabric 8T07 Crossing Pumpkin",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "W600XD600",
    "Type Id": "W600XD600",
    "Type Image": "<None>",
    Volume: "0.12",
    Width: "600",
  },
  {
    ID: "983164",
    Name: "Sofa - Ottoman: W600XD600",
    Category: "Furniture",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry: "wgAAAB+LCAAAAAAABABNjNEKgjAYhd/lv55ja2q6rqKCoC5Egi7Ei1k/Olhb2ApEfPcWGXR3zvk+TjVC0ejTcEeQcHCNLvHilW0NAoHCaesfIKvxG4MiBGWcp6toIWiWpDlM9c9b970aghyGrVY39NiDZJQROKJtfQeS03yZEyidV147O9Ozvv7BPeq285/K40wQ2Bl8zXbEacbihMDGGRe+7dOYqX4DuXGUmcIAAAA=",
    Pbi3DGeometry:
      "qxYAAB+LCAAAAAAABAClWFFr2zAQ/i96doQsyZKdPnXrYLA9lG2wh5KHlJrWkMUjM4NS8t8noiRLbH0nyaW0JPp033cn+e58fXhj94/dj9ffLVuyL/1j973fdE+sYPd9tx3+sOXDm//oYHHjfti++L+yKIW4Ofxxv2y/Opnd7nbrV2erJC+r2hQLqbkti4XgpjKyUIrXRhPLiguhmgTgzA8BUrjktdDVZPdk+cQeBSaOToD5CkZYE1TIB1LFI6fk+aGrOQApDA5vsjxin7ecJplw8aPTv5ZNXY7ISi6kVQ6QvLbSXoZ1BDSvdSkJQHBbW50CnDQgcKGhyvoIWE9VqYiGt3CAMvbKQuvGUzVCHQDpdiZYOEAqc2URiQN6FYgjAuTEAd01lddoytLXsEabd1E5QPjIz1RQo/FH1aj6IGGssjRT44/Q2spcGpTy8OQ6Jr/diJTtDtDHen5lEHAoTxf3C7Af+RPsL3H+QGD0icIrCNxZOOUVb5qTBA2cHnwIpFePSS0YZwQpXuqczIYWDrC1ompBTuQws3GA2XFAd+FDkknlgMpqqhakpjZkcoASMie7oYVrfE1N1YOAU5naOJORr8Al8FKL30QRDb4gUOrAxcXzfty4J8AkLSAQTaRLDZSsWONgMe621EMesRj3zngc0KvkvJ8VB3QX5t5cqnE/yc9vispbjJsZlQURi+tGTfmULY2GU7g/7FFsmAX8k8AiZ5pTl1FK0sNI8kwD+MHoRZQhIDxnKo6VukRniRccOOXGLHKPDypE63jUYk4UYJxKbyLvcZcQD9ZYavoLz3KwYlLTX3gyg0eSHwcVYH4c0F1YczKp4LSS3yuyh1VQUfFgFRwBKX9yZKl+EHYzb4Kl/kcKRnB4M6hjBq9sVbC7bv2rHdodWwouCva13T4PL8cv3/phPXT99vj1Z/d0hj633fPLcPzyadP+vdz4sd/0jpB9uDPuRYbtV/8AUUlD56sWAAA=",
    Area: "1",
    Cost: "0",
    "Default Elevation": "0",
    Depth: "600",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "W600XD600",
    "Family and Type": "W600XD600",
    Host: "Level : Level 1 Living Rm.",
    "Host Id": "-1",
    Image: "<None>",
    Keynote: "12490.Y3",
    "Main Unit": "Herman Miller - Seat Fabric 8T07 Crossing Pumpkin",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "W600XD600",
    "Type Id": "W600XD600",
    "Type Image": "<None>",
    Volume: "0.12",
    Width: "600",
  },
  {
    ID: "983236",
    Name: "Sofa - Ottoman: W600XD600",
    Category: "Furniture",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry: "wQAAAB+LCAAAAAAABABNjNEKgjAYhd/lv55jpua2rqKCoC5Egi7Ei1k/Olhb2ApEfPcWGXR3zvk+TjVC0ejTcEeQcHCNLvHilW0NAoHCaesfIKvxG4OSMMpzsYoWCeXZUsBU/7R136shuGHYanVDjz1IRhmBI9rWdyBjKnJBoHReee3sTM/6+gf3qNvOf2qc8oTAzuBrtqOYcpZmBDbOuPBtn8ZM9Rs34QTOwQAAAA==",
    Pbi3DGeometry:
      "jBYAAB+LCAAAAAAABAClV1Fr2zAQ/i96dows2ZKVPm3rYLA9lG2wh5KHlJrWkMUjM4NS8t+n2E4a2/pOkktpqfX5vu9O0t357l/Z3UP98+VPxdbsa/NQ/2h29SNL2F1T79u/bH3/2v9rYX5jf9gxeVtZZZzfdH/sLztuzmYfDofti7WVPOVCJSuRpzpLVjxVhRKJzFItRYaXZcq5NAHAmR6tk7JZWvK8mL48XT1T+9ZnPs6ApfyKa+XkjwfCpOnt6cmRm+HrlCbYs9nymHvJaphewGFP9nysGrpMywqTliYvLSDSUgt9IXoD8rTMM0EAPNWlzkOAswYErjWMHADdUxXSp9FZWEAqfW1hMpH3VIbLDhBZGWJhASHV2IKOA3rlioMGIuKA7hopRWdhsqwvWiZX76KyAO8jv1BBDcV7DSPLTkNpqWmq3sLeXF2okYXp7q6l6t9XPOh9C+RDCR9bOHyKkUY9gvDU6RDoKV52R1yeLYWHMD82d9bbAlIqKUOA4e5DIKKAzMrBJClI8aIsI5IbWpyAvNBUOYiKHCQ3DjA+DuQuviVxVCdA5IYqB6HJDalOHctoHZHe0OIEKEXVA4dBpLYzk0lXXR6hr1j47QlI8OnAMuc8toCsn3TuOTBLCgh40+hKA6Yq1OgtJu2WvOIei0nzDIgDehWa9cvigO6ixFtMNekm8clNUQ0Wk1ZGpRJtMG7pVPGIFgaTKHrd7Y5nbnWzT1l8uxlRjmEy0nNI8DgD+N0zF1F/gO6CIdhX4oJcxZ9UwCO/QeTOQX5v7fZaxIYAR6iIvrHYW1LcWVbpic81v8EiSU187mkMbkl8HHSAsXFgd2EXiKOC40l8e4gfUN2llBylXCMi5VCELtkI3G5GDKyQnZhk0cHALuk8sU3Cbuvt76qtDmxtvUvYt2r/1D4PD9+bdtvWzX54/FU/XqAvVf303A4Pn3fVv+sXPzW7xhKyj7fKfrqw4+Y/jfSB2IwWAAA=",
    Area: "1",
    Cost: "0",
    "Default Elevation": "0",
    Depth: "600",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "W600XD600",
    "Family and Type": "W600XD600",
    Host: "Level : Level 1 Living Rm.",
    "Host Id": "-1",
    Image: "<None>",
    Keynote: "12490.Y3",
    "Main Unit": "Herman Miller - Seat Fabric 8T07 Crossing Pumpkin",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "W600XD600",
    "Type Id": "W600XD600",
    "Type Image": "<None>",
    Volume: "0.12",
    Width: "600",
  },
  {
    ID: "983306",
    Name: "Sofa - Ottoman: W600XD600 2",
    Category: "Furniture",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry: "wQAAAB+LCAAAAAAABABNjNEKgjAYhd/lv55j04W6rqKCoC5Egi7Ei5k/Olhb2ApEfPcWGXR3zvk+TjVB0ejzeEeQcHSNLvHqle0MAoHCaesfIKvpG4OSMJql+TqKOU1jIWCuf9pmGNQY3DDstLqhxwEko4zACW3ne5Cc5mlOoHReee3sQi+6/YMH1F3vP5WLLCGwN/ha7IjTjIkVga0zLnzbpzFz/QakQUe+wQAAAA==",
    Pbi3DGeometry:
      "0hYAAB+LCAAAAAAABAClWN9r2zAQ/l/07Bj9siSnT2MrDLaHsg32UPqQUtMasnhkZlBK//cpsdMmtr6T5FFaYn357ruTdHe+3r6wm/v2x/Pvhq3Zl+6+/d5t2wdWsJuu3fV/2Pr2ZfjoYX7lf9hr8b6yEpxfHf/4X/Z6d6J92O83z56reMmlKVZSlpW1uljx0lRGFkqUVklBAbx0VqQAJwm0HpUWpeO6mhOm6yeB2PrM0xmwXMFwa4IK+UCadHyTBgHkavo6rQv3LgBcKixfT1VOuACTU5hq5wC0uKxLV2t3BKzm4s3UOyBLy50hAM90XisBOGlA4FyjViOgB1OVimkcGQdAy3NGLaQeTPk9OQJSuBSGLE0txCWDjgN6FYqDBjLigO7WSsmBYQevTK3Nf5nygOXywhTUMHzQcLxyR8AqS5saGB7Q6oJQn66uGiuz4SkEvy5EiBDwKUsaNRHS16BPsO1EFQLBRfYVnsT87MKp76uIM0qlAGMCQCCjisxqwiQzSPHKuTkD3nPIOAC6slRNyIocZDgOMD8O5C6+JXmmDoDUNVUTEjMcWjp0rdra9AxHhMO6MVRFmH8/TxikMelpyCP8pku8nwJD+HhQsQseW0LWT9r3HJglBQSiaXSmAVMVagyMSc8lr3iEMemgCXFAr1Kzflkc0F2UeYtNTbpJdnZTlkbCpJNRyUQTpn2dqB/ZynBgRQTkUWTARQpzS7FtTS/LMCdjc0nGiAM00DxGFCOgvWBcjtW7RGfxGxbwKU7I3j+oEC3mUUZuEHCwymgki70lxYN1lp4DQ1MdrJrUHBie0eCW5MdBB5gbB3YXtoU8U3BeyW8Y+WMrqqrkdBWeHSmnsrTJ3oCczZpnoQI56KJDgi00eHp3BfvUbn41fbNna+9fwb42u8f+aXz41vWbvu124+PP9uEN+ty0j0/9+HC9bf6ef/Fjt+28QWZ1dV0d/gf9D28DHGPSFgAA",
    Area: "1",
    Cost: "0",
    "Default Elevation": "0",
    Depth: "600",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "W600XD600 2",
    "Family and Type": "W600XD600 2",
    Host: "Level : Level 1 Living Rm.",
    "Host Id": "-1",
    Image: "<None>",
    Keynote: "12490.Y3",
    "Main Unit": "Herman Miller - Veneer Z5 Maple",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "W600XD600 2",
    "Type Id": "W600XD600 2",
    "Type Image": "<None>",
    Volume: "0.12",
    Width: "600",
  },
  {
    ID: "983388",
    Name: "Sofa - Ottoman: W600XD600",
    Category: "Furniture",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry: "wQAAAB+LCAAAAAAABABNjNEKgjAYhd/lv55jQ8VtXUUFQV2IBF2IF7N+dLC2sBWI+O4tMujunPN9nHqCsjWn8Y6g4OBbU+ElaNdZBAKlNy48QNXTN0YlZVQUcpVwSXPJBczNT1sPgx6jG4et0TcMOIBilBE4outCD4pTWUgClQ86GO8WejbXP7hH0/XhU3kmUgI7i6/FTjgVLMsJbLz18ds9rZ2bN0OigtDBAAAA",
    Pbi3DGeometry:
      "0hYAAB+LCAAAAAAABAClV01v2zAM/S86O4Ys2ZKcnrp1wIDtUGwDdih6SFGjNZDFQ2YMKIr89/krWWzr0WKCom2sl8dHSiJpPryL+6fyx9vvQqzFl+qp/F5ty2cRifuq3NV/xPrhvf/YwPKm+RGH6P/KKpHypvvT/IrD45F2u99v3hqulrFUJlopGadpmkcrGZvMqEgnsdUqIYDENR+cCwAGCbS+LJ3ETqbZnDBZPwksrc88nQJXKBhpjVeBDwRJB2xSL4BcDV+ndeHeeYCRwhXrgcohF2B8CjNtDkCLqzx2eeo6oDNxNHUCGlOZNQkByNg6mwYAJw0InGvkugcS1ZvK9JJGy+iAxJwz8kSlvSmVqQ5QiQtgtEDmsjGDjAN65Y2DBDhxQHdzrVXPSDtLJk/NNZZaQFs7MoUkjBwkrO4kmv+WttQxWiCR2YiRH2+uHAqzkSGMNgnsUOJHDJ9XPHHURUhvvU7BvrOk4IuO3lp4GPPT86d+U0Wc0ToEGBIAAowqMq0J08wgxTPnGBkOGS2QZpaoCbzIQYbjAPlxIHfxJeGZagHVXlhYFIJzHJpq21ZuLSPHIaMFjCGKgo/A1AapTDrr8wm/7hIvqcAQPiNY8byHt5z70yY+B6apAYHlZDrTgAkLNTrGtPOSF51mTBvpchzQq+DcvywO6C5Kv0tNTVoKP8MJSz1h2s2oZCIJs95OlRC2NBxbEQG5RI+5SMFjid5WTm2GObkwnXAGHaCBpjKiGAHtC4bmhXoX6ix+zwI+LRLY+wcVlov5IoMbBByvGI3kYm9JcW+dpadB32wHqyY1DfpHNbgl/DjoALlxYHdRW+BZQjMLu12wR1dUUcnxyj88Uj6xtMm+gJxlDbRQgZx0wQnB7uk7usdI3JWbX0Vd7MW68S4SX4vdS/06PHyr6k1dVrvh8Wf5fII+F+XLaz08fNoWf8+/+LHaVo1B8eHOKG3E4fEfF1Mi1NIWAAA=",
    Area: "1",
    Cost: "0",
    "Default Elevation": "0",
    Depth: "600",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "W600XD600",
    "Family and Type": "W600XD600",
    Host: "Level : Level 1 Living Rm.",
    "Host Id": "-1",
    Image: "<None>",
    Keynote: "12490.Y3",
    "Main Unit": "Herman Miller - Seat Fabric 8T07 Crossing Pumpkin",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "W600XD600",
    "Type Id": "W600XD600",
    "Type Image": "<None>",
    Volume: "0.12",
    Width: "600",
  },
  {
    ID: "984486",
    Name: "Cabinet 1: W1500XD400XH530",
    Category: "Furniture",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABAA1jNEKgjAYhd/lv17DTdO5rqKCoC5Egi7Ei1k/Olhb2ApEfPcm2d055/s41QhFoy/DE0HCyTW6xJtXtjUIBAqnrX+BrMZfDAoXlKV5tlkxTgXLUpjqv7ftezUEOQx7rR7osQcZ0YjAGW3rO5AJzTmLCZTOK6+dXfBV32fKaMx4oEfUbefnnsVCEDgY/Cz6ilERJWsCO2dceLdvY6b6C5rXbJjEAAAA",
    Pbi3DGeometry:
      "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",
    Area: "4",
    Cost: "0",
    "Default Elevation": "0",
    Depth: "400",
    "Design Option": "-1",
    Door: "Wood - Medium Brown",
    "Door Glass": "Glass - Transparent",
    "Elevation from Level": "0",
    Family: "W1500XD400XH530",
    "Family and Type": "W1500XD400XH530",
    Handle: "Metal - Stainless",
    Height: "530",
    Host: "Pad : Pad 2",
    "Host Id": "-1",
    Image: "<None>",
    Keynote: "12490.Z4",
    "Leg Height": "80",
    Legs: "Metal - Stainless",
    "Main Unit": "Wood - Medium Brown",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "950",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Top Panel": "Wood - Medium Brown",
    Type: "W1500XD400XH530",
    "Type Id": "W1500XD400XH530",
    "Type Image": "<None>",
    Volume: "0.16",
    Width: "1500",
  },
  {
    ID: "985756",
    Name: "M_TV - Flat Screen: 0810mm",
    Category: "Furniture",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABAA1zVELgjAUBeD/cp/X2NTJXE9RQVAPIkEP4sOsoYO1ha1AxP/ejeztcM/HPfUEZWvP48OAgmNobWWuUfvOGSBQBuvjE1Q9/SKSRFKWZtl6xTkthCxgbv5uMwx6RIyHndV3E80AilFG4GR8F3tQCZWCCwJViDra4Jf6Ym/fltFc5AmBg7Fdj1ucyiJFvXfmvfAVekQEtsEF/O5fzs3NB+bSAn/EAAAA",
    Pbi3DGeometry:
      "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",
    Area: "1",
    CosAng: "1",
    Cost: "0",
    "Default Elevation": "0",
    "Design Option": "-1",
    Diagonal: "810",
    "Elevation from Level": "530",
    Family: "0810mm",
    "Family and Type": "0810mm",
    H: "397",
    Host: "Pad : Pad 2",
    "Host Id": "-1",
    Image: "<None>",
    L: "706",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "1480",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    SinAng: "0",
    Stand: "Yes",
    Thickness: "110",
    Type: "0810mm",
    "Type Id": "0810mm",
    "Type Image": "<None>",
    Volume: "0.05",
  },
  {
    ID: "986988",
    Name: "Vase (3)-with Flower: Vase (3)-with Flower",
    Category: "Specialty Equipment",
    Level: "Level 1",
    Pbi2DGeometry: "xAAAAB+LCAAAAAAABAA1zcEKwjAMBuB3ybkr3Wo3nSdRQdDDGIKHsUPVsAVqK7MKY+zdrWze8uf/SKoBiiud+ydCDkd3pRJvXtvGIDAoHFn/grwapjEQKXisMrWO4oQrJRMY67/bdJ3uAw6LHekHeuwgF1wwOKFtfPsLCyEVg9J57cnZub7QfWrlSmYMDkhNG37FXMlsyWBv8DPzKPhUpQy2zrhw3b6NGesv2RXOccQAAAA=",
    Pbi3DGeometry:
      "MwgAAB+LCAAAAAAABADtVE0LgkAQ/S9zXmXdTEtPUUGHDhJBh+hgtOiCuWFbIOJ/bzH7bnW9i/gx7828cVb3bQsI9mydnyh46SVJEAScpeIM3ra4P4IH2JcHlOiFGBbGfnWRJ5S7R9kky8Jc1pKx6doEGRaRd3uEDGxiZ+igATbJeOg2EwPHcp6EjpKq4APXal0Rlmm7hPx2+IM3v5JKqG22b7zW+Z7sF1apKNI7r1sz0dJAN79lrM7fUVtIkd8Md/17NGTaF0futxkLj1TQDDw5DoIlTSMR18GKi1Awntbhhh2e1IKyKBZ1ME/o9T1xyhOe3X2g2uy9MfTG0BtDbwwfxrC7AS9ljOAzCAAA",
    Area: "0",
    Cost: "0",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "-20",
    Family: "Vase (3)-with Flower",
    "Family and Type": "Vase (3)-with Flower",
    Host: "Level : Level 1",
    "Host Id": "-1",
    Image: "<None>",
    Keynote: "12100",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "-20",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Vase (3)-with Flower",
    "Type Id": "Vase (3)-with Flower",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "987054",
    Name: "Side Table 2 (2): Side Table 2 (2)",
    Category: "Furniture",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry: "wgAAAB+LCAAAAAAABABNjNEKgjAYhd/lv55j02m2rqKCoC5Egi7Ei1k/Olhb2ApEfPdGGXR3zvk+TjVC0ejTcEeQcHCNLvHilW0NAoHCaesfIKvxG4OS5DRjGV9FsaBxIpYw1T9v3fdqCHIYtlrd0GMPklFG4Ii29R1ITpNFTqB0Xnnt7EzP+voH96jbzn+qSDmBncHXbEec5kykBDbOuPBtn8ZM9RuQNVOOwgAAAA==",
    Pbi3DGeometry:
      "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",
    Area: "1",
    Cost: "0",
    "Default Elevation": "0",
    Depth: "420",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "Side Table 2 (2)",
    "Family and Type": "Side Table 2 (2)",
    Height: "410",
    Host: "Level : Level 1 Living Rm.",
    "Host Id": "-1",
    Image: "<None>",
    Keynote: "12490.EE3",
    Legs: "Herman Miller - Finish PA Polished Aluminum",
    "Main Unit": "Herman Miller - Veneer Z5 Maple",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Pipe: "Herman Miller - Finish 47 Trivalent Chrome",
    Type: "Side Table 2 (2)",
    "Type Id": "Side Table 2 (2)",
    "Type Image": "<None>",
    Volume: "0.01",
    Width: "420",
  },
  {
    ID: "987167",
    Name: "Side Table 2 (2): Side Table 2 (2)",
    Category: "Furniture",
    Level: "Level 1 Living Rm.",
    Pbi2DGeometry: "wgAAAB+LCAAAAAAABABNjMsKwjAURP/lrtOQ0leIK1FB0EUpgovSRaqX9kJMpEahlP67QSu4m5lzmHqCsqXTeEdQcHAtVXjx2nYGgUHpyPoHqHr6xqAkkuciyVdRCIXMUpibn7ceBj0GOQxb0jf0OIASXDA4ou18DyrmSSEZVM5rT84u9EzXP7hH6nr/qWkWM9gZfC12FHMp0ozBxhkXvu3TmLl5A40soA7CAAAA",
    Pbi3DGeometry:
      "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",
    Area: "1",
    Cost: "0",
    "Default Elevation": "0",
    Depth: "420",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "Side Table 2 (2)",
    "Family and Type": "Side Table 2 (2)",
    Height: "410",
    Host: "Level : Level 1 Living Rm.",
    "Host Id": "-1",
    Image: "<None>",
    Keynote: "12490.EE3",
    Legs: "Herman Miller - Finish PA Polished Aluminum",
    "Main Unit": "Herman Miller - Veneer Z5 Maple",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Pipe: "Herman Miller - Finish 47 Trivalent Chrome",
    Type: "Side Table 2 (2)",
    "Type Id": "Side Table 2 (2)",
    "Type Image": "<None>",
    Volume: "0.01",
    Width: "420",
  },
  {
    ID: "988128",
    Name: "Bar Chair: Bar Chair",
    Category: "Furniture",
    Level: "Level 1",
    Pbi2DGeometry: "wgAAAB+LCAAAAAAABABNzcEKgkAQBuB3mfMmbqKmnaKCoA4iQQfxsOawDmy7YVsg4rs3kUG3+ef/mKlGKBo6D3eEHI6uoRKvXlltEAQUjqx/QF6N35GJTIN4Fct1GIRxKmGqf2rT92pgyosdqRt67CFnJeCEVvvuE7JEZgJK55UnZ+f6Qu1/e0DSHX9aBlGSRQL2Bl8zX7APUylg64zj6/ZpzFS/AZto71/CAAAA",
    Pbi3DGeometry:
      "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",
    Area: "0",
    "Bracket Material": "Herman Miller - Finish 47 Trivalent Chrome",
    Cost: "0",
    "Cushion Material": "Leather - Tan",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "Bar Chair",
    "Family and Type": "Bar Chair",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    Keynote: "12600",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Bar Chair",
    "Type Id": "Bar Chair",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "988396",
    Name: "Bar Chair: Bar Chair",
    Category: "Furniture",
    Level: "Level 1",
    Pbi2DGeometry: "wgAAAB+LCAAAAAAABABNzcEKgkAQBuB3mfMmrkuKdooKgjqIBB3Ew1rDOrDthm2BiO/eRAbd5p//Y6YeoWzpNNwRCjj4liq8BO2MRRBQenLhAUU9fkcmUkUyUXIVR/EykzA1P7Xuez0w5cWW9A0D9lCwEnBEZ0L3CXkqcwGVDzqQd3N9put/u0cyHX9KIpXmSsDO4mvmC/ZxJgVsvPV83T2tnZo3gX74lsIAAAA=",
    Pbi3DGeometry:
      "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",
    Area: "0",
    "Bracket Material": "Herman Miller - Finish 47 Trivalent Chrome",
    Cost: "0",
    "Cushion Material": "Leather - Tan",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "Bar Chair",
    "Family and Type": "Bar Chair",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    Keynote: "12600",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Bar Chair",
    "Type Id": "Bar Chair",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "988459",
    Name: "Bar Chair: Bar Chair",
    Category: "Furniture",
    Level: "Level 1",
    Pbi2DGeometry: "wgAAAB+LCAAAAAAABABNzcEKgkAQBuB3mfMmbqainaKCoA4iQQfxsOawDmy7YVsg4rs3kUG3+ef/mKlGKBo6D3eEHI6uoRKvXlltEAQUjqx/QF6N35GJjIMoXsl1GIRxKmGqf2rT92pgyosdqRt67CFnJeCEVvvuE7JEZgJK55UnZ+f6Qu1/e0DSHX9aBlGSRQL2Bl8zX7APUylg64zj6/ZpzFS/AcV1fqzCAAAA",
    Pbi3DGeometry:
      "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",
    Area: "0",
    "Bracket Material": "Herman Miller - Finish 47 Trivalent Chrome",
    Cost: "0",
    "Cushion Material": "Leather - Tan",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "Bar Chair",
    "Family and Type": "Bar Chair",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    Keynote: "12600",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Bar Chair",
    "Type Id": "Bar Chair",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "988462",
    Name: "Bar Chair: Bar Chair",
    Category: "Furniture",
    Level: "Level 1",
    Pbi2DGeometry: "wQAAAB+LCAAAAAAABABNzU0LwjAMBuD/knMd7Yb78iQqCHoYQ/Awdug0bIHayqzCGPvvRpzgLW/eh6QaoWjoNNwRcji4hkq8eG1bgyCgcGT9A/Jq/I5M0iAJ43QlA7lMFEz1D637Xg8sebElfUOPPeSsBBzRtr77hCxWmYDSee3J2bk+0/W/3SO1HT8KgyjOIgE7g6+ZL9jLRAnYOOP4un0aM9VvktfMBsEAAAA=",
    Pbi3DGeometry:
      "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",
    Area: "0",
    "Bracket Material": "Herman Miller - Finish 47 Trivalent Chrome",
    Cost: "0",
    "Cushion Material": "Leather - Tan",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "Bar Chair",
    "Family and Type": "Bar Chair",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    Keynote: "12600",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Bar Chair",
    "Type Id": "Bar Chair",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "988603",
    Name: "Bar Chair: Bar Chair",
    Category: "Furniture",
    Level: "Level 1",
    Pbi2DGeometry: "wQAAAB+LCAAAAAAABABNzcEKgkAQBuB3mfMma5uKdooKgjqIBB3Ew5qDDmy7YVsg4rs3kUG3+ef/mClHyGs6D3eEDI6upgKvXtvWIAjIHVn/gKwcvyOTVaCUjNYykFESwlT90Kbv9cCSFzvSN/TYQ8ZKwAlt67tPSOMwFVA4rz05O9cXav7bA1Lb8aNloOJUCdgbfM18wV4moYCtM46v26cxU/UG1+ZBkMEAAAA=",
    Pbi3DGeometry:
      "MKIAAB+LCAAAAAAABACdnV2rJ7eRxr/LuZ45tFr96lyFJEsgexF2F/Yi+MIhQzzgeBZnCJjg776tltQtlX5Vf7UJu44VqV6eKqmqnj5n5i//fvvzXz//z8//9+ntm7c/ffnr5//+8sPnv719ePvzl88/fv3n2zd/+Xf8r8f/PPzm+M/bLx/ulY9uGH5z/r/j/95++TYf++1PP33383HWv+/rPH0Y3odt2D+M7+Oy+A/H4rIv56Jbz0W/hcVtPhfXaQ6L67Cei8e5sLhN585t+aDJxOO7O3cuPi768dy5j+fifspcx1E9vvi1VOR0RejRvPnC+Hnbz8WwNE3buXQ4okmcfbk4L+fhad0Kf+ZpUtX0+6NbmRBKVrLufitbv1HzdJo4ry6edYXAeVgLgaiFA46pMY6FovU4cKdGMjOlRpKZtCeZfDwq8vtapjDKpOMpr733ZV7HG+DnrbgBqOiBTLQTs7CNGkpMeZAkpjxI8U2m6/kPSxhcTANUkhI92xgTHQ1nb9RcFWrirffjXNx6lNhvkJVYRWymdze5McPh3rdhPtf8lm0/1xy5E/YNPmsJ+6YdBSLmx8bZTxmMc+NpzrxfLobFxbHfQc+Wc+U8rYhE0NFFEok5iY7r74t4iBSE9OytQePQ4L2BeJF/eL1IIGYfgvsgspT7GO72+LG4LFM+fi7OLPPYuUY8sknryK9i2OnHStF5fJv2ErpVeag1Re3jH2Turgzleira3VrmxrqzdjzeXyY0Rfu4lHm9MR746GA0tONYjjplqo9jf9ixcFEucNgJY66lVPPb4/25oL3snc2FEuGkJ5TJIueiRaF7u9OrbYzwuFZrEpxh8c7jFKLQv6UQoXY8rvbhTcOvKUrpGQ4Ut518R0XYKfKicQlfQYfaNUB4rkFAGt/x+H0Lw2DSvLOv5i9Evn8o02LUmnQXiWunK6pR1j4rQwwe18ad1ve7Nue0mctin0N8F/tiLrpKc47kPLE8nJXQRRKJw5K2kUYyHvJokeFFKwEfffSrh0laIngQSGNELBS/6HJvs190hbVITjTKKbp5i3fXhfh4/HNw4eotwzZl18PiuXOcXT5+/COsTPOF2nn21K1I9Mt1Rc/Vs9igHj7PuhQLUNfkrtz8eCljAcksH6EdVFPdni21oXP+yuvbHjrcYkzicG30OTdOP6ItMTGDd4VzuJNEujnnYFhb3Qt7arjosBLEdc8GfbwtmrbrUn0sJPBqlBB6llLCfM0tpTaWgHtTIoVGrkgkXiUQzPQU5xVr3TVn3UmbsiS0pylLFEPd1S+XdzvGP4DVxL8OYcyeKb7pOXuMpKhP96qJ98DHK5JsTBcm+GMjzI6TyBY02mXGRuYtZhJIUN5zBUvErQkFz/5wmmd1jgSijlkgT2s0CLEorKeJhkYoIZLoNvIyBBqhi8QDIYneiGzTJlpkIhgzgAdPE6vD8SLSC4iVntukDOfKC6RcsuapU4Zu5YoRiaG9qlwv6K0FARqLQjO2pqp9OjS6iFiLflwRwgfR0gxoX1MMH+KEBhE9ooFPBAdHvwVfjRNGxKA4MMyyh2nrhkIJ2I1NKVYZ9ZWmF5ppZVrn/hikKkO4ViQbqQrZoEWACKUmLCpUSP4gfmgoE0poPYeaWCqMvwI00RWIPgcamQ2MPk9dYh7Rhsh2vlG4kr6JiXkE1gIz/5Oxp9mpjPgPZq6mqdOalgYLZZqHqRCPEiXSI08juzB5GByEEWgNzgmMK5FYkBSYPGhjE6wHfMySeNiKUFm2eOcrhnHZ17FcPOmqdRjX7OLFlSk718ufi3Ranb8suoif1cXoV9wfHkdFbHz+GlJ+hsLFJ4oGV/ge+eIss+J22aRl23KILrLbNL6WuSRmr/zMwDJXtxV4RlqcZeJOlkl4druZ4159tuVkwLTBGGE0WVFMsOq7L+9M6V19uVXSBnYqMtfyeL4IZBLK7DYpJ231idjMkOpzm3JlaCfKTPlZfc7NV6b6gJjTpvqmqXjkro79fqysVKxlIiDditb0/bD8MQXlAYOwz26/OO78+M5uvT5YXYM8Pn/zOFw95PWek0g06DBkaSroPDjflEZ86Oa4sSpZKBKrATpJIvFWo+MK6m14GCEqLwgbhofrGMUMfQSE+ksOA/wgulTsMeR0fNpjL1L1TShz2lw7XmC9PGajrVJ0Hl+XErm1rDhVwWI9VBmn1e1lLM95aVp2X6bHOYORcjzdXy1Zz7JdCZtHcEQDyyrGQjlObUq3TKUX7A4690OUCRj07tYF2yE63p8JZl173XdhgJOe6ieKskUV74P1E49jBUtoVvxUDlDFT6FyOs2lnwo660m5WXGA7Dn3GNRO8KJxA18Dh9oRD2wxGA9wHY/nG1hx6f1dDwLf33NxiMikXB4qgj7XoerDAvZceJy7M/I91+Xq+0cu9eUnFeyqU1muPg+gRGzU0UkSiX06b6R5oL/1Z4DRSkKofz7CCYUgQjCN5rnuk61OtzTd7AxrkZxukFmQ7HNAcc/F7vhHWJmujmmILFVYu7uwIZI9x6LzLheLzN2ywP7DuHVefK5pQ+SptEU+Hr923FxTWNuviA2R7lNNQkXjfvUiH2+UXPwRvYKMDlunqx34eBvFAlrsUCQvovWuJbhZD59+rKj86BNWx4upy18HNPQ5ytuSdRURweNxZ/Et+ZZZfCJ+oV3sjJlzf39V1qb7QbojPF0v1x1fPEz70ERapNMpuvkrnxqclJnlh8c75sUXwTvm5Sc5NbpKJrAJ+1WUi2vAhvFelttCgOj1IqWs8nvRKMLn/EUei4xv7gaN/3iaRnXlUXzw+MrTGhPSTu+anqbqKKwSI4luIzVDoBG6yDsQkuiNeGCV8ROJCAUzgAdPt15r8SLeq5Go9AOtf+10rlY5rohtrcGpm8/j5KuWvyfFjj4QI4vSDtm6pvbd1MiiNm2ewKrwFt3B0gzo6VMUmNCeZqOOPPEbHPoWejVKGA+D4cAgy+JIPwUDnIBeR1uxOOs/KZg4B2tFH6TiGK4XyEYqsQ16AIhOaqKiIoXcD8KHdjKfRMZzoIGiwuArKBNbgdBzlInY4NBzWyU6I216bDtfnM9722EiETQtzdSsdvF9kwHO9toQgCK7G78GCxzjsT/Fo8SH9MhT2ANmxRgchBH4DM4JjCsxWJAUmDxoYxOsB0SMP8Ia7oUf/HZTKX44Xoyw6mZ3s1V+WM4HZNzX4nOCshqufZAwzstN5mS5456Im5PP9OF9C6vh/l58qCJhnny0d19uykyRyxJY2wFEXHXjzTx7t0W52zTehLIiIa36gPLFp2UJfvTF10UNX45FxJc9FhJYmxkLaQOuKhIw8glJPy7TTRf68JOErQSWm1bHbby/DCih4LCFn7qEEC87iMVYTuNGykgA65rdBgmp7J0dhJ33srl8KdgG1pYkiFAmG0RKs7YEmUg9DjvvNb0QCanYgPayDSzhyaPzJG6YOsqbw+9TFOD8kYrX451wdONh18UBaJGIypz3RUlgsQpgLim7q3AGxjm/3vXVDo475N2lj6ViyBVnUaqSCBYEwlvzFcMoPMl8dkKYy3JNGCVkD+6vcs/6g269K1KXJcEdg+7dl2lyo13D7vd7fNFevKRtGMZ72MjYDNtWjO/2ay60cTmIQRu2yd9jWd560QzrbpiAEpSKhC8Ia0t7hzBU5oFfwYargRIflmBF4olc3tuVDb+iMnMoBOgPXnhFwIMcMSPcU04w7KnMCV2pxRJ2YTemCLAaY4FtajRFzNgElsAdIY8CrC01sCJ32TeEwZwapBNoLve67C+ja6Eg/X0wfinDHqOLOCoS4pAjbrs5+vDAKbWx3LS3rjTJi6qqKWMWn+e96EOKj6j4Kex1I8HTWwqPKPgslmdQcpelKlMlW2Dp6poqzcm2shbhUsZ7BtGClkd2AS03hGwDN5rohLmV522ZjHx1rOuwTGN8HiLDdi0HPcVqFLFM8c+/KQBbvFvieVNqDOTil/SJoipIyzglOnp1uugUi2VM9Tn5rMhQ/LCdFstsxyOFWcQSf89yKOvdssSf6BuqYU9sZakJimVbbzJSWc3mpp+HTNamrFoSgxvfTd7KYtkwlmDvFThqOcHRz34c1zgtlx19X+RSB9UpQ9kc+zhpXuowRaRZct4r7ohtBsZP+Jca5fLyKrpSoy3vQXauzgDbtyqLla0oFj1jAeRY8qBONT6Omh7FxkBWqLIzr+MWKoQF70XHLLSR9EFgmF359eFGAUyNGPyQTAzMAvbVIoIQQdkMGDwQ35jKAZPD6ch3cxAXpIpO4Mj7gudNwkoEkL2yKEJpgnq3maCQb9aj19SkkBoRFinTdCdPaosigwkJhSNgfVplYEStnOrEWUH0UQQtDrDMCwVMRM2kh5jyacJhxZ+JnCYcFr+jNEQ1a8MSlG5I6Z2Ym1CsUEQzQaK0+3b3LbJCmS8UyRaD1PjN4wUSLTYaPbSqHRMm2JhLYyikzxY/piDBm4VpdkwlA2NxbE38TboGiSRFRPkqKFJx9DJIoJ55ziRQhCqL7RHtAs5o5ujHFFBt7IPJj3sjc7JmQqKKCx/XI9AtkjeKBFCQsgJQxwottQZ65sp4VeSVxRdiAHtopuH8yajwp0nVzOTw7vdtKonjJYAxjYlMuim5sLh7wd41O6PMya+L+BQaFC3y5zmanSzz/PHHKTF3N83YWNQvMv5QorCIzYzKh1FQ7i1w0aKgribGA+yjExx6s9MKRn2cd/bGFz1HjEJ2hZ3zJD48NcdRZn8mxOOTTyTs/aFcOS529h/HnWgSHg8ta4PSfD6eIhHjn/pWZyyLxNOG8joV0KJ4XIQ9WVSlMXqOehgjEJn8qVMbReJp3KgnQo/p8/mnitUXA2GL6T4dtgt6X8kYzMJxWqa6woc1v4mq0/pzKj/6TS8ecikSDYoPynhAJQrpsRiav/rDlfK+jj4XHEOm/upKL0kmPeSG5xJ2PUAEe8/dN0yvrUSRBm4SIqpg/YW2P7xQBViPfnocnRMfZhuR0aBjYBHflpX6N7ppEkNeOD4WvzuAdRb1GMXG7Xmk2e6dbp93MVa1yuk4lk8siqgo7jwW76kQ0eAWAUOBx/vbDl0m7uyIuR402d3oqAuASaQRcnm6Ow+MQMq2EPugNrqxLAg1sXoJg7B68XGoknFNYBkLrwgPKsfj2DNwMSdFsaCKzGTtpMjAoysW3cjpnZGEE1sJvbkRrhudiLh/1J7ojZWEvbvbYivRoLizrgxJe12BuB3G47iTPD8DJOpxDG9d4rEpTJGs6zGKpP4cfUSRRssvlat6xGle1OcNYSZBhF0q46aDSSOMDA+1ZagcWz00Xd8oRHK6UctPuR6L37rEX6AqOK1jcV4myTWGrddvlqVasW5z/FW1sphLiWdFXNcp7vRFv7Ou8Vczy8Z13cZIBy1O1UOn2SDUHfVMoyt5YbTdEnr9PqolNVk65V//tAxAsRwPlhATZ/XbLnn7sJp//XUxJCjR74aGLWBdLOBM8y6pyioJiK+GhDbe8TqL8Hi8+CIxLUV1vrF23Mrqwc5480VI4i0vb6mlRCRE0lJnavJcRA63slTTd7namh+9FOnImjgdHmCvoicOY4ys27Atxa8MK6877eSnT38kiSrBhxN5iTq/rIez1q2/5KJSGpSK0GO8Nx2V0oBNWKSzJ8JHNN3gP6Q/TfW0BlzBSujsB1ZucdygeETI0BudRJPKWxf1ab+pL1xQqXQa3AsXZGQ1lFIkS2R/7cYBHwdvVsWPF0Oop04frgzhg2jpPFkZf0aPcDK4FaRMGvD1QCMVIsE3CBLuOSreg09zieVqihyJ1dzI5CECQCl8WFCZv6Aib5VTZF+6WgfkICwEXnONVgCQjkL+BL2XfuqEEjuPW4VNVvQkjaEzUk2cDcaDGBw+X3VIKFFvgpFDEaWE2l2DiMDmluiSnv4ddxocSsfw0N8Eck+vj/jQKYuzOuadAnGbCDfDo0Nex4ZtpMgaFBMuigzSuTUM2Cuexr/vbos/fxKenPHdL+ffGL/NU/FHeOfF9CdfLUtem96H8PelHYsH0vu9k4Xue/o1yfVkyMq94dcDZ/v8dLwO63mRp2Gc7FVNAlk7vU/hb+NuJezpO4KfXylDtMiv7fzJn8OmsedwCyBBpZo5vM+uCdUQ/nQx00oV0VaRoj3l3uxHGTxpEiGvxTn/oNTktpcS5mXzbZyXJf3CdZF/mgTem34G87ULsBFRgX2K5mmEfD73SvhB5vHIjSLHkuUyIijxhLPOHGUnykTPNdPr65EcFwmKZ3vxRSxAse4fp2atWrkaIriJ2K5Nyn/ZUWF6/isH8DRsFNliHhd3Jf857LWjlqGqVRei+hKfZeXa8Qvj0vmcMfpZVoIScbFO9RLM66ZYO1FmnUjWzvo5fXycnUehxlax2pQtY5UlNBXasMGUWzuhbSVlTZvyVKzok8zj1RNRGlWnkLITZdbtRGlndSWUjVWD8lTiAyMbhFCNliSckqJBsHIamxG8PRAN7KSsBDE7NhXP/kxQejNqNjERmpgrqHW4bS1igQbQOyw3vOloU7tjozfOSnDUsalp+ume9d6918MZXTMcN56826oidQrEh1R5dNkCkMBzpDY1cD15VL30qZUHNBsxA0WecLqmXiMOnRjY8zxjgPHlZ7jLt1eVyc5lbtG5ZPBMaXbEPFMqrao+rbWNMvbqbANL6J5VWRXMD+xVFwKvB6UmCzgKr+03vWJQukJgDuIMAodLGzUbv2CCa5dw+OqdZrURs5nRYNx+tQ1nH6QOrIEI2y/kE/D4r/DFYBjIv9fDJjIHeNraiZB18DJWGPrJGjzeHzBs8lDRy4xU+ZpvP7z9/vN3//j09dNPb98Eov/tPz/9+Pev36d/+a8vX7/7+vnLj+lf//fz367/6Y+fPv/9+6/pX/7ww6d/lRt/9+WHL4fAt/+Ywn/efvn2/wEBkU+rMKIAAA==",
    Area: "0",
    "Bracket Material": "Herman Miller - Finish 47 Trivalent Chrome",
    Cost: "0",
    "Cushion Material": "Leather - Tan",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "Bar Chair",
    "Family and Type": "Bar Chair",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    Keynote: "12600",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Bar Chair",
    "Type Id": "Bar Chair",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "988640",
    Name: "Bar Chair: Bar Chair",
    Category: "Furniture",
    Level: "Level 1",
    Pbi2DGeometry: "wQAAAB+LCAAAAAAABABNzU0LgkAQBuD/MudN/MA17RQVBHUQCTqIh7WGdWDbDdsCEf97Exl0m3feh5l6hLKl03BHKODgWqrw4pXVBkFA6cj6BxT1+B2ZyCCNl3IVBmGaRTA1P7TuezWw5MWW1A099lCwEnBEq333CbmMcgGV88qTs3N9put/u0fSHT+Kg0TmiYCdwdfMF+zDLBKwccbxdfs0ZmreVCAI6MEAAAA=",
    Pbi3DGeometry:
      "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",
    Area: "0",
    "Bracket Material": "Herman Miller - Finish 47 Trivalent Chrome",
    Cost: "0",
    "Cushion Material": "Leather - Tan",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "Bar Chair",
    "Family and Type": "Bar Chair",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    Keynote: "12600",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Bar Chair",
    "Type Id": "Bar Chair",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "989344",
    Name: "Table-Dining 01 (M): 1800 x 900 mm",
    Category: "Furniture",
    Level: "Level 1",
    Pbi2DGeometry: "zAAAAB+LCAAAAAAABAA1jV8LgjAUxb/LfZ5jTjfdeooKgnoQCXoQH7SGDtYWtgIRv3uzP2/n3PM791QTFK0+jXcFEg6u1aW6+MZ2RgGCwmnrHyCr6SsDEuU4odkqSjCPUwpz/afWw9CMAQ2HrW5uyqsBJMEEwVHZzvcgGRaEMQSl843XzoKMMctIJnhCeSbSXITwrK8LS7FgNEewV7rr/eJTTjiCnVGvX/nze+OMCzv2acxcvwFQ1st+zAAAAA==",
    Pbi3DGeometry:
      "+SkAAB+LCAAAAAAABACtmV9L3jAUxr9Lr2tI+r96NbbBYLuQbbAL8ULxRQvODvcyEPG7r9rWtsl5kpM0iOL7e9PnnJycpMnJxXNyft39fPpzSE6Tr/1196O/726SNDnvu4fj3+T04nn8d/hang0/yUu6kBMl5dnbn+E3ebmcH/vw+Hj1NDx7UommlFV6IkVVqSLNRCHV8HHGlSirqn3HrWhkXvhioK1hU6SSpCcbvIjYsOnJBmvawG8g4ueJo/O8UDm0/SKoDZpfQgBtR2CdOEoOckbeie0mc6WyVyzrokmVaLNWrXHRFO0K15kqiNYz5rUG2iOWoi4GR3WshCrz0tD2w0DbwBu/l1BtegkiaGJea6C98VvHUy91bT8MtA1sHTTgdxBm56ANm9og3jYcmt9A25EnNsyeUjbMTk0bZpq0z7R9GWtMbr+FA2iDKcXBUdYq5py349B10Drng7DDZCXaPKuMrKpFXmS1BW+SDeBFG+CN9oy1UM3aGp5ba92ZW4NegtZAW5uuWi9NvJmuAGudN/FGW/Nb19awFkG9tYYdrYFJe56wQ2XDUXKQGVg73pvfQNsvIchJ4jeleKnJw8yFwz4vHfnNw2Fz3qHNmyRgrXKYBK1505WHwxZThzZv9XGMPHgDcveanH1V6OmokO1bfqs6z1Ip5JrlTVXOrMqy1odRemtGPbtjg7tgygHKGNXJHXt90wGXMSoqfudggLnGqEjt2Nnbcwob4+4aOTtp5qHawKPHSsiyVFuPKSZFU6jGxkY9irn1/KoEAFMOYOe3Tu3YteuzwG2MikqUYgvXGBWpHWc5e06Zxmohh+dptn62FllR5HzmtuHz7uTtJ5j7IO5phnKa6hzFQnZFxsaAGgU8WmvmawnsTKjhxU6tWdgeyBgCHG53HvpZGruwfj8sbHmRzZb4jNJbM5/9Pe/Mwz6rcbRpp6nOUSxCZYIeBdtoLczXEjjyUsNrc2phkQo8tnC78tDHUivKOl8fRVQ7FrVG/H6mnrFW4mVhoG1gUD7WPNlio4gIsLXkCKrhwEGuSR4OC5VV2y+CxqD5JQTQ3nH7ECkHI9S3HSaNwtOIh1WhkTnEmjbARrGCZdIoKGie7KnRAW1XAQd0J0K1MCxUsNhMhoqL9yQE0ObF25FVgTkYoUbnMLkc5PO8zlet57cUwFOp1IqNCz2mSVCGnVrrt4J+mFP5dfoNWgc5GBIqoA1CxcX7EgJoBxXgo+RghLtmpsnhjNQO2089ghBP5WMrNorNTJPgSnRqrVes/TDnFtbpN2gd5GBIqIA2CBUX70sIoB10GR4lByPcg1hNXqbJp+7q9+F4eExOX09LybfDw+3xbvrwvT9eHbv+Yfr4q7t5/+rLobu9O04fPt8f/q0bfuzv+0EwqdpKlk3ycvkfbFDShvkpAAA=",
    Area: "3",
    "Base Material": "Herman Miller - Veneer OU Walnut",
    Cost: "0",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "1800 x 900 mm",
    "Family and Type": "1800 x 900 mm",
    Height: "750",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    Length: "1800",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Top Material": "Herman Miller - Veneer UX Walnut on Cherry",
    Type: "1800 x 900 mm",
    "Type Id": "1800 x 900 mm",
    "Type Image": "<None>",
    Volume: "0.07",
    Width: "900",
  },
  {
    ID: "989521",
    Name: "Table-Dining 01 (M): 1800 x 900 mm",
    Category: "Furniture",
    Level: "Level 1",
    Pbi2DGeometry: "ywAAAB+LCAAAAAAABAA1jc0KwjAQhN9lzzGkaZM08SQqCHooRfBQeqga2kBMpEahlL67qT+3mZ1vdqoRirM5DncNCvb+bEp9CY1rrQYEhTcuPEBV41dGZJHjlIolxVQmGUz1H1r1fTNEMh42prnpoHtQBBMEB+3a0IFiWBLGEJQ+NMF4ByrBTBAheUq5kFkuY3gy15mlWDKaI9hp03Zh9hknHMHW6tev/Pm99tbHHfe0dqrfKNbuY8sAAAA=",
    Pbi3DGeometry:
      "oygAAB+LCAAAAAAABACtmVFr3DAMx79LntNgJ45zaZ/GNhhsD2Ub7KH0oaVHG7g1ozsGpfS7L5fLXWJbkmU7lJbe75S/ZFlObOXmLbu+736+/tlml9nX/r770e+6hyzPrvvuef83u7x5O/47fC2uhp/sPZ/JhRTiavwz/Gbvt6fLPry83L0O117oYlMLnddFqZTMy0IJqfMTvRCF1lKdcVtsRKUCMSxtUVdCCzCOJZ41COpEsaS2MBwyLBESBDloVoJI3bC02fMUVAKINJ1PP16l6vzz7aO0v0rK8oClbqtcFm3ZyiWum1YtcFNKBVifMM8a0R5xPRiX0qaqaOrSFuZDWNShRrhzhozBIYlzMc8a0V5GbdHjAC1hPoRFHUpNERJuHGZXHIVdbSTNFI6tZkTbUx4UZi8gCrMrksI8l+Tyiq5UeyUH3B5AUXD1+GDifYi1okkadXsj1nQEpb3poq1K7VRMU1SqbAhsFBKCZ20EG9oTNlM0KZtwsrRGMpnC44NtQVl7BVqDc7GxAhFsjdnFhrYZtCVtUSNtlqkJKUvYlacq2Bmi8CoVx8unB6dWM6IdVgfQkghbQMyK5GHebYJciXRRc2jMCid1GesCvBuRrkBTxrL0w/A7JKXJuquQEws+xdg7Qs7uJ/bEokQ71m6pmyYXhVgytZEnpMuy5SNIbMmASxO2oDOG/AO+gPEl7MVd97QrKCFhZ1IEM31BSUrYdtOlhDrj7fZ8m13WAdehY6Dq0KZQRpwAqguhq4ZAoxaAvFoh53SYAq6xmM1oIjfWVqF73QB5SOxt8JwAeYk7SpEV43hpCjFcC6Hlhc2hS1UxkVee+8jjPPFZOxTesQKIFBgPgIJ3K/ZDHMg3NitLFOQD3D0AU4jFskTBGxQn11hivRUW4GMM27iLz+z8tJmcsBEktmQhu2reSYN9QuJow0FDg4PYCqd/cAqomZpZqCPknAlMLhHSGa3UQKFSTVdgiJ92sKrmc4Fsj+2iEc4n2BO2WqMcDCrbEGm5WlEY2O7HgRDv3CG9YzAwlis/DE8LrhmWK3dqQiYdUU7ozK9UZ0mNYI8zp4lzxMNy34gKw6YyCK0uAMeZfWa3Ikjoc4HKZCsEHMQKnbaY9KDdWTBBXJww/Yg2I8tU/cTUWlJvi3Q0n45VJZuF7enpguCppUhi5xUW0yXSrpys7fdgYZjTIfXGjVhHBRiTKkQbSRUXpxUEoh3VqF6lBld4u8pzORxmpKrtBGJ0asJS1G7YsrzB7wcnW6vlG0IZbyM98cK2EZGFZwfWhbPDowkzD+tGvANOr7PU1wWUt9s8+9Td/d7uty/Z5eEEk33bPj/un6YP3/v93b7rn6ePv7qH81dftt3j03768Hm3/bc0/Njv+kEw060W9SZ7v/0PPpeuQaMoAAA=",
    Area: "3",
    "Base Material": "Herman Miller - Veneer OU Walnut",
    Cost: "0",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "1800 x 900 mm",
    "Family and Type": "1800 x 900 mm",
    Height: "750",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    Length: "1800",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    "Top Material": "Herman Miller - Veneer UX Walnut on Cherry",
    Type: "1800 x 900 mm",
    "Type Id": "1800 x 900 mm",
    "Type Image": "<None>",
    Volume: "0.07",
    Width: "900",
  },
  {
    ID: "990317",
    Name: "Dining Chair (3): Dining Chair (3)",
    Category: "Furniture",
    Level: "Level 1",
    Pbi2DGeometry: "wgAAAB+LCAAAAAAABAA1zVELgjAUBeD/cp/n2Oa0WE9RQVAPIkEP4sPMiw7WFrYCEf97A+3tcM/HPdUERWNu4wtBwcU3psRH0K6zCAQKb1x4g6qmJUaScEa3fMN3knKRpTDXf7YfBj1GGw9Ho58YcADFKCNwRdeFHhSngqeSQOmDDsa7tb6bdmmlzAWBM5quj1OCZjJPCZwsfleeRM8iOXjr43P3sXaufwdqf+DCAAAA",
    Pbi3DGeometry:
      "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",
    Area: "0",
    "Bracket Material": "Herman Miller - Finish 47 Trivalent Chrome",
    Cost: "0",
    "Cushion/Chair Back Material": "Herman Miller - Veneer Z5 Maple",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "Dining Chair (3)",
    "Family and Type": "Dining Chair (3)",
    Host: "Level : Level 1",
    "Host Id": "-1",
    Image: "<None>",
    Keynote: "12600",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Dining Chair (3)",
    "Type Id": "Dining Chair (3)",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "990596",
    Name: "Dining Chair (3): Dining Chair (3)",
    Category: "Furniture",
    Level: "Level 1",
    Pbi2DGeometry: "wQAAAB+LCAAAAAAABAA1zcEKwjAQBNB/2XMMSZtWiSdRQdBDKYKH0kOqSxuIidQolNJ/d6H1Nuw8dqoRisZehxeChnNobIn3aHzrEBgUwfr4Bl2NcySykoJv5FpuJVdpBlP9V7u+NwNROhyseWLEHrTggsEFfRs70JInMlUMyhBNtMEv9c0+5lapPGFwQtt2tJTwTOUpg6PD78JX5AWRfXCBnvuPc1P9AyYAqbTBAAAA",
    Pbi3DGeometry:
      "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",
    Area: "0",
    "Bracket Material": "Herman Miller - Finish 47 Trivalent Chrome",
    Cost: "0",
    "Cushion/Chair Back Material": "Herman Miller - Veneer Z5 Maple",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "Dining Chair (3)",
    "Family and Type": "Dining Chair (3)",
    Host: "Level : Level 1",
    "Host Id": "-1",
    Image: "<None>",
    Keynote: "12600",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Dining Chair (3)",
    "Type Id": "Dining Chair (3)",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "990620",
    Name: "Dining Chair (3): Dining Chair (3)",
    Category: "Furniture",
    Level: "Level 1",
    Pbi2DGeometry: "0AAAAB+LCAAAAAAABAA1zc0KwjAQBOB32XMaml+beBIVBD2UIngoPVQNbSAmUqNQSt/dQPU2DN/u1BOUV3senwY0HMPVVuYWW985AwjKYH18ga6nJSaSCVwwqdYcEyoYzM1fbYahHRNNxc62DxPNADrHOYKT8V3sQRNMCeMIqhDbaIMHzTDhRCgqBROFWilGEFzsfcGcS4rgYGzXp2GKBZcMwd6Zz+86S9/zRLbBhbTl387NzRcce7o/0AAAAA==",
    Pbi3DGeometry:
      "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",
    Area: "0",
    "Bracket Material": "Herman Miller - Finish 47 Trivalent Chrome",
    Cost: "0",
    "Cushion/Chair Back Material": "Herman Miller - Veneer Z5 Maple",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "Dining Chair (3)",
    "Family and Type": "Dining Chair (3)",
    Host: "Level : Level 1",
    "Host Id": "-1",
    Image: "<None>",
    Keynote: "12600",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Dining Chair (3)",
    "Type Id": "Dining Chair (3)",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "990621",
    Name: "Dining Chair (3): Dining Chair (3)",
    Category: "Furniture",
    Level: "Level 1",
    Pbi2DGeometry: "zwAAAB+LCAAAAAAABAA1zc0KwjAQBOB32XMamubHJp5EBUEPpQgeSg9RQxuIidQolNJ3N1C9DcO3O80E1dWex6cBBcdwtbW5Re07ZwBBFayPL1DNtMREMo5LKuSaYEY5zO0fbYZBj0mmYmf1w0QzgMpxjuBkfBd7UAQXhDIEdYg62uBBUUwY4bIQnPJSriQlCC72vmDGRIHgYGzXp90CcyYogr0zn991lr7niWyDC2nLv52b2y9J/z2WzwAAAA==",
    Pbi3DGeometry:
      "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",
    Area: "0",
    "Bracket Material": "Herman Miller - Finish 47 Trivalent Chrome",
    Cost: "0",
    "Cushion/Chair Back Material": "Herman Miller - Veneer Z5 Maple",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "Dining Chair (3)",
    "Family and Type": "Dining Chair (3)",
    Host: "Level : Level 1",
    "Host Id": "-1",
    Image: "<None>",
    Keynote: "12600",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Dining Chair (3)",
    "Type Id": "Dining Chair (3)",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "990645",
    Name: "Dining Chair (3): Dining Chair (3)",
    Category: "Furniture",
    Level: "Level 1",
    Pbi2DGeometry:
      "1gAAAB+LCAAAAAAABAA1jcsKwjAQRf9l1mno5NGWuBItCLooRXBRuqga2kBMpEahlP67gepuuHPuPc0M1dWcp6cGBUd/NbW+hc71VgOByhsXXqCaeT0jkmBKC8xxk0gqRIGwtH9uO47dFOEY7E330EGPoFKaEjhp14cBFFKGXBCofeiC8Q5URkXGci5YITlyZJksE5QELua+FkT8Ezho0w9Rz6gUGSdQWv35LSTRkEZk562PPve2dmm/LNq2XtYAAAA=",
    Pbi3DGeometry:
      "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",
    Area: "0",
    "Bracket Material": "Herman Miller - Finish 47 Trivalent Chrome",
    Cost: "0",
    "Cushion/Chair Back Material": "Herman Miller - Veneer Z5 Maple",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "Dining Chair (3)",
    "Family and Type": "Dining Chair (3)",
    Host: "Level : Level 1",
    "Host Id": "-1",
    Image: "<None>",
    Keynote: "12600",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Dining Chair (3)",
    "Type Id": "Dining Chair (3)",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "990646",
    Name: "Dining Chair (3): Dining Chair (3)",
    Category: "Furniture",
    Level: "Level 1",
    Pbi2DGeometry:
      "1gAAAB+LCAAAAAAABAA1jcsKwjAQRf9l1mloXk2JK9GCoItSBBeli6ihDcREahRK6b8bqO6GO+fe085QX+15ehpQcAxX25hb1L53BhDUwfr4AtXO65mQjOS4JJJsMoqlkCUs3Z/bjqOeEpyCvdUPE80IKsc5gpPxfRxAEUwJ4wiaEHW0wYMqMC+oZJyWghFGaCGqjAgEF3tfCzz9ERyM7Yekp1jwgiGonPn8FrJkyBOyCy4kn387t3Rf2cfVPdYAAAA=",
    Pbi3DGeometry:
      "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",
    Area: "0",
    "Bracket Material": "Herman Miller - Finish 47 Trivalent Chrome",
    Cost: "0",
    "Cushion/Chair Back Material": "Herman Miller - Veneer Z5 Maple",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "Dining Chair (3)",
    "Family and Type": "Dining Chair (3)",
    Host: "Level : Level 1",
    "Host Id": "-1",
    Image: "<None>",
    Keynote: "12600",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Dining Chair (3)",
    "Type Id": "Dining Chair (3)",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "990647",
    Name: "Dining Chair (3): Dining Chair (3)",
    Category: "Furniture",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1zcsKwjAQBdB/mXUamqdtXIkKgi5KEVyULqKGNhATqVEopf9uoLqaYTh3bjNBdbXn8WlAwTFcbW1uUfvOGUBQBevjC1QzLWsimcAFk+U6Tc4LAnP7Z5th0GOy6bCz+mGiGUDlOEdwMr6LPSiCKWEcQR2ijjZ4UAwTTkRJpWCiKFeFLBFc7H3BnEuK4GBs16dmigWXDMHemc8vnaXveSLb4ELq8m/n5vYLoLcg29EAAAA=",
    Pbi3DGeometry:
      "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",
    Area: "0",
    "Bracket Material": "Herman Miller - Finish 47 Trivalent Chrome",
    Cost: "0",
    "Cushion/Chair Back Material": "Herman Miller - Veneer Z5 Maple",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "Dining Chair (3)",
    "Family and Type": "Dining Chair (3)",
    Host: "Level : Level 1",
    "Host Id": "-1",
    Image: "<None>",
    Keynote: "12600",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Dining Chair (3)",
    "Type Id": "Dining Chair (3)",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "990648",
    Name: "Dining Chair (3): Dining Chair (3)",
    Category: "Furniture",
    Level: "Level 1",
    Pbi2DGeometry: "0QAAAB+LCAAAAAAABAA1zV8LgjAUBfDvcp/n0P1zrqeoIKgHkaAH8UFr6GBtYSsQ8bs3sN4Oh9+9p56h7MxlempQcPKdqfQttK63GhCU3rjwAlXPa4wk4VhSUWwSgnOeS1iaP9uOYztFG4u9aR866BFUilMEZ+36MIDKMMkoQ1D50AbjHSiKM5bxgghOuSxyKQoEV3NfMWOCIDhq0w9xmWDOBEVwsPrzu07i9zSSnbc+brm3tUvzBSkN6HnRAAAA",
    Pbi3DGeometry:
      "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",
    Area: "0",
    "Bracket Material": "Herman Miller - Finish 47 Trivalent Chrome",
    Cost: "0",
    "Cushion/Chair Back Material": "Herman Miller - Veneer Z5 Maple",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "0",
    Family: "Dining Chair (3)",
    "Family and Type": "Dining Chair (3)",
    Host: "Level : Level 1",
    "Host Id": "-1",
    Image: "<None>",
    Keynote: "12600",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "0",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Dining Chair (3)",
    "Type Id": "Dining Chair (3)",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "993091",
    Name: "Wine Bottles: Wine Bottles",
    Category: "Specialty Equipment",
    Level: "Level 1",
    Pbi2DGeometry: "wAAAAB+LCAAAAAAABAA1zcEKgkAQBuB3mfO2rLtqYqeoIKiDSNBBPKw16MC2G7YFIr57G+lt/vk/ZqoRioYuwxMhh5NrqMSb17Y1CAwKR9a/IK/G/xjIKuNKrjerhMskTmGqF7Xtez0EGhZ70g/02EMuuGBwRtv67heUEopB6bz25OxcX+m+tFnK4IjUduFTxGUUMTgY/Mxa8jgVQeycceG2fRsz1V++KTZLwAAAAA==",
    Pbi3DGeometry:
      "n+EAAB+LCAAAAAAABACtnduuJbdxht9lX4+EJtlH+SqIHQSwL4wkQC4MXcjwwB5A1gTKwIBh6N3du6t6LZLr/8juSWIksSjuYh3+OjZX9x/+8fb7P376r7//z8e3795++/mPn/7z84+f/vT24e33nz/99OV/3777wz/sv+7/evjV/p+3Xz48V74Jw/Cr4//s//v2y/fnn/3Lzz//8Pf9b79Zv01pXT58M32bhmX+kL5N8xA/vC9HWx1Tel+dytUQx2zvOMzhfTnslPbVcdmOvds0HqvTemzedx2b07gdy0sI78txseVgNOIS7cAUjuVpSMfyNB7cpSUdy2Ncj+XVdo/Hgct4LKY4G4lxzvnYZVi25//MGU9pDi7tHE3ayXhaj7+M42gE36Xfd68mwcnTqbH1ndhz97m8OO01mrzrYjpLB5G0HDqLg4mwrfF9dRwOBcdtMQUvYTpIp2V93x0242+dc0ay3Yupcthsd7qqB63BcbDjkxt4MmbHOJtky1YcLyUbU5hNxYUSJOG0xGjWnVIBM0OIsTyZCqYpmlDzlvMgT3tH3CFdrluwvf3/d7eIS2FN0JD0gNXAG1bjeBwbfrHzcRwYwnJYbbd1jogwzKtQckgx5viZlslpGyPbmLltSPPcP5GsrVR6CVMS/4D0NBurY9jVny17kIpDEEEqzCbX1FQCePM4zua2cZ4swsytwDMPRmQYDk+MIRSeGNbQ91tSCSCxr+MxLoaG0WTYY2srAgN2XJk7Sg4a6+YGOdQzbIcyM6+R2AnJ1BMnw45FnmW21TSG3J9NY6aDaTJFxs38eUiHxsbErg8ZQ+sChD5jWIhbgbdxdJ0vll92+zUM51lxiYVRZssHaQjJVNQITVps8gY/b5sKSwFzkN9BQp32IRjOpupdd9OVGAlZRFtchhvI8JoPOhCXXyEGvIFlzyCwhSoIiLQD6H24ylJo9Cwt5nHNl6Fa0AkYsjXIomsIElFiGikrdYCmwcdV+adjD4V3SAbAhjzvjn9DmaJtgimznwju1F66AO2fIZUBeLmHLsi5UP1Sa6ANDkRgGYhA9oeWBnY7xuJg1e0j4Gki7i5hnWLptpK2rEOJNDACCdQhHKbD7E/Xl7ShRyK3AzcHIcE4IA7QBk4AVKJUeWSdkPKkiK2Abg51ZaRDGbZ7zeawKkmBCOYu3UrqpkQXU1RvQh+km6bZNy+2eRq95lm9szFtJ1u+eSJ0Xrpp0lWy5gM7LF2LqnpYO7SGulYdAFKj956eSaHQhYKeSXeaQS9F4zDnI6h7qNGbNWXwRWUrCEAqdmi/fww+YtpyFqiGkZxRGIRZloxLQBpyEaQXnTAobEotaXUAGxDwIIlACSKLG0gKkBEhf0KnCT06EIFsC80ctH4wZ4Dd1PtpIrIVhq7yXpMNu9t8VC1ys58eLR50umwtIAx5ofYQrSY0fjgJlXNT6sclEX2i5I2KOd3CQrMKgySdT2112Eo7QTiH4SBlIc2HLmkoZ8GRwCDkLNqt+YY0qUeg7XnpNi9itSKhyx9gLkypcd48bbnfSy7iaODda6KY1SlxWq2D5IY0hs0mCmktguKwOathzQLGEdmPOLzk0UVKuwdhA8UaTQCbN508VTF7T7xGefbdFoqCHxjTmrJME+YliHS1/1tPV1bNe8esuY6TeWtVSMZpWgWW4xRNIeZVp6HjGlaRZaNbNKTwjAQkOelJHxij4X7eYi5MXJJIkCRjmooo4/XMrrbR8/eSlUpxSIvI4GFznyozODB4SPdad4DZ05CU05OqAP2L8X3A4FmqXnEKDRjNKwJ6PodBY+7sMgXupC0nbSFmkZKWHaLV6PI0djmU2v/G8k+atyzRgFH3As+rRttdBCh6yh0LgGq54+iJbbVBmhXFcVnm1zQaLbTvcuUF7e7cPg6zUOC16CMUlM33DhFD0BJGCxzTV3gVmDZa7j6y4bO+vAIsaSJdLO0CjaLeIkyAS88W3qvqY3eNUZQZKJgEloecav5KMZjilj2UqBouitg6NG+G2aooIdIyNIOTaMq67ILcCMld51fI+RANVy8hy2bwbj7RWgJzAW3gBI6kZWUYzR5lE8g9AEkw+hmTyvHCw2XKZh/LBZ14dZoGcYBvKH5k6CbzatFJUYoyVGYQ56GygKAFTEs2boUbrFl09QRRSCcFsjhkFig+JW1IZmQCqNeAyImmcqZ9jzbYl/mWuRmI6LwPjQvtdkhVzyaJiPtj+ZiVSEP1qUkTIzrznnitHn0SbUj24GUYA6SU4MEgDoRW6js0qGQZ+Mg15ZyGewBZ6Oi6U8YudpCmO1XlKBCBPhacD+p+XYhB1XahSIW+afW/TDYL9onLrkI/3bK5j1a+/nRd37Zno1XlDCxRN6U5leADlIEXgCKBCAD7ptovKFg3aKAdOEcze1aq1bz7LqLkbqKtCw5tPrCT3qxjxDnwKefBFB41cxQ0dXSEEKaDlcxcmCt1dgEgQjiW+oAMCsEROnuIgrLObc+oagmhz6VA2vcpIHhruAqtIo3IqLHUvSIQaT6mr7vQOyNh2Nxmo2qom913/Xij9Siknkzruh5qFtmWQo9I02CYHeuuGYjAkZI9KgSh4dWdrZ4/NZ/sVU8BIcDDPBETk56DQTEE5QMcCQxCqoF8BXzrzKmnpp0Ra/mTISABk+XWGLp+auuP9w5VR7+AWG5+rl65lpnthhu0+b2DbDfcUsiXXzk5uvrXI+sbVflytrt/AfmVv+rXMPizDKnVfLlPJF8GIn3afft2r17nVu+CgbiGu9eAEQAacAL4y6/uwXL/OgzgD9AKd3i0Tkh4Lc4eu1fLgvMs7H4pZZICtd21H+ROc12rlQ3AIenOj74+Ce4LDLalqYLRBTB0rU4xChAFoQuI0GWx/mWNV58kvcJNWFBVaWE6EhjU2O5ZuHEntyslMAjIbFagx2rXUc+i5hA9W6anCdmy5qPL3TDEBx/w5OFJgx5IwJMHfC6nZCROYBSWLwODmf7yQT4s532nfBpAR3ZGeCXkSXhtso5KSgxDb52tAqD6OLunJ3pqle3OuNateLGsZQQTXLcMjGIby/0jNX/w3KApea0n0KoG/ImcMcRJoO/SXU0yr+aPXAyABk/W2n5aFTs4l4FrMNlyXyVagT00vFw26dm9L42WnfyDBlu3NHWhs3618EV1gzidKN94PNLrV3SXCvZtps4dw7murxRMPRrj+wX6A/DzcmFZ13lUpUBVSLT9Fvw6rBeWoc6jQlQTWcZZxFCi7XyntewZ3bxDjEIldYOpsdDeXFImNqB7o16qLTm0TVBU1z2Mpu02SHEdryxrvuFIav41ba1ByntQdW1bEJDCIkPujlOKwhV0EGgX25Vftym/bO4XY10R4UTSE2h12UZV1cAyJEM/sjI77e7Q1mavaUNKdZ0A0l5y5x2+dXSAE6+kzm6UunMgKqR1YJ3f4iIMczN96N2aNBzYjmdwYKUPCEW3ToTNdyjfSymSxD0/b7JxLWZRBNF+qw8E1wLw3tFdW0kvXiHZAJ61gDWilzkKGuXqqejmXiBc47yzXEH3Cnc1HxWgK/ZOlbZ3A2nNHZCuDN6kXIPUl2tIN2m0N1+yITBXIanNc5u5Skc1otu7m0xXegam2+qvUTD761A2K1XOZX+wnNbNpkwvbDwWx3m088KywCr4xHNzXAxd0zTCKsD5yZqWg3ArxSs2Pyn392bnnWJvYco2g7/mm4Hn7oFadUAZnDtflsbu40Uh49wbwiw0d/jwi5ZD2FC8rtS3bHJBRbUudIA5Vr9K6FOMMCVa7asCsCW9BHwVYKFdWAsI9tOKgygA+VIrCXI8wEirv++sXRdu26riGQS8ECq7uusbtmtuEAVqHqnRGOf4KneRtfVqlhc1iXwV8vNjM2RtvRkoA8+b//ajwH6xmpHw5SNUPjf7awKOdNLL8Po8HXekp4XV34pS4IIUlG/uFl2kOGk/IE1lV778ouZKn3kd1dMyWQoklBgAlV4Q8Cpg2Nq3DNszd7N4LzP5LdU7AMrcXKy+oqW1/CJHFYMfqijCOEEr39ylAZtzPjpy673UEwBqtZ6h3ehr42t1BOrva6Pb9WgJqRC2u/ZpWuzXOwbb1V/Xs4z24iC/Wbn6KyCTvT0nxePebBpXf6Gq3ZMfB39Pzjo50/bWk3nmE6lp2Ww12d3+vRCxrG3XUeKyHXwMm1GOo135Xgf77YGT9lf+DHZ53n9EsZpG9712HTTa1fPJbbj4RenR355suovb7BKOLcH9AmqcjtuxyW+1j/4gcJrtDvxWypLsim0YDp2OKfi7s4yRuNhLpMbz+aBtNsHTEqycCicf/vbx2e5Er3aB+hRmnIzGuk7ZMilVVz23+Fi32ZdNH4aaZfQx8xYKC2imgbQmMgb/BckUzQSzm3E0o88m4mj4Jdycb89aRgfqVNRqq78KzF8MHs/X8xig3GBptp+9xrQV4qwG9+hX78dQoC/FHH3j4P7s160fb8eUagUf9eeUyd8EtgV3UasuRvPQxZVqN+xDio6EscBNHArfWFwf2xQyUUYTJax28370F6ZpwwDa07b6Pf3oRl9aqtY6BRoSwOR1AKfzDYCLRaeUWB+Amgfao//CuwkP0LSMK49b8Ku9mS4YZib/hdFiv6EK5wvpZcMDoUlHBBhESCjtm89fxdiPJ/wV3DoyUZjVIYG8OSyeBuyFUafb3kgOQBmiCnENMqbzt2axAELbuJORPhnRJge3BeRpjHnV7D+xOzPayXOYy/wiXR+8BTZrJ8KIrNBELgcTFwKqQjXEFIgeEK60pqXnoyg6uWj2KOfIxODhMTjuDskwXzg6JvvJWYnGGjNA2H+ttPuK+5Cx7C+3i+MScwG9sjx/1vWQu01kDqWWtNvCkUD7VnaB5HejbO0MIvVMtgzq4+zvFBk9SqytWC+ZoKpcj/p0WSkJazko7MqaHOI82k9XhLfqRwIYZREdxMguckAJmyGN66dEMiph36EPhMjbHzL3pvZIWOqOlrWIWhaIvEADArKOhBDzdOSVaZIKJhmPSR3Np4Wl/nVvgb6lPRHCBBRiusmh3UD7TriCA2EgIrsqmGVQvyaHKnAgDE/gUZ1mQw58NAUdu7XmoIJqzdGjvSQ9nC/V1c1oi2xFQQMfvAT6Wa1iaJFoJJY/wc3cR28G0pqGrublo2GiqwWEnkJyAU/xbykDuNPyEc/QTGlRoJmCuZwkTYmQ6iSdH3WrTDTkTE17hfYgALrOSpqEdjfIYFDi65YOlnVLAQcCDGDmBQOCOxGe8EiTTk3k3gBUj6BhLgq7gfa9mlkXAZDdYEQOjGiNaAdterO/Y/4xKtUZgIqqRhFXD1fak5g6ptwZgWgPgG5dT2304JgGNNptXZ/+ApXOLAEmD9A806BIT6ZgdNyOpVV7eaeTxBZVxmNQiO4vqZEEr4WHUqey/dWZtbLruQZMQfTMBGgTJ/JI6tCBiI4UcEdktC/O7A69PIN1XOy9NGH3yqz+iIu/Y3Sxly2d4XfwVLfa+4U8a8R18lhhHxTx0B63ZREuFt8/yvG+e0tzFvF3zPhPlTIJw7a4l5p3OKBitHdBRSuyTzUZ3ThYXPGmZVfC6nvXjPIeombh6HE23T2ChQdfLTj4/zCfZUIe4B5v9EpevVkzGdP5ZiD7hIOXR3FYLDkMY8zqIFKeVvVOcxNxAbQKl0KG820IZhn3XmJktsYxbPZOKc9H0riASLhoZQOjsHgMsQYqJv+M0mRfIPWoECdrtx5B1eBLsAELRHuXRFwtPnUMs1nBUrn/7gqhcNFQgK+MWnHyNOpfIHm8hBV0Cj5q7C1eEls1uruolVmTvZHLc2P0j86k5aiJH3XuiZvy0cpeMRltez+pJ9LBZElxnLIkQ5YBpU6ewJZ5yXIBWUYrFWgAfoERYPt8gWQy+Fm9IfXxuDPiIIvnO8fcQ8uqE0TRipZh5YxB56jGu7/BPrO1x3Urzc83NstbOGc8WLyDsTYK4oG+9aOBtG/2ot9eeXlWkTouYXrRoYa82b/OZj8qf+j/Tm4AyjqqUG4AGcP5vbWygmsbVz8Qqk2unRaAJyGma/CT5aptAMeXrkKbpQdBotRYQn+TVwMRpgrTEFAocuhYJSWEAAaS6MwC3EnSOikkD43JQeezAcgV7UflFWSAsn++K07+mlqrqM+3IFbF8FlWVoV2j0jZMVEpAEcC7XuphVKfjCp0Y1YXviqK6aAOdQrFesmFPk7fV4ewC6FUl9lQ5cGJOqKDATUK7pWPgDBIIqR/uJaqQh5sBsp3cjsWtxrREHr1leo716+RsMwAmBhk3LxVPMJmTRpCoQ56UJDrihL0AdX7LdRoA0BvAd58y22JCHQ5FEA0ben8sBcOhIGI7KpgM1CGoYqmAcMT3QYDG3Lgo3/xAr820pqTRZR+cuYusQ7F4w6N/RbZigJBHxwF6jutY2iSyHz6R1Z6M5Fu/pSmquflY2CgSwLqSZSWRKPojjKAOy0f8gztlG6QoJ2CwZzuL3UupMwJ2Vf/koVo6DSr/QLyh57cQGaS5T+4rM5iUOfLtg67Pd1YUN7U1oIADUOCW0EeQjENrDWROxNQGELD4Bx2S8qQqSmva55pHqlpaz4kZfDPpjNXz9MwA0Bd1ajj6vFKexZTx5QbUxBKZjAk1oMbPTumIY12W/XEl5pcGD/oBhpnRXI2BcrrxNLqqYXuXKHZhraa2h4YsegeE5pJetAEj6Vc2+XjYGw9YRSiBydAGziBI6mh10TgcRpcwSifrM6Dfwmk3A3L8jbDY68CPNGVBOjSyBVBrspXPbwrwh5s7i0DI/+HE9tRmUS8xEdtgSrgl1lRb75FokO5cqPHMuymp93aFy/R7szwJVKrvb1lChVffWDzVhGJfYmLJ5jOMuEoDC8BYY/oC2O6R3kdNwVqfSDQuOSgvd3AyHmkfV6t4s8/9dMOb0ABIiSwAbtBxLZSW9G3wzWBrPyEVc+dy09p9XZr2gA+iZubB+rdQJp8v/gq31U9XciWQFkDsr25Igy8daJpxfK4+Kx3xNXHh7HS2e2vkZ38sXvyA9+78Ry+xfJjt+bj3LxtC25+rIITlcvP3YPX7MV3H5OPEsrPUu6CW+lWfoax3NxjGsJKuVzrOg6DQFjtRGnye+KDZM++afdUiEtefpCuWq6hEIfjgwm1CXz5yYlmm0yjbVAua4/R33CrNbJDdb0CES06IIeSmsY7eAf4EjielgZQCYgqdz9OBJCcu2MZLsrdPTSAr4OmtOsBGMh9NdtgsnI3oKTnIOBOVEXo4FAuw+5bYbHnCuA37RBfQQpk7CBtaWzuoRXQAFFbHtiqQ3y1drw6sEJMhOAHRNqJsHYlOBKADUEH8A5OTSEAnEa7AYUXfeTgw64CwY/SxRD8oDHMSiXlh6UfNOhL9cVyByPh/DnWUEguoUPVGXw7Fj4SW36V9lni6W/YlssdYaSqQUT6ZvXmrUgZnqrl3id2S9FfDFbhyY1eJchitRamDmZyMzGtRQTtaUSSUgEhGpIEHOhbwDJgxw4nNSjBYNLvyg+Y6821omqD6VQV1jNVrUoh9WefdUepXYa4BmXDR+s7rl7ZFwIUdcJu3zJ5QKSkMHLvM9uXvqfdC1Ed7NShQfLdnOXU7YFGCYQRwB8gTUcMiEXyQASUdlPAmfQlhDDQgPSoc6k8ECBJjqfRpIlQqge4V5fu0uuXL56rcfUf/25LvhxWe1Ybt+Mndo/dmvR5ayIdP+ftbAbSafavP11jRJ5Y33ZL4kssX3ti/Zv9Nu361Q/tI8E0Wn/EiD7x/MV9qSigAezdk5F2z/bj5EqtoO36sW+9O8wSUtVydb+twk6Yhig0VS0DbSBSX5yqvCwEYfbzVlebBGy+JQvs1qQ7Vq+U+jBvqSbaDbQ128Bf9eajNg04kZwdGHH/KM0IjADXHZSBd5RazUnnr2Z+guwrv0eD71HPcNNdxle3Z7J0GdGkC+11l4m/O4zQRxwyJHRJANP3vtREH8DI3K6/G2jf0iq8kZuOBCLaBvdoF07zapsji/W/faSJ4Ivc5W76UtI9TuCN61mp8+rsFem8kugeePMbXVklIQBYKqQDwNaXYLrqI/7go2VApPnFsZcvCt2xI6GV3mQvEQXlEqkb9KpNBnXbBTRABdnXtmakD7R+6awP1Ha8AlYoGfpEwGAXaue+aYC21qqu+IEyWLffNXRtTs0EtB7a8WRjBJShlYVISZ950NEW+t4LgRy6035KkYxcyBHXi8oq4+n4ROrTyr7Qyfa1CnbUlrk1erj2eZD2jAGUCja/pete11vNQPolQM+/oEOm72BCGwA9L/QSuku5QBp297psfaAu1a+MHaCI7e8G2p2y4BptsOOF3V0iV5q//swFMHJhitKFjrZ6f4qiwdAd2sgZgO4HqcW70BDCeAF6ORi49PtE4ORCn9gf/dxqTaGh1sruz4O6WoVRzoVOuD+BuvZVxM686t487d4YoDOhrYZN3VFHdzC1Tf7w53hd5byEJducgj1dOVfD4MvHb9PP5TjPBxdxscsl57Imffx888iY5TIQmfPA3CMNNODExZfXuRB9CXI3Han4A/VNq9T1mJLQqqZB9gLSWpbHqzZLPaU13FAIHEkMwpGgbG11retNLerjHgBJa1JIiEkiVWKsIqH2Pq63BAXeKDwrbPYo8j4BvfOGBJqC1q5WeVBKfFiiOg12S8onSCQqlSvVanSoxu7fy+O1YvQqMKAOIzsoHpphxnmYlkFh6VzOUfPYKgmonQWS2oulMz2WS2nbJPReEFfLACRyQzwWS6O192ZQ6v29ZldSLb3hsZxD4bm3cKjOXk1X8qAZK+Jo+zBFgOyg6VYJvFa655Tn7lGwUaX1yhqeTjsHAo0qt3VI681EuqxReieWhVibEbJhmXpfIFOpjwymTECktRmB67Iq6pAGPgg3GmWajzvY68H6khNQqdR08NpaupKDA6EABQtoNYHJqQC9A7Jr0vSWu4VMD6b3SmwgAjq91Bn07HWzBwClassAkf8PR9e9EsioO1CIhxSCL8VaaGggjkNT2cszwMmlHNHtnPWROnBBQgF1X2lNO2qlWQJoBEQHk4H+wGT31ApE7mib2lt54KVcry3Tq72hlW2XVVVZD63znWpftRuixSUOup1Jj6lLInSX+xML3Rj0RgC6m4PdUm+9dk5OC5qWkH8NatRW+3qxehQuNIm9bh36OdX69XpENYKA7gxGI72+704/KWceNKC50WaCwkC92hZKQUqRFyYsbXkVUVK5NtAtNV6ZirW12xxwVsddGUXw+Oj7D2+//vTDXz9++fjz23fDt8OHt999/OnPX/7i//Afn7/88OXT55/8H//7058e/+rfP37681+++D/85sePf8s3/uvnHz/vBN/m7d/ir5e3X77/J/7+H4Cf4QAA",
    Area: "0",
    "Bottle Material": "Green Glass",
    "Cap Material": "Aluminum_Green",
    Contents: "Water",
    Cost: "0",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "750",
    Family: "Wine Bottles",
    "Family and Type": "Wine Bottles",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    Keynote: "12100",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "750",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Wine Bottles",
    "Type Id": "Wine Bottles",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "993980",
    Name: "aalto vase - tall: White",
    Category: "Generic Models",
    Level: "Level 1",
    Pbi2DGeometry: "uAAAAB+LCAAAAAAABAA9jcsKwjAQRf9l1jEktvVRV6KCoIuigovSRUuHZiAmJUahlP67KVZ3c+493Ml7yCq6dS1CCidb0bVV6BAYZJaMf0Ka998z9DEXYh5vZpJHq0UCQ/Gzts6VXVBDsKfygR4dpIIncr1kcEbTeDWyYHCxvvRkzYR3qv/VEalR4Y0c4aDxPYkRl0LEDHZW2zBrXloPxQeiI2AxuAAAAA==",
    Pbi3DGeometry:
      "fwcAAB+LCAAAAAAABADtU10LwiAU/S/32cSljW09RQU99BAR9DB6WCQl2IxlQUT/PdnWJ2b2GAxRvMdzj9ePk55hshSz045Dkh+kRDBRItd7SNJzNYUESNc0uKAH0goI6ZaD6XBZ3NJ6RZGdTC7FEaURarVxSOMQUWxoDDFMO7TzCQ0wiYMb6BawUl9A91Y1ymyqzL9Wa77zAG8os52A+QhYqf7X4gBdmh5MZ/W/vIqXgp3rRH/4A26Br5dgXDEQ2ZZrXkBCMEEw5vlab+pgqnSmhcrrcC5W96URF+uNroOh5MdnYl9JVVRuLS3Z2Lexb2Pfv7Tv4grt/fCsfwcAAA==",
    "Aalto Vase Material": "Glass - Aalto - White Paint",
    Area: "0",
    Cost: "0",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "945",
    Family: "White",
    "Family and Type": "White",
    Host: "Level : Level 1",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "945",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "White",
    "Type Id": "White",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "994782",
    Name: "White Porcelain Plate: Fine China - Plate",
    Category: "Generic Models",
    Level: "Level 1",
    Pbi2DGeometry: "uwAAAB+LCAAAAAAABAA9jEELgkAQhf/LnNdlU3HNTlFBUAepoIN4UBx0YNuVbQtE/O9tZd3me+97U4yQ13QZeoQMDqamc9+hRWCQG9LuDlkxfk/fB0seyjReBTGXMo1gKn/a2tpq8K4PtlTd0KGFTPA0WjA4om5d90bB4GRc5cjoGa/U/Ks9Utu5D0TC73YKn7Mb8jgRCYONUcY/1g+lpvIFbclGDLsAAAA=",
    Pbi3DGeometry:
      "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",
    Area: "0",
    Cost: "0",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "750",
    Family: "Fine China - Plate",
    "Family and Type": "Fine China - Plate",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "750",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Fine China - Plate",
    "Type Id": "Fine China - Plate",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "996881",
    Name: "Water Glass: Water Glass",
    Category: "Generic Models",
    Level: "Level 1",
    Pbi2DGeometry: "vAAAAB+LCAAAAAAABAA9jMEKwjAQRP9lzzGEpsZQT6KCoIeigofSQ4tLuxCTEqNQSv/dFKu3fTNvthggr+nadwgZHF1Nl65Fj8Agd2TDE7Ji+J6xX2i+0kquFylPxVLBWP60jfdVH90Y7Kh6YEAPmeCJTiSDE9omtBMLBmcXqkDOznij+786IDVtmEBLGXd7g+/ZTXiqhGKwdcbFz/ZlzFh+ABMZ3uS8AAAA",
    Pbi3DGeometry:
      "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",
    Area: "0",
    Cost: "0",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "750",
    Family: "Water Glass",
    "Family and Type": "Water Glass",
    Host: "Level : Level 1",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "750",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Water Glass",
    "Type Id": "Water Glass",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "997032",
    Name: "White Porcelain Plate: Fine China - Plate",
    Category: "Generic Models",
    Level: "Level 1",
    Pbi2DGeometry: "ugAAAB+LCAAAAAAABAA9jMEKwjAQRP9lz2mIbamxnkQFQQ9FBQ+lhxaXZiEmJUahlP67Uau3fTNvthygaOjcdwg57G1Dp06hQ2BQWDL+Dnk5fM/QRwsez2W6jGIupISx+lkr5+o+qCHYUH1Djw5ywWUyY3BA03r1RsHgaH3tyZoJL3T9VzukVvkPJCLsthqfkxvzNBMZg7XVNjw2D63H6gWD2ZhIugAAAA==",
    Pbi3DGeometry:
      "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",
    Area: "0",
    Cost: "0",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "750",
    Family: "Fine China - Plate",
    "Family and Type": "Fine China - Plate",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "750",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Fine China - Plate",
    "Type Id": "Fine China - Plate",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "997033",
    Name: "Water Glass: Water Glass",
    Category: "Generic Models",
    Level: "Level 1",
    Pbi2DGeometry: "vAAAAB+LCAAAAAAABAA9jEELgkAQhf/LnNdF3dLFTlFBUAepoIN4UBx0YNuVbQtE/O+tZN3me+97U4yQ13QbeoQMTqama9+hRWCQG9LuCVkxfk/fB5KnMhGbIOJptBYwlT9ta201eNcHe6oe6NBCFvJYxoLBGXXruplDBhfjKkdGL3in5l8dkdrOzSCF8LuDwvfixnyVhAmDnVHGf9YvpabyA8z+0Ii8AAAA",
    Pbi3DGeometry:
      "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",
    Area: "0",
    Cost: "0",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "750",
    Family: "Water Glass",
    "Family and Type": "Water Glass",
    Host: "Level : Level 1",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "750",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Water Glass",
    "Type Id": "Water Glass",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "997050",
    Name: "White Porcelain Plate: Fine China - Plate",
    Category: "Generic Models",
    Level: "Level 1",
    Pbi2DGeometry: "ugAAAB+LCAAAAAAABAA9jMsKwjAQRf9l1jGkD/pyJSoIuigquChdtDg0AzEpMQql9N+NWt3NuffcqUYoWzoPPUIBe9PSqZdoERiUhrS7Q1GN39P3i5yHaRYvBU/zPICp/lkra5vBqz7YUHNDhxYKwbMoYHBA3Tn5RsHgaFzjyOgZL3T9VzukTroPRMLvtgqfsxvyOBEJg7VRxj/WD6Wm+gWHuyG/ugAAAA==",
    Pbi3DGeometry:
      "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",
    Area: "0",
    Cost: "0",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "750",
    Family: "Fine China - Plate",
    "Family and Type": "Fine China - Plate",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "750",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Fine China - Plate",
    "Type Id": "Fine China - Plate",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "997051",
    Name: "Water Glass: Water Glass",
    Category: "Generic Models",
    Level: "Level 1",
    Pbi2DGeometry: "uwAAAB+LCAAAAAAABAA9jEELgkAQhf/LnLdF3dBlO4UFQR2kgg7iQWnQgW1Xti0Q8b+3knWb773vTTlC0dB16BEUHG1Dl75Dh8CgsGT8E1Q5fs/QryTPZCo2MY+zWMJU/aytc/UQ1BDsqH6gRwcq4olMBIMTmtZ3M0cMztbXnqxZ8Eb3f3VAajs/gxQi7PYa34ub8HUapQxyq234bF5aT9UHaG6AmrsAAAA=",
    Pbi3DGeometry:
      "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",
    Area: "0",
    Cost: "0",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "750",
    Family: "Water Glass",
    "Family and Type": "Water Glass",
    Host: "Level : Level 1",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "750",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Water Glass",
    "Type Id": "Water Glass",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "997068",
    Name: "White Porcelain Plate: Fine China - Plate",
    Category: "Generic Models",
    Level: "Level 1",
    Pbi2DGeometry: "ugAAAB+LCAAAAAAABAA9jMEKwjAQRP9lzzHEJtS2nkQFQQ9FBQ+lhxaXdiEmJUahlP67Uau3fTNvthggr+ncdwgZ7G1Np65Fh8Agt2T8HbJi+J6hn6U8WiRqKblKUgVj+bNWzlV9UEOwoeqGHh1kgidyzuCApvHtGwWDo/WVJ2smvND1X+2QmtZ/QIqw22p8Tm7EVSxiBmurbXhsHlqP5QuXt+77ugAAAA==",
    Pbi3DGeometry:
      "tugAAB+LCAAAAAAABACVnVurJbl1x7/LeW43pUtJqvGTyYVA8mCSQB6MH8a4sRsm02HSBIyZ754qLdU+kur3r7O3g01Go7Nqad1v0v7D399+/6ev//m3//ny9sPbv37709f/+PbT1z+/fXr7/bevP3//37cf/vB3+3/3f738dv+/t18/va/8xi3Lb+v/7P99+/WP55/97pdffvzb/re/KZ9LSeVT+Jxcyp/851iW/Glf3aKL+2osWzxW05LqanL52LvE/FjdPi8hHXuL9+kBYV/1S9hX85Jct9ct23asFhc+hgsQDszWuhrc2n2N4G6fvaurxQ+rbnX+WC3OdScuKaXuxLd0IJqpExN1+BRqVXDoBV4wdYgOimY+lwPuttjqCRchxGXN19UQ8hVsjAkQS86lK4vXUBk0kXfdVnclQ8qLuzJI7HXrOrN43+uX9UpIxpcxE3sZLpKMV5kVSF4mgyAvE2erMj1ohYZLhBRfQzIwIfFoTAUW3oZuSN5/iG4jQ8jRX7nm1uSv6Prsy5XvbsvpY7gIoZHMxxyvsjfBNeK4Na89CiY4y5ZLf2DmJXMNScboMnH4EGKVv/YCK5g4TAckWZOnJWfQywlAM3vTapO9CW4zvQNiD0M/kaE5kIG8D0M/kYHgMoSHUxhIxnA/cHgTgwQO8DVFM0FJ5AXRV52C8GWqS17gKQSHmGYYUDAlWXaYDii+6fARYVfQpX5sO/UqHiis2Q2rhsKaFjOdm6urPlbTO271Ww1InCGbbWeM1fqXmB5/fzAiHazMKZhPMNpuy/GpnHMfam1bPVfe1q2uhmD02nrztJ1hmd96KmZnq/kwAmtM5lTKWuGWUrE9zlf3Vrjbmo69OZYG1wt0+WT7aigHgJT9NpCG6JXzVp1o2HqCMcGBOTtewfDyS+mx9cnVr22lI26s9jEHk4S26CptB2R3em2G1xobvVLbWwPLLdjWitaS1xrTrc2xBlvdQrHVbTAAa3W3KW2PvQfYxVcq+o5jfIIrAgdvK9Dd1xiuIdbVnA6xX9cwBO3ZVxK2nUWThePtype8xj6G2IXq2Lr/k+t4uLYoxKXUkaV6h1xWO1NyiiiHpfMWy6329/vhjlVf9WOX1K2nFZ7giqtQulJ8uAoWq0y5yquSllKqfu7xwiBZJPDeSLjHG+0ApR5222rMt8XtIdqH6avk2paliUtdTSlUuDEYacN6E3eaaKSlsWGX/ONrB6Xr1x5EVCjsPK1J0/Htd0VIy5LNbvTqsWbjQzPJW7FIxYxBck0QogUPMRjLDYNkMUmoilCat9kJdSxWlTuMx/GlG2oza4mJm8uVKlt8F1ipB1fllBLPgXsMFey2DQEnG042shWv/d99eDAlyLMlOL5Ud6ZiTvH4oPRp3lW2er/2Vs/5yqvlNGXR3FdV5XwYys5wg/M5Yu4K4eG+wtZWK7a+mYgcbbXisK82mfc3e9nfo6NZSyEzB6ZrTSYHvbtWEhtiNCvXp3Ux1zC8rLE/gdBl0lpyoDttF1/9RLK88AwY2Ext5n2CKXOJNx8rVT7XtZ0h+hsfzqs74FlLD1m+4HXIUkiziqhQiMKmI8cp2UjuOoO0k7wq5OpdZ9JicpURcVs/jgf5EMgJoK5S02I7R5ILbDdXLeXhNt7tzxLrEcLoLtC1+FJcXT2NXcsjsrmWmLu9KKOIQTS3kNwQyKAf5jiXYkzUO/QfL7iaPa3eLGJInasRHmytCf8uck0I7GPRyjQtE9vOhL9+rbg19NEoCO2RG7m213UMf8mEmnvfF1O/CvG7jKfQ6aN75zBNxLmHW7gYuyWZLIdexXaw1ZenmDpsFws7Rm1cQq4y53MvykQwRVxXLMBIYy4Z6xE2N+TfRJmWYO6ilTq8dhUzAGFYRWVyYY0Wuoy8qWsDVOeD0bA3PTuZk5GgdFaVNR9VlMnNWBECi/mmEteB2sRZZpeyJpWCp5Vs9httDDrXq+FR5j8ceFThLt1Zw2rCvXV6u6/mWivZZSC+IxBiNRJT/B2Wzcqrp+mq6hW8NxloxYszcceATISqa7nGLXv0GC+sEe4OHJuuEmAFBvJLGVCJ4Cv3cB/BV3V4Q4aqY4wqtmuJ27AX4YpgcQwsy03ixSmWt52uD8rE39NO9Lgiv0Lbg0gJaUTBRRlXkQD2TFyt5pVtqIuKsPLJaEilfUJP8WCse+5ZmywQWFc7bA6dpQrZ7F8ZS8NchKJqDaaOomyI2ZjIBiGCFgA4u0D1UKrUV2/va3aszUpD0XYwBEz9RDURIQh82SaZ9fGDNggchP3i5A2tmija8F6EKxJIpA5KDosTSp6QUly1SDrFdWhmMbZYYODmaPLJBgn8UE1hXr7CNVGM4LIDNguf8kUnXFIrUZJB4jAZ4lLJm+NABgEXIXCyJHAgS4Z5lQJLAHCrTO2of465YWm5qe+dxJpqdXHIteReAivSSAzSV1esAT/Gd0eSOcfTfAROTiFnFkww35n9tn18WCxaYn7OpVCsq6npCszwOf3hr3FbAit2eAY8LWcqjBdXaUS35Fo3kMcVREAInBmKohIIHdfFeCtCFWJPBBd1FqQXQxVURBWbOggyf8JUC/NNTFeRKBzcAkrtmGNlAPYhkk/+sUAGg2LBI7aYXCHjVeQR81Pl6sHwHQL+EC1fKAMNxF6Gi9ThAEkUty+NGvktxhYSGcrEuNygMjyV3jxf8cCPcS4mUGAI0ep5YzlOoMt7GS6SjDNCgS+fLaYEcDmt5hIC/T3txEKlGOzj7/O3sLLARQhAS5BbMIxESU1zYloOCfiL4oEQ1Ne4kAIfE0UbZBlRUVlhsOFsv1T9j1wVBwBYWmXecDcTAWDBl7DiOE5EXDwWzN8yCzq2KF4M5Ggvo4s0YNZcXLEIdtjpcrDDrlhkCZBQCM9EPkiZQ2qGtBZHmRsnUD0V5Tx2Qoit6nVB8+eVBlipDelJ67h3w1sZLJeAYdBJ9Wm4pcMfE+0nHLWiHp7Y+8oIF96BYOaoASiQJUFyJOOymVVPi0lY2u4Ogei+QjLROCUcxDBhNK6FVskK6WYvN+gYQqpzc5NdE3C5+SrgIg4w0MGNWjnmwfOq3F3ntjDjy514vojEOPAwLyGmGt4okiy+YuIUBQpZIcSXu8CEgooKMICgwEqYJzSmzzenaWpA0JtFn8WD7+sxBJyHeEmlnE0cjgmyGAvhUW2hJjhCwp0rhntM/E+1QrmXR1MYAo/vkkbxt7DPFmpWMsybq2lvuZfAIr14Fc8lSCuuNwIAGgyX8+p02qWK6DQ6ykPoOG/O38KRw60We4beg5y05VUegydcl2rEh+aSmr/jC6ICLfwWzleWaoGHFh3P9YlBfPrUa9TGE4TFLgl2TR15dZbIxZR9heG8lcEKLhBYPpjQRbQ8oPjaY9CMkxiHwlUVddLHxBVxnhh8Nq7SDo4c0SuTBlTjFA0nnianu0HcLRb9ZmxyCgzoY9gHEyhwg17MVXC7mQcKri1kaVXAfogrP8IqkQkUtkpcMAIMeLJNDJshVAGB9+K4Wq62YqCt9AN4XCYNHVeYdhizwIYX3zOAzqc8FXOcB/bE6IQYs4B+u4hMOYq1MHjs5xAADkxl/oZgGQOy16IWiGVDKHHqS5d8xYZmN0VRQw0iUtmMexZceGO4PMeMcK+lP3nZSoQqFG422sRHGJy7Gdi45GFY1extdGW4P2u+e0e637vLUr0vn9J7AfcIH2oA4je79Hze89mqe6hEbrHlY0DAn9X5s4Ba54NcCY8ARo+f4nScrR4121NAjm+VA4DbfCv3hua1jr0+LGsnIIAsn+sR9h/R0SXUmchltuqRXzhNbmLNYT4Mq7X0jYQUas3A787vnbC7TamL0XWtlHbjrUf1DDF2UoU+xAi1oeXLKXJWhzDn5nweavCm5ftqr+Q1l3It7mh2Llb76bfU22pGH7+/u+zq2mLj6zkbXf1C9Os4j1Z7OXE5A4SiyYKvPjR/4X0cgkJXo2CXXd+yWLyR4Lw238Lo0l59aP7C/BBRJi7RHhoIxgSrELUCj1vWnlx0AsYVNa5dspolCzWmzTD2AqvkxZrxIYUeKP25r2tLexCht3pLWfu/Dq72nHY842PnYfUOvQihxdlh7WKI6T2FFi/s7qqPyUOucyNLGXuMuS12ehU2Q+DIhk4ZrBUFP9iLxurF7FhLjjZLMfdQtjIgP2KLWnVLA69TK/xV1Vpii0OsehlMghbT9xtKI1ORfWGr+JfYF8fEwyekmq0S56Ib9MKigj3/6Xtp+96qLcFf3wCYDCbbVvNmIcSPz8USDFbgAFulyG/lPauRzizU4/o1xY5ebYLGraV3Rm3axrU67XiLaCfNIMip9qqHqdS6eohBPCOm3ELv+gZO6x/XiEluZU/PPj1djAYbrccNwslPC6FlAYe3VKQ6XxWXnOdhi2rSHFxTuxYpsIWqzqcO/fgpJZm/lKqARu8NQPTaecNaO1OnoI9gbcKpDT263IfHGPxwnCSUzler41IYahw1tnUxvMfBMgLEExD5rzRV2mmp02SLl1JjL9fS9fdmwWw0EH12EbuHSbX9v7uYRsEs/U4Vaudbrh5uPr/VeM65nLtTCbfLMS1GlKxsV7fxgoepxUaLEN71j/3Wfi6rCrpH3ha7zHGyYyxXLK7WRNq39hcl1lhNnsutJJf7cUbfBhDGmWjvRz+HwTpHT+zowaeLkCyZxLmWEVv9UETANqD7Lp1nCFz3uthPS7QRX+eHNIZ8hCQYErfNWS3bEIa3mayltfMeM1lEGlSmNiS5bMsQm1G8tH9qtWBlG5ljIcwAoI3QOhehuDHbM1J91FJBccYLMYjV8rkQeoIze5llwqJQxEQnYI/K1sctpYlt6WTZHcFalfA+R/SLicGgus7qojsXhxm6aieW1hU+b2NaHXjJp/Wy6aNgMpdb7e5M1DmX4Lyj3msdwpVHu3niDZ/XutCTOnFVQNwZuuaUMowS0RkWqczjDVmpDC3MqoTpIjDXvhiFMZi0+4RKoxdjWskdg4NPtprfIzEJAfey2+XMCu0P4sXiyJJLMq6CAXzCz+Z1lzK0gTiaxCCHwiERDaOW8rFY9az+OOXMGOQwBju17LCtQH2O1YarE1FlJyzRXFNGmVlxFoaJIMXPCgLnFKAhWpuwg8KFOlZopaW4yhAo5aN0QyQriCzbJGt2xDX3eaDIOdl8YRaFRk1UanArQkXmEl1QYoQcieIDyqdYrXF0CGHs7wOyVFAo6vFP67nv6jM+K8iu5XmGidoDAuBHKp7xQidY0iZBRqYNUsGGFMIZKbVFARYBYJrEGLAB41IggmUAuFWkdCQenBOa7g+p06PvN6RZci/D5QwSo/NatpuqY61FOITR/C3OS2W6LNhQR1D8DvGD83L5Xr6xa/Mffc1GVdKYZ5zcU6dAoIUIQH1Ogr0C0KUkxoB7IFh2YrgIQQT4XCSisF/Vk65ypwDwVgZLBTVBcVFlQTKiPgnagpZBy0AkiphkcarJNTEki4hsASs76FgXoH2cDD7714wOhsTC6IDhlCUyXkVriCwVeXowbMdY30gwVWbEXgQLpJFxE5WEuTvDaRgiK5IYTMO41iDSO5HbPF/u4I9xJsYoMAS7oDiV4xhdsVdghiSjbFCgi0drl3hnsJzoqwICQBB7sVYpUnXGgb/GBQ+sQXBlg2kuuIb1CvHzAlgaoBT8FRFBAOpbXEeBb7WrFuOUB1U727Ws3dv0ZTZph8GKowlT1T90V+yZEDE+AvY1uTZLBV/GioMp0U7H2BO/RXx5rUdPexFZQRiOL67OWEQ8HB2Bf5TOWGQLlFmwexKOiCtvuMp+hD7GJVE2Ulh/Vf0ubAA93wVr99wnveP+De8VcLFZRLNNolODXR3RyVM9KBqvwq4fzbLZbOpkOARQ/k0f5g0LAjbcFG+ePZc4AiGrhtEQAndJEQNg+G6JLN9am2e13yAQTVZozQkAdg1gMmkMVnReBVxCAYc4uAHOox00lspbuR+MuAoM+JfCGAUc2CW8VKcbZQMVXwyWIgBs0bLMis4vYKBGmTBuw0BCGCRuf7/SksaBAUFyFHwhIPxLZaw6aBZZn3icgyUM5VlMZDME/JpoWCHcdhVpqBNKHMRQCkLAOV2cyGW8uL1Wb6sMY+VqrFvsRKBILl7FAWo+gfqJPRpMpxlwMZhOI+zWZxmnRMW0OVIAP8XDhRaoDX0HOVUrVumwjK3diBvaSnLsDn9FkjEQH8Pz2mX6MA5N4DifGLkXH3ue4nwGezx16OlImUOCMW1fYbqYPkW4ghEIl48mjBoaH1J+5TJwdo0jHRxvZoPPoYr4oVKeFnw+rmIHh3PXr80XXAucst8kpsfx2hR2i9U8BLU5GQX+GDfCuGHN7XkeqMABBR4luPaQlWFhE8I3fNgyoRlkeyWuEzEKONQm5swQLAPAvTypZsW6gbjSGeB5mTZ8XgEBJi3UEDO1ROlCjDgX8xyn9dTwhBi0+DT13PX4Ldo7tGyclajsGOywuFGCiLHNFlN1OACMdW71wyF8sYYGN+keF3chWlW/jFUOugbG9RCe/EeojABW/PhyFYcql5BTXdTdGVwv6rrGw3SOR9Vr46n0yV7y9uDDeQ3aJEY8l4C/X8h3the79J1W36HAV8HF48BG8LKUMojyare+W2zXHtlY23uTcVyF16boyvWhuW4mgnxeB14aqa4BaLuGCx828YywM/c4HYxfvKJzCVWyKt7Drp8Y1H7Hui6jfIQ075VDwVuFO0FQcocyCsSVF9ddthfCmmm3U/DleZZG/Lmx9khpL2Asokf4U99L8G6QD5QERpYlVBwBEJOPn5HUCHqJRwFstUT/ISfV61oX3VEvvbGa4hnEb6WqJ7hBz9hU8IP3ZILYYkopR40Q2oNwCYKSZ5YQsLnSCKG9ArsgfQH6jdWymicURekUCdO62qO348H4KVzGNlq9aJI88eMHKDchbDc61WuPeudd4MCv+OOvujHF+HkVlAXhaflNYfS/Qi1ZxlBExJPXSF4mJBOdzRtDEM6SxZ80hYmjHmcm6RV8Rxlh4oifdgENVDiI4LPyMqR8pUI8e+uD1ZwzCPuWdyFfaTMVbXAco7kvt7T4d/CV80BXC8A3Uss5LEcITUrD2VsZ5Hyq+mLpq9kLN0ij6KFwb8aY7lwAwzC3wTE5EWHenZRHX4a9zHUUECJNUwiXP6YBkYslSd1cvX5KlARNF/yawZ9NXGw6Ngkds4aZ8BJziQiMgkoxSe4FF7lbcxX7IwaxW4jOb/2quJ5fZc4nD3hNaTaejMnIM8Zt3magFw9UW2jUSYee4bHV3k6pudPgrrTiV0XWi8TJB5sApph69Reu4t+rM4mbGFym5dXrsSQBQS50IHxNOZXaChVHZyN8BfsV1CSUrZa/TLqMPkwV18B04QlUOg9emAz6S9KJHBePipB5IPlUuAo3Qy7pqsloHJR6s5kXLgFjAGY3SwbZJ541RaAkmrIiwzYazTFfBADCwgEOGdr6i3S5SKU9sPL2ROIYYdafUBkA1OZ9//OY2VoQa/spzWCvE7bVpZ41l/MBzDapWcdWcrRaaN6cSnkYr+NklTC7FNgZ3M15N7t6OCBWG2J5PoSEsLaHE61tm8tdjQUTYKTNetTW99XNksR8vgNax1baS6bZplaW4OzRZJsLzWu+oaNR0RA4mjKVtvZWcLSxpPO0uS6GdqzVbptaHyYV+9mcnLwmuGAOEybXIarhtJI5oU6kjzRYQ1ivp63XjAZkj6axPec6UYtE0S31kYmy2AkkCREnKRlXukoWhvpCbfvBr/P4wAJx0lzJl0+7037KdLsgtR2z5fV92VQ6YSNZcYZn++WH41mLd8N/KYXXEc/ZaMQwi8oONVZKldB8hFs7uzlXZXyrnrSzbkHaItYs1CHvvbHaXGLb6qP99JPf+uOexYhxb8j1SkKJbcLAtelZH64iFI6zHHBtcj1bpzf4aBAaF27KA+JjBnZiWdxqtDLJNiuMaBghf1GQ8Aw+1yGJHVtjmfW8/Gq/LZLamIW/IZgo975wMlFmRBVxaW112bVjD4o+mwj2jCT5O2mHS+5+vTF87H/IHLKACdrGuF0PxrIkaIsmlT3YWkzCRvuHOrn6ithg/4SlW+03CnoPJnaS0DJObGiEbIABO0YZqv0ZpEv6UHAWgi4sSFeRYwQ4MlB+RYgMGxoUJFb+sNSG/25Z134v2FvlXDnIQyqyknJril2RCJGQZOy1WXf5EBjgkOAKx4vywd6Ya4tglOTq8x/jI+DfX8VeRo4cZAnpoBYLKylF6ipQxtj12TBPihFrKc4y8BFQF0TDgj0pNEKUOmK2wJRh+4cA8Agis8FkktIdXKtTWDnY/OEZAGNUjnEAxspgdqRNxpaeyuEQWYzWMazns16sliIAB02qZ/y8PUbLK/wtr7bfLSu5PxnyiyN7BisCAfExoDhLDLb5xaQQybZwoZiciONyfsupMDpLXuVJEGQvh14idOQoj4NPzPwxnuQsmf4eg19hOjndeCHpUtk7doAJW6Ys0pDDbwZACh2D/S7UIPWv5BVMRLEXQ1IhBsjyPXZxVwvIEHivwAzJwFsRrKohYPL7QqIs4PLMCrIt2Cj/ZO1EHeOF6gYixpZNgA1WRRjtnZhQFXESaJQY9GMXhfaOKyFY8xA1HlwVQyRIRzFJhoESjxSxtWHLxBaPB31Z3VF2xUAQElJwjb061/a4DsgFLAGBogUhvCzoXAckORelSI4MmGR8ND6EiDgwwUfx54ouI4YoqEPgpB4qkIrxiO8c47EtFO6OXIIwpshhFhwuMIp58GgXLsapAdHLwr5Xe54zxiFu4kkwsw3+pPkQtcyNWcDsLAjEpb0hJKtbj/L+hBc3IAWA2hj2djFyKEjM34fWNhPmkfXuJnkgomXNsf2y4KPEudotzObE177K6oNVL8aim3f2+OpZkbWArv0m6FhkDbGdrIVu9Ubhdv6516dlxmB7v4Xqw2klayzMnGjQktzhtI8qwYRuS0hnerHQwXGZ44gWbhWEZS5a7Onb82F9UXrAis/6iFaGUz1KIhNezcx4t0DoOUlMM1RusxmB01CZS3bbeUEudkGmyy0mvpNEu3zsYnsIw/WhzTwcZm8wBu8fpv2DBv2sY6hNzQ24PFC82dV59fhtygPdLXVUcDnXmYoWl7T4ztLkiQh2625tJrx5keDtz/3F500UwA8t+UpVi9YmtgiVAdFQ42041YPol+rHd0RD792X9maJbW1uWBAKx/vwWLhIk0IwnHY8mVLDk3Mg5mx6sbiDYH9QpR+MZL3N3fuZRgJhitCgk4EiqRJkrZZwOhZKEAiLtKRstzHaYGMe/GzzpC23anrvuaQpZMmuJePJFoNpkZJxNVjSe18/xUZIrrIMsbzhSGgbp7nEcVe4SmJIOFCKWOd3UbG3fLbQ7WU7ysKBwQb6WeF3cBif3A77eZ5PFFcEZAd/DpbgqFJiedgXZYP5zfN5ZIvk6gtfE6dgWeYAF8NTisw4WkJzyiwTk8UcH2PQ+kpwR0dAKy+QFXkSxZx0+wKjNTFtzOEtH5YJQ4flv8cDcDrDASeHlmK11lB9TMPgJPJLRAEMl40Pk5w9OzKC8RU4iICeT4yqA3SQSQXGiJxpMHEw9kevK1atJPLgz1BTmbjGLkfAxXCAP8YkRxRQJ9E7odSwKxXpC572FRllxNiX8mU1jJMoIoLgCQM9jj911k9BJUsyA+B8CSDIcJnv3qDeiLz94pxktEtxLUfLHGsia1CbW7t6kvnnUwtM2CjM5IAUcxDg9mNoYbJ8AgDvxeiXjo8nRZiiXEDXRYAASihYLDHlRU61qvVk3jCzfLKGgedkI4Ygrbg+GTYRAnFZGd2sutYJvogtG52VSxvq2jLWdvgmGVZ8UIGQ1WyXWNhQLPnCE1VXCCn8EF+vYwqKSiB7bfbwWMhTBSqGANEASiw7aKqPoWyzK1cZNAocH4sOIJDlJJ4knjkjuEjxFJ+Ab++jyqjgDSu3GL0Jo4f2kZ0eAmD2XkXmOuy4tF/UPozRzqCtX4S5SD3WN64u5d1HztN6MJ4qB/uGxeXuXgu3JafVBbvnS++PHu1OXr1BbD4Yr942Z3EyZ1xsUJneyJtp2M+2iik1cRliXD1lJtn0dBxKkFNvdim0esfzZyTplmN0XB4xZUkENr6mDGK68oKWhPoUBnfaMK+y3N/qCENg3VNTV+XKHdZTlHEBAD4mhRHNGkgoy/hVS+50hy2FmNR5ygIx3BuBXu2JzIEKx9HyhQys6pKO4t4rgZ1GGZdWwRrnCHlVWxttmehoLNFycAWETI1e4mQunvi5VZ4YPk+MbEMWz9Mkd6cQvOCh0Ce23vz9c8jeHUENuj1j3m4dHZOc2WOMiP4qjpfS/Lg6sOGRlPMqV/cGmzcFfSLunFYHsYmBLMNwMubD1J/ARS7zDqbtg2h44ONT8TSfdt47OK852+HMaFq9o416S4IoLnCYVgeDNdcjUMaEPBLXWMS4rMyEVFUuKoiNi4OaTVtZTUicHm7qQdwhQhpIc7qpYVKAuctcII5JBOZPqch3zu1YSe5UR3VpnqHhnYAqwwYm8Bnt1zZBjnFyAgH0FtI1S+edzAqjglLPGjIVvIecb6qCg3QqKqK1Rc48Z0LvDCvrLR6LyC1EWZSskTXPUOuOhs+5Uu1gpeVgHK72RFV1uGtB9OLm0xNMuAsFnnMrtzYdGcYH47i94TCHEy/EzAyBM0YM/HGrwAvPIEJThECr0qjdZfRP7b0rkE2IYVlE5KG4FaG+gAB/67b6wFIzGSCOZ275O9tghCsCYYTwvCzIEB+18paS0142LLfCMBshsu+34jgbzDsxf4pkjMJduDYBEOlPqD/GkxdrK6clAYS2um71F1TSYq/atNUY7X5ksT7FPYQXvsZwQ7ArW098LLk6IfHEIQ7XVVsC82p0AJe/tvj6Iz3D0RiuguBtmHQ6m1u2p8lLOKi9DJfJi4jdcs1tdpls5Hu9afakjEx7G9tC+9mWe0LeSe8EgYXEyODaferbo91Sd95rhJzg3vJyIoOACxBYeh8S+RQhGQfxNYSLhLwV/27vHz+9/ePXH//7y/cvv7z9sHxePr3925ef//L9r+0f/v3b9x+/f/32c/vH//r658e/+pcvX//y1+/tH/7ppy//12/8h28/fdsBvv1z/c/br3/8f8SUlu626AAA",
    Area: "0",
    Cost: "0",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "750",
    Family: "Fine China - Plate",
    "Family and Type": "Fine China - Plate",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "750",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Fine China - Plate",
    "Type Id": "Fine China - Plate",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "997069",
    Name: "Water Glass: Water Glass",
    Category: "Generic Models",
    Level: "Level 1",
    Pbi2DGeometry: "uwAAAB+LCAAAAAAABAA9jMEKwjAQRP9lzzHURGKoJ6mCoIeigofSQ4tLuxCTEqNQSv/dFKu3fTNvthggr+nadwgpHF1Nl65Fj8Agd2TDE9Ji+J6xX2i+1kpuJNdKLGEsf9bW+6qPagx2VD0woIc04UILyeCEtgntxAmDswtVIGdnvNH9Xx2QmjZMoKWMu73B9+wKvlKJYpA54+Jn+zJmLD9AC/D9uwAAAA==",
    Pbi3DGeometry:
      "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",
    Area: "0",
    Cost: "0",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "750",
    Family: "Water Glass",
    "Family and Type": "Water Glass",
    Host: "Level : Level 1",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "750",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Water Glass",
    "Type Id": "Water Glass",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "997114",
    Name: "White Porcelain Plate: Fine China - Plate",
    Category: "Generic Models",
    Level: "Level 1",
    Pbi2DGeometry: "uwAAAB+LCAAAAAAABAA9jMEKwjAQRP9lz2mIpjalnkQFQQ9FBQ+lhxaXdiEmJUahlP67Uau3fTNvthggr+ncdwgZ7G1Np65Fh8Agt2T8HbJi+J6hjxSXapEso5grlUoYy5+2cq7qgxuCDVU39OggEzyVMwYHNI1v3ygYHK2vPFkz4YWu/2qH1LT+A1KE3Vbjc3LnPE5EwmBttQ2PzUPrsXwBperDFrsAAAA=",
    Pbi3DGeometry:
      "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",
    Area: "0",
    Cost: "0",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "750",
    Family: "Fine China - Plate",
    "Family and Type": "Fine China - Plate",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "750",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Fine China - Plate",
    "Type Id": "Fine China - Plate",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "997115",
    Name: "Water Glass: Water Glass",
    Category: "Generic Models",
    Level: "Level 1",
    Pbi2DGeometry: "vAAAAB+LCAAAAAAABAA9jMsKwjAQRf9l1mmI6cNSV6KCoIuigovSRUuHdiAmJUahlP67KVZ3c+49d4oR8ppuQ4+QwcnUdO07tAgMckPaPSErxu/p+2DNUyFXmyDmMo4SmMqftrW2Grzrgz1VD3RoIRNcpjJkcEbdum5mweBiXOXI6AXv1PyrI1LbuRnSMPS7g8L34koeJSJhsDPK+M/6pdRUfgAyEmDNvAAAAA==",
    Pbi3DGeometry:
      "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",
    Area: "0",
    Cost: "0",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "750",
    Family: "Water Glass",
    "Family and Type": "Water Glass",
    Host: "Level : Level 1",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "750",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Water Glass",
    "Type Id": "Water Glass",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "997116",
    Name: "White Porcelain Plate: Fine China - Plate",
    Category: "Generic Models",
    Level: "Level 1",
    Pbi2DGeometry: "ugAAAB+LCAAAAAAABAA9jMEKwjAQRP9lz2mIjbYlnkQFQQ9FBQ+lhxaXdiEmJUahlP67Uau3fTNvthggr+ncdwgK9ramU9eiQ2CQWzL+DqoYvmfoo5TLdJEso5iLLIOx/Fkr56o+qCHYUHVDjw6U4JmcMTigaXz7RsHgaH3lyZoJL3T9VzukpvUfkCLsthqfkxvzeSISBmurbXhsHlqP5QuXbG8XugAAAA==",
    Pbi3DGeometry:
      "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",
    Area: "0",
    Cost: "0",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "750",
    Family: "Fine China - Plate",
    "Family and Type": "Fine China - Plate",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "750",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Fine China - Plate",
    "Type Id": "Fine China - Plate",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "997117",
    Name: "Water Glass: Water Glass",
    Category: "Generic Models",
    Level: "Level 1",
    Pbi2DGeometry: "vAAAAB+LCAAAAAAABAA9jcEKgkAQht9lzquYG6tsp7AgqINU0EE8KA3uwLYr2xaI+O6tZN3mm/+b+asRypauQ48g4WhbuvQKHQKD0pLxT5DV+B1DHmVxLrJsE6XxmvMVTPVP2zrXDMENix01D/ToQCZxmqecwQlN59XMCYOz9Y0naxa80f0fHZA65WfIOQ93e43vxQ2FIhEMCqtt+GxeWk/1B/cGJ/28AAAA",
    Pbi3DGeometry:
      "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",
    Area: "0",
    Cost: "0",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "750",
    Family: "Water Glass",
    "Family and Type": "Water Glass",
    Host: "Level : Level 1",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "750",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Water Glass",
    "Type Id": "Water Glass",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "997118",
    Name: "White Porcelain Plate: Fine China - Plate",
    Category: "Generic Models",
    Level: "Level 1",
    Pbi2DGeometry: "ugAAAB+LCAAAAAAABAA9jMEKwjAQRP9lzzGkVlMbT6KCoIeigofSQ4tLuxCTEqNQSv/dqNXbvpk3m/eQVXTuWgQFe1vRqW3QITDILBl/B5X33zP0k4THyVwuBU/SNIKh+Fkr58ouqCHYUHlDjw6U4Is4YnBAU/vmjYLB0frSkzUjXuj6r3ZIdeM/EIuw22p8ju6Uz6SQDNZW2/DYPLQeiheTDtbgugAAAA==",
    Pbi3DGeometry:
      "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",
    Area: "0",
    Cost: "0",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "750",
    Family: "Fine China - Plate",
    "Family and Type": "Fine China - Plate",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "750",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Fine China - Plate",
    "Type Id": "Fine China - Plate",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "997119",
    Name: "Water Glass: Water Glass",
    Category: "Generic Models",
    Level: "Level 1",
    Pbi2DGeometry: "uwAAAB+LCAAAAAAABAA9jMEKwjAQRP9lzzGERNpaT6KCoIeigofSQ4tLsxCTEqNQSv/dFKu3fTNvthygaOjadwg5HF1Dl06jR2BQOLLhCXk5fM/YL1KeJWm6FlxJuYKx+lkb7+s+qjHYUf3AgB5ywWUmFYMT2jboiQWDswt1IGdnvNH9Xx2QWh0myJSKu73B9+xKvkxEwmDrjIuf7cuYsfoAzPh8Y7sAAAA=",
    Pbi3DGeometry:
      "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",
    Area: "0",
    Cost: "0",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "750",
    Family: "Water Glass",
    "Family and Type": "Water Glass",
    Host: "Level : Level 1",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "750",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Water Glass",
    "Type Id": "Water Glass",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "997120",
    Name: "White Porcelain Plate: Fine China - Plate",
    Category: "Generic Models",
    Level: "Level 1",
    Pbi2DGeometry: "ugAAAB+LCAAAAAAABAA9jMEKwjAQRP9lzzFEU9taT6KCoIeigofSQ4tLsxCTEqNQSv/dqNXbvpk3W/SQ13TuWoQM9ramU6vQITDILRl/h6zov2foJwmXyTxeSh6liwiG8metnKu6oIZgQ9UNPTrIBE/llMEBTePVGwWDo/WVJ2tGvND1X+2QGuU/IEXYbTU+R3fGo1jEDNZW2/DYPLQeyheDAhmkugAAAA==",
    Pbi3DGeometry:
      "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",
    Area: "0",
    Cost: "0",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "750",
    Family: "Fine China - Plate",
    "Family and Type": "Fine China - Plate",
    Host: "Floor : Generic 150mm",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "750",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Fine China - Plate",
    "Type Id": "Fine China - Plate",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "997121",
    Name: "Water Glass: Water Glass",
    Category: "Generic Models",
    Level: "Level 1",
    Pbi2DGeometry: "uwAAAB+LCAAAAAAABAA9jMEKwjAQRP9lzzGERppQT2IFQQ9FBQ+lhxaXdiEmJUahlP67KVZv+2bebDlC0dB16BEyOLqGLn2HHoFB4ciGJ2Tl+D1jv1Jcp0ptJBdKa5iqn7X1vh6iGoOc6gcG9JAJnuhEMjihbUM3s2BwdqEO5OyCN7r/qwNS24UZtJRxtzf4XtyEr1ORMtg54+Jn+zJmqj6P8prZuwAAAA==",
    Pbi3DGeometry:
      "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",
    Area: "0",
    Cost: "0",
    "Default Elevation": "0",
    "Design Option": "-1",
    "Elevation from Level": "750",
    Family: "Water Glass",
    "Family and Type": "Water Glass",
    Host: "Level : Level 1",
    "Host Id": "-1",
    Image: "<None>",
    "Moves With Nearby Elements": "No",
    "Offset from Host": "750",
    "Phase Created": "Working Drawings",
    "Phase Demolished": "None",
    Type: "Water Glass",
    "Type Id": "Water Glass",
    "Type Image": "<None>",
    Volume: "0",
  },
  {
    ID: "998189",
    Name: "Kitchen",
    Category: "Views",
    Department: "Independent",
    Description: "-1",
    "Detail Line": "1",
    "Facucent Drilling": "Renderings",
    Family: "Rendering: Rendering",
    "Neutral Rating": "Yes",
    "Nominal Width": "Kitchen",
    Rotation: "None",
    Scale: "1",
    "Sheet Issue Date": "Title Sheet",
    "Sheet Name": "A001",
    "Tumble Dryer": "Rendering",
    "Type Comments": "Rendering",
    "Vertical Scale": "Kitchen",
    "View Scale": "None",
    "View Template": "-1",
  },
  {
    ID: "998197",
    Name: "Raster image: Kitchen",
    Category: "Raster Images",
    Description: "-1",
    "Down Text": "Background",
    "Facucent Drilling": "Kitchen",
    Family: "Kitchen",
    "Heating Set Point": "110",
    Height: "755",
    "Horizontal Gap Distance": "1",
    "Location Line": "Yes",
    "Rendering Settings": "174",
    "Tumble Dryer": "Kitchen",
    "Type Comments": "Kitchen",
    "Vertical Gap Distance": "1",
    "Vertical Scale": "Kitchen",
    Wheels: "201",
    Width: "1377",
  },
  {
    ID: "998202",
    Name: "Living Room",
    Category: "Views",
    Department: "Independent",
    Description: "-1",
    "Detail Line": "2",
    "Facucent Drilling": "Renderings",
    Family: "Rendering: Rendering",
    "Neutral Rating": "Yes",
    "Nominal Width": "Living Room",
    Rotation: "None",
    Scale: "1",
    "Sheet Issue Date": "Title Sheet",
    "Sheet Name": "A001",
    "Tumble Dryer": "Rendering",
    "Type Comments": "Rendering",
    "Vertical Scale": "Living Room",
    "View Scale": "-1",
    "View Template": "-1",
  },
  {
    ID: "998210",
    Name: "Raster image: Living Room",
    Category: "Raster Images",
    Description: "-1",
    "Down Text": "Background",
    "Facucent Drilling": "Living Room",
    Family: "Living Room",
    "Heating Set Point": "110",
    Height: "755",
    "Horizontal Gap Distance": "1",
    "Location Line": "Yes",
    "Rendering Settings": "174",
    "Tumble Dryer": "Living Room",
    "Type Comments": "Living Room",
    "Vertical Gap Distance": "1",
    "Vertical Scale": "Living Room",
    Wheels: "201",
    Width: "1377",
  },
  {
    ID: "998214",
    Name: "Section Perspective",
    Category: "Views",
    Department: "Independent",
    Description: "-1",
    "Detail Line": "3",
    "Facucent Drilling": "Renderings",
    Family: "Rendering: Rendering",
    "Neutral Rating": "Yes",
    "Nominal Width": "Section Perspective",
    Rotation: "None",
    Scale: "1",
    "Sheet Issue Date": "Title Sheet",
    "Sheet Name": "A001",
    "Tumble Dryer": "Rendering",
    "Type Comments": "Rendering",
    "Vertical Scale": "Section Perspective",
    "View Scale": "None",
    "View Template": "-1",
  },
  {
    ID: "998222",
    Name: "Raster image: Section Perspective",
    Category: "Raster Images",
    Description: "-1",
    "Down Text": "Background",
    "Facucent Drilling": "Section Perspective",
    Family: "Section Perspective",
    "Heating Set Point": "110",
    Height: "755",
    "Horizontal Gap Distance": "1",
    "Location Line": "Yes",
    "Rendering Settings": "174",
    "Tumble Dryer": "Section Perspective",
    "Type Comments": "Section Perspective",
    "Vertical Gap Distance": "1",
    "Vertical Scale": "Section Perspective",
    Wheels: "201",
    Width: "1377",
  },
  {
    ID: "1001882",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "1001883",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "1001884",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "1001885",
    Category: "Reference Planes",
    Description: "-1",
    "Schedule Level": "None",
    Structure: "<None>",
  },
  {
    ID: "1101979",
    Category: "Schedule Graphics",
    Description: "-1",
  },
  {
    ID: "1101984",
    Category: "Schedule Graphics",
    Description: "-1",
  },
  {
    ID: "1101989",
    Category: "Schedule Graphics",
    Description: "-1",
  },
  {
    ID: "1101994",
    Category: "Schedule Graphics",
    Description: "-1",
  },
  {
    ID: "1101999",
    Category: "Schedule Graphics",
    Description: "-1",
  },
  {
    ID: "1102004",
    Category: "Schedule Graphics",
    Description: "-1",
  },
];

export default basicJson;
